var hA = (e) => {
  throw TypeError(e);
};
var uc = (e, t, n) => t.has(e) || hA("Cannot " + n);
var D = (e, t, n) => (uc(e, t, "read from private field"), n ? n.call(e) : t.get(e)), ge = (e, t, n) => t.has(e) ? hA("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), ae = (e, t, n, r) => (uc(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n), Ne = (e, t, n) => (uc(e, t, "access private method"), n);
var ls = (e, t, n, r) => ({
  set _(o) {
    ae(e, t, o, n);
  },
  get _() {
    return D(e, t, r);
  }
});
import { jsx as A, jsxs as R, Fragment as Ee } from "react/jsx-runtime";
import * as S from "react";
import Y, { forwardRef as Pt, useLayoutEffect as Yn, useEffect as Ie, useState as Q, useRef as Ce, useCallback as ye, useReducer as z3, createElement as go, useContext as Sa, useMemo as ve, createContext as Tl, Component as G3, Fragment as mr, useSyncExternalStore as Wf, memo as Tr, isValidElement as Yr, cloneElement as uu } from "react";
import * as Nl from "react-dom";
import Zf, { createPortal as j3, flushSync as U3 } from "react-dom";
function Q3(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const o in r)
        if (o !== "default" && !(o in e)) {
          const i = Object.getOwnPropertyDescriptor(r, o);
          i && Object.defineProperty(e, o, i.get ? i : {
            enumerable: !0,
            get: () => r[o]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function q3(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 9 12", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.31744 6.36794C8.56085 6.17515 8.56085 5.82482 8.31744 5.63203L1.3527 0.115704C1.01647 -0.150574 0.499999 0.072258 0.499999 0.483647L0.5 11.5163C0.5 11.9277 1.01647 12.1506 1.3527 11.8843L8.31744 6.36794Z" }) });
}
function Y3(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "none", stroke: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      d: "M8 1L0.999998 8M0.999998 8L8 15M0.999998 8L15 8",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
}
function J3(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 20 21", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M9.98893 18.8223C14.5914 18.8223 18.3223 15.0913 18.3223 10.4889C18.3223 5.88642 14.5914 2.15559 9.98893 2.15559C5.38643 2.15559 1.6556 5.88642 1.6556 10.4889C1.6556 15.0913 5.38643 18.8223 9.98893 18.8223ZM9.98893 14.6556C9.52893 14.6556 9.1556 14.2825 9.1556 13.8223L9.1556 9.65559L6.6556 9.65559L9.98893 6.32226L13.3223 9.65559L10.8223 9.65559L10.8223 13.8223C10.8223 14.2825 10.4489 14.6556 9.98893 14.6556Z" }) });
}
function K3(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12.0104 2.66602C11.2738 2.66602 10.6771 3.26268 10.6771 3.99935V11.9993C10.6771 12.736 11.2738 13.3327 12.0104 13.3327H13.3438C14.0804 13.3327 14.6771 12.736 14.6771 11.9993V3.99935C14.6771 3.26268 14.0804 2.66602 13.3438 2.66602H12.0104ZM7.34375 5.33268C6.60708 5.33268 6.01042 5.92935 6.01042 6.66602V11.9993C6.01042 12.736 6.60708 13.3327 7.34375 13.3327H8.67708C9.41375 13.3327 10.0104 12.736 10.0104 11.9993V6.66602C10.0104 5.92935 9.41375 5.33268 8.67708 5.33268H7.34375ZM2.67708 7.99935C1.94042 7.99935 1.34375 8.59602 1.34375 9.33268V11.9993C1.34375 12.736 1.94042 13.3327 2.67708 13.3327H4.01042C4.74708 13.3327 5.34375 12.736 5.34375 11.9993V9.33268C5.34375 8.59602 4.74708 7.99935 4.01042 7.99935H2.67708Z" }) });
}
function _3(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M16.1557 6.42331C16.6148 5.98332 16.6148 5.26997 16.1557 4.82999C15.6967 4.39 14.9525 4.39 14.4935 4.82999L7.84438 11.2033C7.83003 11.217 7.81614 11.231 7.80268 11.2453C7.79259 11.256 7.78275 11.2669 7.77314 11.2779C7.38661 11.7205 7.41032 12.3808 7.84427 12.7967L14.4933 19.17C14.9524 19.61 15.6966 19.61 16.1556 19.17C16.6146 18.7301 16.6146 18.0167 16.1556 17.5767L10.3377 12.0001L16.1557 6.42331Z" }) });
}
function $3(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.84427 17.5767C7.38524 18.0167 7.38524 18.73 7.84427 19.17C8.30329 19.61 9.04752 19.61 9.50653 19.17L16.1556 12.7967C16.17 12.783 16.1839 12.769 16.1973 12.7547C16.2074 12.744 16.2173 12.7331 16.2269 12.7221C16.6134 12.2795 16.5897 11.6192 16.1557 11.2033L9.50665 4.82997C9.04762 4.39001 8.3034 4.39001 7.84438 4.82997C7.38535 5.26992 7.38535 5.98332 7.84438 6.42328L13.6623 11.9999L7.84427 17.5767Z" }) });
}
function e2(e) {
  return /* @__PURE__ */ A(
    "svg",
    {
      ...e,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "currentcolor",
      children: /* @__PURE__ */ A("path", { d: "M4.67064 1.99414C3.19797 1.99414 2.00397 3.18814 2.00397 4.66081V11.3275C2.00397 12.8001 3.19797 13.9941 4.67064 13.9941H11.3373C12.81 13.9941 14.004 12.8001 14.004 11.3275V4.66081C14.004 3.18814 12.81 1.99414 11.3373 1.99414H4.67064ZM6.64997 3.32747C7.01797 3.32147 7.33131 3.60547 7.33731 3.97347C7.34331 4.34147 7.05931 4.65481 6.69131 4.66081C6.30331 4.66747 6.00864 4.94547 6.00397 5.32747C6.00264 5.42081 6.0053 5.42681 6.00397 5.51481C5.99464 6.23681 5.98063 6.49414 5.89997 6.82747C5.82863 7.11947 5.6493 7.48214 5.39997 7.99414C5.65197 8.51147 5.82797 8.87081 5.89997 9.16081C5.98663 9.51147 5.9993 9.77014 6.00397 10.5775C6.00397 10.6215 6.00397 10.6155 6.00397 10.6608C6.00664 11.0635 6.2673 11.3275 6.67064 11.3275C7.03864 11.3275 7.33731 11.6261 7.33731 11.9941C7.33731 12.3621 7.03864 12.6608 6.67064 12.6608C5.52464 12.6601 4.6773 11.7881 4.67064 10.6608C4.67064 10.6155 4.67064 10.6215 4.67064 10.5775C4.66664 9.88414 4.65997 9.70281 4.60797 9.49414C4.55197 9.26814 4.44797 9.0488 4.06663 8.28613C3.97263 8.09813 3.97263 7.89015 4.06663 7.70215C4.4393 6.95748 4.55264 6.72281 4.60797 6.49414C4.65664 6.29481 4.66264 6.11081 4.67064 5.49414C4.67197 5.40681 4.6693 5.42147 4.67064 5.32747C4.68464 4.22481 5.53997 3.34614 6.64997 3.32747ZM9.33731 3.32747C10.4606 3.33747 11.3466 4.21947 11.3373 5.32747C11.3306 6.07347 11.3446 6.27614 11.4 6.49414C11.456 6.71481 11.5366 6.89282 11.9413 7.70215C12.0353 7.89015 12.0353 8.09813 11.9413 8.28613C11.5466 9.07547 11.456 9.27147 11.4 9.49414C11.3453 9.71147 11.3353 9.89814 11.3373 10.6608C11.3406 11.7935 10.4746 12.6655 9.33731 12.6608C8.96931 12.6595 8.66931 12.3621 8.67064 11.9941C8.67197 11.6261 8.96931 11.3261 9.33731 11.3275C9.73264 11.3288 10.0053 11.0555 10.004 10.6608C10.0013 9.77481 10.0153 9.52881 10.108 9.16081C10.18 8.87414 10.3513 8.51947 10.608 7.99414C10.3473 7.46281 10.1806 7.11214 10.108 6.82747C10.0133 6.45547 9.99664 6.19747 10.004 5.32747C10.0073 4.95814 9.72731 4.66414 9.33731 4.66081C8.96931 4.65747 8.66731 4.36214 8.67064 3.99414C8.67397 3.62614 8.96931 3.32414 9.33731 3.32747Z" })
    }
  );
}
function t2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12.0283 1.99805C10.3713 1.99805 9.02832 3.34105 9.02832 4.99805C9.02832 6.26605 9.86732 7.40607 11.0263 7.82507L11.0283 10.998H7.02832C6.47632 10.998 6.02832 11.446 6.02832 11.998L6.02731 16.173C4.87631 16.569 4.02832 17.73 4.02832 18.998C4.02832 20.655 5.37132 21.998 7.02832 21.998C8.68532 21.998 10.0283 20.655 10.0283 18.998C10.0283 17.73 9.23332 16.612 8.03932 16.16L8.02832 12.998H12.0283H16.0283L16.0353 16.175C14.8343 16.592 14.0283 17.73 14.0283 18.998C14.0283 20.655 15.3713 21.998 17.0283 21.998C18.6853 21.998 20.0283 20.655 20.0283 18.998C20.0283 17.73 19.2093 16.614 18.0363 16.17L18.0283 11.998C18.0283 11.446 17.5803 10.998 17.0283 10.998H13.0283L13.0253 7.82104C14.1893 7.41004 15.0283 6.26605 15.0283 4.99805C15.0283 3.34105 13.6853 1.99805 12.0283 1.99805Z" }) });
}
function n2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 18 19", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.27293 3.26461C8.46408 3.26461 8.61903 3.10949 8.61904 2.91815L8.6191 0.500008C6.2185 0.599662 4.06088 1.64036 2.50446 3.26475L8.27293 3.26461ZM10.6957 6.82116C10.6957 7.0125 10.5407 7.16762 10.3496 7.16762L0.304562 7.16782C0.613333 6.01248 1.14583 4.94828 1.85198 4.02532L10.3496 4.02518C10.5408 4.02518 10.6957 4.1803 10.6957 4.37166L10.6957 6.82116ZM15.4943 15.7353C13.9385 17.3591 11.7809 18.3997 9.37968 18.5L9.37974 16.0819C9.37974 15.8905 9.5347 15.7354 9.72585 15.7354L15.4943 15.7353ZM8.61928 18.4994C6.21868 18.3999 4.06051 17.3587 2.50477 15.735L8.2732 15.7348C8.46437 15.7348 8.61934 15.89 8.61933 16.0813L8.61928 18.4994ZM13.196 12.1777C13.196 11.9864 13.3509 11.8313 13.5421 11.8312L17.6942 11.831C17.3854 12.9863 16.8536 14.0499 16.1468 14.9735L13.5421 14.9737C13.3509 14.9737 13.1959 14.8186 13.1959 14.6272L13.196 12.1777ZM6.63574 8.26583C6.64045 8.07793 6.79397 7.92806 6.98174 7.92805L17.8631 7.92797C17.953 8.43803 18 8.96317 18 9.49919C18 10.0352 17.9529 10.5604 17.8631 11.0704L6.98317 11.07C6.79504 11.0699 6.64138 10.9195 6.63718 10.7312L6.6074 9.39625L6.63574 8.26583ZM12.5542 14.6279C12.5542 14.8192 12.3992 14.9743 12.2081 14.9743L1.85233 14.9744C1.14562 14.0509 0.613778 12.9873 0.305062 11.832L12.2081 11.8319C12.3993 11.8319 12.5543 11.987 12.5543 12.1784L12.5542 14.6279ZM0.136912 7.92839L5.5227 7.92809C5.71386 7.92809 5.86883 8.08321 5.86883 8.27457L5.86877 10.7241C5.86877 10.9154 5.71381 11.0705 5.52266 11.0706L0.136834 11.0708C0.046996 10.5608 -1.44252e-05 10.0356 -1.12058e-06 9.49961C1.02767e-05 8.9636 0.0470512 8.43845 0.136912 7.92839ZM11.4567 4.3716C11.4567 4.18026 11.6117 4.02515 11.8028 4.02514L16.1471 4.02498C16.8538 4.94851 17.3856 6.01207 17.6943 7.1674L11.8028 7.1676C11.6116 7.1676 11.4567 7.01248 11.4567 6.82112L11.4567 4.3716ZM9.3801 0.500001C11.7807 0.599542 13.9389 1.64073 15.4946 3.26444L9.72617 3.26457C9.53501 3.26458 9.38004 3.10945 9.38004 2.9181L9.3801 0.500001Z" }) });
}
function r2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.33203 1.99414C5.85936 1.99414 4.66536 3.18814 4.66536 4.66081H3.9987C2.61203 4.66081 1.50204 5.72481 1.37337 7.07747C1.71071 7.19281 6.22803 8.70282 6.22803 8.70215C7.18469 9.02148 8.8127 9.02148 9.76937 8.70215C9.76937 8.70215 13.224 7.54881 14.6447 7.07747C14.5214 5.71947 13.3887 4.66081 11.9987 4.66081H11.332C11.332 3.18814 10.138 1.99414 8.66536 1.99414H7.33203ZM7.33203 3.32747H8.66536C9.40203 3.32747 9.9987 3.92414 9.9987 4.66081H5.9987C5.9987 3.92414 6.59536 3.32747 7.33203 3.32747ZM1.33203 8.47347V11.3275C1.33203 12.8001 2.52603 13.9941 3.9987 13.9941H11.9987C13.4714 13.9941 14.6654 12.8001 14.6654 11.3275V8.47347L10.186 9.97347C8.95603 10.3835 7.04136 10.3835 5.81136 9.97347L1.33203 8.47347Z" }) });
}
function o2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.00586 2.01367C7.45356 2.01367 7.00586 2.46167 7.00586 3.01367C4.79676 3.01367 3.00576 4.80467 3.00586 7.01367V8.07568L21.0059 8.01367V7.01367C21.0059 4.80467 19.215 3.01367 17.0059 3.01367C17.0059 2.46167 16.5582 2.01367 16.0059 2.01367C15.4536 2.01367 15.0059 2.46167 15.0059 3.01367H9.00586C9.00586 2.46167 8.55816 2.01367 8.00586 2.01367ZM3.00586 10.0137V17.0137C3.00586 19.2227 4.79676 21.0137 7.00586 21.0137H17.0059C19.215 21.0137 21.006 19.2227 21.0059 17.0137V10.0137H3.00586ZM8.00586 12.0137C8.55816 12.0137 9.00586 12.4617 9.00586 13.0137C9.00586 13.5657 8.55816 14.0137 8.00586 14.0137C7.45356 14.0137 7.00586 13.5657 7.00586 13.0137C7.00586 12.4617 7.45356 12.0137 8.00586 12.0137ZM12.0059 12.0137C12.5582 12.0137 13.0059 12.4617 13.0059 13.0137C13.0059 13.5657 12.5582 14.0137 12.0059 14.0137C11.4536 14.0137 11.0059 13.5657 11.0059 13.0137C11.0059 12.4617 11.4536 12.0137 12.0059 12.0137ZM16.0059 12.0137C16.5582 12.0137 17.0059 12.4617 17.0059 13.0137C17.0059 13.5657 16.5582 14.0137 16.0059 14.0137C15.4536 14.0137 15.0059 13.5657 15.0059 13.0137C15.0059 12.4617 15.4536 12.0137 16.0059 12.0137ZM8.00586 15.0137C8.55816 15.0137 9.00586 15.4617 9.00586 16.0137C9.00586 16.5657 8.55816 17.0137 8.00586 17.0137C7.45356 17.0137 7.00586 16.5657 7.00586 16.0137C7.00586 15.4617 7.45356 15.0137 8.00586 15.0137ZM12.0059 15.0137C12.5582 15.0137 13.0059 15.4617 13.0059 16.0137C13.0059 16.5657 12.5582 17.0137 12.0059 17.0137C11.4536 17.0137 11.0059 16.5657 11.0059 16.0137C11.0059 15.4617 11.4536 15.0137 12.0059 15.0137ZM16.0059 15.0137C16.5582 15.0137 17.0059 15.4617 17.0059 16.0137C17.0059 16.5657 16.5582 17.0137 16.0059 17.0137C15.4536 17.0137 15.0059 16.5657 15.0059 16.0137C15.0059 15.4617 15.4536 15.0137 16.0059 15.0137Z" }) });
}
function i2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.28221 5.22951C3.98888 4.9235 3.51331 4.9235 3.21999 5.22951C2.92667 5.53552 2.92667 6.03168 3.21999 6.33769L7.46885 10.7704C7.47802 10.78 7.48736 10.7892 7.49688 10.7982C7.50402 10.8049 7.51125 10.8115 7.51858 10.8179C7.81368 11.0756 8.25385 11.0598 8.53115 10.7705L12.78 6.33777C13.0733 6.03175 13.0733 5.5356 12.78 5.22958C12.4867 4.92357 12.0111 4.92357 11.7178 5.22958L8.00004 9.10822L4.28221 5.22951Z"
    }
  ) });
}
function s2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M10 16L10 12.8L10 11.2L10 8L14 12L10 16Z" }) });
}
function a2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12 3C7.0293 3 3 7.0293 3 12C3 16.9707 7.0293 21 12 21C16.9707 21 21 16.9707 21 12C21 7.0293 16.9707 3 12 3ZM15.6 9.3C15.8304 9.3 16.0707 9.37741 16.2471 9.55291C16.5981 9.90481 16.5981 10.4952 16.2471 10.8471L12.8721 14.1942C11.8362 15.2292 10.2531 15.0744 9.4404 13.8558L8.54041 12.5058C8.26501 12.0927 8.38019 11.5167 8.79419 11.2404C9.20729 10.965 9.78329 11.0802 10.0596 11.4942L10.9596 12.8442C11.1414 13.1169 11.3745 13.1601 11.6058 12.9279L14.9529 9.55291C15.1293 9.37741 15.3696 9.3 15.6 9.3Z" }) });
}
function c2(e) {
  return /* @__PURE__ */ R("svg", { ...e, viewBox: "0 0 24 24", fill: "none", children: [
    /* @__PURE__ */ A("circle", { cx: "12", cy: "12", r: "10", fill: "none" }),
    /* @__PURE__ */ A(
      "path",
      {
        d: "M10.1575 16.8849C10.5032 16.8849 10.8257 16.7467 11.0562 16.5162L18.3142 9.25817L16.517 7.46094L10.1575 13.8204L7.48473 11.1476L5.6875 12.9448L9.25893 16.5162C9.48934 16.7467 9.81192 16.8849 10.1575 16.8849Z",
        fill: "currentcolor"
      }
    ),
    /* @__PURE__ */ A(
      "path",
      {
        d: "M2.51367 12C2.51367 6.75314 6.76701 2.5 12.0137 2.5C17.2603 2.5 21.5137 6.75314 21.5137 12C21.5137 17.2468 17.2603 21.5 12.0137 21.5C6.76701 21.5 2.51367 17.2468 2.51367 12Z",
        stroke: "currentcolor"
      }
    )
  ] });
}
function u2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M10.1575 16.8849C10.5032 16.8849 10.8257 16.7467 11.0562 16.5162L18.3142 9.25817L16.517 7.46094L10.1575 13.8204L7.48473 11.1476L5.6875 12.9448L9.25893 16.5162C9.48934 16.7467 9.81192 16.8849 10.1575 16.8849Z" }) });
}
function l2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "none", stroke: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      d: "M6 9L12 15L18 9",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
}
function d2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("circle", { cx: "8", cy: "8", r: "6.665" }) });
}
function A2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12 3C7.02948 3 3 7.0293 3 12C3 16.9707 7.02948 21 12 21C16.9705 21 21 16.9707 21 12C21 7.0293 16.9705 3 12 3ZM12 6.6C12.4971 6.6 12.9 7.0032 12.9 7.5V11.6058L15.3469 14.0529C15.6984 14.4048 15.6984 14.9952 15.3469 15.3471C14.9954 15.6981 14.4046 15.6981 14.0531 15.3471L11.3531 12.6471C11.1843 12.4779 11.1 12.2385 11.1 12V7.5C11.1 7.0032 11.5029 6.6 12 6.6Z" }) });
}
function f2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12.0137 3.99043C10.8277 4.00043 9.59167 4.33942 8.51367 4.95942C8.03467 5.23442 7.86367 5.85542 8.13867 6.33442C8.41367 6.81342 9.03467 6.95347 9.51367 6.67847C10.2927 6.23047 11.1717 5.99742 12.0137 5.99042C14.6947 5.96942 17.0347 8.27742 17.0137 10.9904C17.0137 11.0504 17.0137 11.8534 17.0137 12.0844C17.0137 12.5504 17.3097 12.9794 17.7637 13.0844C19.0797 13.3884 20.0137 14.3904 20.0137 15.4904C20.0137 15.8464 19.9357 16.2034 19.7637 16.5224C19.5017 17.0074 19.6837 17.6034 20.1697 17.8654C20.6557 18.1284 21.2517 17.9454 21.5137 17.4594C21.8417 16.8524 22.0137 16.1824 22.0137 15.4904C22.0137 13.6764 20.8217 12.1095 19.0097 11.3765C19.0117 11.1985 19.0137 11.0174 19.0137 10.9904C19.0437 7.15542 15.8047 3.96143 12.0137 3.99043ZM5.01367 5.99042C4.75767 5.99042 4.48968 6.07647 4.29468 6.27247C3.90468 6.66247 3.90468 7.31941 4.29468 7.70941L5.40268 8.80542C5.29468 9.03042 5.24667 9.28445 5.19067 9.54345C3.28667 10.3735 2.01367 12.2084 2.01367 14.3654C2.01367 17.3754 4.38968 19.9904 7.32568 19.9904H16.5757L17.2947 20.7094C17.6857 21.1004 18.3417 21.1004 18.7327 20.7094C19.1227 20.3194 19.1227 19.6624 18.7327 19.2724L17.7327 18.2724L5.73267 6.27247C5.53667 6.07647 5.26967 5.99042 5.01367 5.99042ZM7.04169 10.4495L14.5757 17.9904H7.32568C5.53868 17.9904 4.01367 16.3124 4.01367 14.3654C4.01367 12.8734 4.94767 11.6624 6.35767 11.2404C6.71567 11.1334 6.99369 10.8025 7.04169 10.4495Z" }) });
}
function h2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M13.3351 1.99414C13.1645 1.99414 12.9858 2.05148 12.8558 2.18148L10.1891 4.84814L8.66847 3.32747V7.32747H12.6685L11.1478 5.8068L13.8145 3.14014C14.0745 2.87947 14.0745 2.44214 13.8145 2.18148C13.6845 2.05148 13.5058 1.99414 13.3351 1.99414ZM3.33514 8.66081L4.85581 10.1815L2.18914 12.8481C1.92914 13.1088 1.92914 13.5461 2.18914 13.8068C2.31914 13.9368 2.4978 13.9941 2.66847 13.9941C2.83914 13.9941 3.0178 13.9368 3.1478 13.8068L5.81446 11.1401L7.33513 12.6608V8.66081H3.33514Z" }) });
}
function p2(e) {
  return /* @__PURE__ */ R("svg", { ...e, viewBox: "0 0 242 62", fill: "currentcolor", children: [
    /* @__PURE__ */ A("path", { d: "M29.2499 16.0724C29.526 16.0724 29.7499 15.8485 29.7499 15.5724L29.75 9.45358C23.9969 9.69217 18.8261 12.1837 15.0961 16.0727L29.2499 16.0724ZM21.6271 24.9167C21.6271 25.1928 21.4033 25.4167 21.1271 25.4167L9.82394 25.4172C10.5639 22.6511 11.8401 20.1033 13.5324 17.8936L21.1272 17.8933C21.4034 17.8933 21.6272 18.1171 21.6272 18.3933L21.6271 24.9167ZM46.2267 45.9287C42.4981 49.8163 37.3274 52.3078 31.5728 52.5478L31.5729 46.4291C31.5729 46.1529 31.7968 45.9291 32.0729 45.9291L46.2267 45.9287ZM29.7504 52.5464C23.9973 52.3081 18.8252 49.8154 15.0968 45.928L29.2506 45.9277C29.5267 45.9277 29.7506 46.1516 29.7506 46.4277L29.7504 52.5464ZM24.1289 37.082C24.1289 36.8059 24.3527 36.582 24.6289 36.582L51.4988 36.5814C50.7589 39.3474 49.4842 41.8938 47.7904 44.1049L24.6287 44.1055C24.3526 44.1055 24.1287 43.8816 24.1287 43.6054L24.1289 37.082ZM41.5947 27.7247C41.6015 27.4536 41.8233 27.2373 42.0945 27.2373L51.9037 27.2371C52.119 28.4582 52.2317 29.7155 52.2317 30.9988C52.2316 32.282 52.1189 33.5393 51.9035 34.7605L42.0971 34.7593C41.8253 34.7593 41.6033 34.5422 41.5973 34.2705L41.5187 30.7523L41.5947 27.7247ZM22.5908 43.607C22.5908 43.8831 22.3669 44.107 22.0908 44.107L13.5332 44.1071C11.8396 41.8961 10.565 39.3498 9.82514 36.5838L22.0909 36.5835C22.3671 36.5835 22.591 36.8074 22.5909 37.0835L22.5908 43.607ZM9.42216 27.2381L39.2487 27.2373C39.5249 27.2373 39.7487 27.4612 39.7487 27.7374L39.7486 34.2608C39.7486 34.5369 39.5247 34.7608 39.2486 34.7608L9.42197 34.7615C9.20667 33.5404 9.094 32.2831 9.09403 30.9998C9.09406 29.7165 9.2068 28.4592 9.42216 27.2381ZM23.451 18.3932C23.451 18.1171 23.6749 17.8932 23.951 17.8932L47.791 17.8928C49.4847 20.1039 50.7593 22.6502 51.4991 25.4162L23.9509 25.4166C23.6747 25.4167 23.4509 25.1928 23.4509 24.9166L23.451 18.3932ZM31.5738 9.45357C37.3269 9.69188 42.499 12.1846 46.2274 16.072L32.0737 16.0723C31.7975 16.0723 31.5736 15.8484 31.5736 15.5723L31.5738 9.45357Z" }),
    /* @__PURE__ */ A("path", { d: "M66.6074 31.1806C66.6074 28.1869 67.2536 25.5242 68.5459 23.1925C69.8382 20.8321 71.6331 19.0042 73.9306 17.7089C76.2568 16.3847 78.8845 15.7227 81.8138 15.7227C85.4036 15.7227 88.4765 16.6726 91.0324 18.5724C93.5884 20.4723 95.2971 23.063 96.1587 26.3446H88.0601C87.457 25.078 86.5954 24.1137 85.4754 23.4516C84.3841 22.7895 83.1349 22.4585 81.7277 22.4585C79.4589 22.4585 77.6209 23.2501 76.2137 24.8333C74.8065 26.4165 74.1029 28.5323 74.1029 31.1806C74.1029 33.8289 74.8065 35.9446 76.2137 37.5278C77.6209 39.111 79.4589 39.9027 81.7277 39.9027C83.1349 39.9027 84.3841 39.5716 85.4754 38.9095C86.5954 38.2475 87.457 37.2832 88.0601 36.0166H96.1587C95.2971 39.2982 93.5884 41.8889 91.0324 43.7887C88.4765 45.6598 85.4036 46.5953 81.8138 46.5953C78.8845 46.5953 76.2568 45.9477 73.9306 44.6523C71.6331 43.3282 69.8382 41.5003 68.5459 39.1686C67.2536 36.837 66.6074 34.1743 66.6074 31.1806Z" }),
    /* @__PURE__ */ A("path", { d: "M109.888 46.7249C107.533 46.7249 105.408 46.2211 103.513 45.2136C101.646 44.2061 100.167 42.7668 99.0758 40.8958C98.0132 39.0247 97.4819 36.837 97.4819 34.3326C97.4819 31.857 98.0276 29.6837 99.1189 27.8127C100.21 25.9128 101.704 24.4591 103.599 23.4516C105.494 22.4441 107.62 21.9404 109.974 21.9404C112.329 21.9404 114.455 22.4441 116.35 23.4516C118.245 24.4591 119.739 25.9128 120.83 27.8127C121.921 29.6837 122.467 31.857 122.467 34.3326C122.467 36.8082 121.907 38.9959 120.787 40.8958C119.696 42.7668 118.188 44.2061 116.264 45.2136C114.368 46.2211 112.243 46.7249 109.888 46.7249ZM109.888 40.3344C111.295 40.3344 112.487 39.8163 113.464 38.78C114.469 37.7437 114.971 36.2613 114.971 34.3326C114.971 32.404 114.483 30.9215 113.507 29.8852C112.559 28.8489 111.382 28.3308 109.974 28.3308C108.539 28.3308 107.347 28.8489 106.399 29.8852C105.451 30.8927 104.977 32.3752 104.977 34.3326C104.977 36.2613 105.437 37.7437 106.356 38.78C107.304 39.8163 108.481 40.3344 109.888 40.3344Z" }),
    /* @__PURE__ */ A("path", { d: "M139.298 22.0267C142.113 22.0267 144.353 22.9479 146.018 24.7902C147.713 26.6037 148.56 29.108 148.56 32.3032V46.3794H141.237V33.2963C141.237 31.6843 140.82 30.4322 139.987 29.5398C139.155 28.6474 138.035 28.2013 136.627 28.2013C135.22 28.2013 134.1 28.6474 133.267 29.5398C132.434 30.4322 132.018 31.6843 132.018 33.2963V46.3794H124.652V22.2858H132.018V25.481C132.765 24.4159 133.77 23.5812 135.033 22.9767C136.297 22.3434 137.719 22.0267 139.298 22.0267Z" }),
    /* @__PURE__ */ A("path", { d: "M166.602 22.0267C169.416 22.0267 171.656 22.9479 173.322 24.7902C175.016 26.6037 175.864 29.108 175.864 32.3032V46.3794H168.54V33.2963C168.54 31.6843 168.124 30.4322 167.291 29.5398C166.458 28.6474 165.338 28.2013 163.931 28.2013C162.524 28.2013 161.404 28.6474 160.571 29.5398C159.738 30.4322 159.322 31.6843 159.322 33.2963V46.3794H151.956V22.2858H159.322V25.481C160.069 24.4159 161.074 23.5812 162.337 22.9767C163.601 22.3434 165.022 22.0267 166.602 22.0267Z" }),
    /* @__PURE__ */ A("path", { d: "M201.918 33.944C201.918 34.6349 201.875 35.3545 201.789 36.1029H185.118C185.233 37.5998 185.707 38.7512 186.539 39.5572C187.401 40.3344 188.449 40.723 189.684 40.723C191.522 40.723 192.8 39.9458 193.518 38.3914H201.358C200.956 39.9746 200.224 41.3995 199.161 42.6661C198.127 43.9327 196.821 44.9258 195.241 45.6454C193.662 46.365 191.895 46.7249 189.943 46.7249C187.588 46.7249 185.491 46.2211 183.653 45.2136C181.815 44.2061 180.379 42.7668 179.346 40.8958C178.312 39.0247 177.795 36.837 177.795 34.3326C177.795 31.8283 178.297 29.6405 179.302 27.7695C180.336 25.8984 181.772 24.4591 183.61 23.4516C185.448 22.4441 187.559 21.9404 189.943 21.9404C192.269 21.9404 194.337 22.4297 196.146 23.4084C197.955 24.3872 199.362 25.7833 200.367 27.5968C201.401 29.4103 201.918 31.526 201.918 33.944ZM194.38 32.001C194.38 30.7344 193.949 29.7269 193.087 28.9785C192.226 28.23 191.149 27.8558 189.856 27.8558C188.622 27.8558 187.573 28.2157 186.712 28.9353C185.879 29.6549 185.362 30.6768 185.161 32.001H194.38Z" }),
    /* @__PURE__ */ A("path", { d: "M202.617 34.3326C202.617 31.8283 203.119 29.6405 204.124 27.7695C205.158 25.8984 206.58 24.4591 208.389 23.4516C210.227 22.4441 212.323 21.9404 214.678 21.9404C217.694 21.9404 220.207 22.732 222.217 24.3152C224.256 25.8984 225.591 28.1293 226.223 31.0079H218.383C217.722 29.1656 216.444 28.2444 214.549 28.2444C213.199 28.2444 212.122 28.777 211.318 29.842C210.514 30.8783 210.112 32.3752 210.112 34.3326C210.112 36.29 210.514 37.8013 211.318 38.8664C212.122 39.9027 213.199 40.4208 214.549 40.4208C216.444 40.4208 217.722 39.4997 218.383 37.6574H226.223C225.591 40.4784 224.256 42.6949 222.217 44.3069C220.178 45.9189 217.665 46.7249 214.678 46.7249C212.323 46.7249 210.227 46.2211 208.389 45.2136C206.58 44.2061 205.158 42.7668 204.124 40.8958C203.119 39.0247 202.617 36.837 202.617 34.3326Z" }),
    /* @__PURE__ */ A("path", { d: "M241.837 40.1185V46.3794H238.09C235.419 46.3794 233.337 45.7318 231.843 44.4364C230.35 43.1123 229.603 40.9677 229.603 38.0028V28.4172H226.674V22.2858H229.603V16.4135H236.97V22.2858H241.794V28.4172H236.97V38.0892C236.97 38.8088 237.142 39.3269 237.486 39.6436C237.831 39.9602 238.405 40.1185 239.21 40.1185H241.837Z" })
  ] });
}
function m2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 20 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M20 1.84472C20 1.46377 19.7836 1.11591 19.4418 0.94761L18.088 0.28089C17.7399 0.109485 17.3242 0.154861 17.0213 0.397305L10.9046 5.29345L13.3938 7.26606L16.9338 4.43246V11.5763L2.94616 0.468456C2.64307 0.227771 2.22832 0.183587 1.88133 0.355019L0.557054 1.00929C0.215927 1.17782 0 1.52534 0 1.90583V14.1546C0 14.5354 0.216328 14.8832 0.557941 15.0516L1.9119 15.7189C2.26 15.8904 2.67592 15.8451 2.97888 15.6026L9.05159 10.7415L6.56234 8.76886L3.06621 11.5675V4.48484L17.0477 15.5957C17.3508 15.8366 17.7658 15.8809 18.1129 15.7093L19.4431 15.0519C19.7841 14.8833 20 14.5358 20 14.1554V1.84472Z" }) });
}
function g2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 10 2", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M1 0C1.552 0 2 0.448 2 1C2 1.552 1.552 2 1 2C0.448 2 0 1.552 0 1C0 0.448 0.448 0 1 0ZM5 0C5.552 0 6 0.448 6 1C6 1.552 5.552 2 5 2C4.448 2 4 1.552 4 1C4 0.448 4.448 0 5 0ZM9 0C9.552 0 10 0.448 10 1C10 1.552 9.552 2 9 2C8.448 2 8 1.552 8 1C8 0.448 8.448 0 9 0Z" }) });
}
function b2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.00846 1.33203C4.32646 1.33203 1.3418 4.3167 1.3418 7.9987C1.3418 11.6807 4.32646 14.6654 8.00846 14.6654C11.6905 14.6654 14.6751 11.6807 14.6751 7.9987C14.6751 4.3167 11.6905 1.33203 8.00846 1.33203ZM8.00846 4.66536C8.37646 4.66536 8.67513 4.96403 8.67513 5.33203V8.66536C8.67513 9.03336 8.37646 9.33203 8.00846 9.33203C7.64046 9.33203 7.3418 9.03336 7.3418 8.66536V5.33203C7.3418 4.96403 7.64046 4.66536 8.00846 4.66536ZM8.00846 9.9987C8.37646 9.9987 8.67513 10.2974 8.67513 10.6654C8.67513 11.0334 8.37646 11.332 8.00846 11.332C7.64046 11.332 7.3418 11.0334 7.3418 10.6654C7.3418 10.2974 7.64046 9.9987 8.00846 9.9987Z" }) });
}
function v2(e) {
  return /* @__PURE__ */ R("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: [
    /* @__PURE__ */ A("path", { d: "M9 4C9 3.448 8.552 3 8 3C7.448 3 7 3.448 7 4V9C7 9.552 7.448 10 8 10C8.552 10 9 9.552 9 9V4Z" }),
    /* @__PURE__ */ A("path", { d: "M9 12C9 11.448 8.552 11 8 11C7.448 11 7 11.448 7 12C7 12.552 7.448 13 8 13C8.552 13 9 12.552 9 12Z" })
  ] });
}
function y2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 20 20", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.33139 1.67773C5.36388 1.67773 2.49805 4.5159 2.49805 7.48507C2.49805 7.49365 2.49805 7.5024 2.49805 7.51107C2.49805 9.56107 2.49805 12.008 2.49805 12.2246C2.49805 13.7777 3.84056 15.0111 5.46639 15.0111H5.83139V15.5579C5.83139 17.1111 7.1739 18.3444 8.79973 18.3444H14.5297C16.1556 18.3444 17.4981 17.1111 17.4981 15.5579V7.79757C17.4981 6.2444 16.1556 5.01107 14.5297 5.01107H14.1647V4.46423C14.1647 2.91107 12.8222 1.67773 11.1964 1.67773C11.0181 1.67773 11.0097 1.67773 8.33139 1.67773ZM7.49805 3.55273V5.5579C7.49805 6.15257 6.93638 6.67773 6.19638 6.67773H4.34721C4.72971 5.20507 6.02139 3.94473 7.49805 3.55273ZM14.1647 6.67773H14.5297C15.2697 6.67773 15.8314 7.2029 15.8314 7.79757V15.5579C15.8314 16.1526 15.2697 16.6777 14.5297 16.6777H8.79973C8.05973 16.6777 7.49805 16.1526 7.49805 15.5579V15.0111H11.1964C12.8222 15.0111 14.1647 13.7777 14.1647 12.2246V6.67773Z" }) });
}
function C2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 18 19", fill: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      d: "M2.99829 0.682129C1.24429 0.683129 0.008291 1.90913 -0.00170898 3.68213V5.68213C-0.000708986 5.72213 -0.00170898 14.6821 -0.00170898 14.6821C-0.00170898 16.8911 1.78929 18.6821 3.99828 18.6821H13.9983C16.2073 18.6821 17.9983 16.8911 17.9983 14.6821V8.68213C17.9973 8.59713 17.9983 6.84013 17.9983 6.71313C18.0053 4.97213 16.7203 3.68913 14.9983 3.68213C14.7263 3.68113 14.0513 3.68113 14.0613 3.68213C13.1383 3.67913 12.9253 3.49513 12.3423 2.62013C11.4253 1.24513 10.6533 0.682129 8.99828 0.682129H2.99829ZM2.99829 2.68213H8.99828C9.84328 2.68213 10.0713 2.86913 10.6543 3.74413C11.5713 5.11913 12.3433 5.68213 13.9983 5.68213C13.9723 5.68313 14.7223 5.68113 14.9983 5.68213C15.6223 5.68513 16.0013 6.08313 15.9983 6.71313C15.9983 6.77713 15.9973 7.21813 15.9983 7.68213C15.3583 7.68213 15.1983 7.68213 11.9983 7.68213C11.1533 7.68213 10.9253 7.49513 10.3423 6.62013C9.42527 5.24513 8.65328 4.68213 6.99828 4.68213C6.11328 4.68213 3.43429 4.68213 1.99829 4.68213V3.68213C2.00229 3.01813 2.34029 2.68213 2.99829 2.68213Z",
      fill: "#6C7275"
    }
  ) });
}
function x2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 20 19", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M2.99829 0.68213C1.38729 0.68213 0.0122901 1.96913 -0.00170994 3.68213V14.6821C-0.00170994 15.7961 0.45129 16.8001 1.18629 17.5261C1.54429 17.8791 1.96529 18.1711 2.43629 18.3701C2.91929 18.5731 3.45429 18.6821 3.99829 18.6821H5.99829H12.9983C14.0523 18.6821 15.0383 18.2771 15.7793 17.5571C16.1773 17.1711 16.6333 16.0351 17.4363 13.6821C17.5003 13.4921 18.9473 9.0291 18.9673 8.9631C19.1653 8.3201 18.6713 7.6821 17.9983 7.6821C17.8733 7.6821 17.2123 7.6821 16.9983 7.6821V6.68213C16.9983 5.02513 15.6553 3.68213 13.9983 3.68213H11.9983C11.1533 3.68213 10.9253 3.49513 10.3423 2.62013C9.4253 1.24513 8.6533 0.68213 6.99829 0.68213C6.12329 0.68213 3.87329 0.68213 2.99829 0.68213ZM2.99829 2.68213C3.87329 2.68213 6.12329 2.68213 6.99829 2.68213C7.8433 2.68213 8.0713 2.86913 8.6543 3.74413C9.5713 5.11913 10.3433 5.68213 11.9983 5.68213H13.9983C14.5503 5.68213 14.9983 6.13013 14.9983 6.68213V7.6821C11.5293 7.6821 6.24829 7.6821 4.99829 7.6821C4.58429 7.6821 4.20929 7.9511 4.06029 8.3381C4.06029 8.3381 2.90229 11.3631 1.99829 13.7131V3.68213C2.00329 3.10513 2.45829 2.68213 2.99829 2.68213Z" }) });
}
function w2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M5.99804 2.99023C4.34104 2.99023 2.99805 4.33333 2.99805 5.99023V7.99023V16.9902C2.99805 19.1992 4.78904 20.9902 6.99804 20.9902H16.998C19.207 20.9902 20.998 19.1992 20.998 16.9902V7.99023C20.998 7.43793 20.55 6.99023 19.998 6.99023C19.998 6.99023 17.095 6.99023 14.998 6.99023C14.243 6.99023 14 6.74533 13.404 5.55273C12.501 3.74533 11.743 2.99023 9.99804 2.99023H5.99804ZM5.99804 4.99023H9.99804C10.753 4.99023 10.996 5.23513 11.592 6.42773C11.722 6.68883 11.776 6.77213 11.904 6.99023C8.45804 6.99023 5.98304 6.99023 4.99804 6.99023V5.99023C4.99804 5.43793 5.44604 4.99023 5.99804 4.99023ZM11.998 10.9902C12.55 10.9902 12.998 11.4382 12.998 11.9902V12.9902H13.998C14.55 12.9902 14.998 13.4382 14.998 13.9902C14.998 14.5422 14.55 14.9902 13.998 14.9902H12.998V15.9902C12.998 16.5422 12.55 16.9902 11.998 16.9902C11.446 16.9902 10.998 16.5422 10.998 15.9902V14.9902H9.99804C9.44604 14.9902 8.99804 14.5422 8.99804 13.9902C8.99804 13.4382 9.44604 12.9902 9.99804 12.9902H10.998V11.9902C10.998 11.4382 11.446 10.9902 11.998 10.9902Z" }) });
}
function I2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M5.97803 1.63718C5.03269 1.93652 4.21736 2.42652 3.4987 3.09519C3.2767 3.30252 3.2087 3.64052 3.3527 3.90785C3.8867 4.89519 3.32802 5.95119 2.12402 6.01186C1.82869 6.02719 1.56803 6.24518 1.4987 6.53252C1.37936 7.02918 1.33203 7.44519 1.33203 7.99118C1.33203 8.44918 1.38136 8.96719 1.47803 9.42852C1.53803 9.71652 1.7887 9.92385 2.08203 9.94985C3.29403 10.0545 3.89404 10.9785 3.3527 12.1578C3.2327 12.4198 3.28736 12.7332 3.4987 12.9285C4.2067 13.5839 5.02003 14.0452 5.97803 14.3452C6.25136 14.4312 6.56003 14.3279 6.72803 14.0952C7.46936 13.0699 8.5447 13.0659 9.2487 14.0952C9.4147 14.3379 9.7187 14.4545 9.9987 14.3658C10.9234 14.0752 11.7847 13.5799 12.4987 12.9285C12.7187 12.7285 12.7767 12.4038 12.6447 12.1372C12.09 11.0178 12.728 9.98985 13.8734 9.97051C14.1774 9.96518 14.448 9.76518 14.5194 9.47051C14.6347 8.99251 14.6654 8.57585 14.6654 7.99118C14.6654 7.48852 14.606 6.99319 14.4987 6.51186C14.4307 6.20786 14.1647 5.99185 13.8527 5.99119C12.7254 5.98919 12.0934 4.88119 12.6447 3.90785C12.798 3.63652 12.75 3.30452 12.5194 3.09519C11.7927 2.43519 10.9067 1.91985 9.97803 1.63718C9.69269 1.55052 9.38936 1.65719 9.22803 1.90785C8.58403 2.90785 7.38136 2.92586 6.7487 1.92853C6.5867 1.67319 6.26603 1.54518 5.97803 1.63718ZM7.9987 5.32452C9.47136 5.32452 10.6654 6.51852 10.6654 7.99118C10.6654 9.46385 9.47136 10.6579 7.9987 10.6579C6.52603 10.6579 5.33203 9.46385 5.33203 7.99118C5.33203 6.51852 6.52603 5.32452 7.9987 5.32452Z" }) });
}
function E2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.9987 1.34375C4.31683 1.34375 1.33203 4.32842 1.33203 8.01042C1.33203 9.08775 1.5899 10.1018 2.04343 11.0024C3.14036 13.1804 5.32943 14.6764 7.9987 14.6771C11.6806 14.6777 14.6654 11.6924 14.6654 8.01042C14.6654 4.32842 11.6806 1.34375 7.9987 1.34375ZM7.9987 2.67708C8.61997 2.67708 9.33403 3.73641 9.68937 5.29441C9.14997 5.32908 8.5851 5.34375 7.9987 5.34375C7.40983 5.34375 6.8449 5.32175 6.30477 5.28575C6.65983 3.78575 7.37743 2.67708 7.9987 2.67708ZM5.6419 3.22575C5.33797 3.78508 5.11463 4.49575 4.96296 5.16575C4.46976 5.09908 4.0233 5.00242 3.64763 4.90708C4.16463 4.19975 4.85216 3.60308 5.6419 3.22575ZM10.365 3.22174C11.0894 3.59641 11.82 4.19109 12.3484 4.91909C11.9732 5.01309 11.5143 5.09643 11.0237 5.16109C10.872 4.49109 10.6166 3.74641 10.365 3.22174ZM3.01483 6.11041C3.52043 6.26441 4.04203 6.37908 4.74337 6.47308C4.68583 6.98042 4.66536 7.46708 4.66536 8.01042C4.66536 8.55375 4.6907 9.04908 4.74823 9.55642C4.03343 9.65242 3.5151 9.74575 3.00183 9.90175C2.7663 9.29975 2.66536 8.69575 2.66536 8.01042C2.66536 7.32508 2.7793 6.71241 3.01483 6.11041ZM12.9766 6.11375C13.2122 6.71575 13.332 7.32508 13.332 8.01042C13.332 8.69575 13.2171 9.30175 12.9816 9.90375C12.4697 9.74775 11.9517 9.64308 11.2396 9.54775C11.2957 9.04575 11.332 8.54642 11.332 8.01042C11.332 7.46708 11.2956 6.97107 11.238 6.46307C11.9378 6.36641 12.4709 6.26708 12.9766 6.11375ZM6.08396 6.60175C6.7019 6.64641 7.3245 6.67708 7.9987 6.67708C8.6691 6.67708 9.30243 6.64642 9.9175 6.59975C9.97377 7.06842 9.9987 7.49575 9.9987 8.01042C9.9987 8.52508 9.98077 8.94108 9.92457 9.40908C9.30743 9.36374 8.67077 9.34375 7.9987 9.34375C7.3249 9.34375 6.69417 9.36776 6.07457 9.41376C6.01677 8.93976 5.9987 8.53308 5.9987 8.01042C5.9987 7.49575 6.0277 7.06975 6.08396 6.60175ZM7.9987 10.6771C8.58423 10.6771 9.1457 10.6991 9.6849 10.7337C9.30983 12.2944 8.62263 13.3437 7.9987 13.3437C7.37743 13.3437 6.67576 12.2438 6.2909 10.7324C6.83176 10.6964 7.4089 10.6771 7.9987 10.6771ZM4.96603 10.8624C5.11763 11.5324 5.3815 12.2678 5.6331 12.7931C4.89496 12.4424 4.18623 11.8384 3.6459 11.1144C4.0279 11.0178 4.46037 10.9298 4.96603 10.8624ZM11.0257 10.8611C11.5274 10.9264 11.9618 11.0211 12.3431 11.1164C11.86 11.7657 11.1508 12.4084 10.3716 12.7844C10.6558 12.2044 10.874 11.5311 11.0257 10.8611Z" }) });
}
function S2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 25", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.24956 4.68945C5.17156 4.68945 3.27058 6.40045 2.93758 8.53345L1.99956 15.5645C1.98756 15.6545 2.05058 15.7285 2.06258 15.8145C2.04858 15.9415 1.99956 16.0585 1.99956 16.1895V17.1895C1.99956 19.1225 3.56656 20.6895 5.49956 20.6895H18.4996C20.4326 20.6895 21.9996 19.1225 21.9996 17.1895V16.1895C21.9996 16.0585 21.9516 15.9415 21.9376 15.8145C21.9496 15.7285 22.0126 15.6545 21.9996 15.5645L20.9996 8.56445C20.6646 6.41545 18.7966 4.68945 16.7186 4.68945H7.24956ZM5.49956 14.6895H18.4996C19.3286 14.6895 19.9996 15.3615 19.9996 16.1895V17.1895C19.9996 18.0175 19.3286 18.6895 18.4996 18.6895H5.49956C4.67156 18.6895 3.99956 18.0175 3.99956 17.1895V16.1895C3.99956 15.3615 4.67156 14.6895 5.49956 14.6895ZM5.99956 15.6895C5.44756 15.6895 4.99956 16.1375 4.99956 16.6895C4.99956 17.2415 5.44756 17.6895 5.99956 17.6895C6.55256 17.6895 6.99956 17.2415 6.99956 16.6895C6.99956 16.1375 6.55256 15.6895 5.99956 15.6895ZM8.99956 15.6895C8.44756 15.6895 7.99956 16.1375 7.99956 16.6895C7.99956 17.2415 8.44756 17.6895 8.99956 17.6895C9.55256 17.6895 9.99956 17.2415 9.99956 16.6895C9.99956 16.1375 9.55256 15.6895 8.99956 15.6895Z" }) });
}
function T2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.02812 1.33301C4.33612 1.33301 1.34277 4.317 1.34277 7.99833C1.34277 11.6797 4.33612 14.6643 8.02812 14.6643C9.83012 14.6643 11.5248 13.9537 12.7708 12.7063C13.0314 12.445 13.0328 12.0283 12.7708 11.769C12.5094 11.509 12.0914 11.5077 11.8308 11.769C10.8334 12.7677 9.47078 13.331 8.02812 13.331C5.07478 13.331 2.68011 10.9437 2.68011 7.99833C2.68011 5.05366 5.07478 2.66634 8.02812 2.66634C8.39745 2.66634 8.69678 2.36767 8.69678 1.99967C8.69678 1.63167 8.39745 1.33301 8.02812 1.33301ZM10.4728 1.93701C10.3108 1.99035 10.1781 2.10501 10.0968 2.27034C9.93412 2.60101 10.0581 3.00367 10.3894 3.16634C10.5674 3.25301 10.7241 3.35102 10.8908 3.45768C11.2014 3.65568 11.6321 3.55967 11.8308 3.24967C12.0294 2.93901 11.9328 2.53101 11.6221 2.33301C11.4128 2.19967 11.1968 2.08767 10.9741 1.979C10.8088 1.89767 10.6354 1.88434 10.4728 1.93701ZM12.8334 3.58236C12.6641 3.56236 12.4774 3.61502 12.3321 3.72835C12.0421 3.95569 11.9994 4.37636 12.2281 4.66569C12.3501 4.82102 12.4781 4.97702 12.5828 5.14502C12.7774 5.45769 13.1888 5.54703 13.5021 5.35303C13.8161 5.15903 13.9054 4.77035 13.7114 4.45768C13.5808 4.24768 13.4254 4.02702 13.2721 3.83236C13.1581 3.68769 13.0034 3.60302 12.8334 3.58236ZM8.02812 3.99902C7.65945 3.99902 7.36011 4.29769 7.36011 4.66569V7.99833C7.36011 8.17566 7.44343 8.35233 7.56877 8.47766L9.5741 10.477C9.83543 10.7377 10.2534 10.7377 10.5148 10.477C10.7754 10.217 10.7754 9.77967 10.5148 9.519L8.69678 7.70699V4.66569C8.69678 4.29769 8.39745 3.99902 8.02812 3.99902ZM13.7528 6.01969C13.3921 6.09903 13.1714 6.45166 13.2514 6.81099C13.2941 7.00366 13.3354 7.19766 13.3561 7.39433C13.3948 7.76033 13.7201 8.01633 14.0874 7.97766C14.4541 7.93899 14.7114 7.61502 14.6721 7.24902C14.6461 7.00236 14.6214 6.76036 14.5674 6.51969C14.4881 6.16036 14.1134 5.94036 13.7528 6.01969ZM14.0454 8.72766C13.6868 8.64099 13.3174 8.86966 13.2308 9.22766C13.1841 9.42033 13.1101 9.60501 13.0428 9.78967C12.9161 10.1357 13.1134 10.497 13.4608 10.623C13.8074 10.749 14.1701 10.5943 14.2961 10.2483C14.3808 10.0163 14.4674 9.78101 14.5261 9.53967C14.6128 9.18234 14.4041 8.81433 14.0454 8.72766Z" }) });
}
function N2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M4.66557 1.99414C3.1929 1.99414 1.9989 3.18815 1.9989 4.66082V11.3275C1.9989 12.8002 3.1929 13.9942 4.66557 13.9942H11.3322C12.8049 13.9942 13.9989 12.8002 13.9989 11.3275V4.66082C13.9989 3.18815 12.8049 1.99414 11.3322 1.99414H4.66557ZM7.9989 4.66082C8.3669 4.66082 8.66556 4.95949 8.66556 5.32749C8.66556 5.6955 8.3669 5.99416 7.9989 5.99416C7.6309 5.99416 7.33223 5.6955 7.33223 5.32749C7.33223 4.95949 7.6309 4.66082 7.9989 4.66082ZM7.9989 6.66083C8.3669 6.66083 8.66556 6.9595 8.66556 7.32751V10.6609C8.66556 11.0289 8.3669 11.3275 7.9989 11.3275C7.6309 11.3275 7.33223 11.0289 7.33223 10.6609V7.32751C7.33223 6.9595 7.6309 6.66083 7.9989 6.66083Z" }) });
}
function P2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.7562 4.74381C17.0977 3.0854 14.4088 3.0854 12.7503 4.74381L9.74749 7.74664C8.08906 9.40505 8.08941 12.0937 9.74786 13.7521C10.1625 14.1667 10.8347 14.1667 11.2493 13.7521C11.6639 13.3375 11.6639 12.6653 11.2493 12.2507L11.2322 12.2339C10.4197 11.4035 10.4253 10.0716 11.2489 9.24805L14.2518 6.24522C15.0811 5.41601 16.4255 5.41603 17.2547 6.24522C18.0839 7.07443 18.0839 8.41884 17.2547 9.24805L16.1917 10.3111C16.5282 11.17 16.6325 12.099 16.5043 13.0012L18.7562 10.7495C20.4146 9.09106 20.4146 6.40223 18.7562 4.74381ZM5.24383 18.2562C6.90228 19.9146 9.59115 19.9146 11.2496 18.2562L14.2525 15.2534C15.911 13.595 15.911 10.9061 14.2525 9.24768C13.8378 8.83308 13.1657 8.83308 12.7511 9.24768C12.3364 9.66229 12.3364 10.3345 12.7511 10.7491C13.5803 11.5783 13.5803 12.9227 12.7511 13.7519L9.74815 16.7548C8.91894 17.5839 7.5745 17.5839 6.74528 16.7548C5.91605 15.9255 5.91605 14.5811 6.74528 13.7519L7.80833 12.6888C7.47174 11.83 7.36751 10.901 7.49563 9.99875L5.24383 12.2505C3.58539 13.9089 3.58539 16.5978 5.24383 18.2562Z"
    }
  ) });
}
function R2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M11.998 1.95312C9.23705 1.95312 6.99805 4.19213 6.99805 6.95312V8.95312C5.34105 8.95312 3.99805 10.2961 3.99805 11.9531V18.9531C3.99805 20.6101 5.34105 21.9531 6.99805 21.9531H16.998C18.655 21.9531 19.998 20.6101 19.998 18.9531V11.9531C19.998 10.2961 18.655 8.95312 16.998 8.95312V6.95312C16.998 4.19213 14.759 1.95312 11.998 1.95312ZM11.998 3.95312C13.655 3.95312 14.998 5.29612 14.998 6.95312V8.95312H8.99805V6.95312C8.99805 5.29612 10.341 3.95312 11.998 3.95312ZM11.998 11.9531C13.103 11.9531 13.998 12.8481 13.998 13.9531C13.998 14.6631 13.555 15.1611 12.998 15.5151V17.9531C12.998 18.5051 12.55 18.9531 11.998 18.9531C11.446 18.9531 10.998 18.5051 10.998 17.9531V15.5151C10.441 15.1601 9.99805 14.6631 9.99805 13.9531C9.99805 12.8481 10.893 11.9531 11.998 11.9531Z" }) });
}
function O2(e) {
  return /* @__PURE__ */ R("svg", { ...e, viewBox: "0 0 24 24", fill: "none", children: [
    /* @__PURE__ */ A(
      "path",
      {
        d: "M1.88134 8.65644V18.3251H0V7.09336C0 6.19326 1.03474 5.68003 1.75748 6.22134L10.6938 12.912C10.9698 13.1179 11.1313 13.4409 11.1313 13.784V18.3235H9.24992V14.174L1.88134 8.65644Z",
        fill: "currentcolor"
      }
    ),
    /* @__PURE__ */ A(
      "path",
      {
        d: "M22.0605 18.3251V8.65599L14.4616 14.1738V18.3251H12.5215V13.7854C12.5215 13.4422 12.688 13.1193 12.9726 12.9133L22.1882 6.22233C22.9335 5.67944 24.0006 6.19269 24.0006 7.09283V18.3251H22.0605Z",
        fill: "currentcolor"
      }
    )
  ] });
}
function D2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M16.9951 1.95312C16.7301 1.95312 16.4641 2.04713 16.2761 2.23413C15.7201 2.79013 13.7191 4.79115 13.2751 5.23615L4.26978 14.2412L3.26928 15.2412C3.12958 15.3812 3.05788 15.5792 3.01918 15.7732L2.01858 20.7762C1.87858 21.4762 2.47538 22.0721 3.17548 21.9331C3.80078 21.8071 7.55288 21.0572 8.17818 20.9322C8.37188 20.8932 8.57008 20.8212 8.70968 20.6822L9.71027 19.6812L18.7151 10.6762C19.1601 10.2322 21.1611 8.23012 21.7171 7.67512C21.9041 7.48712 21.9981 7.22113 21.9981 6.95613C21.9981 5.31912 21.5811 4.14912 20.7161 3.26612C19.8431 2.37511 18.6771 1.95312 16.9951 1.95312ZM17.3891 3.97211C18.2921 4.02511 18.8771 4.23216 19.2781 4.64216C19.6881 5.06016 19.9471 5.64015 20.0031 6.52516C19.4551 7.07216 18.6531 7.86212 17.9961 8.51912C17.2031 7.72612 16.2251 6.74815 15.4321 5.95515C16.0901 5.29815 16.8421 4.51911 17.3891 3.97211ZM4.98898 16.3982L7.55288 18.9621L7.45908 19.0562C6.79908 19.1882 5.46628 19.4672 4.23858 19.7132L4.89518 16.4922L4.98898 16.3982Z" }) });
}
function M2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M15.498 2.92969C13.0127 2.92969 10.998 4.94469 10.998 7.42969C10.998 9.91469 13.0127 11.9297 15.498 11.9297C17.9833 11.9297 19.998 9.91469 19.998 7.42969C19.998 4.94469 17.9833 2.92969 15.498 2.92969ZM7.99805 3.92969C5.78895 3.92969 3.99805 5.72069 3.99805 7.92969C3.99805 10.1387 5.78895 11.9297 7.99805 11.9297C8.82745 11.9297 9.58455 11.7017 10.2508 11.2357C8.54205 8.69572 8.78425 6.26369 9.71555 4.30469C9.18365 4.05269 8.59945 3.92969 7.99805 3.92969ZM5.06055 13.2737C3.22645 14.0307 1.99805 15.8857 1.99805 17.9297V19.9297C1.99805 20.4817 2.44575 20.9297 2.99805 20.9297L7.15085 20.9317C6.91685 20.1717 6.98565 18.9397 7.00105 17.9427C7.03355 15.8257 7.90905 14.3157 8.25195 13.9177C7.62175 13.9127 6.86545 13.7597 6.31055 13.5237C6.17655 13.4667 6.09875 13.4217 5.84185 13.3047C5.58995 13.1897 5.31635 13.1677 5.06055 13.2737ZM12.0605 13.2737C10.2264 14.0307 8.99805 15.8857 8.99805 17.9297V19.9297C8.99805 20.4817 9.44575 20.9297 9.99805 20.9297H20.998C21.5503 20.9297 21.998 20.4817 21.998 19.9297V17.9297C21.998 15.9337 20.7628 14.1237 18.9355 13.3357C18.6783 13.2247 18.3786 13.2217 18.123 13.3357C17.2382 13.7327 16.3762 13.9297 15.498 13.9297C14.6228 13.9297 13.7578 13.7217 12.8418 13.3047C12.5899 13.1897 12.3163 13.1677 12.0605 13.2737Z" }) });
}
function F2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.9974 1.30273C6.15646 1.30273 4.66406 2.79513 4.66406 4.63607C4.66406 6.477 6.15646 7.9694 7.9974 7.9694C9.83833 7.9694 11.3307 6.477 11.3307 4.63607C11.3307 2.79513 9.83833 1.30273 7.9974 1.30273ZM5.64326 8.8444C3.9004 9.32073 2.66406 10.8362 2.66406 12.6361V13.9694C2.66406 14.3376 2.96253 14.6361 3.33073 14.6361H12.6641C13.0323 14.6361 13.3307 14.3376 13.3307 13.9694V12.6361C13.3307 10.8362 12.0944 9.32073 10.3515 8.8444C10.2021 8.80353 10.0553 8.8224 9.91406 8.88607C9.30373 9.16113 8.654 9.30273 7.9974 9.30273C7.3408 9.30273 6.69106 9.16113 6.08073 8.88607C5.93946 8.8224 5.79266 8.80353 5.64326 8.8444Z" }) });
}
function V2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.00846 1.30273C4.3266 1.30273 1.3418 4.2874 1.3418 7.9694C1.3418 11.6514 4.3266 14.6361 8.00846 14.6361C11.6903 14.6361 14.6751 11.6514 14.6751 7.9694C14.6751 4.2874 11.6903 1.30273 8.00846 1.30273ZM8.00846 4.63607C8.37667 4.63607 8.67513 4.93473 8.67513 5.30273V7.30273H10.6751C11.0433 7.30273 11.3418 7.6014 11.3418 7.9694C11.3418 8.3374 11.0433 8.63606 10.6751 8.63606H8.67513V10.6361C8.67513 11.0041 8.37667 11.3027 8.00846 11.3027C7.64026 11.3027 7.3418 11.0041 7.3418 10.6361V8.63606H5.3418C4.9736 8.63606 4.67513 8.3374 4.67513 7.9694C4.67513 7.6014 4.9736 7.30273 5.3418 7.30273H7.3418V5.30273C7.3418 4.93473 7.64026 4.63607 8.00846 4.63607Z" }) });
}
function B2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 18 19", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.99072 0.929749C8.43872 0.929749 7.99072 1.37775 7.99072 1.92975V8.92975H0.990723C0.438723 8.92975 -0.00927734 9.37775 -0.00927734 9.92975C-0.00927734 10.4817 0.438723 10.9297 0.990723 10.9297H7.99072V17.9297C7.99072 18.4817 8.43872 18.9297 8.99072 18.9297C9.54272 18.9297 9.99072 18.4817 9.99072 17.9297V10.9297H16.9907C17.5427 10.9297 17.9907 10.4817 17.9907 9.92975C17.9907 9.37775 17.5427 8.92975 16.9907 8.92975H9.99072V1.92975C9.99072 1.37775 9.54272 0.929749 8.99072 0.929749Z" }) });
}
function k2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M11.4561 1.95312C12.8734 1.95312 13.998 3.15579 13.998 4.61979V11.2865C13.998 12.7505 12.8734 13.9531 11.4561 13.9531H11.3314V1.95312H11.4561ZM9.99805 1.95312V13.9531H4.53939C3.12272 13.9531 1.99805 12.7505 1.99805 11.2865V4.61979C1.99805 3.15579 3.12272 1.95312 4.53939 1.95312H9.99805ZM7.33138 4.61979H4.66471C4.29671 4.61979 3.99805 4.91846 3.99805 5.28646C3.99805 5.65446 4.29671 5.95312 4.66471 5.95312H7.33138C7.69938 5.95312 7.99805 5.65446 7.99805 5.28646C7.99805 4.91846 7.69938 4.61979 7.33138 4.61979ZM7.33138 7.28646H4.66471C4.29671 7.28646 3.99805 7.58512 3.99805 7.95312C3.99805 8.32112 4.29671 8.61979 4.66471 8.61979H7.33138C7.69938 8.61979 7.99805 8.32112 7.99805 7.95312C7.99805 7.58512 7.69938 7.28646 7.33138 7.28646ZM7.33138 9.95312H4.66471C4.29671 9.95312 3.99805 10.2518 3.99805 10.6198C3.99805 10.9878 4.29671 11.2865 4.66471 11.2865H7.33138C7.69938 11.2865 7.99805 10.9878 7.99805 10.6198C7.99805 10.2518 7.69938 9.95312 7.33138 9.95312Z" }) });
}
function L2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 21 17", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M10.9863 4.90607C10.6036 4.90607 8.3471 4.87807 7.9863 4.90607C2.04289 5.36307 0.986294 9.90607 0.986294 14.9061V15.9061C2.85309 13.9911 3.9863 12.9061 7.9863 12.9061C8.7319 12.9061 10.0809 12.9061 10.9863 12.9061L11.0166 15.4801C11.0166 16.9001 11.8933 17.3321 12.9747 16.4451L20.1554 10.5521C21.2633 9.64306 21.2633 8.16907 20.1554 7.26007L12.9747 1.36707C11.8933 0.480072 11.0166 0.912068 11.0166 2.33207L10.9863 4.90607Z" }) });
}
function H2(e) {
  return /* @__PURE__ */ R("svg", { ...e, viewBox: "0 0 71 19", fill: "currentcolor", children: [
    /* @__PURE__ */ A("path", { d: "M53.6211 18.4887V9.0342H56.435V10.8096H56.4923C56.7377 10.181 57.1085 9.70244 57.6047 9.37398C58.101 9.03986 58.6981 8.8728 59.3962 8.8728C60.4105 8.8728 61.2039 9.1871 61.7765 9.8157C62.3546 10.4443 62.6436 11.3164 62.6436 12.432V18.4887H59.7397V13.0776C59.7397 12.5283 59.6007 12.1007 59.3225 11.7949C59.0499 11.4835 58.6654 11.3277 58.1692 11.3277C57.6784 11.3277 57.2803 11.4976 56.9749 11.8374C56.6695 12.1772 56.5168 12.6161 56.5168 13.1541V18.4887H53.6211Z" }),
    /* @__PURE__ */ A("path", { d: "M53.097 9.03394L50.7412 18.4884H47.6164L46.1522 12.075H46.0949L44.6389 18.4884H41.5632L39.1992 9.03394H42.1195L43.3056 15.7532H43.3628L44.7861 9.03394H47.551L48.9906 15.7532H49.0479L50.234 9.03394H53.097Z" }),
    /* @__PURE__ */ A("path", { d: "M37.8661 17.3926C37.0427 18.2591 35.9084 18.6923 34.4632 18.6923C33.0181 18.6923 31.8838 18.2591 31.0604 17.3926C30.2369 16.5205 29.8252 15.3086 29.8252 13.7569C29.8252 12.2336 30.2424 11.033 31.0767 10.1552C31.9111 9.2718 33.0399 8.83008 34.4632 8.83008C35.892 8.83008 37.0208 9.26896 37.8497 10.1467C38.6841 11.0188 39.1013 12.2222 39.1013 13.7569C39.1013 15.3143 38.6896 16.5262 37.8661 17.3926ZM33.2117 15.7702C33.5116 16.2402 33.9288 16.4752 34.4632 16.4752C34.9977 16.4752 35.4148 16.2402 35.7148 15.7702C36.0147 15.2945 36.1647 14.6234 36.1647 13.7569C36.1647 12.9131 36.012 12.2506 35.7066 11.7692C35.4012 11.2878 34.9868 11.0472 34.4632 11.0472C33.9343 11.0472 33.5171 11.2878 33.2117 11.7692C32.9118 12.2449 32.7618 12.9075 32.7618 13.7569C32.7618 14.6234 32.9118 15.2945 33.2117 15.7702Z" }),
    /* @__PURE__ */ A("path", { d: "M20.0088 18.4887V9.0342H22.8227V10.8096H22.88C23.1254 10.181 23.4962 9.70244 23.9924 9.37398C24.4887 9.03986 25.0858 8.8728 25.7838 8.8728C26.7982 8.8728 27.5916 9.1871 28.1642 9.8157C28.7423 10.4443 29.0313 11.3164 29.0313 12.432V18.4887H26.1274V13.0776C26.1274 12.5283 25.9883 12.1007 25.7102 11.7949C25.4376 11.4835 25.0531 11.3277 24.5569 11.3277C24.0661 11.3277 23.668 11.4976 23.3626 11.8374C23.0572 12.1772 22.9045 12.6161 22.9045 13.1541V18.4887H20.0088Z" }),
    /* @__PURE__ */ A("path", { d: "M14.7486 10.9707C14.2851 10.9707 13.8952 11.1321 13.5789 11.4549C13.2626 11.7777 13.0854 12.1911 13.0472 12.6951H16.4337C16.4064 12.1741 16.2374 11.7579 15.9265 11.4464C15.6212 11.1293 15.2285 10.9707 14.7486 10.9707ZM16.4991 15.5153H19.1167C18.9749 16.4837 18.5141 17.2567 17.7343 17.8343C16.9599 18.4063 15.9838 18.6923 14.8059 18.6923C13.3662 18.6923 12.2374 18.2591 11.4194 17.3926C10.6014 16.5262 10.1924 15.3313 10.1924 13.8079C10.1924 12.2845 10.5987 11.0755 11.4112 10.1807C12.2237 9.28029 13.3226 8.83008 14.7077 8.83008C16.0656 8.83008 17.1481 9.26047 17.9552 10.1213C18.7677 10.9764 19.174 12.1231 19.174 13.5616V14.4195H13.0145V14.6064C13.0145 15.184 13.1835 15.6541 13.5216 16.0165C13.8597 16.3733 14.3015 16.5517 14.8468 16.5517C15.2503 16.5517 15.5993 16.461 15.8938 16.2798C16.1883 16.0929 16.3901 15.8381 16.4991 15.5153Z" }),
    /* @__PURE__ */ A("path", { d: "M3.00205 8.58396V12.0667H4.7771C5.32789 12.0667 5.7587 11.911 6.06954 11.5995C6.38038 11.2881 6.5358 10.8662 6.5358 10.3338C6.5358 9.80718 6.37492 9.38528 6.05318 9.06815C5.73143 8.74535 5.30335 8.58396 4.76892 8.58396H3.00205ZM3.00205 14.1989V18.4886H0V6.23096H5.07158C6.53307 6.23096 7.65373 6.5849 8.43355 7.29278C9.21337 8.00066 9.60328 8.99453 9.60328 10.2744C9.60328 11.0446 9.42605 11.7439 9.07159 12.3725C8.71712 12.9955 8.2236 13.4514 7.59101 13.7402L9.94684 18.4886H6.5767L4.55624 14.1989H3.00205Z" }),
    /* @__PURE__ */ A(
      "path",
      {
        d: "M65.7255 0.211478C65.0841 2.46724 63.3737 4.2455 61.2041 4.90969C60.932 4.99366 60.932 5.39096 61.2041 5.47492C63.3725 6.13912 65.0841 7.91738 65.7255 10.1731C65.8056 10.4551 66.1932 10.4551 66.2745 10.1731C66.9159 7.91738 68.6263 6.13912 70.7959 5.47492C71.068 5.39096 71.068 4.99366 70.7959 4.90969C68.6276 4.2455 66.9159 2.46724 66.2745 0.211478C66.1944 -0.0704925 65.8068 -0.0704925 65.7255 0.211478Z",
        fill: "#21FFB4"
      }
    )
  ] });
}
function X2(e) {
  return /* @__PURE__ */ R("svg", { ...e, viewBox: "0 0 71 19", fill: "currentcolor", children: [
    /* @__PURE__ */ A("path", { d: "M53.6211 18.4887V9.0342H56.435V10.8096H56.4923C56.7377 10.181 57.1085 9.70244 57.6047 9.37398C58.101 9.03986 58.6981 8.8728 59.3962 8.8728C60.4105 8.8728 61.2039 9.1871 61.7765 9.8157C62.3546 10.4443 62.6436 11.3164 62.6436 12.432V18.4887H59.7397V13.0776C59.7397 12.5283 59.6007 12.1007 59.3225 11.7949C59.0499 11.4835 58.6654 11.3277 58.1692 11.3277C57.6784 11.3277 57.2803 11.4976 56.9749 11.8374C56.6695 12.1772 56.5168 12.6161 56.5168 13.1541V18.4887H53.6211Z" }),
    /* @__PURE__ */ A("path", { d: "M53.097 9.03394L50.7412 18.4884H47.6164L46.1522 12.075H46.0949L44.6389 18.4884H41.5632L39.1992 9.03394H42.1195L43.3056 15.7532H43.3628L44.7861 9.03394H47.551L48.9906 15.7532H49.0479L50.234 9.03394H53.097Z" }),
    /* @__PURE__ */ A("path", { d: "M37.8661 17.3926C37.0427 18.2591 35.9084 18.6923 34.4632 18.6923C33.0181 18.6923 31.8838 18.2591 31.0604 17.3926C30.2369 16.5205 29.8252 15.3086 29.8252 13.7569C29.8252 12.2336 30.2424 11.033 31.0767 10.1552C31.9111 9.2718 33.0399 8.83008 34.4632 8.83008C35.892 8.83008 37.0208 9.26896 37.8497 10.1467C38.6841 11.0188 39.1013 12.2222 39.1013 13.7569C39.1013 15.3143 38.6896 16.5262 37.8661 17.3926ZM33.2117 15.7702C33.5116 16.2402 33.9288 16.4752 34.4632 16.4752C34.9977 16.4752 35.4148 16.2402 35.7148 15.7702C36.0147 15.2945 36.1647 14.6234 36.1647 13.7569C36.1647 12.9131 36.012 12.2506 35.7066 11.7692C35.4012 11.2878 34.9868 11.0472 34.4632 11.0472C33.9343 11.0472 33.5171 11.2878 33.2117 11.7692C32.9118 12.2449 32.7618 12.9075 32.7618 13.7569C32.7618 14.6234 32.9118 15.2945 33.2117 15.7702Z" }),
    /* @__PURE__ */ A("path", { d: "M20.0088 18.4887V9.0342H22.8227V10.8096H22.88C23.1254 10.181 23.4962 9.70244 23.9924 9.37398C24.4887 9.03986 25.0858 8.8728 25.7838 8.8728C26.7982 8.8728 27.5916 9.1871 28.1642 9.8157C28.7423 10.4443 29.0313 11.3164 29.0313 12.432V18.4887H26.1274V13.0776C26.1274 12.5283 25.9883 12.1007 25.7102 11.7949C25.4376 11.4835 25.0531 11.3277 24.5569 11.3277C24.0661 11.3277 23.668 11.4976 23.3626 11.8374C23.0572 12.1772 22.9045 12.6161 22.9045 13.1541V18.4887H20.0088Z" }),
    /* @__PURE__ */ A("path", { d: "M14.7486 10.9707C14.2851 10.9707 13.8952 11.1321 13.5789 11.4549C13.2626 11.7777 13.0854 12.1911 13.0472 12.6951H16.4337C16.4064 12.1741 16.2374 11.7579 15.9265 11.4464C15.6212 11.1293 15.2285 10.9707 14.7486 10.9707ZM16.4991 15.5153H19.1167C18.9749 16.4837 18.5141 17.2567 17.7343 17.8343C16.9599 18.4063 15.9838 18.6923 14.8059 18.6923C13.3662 18.6923 12.2374 18.2591 11.4194 17.3926C10.6014 16.5262 10.1924 15.3313 10.1924 13.8079C10.1924 12.2845 10.5987 11.0755 11.4112 10.1807C12.2237 9.28029 13.3226 8.83008 14.7077 8.83008C16.0656 8.83008 17.1481 9.26047 17.9552 10.1213C18.7677 10.9764 19.174 12.1231 19.174 13.5616V14.4195H13.0145V14.6064C13.0145 15.184 13.1835 15.6541 13.5216 16.0165C13.8597 16.3733 14.3015 16.5517 14.8468 16.5517C15.2503 16.5517 15.5993 16.461 15.8938 16.2798C16.1883 16.0929 16.3901 15.8381 16.4991 15.5153Z" }),
    /* @__PURE__ */ A("path", { d: "M3.00205 8.58396V12.0667H4.7771C5.32789 12.0667 5.7587 11.911 6.06954 11.5995C6.38038 11.2881 6.5358 10.8662 6.5358 10.3338C6.5358 9.80718 6.37492 9.38528 6.05318 9.06815C5.73143 8.74535 5.30335 8.58396 4.76892 8.58396H3.00205ZM3.00205 14.1989V18.4886H0V6.23096H5.07158C6.53307 6.23096 7.65373 6.5849 8.43355 7.29278C9.21337 8.00066 9.60328 8.99453 9.60328 10.2744C9.60328 11.0446 9.42605 11.7439 9.07159 12.3725C8.71712 12.9955 8.2236 13.4514 7.59101 13.7402L9.94684 18.4886H6.5767L4.55624 14.1989H3.00205Z" }),
    /* @__PURE__ */ A("path", { d: "M65.7255 0.211478C65.0841 2.46724 63.3737 4.2455 61.2041 4.90969C60.932 4.99366 60.932 5.39096 61.2041 5.47492C63.3725 6.13912 65.0841 7.91738 65.7255 10.1731C65.8056 10.4551 66.1932 10.4551 66.2745 10.1731C66.9159 7.91738 68.6263 6.13912 70.7959 5.47492C71.068 5.39096 71.068 4.99366 70.7959 4.90969C68.6276 4.2455 66.9159 2.46724 66.2745 0.211478C66.1944 -0.0704925 65.8068 -0.0704925 65.7255 0.211478Z" })
  ] });
}
function W2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.99853 2.60352C5.0532 2.60352 2.66519 4.99152 2.66519 7.93685C2.66519 10.8822 5.0532 13.2702 7.99853 13.2702C10.9439 13.2702 13.3319 10.8822 13.3319 7.93685C13.3319 4.99152 10.9439 2.60352 7.99853 2.60352ZM7.99853 3.93685C10.2079 3.93685 11.9985 5.72752 11.9985 7.93685C11.9985 10.1462 10.2079 11.9368 7.99853 11.9368C5.7892 11.9368 3.99853 10.1462 3.99853 7.93685C3.99853 5.72752 5.7892 3.93685 7.99853 3.93685Z" }) });
}
function Z2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M2 4.66667C2 3.194 3.194 2 4.66667 2H8.08333C7.64666 2.564 7.33333 3.23133 7.33333 4V8.66667H5.33333L8 11.3333L10.6667 8.66667H8.66666V4C8.66666 2.89533 9.562 2 10.6667 2H11.3333C12.806 2 14 3.194 14 4.66667V11.3333C14 12.806 12.806 14 11.3333 14H4.66667C3.194 14 2 12.806 2 11.3333V4.66667Z" }) });
}
function z2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M10.0137 1.95312C5.59537 1.95312 2.01367 5.53513 2.01367 9.95314C2.01367 14.3712 5.59537 17.9532 10.0137 17.9532C11.8504 17.9532 13.5913 17.3222 14.9416 16.2822L19.2949 20.6722C19.6855 21.0622 20.3419 21.0622 20.7325 20.6722C21.123 20.2812 21.123 19.6252 20.7325 19.2342L16.349 14.8741C17.3898 13.5241 18.0137 11.7901 18.0137 9.95314C18.0137 5.53513 14.432 1.95312 10.0137 1.95312ZM10.0137 3.95313C13.3274 3.95313 16.0137 6.63914 16.0137 9.95314C16.0137 13.2672 13.3274 15.9532 10.0137 15.9532C6.69997 15.9532 4.01367 13.2672 4.01367 9.95314C4.01367 6.63914 6.69997 3.95313 10.0137 3.95313Z" }) });
}
function G2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M11.998 1.95312C7.63605 1.95312 3.99805 3.51213 3.99805 5.95312C3.99805 8.39412 7.63605 9.95312 11.998 9.95312C16.36 9.95312 19.998 8.39412 19.998 5.95312C19.998 3.51213 16.36 1.95312 11.998 1.95312ZM3.99805 9.57812V11.9531C3.99805 14.3941 7.63605 15.9531 11.998 15.9531C16.36 15.9531 19.998 14.3941 19.998 11.9531V9.57812C18.184 11.0681 15.356 11.9531 11.998 11.9531C8.64005 11.9531 5.81205 11.0681 3.99805 9.57812ZM3.99805 15.5781V17.9531C3.99805 20.3941 7.63605 21.9531 11.998 21.9531C16.36 21.9531 19.998 20.3941 19.998 17.9531V15.5781C18.184 17.0681 15.356 17.9531 11.998 17.9531C8.64005 17.9531 5.81205 17.0681 3.99805 15.5781Z" }) });
}
function j2(e) {
  return /* @__PURE__ */ R("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: [
    /* @__PURE__ */ A(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5 2C13.1894 2 13.8136 2.27905 14.2659 2.73036C14.2834 2.74784 14.3007 2.76559 14.3177 2.78358C14.7174 3.20678 14.971 3.76953 14.9977 4.39107L14.9985 4.41205C14.9995 4.44124 15 4.47056 15 4.5L15 4.51426C15 4.55491 15.0247 4.59145 15.0623 4.60702C15.0998 4.62261 15.1431 4.61423 15.1719 4.58546L15.182 4.57538C15.2028 4.55456 15.2239 4.53419 15.2452 4.51426L15.2607 4.5C15.719 4.07934 16.2962 3.86073 16.8782 3.84417C16.9029 3.84346 16.9277 3.84312 16.9524 3.84315C17.5913 3.84382 18.23 4.0879 18.7175 4.57538L19.4246 5.28249C19.9121 5.76997 20.1562 6.40868 20.1569 7.0476C20.1569 7.07234 20.1565 7.09709 20.1558 7.12182C20.1393 7.70375 19.9207 8.281 19.5 8.73935L19.4857 8.75476C19.4658 8.77611 19.4454 8.7972 19.4246 8.81802L19.4145 8.82811C19.3858 8.85687 19.3774 8.90017 19.393 8.93775C19.4085 8.97529 19.4451 9 19.4857 9L19.5 9C19.5294 9 19.5588 9.00051 19.5879 9.00152L19.6089 9.00233C20.2305 9.02898 20.7932 9.28257 21.2164 9.68233C21.2344 9.69933 21.2522 9.71659 21.2696 9.73411C21.721 10.1864 22 10.8106 22 11.5L22 12.5C22 13.1894 21.721 13.8136 21.2696 14.2659C21.2522 14.2834 21.2344 14.3007 21.2164 14.3177C20.7932 14.7174 20.2305 14.971 19.6089 14.9977L19.5879 14.9985C19.5588 14.9995 19.5294 15 19.5 15L19.4857 15C19.4451 15 19.4085 15.0247 19.393 15.0623C19.3774 15.0998 19.3858 15.1431 19.4145 15.1719L19.4246 15.182C19.4454 15.2028 19.4658 15.2239 19.4857 15.2452L19.5 15.2607C19.9207 15.719 20.1393 16.2962 20.1558 16.8782C20.1565 16.9029 20.1569 16.9277 20.1569 16.9524C20.1562 17.5913 19.9121 18.23 19.4246 18.7175L18.7175 19.4246C18.23 19.9121 17.5913 20.1562 16.9524 20.1568C16.9277 20.1569 16.9029 20.1565 16.8782 20.1558C16.2963 20.1393 15.719 19.9207 15.2607 19.5L15.2452 19.4857C15.2239 19.4658 15.2028 19.4454 15.182 19.4246L15.1719 19.4145C15.1431 19.3858 15.0998 19.3774 15.0623 19.393C15.0247 19.4085 15 19.4451 15 19.4857L15 19.5C15 19.5294 14.9995 19.5588 14.9985 19.5879L14.9977 19.6089C14.971 20.2305 14.7174 20.7932 14.3177 21.2164C14.3007 21.2344 14.2834 21.2522 14.2659 21.2696C13.8136 21.7209 13.1894 22 12.5 22L11.5 22C10.8106 22 10.1864 21.7209 9.73411 21.2696C9.71659 21.2522 9.69933 21.2344 9.68233 21.2164C9.28257 20.7932 9.02898 20.2305 9.00233 19.6089L9.00152 19.5879C9.00051 19.5588 9 19.5294 9 19.5L9 19.4857C9 19.4451 8.97529 19.4085 8.93774 19.393C8.90017 19.3774 8.85687 19.3858 8.8281 19.4145L8.81802 19.4246C8.7972 19.4454 8.77611 19.4658 8.75475 19.4857L8.73934 19.5C8.281 19.9207 7.70375 20.1393 7.12182 20.1558C7.09708 20.1565 7.07234 20.1569 7.0476 20.1568C6.40868 20.1562 5.76997 19.9121 5.28249 19.4246L4.57538 18.7175C4.0879 18.23 3.84382 17.5913 3.84315 16.9524C3.84312 16.9277 3.84346 16.9029 3.84417 16.8782C3.86073 16.2962 4.07934 15.719 4.5 15.2607L4.51426 15.2452C4.53419 15.2239 4.55456 15.2028 4.57538 15.182L4.58546 15.1719C4.61423 15.1431 4.62261 15.0998 4.60702 15.0623C4.59145 15.0247 4.55491 15 4.51426 15L4.5 15C4.47056 15 4.44125 14.9995 4.41205 14.9985L4.39107 14.9977C3.76953 14.971 3.20678 14.7174 2.78358 14.3177C2.76558 14.3007 2.74784 14.2834 2.73036 14.2659C2.27905 13.8136 2 13.1894 2 12.5L2 11.5C2 10.8106 2.27905 10.1864 2.73036 9.73411C2.74784 9.71659 2.76558 9.69933 2.78358 9.68233C3.20678 9.28257 3.76953 9.02898 4.39107 9.00233L4.41205 9.00152C4.44125 9.00051 4.47056 9 4.5 9L4.51426 9C4.55491 9 4.59145 8.97529 4.60702 8.93775C4.62261 8.90017 4.61423 8.85687 4.58546 8.82811L4.57538 8.81802C4.55456 8.7972 4.53419 8.77611 4.51426 8.75476L4.5 8.73935C4.07934 8.281 3.86073 7.70375 3.84417 7.12182C3.84346 7.09709 3.84312 7.07234 3.84315 7.0476C3.84382 6.40868 4.0879 5.76997 4.57538 5.28249L5.28249 4.57538C5.76997 4.0879 6.40868 3.84382 7.0476 3.84315C7.07234 3.84312 7.09709 3.84346 7.12182 3.84417C7.70375 3.86073 8.281 4.07934 8.73934 4.5L8.75476 4.51426C8.77611 4.53419 8.7972 4.55456 8.81802 4.57538L8.8281 4.58546C8.85687 4.61423 8.90017 4.62261 8.93775 4.60702C8.97529 4.59145 9 4.55491 9 4.51426L9 4.5C9 4.47056 9.00051 4.44124 9.00152 4.41205L9.00233 4.39107C9.02898 3.76953 9.28257 3.20678 9.68233 2.78358C9.69933 2.76559 9.71659 2.74784 9.73411 2.73036C10.1864 2.27905 10.8106 2 11.5 2L12.5 2ZM11 19.5C11 19.7761 11.2239 20 11.5 20L12.5 20C12.7761 20 13 19.7761 13 19.5L13 19.4857C13 18.6262 13.5212 17.8669 14.2962 17.5455C15.0727 17.2235 15.9787 17.3929 16.5861 18.0003L16.5962 18.0104C16.7915 18.2057 17.108 18.2057 17.3033 18.0104L18.0104 17.3033C18.2057 17.108 18.2057 16.7915 18.0104 16.5962L18.0003 16.5861C17.3929 15.9787 17.2235 15.0727 17.5455 14.2961C17.8669 13.5212 18.6262 13 19.4857 13L19.5 13C19.7761 13 20 12.7761 20 12.5L20 11.5C20 11.2239 19.7761 11 19.5 11L19.4857 11C18.6262 11 17.8669 10.4788 17.5455 9.70385C17.2235 8.92727 17.3929 8.02132 18.0003 7.41389L18.0104 7.40381C18.2057 7.20854 18.2057 6.89196 18.0104 6.6967L17.3033 5.98959C17.108 5.79433 16.7915 5.79433 16.5962 5.98959L16.5861 5.99968C15.9787 6.60711 15.0727 6.77651 14.2962 6.45448C13.5212 6.13311 13 5.37381 13 4.51426L13 4.5C13 4.22386 12.7761 4 12.5 4L11.5 4C11.2239 4 11 4.22386 11 4.5L11 4.51426C11 5.37381 10.4788 6.13311 9.70384 6.45448C8.92725 6.77651 8.02132 6.60711 7.41389 5.99968L7.40381 5.98959C7.20854 5.79433 6.89196 5.79433 6.6967 5.98959L5.98959 6.6967C5.79433 6.89196 5.79433 7.20854 5.98959 7.40381L5.99967 7.41389C6.60711 8.02132 6.77651 8.92727 6.45448 9.70385C6.13311 10.4788 5.37382 11 4.51426 11L4.5 11C4.22386 11 4 11.2239 4 11.5L4 12.5C4 12.7761 4.22386 13 4.5 13L4.51426 13C5.37382 13 6.13311 13.5212 6.45447 14.2961C6.77651 15.0727 6.60711 15.9787 5.99968 16.5861L5.98959 16.5962C5.79433 16.7915 5.79433 17.108 5.98959 17.3033L6.6967 18.0104C6.89196 18.2057 7.20854 18.2057 7.4038 18.0104L7.41389 18.0003C8.02132 17.3929 8.92726 17.2235 9.70384 17.5455C10.4788 17.8669 11 18.6262 11 19.4857L11 19.5Z"
      }
    ),
    /* @__PURE__ */ A(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
      }
    )
  ] });
}
function U2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M8.01042 1.3418C4.32842 1.3418 1.34375 4.3266 1.34375 8.00847C1.34375 11.6905 4.32842 14.6751 8.01042 14.6751C11.6924 14.6751 14.6771 11.6905 14.6771 8.00847C14.6771 4.3266 11.6924 1.3418 8.01042 1.3418ZM8.01042 4.67513C8.37842 4.67513 8.67708 4.9736 8.67708 5.3418V8.67514H10.6771L8.01042 11.3418L5.34375 8.67514H7.34375V5.3418C7.34375 4.9736 7.64242 4.67513 8.01042 4.67513Z" }) });
}
function Q2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.81333 1.33662C6.07787 1.38545 4.42992 2.10935 3.21991 3.35437C2.0099 4.59939 1.3333 6.26732 1.33398 8.00346C1.33478 9.7711 2.03752 11.4661 3.28771 12.7157C4.5379 13.9653 6.23319 14.6673 8.00083 14.6673C9.76847 14.6673 11.4638 13.9653 12.714 12.7157C13.9641 11.4661 14.6669 9.7711 14.6677 8.00346C14.668 7.11195 14.4896 6.22943 14.1429 5.4081C13.7962 4.58678 13.2883 3.84332 12.6492 3.22173C12.0101 2.60015 11.2529 2.11306 10.4222 1.78926C9.59161 1.46547 8.70448 1.31155 7.81333 1.33662ZM8.00083 4.67003C8.92086 4.67003 9.75038 5.00753 10.3551 5.60755L11.3343 4.67003V7.33679H11.2718H10.2093H8.66755L9.62591 6.33676C9.21457 5.93674 8.64705 5.67005 8.0217 5.67005C6.98901 5.67005 6.13082 6.4034 5.83414 7.33679H4.72995C5.04062 5.80341 6.39012 4.67003 8.00083 4.67003ZM4.66741 8.67016H4.72988H5.79241H7.33412L6.37576 9.60768C6.7871 10.0077 7.35461 10.2744 7.97997 10.2744C9.01266 10.2744 9.87085 9.60351 10.1675 8.67016H11.2717C10.961 10.1368 9.61151 11.3369 8.0008 11.3369C7.08078 11.3369 6.25125 10.9369 5.64657 10.3369L4.66738 11.3369L4.66741 8.67016Z" }) });
}
function q2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M11.9981 4.46484C11.1693 4.46484 10.4981 5.13609 10.4981 5.96484H6.74805C6.33405 5.96484 5.99805 6.30084 5.99805 6.71484C5.99805 7.12884 6.33405 7.46483 6.74805 7.46483H17.2481C17.6621 7.46483 17.9981 7.12884 17.9981 6.71484C17.9981 6.30084 17.6621 5.96484 17.2481 5.96484H13.4981C13.4981 5.13609 12.8268 4.46484 11.9981 4.46484ZM6.74805 8.96483V16.4648C6.74805 18.1073 8.1018 19.4415 9.74805 19.4415L14.2713 19.4648C15.9176 19.4648 17.2481 18.1111 17.2481 16.4648V8.96483H6.74805ZM10.4981 11.2148C10.9121 11.2148 11.2481 11.5508 11.2481 11.9648V16.4648C11.2481 16.8788 10.9121 17.2148 10.4981 17.2148C10.0841 17.2148 9.74805 16.8788 9.74805 16.4648V11.9648C9.74805 11.5508 10.0841 11.2148 10.4981 11.2148ZM13.4981 11.2148C13.9121 11.2148 14.2481 11.5508 14.2481 11.9648V16.4648C14.2481 16.8788 13.9121 17.2148 13.4981 17.2148C13.0841 17.2148 12.7481 16.8788 12.7481 16.4648V11.9648C12.7481 11.5508 13.0841 11.2148 13.4981 11.2148Z" }) });
}
function Y2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M7.99935 1.30273C7.26269 1.30273 6.66602 1.8994 6.66602 2.63606H3.33268C2.96468 2.63606 2.66602 2.93473 2.66602 3.30273C2.66602 3.67073 2.96468 3.96939 3.33268 3.96939H12.666C13.034 3.96939 13.3327 3.67073 13.3327 3.30273C13.3327 2.93473 13.034 2.63606 12.666 2.63606H9.33269C9.33269 1.8994 8.73602 1.30273 7.99935 1.30273ZM3.33268 5.30272V11.9694C3.33268 13.4294 4.53602 14.6154 5.99935 14.6154L10.02 14.636C11.4834 14.636 12.666 13.4327 12.666 11.9694V5.30272H3.33268ZM6.66602 7.30272C7.03402 7.30272 7.33269 7.60138 7.33269 7.96938V11.9694C7.33269 12.3374 7.03402 12.636 6.66602 12.636C6.29802 12.636 5.99935 12.3374 5.99935 11.9694V7.96938C5.99935 7.60138 6.29802 7.30272 6.66602 7.30272ZM9.33269 7.30272C9.70069 7.30272 9.99936 7.60138 9.99936 7.96938V11.9694C9.99936 12.3374 9.70069 12.636 9.33269 12.636C8.96469 12.636 8.66602 12.3374 8.66602 11.9694V7.96938C8.66602 7.60138 8.96469 7.30272 9.33269 7.30272Z" }) });
}
function J2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M4.09245 12.0893L4 11.9998L4.09245 11.9103L4.66414 11.3568L4.66493 11.356L9.81374 6.37154C10.1808 6.01623 10.7758 6.01623 11.1428 6.37154C11.5098 6.72685 11.5098 7.30291 11.1428 7.65822L7.59798 11.09L19.0602 11.09C19.5792 11.09 20 11.4973 20 11.9998C20 12.5023 19.5792 12.9096 19.0602 12.9096L7.59798 12.9096L11.1428 16.3413C11.5098 16.6967 11.5098 17.2727 11.1428 17.628C10.7758 17.9834 10.1808 17.9834 9.81375 17.628L4.66493 12.6435L4.66414 12.6427L4.09245 12.0893Z" }) });
}
function K2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M14.0098 3.95312C14.0098 2.84812 13.1144 1.95312 12.0098 1.95312C10.9052 1.95312 10.0098 2.84812 10.0098 3.95312C10.0098 5.05812 10.9052 5.95311 12.0098 5.95311C13.1144 5.95311 14.0098 5.05812 14.0098 3.95312ZM14.0098 11.9531C14.0098 10.8481 13.1144 9.9531 12.0098 9.9531C10.9052 9.9531 10.0098 10.8481 10.0098 11.9531C10.0098 13.0581 10.9052 13.9531 12.0098 13.9531C13.1144 13.9531 14.0098 13.0581 14.0098 11.9531ZM14.0098 19.9531C14.0098 18.8481 13.1144 17.9531 12.0098 17.9531C10.9052 17.9531 10.0098 18.8481 10.0098 19.9531C10.0098 21.0581 10.9052 21.9531 12.0098 21.9531C13.1144 21.9531 14.0098 21.0581 14.0098 19.9531Z" }) });
}
function _2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M12 3C7.0293 3 3 7.0293 3 12C3 16.9707 7.0293 21 12 21C16.9707 21 21 16.9707 21 12C21 7.0293 16.9707 3 12 3ZM12 7.5C12.4968 7.5 12.9 7.9032 12.9 8.4V12.9C12.9 13.3968 12.4968 13.8 12 13.8C11.5032 13.8 11.1 13.3968 11.1 12.9V8.4C11.1 7.9032 11.5032 7.5 12 7.5ZM12 14.7C12.4968 14.7 12.9 15.1032 12.9 15.6C12.9 16.0968 12.4968 16.5 12 16.5C11.5032 16.5 11.1 16.0968 11.1 15.6C11.1 15.1032 11.5032 14.7 12 14.7Z" }) });
}
function $2(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 16 16", fill: "currentcolor", children: /* @__PURE__ */ A("path", { d: "M3.32875 2.60352C3.15815 2.60352 2.97975 2.66085 2.84955 2.79085C2.58921 3.05152 2.58921 3.48884 2.84955 3.74951L7.03708 7.93685L2.84955 12.1242C2.58921 12.3849 2.58921 12.8222 2.84955 13.0828C3.10995 13.3428 3.54755 13.3428 3.80795 13.0828L7.99541 8.89552L12.1829 13.0828C12.4433 13.3428 12.8809 13.3428 13.1413 13.0828C13.4016 12.8222 13.4016 12.3849 13.1413 12.1242L8.95375 7.93685L13.1413 3.74951C13.4016 3.48884 13.4016 3.05152 13.1413 2.79085C13.0111 2.66085 12.8326 2.60352 12.6621 2.60352C12.4915 2.60352 12.3131 2.66085 12.1829 2.79085L7.99541 6.97818L3.80795 2.79085C3.67775 2.66085 3.49935 2.60352 3.32875 2.60352Z" }) });
}
function e9(e) {
  return /* @__PURE__ */ A("svg", { ...e, viewBox: "0 0 24 24", fill: "currentcolor", children: /* @__PURE__ */ A(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.9993 8.51506L15.4844 7L11.9994 10.4852L8.51497 7.00057L7 8.51562L10.4844 12.0003L7.00056 15.4843L8.51552 16.9994L11.9994 13.5153L15.4838 17L16.9988 15.4849L13.5144 12.0003L16.9993 8.51506Z"
    }
  ) });
}
const t9 = {
  ArrowFilledRight: q3,
  ArrowLeft: Y3,
  ArrowUp: J3,
  BarChart: K3,
  BaseArrowLeft: _3,
  BaseArrowRight: $3,
  Braces: e2,
  Branch: t2,
  BrickGlobe: n2,
  Briefcase: r2,
  Calendar: o2,
  CaretDown: i2,
  Caret: s2,
  CheckCircleFill: a2,
  CheckCircle: c2,
  Check: u2,
  ChevronDown: l2,
  Circle: d2,
  ClockFill: A2,
  CloudSlash: f2,
  Collapse: h2,
  Connect: p2,
  Drive: m2,
  Ellipsis: g2,
  Error: b2,
  Exclamation: v2,
  FilesEarmark: y2,
  FolderClose: C2,
  FolderOpen: x2,
  FolderPlus: w2,
  Gear: I2,
  Globe: E2,
  Hdd: S2,
  History: T2,
  InfoSquare: N2,
  Link: P2,
  Lock: R2,
  M: O2,
  Pencil: D2,
  People: M2,
  Person: F2,
  PlusCircle: V2,
  Plus: B2,
  Project: k2,
  RedoArrow: L2,
  RenownHover: H2,
  Renown: X2,
  Ring: W2,
  Save: Z2,
  Search: z2,
  Server: G2,
  Settings: j2,
  Synced: U2,
  Syncing: Q2,
  TrashFill: q2,
  Trash: Y2,
  VariantArrowLeft: J2,
  VerticalDots: K2,
  WarningFill: _2,
  XmarkLight: $2,
  Xmark: e9
}, n9 = "data:image/png;base64,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", Pl = "-";
function r9(e) {
  const t = i9(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  function o(s) {
    const a = s.split(Pl);
    return a[0] === "" && a.length !== 1 && a.shift(), zf(a, t) || o9(s);
  }
  function i(s, a) {
    const c = n[s] || [];
    return a && r[s] ? [...c, ...r[s]] : c;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: i
  };
}
function zf(e, t) {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? zf(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(Pl);
  return (s = t.validators.find(({
    validator: a
  }) => a(i))) == null ? void 0 : s.classGroupId;
}
const pA = /^\[(.+)\]$/;
function o9(e) {
  if (pA.test(e)) {
    const t = pA.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function i9(e) {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return a9(Object.entries(e.classGroups), n).forEach(([i, s]) => {
    lu(s, r, i, t);
  }), r;
}
function lu(e, t, n, r) {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : mA(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (s9(o)) {
        lu(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, s]) => {
      lu(s, mA(t, i), n, r);
    });
  });
}
function mA(e, t) {
  let n = e;
  return t.split(Pl).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function s9(e) {
  return e.isThemeGetter;
}
function a9(e, t) {
  return t ? e.map(([n, r]) => {
    const o = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([s, a]) => [t + s, a])) : i);
    return [n, o];
  }) : e;
}
function c9(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(i, s) {
    n.set(i, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get(i) {
      let s = n.get(i);
      if (s !== void 0)
        return s;
      if ((s = r.get(i)) !== void 0)
        return o(i, s), s;
    },
    set(i, s) {
      n.has(i) ? n.set(i, s) : o(i, s);
    }
  };
}
const Gf = "!";
function u9(e) {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], i = t.length;
  function s(a) {
    const c = [];
    let u = 0, l = 0, d;
    for (let m = 0; m < a.length; m++) {
      let b = a[m];
      if (u === 0) {
        if (b === o && (r || a.slice(m, m + i) === t)) {
          c.push(a.slice(l, m)), l = m + i;
          continue;
        }
        if (b === "/") {
          d = m;
          continue;
        }
      }
      b === "[" ? u++ : b === "]" && u--;
    }
    const f = c.length === 0 ? a : a.substring(l), p = f.startsWith(Gf), h = p ? f.substring(1) : f, g = d && d > l ? d - l : void 0;
    return {
      modifiers: c,
      hasImportantModifier: p,
      baseClassName: h,
      maybePostfixModifierPosition: g
    };
  }
  return n ? function(c) {
    return n({
      className: c,
      parseClassName: s
    });
  } : s;
}
function l9(e) {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}
function d9(e) {
  return {
    cache: c9(e.cacheSize),
    parseClassName: u9(e),
    ...r9(e)
  };
}
const A9 = /\s+/;
function f9(e, t) {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, i = /* @__PURE__ */ new Set();
  return e.trim().split(A9).map((s) => {
    const {
      modifiers: a,
      hasImportantModifier: c,
      baseClassName: u,
      maybePostfixModifierPosition: l
    } = n(s);
    let d = !!l, f = r(d ? u.substring(0, l) : u);
    if (!f) {
      if (!d)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      if (f = r(u), !f)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      d = !1;
    }
    const p = l9(a).join(":");
    return {
      isTailwindClass: !0,
      modifierId: c ? p + Gf : p,
      classGroupId: f,
      originalClassName: s,
      hasPostfixModifier: d
    };
  }).reverse().filter((s) => {
    if (!s.isTailwindClass)
      return !0;
    const {
      modifierId: a,
      classGroupId: c,
      hasPostfixModifier: u
    } = s, l = a + c;
    return i.has(l) ? !1 : (i.add(l), o(c, u).forEach((d) => i.add(a + d)), !0);
  }).reverse().map((s) => s.originalClassName).join(" ");
}
function Nr() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = jf(t)) && (r && (r += " "), r += n);
  return r;
}
function jf(e) {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = jf(e[r])) && (n && (n += " "), n += t);
  return n;
}
function h9(e, ...t) {
  let n, r, o, i = s;
  function s(c) {
    const u = t.reduce((l, d) => d(l), e());
    return n = d9(u), r = n.cache.get, o = n.cache.set, i = a, a(c);
  }
  function a(c) {
    const u = r(c);
    if (u)
      return u;
    const l = f9(c, n);
    return o(c, l), l;
  }
  return function() {
    return i(Nr.apply(null, arguments));
  };
}
function We(e) {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}
const Uf = /^\[(?:([a-z-]+):)?(.+)\]$/i, p9 = /^\d+\/\d+$/, m9 = /* @__PURE__ */ new Set(["px", "full", "screen"]), g9 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, b9 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, v9 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, y9 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, C9 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function fn(e) {
  return rr(e) || m9.has(e) || p9.test(e);
}
function En(e) {
  return No(e, "length", P9);
}
function rr(e) {
  return !!e && !Number.isNaN(Number(e));
}
function ds(e) {
  return No(e, "number", rr);
}
function zo(e) {
  return !!e && Number.isInteger(Number(e));
}
function x9(e) {
  return e.endsWith("%") && rr(e.slice(0, -1));
}
function we(e) {
  return Uf.test(e);
}
function Sn(e) {
  return g9.test(e);
}
const w9 = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function I9(e) {
  return No(e, w9, Qf);
}
function E9(e) {
  return No(e, "position", Qf);
}
const S9 = /* @__PURE__ */ new Set(["image", "url"]);
function T9(e) {
  return No(e, S9, O9);
}
function N9(e) {
  return No(e, "", R9);
}
function Go() {
  return !0;
}
function No(e, t, n) {
  const r = Uf.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}
function P9(e) {
  return b9.test(e) && !v9.test(e);
}
function Qf() {
  return !1;
}
function R9(e) {
  return y9.test(e);
}
function O9(e) {
  return C9.test(e);
}
function D9() {
  const e = We("colors"), t = We("spacing"), n = We("blur"), r = We("brightness"), o = We("borderColor"), i = We("borderRadius"), s = We("borderSpacing"), a = We("borderWidth"), c = We("contrast"), u = We("grayscale"), l = We("hueRotate"), d = We("invert"), f = We("gap"), p = We("gradientColorStops"), h = We("gradientColorStopPositions"), g = We("inset"), m = We("margin"), b = We("opacity"), v = We("padding"), C = We("saturate"), w = We("scale"), y = We("sepia"), I = We("skew"), x = We("space"), E = We("translate"), P = () => ["auto", "contain", "none"], L = () => ["auto", "hidden", "clip", "visible", "scroll"], W = () => ["auto", we, t], V = () => [we, t], X = () => ["", fn, En], N = () => ["auto", rr, we], M = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], F = () => ["solid", "dashed", "dotted", "double", "none"], B = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], Z = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], H = () => ["", "0", we], K = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], ee = () => [rr, ds], z = () => [rr, we];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Go],
      spacing: [fn, En],
      blur: ["none", "", Sn, we],
      brightness: ee(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Sn, we],
      borderSpacing: V(),
      borderWidth: X(),
      contrast: ee(),
      grayscale: H(),
      hueRotate: z(),
      invert: H(),
      gap: V(),
      gradientColorStops: [e],
      gradientColorStopPositions: [x9, En],
      inset: W(),
      margin: W(),
      opacity: ee(),
      padding: V(),
      saturate: ee(),
      scale: ee(),
      sepia: H(),
      skew: z(),
      space: V(),
      translate: V()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", we]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Sn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": K()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": K()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...M(), we]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: L()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": L()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": L()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: P()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": P()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": P()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", zo, we]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: W()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", we]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: H()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: H()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", zo, we]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Go]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", zo, we]
        }, we]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": N()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": N()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Go]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [zo, we]
        }, we]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": N()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": N()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", we]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", we]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...Z()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...Z(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...Z(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [x]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [x]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", we, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [we, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [we, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Sn]
        }, Sn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [we, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [we, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [we, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [we, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Sn, En]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ds]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Go]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", we]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", rr, ds]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", fn, we]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", we]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", we]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...F(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", fn, En]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", fn, we]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: V()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", we]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", we]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...M(), E9]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", I9]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, T9]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...F(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: F()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...F()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [fn, we]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [fn, En]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: X()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [fn, En]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Sn, N9]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Go]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...B(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": B()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Sn, we]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [l]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [C]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [y]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [l]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [C]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [y]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", we]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: z()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", we]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: z()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", we]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [w]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [w]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [w]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [zo, we]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [E]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [E]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [I]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [I]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", we]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", we]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": V()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": V()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": V()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": V()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": V()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": V()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": V()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": V()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": V()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": V()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": V()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": V()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": V()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": V()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": V()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": V()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": V()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": V()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", we]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [fn, En, ds]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const $ = /* @__PURE__ */ h9(D9), jt = Pt(function(t, n) {
  const {
    color: r = "dark",
    size: o = "medium",
    className: i = "",
    children: s,
    icon: a,
    iconPosition: c = "left",
    ...u
  } = t, l = {
    small: "px-2 py-1.5 text-xs rounded-md font-medium",
    medium: "px-6 py-3 text-base rounded-xl font-semibold tracking-wide"
  }, f = Nr({
    light: "bg-gray-200 text-gray-600 hover:text-gray-700 hover:border-gray-300 active:border-slate-100 active:text-gray-600 disabled:text-gray-400",
    dark: "bg-gray-800 text-slate-50 hover:bg-slate-800 active:border-slate-700 disabled:bg-gray-300 disabled:text-slate-100",
    red: "bg-red-900 text-slate-50 hover:opacity-80 active:border-red-800 disabled:text-red-400 disabled:opacity-100",
    blue: "bg-blue-900 text-slate-50 hover:opacity-80 active:border-blue-800 disabled:text-blue-400 disabled:opacity-100"
  }[r], l[o]), p = $(
    "flex items-center justify-center gap-2 border border-none outline-none transition disabled:cursor-not-allowed",
    f,
    i
  );
  return /* @__PURE__ */ R("button", { ref: n, className: p, ...u, children: [
    c === "left" && a,
    s,
    c === "right" && a
  ] });
});
function he(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function M9(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ta(...e) {
  return (t) => e.forEach((n) => M9(n, t));
}
function _e(...e) {
  return S.useCallback(Ta(...e), e);
}
function F9(e, t) {
  const n = S.createContext(t);
  function r(i) {
    const { children: s, ...a } = i, c = S.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ A(n.Provider, { value: c, children: s });
  }
  function o(i) {
    const s = S.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return r.displayName = e + "Provider", [r, o];
}
function Jn(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = S.createContext(s), c = n.length;
    n = [...n, s];
    function u(d) {
      const { scope: f, children: p, ...h } = d, g = (f == null ? void 0 : f[e][c]) || a, m = S.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ A(g.Provider, { value: m, children: p });
    }
    function l(d, f) {
      const p = (f == null ? void 0 : f[e][c]) || a, h = S.useContext(p);
      if (h) return h;
      if (s !== void 0) return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [u, l];
  }
  const o = () => {
    const i = n.map((s) => S.createContext(s));
    return function(a) {
      const c = (a == null ? void 0 : a[e]) || i;
      return S.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: c } }),
        [a, c]
      );
    };
  };
  return o.scopeName = e, [r, V9(o, ...t)];
}
function V9(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((a, { useScope: c, scopeName: u }) => {
        const d = c(i)[`__scope${u}`];
        return { ...a, ...d };
      }, {});
      return S.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Ut(e) {
  const t = S.useRef(e);
  return S.useEffect(() => {
    t.current = e;
  }), S.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Ji({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = B9({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, a = Ut(n), c = S.useCallback(
    (u) => {
      if (i) {
        const d = typeof u == "function" ? u(e) : u;
        d !== e && a(d);
      } else
        o(u);
    },
    [i, e, o, a]
  );
  return [s, c];
}
function B9({
  defaultProp: e,
  onChange: t
}) {
  const n = S.useState(e), [r] = n, o = S.useRef(r), i = Ut(t);
  return S.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var bo = S.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = S.Children.toArray(n), i = o.find(k9);
  if (i) {
    const s = i.props.children, a = o.map((c) => c === i ? S.Children.count(s) > 1 ? S.Children.only(null) : S.isValidElement(s) ? s.props.children : null : c);
    return /* @__PURE__ */ A(du, { ...r, ref: t, children: S.isValidElement(s) ? S.cloneElement(s, void 0, a) : null });
  }
  return /* @__PURE__ */ A(du, { ...r, ref: t, children: n });
});
bo.displayName = "Slot";
var du = S.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (S.isValidElement(n)) {
    const o = H9(n);
    return S.cloneElement(n, {
      ...L9(r, n.props),
      // @ts-ignore
      ref: t ? Ta(t, o) : o
    });
  }
  return S.Children.count(n) > 1 ? S.Children.only(null) : null;
});
du.displayName = "SlotClone";
var qf = ({ children: e }) => /* @__PURE__ */ A(Ee, { children: e });
function k9(e) {
  return S.isValidElement(e) && e.type === qf;
}
function L9(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function H9(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var X9 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Xe = X9.reduce((e, t) => {
  const n = S.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, a = i ? bo : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ A(a, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Yf(e, t) {
  e && Nl.flushSync(() => e.dispatchEvent(t));
}
function Jf(e) {
  const t = e + "CollectionProvider", [n, r] = Jn(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (p) => {
    const { scope: h, children: g } = p, m = Y.useRef(null), b = Y.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ A(o, { scope: h, itemMap: b, collectionRef: m, children: g });
  };
  s.displayName = t;
  const a = e + "CollectionSlot", c = Y.forwardRef(
    (p, h) => {
      const { scope: g, children: m } = p, b = i(a, g), v = _e(h, b.collectionRef);
      return /* @__PURE__ */ A(bo, { ref: v, children: m });
    }
  );
  c.displayName = a;
  const u = e + "CollectionItemSlot", l = "data-radix-collection-item", d = Y.forwardRef(
    (p, h) => {
      const { scope: g, children: m, ...b } = p, v = Y.useRef(null), C = _e(h, v), w = i(u, g);
      return Y.useEffect(() => (w.itemMap.set(v, { ref: v, ...b }), () => void w.itemMap.delete(v))), /* @__PURE__ */ A(bo, { [l]: "", ref: C, children: m });
    }
  );
  d.displayName = u;
  function f(p) {
    const h = i(e + "CollectionConsumer", p);
    return Y.useCallback(() => {
      const m = h.collectionRef.current;
      if (!m) return [];
      const b = Array.from(m.querySelectorAll(`[${l}]`));
      return Array.from(h.itemMap.values()).sort(
        (w, y) => b.indexOf(w.ref.current) - b.indexOf(y.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: s, Slot: c, ItemSlot: d },
    f,
    r
  ];
}
var W9 = S.createContext(void 0);
function Rl(e) {
  const t = S.useContext(W9);
  return e || t || "ltr";
}
function Z9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ut(e);
  S.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var z9 = "DismissableLayer", Au = "dismissableLayer.update", G9 = "dismissableLayer.pointerDownOutside", j9 = "dismissableLayer.focusOutside", gA, Kf = S.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Na = S.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...c
    } = e, u = S.useContext(Kf), [l, d] = S.useState(null), f = (l == null ? void 0 : l.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = S.useState({}), h = _e(t, (x) => d(x)), g = Array.from(u.layers), [m] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), b = g.indexOf(m), v = l ? g.indexOf(l) : -1, C = u.layersWithOutsidePointerEventsDisabled.size > 0, w = v >= b, y = q9((x) => {
      const E = x.target, P = [...u.branches].some((L) => L.contains(E));
      !w || P || (o == null || o(x), s == null || s(x), x.defaultPrevented || a == null || a());
    }, f), I = Y9((x) => {
      const E = x.target;
      [...u.branches].some((L) => L.contains(E)) || (i == null || i(x), s == null || s(x), x.defaultPrevented || a == null || a());
    }, f);
    return Z9((x) => {
      v === u.layers.size - 1 && (r == null || r(x), !x.defaultPrevented && a && (x.preventDefault(), a()));
    }, f), S.useEffect(() => {
      if (l)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (gA = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(l)), u.layers.add(l), bA(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = gA);
        };
    }, [l, f, n, u]), S.useEffect(() => () => {
      l && (u.layers.delete(l), u.layersWithOutsidePointerEventsDisabled.delete(l), bA());
    }, [l, u]), S.useEffect(() => {
      const x = () => p({});
      return document.addEventListener(Au, x), () => document.removeEventListener(Au, x);
    }, []), /* @__PURE__ */ A(
      Xe.div,
      {
        ...c,
        ref: h,
        style: {
          pointerEvents: C ? w ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: he(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: he(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: he(
          e.onPointerDownCapture,
          y.onPointerDownCapture
        )
      }
    );
  }
);
Na.displayName = z9;
var U9 = "DismissableLayerBranch", Q9 = S.forwardRef((e, t) => {
  const n = S.useContext(Kf), r = S.useRef(null), o = _e(t, r);
  return S.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ A(Xe.div, { ...e, ref: o });
});
Q9.displayName = U9;
function q9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ut(e), r = S.useRef(!1), o = S.useRef(() => {
  });
  return S.useEffect(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let c = function() {
          _f(
            G9,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Y9(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ut(e), r = S.useRef(!1);
  return S.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && _f(j9, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function bA() {
  const e = new CustomEvent(Au);
  document.dispatchEvent(e);
}
function _f(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Yf(o, i) : o.dispatchEvent(i);
}
var lc = 0;
function $f() {
  S.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? vA()), document.body.insertAdjacentElement("beforeend", e[1] ?? vA()), lc++, () => {
      lc === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), lc--;
    };
  }, []);
}
function vA() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var dc = "focusScope.autoFocusOnMount", Ac = "focusScope.autoFocusOnUnmount", yA = { bubbles: !1, cancelable: !0 }, J9 = "FocusScope", Ol = S.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, c] = S.useState(null), u = Ut(o), l = Ut(i), d = S.useRef(null), f = _e(t, (g) => c(g)), p = S.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  S.useEffect(() => {
    if (r) {
      let g = function(C) {
        if (p.paused || !a) return;
        const w = C.target;
        a.contains(w) ? d.current = w : Pn(d.current, { select: !0 });
      }, m = function(C) {
        if (p.paused || !a) return;
        const w = C.relatedTarget;
        w !== null && (a.contains(w) || Pn(d.current, { select: !0 }));
      }, b = function(C) {
        if (document.activeElement === document.body)
          for (const y of C)
            y.removedNodes.length > 0 && Pn(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", m);
      const v = new MutationObserver(b);
      return a && v.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", m), v.disconnect();
      };
    }
  }, [r, a, p.paused]), S.useEffect(() => {
    if (a) {
      xA.add(p);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const b = new CustomEvent(dc, yA);
        a.addEventListener(dc, u), a.dispatchEvent(b), b.defaultPrevented || (K9(nb(e0(a)), { select: !0 }), document.activeElement === g && Pn(a));
      }
      return () => {
        a.removeEventListener(dc, u), setTimeout(() => {
          const b = new CustomEvent(Ac, yA);
          a.addEventListener(Ac, l), a.dispatchEvent(b), b.defaultPrevented || Pn(g ?? document.body, { select: !0 }), a.removeEventListener(Ac, l), xA.remove(p);
        }, 0);
      };
    }
  }, [a, u, l, p]);
  const h = S.useCallback(
    (g) => {
      if (!n && !r || p.paused) return;
      const m = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
      if (m && b) {
        const v = g.currentTarget, [C, w] = _9(v);
        C && w ? !g.shiftKey && b === w ? (g.preventDefault(), n && Pn(C, { select: !0 })) : g.shiftKey && b === C && (g.preventDefault(), n && Pn(w, { select: !0 })) : b === v && g.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ A(Xe.div, { tabIndex: -1, ...s, ref: f, onKeyDown: h });
});
Ol.displayName = J9;
function K9(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Pn(r, { select: t }), document.activeElement !== n) return;
}
function _9(e) {
  const t = e0(e), n = CA(t, e), r = CA(t.reverse(), e);
  return [n, r];
}
function e0(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function CA(e, t) {
  for (const n of e)
    if (!$9(n, { upTo: t })) return n;
}
function $9(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function eb(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Pn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && eb(e) && t && e.select();
  }
}
var xA = tb();
function tb() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = wA(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = wA(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function wA(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function nb(e) {
  return e.filter((t) => t.tagName !== "A");
}
var gr = globalThis != null && globalThis.document ? S.useLayoutEffect : () => {
}, rb = S.useId || (() => {
}), ob = 0;
function Xn(e) {
  const [t, n] = S.useState(rb());
  return gr(() => {
    e || n((r) => r ?? String(ob++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const ib = ["top", "right", "bottom", "left"], cn = Math.min, It = Math.max, Js = Math.round, As = Math.floor, jn = (e) => ({
  x: e,
  y: e
}), sb = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ab = {
  start: "end",
  end: "start"
};
function fu(e, t, n) {
  return It(e, cn(t, n));
}
function yn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Cn(e) {
  return e.split("-")[0];
}
function Po(e) {
  return e.split("-")[1];
}
function Dl(e) {
  return e === "x" ? "y" : "x";
}
function Ml(e) {
  return e === "y" ? "height" : "width";
}
function Un(e) {
  return ["top", "bottom"].includes(Cn(e)) ? "y" : "x";
}
function Fl(e) {
  return Dl(Un(e));
}
function cb(e, t, n) {
  n === void 0 && (n = !1);
  const r = Po(e), o = Fl(e), i = Ml(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = Ks(s)), [s, Ks(s)];
}
function ub(e) {
  const t = Ks(e);
  return [hu(e), t, hu(t)];
}
function hu(e) {
  return e.replace(/start|end/g, (t) => ab[t]);
}
function lb(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function db(e, t, n, r) {
  const o = Po(e);
  let i = lb(Cn(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(hu)))), i;
}
function Ks(e) {
  return e.replace(/left|right|bottom|top/g, (t) => sb[t]);
}
function Ab(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function t0(e) {
  return typeof e != "number" ? Ab(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function _s(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function IA(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = Un(t), s = Fl(t), a = Ml(s), c = Cn(t), u = i === "y", l = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: l,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Po(t)) {
    case "start":
      p[s] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      p[s] += f * (n && u ? -1 : 1);
      break;
  }
  return p;
}
const fb = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: l,
    y: d
  } = IA(u, r, c), f = r, p = {}, h = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: m,
      fn: b
    } = a[g], {
      x: v,
      y: C,
      data: w,
      reset: y
    } = await b({
      x: l,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: p,
      rects: u,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    l = v ?? l, d = C ?? d, p = {
      ...p,
      [m]: {
        ...p[m],
        ...w
      }
    }, y && h <= 50 && (h++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (u = y.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : y.rects), {
      x: l,
      y: d
    } = IA(u, f, c)), g = -1);
  }
  return {
    x: l,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: p
  };
};
async function di(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = yn(t, e), h = t0(p), m = a[f ? d === "floating" ? "reference" : "floating" : d], b = _s(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(m))) == null || n ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: l,
    strategy: c
  })), v = d === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), w = await (i.isElement == null ? void 0 : i.isElement(C)) ? await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, y = _s(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: v,
    offsetParent: C,
    strategy: c
  }) : v);
  return {
    top: (b.top - y.top + h.top) / w.y,
    bottom: (y.bottom - b.bottom + h.bottom) / w.y,
    left: (b.left - y.left + h.left) / w.x,
    right: (y.right - b.right + h.right) / w.x
  };
}
const hb = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: c
    } = t, {
      element: u,
      padding: l = 0
    } = yn(e, t) || {};
    if (u == null)
      return {};
    const d = t0(l), f = {
      x: n,
      y: r
    }, p = Fl(o), h = Ml(p), g = await s.getDimensions(u), m = p === "y", b = m ? "top" : "left", v = m ? "bottom" : "right", C = m ? "clientHeight" : "clientWidth", w = i.reference[h] + i.reference[p] - f[p] - i.floating[h], y = f[p] - i.reference[p], I = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let x = I ? I[C] : 0;
    (!x || !await (s.isElement == null ? void 0 : s.isElement(I))) && (x = a.floating[C] || i.floating[h]);
    const E = w / 2 - y / 2, P = x / 2 - g[h] / 2 - 1, L = cn(d[b], P), W = cn(d[v], P), V = L, X = x - g[h] - W, N = x / 2 - g[h] / 2 + E, M = fu(V, N, X), F = !c.arrow && Po(o) != null && N !== M && i.reference[h] / 2 - (N < V ? L : W) - g[h] / 2 < 0, B = F ? N < V ? N - V : N - X : 0;
    return {
      [p]: f[p] + B,
      data: {
        [p]: M,
        centerOffset: N - M - B,
        ...F && {
          alignmentOffset: B
        }
      },
      reset: F
    };
  }
}), pb = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: c,
        elements: u
      } = t, {
        mainAxis: l = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...m
      } = yn(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const b = Cn(o), v = Un(a), C = Cn(a) === a, w = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), y = f || (C || !g ? [Ks(a)] : ub(a)), I = h !== "none";
      !f && I && y.push(...db(a, g, h, w));
      const x = [a, ...y], E = await di(t, m), P = [];
      let L = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (l && P.push(E[b]), d) {
        const N = cb(o, s, w);
        P.push(E[N[0]], E[N[1]]);
      }
      if (L = [...L, {
        placement: o,
        overflows: P
      }], !P.every((N) => N <= 0)) {
        var W, V;
        const N = (((W = i.flip) == null ? void 0 : W.index) || 0) + 1, M = x[N];
        if (M)
          return {
            data: {
              index: N,
              overflows: L
            },
            reset: {
              placement: M
            }
          };
        let F = (V = L.filter((B) => B.overflows[0] <= 0).sort((B, Z) => B.overflows[1] - Z.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!F)
          switch (p) {
            case "bestFit": {
              var X;
              const B = (X = L.filter((Z) => {
                if (I) {
                  const H = Un(Z.placement);
                  return H === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  H === "y";
                }
                return !0;
              }).map((Z) => [Z.placement, Z.overflows.filter((H) => H > 0).reduce((H, K) => H + K, 0)]).sort((Z, H) => Z[1] - H[1])[0]) == null ? void 0 : X[0];
              B && (F = B);
              break;
            }
            case "initialPlacement":
              F = a;
              break;
          }
        if (o !== F)
          return {
            reset: {
              placement: F
            }
          };
      }
      return {};
    }
  };
};
function EA(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function SA(e) {
  return ib.some((t) => e[t] >= 0);
}
const mb = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = yn(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await di(t, {
            ...o,
            elementContext: "reference"
          }), s = EA(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: SA(s)
            }
          };
        }
        case "escaped": {
          const i = await di(t, {
            ...o,
            altBoundary: !0
          }), s = EA(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: SA(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function gb(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Cn(n), a = Po(n), c = Un(n) === "y", u = ["left", "top"].includes(s) ? -1 : 1, l = i && c ? -1 : 1, d = yn(t, e);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return a && typeof h == "number" && (p = a === "end" ? h * -1 : h), c ? {
    x: p * l,
    y: f * u
  } : {
    x: f * u,
    y: p * l
  };
}
const bb = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: a
      } = t, c = await gb(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, vb = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (m) => {
            let {
              x: b,
              y: v
            } = m;
            return {
              x: b,
              y: v
            };
          }
        },
        ...c
      } = yn(e, t), u = {
        x: n,
        y: r
      }, l = await di(t, c), d = Un(Cn(o)), f = Dl(d);
      let p = u[f], h = u[d];
      if (i) {
        const m = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", v = p + l[m], C = p - l[b];
        p = fu(v, p, C);
      }
      if (s) {
        const m = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", v = h + l[m], C = h - l[b];
        h = fu(v, h, C);
      }
      const g = a.fn({
        ...t,
        [f]: p,
        [d]: h
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
}, yb = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = yn(e, t), l = {
        x: n,
        y: r
      }, d = Un(o), f = Dl(d);
      let p = l[f], h = l[d];
      const g = yn(a, t), m = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (c) {
        const C = f === "y" ? "height" : "width", w = i.reference[f] - i.floating[C] + m.mainAxis, y = i.reference[f] + i.reference[C] - m.mainAxis;
        p < w ? p = w : p > y && (p = y);
      }
      if (u) {
        var b, v;
        const C = f === "y" ? "width" : "height", w = ["top", "left"].includes(Cn(o)), y = i.reference[d] - i.floating[C] + (w && ((b = s.offset) == null ? void 0 : b[d]) || 0) + (w ? 0 : m.crossAxis), I = i.reference[d] + i.reference[C] + (w ? 0 : ((v = s.offset) == null ? void 0 : v[d]) || 0) - (w ? m.crossAxis : 0);
        h < y ? h = y : h > I && (h = I);
      }
      return {
        [f]: p,
        [d]: h
      };
    }
  };
}, Cb = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = t, {
        apply: s = () => {
        },
        ...a
      } = yn(e, t), c = await di(t, a), u = Cn(n), l = Po(n), d = Un(n) === "y", {
        width: f,
        height: p
      } = r.floating;
      let h, g;
      u === "top" || u === "bottom" ? (h = u, g = l === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (g = u, h = l === "end" ? "top" : "bottom");
      const m = p - c.top - c.bottom, b = f - c.left - c.right, v = cn(p - c[h], m), C = cn(f - c[g], b), w = !t.middlewareData.shift;
      let y = v, I = C;
      if (d ? I = l || w ? cn(C, b) : b : y = l || w ? cn(v, m) : m, w && !l) {
        const E = It(c.left, 0), P = It(c.right, 0), L = It(c.top, 0), W = It(c.bottom, 0);
        d ? I = f - 2 * (E !== 0 || P !== 0 ? E + P : It(c.left, c.right)) : y = p - 2 * (L !== 0 || W !== 0 ? L + W : It(c.top, c.bottom));
      }
      await s({
        ...t,
        availableWidth: I,
        availableHeight: y
      });
      const x = await o.getDimensions(i.floating);
      return f !== x.width || p !== x.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ro(e) {
  return n0(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Tt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function xn(e) {
  var t;
  return (t = (n0(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function n0(e) {
  return e instanceof Node || e instanceof Tt(e).Node;
}
function Qt(e) {
  return e instanceof Element || e instanceof Tt(e).Element;
}
function dn(e) {
  return e instanceof HTMLElement || e instanceof Tt(e).HTMLElement;
}
function TA(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Tt(e).ShadowRoot;
}
function Ki(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = qt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function xb(e) {
  return ["table", "td", "th"].includes(Ro(e));
}
function Pa(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Vl(e) {
  const t = Bl(), n = Qt(e) ? qt(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function wb(e) {
  let t = Qn(e);
  for (; dn(t) && !vo(t); ) {
    if (Vl(t))
      return t;
    if (Pa(t))
      return null;
    t = Qn(t);
  }
  return null;
}
function Bl() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function vo(e) {
  return ["html", "body", "#document"].includes(Ro(e));
}
function qt(e) {
  return Tt(e).getComputedStyle(e);
}
function Ra(e) {
  return Qt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Qn(e) {
  if (Ro(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    TA(e) && e.host || // Fallback.
    xn(e)
  );
  return TA(t) ? t.host : t;
}
function r0(e) {
  const t = Qn(e);
  return vo(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : dn(t) && Ki(t) ? t : r0(t);
}
function Ai(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = r0(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = Tt(o);
  if (i) {
    const a = pu(s);
    return t.concat(s, s.visualViewport || [], Ki(o) ? o : [], a && n ? Ai(a) : []);
  }
  return t.concat(o, Ai(o, [], n));
}
function pu(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function o0(e) {
  const t = qt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = dn(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, a = Js(n) !== i || Js(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function kl(e) {
  return Qt(e) ? e : e.contextElement;
}
function Jr(e) {
  const t = kl(e);
  if (!dn(t))
    return jn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = o0(t);
  let s = (i ? Js(n.width) : n.width) / r, a = (i ? Js(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Ib = /* @__PURE__ */ jn(0);
function i0(e) {
  const t = Tt(e);
  return !Bl() || !t.visualViewport ? Ib : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Eb(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Tt(e) ? !1 : t;
}
function br(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = kl(e);
  let s = jn(1);
  t && (r ? Qt(r) && (s = Jr(r)) : s = Jr(e));
  const a = Eb(i, n, r) ? i0(i) : jn(0);
  let c = (o.left + a.x) / s.x, u = (o.top + a.y) / s.y, l = o.width / s.x, d = o.height / s.y;
  if (i) {
    const f = Tt(i), p = r && Qt(r) ? Tt(r) : r;
    let h = f, g = pu(h);
    for (; g && r && p !== h; ) {
      const m = Jr(g), b = g.getBoundingClientRect(), v = qt(g), C = b.left + (g.clientLeft + parseFloat(v.paddingLeft)) * m.x, w = b.top + (g.clientTop + parseFloat(v.paddingTop)) * m.y;
      c *= m.x, u *= m.y, l *= m.x, d *= m.y, c += C, u += w, h = Tt(g), g = pu(h);
    }
  }
  return _s({
    width: l,
    height: d,
    x: c,
    y: u
  });
}
function Sb(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = xn(r), a = t ? Pa(t.floating) : !1;
  if (r === s || a && i)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = jn(1);
  const l = jn(0), d = dn(r);
  if ((d || !d && !i) && ((Ro(r) !== "body" || Ki(s)) && (c = Ra(r)), dn(r))) {
    const f = br(r);
    u = Jr(r), l.x = f.x + r.clientLeft, l.y = f.y + r.clientTop;
  }
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + l.x,
    y: n.y * u.y - c.scrollTop * u.y + l.y
  };
}
function Tb(e) {
  return Array.from(e.getClientRects());
}
function s0(e) {
  return br(xn(e)).left + Ra(e).scrollLeft;
}
function Nb(e) {
  const t = xn(e), n = Ra(e), r = e.ownerDocument.body, o = It(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = It(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + s0(e);
  const a = -n.scrollTop;
  return qt(r).direction === "rtl" && (s += It(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
function Pb(e, t) {
  const n = Tt(e), r = xn(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, c = 0;
  if (o) {
    i = o.width, s = o.height;
    const u = Bl();
    (!u || u && t === "fixed") && (a = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: c
  };
}
function Rb(e, t) {
  const n = br(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = dn(e) ? Jr(e) : jn(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, c = o * i.x, u = r * i.y;
  return {
    width: s,
    height: a,
    x: c,
    y: u
  };
}
function NA(e, t, n) {
  let r;
  if (t === "viewport")
    r = Pb(e, n);
  else if (t === "document")
    r = Nb(xn(e));
  else if (Qt(t))
    r = Rb(t, n);
  else {
    const o = i0(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return _s(r);
}
function a0(e, t) {
  const n = Qn(e);
  return n === t || !Qt(n) || vo(n) ? !1 : qt(n).position === "fixed" || a0(n, t);
}
function Ob(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ai(e, [], !1).filter((a) => Qt(a) && Ro(a) !== "body"), o = null;
  const i = qt(e).position === "fixed";
  let s = i ? Qn(e) : e;
  for (; Qt(s) && !vo(s); ) {
    const a = qt(s), c = Vl(s);
    !c && a.position === "fixed" && (o = null), (i ? !c && !o : !c && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Ki(s) && !c && a0(e, s)) ? r = r.filter((l) => l !== s) : o = a, s = Qn(s);
  }
  return t.set(e, r), r;
}
function Db(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Pa(t) ? [] : Ob(t, this._c) : [].concat(n), r], a = s[0], c = s.reduce((u, l) => {
    const d = NA(t, l, o);
    return u.top = It(d.top, u.top), u.right = cn(d.right, u.right), u.bottom = cn(d.bottom, u.bottom), u.left = It(d.left, u.left), u;
  }, NA(t, a, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Mb(e) {
  const {
    width: t,
    height: n
  } = o0(e);
  return {
    width: t,
    height: n
  };
}
function Fb(e, t, n) {
  const r = dn(t), o = xn(t), i = n === "fixed", s = br(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = jn(0);
  if (r || !r && !i)
    if ((Ro(t) !== "body" || Ki(o)) && (a = Ra(t)), r) {
      const d = br(t, !0, i, t);
      c.x = d.x + t.clientLeft, c.y = d.y + t.clientTop;
    } else o && (c.x = s0(o));
  const u = s.left + a.scrollLeft - c.x, l = s.top + a.scrollTop - c.y;
  return {
    x: u,
    y: l,
    width: s.width,
    height: s.height
  };
}
function fc(e) {
  return qt(e).position === "static";
}
function PA(e, t) {
  return !dn(e) || qt(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function c0(e, t) {
  const n = Tt(e);
  if (Pa(e))
    return n;
  if (!dn(e)) {
    let o = Qn(e);
    for (; o && !vo(o); ) {
      if (Qt(o) && !fc(o))
        return o;
      o = Qn(o);
    }
    return n;
  }
  let r = PA(e, t);
  for (; r && xb(r) && fc(r); )
    r = PA(r, t);
  return r && vo(r) && fc(r) && !Vl(r) ? n : r || wb(e) || n;
}
const Vb = async function(e) {
  const t = this.getOffsetParent || c0, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Fb(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Bb(e) {
  return qt(e).direction === "rtl";
}
const kb = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Sb,
  getDocumentElement: xn,
  getClippingRect: Db,
  getOffsetParent: c0,
  getElementRects: Vb,
  getClientRects: Tb,
  getDimensions: Mb,
  getScale: Jr,
  isElement: Qt,
  isRTL: Bb
};
function Lb(e, t) {
  let n = null, r;
  const o = xn(e);
  function i() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), i();
    const {
      left: u,
      top: l,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (a || t(), !d || !f)
      return;
    const p = As(l), h = As(o.clientWidth - (u + d)), g = As(o.clientHeight - (l + f)), m = As(u), v = {
      rootMargin: -p + "px " + -h + "px " + -g + "px " + -m + "px",
      threshold: It(0, cn(1, c)) || 1
    };
    let C = !0;
    function w(y) {
      const I = y[0].intersectionRatio;
      if (I !== c) {
        if (!C)
          return s();
        I ? s(!1, I) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      C = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...v,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, v);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function u0(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, u = kl(e), l = o || i ? [...u ? Ai(u) : [], ...Ai(t)] : [];
  l.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), i && b.addEventListener("resize", n);
  });
  const d = u && a ? Lb(u, n) : null;
  let f = -1, p = null;
  s && (p = new ResizeObserver((b) => {
    let [v] = b;
    v && v.target === u && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var C;
      (C = p) == null || C.observe(t);
    })), n();
  }), u && !c && p.observe(u), p.observe(t));
  let h, g = c ? br(e) : null;
  c && m();
  function m() {
    const b = br(e);
    g && (b.x !== g.x || b.y !== g.y || b.width !== g.width || b.height !== g.height) && n(), g = b, h = requestAnimationFrame(m);
  }
  return n(), () => {
    var b;
    l.forEach((v) => {
      o && v.removeEventListener("scroll", n), i && v.removeEventListener("resize", n);
    }), d == null || d(), (b = p) == null || b.disconnect(), p = null, c && cancelAnimationFrame(h);
  };
}
const Hb = bb, Xb = vb, Wb = pb, Zb = Cb, zb = mb, RA = hb, Gb = yb, jb = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: kb,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return fb(e, t, {
    ...o,
    platform: i
  });
};
var Bs = typeof document < "u" ? Yn : Ie;
function $s(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!$s(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !$s(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function l0(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function OA(e, t) {
  const n = l0(e);
  return Math.round(t * n) / n;
}
function DA(e) {
  const t = S.useRef(e);
  return Bs(() => {
    t.current = e;
  }), t;
}
function Ub(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: c,
    open: u
  } = e, [l, d] = S.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = S.useState(r);
  $s(f, r) || p(r);
  const [h, g] = S.useState(null), [m, b] = S.useState(null), v = S.useCallback((B) => {
    B !== I.current && (I.current = B, g(B));
  }, []), C = S.useCallback((B) => {
    B !== x.current && (x.current = B, b(B));
  }, []), w = i || h, y = s || m, I = S.useRef(null), x = S.useRef(null), E = S.useRef(l), P = c != null, L = DA(c), W = DA(o), V = S.useCallback(() => {
    if (!I.current || !x.current)
      return;
    const B = {
      placement: t,
      strategy: n,
      middleware: f
    };
    W.current && (B.platform = W.current), jb(I.current, x.current, B).then((Z) => {
      const H = {
        ...Z,
        isPositioned: !0
      };
      X.current && !$s(E.current, H) && (E.current = H, Nl.flushSync(() => {
        d(H);
      }));
    });
  }, [f, t, n, W]);
  Bs(() => {
    u === !1 && E.current.isPositioned && (E.current.isPositioned = !1, d((B) => ({
      ...B,
      isPositioned: !1
    })));
  }, [u]);
  const X = S.useRef(!1);
  Bs(() => (X.current = !0, () => {
    X.current = !1;
  }), []), Bs(() => {
    if (w && (I.current = w), y && (x.current = y), w && y) {
      if (L.current)
        return L.current(w, y, V);
      V();
    }
  }, [w, y, V, L, P]);
  const N = S.useMemo(() => ({
    reference: I,
    floating: x,
    setReference: v,
    setFloating: C
  }), [v, C]), M = S.useMemo(() => ({
    reference: w,
    floating: y
  }), [w, y]), F = S.useMemo(() => {
    const B = {
      position: n,
      left: 0,
      top: 0
    };
    if (!M.floating)
      return B;
    const Z = OA(M.floating, l.x), H = OA(M.floating, l.y);
    return a ? {
      ...B,
      transform: "translate(" + Z + "px, " + H + "px)",
      ...l0(M.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: Z,
      top: H
    };
  }, [n, a, M.floating, l.x, l.y]);
  return S.useMemo(() => ({
    ...l,
    update: V,
    refs: N,
    elements: M,
    floatingStyles: F
  }), [l, V, N, M, F]);
}
const Qb = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? RA({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? RA({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, qb = (e, t) => ({
  ...Hb(e),
  options: [e, t]
}), Yb = (e, t) => ({
  ...Xb(e),
  options: [e, t]
}), Jb = (e, t) => ({
  ...Gb(e),
  options: [e, t]
}), Kb = (e, t) => ({
  ...Wb(e),
  options: [e, t]
}), _b = (e, t) => ({
  ...Zb(e),
  options: [e, t]
}), $b = (e, t) => ({
  ...zb(e),
  options: [e, t]
}), ev = (e, t) => ({
  ...Qb(e),
  options: [e, t]
});
var tv = "Arrow", d0 = S.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ A(
    Xe.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ A("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
d0.displayName = tv;
var nv = d0;
function rv(e) {
  const [t, n] = S.useState(void 0);
  return gr(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, a;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          s = u.inlineSize, a = u.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        n({ width: s, height: a });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Ll = "Popper", [A0, Oa] = Jn(Ll), [ov, f0] = A0(Ll), h0 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = S.useState(null);
  return /* @__PURE__ */ A(ov, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
h0.displayName = Ll;
var p0 = "PopperAnchor", m0 = S.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = f0(p0, n), s = S.useRef(null), a = _e(t, s);
    return S.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ A(Xe.div, { ...o, ref: a });
  }
);
m0.displayName = p0;
var Hl = "PopperContent", [iv, sv] = A0(Hl), g0 = S.forwardRef(
  (e, t) => {
    var me, Te, Be, et, it, re;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: a = 0,
      avoidCollisions: c = !0,
      collisionBoundary: u = [],
      collisionPadding: l = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: h,
      ...g
    } = e, m = f0(Hl, n), [b, v] = S.useState(null), C = _e(t, (Ge) => v(Ge)), [w, y] = S.useState(null), I = rv(w), x = (I == null ? void 0 : I.width) ?? 0, E = (I == null ? void 0 : I.height) ?? 0, P = r + (i !== "center" ? "-" + i : ""), L = typeof l == "number" ? l : { top: 0, right: 0, bottom: 0, left: 0, ...l }, W = Array.isArray(u) ? u : [u], V = W.length > 0, X = {
      padding: L,
      boundary: W.filter(cv),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: V
    }, { refs: N, floatingStyles: M, placement: F, isPositioned: B, middlewareData: Z } = Ub({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: P,
      whileElementsMounted: (...Ge) => u0(...Ge, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: m.anchor
      },
      middleware: [
        qb({ mainAxis: o + E, alignmentAxis: s }),
        c && Yb({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? Jb() : void 0,
          ...X
        }),
        c && Kb({ ...X }),
        _b({
          ...X,
          apply: ({ elements: Ge, rects: nt, availableWidth: Rt, availableHeight: $n }) => {
            const { width: ie, height: T } = nt.reference, O = Ge.floating.style;
            O.setProperty("--radix-popper-available-width", `${Rt}px`), O.setProperty("--radix-popper-available-height", `${$n}px`), O.setProperty("--radix-popper-anchor-width", `${ie}px`), O.setProperty("--radix-popper-anchor-height", `${T}px`);
          }
        }),
        w && ev({ element: w, padding: a }),
        uv({ arrowWidth: x, arrowHeight: E }),
        f && $b({ strategy: "referenceHidden", ...X })
      ]
    }), [H, K] = y0(F), ee = Ut(h);
    gr(() => {
      B && (ee == null || ee());
    }, [B, ee]);
    const z = (me = Z.arrow) == null ? void 0 : me.x, ce = (Te = Z.arrow) == null ? void 0 : Te.y, be = ((Be = Z.arrow) == null ? void 0 : Be.centerOffset) !== 0, [te, ue] = S.useState();
    return gr(() => {
      b && ue(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ A(
      "div",
      {
        ref: N.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...M,
          transform: B ? M.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: te,
          "--radix-popper-transform-origin": [
            (et = Z.transformOrigin) == null ? void 0 : et.x,
            (it = Z.transformOrigin) == null ? void 0 : it.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((re = Z.hide) == null ? void 0 : re.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ A(
          iv,
          {
            scope: n,
            placedSide: H,
            onArrowChange: y,
            arrowX: z,
            arrowY: ce,
            shouldHideArrow: be,
            children: /* @__PURE__ */ A(
              Xe.div,
              {
                "data-side": H,
                "data-align": K,
                ...g,
                ref: C,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: B ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
g0.displayName = Hl;
var b0 = "PopperArrow", av = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, v0 = S.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = sv(b0, r), s = av[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ A(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ A(
          nv,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
v0.displayName = b0;
function cv(e) {
  return e !== null;
}
var uv = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var m, b, v;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((m = o.arrow) == null ? void 0 : m.centerOffset) !== 0, a = s ? 0 : e.arrowWidth, c = s ? 0 : e.arrowHeight, [u, l] = y0(n), d = { start: "0%", center: "50%", end: "100%" }[l], f = (((b = o.arrow) == null ? void 0 : b.x) ?? 0) + a / 2, p = (((v = o.arrow) == null ? void 0 : v.y) ?? 0) + c / 2;
    let h = "", g = "";
    return u === "bottom" ? (h = s ? d : `${f}px`, g = `${-c}px`) : u === "top" ? (h = s ? d : `${f}px`, g = `${r.floating.height + c}px`) : u === "right" ? (h = `${-c}px`, g = s ? d : `${p}px`) : u === "left" && (h = `${r.floating.width + c}px`, g = s ? d : `${p}px`), { data: { x: h, y: g } };
  }
});
function y0(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var C0 = h0, x0 = m0, w0 = g0, I0 = v0, lv = "Portal", Da = S.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [o, i] = S.useState(!1);
  gr(() => i(!0), []);
  const s = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? Zf.createPortal(/* @__PURE__ */ A(Xe.div, { ...r, ref: t }), s) : null;
});
Da.displayName = lv;
function dv(e, t) {
  return S.useReducer((n, r) => t[n][r] ?? n, e);
}
var Yt = (e) => {
  const { present: t, children: n } = e, r = Av(t), o = typeof n == "function" ? n({ present: r.isPresent }) : S.Children.only(n), i = _e(r.ref, fv(o));
  return typeof n == "function" || r.isPresent ? S.cloneElement(o, { ref: i }) : null;
};
Yt.displayName = "Presence";
function Av(e) {
  const [t, n] = S.useState(), r = S.useRef({}), o = S.useRef(e), i = S.useRef("none"), s = e ? "mounted" : "unmounted", [a, c] = dv(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return S.useEffect(() => {
    const u = fs(r.current);
    i.current = a === "mounted" ? u : "none";
  }, [a]), gr(() => {
    const u = r.current, l = o.current;
    if (l !== e) {
      const f = i.current, p = fs(u);
      e ? c("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(l && f !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), gr(() => {
    if (t) {
      const u = (d) => {
        const p = fs(r.current).includes(d.animationName);
        d.target === t && p && Nl.flushSync(() => c("ANIMATION_END"));
      }, l = (d) => {
        d.target === t && (i.current = fs(r.current));
      };
      return t.addEventListener("animationstart", l), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", l), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: S.useCallback((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function fs(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function fv(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var hc = "rovingFocusGroup.onEntryFocus", hv = { bubbles: !1, cancelable: !0 }, Ma = "RovingFocusGroup", [mu, E0, pv] = Jf(Ma), [mv, Fa] = Jn(
  Ma,
  [pv]
), [gv, bv] = mv(Ma), S0 = S.forwardRef(
  (e, t) => /* @__PURE__ */ A(mu.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ A(mu.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ A(vv, { ...e, ref: t }) }) })
);
S0.displayName = Ma;
var vv = S.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: s,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: c,
    onEntryFocus: u,
    preventScrollOnEntryFocus: l = !1,
    ...d
  } = e, f = S.useRef(null), p = _e(t, f), h = Rl(i), [g = null, m] = Ji({
    prop: s,
    defaultProp: a,
    onChange: c
  }), [b, v] = S.useState(!1), C = Ut(u), w = E0(n), y = S.useRef(!1), [I, x] = S.useState(0);
  return S.useEffect(() => {
    const E = f.current;
    if (E)
      return E.addEventListener(hc, C), () => E.removeEventListener(hc, C);
  }, [C]), /* @__PURE__ */ A(
    gv,
    {
      scope: n,
      orientation: r,
      dir: h,
      loop: o,
      currentTabStopId: g,
      onItemFocus: S.useCallback(
        (E) => m(E),
        [m]
      ),
      onItemShiftTab: S.useCallback(() => v(!0), []),
      onFocusableItemAdd: S.useCallback(
        () => x((E) => E + 1),
        []
      ),
      onFocusableItemRemove: S.useCallback(
        () => x((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ A(
        Xe.div,
        {
          tabIndex: b || I === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: he(e.onMouseDown, () => {
            y.current = !0;
          }),
          onFocus: he(e.onFocus, (E) => {
            const P = !y.current;
            if (E.target === E.currentTarget && P && !b) {
              const L = new CustomEvent(hc, hv);
              if (E.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
                const W = w().filter((F) => F.focusable), V = W.find((F) => F.active), X = W.find((F) => F.id === g), M = [V, X, ...W].filter(
                  Boolean
                ).map((F) => F.ref.current);
                P0(M, l);
              }
            }
            y.current = !1;
          }),
          onBlur: he(e.onBlur, () => v(!1))
        }
      )
    }
  );
}), T0 = "RovingFocusGroupItem", N0 = S.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      ...s
    } = e, a = Xn(), c = i || a, u = bv(T0, n), l = u.currentTabStopId === c, d = E0(n), { onFocusableItemAdd: f, onFocusableItemRemove: p } = u;
    return S.useEffect(() => {
      if (r)
        return f(), () => p();
    }, [r, f, p]), /* @__PURE__ */ A(
      mu.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ A(
          Xe.span,
          {
            tabIndex: l ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: he(e.onMouseDown, (h) => {
              r ? u.onItemFocus(c) : h.preventDefault();
            }),
            onFocus: he(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: he(e.onKeyDown, (h) => {
              if (h.key === "Tab" && h.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (h.target !== h.currentTarget) return;
              const g = xv(h, u.orientation, u.dir);
              if (g !== void 0) {
                if (h.metaKey || h.ctrlKey || h.altKey || h.shiftKey) return;
                h.preventDefault();
                let b = d().filter((v) => v.focusable).map((v) => v.ref.current);
                if (g === "last") b.reverse();
                else if (g === "prev" || g === "next") {
                  g === "prev" && b.reverse();
                  const v = b.indexOf(h.currentTarget);
                  b = u.loop ? wv(b, v + 1) : b.slice(v + 1);
                }
                setTimeout(() => P0(b));
              }
            })
          }
        )
      }
    );
  }
);
N0.displayName = T0;
var yv = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Cv(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function xv(e, t, n) {
  const r = Cv(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return yv[r];
}
function P0(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function wv(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var R0 = S0, O0 = N0, Iv = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, kr = /* @__PURE__ */ new WeakMap(), hs = /* @__PURE__ */ new WeakMap(), ps = {}, pc = 0, D0 = function(e) {
  return e && (e.host || D0(e.parentNode));
}, Ev = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = D0(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Sv = function(e, t, n, r) {
  var o = Ev(t, Array.isArray(e) ? e : [e]);
  ps[n] || (ps[n] = /* @__PURE__ */ new WeakMap());
  var i = ps[n], s = [], a = /* @__PURE__ */ new Set(), c = new Set(o), u = function(d) {
    !d || a.has(d) || (a.add(d), u(d.parentNode));
  };
  o.forEach(u);
  var l = function(d) {
    !d || c.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        l(f);
      else
        try {
          var p = f.getAttribute(r), h = p !== null && p !== "false", g = (kr.get(f) || 0) + 1, m = (i.get(f) || 0) + 1;
          kr.set(f, g), i.set(f, m), s.push(f), g === 1 && h && hs.set(f, !0), m === 1 && f.setAttribute(n, "true"), h || f.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", f, b);
        }
    });
  };
  return l(t), a.clear(), pc++, function() {
    s.forEach(function(d) {
      var f = kr.get(d) - 1, p = i.get(d) - 1;
      kr.set(d, f), i.set(d, p), f || (hs.has(d) || d.removeAttribute(r), hs.delete(d)), p || d.removeAttribute(n);
    }), pc--, pc || (kr = /* @__PURE__ */ new WeakMap(), kr = /* @__PURE__ */ new WeakMap(), hs = /* @__PURE__ */ new WeakMap(), ps = {});
  };
}, M0 = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = Iv(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), Sv(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, sn = function() {
  return sn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, sn.apply(this, arguments);
};
function F0(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Tv(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var ks = "right-scroll-bar-position", Ls = "width-before-scroll-bar", Nv = "with-scroll-bars-hidden", Pv = "--removed-body-scroll-bar-size";
function mc(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Rv(e, t) {
  var n = Q(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Ov = typeof window < "u" ? S.useLayoutEffect : S.useEffect, MA = /* @__PURE__ */ new WeakMap();
function Dv(e, t) {
  var n = Rv(null, function(r) {
    return e.forEach(function(o) {
      return mc(o, r);
    });
  });
  return Ov(function() {
    var r = MA.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), s = n.current;
      o.forEach(function(a) {
        i.has(a) || mc(a, null);
      }), i.forEach(function(a) {
        o.has(a) || mc(a, s);
      });
    }
    MA.set(n, e);
  }, [e]), n;
}
function Mv(e) {
  return e;
}
function Fv(e, t) {
  t === void 0 && (t = Mv);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var c = function() {
        var l = s;
        s = [], l.forEach(i);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), n = {
        push: function(l) {
          s.push(l), u();
        },
        filter: function(l) {
          return s = s.filter(l), n;
        }
      };
    }
  };
  return o;
}
function Vv(e) {
  e === void 0 && (e = {});
  var t = Fv(null);
  return t.options = sn({ async: !0, ssr: !1 }, e), t;
}
var V0 = function(e) {
  var t = e.sideCar, n = F0(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return S.createElement(r, sn({}, n));
};
V0.isSideCarExport = !0;
function Bv(e, t) {
  return e.useMedium(t), V0;
}
var B0 = Vv(), gc = function() {
}, Va = S.forwardRef(function(e, t) {
  var n = S.useRef(null), r = S.useState({
    onScrollCapture: gc,
    onWheelCapture: gc,
    onTouchMoveCapture: gc
  }), o = r[0], i = r[1], s = e.forwardProps, a = e.children, c = e.className, u = e.removeScrollBar, l = e.enabled, d = e.shards, f = e.sideCar, p = e.noIsolation, h = e.inert, g = e.allowPinchZoom, m = e.as, b = m === void 0 ? "div" : m, v = e.gapMode, C = F0(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = f, y = Dv([n, t]), I = sn(sn({}, C), o);
  return S.createElement(
    S.Fragment,
    null,
    l && S.createElement(w, { sideCar: B0, removeScrollBar: u, shards: d, noIsolation: p, inert: h, setCallbacks: i, allowPinchZoom: !!g, lockRef: n, gapMode: v }),
    s ? S.cloneElement(S.Children.only(a), sn(sn({}, I), { ref: y })) : S.createElement(b, sn({}, I, { className: c, ref: y }), a)
  );
});
Va.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Va.classNames = {
  fullWidth: Ls,
  zeroRight: ks
};
var kv = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Lv() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = kv();
  return t && e.setAttribute("nonce", t), e;
}
function Hv(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Xv(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Wv = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Lv()) && (Hv(t, n), Xv(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Zv = function() {
  var e = Wv();
  return function(t, n) {
    S.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, k0 = function() {
  var e = Zv(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, zv = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, bc = function(e) {
  return parseInt(e || "", 10) || 0;
}, Gv = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [bc(n), bc(r), bc(o)];
}, jv = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return zv;
  var t = Gv(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Uv = k0(), Kr = "data-scroll-locked", Qv = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Nv, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(Kr, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ks, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Ls, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(ks, " .").concat(ks, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Ls, " .").concat(Ls, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Kr, `] {
    `).concat(Pv, ": ").concat(a, `px;
  }
`);
}, FA = function() {
  var e = parseInt(document.body.getAttribute(Kr) || "0", 10);
  return isFinite(e) ? e : 0;
}, qv = function() {
  S.useEffect(function() {
    return document.body.setAttribute(Kr, (FA() + 1).toString()), function() {
      var e = FA() - 1;
      e <= 0 ? document.body.removeAttribute(Kr) : document.body.setAttribute(Kr, e.toString());
    };
  }, []);
}, Yv = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  qv();
  var i = S.useMemo(function() {
    return jv(o);
  }, [o]);
  return S.createElement(Uv, { styles: Qv(i, !t, o, n ? "" : "!important") });
}, gu = !1;
if (typeof window < "u")
  try {
    var ms = Object.defineProperty({}, "passive", {
      get: function() {
        return gu = !0, !0;
      }
    });
    window.addEventListener("test", ms, ms), window.removeEventListener("test", ms, ms);
  } catch {
    gu = !1;
  }
var Lr = gu ? { passive: !1 } : !1, Jv = function(e) {
  return e.tagName === "TEXTAREA";
}, L0 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Jv(e) && n[t] === "visible")
  );
}, Kv = function(e) {
  return L0(e, "overflowY");
}, _v = function(e) {
  return L0(e, "overflowX");
}, VA = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = H0(e, r);
    if (o) {
      var i = X0(e, r), s = i[1], a = i[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, $v = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, e6 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, H0 = function(e, t) {
  return e === "v" ? Kv(t) : _v(t);
}, X0 = function(e, t) {
  return e === "v" ? $v(t) : e6(t);
}, t6 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, n6 = function(e, t, n, r, o) {
  var i = t6(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, c = t.contains(a), u = !1, l = s > 0, d = 0, f = 0;
  do {
    var p = X0(e, a), h = p[0], g = p[1], m = p[2], b = g - m - i * h;
    (h || b) && H0(e, a) && (d += b, f += h), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (t.contains(a) || t === a)
  );
  return (l && (Math.abs(d) < 1 || !o) || !l && (Math.abs(f) < 1 || !o)) && (u = !0), u;
}, gs = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, BA = function(e) {
  return [e.deltaX, e.deltaY];
}, kA = function(e) {
  return e && "current" in e ? e.current : e;
}, r6 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, o6 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, i6 = 0, Hr = [];
function s6(e) {
  var t = S.useRef([]), n = S.useRef([0, 0]), r = S.useRef(), o = S.useState(i6++)[0], i = S.useState(k0)[0], s = S.useRef(e);
  S.useEffect(function() {
    s.current = e;
  }, [e]), S.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = Tv([e.lockRef.current], (e.shards || []).map(kA), !0).filter(Boolean);
      return g.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = S.useCallback(function(g, m) {
    if ("touches" in g && g.touches.length === 2)
      return !s.current.allowPinchZoom;
    var b = gs(g), v = n.current, C = "deltaX" in g ? g.deltaX : v[0] - b[0], w = "deltaY" in g ? g.deltaY : v[1] - b[1], y, I = g.target, x = Math.abs(C) > Math.abs(w) ? "h" : "v";
    if ("touches" in g && x === "h" && I.type === "range")
      return !1;
    var E = VA(x, I);
    if (!E)
      return !0;
    if (E ? y = x : (y = x === "v" ? "h" : "v", E = VA(x, I)), !E)
      return !1;
    if (!r.current && "changedTouches" in g && (C || w) && (r.current = y), !y)
      return !0;
    var P = r.current || y;
    return n6(P, m, g, P === "h" ? C : w, !0);
  }, []), c = S.useCallback(function(g) {
    var m = g;
    if (!(!Hr.length || Hr[Hr.length - 1] !== i)) {
      var b = "deltaY" in m ? BA(m) : gs(m), v = t.current.filter(function(y) {
        return y.name === m.type && (y.target === m.target || m.target === y.shadowParent) && r6(y.delta, b);
      })[0];
      if (v && v.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!v) {
        var C = (s.current.shards || []).map(kA).filter(Boolean).filter(function(y) {
          return y.contains(m.target);
        }), w = C.length > 0 ? a(m, C[0]) : !s.current.noIsolation;
        w && m.cancelable && m.preventDefault();
      }
    }
  }, []), u = S.useCallback(function(g, m, b, v) {
    var C = { name: g, delta: m, target: b, should: v, shadowParent: a6(b) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(w) {
        return w !== C;
      });
    }, 1);
  }, []), l = S.useCallback(function(g) {
    n.current = gs(g), r.current = void 0;
  }, []), d = S.useCallback(function(g) {
    u(g.type, BA(g), g.target, a(g, e.lockRef.current));
  }, []), f = S.useCallback(function(g) {
    u(g.type, gs(g), g.target, a(g, e.lockRef.current));
  }, []);
  S.useEffect(function() {
    return Hr.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, Lr), document.addEventListener("touchmove", c, Lr), document.addEventListener("touchstart", l, Lr), function() {
      Hr = Hr.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", c, Lr), document.removeEventListener("touchmove", c, Lr), document.removeEventListener("touchstart", l, Lr);
    };
  }, []);
  var p = e.removeScrollBar, h = e.inert;
  return S.createElement(
    S.Fragment,
    null,
    h ? S.createElement(i, { styles: o6(o) }) : null,
    p ? S.createElement(Yv, { gapMode: e.gapMode }) : null
  );
}
function a6(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const c6 = Bv(B0, s6);
var Xl = S.forwardRef(function(e, t) {
  return S.createElement(Va, sn({}, e, { ref: t, sideCar: c6 }));
});
Xl.classNames = Va.classNames;
var bu = ["Enter", " "], u6 = ["ArrowDown", "PageUp", "Home"], W0 = ["ArrowUp", "PageDown", "End"], l6 = [...u6, ...W0], d6 = {
  ltr: [...bu, "ArrowRight"],
  rtl: [...bu, "ArrowLeft"]
}, A6 = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, _i = "Menu", [fi, f6, h6] = Jf(_i), [Pr, Z0] = Jn(_i, [
  h6,
  Oa,
  Fa
]), Ba = Oa(), z0 = Fa(), [p6, Rr] = Pr(_i), [m6, $i] = Pr(_i), G0 = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: s = !0 } = e, a = Ba(t), [c, u] = S.useState(null), l = S.useRef(!1), d = Ut(i), f = Rl(o);
  return S.useEffect(() => {
    const p = () => {
      l.current = !0, document.addEventListener("pointerdown", h, { capture: !0, once: !0 }), document.addEventListener("pointermove", h, { capture: !0, once: !0 });
    }, h = () => l.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", h, { capture: !0 }), document.removeEventListener("pointermove", h, { capture: !0 });
    };
  }, []), /* @__PURE__ */ A(C0, { ...a, children: /* @__PURE__ */ A(
    p6,
    {
      scope: t,
      open: n,
      onOpenChange: d,
      content: c,
      onContentChange: u,
      children: /* @__PURE__ */ A(
        m6,
        {
          scope: t,
          onClose: S.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: l,
          dir: f,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
G0.displayName = _i;
var g6 = "MenuAnchor", Wl = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Ba(n);
    return /* @__PURE__ */ A(x0, { ...o, ...r, ref: t });
  }
);
Wl.displayName = g6;
var Zl = "MenuPortal", [b6, j0] = Pr(Zl, {
  forceMount: void 0
}), U0 = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = Rr(Zl, t);
  return /* @__PURE__ */ A(b6, { scope: t, forceMount: n, children: /* @__PURE__ */ A(Yt, { present: n || i.open, children: /* @__PURE__ */ A(Da, { asChild: !0, container: o, children: r }) }) });
};
U0.displayName = Zl;
var Ft = "MenuContent", [v6, zl] = Pr(Ft), Q0 = S.forwardRef(
  (e, t) => {
    const n = j0(Ft, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = Rr(Ft, e.__scopeMenu), s = $i(Ft, e.__scopeMenu);
    return /* @__PURE__ */ A(fi.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ A(Yt, { present: r || i.open, children: /* @__PURE__ */ A(fi.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ A(y6, { ...o, ref: t }) : /* @__PURE__ */ A(C6, { ...o, ref: t }) }) }) });
  }
), y6 = S.forwardRef(
  (e, t) => {
    const n = Rr(Ft, e.__scopeMenu), r = S.useRef(null), o = _e(t, r);
    return S.useEffect(() => {
      const i = r.current;
      if (i) return M0(i);
    }, []), /* @__PURE__ */ A(
      Gl,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: he(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), C6 = S.forwardRef((e, t) => {
  const n = Rr(Ft, e.__scopeMenu);
  return /* @__PURE__ */ A(
    Gl,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Gl = S.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: a,
      onEntryFocus: c,
      onEscapeKeyDown: u,
      onPointerDownOutside: l,
      onFocusOutside: d,
      onInteractOutside: f,
      onDismiss: p,
      disableOutsideScroll: h,
      ...g
    } = e, m = Rr(Ft, n), b = $i(Ft, n), v = Ba(n), C = z0(n), w = f6(n), [y, I] = S.useState(null), x = S.useRef(null), E = _e(t, x, m.onContentChange), P = S.useRef(0), L = S.useRef(""), W = S.useRef(0), V = S.useRef(null), X = S.useRef("right"), N = S.useRef(0), M = h ? Xl : S.Fragment, F = h ? { as: bo, allowPinchZoom: !0 } : void 0, B = (H) => {
      var me, Te;
      const K = L.current + H, ee = w().filter((Be) => !Be.disabled), z = document.activeElement, ce = (me = ee.find((Be) => Be.ref.current === z)) == null ? void 0 : me.textValue, be = ee.map((Be) => Be.textValue), te = M6(be, K, ce), ue = (Te = ee.find((Be) => Be.textValue === te)) == null ? void 0 : Te.ref.current;
      (function Be(et) {
        L.current = et, window.clearTimeout(P.current), et !== "" && (P.current = window.setTimeout(() => Be(""), 1e3));
      })(K), ue && setTimeout(() => ue.focus());
    };
    S.useEffect(() => () => window.clearTimeout(P.current), []), $f();
    const Z = S.useCallback((H) => {
      var ee, z;
      return X.current === ((ee = V.current) == null ? void 0 : ee.side) && V6(H, (z = V.current) == null ? void 0 : z.area);
    }, []);
    return /* @__PURE__ */ A(
      v6,
      {
        scope: n,
        searchRef: L,
        onItemEnter: S.useCallback(
          (H) => {
            Z(H) && H.preventDefault();
          },
          [Z]
        ),
        onItemLeave: S.useCallback(
          (H) => {
            var K;
            Z(H) || ((K = x.current) == null || K.focus(), I(null));
          },
          [Z]
        ),
        onTriggerLeave: S.useCallback(
          (H) => {
            Z(H) && H.preventDefault();
          },
          [Z]
        ),
        pointerGraceTimerRef: W,
        onPointerGraceIntentChange: S.useCallback((H) => {
          V.current = H;
        }, []),
        children: /* @__PURE__ */ A(M, { ...F, children: /* @__PURE__ */ A(
          Ol,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: he(i, (H) => {
              var K;
              H.preventDefault(), (K = x.current) == null || K.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ A(
              Na,
              {
                asChild: !0,
                disableOutsidePointerEvents: a,
                onEscapeKeyDown: u,
                onPointerDownOutside: l,
                onFocusOutside: d,
                onInteractOutside: f,
                onDismiss: p,
                children: /* @__PURE__ */ A(
                  R0,
                  {
                    asChild: !0,
                    ...C,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: y,
                    onCurrentTabStopIdChange: I,
                    onEntryFocus: he(c, (H) => {
                      b.isUsingKeyboardRef.current || H.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ A(
                      w0,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": uh(m.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...v,
                        ...g,
                        ref: E,
                        style: { outline: "none", ...g.style },
                        onKeyDown: he(g.onKeyDown, (H) => {
                          const ee = H.target.closest("[data-radix-menu-content]") === H.currentTarget, z = H.ctrlKey || H.altKey || H.metaKey, ce = H.key.length === 1;
                          ee && (H.key === "Tab" && H.preventDefault(), !z && ce && B(H.key));
                          const be = x.current;
                          if (H.target !== be || !l6.includes(H.key)) return;
                          H.preventDefault();
                          const ue = w().filter((me) => !me.disabled).map((me) => me.ref.current);
                          W0.includes(H.key) && ue.reverse(), O6(ue);
                        }),
                        onBlur: he(e.onBlur, (H) => {
                          H.currentTarget.contains(H.target) || (window.clearTimeout(P.current), L.current = "");
                        }),
                        onPointerMove: he(
                          e.onPointerMove,
                          hi((H) => {
                            const K = H.target, ee = N.current !== H.clientX;
                            if (H.currentTarget.contains(K) && ee) {
                              const z = H.clientX > N.current ? "right" : "left";
                              X.current = z, N.current = H.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Q0.displayName = Ft;
var x6 = "MenuGroup", jl = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ A(Xe.div, { role: "group", ...r, ref: t });
  }
);
jl.displayName = x6;
var w6 = "MenuLabel", q0 = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ A(Xe.div, { ...r, ref: t });
  }
);
q0.displayName = w6;
var ea = "MenuItem", LA = "menu.itemSelect", ka = S.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = S.useRef(null), s = $i(ea, e.__scopeMenu), a = zl(ea, e.__scopeMenu), c = _e(t, i), u = S.useRef(!1), l = () => {
      const d = i.current;
      if (!n && d) {
        const f = new CustomEvent(LA, { bubbles: !0, cancelable: !0 });
        d.addEventListener(LA, (p) => r == null ? void 0 : r(p), { once: !0 }), Yf(d, f), f.defaultPrevented ? u.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ A(
      Y0,
      {
        ...o,
        ref: c,
        disabled: n,
        onClick: he(e.onClick, l),
        onPointerDown: (d) => {
          var f;
          (f = e.onPointerDown) == null || f.call(e, d), u.current = !0;
        },
        onPointerUp: he(e.onPointerUp, (d) => {
          var f;
          u.current || (f = d.currentTarget) == null || f.click();
        }),
        onKeyDown: he(e.onKeyDown, (d) => {
          const f = a.searchRef.current !== "";
          n || f && d.key === " " || bu.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
ka.displayName = ea;
var Y0 = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, s = zl(ea, n), a = z0(n), c = S.useRef(null), u = _e(t, c), [l, d] = S.useState(!1), [f, p] = S.useState("");
    return S.useEffect(() => {
      const h = c.current;
      h && p((h.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ A(
      fi.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? f,
        children: /* @__PURE__ */ A(O0, { asChild: !0, ...a, focusable: !r, children: /* @__PURE__ */ A(
          Xe.div,
          {
            role: "menuitem",
            "data-highlighted": l ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: u,
            onPointerMove: he(
              e.onPointerMove,
              hi((h) => {
                r ? s.onItemLeave(h) : (s.onItemEnter(h), h.defaultPrevented || h.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: he(
              e.onPointerLeave,
              hi((h) => s.onItemLeave(h))
            ),
            onFocus: he(e.onFocus, () => d(!0)),
            onBlur: he(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), I6 = "MenuCheckboxItem", J0 = S.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ A(th, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ A(
      ka,
      {
        role: "menuitemcheckbox",
        "aria-checked": ta(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": Ql(n),
        onSelect: he(
          o.onSelect,
          () => r == null ? void 0 : r(ta(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
J0.displayName = I6;
var K0 = "MenuRadioGroup", [E6, S6] = Pr(
  K0,
  { value: void 0, onValueChange: () => {
  } }
), _0 = S.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = Ut(r);
    return /* @__PURE__ */ A(E6, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ A(jl, { ...o, ref: t }) });
  }
);
_0.displayName = K0;
var $0 = "MenuRadioItem", eh = S.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = S6($0, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ A(th, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ A(
      ka,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": Ql(i),
        onSelect: he(
          r.onSelect,
          () => {
            var s;
            return (s = o.onValueChange) == null ? void 0 : s.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
eh.displayName = $0;
var Ul = "MenuItemIndicator", [th, T6] = Pr(
  Ul,
  { checked: !1 }
), nh = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = T6(Ul, n);
    return /* @__PURE__ */ A(
      Yt,
      {
        present: r || ta(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ A(
          Xe.span,
          {
            ...o,
            ref: t,
            "data-state": Ql(i.checked)
          }
        )
      }
    );
  }
);
nh.displayName = Ul;
var N6 = "MenuSeparator", rh = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ A(
      Xe.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
rh.displayName = N6;
var P6 = "MenuArrow", oh = S.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Ba(n);
    return /* @__PURE__ */ A(I0, { ...o, ...r, ref: t });
  }
);
oh.displayName = P6;
var R6 = "MenuSub", [vM, ih] = Pr(R6), ti = "MenuSubTrigger", sh = S.forwardRef(
  (e, t) => {
    const n = Rr(ti, e.__scopeMenu), r = $i(ti, e.__scopeMenu), o = ih(ti, e.__scopeMenu), i = zl(ti, e.__scopeMenu), s = S.useRef(null), { pointerGraceTimerRef: a, onPointerGraceIntentChange: c } = i, u = { __scopeMenu: e.__scopeMenu }, l = S.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return S.useEffect(() => l, [l]), S.useEffect(() => {
      const d = a.current;
      return () => {
        window.clearTimeout(d), c(null);
      };
    }, [a, c]), /* @__PURE__ */ A(Wl, { asChild: !0, ...u, children: /* @__PURE__ */ A(
      Y0,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": uh(n.open),
        ...e,
        ref: Ta(t, o.onTriggerChange),
        onClick: (d) => {
          var f;
          (f = e.onClick) == null || f.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: he(
          e.onPointerMove,
          hi((d) => {
            i.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !s.current && (i.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), l();
            }, 100));
          })
        ),
        onPointerLeave: he(
          e.onPointerLeave,
          hi((d) => {
            var p, h;
            l();
            const f = (p = n.content) == null ? void 0 : p.getBoundingClientRect();
            if (f) {
              const g = (h = n.content) == null ? void 0 : h.dataset.side, m = g === "right", b = m ? -5 : 5, v = f[m ? "left" : "right"], C = f[m ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + b, y: d.clientY },
                  { x: v, y: f.top },
                  { x: C, y: f.top },
                  { x: C, y: f.bottom },
                  { x: v, y: f.bottom }
                ],
                side: g
              }), window.clearTimeout(a.current), a.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(d), d.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: he(e.onKeyDown, (d) => {
          var p;
          const f = i.searchRef.current !== "";
          e.disabled || f && d.key === " " || d6[r.dir].includes(d.key) && (n.onOpenChange(!0), (p = n.content) == null || p.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
sh.displayName = ti;
var ah = "MenuSubContent", ch = S.forwardRef(
  (e, t) => {
    const n = j0(Ft, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = Rr(Ft, e.__scopeMenu), s = $i(Ft, e.__scopeMenu), a = ih(ah, e.__scopeMenu), c = S.useRef(null), u = _e(t, c);
    return /* @__PURE__ */ A(fi.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ A(Yt, { present: r || i.open, children: /* @__PURE__ */ A(fi.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ A(
      Gl,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...o,
        ref: u,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (l) => {
          var d;
          s.isUsingKeyboardRef.current && ((d = c.current) == null || d.focus()), l.preventDefault();
        },
        onCloseAutoFocus: (l) => l.preventDefault(),
        onFocusOutside: he(e.onFocusOutside, (l) => {
          l.target !== a.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: he(e.onEscapeKeyDown, (l) => {
          s.onClose(), l.preventDefault();
        }),
        onKeyDown: he(e.onKeyDown, (l) => {
          var p;
          const d = l.currentTarget.contains(l.target), f = A6[s.dir].includes(l.key);
          d && f && (i.onOpenChange(!1), (p = a.trigger) == null || p.focus(), l.preventDefault());
        })
      }
    ) }) }) });
  }
);
ch.displayName = ah;
function uh(e) {
  return e ? "open" : "closed";
}
function ta(e) {
  return e === "indeterminate";
}
function Ql(e) {
  return ta(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function O6(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function D6(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function M6(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = D6(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((u) => u !== n));
  const c = s.find(
    (u) => u.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function F6(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const a = t[i].x, c = t[i].y, u = t[s].x, l = t[s].y;
    c > r != l > r && n < (u - a) * (r - c) / (l - c) + a && (o = !o);
  }
  return o;
}
function V6(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return F6(n, t);
}
function hi(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var B6 = G0, k6 = Wl, L6 = U0, H6 = Q0, X6 = jl, W6 = q0, Z6 = ka, z6 = J0, G6 = _0, j6 = eh, U6 = nh, Q6 = rh, q6 = oh, Y6 = sh, J6 = ch, ql = "DropdownMenu", [K6, yM] = Jn(
  ql,
  [Z0]
), pt = Z0(), [_6, lh] = K6(ql), dh = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: i,
    onOpenChange: s,
    modal: a = !0
  } = e, c = pt(t), u = S.useRef(null), [l = !1, d] = Ji({
    prop: o,
    defaultProp: i,
    onChange: s
  });
  return /* @__PURE__ */ A(
    _6,
    {
      scope: t,
      triggerId: Xn(),
      triggerRef: u,
      contentId: Xn(),
      open: l,
      onOpenChange: d,
      onOpenToggle: S.useCallback(() => d((f) => !f), [d]),
      modal: a,
      children: /* @__PURE__ */ A(B6, { ...c, open: l, onOpenChange: d, dir: r, modal: a, children: n })
    }
  );
};
dh.displayName = ql;
var Ah = "DropdownMenuTrigger", fh = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = lh(Ah, n), s = pt(n);
    return /* @__PURE__ */ A(k6, { asChild: !0, ...s, children: /* @__PURE__ */ A(
      Xe.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: Ta(t, i.triggerRef),
        onPointerDown: he(e.onPointerDown, (a) => {
          !r && a.button === 0 && a.ctrlKey === !1 && (i.onOpenToggle(), i.open || a.preventDefault());
        }),
        onKeyDown: he(e.onKeyDown, (a) => {
          r || (["Enter", " "].includes(a.key) && i.onOpenToggle(), a.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(a.key) && a.preventDefault());
        })
      }
    ) });
  }
);
fh.displayName = Ah;
var $6 = "DropdownMenuPortal", hh = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = pt(t);
  return /* @__PURE__ */ A(L6, { ...r, ...n });
};
hh.displayName = $6;
var ph = "DropdownMenuContent", mh = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = lh(ph, n), i = pt(n), s = S.useRef(!1);
    return /* @__PURE__ */ A(
      H6,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: he(e.onCloseAutoFocus, (a) => {
          var c;
          s.current || (c = o.triggerRef.current) == null || c.focus(), s.current = !1, a.preventDefault();
        }),
        onInteractOutside: he(e.onInteractOutside, (a) => {
          const c = a.detail.originalEvent, u = c.button === 0 && c.ctrlKey === !0, l = c.button === 2 || u;
          (!o.modal || l) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
mh.displayName = ph;
var e5 = "DropdownMenuGroup", t5 = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = pt(n);
    return /* @__PURE__ */ A(X6, { ...o, ...r, ref: t });
  }
);
t5.displayName = e5;
var n5 = "DropdownMenuLabel", gh = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = pt(n);
    return /* @__PURE__ */ A(W6, { ...o, ...r, ref: t });
  }
);
gh.displayName = n5;
var r5 = "DropdownMenuItem", bh = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = pt(n);
    return /* @__PURE__ */ A(Z6, { ...o, ...r, ref: t });
  }
);
bh.displayName = r5;
var o5 = "DropdownMenuCheckboxItem", i5 = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = pt(n);
  return /* @__PURE__ */ A(z6, { ...o, ...r, ref: t });
});
i5.displayName = o5;
var s5 = "DropdownMenuRadioGroup", a5 = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = pt(n);
  return /* @__PURE__ */ A(G6, { ...o, ...r, ref: t });
});
a5.displayName = s5;
var c5 = "DropdownMenuRadioItem", u5 = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = pt(n);
  return /* @__PURE__ */ A(j6, { ...o, ...r, ref: t });
});
u5.displayName = c5;
var l5 = "DropdownMenuItemIndicator", d5 = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = pt(n);
  return /* @__PURE__ */ A(U6, { ...o, ...r, ref: t });
});
d5.displayName = l5;
var A5 = "DropdownMenuSeparator", f5 = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = pt(n);
  return /* @__PURE__ */ A(Q6, { ...o, ...r, ref: t });
});
f5.displayName = A5;
var h5 = "DropdownMenuArrow", p5 = S.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = pt(n);
    return /* @__PURE__ */ A(q6, { ...o, ...r, ref: t });
  }
);
p5.displayName = h5;
var m5 = "DropdownMenuSubTrigger", g5 = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = pt(n);
  return /* @__PURE__ */ A(Y6, { ...o, ...r, ref: t });
});
g5.displayName = m5;
var b5 = "DropdownMenuSubContent", v5 = S.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = pt(n);
  return /* @__PURE__ */ A(
    J6,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
v5.displayName = b5;
var y5 = dh, C5 = fh, x5 = hh, w5 = mh, I5 = gh, E5 = bh;
const vh = y5, yh = C5, Ch = Pt(function({ children: t, ...n }, r) {
  return /* @__PURE__ */ A(x5, { children: /* @__PURE__ */ A(w5, { ...n, ref: r, children: t }) });
}), CM = I5, xh = E5;
function J({ name: e, size: t = 24, color: n, style: r, ...o }) {
  const i = Xh(t), s = {
    color: n,
    ...i,
    style: r
  }, a = t9[e];
  return /* @__PURE__ */ A(a, { ...o, style: s });
}
function S5(e) {
  const t = ["document-editor", `${e.mode}-mode`];
  return /* @__PURE__ */ A("div", { className: t.join(" "), children: e.children });
}
function T5(e) {
  const t = e.left || [], n = e.center || [], r = e.right || [];
  return /* @__PURE__ */ R("div", { className: "editor-toolbar", children: [
    /* @__PURE__ */ A("div", { className: "editor-toolbar--column editor-toolbar--left", children: t }),
    /* @__PURE__ */ A("div", { className: "editor-toolbar--column editor-toolbar--center", children: n }),
    /* @__PURE__ */ A("div", { className: "editor-toolbar--column editor-toolbar--right", children: r })
  ] });
}
function N5(e) {
  return /* @__PURE__ */ A("div", { className: "editor-worksheet", children: /* @__PURE__ */ A("div", { className: "editor-worksheet--page", children: e.children }) });
}
const wh = {
  light: {
    color: "#222222",
    bgColor: "#FFFFFF",
    border: "#EEEEEE",
    shadow: "rgba(128,128,128,0.65)",
    inputColor: "#222222",
    inputBg: "#F6F6F6"
  },
  dark: {
    color: "#E6E6E6",
    bgColor: "#181818",
    border: "#181818",
    shadow: "rgba(0, 0, 0, 0.25)",
    inputColor: "#E6E6E6",
    inputBg: "#222222"
  }
}, Ih = {
  huge: {
    fontSize: "36pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "30pt 0 0 0"
  },
  larger: {
    fontSize: "24pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "18pt 0 0 0"
  },
  large: {
    fontSize: "18pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "12pt 0 0 0"
  },
  medium: {
    fontSize: "11pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "5pt 0 0 0"
  },
  small: {
    fontSize: "10pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "0"
  },
  smaller: {
    fontSize: "9pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "0"
  },
  tiny: {
    fontSize: "8pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "0"
  }
}, vu = (e = "light", t = !1) => {
  const n = wh[e];
  return {
    width: "100%",
    border: "none",
    boxSizing: "border-box",
    backgroundColor: t ? n.inputBg : n.bgColor,
    outline: "none",
    color: n.inputColor,
    resize: "none",
    fontFamily: "Roboto, sans-serif",
    overflow: "hidden",
    lineHeight: "1.5"
  };
}, P5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  colorScheme: wh,
  inputStyle: vu,
  typographySizes: Ih
}, Symbol.toStringTag, { value: "Module" })), Eh = {
  light: {
    color: "#222222",
    bgColor: "#FFFFFF",
    border: "#EEEEEE",
    shadow: "rgba(128,128,128,0.65)",
    inputColor: "#222222",
    inputBg: "#F6F6F6"
  },
  dark: {
    color: "#CCCCCC",
    bgColor: "#0A0A0A",
    border: "#181818",
    shadow: "rgba(255, 255, 255, 0.25)",
    inputColor: "#CCCCCC",
    inputBg: "#1A1D1F"
  }
}, Sh = {
  chapter: {
    fontSize: "64pt",
    fontWeight: "bold",
    padding: "6pt 24pt",
    margin: "0",
    lineHeight: 1,
    textAlign: "right",
    borderLeft: "4px solid"
  },
  huge: {
    fontSize: "32pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "0 0 0 -6pt",
    lineHeight: 1
  },
  larger: {
    fontSize: "24pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "-12pt 0 0 0"
  },
  large: {
    fontSize: "18pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "-10.5pt 0 0 0"
  },
  medium: {
    fontSize: "11pt",
    fontWeight: "bold",
    padding: "6pt",
    margin: "-8pt 0 0 0"
  },
  small: {
    fontSize: "10pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "-6pt 0 0 0"
  },
  smaller: {
    fontSize: "9pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "-5pt 0 0 0"
  },
  tiny: {
    fontSize: "8pt",
    fontWeight: "normal",
    padding: "6pt",
    margin: "-8pt 0 0 0"
  }
}, yu = (e = "light", t = !1) => {
  const n = Eh[e];
  return {
    width: "100%",
    border: "none",
    boxSizing: "border-box",
    backgroundColor: t ? n.inputBg : n.bgColor,
    outline: "none",
    color: n.inputColor,
    resize: "none",
    fontFamily: "Roboto, sans-serif",
    overflow: "hidden",
    lineHeight: "1.5"
  };
}, R5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  colorScheme: Eh,
  inputStyle: yu,
  typographySizes: Sh
}, Symbol.toStringTag, { value: "Module" }));
function O5(e) {
  const [t, n] = Q({
    value: e.value || "",
    hasFocus: !1,
    pressingEnter: !1
  });
  Ie(() => {
    n({ ...t, value: e.value || "" });
  }, [e]);
  const r = (u) => {
    u.key === "Enter" && (n({ ...t, pressingEnter: !0 }), u.preventDefault());
  }, o = (u) => {
    u.key === "Enter" && (e.onSubmit && e.onSubmit(u.target.value), e.clearOnSubmit ? n({ ...t, value: "", pressingEnter: !1 }) : n({ ...t, pressingEnter: !1 }), u.preventDefault()), (u.key === "Backspace" || u.key === "Delete") && (e.onEmpty && u.target.value.length < 1 && e.onEmpty(e.id || ""), u.preventDefault());
  }, i = (u) => {
    if (!t.pressingEnter) {
      const l = u.target;
      n({ ...t, value: l.value }), l.style.height = "1px", l.style.height = l.scrollHeight + "px";
    }
  }, s = (u) => {
    var l;
    if (n({ ...t, hasFocus: u }), !u) {
      const d = ((l = a.current) == null ? void 0 : l.value) || "", f = e.value || "";
      d !== f && e.onSubmit && e.onSubmit(d);
    }
  }, a = Ce(null);
  Ie(() => {
    const u = () => {
      a.current && (a.current.style.height = "1px", a.current.style.height = a.current.scrollHeight + "px");
    };
    return window.addEventListener("resize", u), u(), () => {
      window.removeEventListener("resize", u);
    };
  });
  const c = {
    ...vu(e.theme, t.hasFocus),
    ...Ih[e.size || "small"]
  };
  return /* @__PURE__ */ R("div", { children: [
    e.horizontalLine ? /* @__PURE__ */ A(
      "hr",
      {
        style: {
          borderColor: vu(e.theme, !1).backgroundColor
        }
      },
      "line"
    ) : "",
    /* @__PURE__ */ A(
      "textarea",
      {
        ref: a,
        placeholder: e.placeholder || "",
        autoFocus: e.autoFocus || !1,
        onInput: i,
        onKeyDown: r,
        onKeyUp: o,
        style: c,
        value: t.value,
        onFocus: () => s(!0),
        onBlur: () => s(!1)
      },
      "text"
    )
  ] });
}
function D5(e) {
  const [t, n] = Q({
    value: e.value || "",
    hasFocus: !1,
    pressingEnter: !1
  });
  Ie(() => {
    n({ ...t, value: e.value || "" });
  }, [e.value]);
  const r = (u) => {
    u.key === "Enter" && (n({ ...t, pressingEnter: !0 }), u.preventDefault());
  }, o = (u) => {
    u.key === "Enter" && (e.onSubmit && e.onSubmit(u.target.value), e.clearOnSubmit ? n({ ...t, value: "", pressingEnter: !1 }) : n({ ...t, pressingEnter: !1 }), u.preventDefault()), (u.key === "Backspace" || u.key === "Delete") && (e.onEmpty && u.target.value.length < 1 && e.onEmpty(e.id || ""), u.preventDefault());
  }, i = (u) => {
    if (!t.pressingEnter) {
      const l = u.target;
      n({ ...t, value: l.value }), l.style.height = "1px", l.style.height = `${l.scrollHeight}px`;
    }
  }, s = (u) => {
    var l;
    if (n({ ...t, hasFocus: u }), !u) {
      const d = ((l = a.current) == null ? void 0 : l.value) || "", f = e.value || "";
      d !== f && e.onSubmit && e.onSubmit(d);
    }
  }, a = Ce(null);
  Ie(() => {
    const u = () => {
      a.current && (a.current.style.height = "1px", a.current.style.height = `${a.current.scrollHeight}px`);
    };
    return window.addEventListener("resize", u), u(), () => {
      window.removeEventListener("resize", u);
    };
  });
  const c = {
    ...yu(e.theme, t.hasFocus),
    ...Sh[e.size || "small"]
  };
  return e.labelStyle && (c.textAlign = "center", c.textTransform = "uppercase", c.backgroundColor = "rgba(0, 0, 255, 0.05)", c.borderRadius = "8px", c.padding = "1px 0 4px 0", c.margin = "0", c.fontWeight = "bold", c.fontSize = "8pt", c.color = "#518EBE", c.border = "2px solid #518EBE", c.cursor = "pointer", c.lineHeight = "1.5"), /* @__PURE__ */ R("div", { children: [
    e.horizontalLine ? /* @__PURE__ */ A(
      "hr",
      {
        style: {
          borderColor: yu(e.theme, !1).backgroundColor
        }
      },
      "line"
    ) : "",
    /* @__PURE__ */ A(
      "textarea",
      {
        ref: a,
        placeholder: e.placeholder || "",
        autoFocus: e.autoFocus || !1,
        onInput: i,
        onKeyDown: r,
        onKeyUp: o,
        style: c,
        value: t.value,
        onFocus: () => s(!0),
        onBlur: () => s(!1),
        tabIndex: e.labelStyle ? -1 : 1,
        spellCheck: t.hasFocus
      },
      "text"
    )
  ] });
}
function M5(e) {
  const t = e.onClick || (() => {
    console.log("No onClick handler attached to button.");
  });
  return /* @__PURE__ */ A(
    "div",
    {
      onClick: t,
      className: "toolbar-button",
      style: { userSelect: "none" },
      children: e.children
    }
  );
}
const xM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DocumentEditor: S5,
  EditorToolbar: T5,
  EditorWorksheet: N5,
  TextInput: O5,
  TextInputVariant: D5,
  ToolbarButton: M5,
  styles: P5,
  stylesVariant: R5
}, Symbol.toStringTag, { value: "Module" }));
var Yl = "Dialog", [Th, wM] = Jn(Yl), [F5, Jt] = Th(Yl), Nh = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, a = S.useRef(null), c = S.useRef(null), [u = !1, l] = Ji({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ A(
    F5,
    {
      scope: t,
      triggerRef: a,
      contentRef: c,
      contentId: Xn(),
      titleId: Xn(),
      descriptionId: Xn(),
      open: u,
      onOpenChange: l,
      onOpenToggle: S.useCallback(() => l((d) => !d), [l]),
      modal: s,
      children: n
    }
  );
};
Nh.displayName = Yl;
var Ph = "DialogTrigger", V5 = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Jt(Ph, n), i = _e(t, o.triggerRef);
    return /* @__PURE__ */ A(
      Xe.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": _l(o.open),
        ...r,
        ref: i,
        onClick: he(e.onClick, o.onOpenToggle)
      }
    );
  }
);
V5.displayName = Ph;
var Jl = "DialogPortal", [B5, Rh] = Th(Jl, {
  forceMount: void 0
}), Oh = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = Jt(Jl, t);
  return /* @__PURE__ */ A(B5, { scope: t, forceMount: n, children: S.Children.map(r, (s) => /* @__PURE__ */ A(Yt, { present: n || i.open, children: /* @__PURE__ */ A(Da, { asChild: !0, container: o, children: s }) })) });
};
Oh.displayName = Jl;
var na = "DialogOverlay", Dh = S.forwardRef(
  (e, t) => {
    const n = Rh(na, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Jt(na, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ A(Yt, { present: r || i.open, children: /* @__PURE__ */ A(k5, { ...o, ref: t }) }) : null;
  }
);
Dh.displayName = na;
var k5 = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Jt(na, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ A(Xl, { as: bo, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ A(
        Xe.div,
        {
          "data-state": _l(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), vr = "DialogContent", Mh = S.forwardRef(
  (e, t) => {
    const n = Rh(vr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Jt(vr, e.__scopeDialog);
    return /* @__PURE__ */ A(Yt, { present: r || i.open, children: i.modal ? /* @__PURE__ */ A(L5, { ...o, ref: t }) : /* @__PURE__ */ A(H5, { ...o, ref: t }) });
  }
);
Mh.displayName = vr;
var L5 = S.forwardRef(
  (e, t) => {
    const n = Jt(vr, e.__scopeDialog), r = S.useRef(null), o = _e(t, n.contentRef, r);
    return S.useEffect(() => {
      const i = r.current;
      if (i) return M0(i);
    }, []), /* @__PURE__ */ A(
      Fh,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: he(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: he(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && i.preventDefault();
        }),
        onFocusOutside: he(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), H5 = S.forwardRef(
  (e, t) => {
    const n = Jt(vr, e.__scopeDialog), r = S.useRef(!1), o = S.useRef(!1);
    return /* @__PURE__ */ A(
      Fh,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var c, u;
          (c = e.onInteractOutside) == null || c.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), Fh = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, a = Jt(vr, n), c = S.useRef(null), u = _e(t, c);
    return $f(), /* @__PURE__ */ R(Ee, { children: [
      /* @__PURE__ */ A(
        Ol,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ A(
            Na,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": _l(a.open),
              ...s,
              ref: u,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ R(Ee, { children: [
        /* @__PURE__ */ A(z5, { titleId: a.titleId }),
        /* @__PURE__ */ A(j5, { contentRef: c, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), Kl = "DialogTitle", X5 = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Jt(Kl, n);
    return /* @__PURE__ */ A(Xe.h2, { id: o.titleId, ...r, ref: t });
  }
);
X5.displayName = Kl;
var Vh = "DialogDescription", W5 = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Jt(Vh, n);
    return /* @__PURE__ */ A(Xe.p, { id: o.descriptionId, ...r, ref: t });
  }
);
W5.displayName = Vh;
var Bh = "DialogClose", Z5 = S.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Jt(Bh, n);
    return /* @__PURE__ */ A(
      Xe.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: he(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Z5.displayName = Bh;
function _l(e) {
  return e ? "open" : "closed";
}
var kh = "DialogTitleWarning", [IM, Lh] = F9(kh, {
  contentName: vr,
  titleName: Kl,
  docsSlug: "dialog"
}), z5 = ({ titleId: e }) => {
  const t = Lh(kh), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return S.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, G5 = "DialogDescriptionWarning", j5 = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Lh(G5).contentName}}.`;
  return S.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, U5 = Nh, Q5 = Oh, q5 = Dh, Y5 = Mh;
function wn(e) {
  const {
    open: t,
    onOpenChange: n,
    contentProps: r,
    overlayProps: o,
    children: i,
    ...s
  } = e;
  return /* @__PURE__ */ A(U5, { open: t, defaultOpen: t, onOpenChange: n, children: /* @__PURE__ */ A(Q5, { children: /* @__PURE__ */ A(
    q5,
    {
      ...o,
      className: $(
        "fixed inset-0 grid place-items-center overflow-y-auto bg-slate-900/50 data-[state=closed]:animate-fade-out data-[state=open]:animate-fade-in",
        o == null ? void 0 : o.className
      ),
      children: /* @__PURE__ */ A(
        Y5,
        {
          ...s,
          ...r,
          className: $(
            "bg-white data-[state=closed]:animate-zoom-out data-[state=open]:animate-zoom-in",
            r == null ? void 0 : r.className
          ),
          children: i
        }
      )
    }
  ) }) });
}
function J5({ className: e, ...t }) {
  return /* @__PURE__ */ A("div", { className: $("flex-shrink-0", e), ...t });
}
function K5({ className: e, ...t }) {
  return /* @__PURE__ */ A("div", { className: $("flex-shrink-0", e), ...t });
}
const _5 = ({
  collapsed: e = !1,
  maxWidth: t = "304px",
  minWidth: n = "80px",
  className: r,
  children: o,
  ...i
}) => {
  const s = Ce(null), [a, c] = Q(
    e ? "collapsed" : "expanded"
  );
  return $l(s, ["collapsing", "expanding"].includes(a), () => {
    c(
      (u) => u === "collapsing" ? "collapsed" : u === "expanding" ? "expanded" : u
    );
  }), Ie(() => {
    e && a !== "collapsed" ? c("collapsing") : !e && a !== "expanded" && c("expanding");
  }, [e]), /* @__PURE__ */ A(
    "div",
    {
      ...i,
      ref: s,
      className: $(
        ` group ${a} flex
                 h-full flex-col overflow-hidden transition-none duration-300`,
        r,
        ["collapsing", "expanding"].includes(a) && "animate-out fade-out",
        ["collapsed", "expanded"].includes(a) && "animate-in fade-in",
        a === "collapsed" && "bg-transparent shadow-none",
        a === "expanded" && "shadow-sidebar"
      ),
      style: {
        width: ["collapsed", "expanding"].includes(a) ? n : t
      },
      children: o
    }
  );
};
function $5({
  className: e,
  children: t,
  ...n
}) {
  const [r, o] = Q(!1);
  function i(a) {
    o(
      a.scrollHeight - a.scrollTop - a.clientHeight > 1
    );
  }
  const s = Ce(null);
  return Ie(() => {
    if (!s.current)
      return;
    const a = new ResizeObserver(
      (c) => {
        const u = c.pop();
        if (!u)
          return;
        const { target: l } = u;
        i(l);
      }
    );
    return a.observe(s.current), () => {
      a.disconnect();
    };
  }, [s.current]), /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      "div",
      {
        className: $(
          "no-scrollbar flex-1 overflow-auto text-gray-900 transition-shadow",
          e
        ),
        ref: s,
        onScroll: (a) => i(a.currentTarget),
        ...n,
        children: t
      }
    ),
    r && /* @__PURE__ */ A(
      "div",
      {
        className: "pointer-events-none z-10 -mt-12 h-12 w-full",
        style: {
          boxShadow: "inset 0px -33px 32px -16px rgba(0,0,0,0.1)"
        }
      }
    )
  ] });
}
function EM(e, t = !0) {
  const [n, r] = Q(!0);
  return $l(
    e,
    n && t,
    ye(() => r(!1), [])
  ), n && t;
}
function SM(e, t) {
  const [n, r] = Q(!1), [o, i] = Q("idle");
  return !t && e.current && o === "idle" && (r(!0), i("exiting")), !e.current && o === "exited" && i("idle"), $l(
    e,
    n,
    ye(() => {
      i("exited"), r(!1);
    }, [])
  ), n;
}
function $l(e, t, n) {
  const r = Ce(null);
  t && e.current && (r.current = window.getComputedStyle(e.current).animation), Yn(() => {
    if (t && e.current) {
      const o = window.getComputedStyle(e.current);
      if (o.animationName !== "none" && o.animation !== r.current) {
        const i = (a) => {
          a.target === e.current && (s.removeEventListener(
            "animationend",
            i
          ), Zf.flushSync(() => {
            n();
          }));
        }, s = e.current;
        return s.addEventListener("animationend", i), () => {
          s.removeEventListener("animationend", i);
        };
      } else
        n();
    }
  }, [e, t, n]);
}
function e4(e, t) {
  return (n, r) => {
    try {
      return e(n, r);
    } catch (o) {
      return t == null || t(o), n;
    }
  };
}
function TM(e, t) {
  return (n, r) => t4(e, t(n), r);
}
function t4(e, t, n) {
  const [r, o] = z3(
    e4(e, n),
    t
  );
  return [r, o];
}
function Hh(e) {
  return Pt(e);
}
function Xh(e) {
  return e ? typeof e == "number" ? {
    width: e.toString() + "px",
    height: e.toString() + "px"
  } : {
    width: e,
    height: e
  } : {};
}
function gn(e, t) {
  const { className: n, ...r } = e;
  return {
    className: $(
      t,
      typeof n == "string" && n
    ),
    ...r
  };
}
function n4(e) {
  const { style: t, size: n = 250, alt: r = "Loading...", ...o } = e, s = {
    objectFit: "contain",
    ...Xh(n),
    ...t
  };
  return /* @__PURE__ */ A(
    "img",
    {
      ...o,
      src: n9,
      alt: r,
      style: s
    }
  );
}
function NM(e) {
  const {
    selectedNodePath: t,
    isAllowedToCreateDocuments: n,
    onAddAndSelectNewFolder: r
  } = e, [o, i] = Q(!1);
  function s() {
    i(!0);
  }
  async function a(u) {
    await r(u), i(!1);
  }
  function c() {
    i(!1);
  }
  return /* @__PURE__ */ R("div", { className: "flex h-9 flex-row items-center gap-2 p-6 text-gray-500", children: [
    t.map((u) => /* @__PURE__ */ go(r4, { ...e, key: u.id, node: u })),
    /* @__PURE__ */ A(Ee, { children: n && /* @__PURE__ */ A(Ee, { children: o ? /* @__PURE__ */ A(
      ki,
      {
        defaultValue: "New Folder",
        placeholder: "New Folder",
        className: "text-gray-800",
        onSubmit: a,
        onCancel: c
      }
    ) : /* @__PURE__ */ R(
      "button",
      {
        onClick: s,
        className: "ml-1 flex items-center justify-center gap-2 rounded-md bg-gray-50 px-2 py-1.5 transition-colors hover:bg-gray-200 hover:text-gray-800",
        children: [
          /* @__PURE__ */ A(J, { name: "Plus", size: 14 }),
          "Add new"
        ]
      }
    ) }) })
  ] });
}
function r4(e) {
  const { node: t, setSelectedNode: n } = e;
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      "div",
      {
        role: "button",
        className: "transition-colors last-of-type:text-gray-800 hover:text-gray-800",
        onClick: () => n(t),
        children: t.name
      }
    ),
    "/"
  ] });
}
function yr(e) {
  "@babel/helpers - typeof";
  return yr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yr(e);
}
function o4(e, t) {
  if (yr(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (yr(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Wh(e) {
  var t = o4(e, "string");
  return yr(t) == "symbol" ? t : t + "";
}
function ni(e, t, n) {
  return (t = Wh(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function HA(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function de(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? HA(Object(n), !0).forEach(function(r) {
      ni(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : HA(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function i4(e) {
  if (Array.isArray(e)) return e;
}
function s4(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, i, s, a = [], c = !0, u = !1;
    try {
      if (i = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        c = !1;
      } else for (; !(c = (r = i.call(n)).done) && (a.push(r.value), a.length !== t); c = !0) ;
    } catch (l) {
      u = !0, o = l;
    } finally {
      try {
        if (!c && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (u) throw o;
      }
    }
    return a;
  }
}
function Cu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Zh(e, t) {
  if (e) {
    if (typeof e == "string") return Cu(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Cu(e, t) : void 0;
  }
}
function a4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bn(e, t) {
  return i4(e) || s4(e, t) || Zh(e, t) || a4();
}
function c4(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
function In(e, t) {
  if (e == null) return {};
  var n, r, o = c4(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var u4 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function l4(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, o = r === void 0 ? !1 : r, i = e.defaultValue, s = i === void 0 ? null : i, a = e.inputValue, c = e.menuIsOpen, u = e.onChange, l = e.onInputChange, d = e.onMenuClose, f = e.onMenuOpen, p = e.value, h = In(e, u4), g = Q(a !== void 0 ? a : n), m = bn(g, 2), b = m[0], v = m[1], C = Q(c !== void 0 ? c : o), w = bn(C, 2), y = w[0], I = w[1], x = Q(p !== void 0 ? p : s), E = bn(x, 2), P = E[0], L = E[1], W = ye(function(Z, H) {
    typeof u == "function" && u(Z, H), L(Z);
  }, [u]), V = ye(function(Z, H) {
    var K;
    typeof l == "function" && (K = l(Z, H)), v(K !== void 0 ? K : Z);
  }, [l]), X = ye(function() {
    typeof f == "function" && f(), I(!0);
  }, [f]), N = ye(function() {
    typeof d == "function" && d(), I(!1);
  }, [d]), M = a !== void 0 ? a : b, F = c !== void 0 ? c : y, B = p !== void 0 ? p : P;
  return de(de({}, h), {}, {
    inputValue: M,
    menuIsOpen: F,
    onChange: W,
    onInputChange: V,
    onMenuClose: N,
    onMenuOpen: X,
    value: B
  });
}
function Ae() {
  return Ae = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ae.apply(null, arguments);
}
function d4(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function XA(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Wh(r.key), r);
  }
}
function A4(e, t, n) {
  return t && XA(e.prototype, t), n && XA(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function xu(e, t) {
  return xu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, xu(e, t);
}
function f4(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && xu(e, t);
}
function ra(e) {
  return ra = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ra(e);
}
function zh() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zh = function() {
    return !!e;
  })();
}
function h4(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function p4(e, t) {
  if (t && (yr(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return h4(e);
}
function m4(e) {
  var t = zh();
  return function() {
    var n, r = ra(e);
    if (t) {
      var o = ra(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);
    return p4(this, n);
  };
}
function g4(e) {
  if (Array.isArray(e)) return Cu(e);
}
function b4(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function v4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ed(e) {
  return g4(e) || b4(e) || Zh(e) || v4();
}
var y4 = !1;
function C4(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function x4(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var w4 = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(o) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(o, i), r.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? !y4 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(x4(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = C4(o);
      try {
        i.insertRule(r, i.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var o;
      return (o = r.parentNode) == null ? void 0 : o.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), st = "-ms-", oa = "-moz-", Re = "-webkit-", Gh = "comm", td = "rule", nd = "decl", I4 = "@import", jh = "@keyframes", E4 = "@layer", S4 = Math.abs, La = String.fromCharCode, T4 = Object.assign;
function N4(e, t) {
  return rt(e, 0) ^ 45 ? (((t << 2 ^ rt(e, 0)) << 2 ^ rt(e, 1)) << 2 ^ rt(e, 2)) << 2 ^ rt(e, 3) : 0;
}
function Uh(e) {
  return e.trim();
}
function P4(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Oe(e, t, n) {
  return e.replace(t, n);
}
function wu(e, t) {
  return e.indexOf(t);
}
function rt(e, t) {
  return e.charCodeAt(t) | 0;
}
function pi(e, t, n) {
  return e.slice(t, n);
}
function rn(e) {
  return e.length;
}
function rd(e) {
  return e.length;
}
function bs(e, t) {
  return t.push(e), e;
}
function R4(e, t) {
  return e.map(t).join("");
}
var Ha = 1, yo = 1, Qh = 0, yt = 0, Ye = 0, Oo = "";
function Xa(e, t, n, r, o, i, s) {
  return { value: e, root: t, parent: n, type: r, props: o, children: i, line: Ha, column: yo, length: s, return: "" };
}
function jo(e, t) {
  return T4(Xa("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function O4() {
  return Ye;
}
function D4() {
  return Ye = yt > 0 ? rt(Oo, --yt) : 0, yo--, Ye === 10 && (yo = 1, Ha--), Ye;
}
function Nt() {
  return Ye = yt < Qh ? rt(Oo, yt++) : 0, yo++, Ye === 10 && (yo = 1, Ha++), Ye;
}
function ln() {
  return rt(Oo, yt);
}
function Hs() {
  return yt;
}
function es(e, t) {
  return pi(Oo, e, t);
}
function mi(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function qh(e) {
  return Ha = yo = 1, Qh = rn(Oo = e), yt = 0, [];
}
function Yh(e) {
  return Oo = "", e;
}
function Xs(e) {
  return Uh(es(yt - 1, Iu(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function M4(e) {
  for (; (Ye = ln()) && Ye < 33; )
    Nt();
  return mi(e) > 2 || mi(Ye) > 3 ? "" : " ";
}
function F4(e, t) {
  for (; --t && Nt() && !(Ye < 48 || Ye > 102 || Ye > 57 && Ye < 65 || Ye > 70 && Ye < 97); )
    ;
  return es(e, Hs() + (t < 6 && ln() == 32 && Nt() == 32));
}
function Iu(e) {
  for (; Nt(); )
    switch (Ye) {
      case e:
        return yt;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Iu(Ye);
        break;
      case 40:
        e === 41 && Iu(e);
        break;
      case 92:
        Nt();
        break;
    }
  return yt;
}
function V4(e, t) {
  for (; Nt() && e + Ye !== 57; )
    if (e + Ye === 84 && ln() === 47)
      break;
  return "/*" + es(t, yt - 1) + "*" + La(e === 47 ? e : Nt());
}
function B4(e) {
  for (; !mi(ln()); )
    Nt();
  return es(e, yt);
}
function k4(e) {
  return Yh(Ws("", null, null, null, [""], e = qh(e), 0, [0], e));
}
function Ws(e, t, n, r, o, i, s, a, c) {
  for (var u = 0, l = 0, d = s, f = 0, p = 0, h = 0, g = 1, m = 1, b = 1, v = 0, C = "", w = o, y = i, I = r, x = C; m; )
    switch (h = v, v = Nt()) {
      case 40:
        if (h != 108 && rt(x, d - 1) == 58) {
          wu(x += Oe(Xs(v), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        x += Xs(v);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        x += M4(h);
        break;
      case 92:
        x += F4(Hs() - 1, 7);
        continue;
      case 47:
        switch (ln()) {
          case 42:
          case 47:
            bs(L4(V4(Nt(), Hs()), t, n), c);
            break;
          default:
            x += "/";
        }
        break;
      case 123 * g:
        a[u++] = rn(x) * b;
      case 125 * g:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            m = 0;
          case 59 + l:
            b == -1 && (x = Oe(x, /\f/g, "")), p > 0 && rn(x) - d && bs(p > 32 ? ZA(x + ";", r, n, d - 1) : ZA(Oe(x, " ", "") + ";", r, n, d - 2), c);
            break;
          case 59:
            x += ";";
          default:
            if (bs(I = WA(x, t, n, u, l, o, a, C, w = [], y = [], d), i), v === 123)
              if (l === 0)
                Ws(x, t, I, I, w, i, d, a, y);
              else
                switch (f === 99 && rt(x, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ws(e, I, I, r && bs(WA(e, I, I, 0, 0, o, a, C, o, w = [], d), y), o, y, d, a, r ? w : y);
                    break;
                  default:
                    Ws(x, I, I, I, [""], y, 0, a, y);
                }
        }
        u = l = p = 0, g = b = 1, C = x = "", d = s;
        break;
      case 58:
        d = 1 + rn(x), p = h;
      default:
        if (g < 1) {
          if (v == 123)
            --g;
          else if (v == 125 && g++ == 0 && D4() == 125)
            continue;
        }
        switch (x += La(v), v * g) {
          case 38:
            b = l > 0 ? 1 : (x += "\f", -1);
            break;
          case 44:
            a[u++] = (rn(x) - 1) * b, b = 1;
            break;
          case 64:
            ln() === 45 && (x += Xs(Nt())), f = ln(), l = d = rn(C = x += B4(Hs())), v++;
            break;
          case 45:
            h === 45 && rn(x) == 2 && (g = 0);
        }
    }
  return i;
}
function WA(e, t, n, r, o, i, s, a, c, u, l) {
  for (var d = o - 1, f = o === 0 ? i : [""], p = rd(f), h = 0, g = 0, m = 0; h < r; ++h)
    for (var b = 0, v = pi(e, d + 1, d = S4(g = s[h])), C = e; b < p; ++b)
      (C = Uh(g > 0 ? f[b] + " " + v : Oe(v, /&\f/g, f[b]))) && (c[m++] = C);
  return Xa(e, t, n, o === 0 ? td : a, c, u, l);
}
function L4(e, t, n) {
  return Xa(e, t, n, Gh, La(O4()), pi(e, 2, -2), 0);
}
function ZA(e, t, n, r) {
  return Xa(e, t, n, nd, pi(e, 0, r), pi(e, r + 1, -1), r);
}
function _r(e, t) {
  for (var n = "", r = rd(e), o = 0; o < r; o++)
    n += t(e[o], o, e, t) || "";
  return n;
}
function H4(e, t, n, r) {
  switch (e.type) {
    case E4:
      if (e.children.length) break;
    case I4:
    case nd:
      return e.return = e.return || e.value;
    case Gh:
      return "";
    case jh:
      return e.return = e.value + "{" + _r(e.children, r) + "}";
    case td:
      e.value = e.props.join(",");
  }
  return rn(n = _r(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function X4(e) {
  var t = rd(e);
  return function(n, r, o, i) {
    for (var s = "", a = 0; a < t; a++)
      s += e[a](n, r, o, i) || "";
    return s;
  };
}
function W4(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function Z4(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var z4 = function(t, n, r) {
  for (var o = 0, i = 0; o = i, i = ln(), o === 38 && i === 12 && (n[r] = 1), !mi(i); )
    Nt();
  return es(t, yt);
}, G4 = function(t, n) {
  var r = -1, o = 44;
  do
    switch (mi(o)) {
      case 0:
        o === 38 && ln() === 12 && (n[r] = 1), t[r] += z4(yt - 1, n, r);
        break;
      case 2:
        t[r] += Xs(o);
        break;
      case 4:
        if (o === 44) {
          t[++r] = ln() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += La(o);
    }
  while (o = Nt());
  return t;
}, j4 = function(t, n) {
  return Yh(G4(qh(t), n));
}, zA = /* @__PURE__ */ new WeakMap(), U4 = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, o = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !zA.get(r)) && !o) {
      zA.set(t, !0);
      for (var i = [], s = j4(n, i), a = r.props, c = 0, u = 0; c < s.length; c++)
        for (var l = 0; l < a.length; l++, u++)
          t.props[u] = i[c] ? s[c].replace(/&\f/g, a[l]) : a[l] + " " + s[c];
    }
  }
}, Q4 = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function Jh(e, t) {
  switch (N4(e, t)) {
    case 5103:
      return Re + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Re + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Re + e + oa + e + st + e + e;
    case 6828:
    case 4268:
      return Re + e + st + e + e;
    case 6165:
      return Re + e + st + "flex-" + e + e;
    case 5187:
      return Re + e + Oe(e, /(\w+).+(:[^]+)/, Re + "box-$1$2" + st + "flex-$1$2") + e;
    case 5443:
      return Re + e + st + "flex-item-" + Oe(e, /flex-|-self/, "") + e;
    case 4675:
      return Re + e + st + "flex-line-pack" + Oe(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Re + e + st + Oe(e, "shrink", "negative") + e;
    case 5292:
      return Re + e + st + Oe(e, "basis", "preferred-size") + e;
    case 6060:
      return Re + "box-" + Oe(e, "-grow", "") + Re + e + st + Oe(e, "grow", "positive") + e;
    case 4554:
      return Re + Oe(e, /([^-])(transform)/g, "$1" + Re + "$2") + e;
    case 6187:
      return Oe(Oe(Oe(e, /(zoom-|grab)/, Re + "$1"), /(image-set)/, Re + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Oe(e, /(image-set\([^]*)/, Re + "$1$`$1");
    case 4968:
      return Oe(Oe(e, /(.+:)(flex-)?(.*)/, Re + "box-pack:$3" + st + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Re + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Oe(e, /(.+)-inline(.+)/, Re + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (rn(e) - 1 - t > 6) switch (rt(e, t + 1)) {
        case 109:
          if (rt(e, t + 4) !== 45) break;
        case 102:
          return Oe(e, /(.+:)(.+)-([^]+)/, "$1" + Re + "$2-$3$1" + oa + (rt(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~wu(e, "stretch") ? Jh(Oe(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (rt(e, t + 1) !== 115) break;
    case 6444:
      switch (rt(e, rn(e) - 3 - (~wu(e, "!important") && 10))) {
        case 107:
          return Oe(e, ":", ":" + Re) + e;
        case 101:
          return Oe(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Re + (rt(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Re + "$2$3$1" + st + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (rt(e, t + 11)) {
        case 114:
          return Re + e + st + Oe(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Re + e + st + Oe(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Re + e + st + Oe(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Re + e + st + e + e;
  }
  return e;
}
var q4 = function(t, n, r, o) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case nd:
      t.return = Jh(t.value, t.length);
      break;
    case jh:
      return _r([jo(t, {
        value: Oe(t.value, "@", "@" + Re)
      })], o);
    case td:
      if (t.length) return R4(t.props, function(i) {
        switch (P4(i, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return _r([jo(t, {
              props: [Oe(i, /:(read-\w+)/, ":" + oa + "$1")]
            })], o);
          case "::placeholder":
            return _r([jo(t, {
              props: [Oe(i, /:(plac\w+)/, ":" + Re + "input-$1")]
            }), jo(t, {
              props: [Oe(i, /:(plac\w+)/, ":" + oa + "$1")]
            }), jo(t, {
              props: [Oe(i, /:(plac\w+)/, st + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, Y4 = [q4], J4 = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(g) {
      var m = g.getAttribute("data-emotion");
      m.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || Y4, i = {}, s, a = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var m = g.getAttribute("data-emotion").split(" "), b = 1; b < m.length; b++)
        i[m[b]] = !0;
      a.push(g);
    }
  );
  var c, u = [U4, Q4];
  {
    var l, d = [H4, W4(function(g) {
      l.insert(g);
    })], f = X4(u.concat(o, d)), p = function(m) {
      return _r(k4(m), f);
    };
    c = function(m, b, v, C) {
      l = v, p(m ? m + "{" + b.styles + "}" : b.styles), C && (h.inserted[b.name] = !0);
    };
  }
  var h = {
    key: n,
    sheet: new w4({
      key: n,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return h.sheet.hydrate(a), h;
}, ri = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Do(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Eu = { exports: {} }, De = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var GA;
function K4() {
  if (GA) return De;
  GA = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function C(y) {
    if (typeof y == "object" && y !== null) {
      var I = y.$$typeof;
      switch (I) {
        case t:
          switch (y = y.type, y) {
            case c:
            case u:
            case r:
            case i:
            case o:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case a:
                case l:
                case h:
                case p:
                case s:
                  return y;
                default:
                  return I;
              }
          }
        case n:
          return I;
      }
    }
  }
  function w(y) {
    return C(y) === u;
  }
  return De.AsyncMode = c, De.ConcurrentMode = u, De.ContextConsumer = a, De.ContextProvider = s, De.Element = t, De.ForwardRef = l, De.Fragment = r, De.Lazy = h, De.Memo = p, De.Portal = n, De.Profiler = i, De.StrictMode = o, De.Suspense = d, De.isAsyncMode = function(y) {
    return w(y) || C(y) === c;
  }, De.isConcurrentMode = w, De.isContextConsumer = function(y) {
    return C(y) === a;
  }, De.isContextProvider = function(y) {
    return C(y) === s;
  }, De.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === t;
  }, De.isForwardRef = function(y) {
    return C(y) === l;
  }, De.isFragment = function(y) {
    return C(y) === r;
  }, De.isLazy = function(y) {
    return C(y) === h;
  }, De.isMemo = function(y) {
    return C(y) === p;
  }, De.isPortal = function(y) {
    return C(y) === n;
  }, De.isProfiler = function(y) {
    return C(y) === i;
  }, De.isStrictMode = function(y) {
    return C(y) === o;
  }, De.isSuspense = function(y) {
    return C(y) === d;
  }, De.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === u || y === i || y === o || y === d || y === f || typeof y == "object" && y !== null && (y.$$typeof === h || y.$$typeof === p || y.$$typeof === s || y.$$typeof === a || y.$$typeof === l || y.$$typeof === m || y.$$typeof === b || y.$$typeof === v || y.$$typeof === g);
  }, De.typeOf = C, De;
}
var Me = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jA;
function _4() {
  return jA || (jA = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function C(re) {
      return typeof re == "string" || typeof re == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      re === r || re === u || re === i || re === o || re === d || re === f || typeof re == "object" && re !== null && (re.$$typeof === h || re.$$typeof === p || re.$$typeof === s || re.$$typeof === a || re.$$typeof === l || re.$$typeof === m || re.$$typeof === b || re.$$typeof === v || re.$$typeof === g);
    }
    function w(re) {
      if (typeof re == "object" && re !== null) {
        var Ge = re.$$typeof;
        switch (Ge) {
          case t:
            var nt = re.type;
            switch (nt) {
              case c:
              case u:
              case r:
              case i:
              case o:
              case d:
                return nt;
              default:
                var Rt = nt && nt.$$typeof;
                switch (Rt) {
                  case a:
                  case l:
                  case h:
                  case p:
                  case s:
                    return Rt;
                  default:
                    return Ge;
                }
            }
          case n:
            return Ge;
        }
      }
    }
    var y = c, I = u, x = a, E = s, P = t, L = l, W = r, V = h, X = p, N = n, M = i, F = o, B = d, Z = !1;
    function H(re) {
      return Z || (Z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), K(re) || w(re) === c;
    }
    function K(re) {
      return w(re) === u;
    }
    function ee(re) {
      return w(re) === a;
    }
    function z(re) {
      return w(re) === s;
    }
    function ce(re) {
      return typeof re == "object" && re !== null && re.$$typeof === t;
    }
    function be(re) {
      return w(re) === l;
    }
    function te(re) {
      return w(re) === r;
    }
    function ue(re) {
      return w(re) === h;
    }
    function me(re) {
      return w(re) === p;
    }
    function Te(re) {
      return w(re) === n;
    }
    function Be(re) {
      return w(re) === i;
    }
    function et(re) {
      return w(re) === o;
    }
    function it(re) {
      return w(re) === d;
    }
    Me.AsyncMode = y, Me.ConcurrentMode = I, Me.ContextConsumer = x, Me.ContextProvider = E, Me.Element = P, Me.ForwardRef = L, Me.Fragment = W, Me.Lazy = V, Me.Memo = X, Me.Portal = N, Me.Profiler = M, Me.StrictMode = F, Me.Suspense = B, Me.isAsyncMode = H, Me.isConcurrentMode = K, Me.isContextConsumer = ee, Me.isContextProvider = z, Me.isElement = ce, Me.isForwardRef = be, Me.isFragment = te, Me.isLazy = ue, Me.isMemo = me, Me.isPortal = Te, Me.isProfiler = Be, Me.isStrictMode = et, Me.isSuspense = it, Me.isValidElementType = C, Me.typeOf = w;
  }()), Me;
}
process.env.NODE_ENV === "production" ? Eu.exports = K4() : Eu.exports = _4();
var $4 = Eu.exports, Kh = $4, e7 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, t7 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, _h = {};
_h[Kh.ForwardRef] = e7;
_h[Kh.Memo] = t7;
var n7 = !0;
function r7(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : r += o + " ";
  }), r;
}
var $h = function(t, n, r) {
  var o = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  n7 === !1) && t.registered[o] === void 0 && (t.registered[o] = n.styles);
}, o7 = function(t, n, r) {
  $h(t, n, r);
  var o = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + o : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function i7(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var s7 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, a7 = !1, c7 = /[A-Z]|^ms/g, u7 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, ep = function(t) {
  return t.charCodeAt(1) === 45;
}, UA = function(t) {
  return t != null && typeof t != "boolean";
}, vc = /* @__PURE__ */ Z4(function(e) {
  return ep(e) ? e : e.replace(c7, "-$&").toLowerCase();
}), QA = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(u7, function(r, o, i) {
          return on = {
            name: o,
            styles: i,
            next: on
          }, o;
        });
  }
  return s7[t] !== 1 && !ep(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, l7 = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function gi(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var o = n;
      if (o.anim === 1)
        return on = {
          name: o.name,
          styles: o.styles,
          next: on
        }, o.name;
      var i = n;
      if (i.styles !== void 0) {
        var s = i.next;
        if (s !== void 0)
          for (; s !== void 0; )
            on = {
              name: s.name,
              styles: s.styles,
              next: on
            }, s = s.next;
        var a = i.styles + ";";
        return a;
      }
      return d7(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = on, u = n(e);
        return on = c, gi(e, t, u);
      }
      break;
    }
  }
  var l = n;
  return l;
}
function d7(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      r += gi(e, t, n[o]) + ";";
  else
    for (var i in n) {
      var s = n[i];
      if (typeof s != "object") {
        var a = s;
        UA(a) && (r += vc(i) + ":" + QA(i, a) + ";");
      } else {
        if (i === "NO_COMPONENT_SELECTOR" && a7)
          throw new Error(l7);
        if (Array.isArray(s) && typeof s[0] == "string" && t == null)
          for (var c = 0; c < s.length; c++)
            UA(s[c]) && (r += vc(i) + ":" + QA(i, s[c]) + ";");
        else {
          var u = gi(e, t, s);
          switch (i) {
            case "animation":
            case "animationName": {
              r += vc(i) + ":" + u + ";";
              break;
            }
            default:
              r += i + "{" + u + "}";
          }
        }
      }
    }
  return r;
}
var qA = /label:\s*([^\s;\n{]+)\s*(;|$)/g, on;
function tp(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, o = "";
  on = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    r = !1, o += gi(n, t, i);
  else {
    var s = i;
    o += s[0];
  }
  for (var a = 1; a < e.length; a++)
    if (o += gi(n, t, e[a]), r) {
      var c = i;
      o += c[a];
    }
  qA.lastIndex = 0;
  for (var u = "", l; (l = qA.exec(o)) !== null; )
    u += "-" + l[1];
  var d = i7(o) + u;
  return {
    name: d,
    styles: o,
    next: on
  };
}
var A7 = function(t) {
  return t();
}, f7 = S.useInsertionEffect ? S.useInsertionEffect : !1, h7 = f7 || A7, p7 = !1, np = /* @__PURE__ */ S.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ J4({
    key: "css"
  }) : null
);
np.Provider;
var m7 = function(t) {
  return /* @__PURE__ */ Pt(function(n, r) {
    var o = Sa(np);
    return t(n, o, r);
  });
}, g7 = /* @__PURE__ */ S.createContext({}), od = {}.hasOwnProperty, Su = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", b7 = function(t, n) {
  var r = {};
  for (var o in n)
    od.call(n, o) && (r[o] = n[o]);
  return r[Su] = t, r;
}, v7 = function(t) {
  var n = t.cache, r = t.serialized, o = t.isStringTag;
  return $h(n, r, o), h7(function() {
    return o7(n, r, o);
  }), null;
}, y7 = /* @__PURE__ */ m7(
  /* <any, any> */
  function(e, t, n) {
    var r = e.css;
    typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
    var o = e[Su], i = [r], s = "";
    typeof e.className == "string" ? s = r7(t.registered, i, e.className) : e.className != null && (s = e.className + " ");
    var a = tp(i, void 0, S.useContext(g7));
    s += t.key + "-" + a.name;
    var c = {};
    for (var u in e)
      od.call(e, u) && u !== "css" && u !== Su && !p7 && (c[u] = e[u]);
    return c.className = s, n && (c.ref = n), /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement(v7, {
      cache: t,
      serialized: a,
      isStringTag: typeof o == "string"
    }), /* @__PURE__ */ S.createElement(o, c));
  }
), C7 = y7, le = function(t, n) {
  var r = arguments;
  if (n == null || !od.call(n, "css"))
    return S.createElement.apply(void 0, r);
  var o = r.length, i = new Array(o);
  i[0] = C7, i[1] = b7(t, n);
  for (var s = 2; s < o; s++)
    i[s] = r[s];
  return S.createElement.apply(null, i);
};
function id() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return tp(t);
}
var x7 = function() {
  var t = id.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
function w7(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
var Tu = Yn, I7 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], ia = function() {
};
function E7(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function S7(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    r[o - 2] = arguments[o];
  var i = [].concat(r);
  if (t && e)
    for (var s in t)
      t.hasOwnProperty(s) && t[s] && i.push("".concat(E7(e, s)));
  return i.filter(function(a) {
    return a;
  }).map(function(a) {
    return String(a).trim();
  }).join(" ");
}
var YA = function(t) {
  return V7(t) ? t.filter(Boolean) : yr(t) === "object" && t !== null ? [t] : [];
}, rp = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = In(t, I7);
  return de({}, n);
}, Ue = function(t, n, r) {
  var o = t.cx, i = t.getStyles, s = t.getClassNames, a = t.className;
  return {
    css: i(n, t),
    className: o(r ?? {}, s(n, t), a)
  };
};
function Wa(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function T7(e) {
  return Wa(e) ? window.innerHeight : e.clientHeight;
}
function op(e) {
  return Wa(e) ? window.pageYOffset : e.scrollTop;
}
function sa(e, t) {
  if (Wa(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function N7(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", r = /(auto|scroll)/;
  if (t.position === "fixed") return document.documentElement;
  for (var o = e; o = o.parentElement; )
    if (t = getComputedStyle(o), !(n && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX))
      return o;
  return document.documentElement;
}
function P7(e, t, n, r) {
  return n * ((e = e / r - 1) * e * e + 1) + t;
}
function vs(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ia, o = op(e), i = t - o, s = 10, a = 0;
  function c() {
    a += s;
    var u = P7(a, o, i, n);
    sa(e, u), a < n ? window.requestAnimationFrame(c) : r(e);
  }
  c();
}
function JA(e, t) {
  var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), o = t.offsetHeight / 3;
  r.bottom + o > n.bottom ? sa(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + o, e.scrollHeight)) : r.top - o < n.top && sa(e, Math.max(t.offsetTop - o, 0));
}
function R7(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function KA() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function O7() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var ip = !1, D7 = {
  get passive() {
    return ip = !0;
  }
}, ys = typeof window < "u" ? window : {};
ys.addEventListener && ys.removeEventListener && (ys.addEventListener("p", ia, D7), ys.removeEventListener("p", ia, !1));
var M7 = ip;
function F7(e) {
  return e != null;
}
function V7(e) {
  return Array.isArray(e);
}
function Cs(e, t, n) {
  return e ? t : n;
}
var B7 = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  var i = Object.entries(t).filter(function(s) {
    var a = bn(s, 1), c = a[0];
    return !r.includes(c);
  });
  return i.reduce(function(s, a) {
    var c = bn(a, 2), u = c[0], l = c[1];
    return s[u] = l, s;
  }, {});
}, k7 = ["children", "innerProps"], L7 = ["children", "innerProps"];
function H7(e) {
  var t = e.maxHeight, n = e.menuEl, r = e.minHeight, o = e.placement, i = e.shouldScroll, s = e.isFixedPosition, a = e.controlHeight, c = N7(n), u = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent) return u;
  var l = c.getBoundingClientRect(), d = l.height, f = n.getBoundingClientRect(), p = f.bottom, h = f.height, g = f.top, m = n.offsetParent.getBoundingClientRect(), b = m.top, v = s ? window.innerHeight : T7(c), C = op(c), w = parseInt(getComputedStyle(n).marginBottom, 10), y = parseInt(getComputedStyle(n).marginTop, 10), I = b - y, x = v - g, E = I + C, P = d - C - g, L = p - v + C + w, W = C + g - y, V = 160;
  switch (o) {
    case "auto":
    case "bottom":
      if (x >= h)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (P >= h && !s)
        return i && vs(c, L, V), {
          placement: "bottom",
          maxHeight: t
        };
      if (!s && P >= r || s && x >= r) {
        i && vs(c, L, V);
        var X = s ? x - w : P - w;
        return {
          placement: "bottom",
          maxHeight: X
        };
      }
      if (o === "auto" || s) {
        var N = t, M = s ? I : E;
        return M >= r && (N = Math.min(M - w - a, t)), {
          placement: "top",
          maxHeight: N
        };
      }
      if (o === "bottom")
        return i && sa(c, L), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (I >= h)
        return {
          placement: "top",
          maxHeight: t
        };
      if (E >= h && !s)
        return i && vs(c, W, V), {
          placement: "top",
          maxHeight: t
        };
      if (!s && E >= r || s && I >= r) {
        var F = t;
        return (!s && E >= r || s && I >= r) && (F = s ? I - y : E - y), i && vs(c, W, V), {
          placement: "top",
          maxHeight: F
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(o, '".'));
  }
  return u;
}
function X7(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var sp = function(t) {
  return t === "auto" ? "bottom" : t;
}, W7 = function(t, n) {
  var r, o = t.placement, i = t.theme, s = i.borderRadius, a = i.spacing, c = i.colors;
  return de((r = {
    label: "menu"
  }, ni(r, X7(o), "100%"), ni(r, "position", "absolute"), ni(r, "width", "100%"), ni(r, "zIndex", 1), r), n ? {} : {
    backgroundColor: c.neutral0,
    borderRadius: s,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: a.menuGutter,
    marginTop: a.menuGutter
  });
}, ap = /* @__PURE__ */ Tl(null), Z7 = function(t) {
  var n = t.children, r = t.minMenuHeight, o = t.maxMenuHeight, i = t.menuPlacement, s = t.menuPosition, a = t.menuShouldScrollIntoView, c = t.theme, u = Sa(ap) || {}, l = u.setPortalPlacement, d = Ce(null), f = Q(o), p = bn(f, 2), h = p[0], g = p[1], m = Q(null), b = bn(m, 2), v = b[0], C = b[1], w = c.spacing.controlHeight;
  return Tu(function() {
    var y = d.current;
    if (y) {
      var I = s === "fixed", x = a && !I, E = H7({
        maxHeight: o,
        menuEl: y,
        minHeight: r,
        placement: i,
        shouldScroll: x,
        isFixedPosition: I,
        controlHeight: w
      });
      g(E.maxHeight), C(E.placement), l == null || l(E.placement);
    }
  }, [o, i, s, a, r, l, w]), n({
    ref: d,
    placerProps: de(de({}, t), {}, {
      placement: v || sp(i),
      maxHeight: h
    })
  });
}, z7 = function(t) {
  var n = t.children, r = t.innerRef, o = t.innerProps;
  return le("div", Ae({}, Ue(t, "menu", {
    menu: !0
  }), {
    ref: r
  }, o), n);
}, G7 = z7, j7 = function(t, n) {
  var r = t.maxHeight, o = t.theme.spacing.baseUnit;
  return de({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: o,
    paddingTop: o
  });
}, U7 = function(t) {
  var n = t.children, r = t.innerProps, o = t.innerRef, i = t.isMulti;
  return le("div", Ae({}, Ue(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": i
  }), {
    ref: o
  }, r), n);
}, cp = function(t, n) {
  var r = t.theme, o = r.spacing.baseUnit, i = r.colors;
  return de({
    textAlign: "center"
  }, n ? {} : {
    color: i.neutral40,
    padding: "".concat(o * 2, "px ").concat(o * 3, "px")
  });
}, Q7 = cp, q7 = cp, Y7 = function(t) {
  var n = t.children, r = n === void 0 ? "No options" : n, o = t.innerProps, i = In(t, k7);
  return le("div", Ae({}, Ue(de(de({}, i), {}, {
    children: r,
    innerProps: o
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), o), r);
}, J7 = function(t) {
  var n = t.children, r = n === void 0 ? "Loading..." : n, o = t.innerProps, i = In(t, L7);
  return le("div", Ae({}, Ue(de(de({}, i), {}, {
    children: r,
    innerProps: o
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), o), r);
}, K7 = function(t) {
  var n = t.rect, r = t.offset, o = t.position;
  return {
    left: n.left,
    position: o,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, _7 = function(t) {
  var n = t.appendTo, r = t.children, o = t.controlElement, i = t.innerProps, s = t.menuPlacement, a = t.menuPosition, c = Ce(null), u = Ce(null), l = Q(sp(s)), d = bn(l, 2), f = d[0], p = d[1], h = ve(function() {
    return {
      setPortalPlacement: p
    };
  }, []), g = Q(null), m = bn(g, 2), b = m[0], v = m[1], C = ye(function() {
    if (o) {
      var x = R7(o), E = a === "fixed" ? 0 : window.pageYOffset, P = x[f] + E;
      (P !== (b == null ? void 0 : b.offset) || x.left !== (b == null ? void 0 : b.rect.left) || x.width !== (b == null ? void 0 : b.rect.width)) && v({
        offset: P,
        rect: x
      });
    }
  }, [o, a, f, b == null ? void 0 : b.offset, b == null ? void 0 : b.rect.left, b == null ? void 0 : b.rect.width]);
  Tu(function() {
    C();
  }, [C]);
  var w = ye(function() {
    typeof u.current == "function" && (u.current(), u.current = null), o && c.current && (u.current = u0(o, c.current, C, {
      elementResize: "ResizeObserver" in window
    }));
  }, [o, C]);
  Tu(function() {
    w();
  }, [w]);
  var y = ye(function(x) {
    c.current = x, w();
  }, [w]);
  if (!n && a !== "fixed" || !b) return null;
  var I = le("div", Ae({
    ref: y
  }, Ue(de(de({}, t), {}, {
    offset: b.offset,
    position: a,
    rect: b.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), i), r);
  return le(ap.Provider, {
    value: h
  }, n ? /* @__PURE__ */ j3(I, n) : I);
}, $7 = function(t) {
  var n = t.isDisabled, r = t.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, ey = function(t) {
  var n = t.children, r = t.innerProps, o = t.isDisabled, i = t.isRtl;
  return le("div", Ae({}, Ue(t, "container", {
    "--is-disabled": o,
    "--is-rtl": i
  }), r), n);
}, ty = function(t, n) {
  var r = t.theme.spacing, o = t.isMulti, i = t.hasValue, s = t.selectProps.controlShouldRenderValue;
  return de({
    alignItems: "center",
    display: o && i && s ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, ny = function(t) {
  var n = t.children, r = t.innerProps, o = t.isMulti, i = t.hasValue;
  return le("div", Ae({}, Ue(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": o,
    "value-container--has-value": i
  }), r), n);
}, ry = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, oy = function(t) {
  var n = t.children, r = t.innerProps;
  return le("div", Ae({}, Ue(t, "indicatorsContainer", {
    indicators: !0
  }), r), n);
}, _A, iy = ["size"], sy = ["innerProps", "isRtl", "size"];
function ay() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var cy = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: ay
}, up = function(t) {
  var n = t.size, r = In(t, iy);
  return le("svg", Ae({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: cy
  }, r));
}, sd = function(t) {
  return le(up, Ae({
    size: 20
  }, t), le("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, lp = function(t) {
  return le(up, Ae({
    size: 20
  }, t), le("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, dp = function(t, n) {
  var r = t.isFocused, o = t.theme, i = o.spacing.baseUnit, s = o.colors;
  return de({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: r ? s.neutral60 : s.neutral20,
    padding: i * 2,
    ":hover": {
      color: r ? s.neutral80 : s.neutral40
    }
  });
}, uy = dp, ly = function(t) {
  var n = t.children, r = t.innerProps;
  return le("div", Ae({}, Ue(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), n || le(lp, null));
}, dy = dp, Ay = function(t) {
  var n = t.children, r = t.innerProps;
  return le("div", Ae({}, Ue(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), n || le(sd, null));
}, fy = function(t, n) {
  var r = t.isDisabled, o = t.theme, i = o.spacing.baseUnit, s = o.colors;
  return de({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: r ? s.neutral10 : s.neutral20,
    marginBottom: i * 2,
    marginTop: i * 2
  });
}, hy = function(t) {
  var n = t.innerProps;
  return le("span", Ae({}, n, Ue(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, py = x7(_A || (_A = w7([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), my = function(t, n) {
  var r = t.isFocused, o = t.size, i = t.theme, s = i.colors, a = i.spacing.baseUnit;
  return de({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: o,
    lineHeight: 1,
    marginRight: o,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: r ? s.neutral60 : s.neutral20,
    padding: a * 2
  });
}, yc = function(t) {
  var n = t.delay, r = t.offset;
  return le("span", {
    css: /* @__PURE__ */ id({
      animation: "".concat(py, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGljYXRvcnMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1RSSIsImZpbGUiOiJpbmRpY2F0b3JzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4LCBrZXlmcmFtZXMgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmltcG9ydCB7XG4gIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lLFxuICBDU1NPYmplY3RXaXRoTGFiZWwsXG4gIEdyb3VwQmFzZSxcbn0gZnJvbSAnLi4vdHlwZXMnO1xuaW1wb3J0IHsgZ2V0U3R5bGVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBEcm9wZG93biAmIENsZWFyIEljb25zXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuY29uc3QgU3ZnID0gKHtcbiAgc2l6ZSxcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snc3ZnJ10gJiB7IHNpemU6IG51bWJlciB9KSA9PiAoXG4gIDxzdmdcbiAgICBoZWlnaHQ9e3NpemV9XG4gICAgd2lkdGg9e3NpemV9XG4gICAgdmlld0JveD1cIjAgMCAyMCAyMFwiXG4gICAgYXJpYS1oaWRkZW49XCJ0cnVlXCJcbiAgICBmb2N1c2FibGU9XCJmYWxzZVwiXG4gICAgY3NzPXt7XG4gICAgICBkaXNwbGF5OiAnaW5saW5lLWJsb2NrJyxcbiAgICAgIGZpbGw6ICdjdXJyZW50Q29sb3InLFxuICAgICAgbGluZUhlaWdodDogMSxcbiAgICAgIHN0cm9rZTogJ2N1cnJlbnRDb2xvcicsXG4gICAgICBzdHJva2VXaWR0aDogMCxcbiAgICB9fVxuICAgIHsuLi5wcm9wc31cbiAgLz5cbik7XG5cbmV4cG9ydCB0eXBlIENyb3NzSWNvblByb3BzID0gSlNYLkludHJpbnNpY0VsZW1lbnRzWydzdmcnXSAmIHsgc2l6ZT86IG51bWJlciB9O1xuZXhwb3J0IGNvbnN0IENyb3NzSWNvbiA9IChwcm9wczogQ3Jvc3NJY29uUHJvcHMpID0+IChcbiAgPFN2ZyBzaXplPXsyMH0gey4uLnByb3BzfT5cbiAgICA8cGF0aCBkPVwiTTE0LjM0OCAxNC44NDljLTAuNDY5IDAuNDY5LTEuMjI5IDAuNDY5LTEuNjk3IDBsLTIuNjUxLTMuMDMwLTIuNjUxIDMuMDI5Yy0wLjQ2OSAwLjQ2OS0xLjIyOSAwLjQ2OS0xLjY5NyAwLTAuNDY5LTAuNDY5LTAuNDY5LTEuMjI5IDAtMS42OTdsMi43NTgtMy4xNS0yLjc1OS0zLjE1MmMtMC40NjktMC40NjktMC40NjktMS4yMjggMC0xLjY5N3MxLjIyOC0wLjQ2OSAxLjY5NyAwbDIuNjUyIDMuMDMxIDIuNjUxLTMuMDMxYzAuNDY5LTAuNDY5IDEuMjI4LTAuNDY5IDEuNjk3IDBzMC40NjkgMS4yMjkgMCAxLjY5N2wtMi43NTggMy4xNTIgMi43NTggMy4xNWMwLjQ2OSAwLjQ2OSAwLjQ2OSAxLjIyOSAwIDEuNjk4elwiIC8+XG4gIDwvU3ZnPlxuKTtcbmV4cG9ydCB0eXBlIERvd25DaGV2cm9uUHJvcHMgPSBKU1guSW50cmluc2ljRWxlbWVudHNbJ3N2ZyddICYgeyBzaXplPzogbnVtYmVyIH07XG5leHBvcnQgY29uc3QgRG93bkNoZXZyb24gPSAocHJvcHM6IERvd25DaGV2cm9uUHJvcHMpID0+IChcbiAgPFN2ZyBzaXplPXsyMH0gey4uLnByb3BzfT5cbiAgICA8cGF0aCBkPVwiTTQuNTE2IDcuNTQ4YzAuNDM2LTAuNDQ2IDEuMDQzLTAuNDgxIDEuNTc2IDBsMy45MDggMy43NDcgMy45MDgtMy43NDdjMC41MzMtMC40ODEgMS4xNDEtMC40NDYgMS41NzQgMCAwLjQzNiAwLjQ0NSAwLjQwOCAxLjE5NyAwIDEuNjE1LTAuNDA2IDAuNDE4LTQuNjk1IDQuNTAyLTQuNjk1IDQuNTAyLTAuMjE3IDAuMjIzLTAuNTAyIDAuMzM1LTAuNzg3IDAuMzM1cy0wLjU3LTAuMTEyLTAuNzg5LTAuMzM1YzAgMC00LjI4Ny00LjA4NC00LjY5NS00LjUwMnMtMC40MzYtMS4xNyAwLTEuNjE1elwiIC8+XG4gIDwvU3ZnPlxuKTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBEcm9wZG93biAmIENsZWFyIEJ1dHRvbnNcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG5leHBvcnQgaW50ZXJmYWNlIERyb3Bkb3duSW5kaWNhdG9yUHJvcHM8XG4gIE9wdGlvbiA9IHVua25vd24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuID0gYm9vbGVhbixcbiAgR3JvdXAgZXh0ZW5kcyBHcm91cEJhc2U8T3B0aW9uPiA9IEdyb3VwQmFzZTxPcHRpb24+XG4+IGV4dGVuZHMgQ29tbW9uUHJvcHNBbmRDbGFzc05hbWU8T3B0aW9uLCBJc011bHRpLCBHcm91cD4ge1xuICAvKiogVGhlIGNoaWxkcmVuIHRvIGJlIHJlbmRlcmVkIGluc2lkZSB0aGUgaW5kaWNhdG9yLiAqL1xuICBjaGlsZHJlbj86IFJlYWN0Tm9kZTtcbiAgLyoqIFByb3BzIHRoYXQgd2lsbCBiZSBwYXNzZWQgb24gdG8gdGhlIGNoaWxkcmVuLiAqL1xuICBpbm5lclByb3BzOiBKU1guSW50cmluc2ljRWxlbWVudHNbJ2RpdiddO1xuICAvKiogVGhlIGZvY3VzZWQgc3RhdGUgb2YgdGhlIHNlbGVjdC4gKi9cbiAgaXNGb2N1c2VkOiBib29sZWFuO1xuICBpc0Rpc2FibGVkOiBib29sZWFuO1xufVxuXG5jb25zdCBiYXNlQ1NTID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KFxuICB7XG4gICAgaXNGb2N1c2VkLFxuICAgIHRoZW1lOiB7XG4gICAgICBzcGFjaW5nOiB7IGJhc2VVbml0IH0sXG4gICAgICBjb2xvcnMsXG4gICAgfSxcbiAgfTpcbiAgICB8IERyb3Bkb3duSW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD5cbiAgICB8IENsZWFySW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD4sXG4gIHVuc3R5bGVkOiBib29sZWFuXG4pOiBDU1NPYmplY3RXaXRoTGFiZWwgPT4gKHtcbiAgbGFiZWw6ICdpbmRpY2F0b3JDb250YWluZXInLFxuICBkaXNwbGF5OiAnZmxleCcsXG4gIHRyYW5zaXRpb246ICdjb2xvciAxNTBtcycsXG4gIC4uLih1bnN0eWxlZFxuICAgID8ge31cbiAgICA6IHtcbiAgICAgICAgY29sb3I6IGlzRm9jdXNlZCA/IGNvbG9ycy5uZXV0cmFsNjAgOiBjb2xvcnMubmV1dHJhbDIwLFxuICAgICAgICBwYWRkaW5nOiBiYXNlVW5pdCAqIDIsXG4gICAgICAgICc6aG92ZXInOiB7XG4gICAgICAgICAgY29sb3I6IGlzRm9jdXNlZCA/IGNvbG9ycy5uZXV0cmFsODAgOiBjb2xvcnMubmV1dHJhbDQwLFxuICAgICAgICB9LFxuICAgICAgfSksXG59KTtcblxuZXhwb3J0IGNvbnN0IGRyb3Bkb3duSW5kaWNhdG9yQ1NTID0gYmFzZUNTUztcbmV4cG9ydCBjb25zdCBEcm9wZG93bkluZGljYXRvciA9IDxcbiAgT3B0aW9uLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbixcbiAgR3JvdXAgZXh0ZW5kcyBHcm91cEJhc2U8T3B0aW9uPlxuPihcbiAgcHJvcHM6IERyb3Bkb3duSW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD5cbikgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuLCBpbm5lclByb3BzIH0gPSBwcm9wcztcbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICB7Li4uZ2V0U3R5bGVQcm9wcyhwcm9wcywgJ2Ryb3Bkb3duSW5kaWNhdG9yJywge1xuICAgICAgICBpbmRpY2F0b3I6IHRydWUsXG4gICAgICAgICdkcm9wZG93bi1pbmRpY2F0b3InOiB0cnVlLFxuICAgICAgfSl9XG4gICAgICB7Li4uaW5uZXJQcm9wc31cbiAgICA+XG4gICAgICB7Y2hpbGRyZW4gfHwgPERvd25DaGV2cm9uIC8+fVxuICAgIDwvZGl2PlxuICApO1xufTtcblxuZXhwb3J0IGludGVyZmFjZSBDbGVhckluZGljYXRvclByb3BzPFxuICBPcHRpb24gPSB1bmtub3duLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbiA9IGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj4gPSBHcm91cEJhc2U8T3B0aW9uPlxuPiBleHRlbmRzIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+IHtcbiAgLyoqIFRoZSBjaGlsZHJlbiB0byBiZSByZW5kZXJlZCBpbnNpZGUgdGhlIGluZGljYXRvci4gKi9cbiAgY2hpbGRyZW4/OiBSZWFjdE5vZGU7XG4gIC8qKiBQcm9wcyB0aGF0IHdpbGwgYmUgcGFzc2VkIG9uIHRvIHRoZSBjaGlsZHJlbi4gKi9cbiAgaW5uZXJQcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydkaXYnXTtcbiAgLyoqIFRoZSBmb2N1c2VkIHN0YXRlIG9mIHRoZSBzZWxlY3QuICovXG4gIGlzRm9jdXNlZDogYm9vbGVhbjtcbn1cblxuZXhwb3J0IGNvbnN0IGNsZWFySW5kaWNhdG9yQ1NTID0gYmFzZUNTUztcbmV4cG9ydCBjb25zdCBDbGVhckluZGljYXRvciA9IDxcbiAgT3B0aW9uLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbixcbiAgR3JvdXAgZXh0ZW5kcyBHcm91cEJhc2U8T3B0aW9uPlxuPihcbiAgcHJvcHM6IENsZWFySW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD5cbikgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuLCBpbm5lclByb3BzIH0gPSBwcm9wcztcbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICB7Li4uZ2V0U3R5bGVQcm9wcyhwcm9wcywgJ2NsZWFySW5kaWNhdG9yJywge1xuICAgICAgICBpbmRpY2F0b3I6IHRydWUsXG4gICAgICAgICdjbGVhci1pbmRpY2F0b3InOiB0cnVlLFxuICAgICAgfSl9XG4gICAgICB7Li4uaW5uZXJQcm9wc31cbiAgICA+XG4gICAgICB7Y2hpbGRyZW4gfHwgPENyb3NzSWNvbiAvPn1cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5cbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuLy8gU2VwYXJhdG9yXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuZXhwb3J0IGludGVyZmFjZSBJbmRpY2F0b3JTZXBhcmF0b3JQcm9wczxcbiAgT3B0aW9uID0gdW5rbm93bixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4gPSBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+ID0gR3JvdXBCYXNlPE9wdGlvbj5cbj4gZXh0ZW5kcyBDb21tb25Qcm9wc0FuZENsYXNzTmFtZTxPcHRpb24sIElzTXVsdGksIEdyb3VwPiB7XG4gIGlzRGlzYWJsZWQ6IGJvb2xlYW47XG4gIGlzRm9jdXNlZDogYm9vbGVhbjtcbiAgaW5uZXJQcm9wcz86IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snc3BhbiddO1xufVxuXG5leHBvcnQgY29uc3QgaW5kaWNhdG9yU2VwYXJhdG9yQ1NTID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KFxuICB7XG4gICAgaXNEaXNhYmxlZCxcbiAgICB0aGVtZToge1xuICAgICAgc3BhY2luZzogeyBiYXNlVW5pdCB9LFxuICAgICAgY29sb3JzLFxuICAgIH0sXG4gIH06IEluZGljYXRvclNlcGFyYXRvclByb3BzPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+LFxuICB1bnN0eWxlZDogYm9vbGVhblxuKTogQ1NTT2JqZWN0V2l0aExhYmVsID0+ICh7XG4gIGxhYmVsOiAnaW5kaWNhdG9yU2VwYXJhdG9yJyxcbiAgYWxpZ25TZWxmOiAnc3RyZXRjaCcsXG4gIHdpZHRoOiAxLFxuICAuLi4odW5zdHlsZWRcbiAgICA/IHt9XG4gICAgOiB7XG4gICAgICAgIGJhY2tncm91bmRDb2xvcjogaXNEaXNhYmxlZCA/IGNvbG9ycy5uZXV0cmFsMTAgOiBjb2xvcnMubmV1dHJhbDIwLFxuICAgICAgICBtYXJnaW5Cb3R0b206IGJhc2VVbml0ICogMixcbiAgICAgICAgbWFyZ2luVG9wOiBiYXNlVW5pdCAqIDIsXG4gICAgICB9KSxcbn0pO1xuXG5leHBvcnQgY29uc3QgSW5kaWNhdG9yU2VwYXJhdG9yID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KFxuICBwcm9wczogSW5kaWNhdG9yU2VwYXJhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD5cbikgPT4ge1xuICBjb25zdCB7IGlubmVyUHJvcHMgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxzcGFuXG4gICAgICB7Li4uaW5uZXJQcm9wc31cbiAgICAgIHsuLi5nZXRTdHlsZVByb3BzKHByb3BzLCAnaW5kaWNhdG9yU2VwYXJhdG9yJywge1xuICAgICAgICAnaW5kaWNhdG9yLXNlcGFyYXRvcic6IHRydWUsXG4gICAgICB9KX1cbiAgICAvPlxuICApO1xufTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBMb2FkaW5nXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuY29uc3QgbG9hZGluZ0RvdEFuaW1hdGlvbnMgPSBrZXlmcmFtZXNgXG4gIDAlLCA4MCUsIDEwMCUgeyBvcGFjaXR5OiAwOyB9XG4gIDQwJSB7IG9wYWNpdHk6IDE7IH1cbmA7XG5cbmV4cG9ydCBjb25zdCBsb2FkaW5nSW5kaWNhdG9yQ1NTID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KFxuICB7XG4gICAgaXNGb2N1c2VkLFxuICAgIHNpemUsXG4gICAgdGhlbWU6IHtcbiAgICAgIGNvbG9ycyxcbiAgICAgIHNwYWNpbmc6IHsgYmFzZVVuaXQgfSxcbiAgICB9LFxuICB9OiBMb2FkaW5nSW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD4sXG4gIHVuc3R5bGVkOiBib29sZWFuXG4pOiBDU1NPYmplY3RXaXRoTGFiZWwgPT4gKHtcbiAgbGFiZWw6ICdsb2FkaW5nSW5kaWNhdG9yJyxcbiAgZGlzcGxheTogJ2ZsZXgnLFxuICB0cmFuc2l0aW9uOiAnY29sb3IgMTUwbXMnLFxuICBhbGlnblNlbGY6ICdjZW50ZXInLFxuICBmb250U2l6ZTogc2l6ZSxcbiAgbGluZUhlaWdodDogMSxcbiAgbWFyZ2luUmlnaHQ6IHNpemUsXG4gIHRleHRBbGlnbjogJ2NlbnRlcicsXG4gIHZlcnRpY2FsQWxpZ246ICdtaWRkbGUnLFxuICAuLi4odW5zdHlsZWRcbiAgICA/IHt9XG4gICAgOiB7XG4gICAgICAgIGNvbG9yOiBpc0ZvY3VzZWQgPyBjb2xvcnMubmV1dHJhbDYwIDogY29sb3JzLm5ldXRyYWwyMCxcbiAgICAgICAgcGFkZGluZzogYmFzZVVuaXQgKiAyLFxuICAgICAgfSksXG59KTtcblxuaW50ZXJmYWNlIExvYWRpbmdEb3RQcm9wcyB7XG4gIGRlbGF5OiBudW1iZXI7XG4gIG9mZnNldDogYm9vbGVhbjtcbn1cbmNvbnN0IExvYWRpbmdEb3QgPSAoeyBkZWxheSwgb2Zmc2V0IH06IExvYWRpbmdEb3RQcm9wcykgPT4gKFxuICA8c3BhblxuICAgIGNzcz17e1xuICAgICAgYW5pbWF0aW9uOiBgJHtsb2FkaW5nRG90QW5pbWF0aW9uc30gMXMgZWFzZS1pbi1vdXQgJHtkZWxheX1tcyBpbmZpbml0ZTtgLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiAnY3VycmVudENvbG9yJyxcbiAgICAgIGJvcmRlclJhZGl1czogJzFlbScsXG4gICAgICBkaXNwbGF5OiAnaW5saW5lLWJsb2NrJyxcbiAgICAgIG1hcmdpbkxlZnQ6IG9mZnNldCA/ICcxZW0nIDogdW5kZWZpbmVkLFxuICAgICAgaGVpZ2h0OiAnMWVtJyxcbiAgICAgIHZlcnRpY2FsQWxpZ246ICd0b3AnLFxuICAgICAgd2lkdGg6ICcxZW0nLFxuICAgIH19XG4gIC8+XG4pO1xuXG5leHBvcnQgaW50ZXJmYWNlIExvYWRpbmdJbmRpY2F0b3JQcm9wczxcbiAgT3B0aW9uID0gdW5rbm93bixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4gPSBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+ID0gR3JvdXBCYXNlPE9wdGlvbj5cbj4gZXh0ZW5kcyBDb21tb25Qcm9wc0FuZENsYXNzTmFtZTxPcHRpb24sIElzTXVsdGksIEdyb3VwPiB7XG4gIC8qKiBQcm9wcyB0aGF0IHdpbGwgYmUgcGFzc2VkIG9uIHRvIHRoZSBjaGlsZHJlbi4gKi9cbiAgaW5uZXJQcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydkaXYnXTtcbiAgLyoqIFRoZSBmb2N1c2VkIHN0YXRlIG9mIHRoZSBzZWxlY3QuICovXG4gIGlzRm9jdXNlZDogYm9vbGVhbjtcbiAgaXNEaXNhYmxlZDogYm9vbGVhbjtcbiAgLyoqIFNldCBzaXplIG9mIHRoZSBjb250YWluZXIuICovXG4gIHNpemU6IG51bWJlcjtcbn1cbmV4cG9ydCBjb25zdCBMb2FkaW5nSW5kaWNhdG9yID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KHtcbiAgaW5uZXJQcm9wcyxcbiAgaXNSdGwsXG4gIHNpemUgPSA0LFxuICAuLi5yZXN0UHJvcHNcbn06IExvYWRpbmdJbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPikgPT4ge1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIHsuLi5nZXRTdHlsZVByb3BzKFxuICAgICAgICB7IC4uLnJlc3RQcm9wcywgaW5uZXJQcm9wcywgaXNSdGwsIHNpemUgfSxcbiAgICAgICAgJ2xvYWRpbmdJbmRpY2F0b3InLFxuICAgICAgICB7XG4gICAgICAgICAgaW5kaWNhdG9yOiB0cnVlLFxuICAgICAgICAgICdsb2FkaW5nLWluZGljYXRvcic6IHRydWUsXG4gICAgICAgIH1cbiAgICAgICl9XG4gICAgICB7Li4uaW5uZXJQcm9wc31cbiAgICA+XG4gICAgICA8TG9hZGluZ0RvdCBkZWxheT17MH0gb2Zmc2V0PXtpc1J0bH0gLz5cbiAgICAgIDxMb2FkaW5nRG90IGRlbGF5PXsxNjB9IG9mZnNldCAvPlxuICAgICAgPExvYWRpbmdEb3QgZGVsYXk9ezMyMH0gb2Zmc2V0PXshaXNSdGx9IC8+XG4gICAgPC9kaXY+XG4gICk7XG59O1xuIl19 */")
  });
}, gy = function(t) {
  var n = t.innerProps, r = t.isRtl, o = t.size, i = o === void 0 ? 4 : o, s = In(t, sy);
  return le("div", Ae({}, Ue(de(de({}, s), {}, {
    innerProps: n,
    isRtl: r,
    size: i
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), le(yc, {
    delay: 0,
    offset: r
  }), le(yc, {
    delay: 160,
    offset: !0
  }), le(yc, {
    delay: 320,
    offset: !r
  }));
}, by = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, i = t.theme, s = i.colors, a = i.borderRadius, c = i.spacing;
  return de({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: c.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: r ? s.neutral5 : s.neutral0,
    borderColor: r ? s.neutral10 : o ? s.primary : s.neutral20,
    borderRadius: a,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: o ? "0 0 0 1px ".concat(s.primary) : void 0,
    "&:hover": {
      borderColor: o ? s.primary : s.neutral30
    }
  });
}, vy = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, i = t.innerRef, s = t.innerProps, a = t.menuIsOpen;
  return le("div", Ae({
    ref: i
  }, Ue(t, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": o,
    "control--menu-is-open": a
  }), s, {
    "aria-disabled": r || void 0
  }), n);
}, yy = vy, Cy = ["data"], xy = function(t, n) {
  var r = t.theme.spacing;
  return n ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, wy = function(t) {
  var n = t.children, r = t.cx, o = t.getStyles, i = t.getClassNames, s = t.Heading, a = t.headingProps, c = t.innerProps, u = t.label, l = t.theme, d = t.selectProps;
  return le("div", Ae({}, Ue(t, "group", {
    group: !0
  }), c), le(s, Ae({}, a, {
    selectProps: d,
    theme: l,
    getStyles: o,
    getClassNames: i,
    cx: r
  }), u), le("div", null, n));
}, Iy = function(t, n) {
  var r = t.theme, o = r.colors, i = r.spacing;
  return de({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: o.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: i.baseUnit * 3,
    paddingRight: i.baseUnit * 3,
    textTransform: "uppercase"
  });
}, Ey = function(t) {
  var n = rp(t);
  n.data;
  var r = In(n, Cy);
  return le("div", Ae({}, Ue(t, "groupHeading", {
    "group-heading": !0
  }), r));
}, Sy = wy, Ty = ["innerRef", "isDisabled", "isHidden", "inputClassName"], Ny = function(t, n) {
  var r = t.isDisabled, o = t.value, i = t.theme, s = i.spacing, a = i.colors;
  return de(de({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: o ? "translateZ(0)" : ""
  }, Py), n ? {} : {
    margin: s.baseUnit / 2,
    paddingBottom: s.baseUnit / 2,
    paddingTop: s.baseUnit / 2,
    color: a.neutral80
  });
}, Ap = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, Py = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": de({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, Ap)
}, Ry = function(t) {
  return de({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, Ap);
}, Oy = function(t) {
  var n = t.cx, r = t.value, o = rp(t), i = o.innerRef, s = o.isDisabled, a = o.isHidden, c = o.inputClassName, u = In(o, Ty);
  return le("div", Ae({}, Ue(t, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), le("input", Ae({
    className: n({
      input: !0
    }, c),
    ref: i,
    style: Ry(a),
    disabled: s
  }, u)));
}, Dy = Oy, My = function(t, n) {
  var r = t.theme, o = r.spacing, i = r.borderRadius, s = r.colors;
  return de({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: s.neutral10,
    borderRadius: i / 2,
    margin: o.baseUnit / 2
  });
}, Fy = function(t, n) {
  var r = t.theme, o = r.borderRadius, i = r.colors, s = t.cropWithEllipsis;
  return de({
    overflow: "hidden",
    textOverflow: s || s === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: o / 2,
    color: i.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, Vy = function(t, n) {
  var r = t.theme, o = r.spacing, i = r.borderRadius, s = r.colors, a = t.isFocused;
  return de({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: i / 2,
    backgroundColor: a ? s.dangerLight : void 0,
    paddingLeft: o.baseUnit,
    paddingRight: o.baseUnit,
    ":hover": {
      backgroundColor: s.dangerLight,
      color: s.danger
    }
  });
}, fp = function(t) {
  var n = t.children, r = t.innerProps;
  return le("div", r, n);
}, By = fp, ky = fp;
function Ly(e) {
  var t = e.children, n = e.innerProps;
  return le("div", Ae({
    role: "button"
  }, n), t || le(sd, {
    size: 14
  }));
}
var Hy = function(t) {
  var n = t.children, r = t.components, o = t.data, i = t.innerProps, s = t.isDisabled, a = t.removeProps, c = t.selectProps, u = r.Container, l = r.Label, d = r.Remove;
  return le(u, {
    data: o,
    innerProps: de(de({}, Ue(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": s
    })), i),
    selectProps: c
  }, le(l, {
    data: o,
    innerProps: de({}, Ue(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: c
  }, n), le(d, {
    data: o,
    innerProps: de(de({}, Ue(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, a),
    selectProps: c
  }));
}, Xy = Hy, Wy = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, i = t.isSelected, s = t.theme, a = s.spacing, c = s.colors;
  return de({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: i ? c.primary : o ? c.primary25 : "transparent",
    color: r ? c.neutral20 : i ? c.neutral0 : "inherit",
    padding: "".concat(a.baseUnit * 2, "px ").concat(a.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : i ? c.primary : c.primary50
    }
  });
}, Zy = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, i = t.isSelected, s = t.innerRef, a = t.innerProps;
  return le("div", Ae({}, Ue(t, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": o,
    "option--is-selected": i
  }), {
    ref: s,
    "aria-disabled": r
  }, a), n);
}, zy = Zy, Gy = function(t, n) {
  var r = t.theme, o = r.spacing, i = r.colors;
  return de({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: i.neutral50,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, jy = function(t) {
  var n = t.children, r = t.innerProps;
  return le("div", Ae({}, Ue(t, "placeholder", {
    placeholder: !0
  }), r), n);
}, Uy = jy, Qy = function(t, n) {
  var r = t.isDisabled, o = t.theme, i = o.spacing, s = o.colors;
  return de({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: r ? s.neutral40 : s.neutral80,
    marginLeft: i.baseUnit / 2,
    marginRight: i.baseUnit / 2
  });
}, qy = function(t) {
  var n = t.children, r = t.isDisabled, o = t.innerProps;
  return le("div", Ae({}, Ue(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), o), n);
}, Yy = qy, Za = {
  ClearIndicator: Ay,
  Control: yy,
  DropdownIndicator: ly,
  DownChevron: lp,
  CrossIcon: sd,
  Group: Sy,
  GroupHeading: Ey,
  IndicatorsContainer: oy,
  IndicatorSeparator: hy,
  Input: Dy,
  LoadingIndicator: gy,
  Menu: G7,
  MenuList: U7,
  MenuPortal: _7,
  LoadingMessage: J7,
  NoOptionsMessage: Y7,
  MultiValue: Xy,
  MultiValueContainer: By,
  MultiValueLabel: ky,
  MultiValueRemove: Ly,
  Option: zy,
  Placeholder: Uy,
  SelectContainer: ey,
  SingleValue: Yy,
  ValueContainer: ny
}, Jy = function(t) {
  return de(de({}, Za), t.components);
}, $A = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Ky(e, t) {
  return !!(e === t || $A(e) && $A(t));
}
function _y(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!Ky(e[n], t[n]))
      return !1;
  return !0;
}
function $y(e, t) {
  t === void 0 && (t = _y);
  var n = null;
  function r() {
    for (var o = [], i = 0; i < arguments.length; i++)
      o[i] = arguments[i];
    if (n && n.lastThis === this && t(o, n.lastArgs))
      return n.lastResult;
    var s = e.apply(this, o);
    return n = {
      lastResult: s,
      lastArgs: o,
      lastThis: this
    }, s;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
function e8() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var t8 = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: e8
}, n8 = function(t) {
  return le("span", Ae({
    css: t8
  }, t));
}, e1 = n8, r8 = {
  guidance: function(t) {
    var n = t.isSearchable, r = t.isMulti, o = t.tabSelectsValue, i = t.context, s = t.isInitialFocus;
    switch (i) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(o ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return s ? "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, r = t.label, o = r === void 0 ? "" : r, i = t.labels, s = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(o, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(i.length > 1 ? "s" : "", " ").concat(i.join(","), ", selected.");
      case "select-option":
        return s ? "option ".concat(o, " is disabled. Select another option.") : "option ".concat(o, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, r = t.focused, o = t.options, i = t.label, s = i === void 0 ? "" : i, a = t.selectValue, c = t.isDisabled, u = t.isSelected, l = t.isAppleDevice, d = function(g, m) {
      return g && g.length ? "".concat(g.indexOf(m) + 1, " of ").concat(g.length) : "";
    };
    if (n === "value" && a)
      return "value ".concat(s, " focused, ").concat(d(a, r), ".");
    if (n === "menu" && l) {
      var f = c ? " disabled" : "", p = "".concat(u ? " selected" : "").concat(f);
      return "".concat(s).concat(p, ", ").concat(d(o, r), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, r = t.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, o8 = function(t) {
  var n = t.ariaSelection, r = t.focusedOption, o = t.focusedValue, i = t.focusableOptions, s = t.isFocused, a = t.selectValue, c = t.selectProps, u = t.id, l = t.isAppleDevice, d = c.ariaLiveMessages, f = c.getOptionLabel, p = c.inputValue, h = c.isMulti, g = c.isOptionDisabled, m = c.isSearchable, b = c.menuIsOpen, v = c.options, C = c.screenReaderStatus, w = c.tabSelectsValue, y = c.isLoading, I = c["aria-label"], x = c["aria-live"], E = ve(function() {
    return de(de({}, r8), d || {});
  }, [d]), P = ve(function() {
    var M = "";
    if (n && E.onChange) {
      var F = n.option, B = n.options, Z = n.removedValue, H = n.removedValues, K = n.value, ee = function(Te) {
        return Array.isArray(Te) ? null : Te;
      }, z = Z || F || ee(K), ce = z ? f(z) : "", be = B || H || void 0, te = be ? be.map(f) : [], ue = de({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: z && g(z, a),
        label: ce,
        labels: te
      }, n);
      M = E.onChange(ue);
    }
    return M;
  }, [n, E, g, a, f]), L = ve(function() {
    var M = "", F = r || o, B = !!(r && a && a.includes(r));
    if (F && E.onFocus) {
      var Z = {
        focused: F,
        label: f(F),
        isDisabled: g(F, a),
        isSelected: B,
        options: i,
        context: F === r ? "menu" : "value",
        selectValue: a,
        isAppleDevice: l
      };
      M = E.onFocus(Z);
    }
    return M;
  }, [r, o, f, g, E, i, a, l]), W = ve(function() {
    var M = "";
    if (b && v.length && !y && E.onFilter) {
      var F = C({
        count: i.length
      });
      M = E.onFilter({
        inputValue: p,
        resultsMessage: F
      });
    }
    return M;
  }, [i, p, b, E, v, C, y]), V = (n == null ? void 0 : n.action) === "initial-input-focus", X = ve(function() {
    var M = "";
    if (E.guidance) {
      var F = o ? "value" : b ? "menu" : "input";
      M = E.guidance({
        "aria-label": I,
        context: F,
        isDisabled: r && g(r, a),
        isMulti: h,
        isSearchable: m,
        tabSelectsValue: w,
        isInitialFocus: V
      });
    }
    return M;
  }, [I, r, o, h, g, m, b, E, a, w, V]), N = le(mr, null, le("span", {
    id: "aria-selection"
  }, P), le("span", {
    id: "aria-focused"
  }, L), le("span", {
    id: "aria-results"
  }, W), le("span", {
    id: "aria-guidance"
  }, X));
  return le(mr, null, le(e1, {
    id: u
  }, V && N), le(e1, {
    "aria-live": x,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, s && !V && N));
}, i8 = o8, Nu = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], s8 = new RegExp("[" + Nu.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), hp = {};
for (var Cc = 0; Cc < Nu.length; Cc++)
  for (var xc = Nu[Cc], wc = 0; wc < xc.letters.length; wc++)
    hp[xc.letters[wc]] = xc.base;
var pp = function(t) {
  return t.replace(s8, function(n) {
    return hp[n];
  });
}, a8 = $y(pp), t1 = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, c8 = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, u8 = function(t) {
  return function(n, r) {
    if (n.data.__isNew__) return !0;
    var o = de({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: c8,
      trim: !0,
      matchFrom: "any"
    }, t), i = o.ignoreCase, s = o.ignoreAccents, a = o.stringify, c = o.trim, u = o.matchFrom, l = c ? t1(r) : r, d = c ? t1(a(n)) : a(n);
    return i && (l = l.toLowerCase(), d = d.toLowerCase()), s && (l = a8(l), d = pp(d)), u === "start" ? d.substr(0, l.length) === l : d.indexOf(l) > -1;
  };
}, l8 = ["innerRef"];
function d8(e) {
  var t = e.innerRef, n = In(e, l8), r = B7(n, "onExited", "in", "enter", "exit", "appear");
  return le("input", Ae({
    ref: t
  }, r, {
    css: /* @__PURE__ */ id({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var A8 = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function f8(e) {
  var t = e.isEnabled, n = e.onBottomArrive, r = e.onBottomLeave, o = e.onTopArrive, i = e.onTopLeave, s = Ce(!1), a = Ce(!1), c = Ce(0), u = Ce(null), l = ye(function(m, b) {
    if (u.current !== null) {
      var v = u.current, C = v.scrollTop, w = v.scrollHeight, y = v.clientHeight, I = u.current, x = b > 0, E = w - y - C, P = !1;
      E > b && s.current && (r && r(m), s.current = !1), x && a.current && (i && i(m), a.current = !1), x && b > E ? (n && !s.current && n(m), I.scrollTop = w, P = !0, s.current = !0) : !x && -b > C && (o && !a.current && o(m), I.scrollTop = 0, P = !0, a.current = !0), P && A8(m);
    }
  }, [n, r, o, i]), d = ye(function(m) {
    l(m, m.deltaY);
  }, [l]), f = ye(function(m) {
    c.current = m.changedTouches[0].clientY;
  }, []), p = ye(function(m) {
    var b = c.current - m.changedTouches[0].clientY;
    l(m, b);
  }, [l]), h = ye(function(m) {
    if (m) {
      var b = M7 ? {
        passive: !1
      } : !1;
      m.addEventListener("wheel", d, b), m.addEventListener("touchstart", f, b), m.addEventListener("touchmove", p, b);
    }
  }, [p, f, d]), g = ye(function(m) {
    m && (m.removeEventListener("wheel", d, !1), m.removeEventListener("touchstart", f, !1), m.removeEventListener("touchmove", p, !1));
  }, [p, f, d]);
  return Ie(function() {
    if (t) {
      var m = u.current;
      return h(m), function() {
        g(m);
      };
    }
  }, [t, h, g]), function(m) {
    u.current = m;
  };
}
var n1 = ["boxSizing", "height", "overflow", "paddingRight", "position"], r1 = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function o1(e) {
  e.preventDefault();
}
function i1(e) {
  e.stopPropagation();
}
function s1() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function a1() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var c1 = !!(typeof window < "u" && window.document && window.document.createElement), Uo = 0, Xr = {
  capture: !1,
  passive: !1
};
function h8(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, r = n === void 0 ? !0 : n, o = Ce({}), i = Ce(null), s = ye(function(c) {
    if (c1) {
      var u = document.body, l = u && u.style;
      if (r && n1.forEach(function(h) {
        var g = l && l[h];
        o.current[h] = g;
      }), r && Uo < 1) {
        var d = parseInt(o.current.paddingRight, 10) || 0, f = document.body ? document.body.clientWidth : 0, p = window.innerWidth - f + d || 0;
        Object.keys(r1).forEach(function(h) {
          var g = r1[h];
          l && (l[h] = g);
        }), l && (l.paddingRight = "".concat(p, "px"));
      }
      u && a1() && (u.addEventListener("touchmove", o1, Xr), c && (c.addEventListener("touchstart", s1, Xr), c.addEventListener("touchmove", i1, Xr))), Uo += 1;
    }
  }, [r]), a = ye(function(c) {
    if (c1) {
      var u = document.body, l = u && u.style;
      Uo = Math.max(Uo - 1, 0), r && Uo < 1 && n1.forEach(function(d) {
        var f = o.current[d];
        l && (l[d] = f);
      }), u && a1() && (u.removeEventListener("touchmove", o1, Xr), c && (c.removeEventListener("touchstart", s1, Xr), c.removeEventListener("touchmove", i1, Xr)));
    }
  }, [r]);
  return Ie(function() {
    if (t) {
      var c = i.current;
      return s(c), function() {
        a(c);
      };
    }
  }, [t, s, a]), function(c) {
    i.current = c;
  };
}
function p8() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var m8 = function(t) {
  var n = t.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, g8 = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: p8
};
function b8(e) {
  var t = e.children, n = e.lockEnabled, r = e.captureEnabled, o = r === void 0 ? !0 : r, i = e.onBottomArrive, s = e.onBottomLeave, a = e.onTopArrive, c = e.onTopLeave, u = f8({
    isEnabled: o,
    onBottomArrive: i,
    onBottomLeave: s,
    onTopArrive: a,
    onTopLeave: c
  }), l = h8({
    isEnabled: n
  }), d = function(p) {
    u(p), l(p);
  };
  return le(mr, null, n && le("div", {
    onClick: m8,
    css: g8
  }), t(d));
}
function v8() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var y8 = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: v8
}, C8 = function(t) {
  var n = t.name, r = t.onFocus;
  return le("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: r,
    css: y8,
    value: "",
    onChange: function() {
    }
  });
}, x8 = C8;
function ad(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function w8() {
  return ad(/^iPhone/i);
}
function mp() {
  return ad(/^Mac/i);
}
function I8() {
  return ad(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  mp() && navigator.maxTouchPoints > 1;
}
function E8() {
  return w8() || I8();
}
function S8() {
  return mp() || E8();
}
var T8 = function(t) {
  return t.label;
}, N8 = function(t) {
  return t.label;
}, P8 = function(t) {
  return t.value;
}, R8 = function(t) {
  return !!t.isDisabled;
}, O8 = {
  clearIndicator: dy,
  container: $7,
  control: by,
  dropdownIndicator: uy,
  group: xy,
  groupHeading: Iy,
  indicatorsContainer: ry,
  indicatorSeparator: fy,
  input: Ny,
  loadingIndicator: my,
  loadingMessage: q7,
  menu: W7,
  menuList: j7,
  menuPortal: K7,
  multiValue: My,
  multiValueLabel: Fy,
  multiValueRemove: Vy,
  noOptionsMessage: Q7,
  option: Wy,
  placeholder: Gy,
  singleValue: Qy,
  valueContainer: ty
}, D8 = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, M8 = 4, gp = 4, F8 = 38, V8 = gp * 2, B8 = {
  baseUnit: gp,
  controlHeight: F8,
  menuGutter: V8
}, Ic = {
  borderRadius: M8,
  colors: D8,
  spacing: B8
}, k8 = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: KA(),
  captureMenuScroll: !KA(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: u8(),
  formatGroupLabel: T8,
  getOptionLabel: N8,
  getOptionValue: P8,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: R8,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !O7(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function u1(e, t, n, r) {
  var o = yp(e, t, n), i = Cp(e, t, n), s = vp(e, t), a = aa(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: o,
    isSelected: i,
    label: s,
    value: a,
    index: r
  };
}
function Zs(e, t) {
  return e.options.map(function(n, r) {
    if ("options" in n) {
      var o = n.options.map(function(s, a) {
        return u1(e, s, t, a);
      }).filter(function(s) {
        return d1(e, s);
      });
      return o.length > 0 ? {
        type: "group",
        data: n,
        options: o,
        index: r
      } : void 0;
    }
    var i = u1(e, n, t, r);
    return d1(e, i) ? i : void 0;
  }).filter(F7);
}
function bp(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, ed(n.options.map(function(r) {
      return r.data;
    }))) : t.push(n.data), t;
  }, []);
}
function l1(e, t) {
  return e.reduce(function(n, r) {
    return r.type === "group" ? n.push.apply(n, ed(r.options.map(function(o) {
      return {
        data: o.data,
        id: "".concat(t, "-").concat(r.index, "-").concat(o.index)
      };
    }))) : n.push({
      data: r.data,
      id: "".concat(t, "-").concat(r.index)
    }), n;
  }, []);
}
function L8(e, t) {
  return bp(Zs(e, t));
}
function d1(e, t) {
  var n = e.inputValue, r = n === void 0 ? "" : n, o = t.data, i = t.isSelected, s = t.label, a = t.value;
  return (!wp(e) || !i) && xp(e, {
    label: s,
    value: a,
    data: o
  }, r);
}
function H8(e, t) {
  var n = e.focusedValue, r = e.selectValue, o = r.indexOf(n);
  if (o > -1) {
    var i = t.indexOf(n);
    if (i > -1)
      return n;
    if (o < t.length)
      return t[o];
  }
  return null;
}
function X8(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var Ec = function(t, n) {
  var r, o = (r = t.find(function(i) {
    return i.data === n;
  })) === null || r === void 0 ? void 0 : r.id;
  return o || null;
}, vp = function(t, n) {
  return t.getOptionLabel(n);
}, aa = function(t, n) {
  return t.getOptionValue(n);
};
function yp(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function Cp(e, t, n) {
  if (n.indexOf(t) > -1) return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var r = aa(e, t);
  return n.some(function(o) {
    return aa(e, o) === r;
  });
}
function xp(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var wp = function(t) {
  var n = t.hideSelectedOptions, r = t.isMulti;
  return n === void 0 ? r : n;
}, W8 = 1, Ip = /* @__PURE__ */ function(e) {
  f4(n, e);
  var t = m4(n);
  function n(r) {
    var o;
    if (d4(this, n), o = t.call(this, r), o.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, o.blockOptionHover = !1, o.isComposing = !1, o.commonProps = void 0, o.initialTouchX = 0, o.initialTouchY = 0, o.openAfterFocus = !1, o.scrollToFocusedOptionOnUpdate = !1, o.userIsDragging = void 0, o.isAppleDevice = S8(), o.controlRef = null, o.getControlRef = function(c) {
      o.controlRef = c;
    }, o.focusedOptionRef = null, o.getFocusedOptionRef = function(c) {
      o.focusedOptionRef = c;
    }, o.menuListRef = null, o.getMenuListRef = function(c) {
      o.menuListRef = c;
    }, o.inputRef = null, o.getInputRef = function(c) {
      o.inputRef = c;
    }, o.focus = o.focusInput, o.blur = o.blurInput, o.onChange = function(c, u) {
      var l = o.props, d = l.onChange, f = l.name;
      u.name = f, o.ariaOnChange(c, u), d(c, u);
    }, o.setValue = function(c, u, l) {
      var d = o.props, f = d.closeMenuOnSelect, p = d.isMulti, h = d.inputValue;
      o.onInputChange("", {
        action: "set-value",
        prevInputValue: h
      }), f && (o.setState({
        inputIsHiddenAfterUpdate: !p
      }), o.onMenuClose()), o.setState({
        clearFocusValueOnUpdate: !0
      }), o.onChange(c, {
        action: u,
        option: l
      });
    }, o.selectOption = function(c) {
      var u = o.props, l = u.blurInputOnSelect, d = u.isMulti, f = u.name, p = o.state.selectValue, h = d && o.isOptionSelected(c, p), g = o.isOptionDisabled(c, p);
      if (h) {
        var m = o.getOptionValue(c);
        o.setValue(p.filter(function(b) {
          return o.getOptionValue(b) !== m;
        }), "deselect-option", c);
      } else if (!g)
        d ? o.setValue([].concat(ed(p), [c]), "select-option", c) : o.setValue(c, "select-option");
      else {
        o.ariaOnChange(c, {
          action: "select-option",
          option: c,
          name: f
        });
        return;
      }
      l && o.blurInput();
    }, o.removeValue = function(c) {
      var u = o.props.isMulti, l = o.state.selectValue, d = o.getOptionValue(c), f = l.filter(function(h) {
        return o.getOptionValue(h) !== d;
      }), p = Cs(u, f, f[0] || null);
      o.onChange(p, {
        action: "remove-value",
        removedValue: c
      }), o.focusInput();
    }, o.clearValue = function() {
      var c = o.state.selectValue;
      o.onChange(Cs(o.props.isMulti, [], null), {
        action: "clear",
        removedValues: c
      });
    }, o.popValue = function() {
      var c = o.props.isMulti, u = o.state.selectValue, l = u[u.length - 1], d = u.slice(0, u.length - 1), f = Cs(c, d, d[0] || null);
      o.onChange(f, {
        action: "pop-value",
        removedValue: l
      });
    }, o.getFocusedOptionId = function(c) {
      return Ec(o.state.focusableOptionsWithIds, c);
    }, o.getFocusableOptionsWithIds = function() {
      return l1(Zs(o.props, o.state.selectValue), o.getElementId("option"));
    }, o.getValue = function() {
      return o.state.selectValue;
    }, o.cx = function() {
      for (var c = arguments.length, u = new Array(c), l = 0; l < c; l++)
        u[l] = arguments[l];
      return S7.apply(void 0, [o.props.classNamePrefix].concat(u));
    }, o.getOptionLabel = function(c) {
      return vp(o.props, c);
    }, o.getOptionValue = function(c) {
      return aa(o.props, c);
    }, o.getStyles = function(c, u) {
      var l = o.props.unstyled, d = O8[c](u, l);
      d.boxSizing = "border-box";
      var f = o.props.styles[c];
      return f ? f(d, u) : d;
    }, o.getClassNames = function(c, u) {
      var l, d;
      return (l = (d = o.props.classNames)[c]) === null || l === void 0 ? void 0 : l.call(d, u);
    }, o.getElementId = function(c) {
      return "".concat(o.state.instancePrefix, "-").concat(c);
    }, o.getComponents = function() {
      return Jy(o.props);
    }, o.buildCategorizedOptions = function() {
      return Zs(o.props, o.state.selectValue);
    }, o.getCategorizedOptions = function() {
      return o.props.menuIsOpen ? o.buildCategorizedOptions() : [];
    }, o.buildFocusableOptions = function() {
      return bp(o.buildCategorizedOptions());
    }, o.getFocusableOptions = function() {
      return o.props.menuIsOpen ? o.buildFocusableOptions() : [];
    }, o.ariaOnChange = function(c, u) {
      o.setState({
        ariaSelection: de({
          value: c
        }, u)
      });
    }, o.onMenuMouseDown = function(c) {
      c.button === 0 && (c.stopPropagation(), c.preventDefault(), o.focusInput());
    }, o.onMenuMouseMove = function(c) {
      o.blockOptionHover = !1;
    }, o.onControlMouseDown = function(c) {
      if (!c.defaultPrevented) {
        var u = o.props.openMenuOnClick;
        o.state.isFocused ? o.props.menuIsOpen ? c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && o.onMenuClose() : u && o.openMenu("first") : (u && (o.openAfterFocus = !0), o.focusInput()), c.target.tagName !== "INPUT" && c.target.tagName !== "TEXTAREA" && c.preventDefault();
      }
    }, o.onDropdownIndicatorMouseDown = function(c) {
      if (!(c && c.type === "mousedown" && c.button !== 0) && !o.props.isDisabled) {
        var u = o.props, l = u.isMulti, d = u.menuIsOpen;
        o.focusInput(), d ? (o.setState({
          inputIsHiddenAfterUpdate: !l
        }), o.onMenuClose()) : o.openMenu("first"), c.preventDefault();
      }
    }, o.onClearIndicatorMouseDown = function(c) {
      c && c.type === "mousedown" && c.button !== 0 || (o.clearValue(), c.preventDefault(), o.openAfterFocus = !1, c.type === "touchend" ? o.focusInput() : setTimeout(function() {
        return o.focusInput();
      }));
    }, o.onScroll = function(c) {
      typeof o.props.closeMenuOnScroll == "boolean" ? c.target instanceof HTMLElement && Wa(c.target) && o.props.onMenuClose() : typeof o.props.closeMenuOnScroll == "function" && o.props.closeMenuOnScroll(c) && o.props.onMenuClose();
    }, o.onCompositionStart = function() {
      o.isComposing = !0;
    }, o.onCompositionEnd = function() {
      o.isComposing = !1;
    }, o.onTouchStart = function(c) {
      var u = c.touches, l = u && u.item(0);
      l && (o.initialTouchX = l.clientX, o.initialTouchY = l.clientY, o.userIsDragging = !1);
    }, o.onTouchMove = function(c) {
      var u = c.touches, l = u && u.item(0);
      if (l) {
        var d = Math.abs(l.clientX - o.initialTouchX), f = Math.abs(l.clientY - o.initialTouchY), p = 5;
        o.userIsDragging = d > p || f > p;
      }
    }, o.onTouchEnd = function(c) {
      o.userIsDragging || (o.controlRef && !o.controlRef.contains(c.target) && o.menuListRef && !o.menuListRef.contains(c.target) && o.blurInput(), o.initialTouchX = 0, o.initialTouchY = 0);
    }, o.onControlTouchEnd = function(c) {
      o.userIsDragging || o.onControlMouseDown(c);
    }, o.onClearIndicatorTouchEnd = function(c) {
      o.userIsDragging || o.onClearIndicatorMouseDown(c);
    }, o.onDropdownIndicatorTouchEnd = function(c) {
      o.userIsDragging || o.onDropdownIndicatorMouseDown(c);
    }, o.handleInputChange = function(c) {
      var u = o.props.inputValue, l = c.currentTarget.value;
      o.setState({
        inputIsHiddenAfterUpdate: !1
      }), o.onInputChange(l, {
        action: "input-change",
        prevInputValue: u
      }), o.props.menuIsOpen || o.onMenuOpen();
    }, o.onInputFocus = function(c) {
      o.props.onFocus && o.props.onFocus(c), o.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (o.openAfterFocus || o.props.openMenuOnFocus) && o.openMenu("first"), o.openAfterFocus = !1;
    }, o.onInputBlur = function(c) {
      var u = o.props.inputValue;
      if (o.menuListRef && o.menuListRef.contains(document.activeElement)) {
        o.inputRef.focus();
        return;
      }
      o.props.onBlur && o.props.onBlur(c), o.onInputChange("", {
        action: "input-blur",
        prevInputValue: u
      }), o.onMenuClose(), o.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, o.onOptionHover = function(c) {
      if (!(o.blockOptionHover || o.state.focusedOption === c)) {
        var u = o.getFocusableOptions(), l = u.indexOf(c);
        o.setState({
          focusedOption: c,
          focusedOptionId: l > -1 ? o.getFocusedOptionId(c) : null
        });
      }
    }, o.shouldHideSelectedOptions = function() {
      return wp(o.props);
    }, o.onValueInputFocus = function(c) {
      c.preventDefault(), c.stopPropagation(), o.focus();
    }, o.onKeyDown = function(c) {
      var u = o.props, l = u.isMulti, d = u.backspaceRemovesValue, f = u.escapeClearsValue, p = u.inputValue, h = u.isClearable, g = u.isDisabled, m = u.menuIsOpen, b = u.onKeyDown, v = u.tabSelectsValue, C = u.openMenuOnFocus, w = o.state, y = w.focusedOption, I = w.focusedValue, x = w.selectValue;
      if (!g && !(typeof b == "function" && (b(c), c.defaultPrevented))) {
        switch (o.blockOptionHover = !0, c.key) {
          case "ArrowLeft":
            if (!l || p) return;
            o.focusValue("previous");
            break;
          case "ArrowRight":
            if (!l || p) return;
            o.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (p) return;
            if (I)
              o.removeValue(I);
            else {
              if (!d) return;
              l ? o.popValue() : h && o.clearValue();
            }
            break;
          case "Tab":
            if (o.isComposing || c.shiftKey || !m || !v || !y || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            C && o.isOptionSelected(y, x))
              return;
            o.selectOption(y);
            break;
          case "Enter":
            if (c.keyCode === 229)
              break;
            if (m) {
              if (!y || o.isComposing) return;
              o.selectOption(y);
              break;
            }
            return;
          case "Escape":
            m ? (o.setState({
              inputIsHiddenAfterUpdate: !1
            }), o.onInputChange("", {
              action: "menu-close",
              prevInputValue: p
            }), o.onMenuClose()) : h && f && o.clearValue();
            break;
          case " ":
            if (p)
              return;
            if (!m) {
              o.openMenu("first");
              break;
            }
            if (!y) return;
            o.selectOption(y);
            break;
          case "ArrowUp":
            m ? o.focusOption("up") : o.openMenu("last");
            break;
          case "ArrowDown":
            m ? o.focusOption("down") : o.openMenu("first");
            break;
          case "PageUp":
            if (!m) return;
            o.focusOption("pageup");
            break;
          case "PageDown":
            if (!m) return;
            o.focusOption("pagedown");
            break;
          case "Home":
            if (!m) return;
            o.focusOption("first");
            break;
          case "End":
            if (!m) return;
            o.focusOption("last");
            break;
          default:
            return;
        }
        c.preventDefault();
      }
    }, o.state.instancePrefix = "react-select-" + (o.props.instanceId || ++W8), o.state.selectValue = YA(r.value), r.menuIsOpen && o.state.selectValue.length) {
      var i = o.getFocusableOptionsWithIds(), s = o.buildFocusableOptions(), a = s.indexOf(o.state.selectValue[0]);
      o.state.focusableOptionsWithIds = i, o.state.focusedOption = s[a], o.state.focusedOptionId = Ec(i, s[a]);
    }
    return o;
  }
  return A4(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && JA(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var i = this.props, s = i.isDisabled, a = i.menuIsOpen, c = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (c && !s && o.isDisabled || // ensure focus is on the Input when the menu opens
      c && a && !o.menuIsOpen) && this.focusInput(), c && s && !o.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !c && !s && o.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (JA(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(o, i) {
      this.props.onInputChange(o, i);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(o) {
      var i = this, s = this.state, a = s.selectValue, c = s.isFocused, u = this.buildFocusableOptions(), l = o === "first" ? 0 : u.length - 1;
      if (!this.props.isMulti) {
        var d = u.indexOf(a[0]);
        d > -1 && (l = d);
      }
      this.scrollToFocusedOptionOnUpdate = !(c && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: u[l],
        focusedOptionId: this.getFocusedOptionId(u[l])
      }, function() {
        return i.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(o) {
      var i = this.state, s = i.selectValue, a = i.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var c = s.indexOf(a);
        a || (c = -1);
        var u = s.length - 1, l = -1;
        if (s.length) {
          switch (o) {
            case "previous":
              c === 0 ? l = 0 : c === -1 ? l = u : l = c - 1;
              break;
            case "next":
              c > -1 && c < u && (l = c + 1);
              break;
          }
          this.setState({
            inputIsHidden: l !== -1,
            focusedValue: s[l]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", i = this.props.pageSize, s = this.state.focusedOption, a = this.getFocusableOptions();
      if (a.length) {
        var c = 0, u = a.indexOf(s);
        s || (u = -1), o === "up" ? c = u > 0 ? u - 1 : a.length - 1 : o === "down" ? c = (u + 1) % a.length : o === "pageup" ? (c = u - i, c < 0 && (c = 0)) : o === "pagedown" ? (c = u + i, c > a.length - 1 && (c = a.length - 1)) : o === "last" && (c = a.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: a[c],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(a[c])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(Ic) : de(de({}, Ic), this.props.theme) : Ic;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var o = this.clearValue, i = this.cx, s = this.getStyles, a = this.getClassNames, c = this.getValue, u = this.selectOption, l = this.setValue, d = this.props, f = d.isMulti, p = d.isRtl, h = d.options, g = this.hasValue();
      return {
        clearValue: o,
        cx: i,
        getStyles: s,
        getClassNames: a,
        getValue: c,
        hasValue: g,
        isMulti: f,
        isRtl: p,
        options: h,
        selectOption: u,
        selectProps: d,
        setValue: l,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var o = this.state.selectValue;
      return o.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var o = this.props, i = o.isClearable, s = o.isMulti;
      return i === void 0 ? s : i;
    }
  }, {
    key: "isOptionDisabled",
    value: function(o, i) {
      return yp(this.props, o, i);
    }
  }, {
    key: "isOptionSelected",
    value: function(o, i) {
      return Cp(this.props, o, i);
    }
  }, {
    key: "filterOption",
    value: function(o, i) {
      return xp(this.props, o, i);
    }
  }, {
    key: "formatOptionLabel",
    value: function(o, i) {
      if (typeof this.props.formatOptionLabel == "function") {
        var s = this.props.inputValue, a = this.state.selectValue;
        return this.props.formatOptionLabel(o, {
          context: i,
          inputValue: s,
          selectValue: a
        });
      } else
        return this.getOptionLabel(o);
    }
  }, {
    key: "formatGroupLabel",
    value: function(o) {
      return this.props.formatGroupLabel(o);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var o = this.props, i = o.isDisabled, s = o.isSearchable, a = o.inputId, c = o.inputValue, u = o.tabIndex, l = o.form, d = o.menuIsOpen, f = o.required, p = this.getComponents(), h = p.Input, g = this.state, m = g.inputIsHidden, b = g.ariaSelection, v = this.commonProps, C = a || this.getElementId("input"), w = de(de(de({
          "aria-autocomplete": "list",
          "aria-expanded": d,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": f,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, d && {
          "aria-controls": this.getElementId("listbox")
        }), !s && {
          "aria-readonly": !0
        }), this.hasValue() ? (b == null ? void 0 : b.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return s ? /* @__PURE__ */ S.createElement(h, Ae({}, v, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: C,
          innerRef: this.getInputRef,
          isDisabled: i,
          isHidden: m,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: u,
          form: l,
          type: "text",
          value: c
        }, w)) : /* @__PURE__ */ S.createElement(d8, Ae({
          id: C,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: ia,
          onFocus: this.onInputFocus,
          disabled: i,
          tabIndex: u,
          inputMode: "none",
          form: l,
          value: ""
        }, w));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var o = this, i = this.getComponents(), s = i.MultiValue, a = i.MultiValueContainer, c = i.MultiValueLabel, u = i.MultiValueRemove, l = i.SingleValue, d = i.Placeholder, f = this.commonProps, p = this.props, h = p.controlShouldRenderValue, g = p.isDisabled, m = p.isMulti, b = p.inputValue, v = p.placeholder, C = this.state, w = C.selectValue, y = C.focusedValue, I = C.isFocused;
      if (!this.hasValue() || !h)
        return b ? null : /* @__PURE__ */ S.createElement(d, Ae({}, f, {
          key: "placeholder",
          isDisabled: g,
          isFocused: I,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), v);
      if (m)
        return w.map(function(E, P) {
          var L = E === y, W = "".concat(o.getOptionLabel(E), "-").concat(o.getOptionValue(E));
          return /* @__PURE__ */ S.createElement(s, Ae({}, f, {
            components: {
              Container: a,
              Label: c,
              Remove: u
            },
            isFocused: L,
            isDisabled: g,
            key: W,
            index: P,
            removeProps: {
              onClick: function() {
                return o.removeValue(E);
              },
              onTouchEnd: function() {
                return o.removeValue(E);
              },
              onMouseDown: function(X) {
                X.preventDefault();
              }
            },
            data: E
          }), o.formatOptionLabel(E, "value"));
        });
      if (b)
        return null;
      var x = w[0];
      return /* @__PURE__ */ S.createElement(l, Ae({}, f, {
        data: x,
        isDisabled: g
      }), this.formatOptionLabel(x, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var o = this.getComponents(), i = o.ClearIndicator, s = this.commonProps, a = this.props, c = a.isDisabled, u = a.isLoading, l = this.state.isFocused;
      if (!this.isClearable() || !i || c || !this.hasValue() || u)
        return null;
      var d = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ S.createElement(i, Ae({}, s, {
        innerProps: d,
        isFocused: l
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var o = this.getComponents(), i = o.LoadingIndicator, s = this.commonProps, a = this.props, c = a.isDisabled, u = a.isLoading, l = this.state.isFocused;
      if (!i || !u) return null;
      var d = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ S.createElement(i, Ae({}, s, {
        innerProps: d,
        isDisabled: c,
        isFocused: l
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var o = this.getComponents(), i = o.DropdownIndicator, s = o.IndicatorSeparator;
      if (!i || !s) return null;
      var a = this.commonProps, c = this.props.isDisabled, u = this.state.isFocused;
      return /* @__PURE__ */ S.createElement(s, Ae({}, a, {
        isDisabled: c,
        isFocused: u
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var o = this.getComponents(), i = o.DropdownIndicator;
      if (!i) return null;
      var s = this.commonProps, a = this.props.isDisabled, c = this.state.isFocused, u = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ S.createElement(i, Ae({}, s, {
        innerProps: u,
        isDisabled: a,
        isFocused: c
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var o = this, i = this.getComponents(), s = i.Group, a = i.GroupHeading, c = i.Menu, u = i.MenuList, l = i.MenuPortal, d = i.LoadingMessage, f = i.NoOptionsMessage, p = i.Option, h = this.commonProps, g = this.state.focusedOption, m = this.props, b = m.captureMenuScroll, v = m.inputValue, C = m.isLoading, w = m.loadingMessage, y = m.minMenuHeight, I = m.maxMenuHeight, x = m.menuIsOpen, E = m.menuPlacement, P = m.menuPosition, L = m.menuPortalTarget, W = m.menuShouldBlockScroll, V = m.menuShouldScrollIntoView, X = m.noOptionsMessage, N = m.onMenuScrollToTop, M = m.onMenuScrollToBottom;
      if (!x) return null;
      var F = function(ce, be) {
        var te = ce.type, ue = ce.data, me = ce.isDisabled, Te = ce.isSelected, Be = ce.label, et = ce.value, it = g === ue, re = me ? void 0 : function() {
          return o.onOptionHover(ue);
        }, Ge = me ? void 0 : function() {
          return o.selectOption(ue);
        }, nt = "".concat(o.getElementId("option"), "-").concat(be), Rt = {
          id: nt,
          onClick: Ge,
          onMouseMove: re,
          onMouseOver: re,
          tabIndex: -1,
          role: "option",
          "aria-selected": o.isAppleDevice ? void 0 : Te
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ S.createElement(p, Ae({}, h, {
          innerProps: Rt,
          data: ue,
          isDisabled: me,
          isSelected: Te,
          key: nt,
          label: Be,
          type: te,
          value: et,
          isFocused: it,
          innerRef: it ? o.getFocusedOptionRef : void 0
        }), o.formatOptionLabel(ce.data, "menu"));
      }, B;
      if (this.hasOptions())
        B = this.getCategorizedOptions().map(function(z) {
          if (z.type === "group") {
            var ce = z.data, be = z.options, te = z.index, ue = "".concat(o.getElementId("group"), "-").concat(te), me = "".concat(ue, "-heading");
            return /* @__PURE__ */ S.createElement(s, Ae({}, h, {
              key: ue,
              data: ce,
              options: be,
              Heading: a,
              headingProps: {
                id: me,
                data: z.data
              },
              label: o.formatGroupLabel(z.data)
            }), z.options.map(function(Te) {
              return F(Te, "".concat(te, "-").concat(Te.index));
            }));
          } else if (z.type === "option")
            return F(z, "".concat(z.index));
        });
      else if (C) {
        var Z = w({
          inputValue: v
        });
        if (Z === null) return null;
        B = /* @__PURE__ */ S.createElement(d, h, Z);
      } else {
        var H = X({
          inputValue: v
        });
        if (H === null) return null;
        B = /* @__PURE__ */ S.createElement(f, h, H);
      }
      var K = {
        minMenuHeight: y,
        maxMenuHeight: I,
        menuPlacement: E,
        menuPosition: P,
        menuShouldScrollIntoView: V
      }, ee = /* @__PURE__ */ S.createElement(Z7, Ae({}, h, K), function(z) {
        var ce = z.ref, be = z.placerProps, te = be.placement, ue = be.maxHeight;
        return /* @__PURE__ */ S.createElement(c, Ae({}, h, K, {
          innerRef: ce,
          innerProps: {
            onMouseDown: o.onMenuMouseDown,
            onMouseMove: o.onMenuMouseMove
          },
          isLoading: C,
          placement: te
        }), /* @__PURE__ */ S.createElement(b8, {
          captureEnabled: b,
          onTopArrive: N,
          onBottomArrive: M,
          lockEnabled: W
        }, function(me) {
          return /* @__PURE__ */ S.createElement(u, Ae({}, h, {
            innerRef: function(Be) {
              o.getMenuListRef(Be), me(Be);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": h.isMulti,
              id: o.getElementId("listbox")
            },
            isLoading: C,
            maxHeight: ue,
            focusedOption: g
          }), B);
        }));
      });
      return L || P === "fixed" ? /* @__PURE__ */ S.createElement(l, Ae({}, h, {
        appendTo: L,
        controlElement: this.controlRef,
        menuPlacement: E,
        menuPosition: P
      }), ee) : ee;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var o = this, i = this.props, s = i.delimiter, a = i.isDisabled, c = i.isMulti, u = i.name, l = i.required, d = this.state.selectValue;
      if (l && !this.hasValue() && !a)
        return /* @__PURE__ */ S.createElement(x8, {
          name: u,
          onFocus: this.onValueInputFocus
        });
      if (!(!u || a))
        if (c)
          if (s) {
            var f = d.map(function(g) {
              return o.getOptionValue(g);
            }).join(s);
            return /* @__PURE__ */ S.createElement("input", {
              name: u,
              type: "hidden",
              value: f
            });
          } else {
            var p = d.length > 0 ? d.map(function(g, m) {
              return /* @__PURE__ */ S.createElement("input", {
                key: "i-".concat(m),
                name: u,
                type: "hidden",
                value: o.getOptionValue(g)
              });
            }) : /* @__PURE__ */ S.createElement("input", {
              name: u,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ S.createElement("div", null, p);
          }
        else {
          var h = d[0] ? this.getOptionValue(d[0]) : "";
          return /* @__PURE__ */ S.createElement("input", {
            name: u,
            type: "hidden",
            value: h
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var o = this.commonProps, i = this.state, s = i.ariaSelection, a = i.focusedOption, c = i.focusedValue, u = i.isFocused, l = i.selectValue, d = this.getFocusableOptions();
      return /* @__PURE__ */ S.createElement(i8, Ae({}, o, {
        id: this.getElementId("live-region"),
        ariaSelection: s,
        focusedOption: a,
        focusedValue: c,
        isFocused: u,
        selectValue: l,
        focusableOptions: d,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var o = this.getComponents(), i = o.Control, s = o.IndicatorsContainer, a = o.SelectContainer, c = o.ValueContainer, u = this.props, l = u.className, d = u.id, f = u.isDisabled, p = u.menuIsOpen, h = this.state.isFocused, g = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ S.createElement(a, Ae({}, g, {
        className: l,
        innerProps: {
          id: d,
          onKeyDown: this.onKeyDown
        },
        isDisabled: f,
        isFocused: h
      }), this.renderLiveRegion(), /* @__PURE__ */ S.createElement(i, Ae({}, g, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: f,
        isFocused: h,
        menuIsOpen: p
      }), /* @__PURE__ */ S.createElement(c, Ae({}, g, {
        isDisabled: f
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ S.createElement(s, Ae({}, g, {
        isDisabled: f
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, i) {
      var s = i.prevProps, a = i.clearFocusValueOnUpdate, c = i.inputIsHiddenAfterUpdate, u = i.ariaSelection, l = i.isFocused, d = i.prevWasFocused, f = i.instancePrefix, p = o.options, h = o.value, g = o.menuIsOpen, m = o.inputValue, b = o.isMulti, v = YA(h), C = {};
      if (s && (h !== s.value || p !== s.options || g !== s.menuIsOpen || m !== s.inputValue)) {
        var w = g ? L8(o, v) : [], y = g ? l1(Zs(o, v), "".concat(f, "-option")) : [], I = a ? H8(i, v) : null, x = X8(i, w), E = Ec(y, x);
        C = {
          selectValue: v,
          focusedOption: x,
          focusedOptionId: E,
          focusableOptionsWithIds: y,
          focusedValue: I,
          clearFocusValueOnUpdate: !1
        };
      }
      var P = c != null && o !== s ? {
        inputIsHidden: c,
        inputIsHiddenAfterUpdate: void 0
      } : {}, L = u, W = l && d;
      return l && !W && (L = {
        value: Cs(b, v, v[0] || null),
        options: v,
        action: "initial-input-focus"
      }, W = !d), (u == null ? void 0 : u.action) === "initial-input-focus" && (L = null), de(de(de({}, C), P), {}, {
        prevProps: o,
        ariaSelection: L,
        prevWasFocused: W
      });
    }
  }]), n;
}(G3);
Ip.defaultProps = k8;
var Z8 = /* @__PURE__ */ Pt(function(e, t) {
  var n = l4(e);
  return /* @__PURE__ */ S.createElement(Ip, Ae({
    ref: t
  }, n));
}), z8 = Z8;
function G8(e) {
  return /* @__PURE__ */ A(Za.DropdownIndicator, { ...e, children: /* @__PURE__ */ A(J, { name: "ChevronDown", size: 16 }) });
}
function j8(e) {
  return /* @__PURE__ */ A(Za.ClearIndicator, { ...e, children: /* @__PURE__ */ A(J, { name: "Xmark", size: 16 }) });
}
function U8(e) {
  const { label: t, onClick: n, ...r } = e, o = !!t && !!n;
  return /* @__PURE__ */ R(Za.MenuList, { ...r, children: [
    e.children,
    o && /* @__PURE__ */ A(
      "button",
      {
        onClick: n,
        className: "w-full px-2 py-3 hover:bg-slate-50",
        children: t
      }
    )
  ] });
}
function Pu(e) {
  const t = e["aria-invalid"] === "true", { addItemButtonProps: n, ...r } = e;
  return /* @__PURE__ */ A(
    z8,
    {
      ...r,
      components: {
        DropdownIndicator: G8,
        ClearIndicator: j8,
        MenuList: (o) => U8({ ...o, ...n })
      },
      styles: {
        dropdownIndicator: () => ({
          label: "indicatorContainer",
          display: "flex",
          transition: "color 150ms",
          color: "var(--gray-900)",
          padding: 8,
          boxSizing: "border-box"
        }),
        clearIndicator: (o) => ({
          ...o,
          color: "var(--gray-900)"
        }),
        container: (o) => ({
          ...o,
          borderColor: "var(--gray-200)",
          fontSize: 12
        }),
        placeholder: (o) => ({
          ...o,
          color: t ? "var(--red-800)" : "var(--gray-500)"
        }),
        control: () => ({
          label: "control",
          alignItems: "center",
          cursor: "default",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          minHeight: 32,
          outline: "0 !important",
          position: "relative",
          transition: "all 100ms",
          backgroundColor: "var(--white)",
          borderColor: t ? "var(--red-900)" : "var(--gray-200)",
          borderStyle: "solid",
          borderWidth: 1,
          borderRadius: "6px",
          boxSizing: "border-box"
        }),
        option: (o, i) => ({
          ...o,
          backgroundColor: i.isSelected ? "var(--slate-50)" : "var(--white)",
          color: "var(--gray-800)",
          ":hover": {
            backgroundColor: "var(--slate-50)"
          }
        }),
        menuList: (o) => ({
          ...o,
          padding: 0,
          borderRadius: "6px"
        })
      },
      theme: (o) => ({
        ...o,
        colors: {
          ...o.colors,
          primary: "var(--slate-100)",
          primary25: "var(--slate-50)",
          primary50: "var(--slate-100)",
          primary75: "var(--slate-100)",
          danger: "var(--red-900)",
          dangerLight: "var(--red-100)",
          neutral0: "var(--white)",
          neutral5: "var(--gray-50)",
          neutral10: "var(--gray-100)",
          neutral20: "var(--gray-200)",
          neutral30: "var(--gray-300)",
          neutral40: "var(--gray-400)",
          neutral50: "var(--gray-500)",
          neutral60: "var(--gray-600)",
          neutral70: "var(--gray-700)",
          neutral80: "var(--gray-800)",
          neutral90: "var(--gray-900)"
        }
      })
    }
  );
}
const Ep = Pt(function(t, n) {
  return /* @__PURE__ */ A(
    "input",
    {
      ...t,
      className: $(
        "h-8 w-full rounded-md bg-gray-100 px-3 disabled:bg-transparent disabled:p-0",
        t.className
      ),
      type: "datetime-local",
      ref: n,
      step: t.step ?? "1"
    }
  );
});
function PM() {
  return /* @__PURE__ */ A("div", { className: "grid h-full place-items-center", children: /* @__PURE__ */ R("div", { className: "-mt-20", children: [
    /* @__PURE__ */ A("h3", { className: "mb-4 text-center text-xl", children: "Loading editor" }),
    /* @__PURE__ */ A(n4, {})
  ] }) });
}
function Co(e) {
  const { title: t, isOpen: n, onOpenChange: r, children: o, className: i, ...s } = e;
  return /* @__PURE__ */ R("div", { ...s, children: [
    /* @__PURE__ */ R(
      "div",
      {
        className: "flex cursor-pointer justify-between text-gray-500",
        onClick: r,
        children: [
          /* @__PURE__ */ A("h2", { className: " font-semibold text-gray-500", children: t }),
          /* @__PURE__ */ A(
            J,
            {
              name: "ChevronDown",
              className: Nr("transition", n ? "" : "-rotate-90")
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ A(
      "div",
      {
        className: $(
          "max-h-0 overflow-hidden transition-[max-height] duration-300 ease-in-out",
          n && "max-h-screen",
          i
        ),
        children: o
      }
    )
  ] });
}
function bt(e) {
  return /* @__PURE__ */ A(
    "div",
    {
      ...e,
      className: $("h-px bg-gray-200", e.className)
    }
  );
}
function RM(e) {
  const {
    driveNodes: t,
    selectedDriveNode: n,
    label: r,
    groupSharingType: o,
    className: i,
    disableAddDrives: s,
    isAllowedToCreateDocuments: a,
    showAddDriveModal: c
  } = e, u = t.length > 0, l = (n == null ? void 0 : n.sharingType) === o;
  function d() {
    c(o);
  }
  return /* @__PURE__ */ R(
    "div",
    {
      className: $(
        "border-y border-gray-100 pl-4 pr-1 first-of-type:border-b-0 last-of-type:border-t-0",
        u && "pb-2",
        l && "bg-gray-100",
        i
      ),
      children: [
        /* @__PURE__ */ R(
          "div",
          {
            className: Nr(
              "flex items-center justify-between py-1.5 pr-2"
            ),
            children: [
              /* @__PURE__ */ A("p", { className: "text-sm font-medium leading-6 text-gray-500", children: r }),
              /* @__PURE__ */ A("div", { className: "size-4 text-gray-600", children: !s && a && /* @__PURE__ */ A(
                "button",
                {
                  onClick: d,
                  className: $(
                    "mr-2 transition hover:text-gray-800"
                  ),
                  children: /* @__PURE__ */ A(J, { name: "PlusCircle", size: 16 })
                }
              ) })
            ]
          }
        ),
        t.map((f) => /* @__PURE__ */ go(
          Gg,
          {
            ...e,
            key: f.id,
            uiNode: f
          }
        ))
      ]
    }
  );
}
function cd(e) {
  const { children: t, items: n, open: r, onItemClick: o, onOpenChange: i } = e;
  return /* @__PURE__ */ R(vh, { open: r, onOpenChange: i, children: [
    /* @__PURE__ */ A(yh, { asChild: !0, className: "outline-none", children: t }),
    /* @__PURE__ */ A(Ch, { className: "modal-shadow cursor-pointer rounded-2xl bg-white text-sm font-medium text-slate-200", children: n.map(({ id: s, label: a, icon: c, className: u }) => /* @__PURE__ */ R(
      xh,
      {
        onClick: (l) => l.stopPropagation(),
        onSelect: () => o(s),
        className: $(
          "flex items-center px-5 py-2 outline-none first-of-type:rounded-t-2xl first-of-type:pt-3 last-of-type:rounded-b-2xl last-of-type:pb-3 hover:bg-slate-50",
          u
        ),
        children: [
          c && /* @__PURE__ */ A("span", { className: "mr-2 inline-block", children: c }),
          a
        ]
      },
      s
    )) })
  ] });
}
function Q8(e) {
  const { onSwitchboardLinkClick: t, onExport: n, onClose: r, onShowRevisionHistory: o } = e;
  return /* @__PURE__ */ R("div", { className: "flex gap-x-2", children: [
    t && /* @__PURE__ */ A(
      "button",
      {
        className: "flex h-8 items-center gap-x-2 rounded border border-gray-200 px-3 text-sm font-semibold text-gray-900 active:opacity-50",
        onClick: t,
        children: /* @__PURE__ */ A(J, { name: "Drive", size: 16 })
      }
    ),
    /* @__PURE__ */ R(
      "button",
      {
        className: "flex h-8 items-center gap-x-2 rounded border border-gray-200 px-3 text-sm font-semibold text-gray-900 active:opacity-50",
        onClick: n,
        children: [
          "Export ",
          /* @__PURE__ */ A(J, { name: "Save", size: 16 })
        ]
      }
    ),
    /* @__PURE__ */ R(
      "button",
      {
        className: "flex h-8 items-center gap-x-2 whitespace-nowrap rounded border border-gray-200 px-3 text-sm font-semibold text-gray-900 active:opacity-50",
        onClick: o,
        children: [
          "Revision history ",
          /* @__PURE__ */ A(J, { name: "History", size: 16 })
        ]
      }
    ),
    /* @__PURE__ */ A(
      "button",
      {
        className: "grid size-8 place-items-center rounded border border-gray-200 active:opacity-50",
        onClick: r,
        children: /* @__PURE__ */ A(J, { name: "Xmark" })
      }
    )
  ] });
}
function OM(e) {
  const { canUndo: t, canRedo: n, undo: r, redo: o } = e, i = "w-8 h-8 tab-shadow rounded-lg flex justify-center items-center";
  return /* @__PURE__ */ R("div", { className: "flex gap-x-2 text-gray-500", children: [
    /* @__PURE__ */ A("button", { onClick: r, disabled: !t, className: i, children: /* @__PURE__ */ A(
      J,
      {
        name: "RedoArrow",
        className: $(
          "scale-x-[-1]",
          t ? "active:opacity-50" : "text-gray-500"
        )
      }
    ) }),
    /* @__PURE__ */ A("button", { onClick: o, disabled: !n, className: i, children: /* @__PURE__ */ A(
      J,
      {
        name: "RedoArrow",
        className: $(
          n ? "active:opacity-50" : "text-gray-500"
        )
      }
    ) })
  ] });
}
const q8 = "data:image/png;base64,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", Sp = "2.19.2";
let xs = {
  getDocsUrl: ({ docsBaseUrl: e, docsPath: t = "", docsSlug: n }) => t ? `${e ?? "https://viem.sh"}${t}${n ? `#${n}` : ""}` : void 0,
  version: Sp
}, ne = class Ru extends Error {
  constructor(t, n = {}) {
    var a;
    const r = (() => {
      var c;
      return n.cause instanceof Ru ? n.cause.details : (c = n.cause) != null && c.message ? n.cause.message : n.details;
    })(), o = n.cause instanceof Ru && n.cause.docsPath || n.docsPath, i = (a = xs.getDocsUrl) == null ? void 0 : a.call(xs, { ...n, docsPath: o }), s = [
      t || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...i ? [`Docs: ${i}`] : [],
      ...r ? [`Details: ${r}`] : [],
      `Version: ${xs.version}`
    ].join(`
`);
    super(s, n.cause ? { cause: n.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = r, this.docsPath = o, this.metaMessages = n.metaMessages, this.name = n.name ?? this.name, this.shortMessage = t, this.version = Sp;
  }
  walk(t) {
    return Tp(this, t);
  }
};
function Tp(e, t) {
  return t != null && t(e) ? e : e && typeof e == "object" && "cause" in e ? Tp(e.cause, t) : t ? null : e;
}
class Y8 extends ne {
  constructor({ max: t, min: n, signed: r, size: o, value: i }) {
    super(`Number "${i}" is not in safe ${o ? `${o * 8}-bit ${r ? "signed" : "unsigned"} ` : ""}integer range ${t ? `(${n} to ${t})` : `(above ${n})`}`, { name: "IntegerOutOfRangeError" });
  }
}
class J8 extends ne {
  constructor(t) {
    super(`Bytes value "${t}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
      name: "InvalidBytesBooleanError"
    });
  }
}
class K8 extends ne {
  constructor({ givenSize: t, maxSize: n }) {
    super(`Size cannot exceed ${n} bytes. Given size: ${t} bytes.`, { name: "SizeOverflowError" });
  }
}
class Np extends ne {
  constructor({ offset: t, position: n, size: r }) {
    super(`Slice ${n === "start" ? "starting" : "ending"} at offset "${t}" is out-of-bounds (size: ${r}).`, { name: "SliceOffsetOutOfBoundsError" });
  }
}
class Pp extends ne {
  constructor({ size: t, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} size (${t}) exceeds padding size (${n}).`, { name: "SizeExceedsPaddingSizeError" });
  }
}
class A1 extends ne {
  constructor({ size: t, targetSize: n, type: r }) {
    super(`${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()} is expected to be ${n} ${r} long, but is ${t} ${r} long.`, { name: "InvalidBytesLengthError" });
  }
}
function Mo(e, { dir: t, size: n = 32 } = {}) {
  return typeof e == "string" ? Wn(e, { dir: t, size: n }) : _8(e, { dir: t, size: n });
}
function Wn(e, { dir: t, size: n = 32 } = {}) {
  if (n === null)
    return e;
  const r = e.replace("0x", "");
  if (r.length > n * 2)
    throw new Pp({
      size: Math.ceil(r.length / 2),
      targetSize: n,
      type: "hex"
    });
  return `0x${r[t === "right" ? "padEnd" : "padStart"](n * 2, "0")}`;
}
function _8(e, { dir: t, size: n = 32 } = {}) {
  if (n === null)
    return e;
  if (e.length > n)
    throw new Pp({
      size: e.length,
      targetSize: n,
      type: "bytes"
    });
  const r = new Uint8Array(n);
  for (let o = 0; o < n; o++) {
    const i = t === "right";
    r[i ? o : n - o - 1] = e[i ? o : e.length - o - 1];
  }
  return r;
}
function Fo(e, { strict: t = !0 } = {}) {
  return !e || typeof e != "string" ? !1 : t ? /^0x[0-9a-fA-F]*$/.test(e) : e.startsWith("0x");
}
function ct(e) {
  return Fo(e, { strict: !1 }) ? Math.ceil((e.length - 2) / 2) : e.length;
}
function ud(e, { dir: t = "left" } = {}) {
  let n = typeof e == "string" ? e.replace("0x", "") : e, r = 0;
  for (let o = 0; o < n.length - 1 && n[t === "left" ? o : n.length - o - 1].toString() === "0"; o++)
    r++;
  return n = t === "left" ? n.slice(r) : n.slice(0, n.length - r), typeof e == "string" ? (n.length === 1 && t === "right" && (n = `${n}0`), `0x${n.length % 2 === 1 ? `0${n}` : n}`) : n;
}
const $8 = /* @__PURE__ */ new TextEncoder();
function ld(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? tC(e, t) : typeof e == "boolean" ? eC(e, t) : Fo(e) ? dd(e, t) : Ar(e, t);
}
function eC(e, t = {}) {
  const n = new Uint8Array(1);
  return n[0] = Number(e), typeof t.size == "number" ? (An(n, { size: t.size }), Mo(n, { size: t.size })) : n;
}
const hn = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function f1(e) {
  if (e >= hn.zero && e <= hn.nine)
    return e - hn.zero;
  if (e >= hn.A && e <= hn.F)
    return e - (hn.A - 10);
  if (e >= hn.a && e <= hn.f)
    return e - (hn.a - 10);
}
function dd(e, t = {}) {
  let n = e;
  t.size && (An(n, { size: t.size }), n = Mo(n, { dir: "right", size: t.size }));
  let r = n.slice(2);
  r.length % 2 && (r = `0${r}`);
  const o = r.length / 2, i = new Uint8Array(o);
  for (let s = 0, a = 0; s < o; s++) {
    const c = f1(r.charCodeAt(a++)), u = f1(r.charCodeAt(a++));
    if (c === void 0 || u === void 0)
      throw new ne(`Invalid byte sequence ("${r[a - 2]}${r[a - 1]}" in "${r}").`);
    i[s] = c * 16 + u;
  }
  return i;
}
function tC(e, t) {
  const n = ze(e, t);
  return dd(n);
}
function Ar(e, t = {}) {
  const n = $8.encode(e);
  return typeof t.size == "number" ? (An(n, { size: t.size }), Mo(n, { dir: "right", size: t.size })) : n;
}
function An(e, { size: t }) {
  if (ct(e) > t)
    throw new K8({
      givenSize: ct(e),
      maxSize: t
    });
}
function Rp(e, t = {}) {
  const { signed: n } = t;
  t.size && An(e, { size: t.size });
  const r = BigInt(e);
  if (!n)
    return r;
  const o = (e.length - 2) / 2, i = (1n << BigInt(o) * 8n - 1n) - 1n;
  return r <= i ? r : r - BigInt(`0x${"f".padStart(o * 2, "f")}`) - 1n;
}
function nC(e, t = {}) {
  return Number(Rp(e, t));
}
const rC = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function Ad(e, t = {}) {
  return typeof e == "number" || typeof e == "bigint" ? ze(e, t) : typeof e == "string" ? fd(e, t) : typeof e == "boolean" ? Op(e, t) : Vt(e, t);
}
function Op(e, t = {}) {
  const n = `0x${Number(e)}`;
  return typeof t.size == "number" ? (An(n, { size: t.size }), Mo(n, { size: t.size })) : n;
}
function Vt(e, t = {}) {
  let n = "";
  for (let o = 0; o < e.length; o++)
    n += rC[e[o]];
  const r = `0x${n}`;
  return typeof t.size == "number" ? (An(r, { size: t.size }), Mo(r, { dir: "right", size: t.size })) : r;
}
function ze(e, t = {}) {
  const { signed: n, size: r } = t, o = BigInt(e);
  let i;
  r ? n ? i = (1n << BigInt(r) * 8n - 1n) - 1n : i = 2n ** (BigInt(r) * 8n) - 1n : typeof e == "number" && (i = BigInt(Number.MAX_SAFE_INTEGER));
  const s = typeof i == "bigint" && n ? -i - 1n : 0;
  if (i && o > i || o < s) {
    const c = typeof e == "bigint" ? "n" : "";
    throw new Y8({
      max: i ? `${i}${c}` : void 0,
      min: `${s}${c}`,
      signed: n,
      size: r,
      value: `${e}${c}`
    });
  }
  const a = `0x${(n && o < 0 ? (1n << BigInt(r * 8)) + BigInt(o) : o).toString(16)}`;
  return r ? Mo(a, { size: r }) : a;
}
const oC = /* @__PURE__ */ new TextEncoder();
function fd(e, t = {}) {
  const n = oC.encode(e);
  return Vt(n, t);
}
function xo(e, { includeName: t = !1 } = {}) {
  if (e.type !== "function" && e.type !== "event" && e.type !== "error")
    throw new mC(e.type);
  return `${e.name}(${hd(e.inputs, { includeName: t })})`;
}
function hd(e, { includeName: t = !1 } = {}) {
  return e ? e.map((n) => iC(n, { includeName: t })).join(t ? ", " : ",") : "";
}
function iC(e, { includeName: t }) {
  return e.type.startsWith("tuple") ? `(${hd(e.components, { includeName: t })})${e.type.slice(5)}` : e.type + (t && e.name ? ` ${e.name}` : "");
}
class sC extends ne {
  constructor({ docsPath: t }) {
    super([
      "A constructor was not found on the ABI.",
      "Make sure you are using the correct ABI and that the constructor exists on it."
    ].join(`
`), {
      docsPath: t,
      name: "AbiConstructorNotFoundError"
    });
  }
}
class h1 extends ne {
  constructor({ docsPath: t }) {
    super([
      "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
      "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
    ].join(`
`), {
      docsPath: t,
      name: "AbiConstructorParamsNotFoundError"
    });
  }
}
class aC extends ne {
  constructor({ data: t, params: n, size: r }) {
    super([`Data size of ${r} bytes is too small for given parameters.`].join(`
`), {
      metaMessages: [
        `Params: (${hd(n, { includeName: !0 })})`,
        `Data:   ${t} (${r} bytes)`
      ],
      name: "AbiDecodingDataSizeTooSmallError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "params", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "size", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = t, this.params = n, this.size = r;
  }
}
class pd extends ne {
  constructor() {
    super('Cannot decode zero data ("0x") with ABI parameters.', {
      name: "AbiDecodingZeroDataError"
    });
  }
}
class cC extends ne {
  constructor({ expectedLength: t, givenLength: n, type: r }) {
    super([
      `ABI encoding array length mismatch for type ${r}.`,
      `Expected length: ${t}`,
      `Given length: ${n}`
    ].join(`
`), { name: "AbiEncodingArrayLengthMismatchError" });
  }
}
class uC extends ne {
  constructor({ expectedSize: t, value: n }) {
    super(`Size of bytes "${n}" (bytes${ct(n)}) does not match expected size (bytes${t}).`, { name: "AbiEncodingBytesSizeMismatchError" });
  }
}
class lC extends ne {
  constructor({ expectedLength: t, givenLength: n }) {
    super([
      "ABI encoding params/values length mismatch.",
      `Expected length (params): ${t}`,
      `Given length (values): ${n}`
    ].join(`
`), { name: "AbiEncodingLengthMismatchError" });
  }
}
class Dp extends ne {
  constructor(t, { docsPath: n }) {
    super([
      `Encoded error signature "${t}" not found on ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${t}.`
    ].join(`
`), {
      docsPath: n,
      name: "AbiErrorSignatureNotFoundError"
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.signature = t;
  }
}
class ca extends ne {
  constructor(t, { docsPath: n } = {}) {
    super([
      `Function ${t ? `"${t}" ` : ""}not found on ABI.`,
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: n,
      name: "AbiFunctionNotFoundError"
    });
  }
}
class dC extends ne {
  constructor(t, { docsPath: n }) {
    super([
      `Function "${t}" does not contain any \`outputs\` on ABI.`,
      "Cannot decode function result without knowing what the parameter types are.",
      "Make sure you are using the correct ABI and that the function exists on it."
    ].join(`
`), {
      docsPath: n,
      name: "AbiFunctionOutputsNotFoundError"
    });
  }
}
class AC extends ne {
  constructor(t, n) {
    super("Found ambiguous types in overloaded ABI items.", {
      metaMessages: [
        `\`${t.type}\` in \`${xo(t.abiItem)}\`, and`,
        `\`${n.type}\` in \`${xo(n.abiItem)}\``,
        "",
        "These types encode differently and cannot be distinguished at runtime.",
        "Remove one of the ambiguous items in the ABI."
      ],
      name: "AbiItemAmbiguityError"
    });
  }
}
class fC extends ne {
  constructor(t, { docsPath: n }) {
    super([
      `Type "${t}" is not a valid encoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n, name: "InvalidAbiEncodingType" });
  }
}
class hC extends ne {
  constructor(t, { docsPath: n }) {
    super([
      `Type "${t}" is not a valid decoding type.`,
      "Please provide a valid ABI type."
    ].join(`
`), { docsPath: n, name: "InvalidAbiDecodingType" });
  }
}
class pC extends ne {
  constructor(t) {
    super([`Value "${t}" is not a valid array.`].join(`
`), {
      name: "InvalidArrayError"
    });
  }
}
class mC extends ne {
  constructor(t) {
    super([
      `"${t}" is not a valid definition type.`,
      'Valid types: "function", "event", "error"'
    ].join(`
`), { name: "InvalidDefinitionTypeError" });
  }
}
function Cr(e) {
  return typeof e[0] == "string" ? md(e) : gC(e);
}
function gC(e) {
  let t = 0;
  for (const o of e)
    t += o.length;
  const n = new Uint8Array(t);
  let r = 0;
  for (const o of e)
    n.set(o, r), r += o.length;
  return n;
}
function md(e) {
  return `0x${e.reduce((t, n) => t + n.replace("0x", ""), "")}`;
}
class bi extends ne {
  constructor({ address: t }) {
    super(`Address "${t}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ],
      name: "InvalidAddressError"
    });
  }
}
class gd extends Map {
  constructor(t) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = t;
  }
  set(t, n) {
    return super.set(t, n), this.maxSize && this.size > this.maxSize && this.delete(this.keys().next().value), this;
  }
}
function p1(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`positive integer expected, not ${e}`);
}
function bC(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function bd(e, ...t) {
  if (!bC(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Uint8Array expected of length ${t}, not of length=${e.length}`);
}
function m1(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function vC(e, t) {
  bd(e);
  const n = t.outputLen;
  if (e.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const ws = /* @__PURE__ */ BigInt(2 ** 32 - 1), g1 = /* @__PURE__ */ BigInt(32);
function yC(e, t = !1) {
  return t ? { h: Number(e & ws), l: Number(e >> g1 & ws) } : { h: Number(e >> g1 & ws) | 0, l: Number(e & ws) | 0 };
}
function CC(e, t = !1) {
  let n = new Uint32Array(e.length), r = new Uint32Array(e.length);
  for (let o = 0; o < e.length; o++) {
    const { h: i, l: s } = yC(e[o], t);
    [n[o], r[o]] = [i, s];
  }
  return [n, r];
}
const xC = (e, t, n) => e << n | t >>> 32 - n, wC = (e, t, n) => t << n | e >>> 32 - n, IC = (e, t, n) => t << n - 32 | e >>> 64 - n, EC = (e, t, n) => e << n - 32 | t >>> 64 - n;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const SC = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), b1 = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, TC = (e) => e << 24 & 4278190080 | e << 8 & 16711680 | e >>> 8 & 65280 | e >>> 24 & 255;
function v1(e) {
  for (let t = 0; t < e.length; t++)
    e[t] = TC(e[t]);
}
function NC(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function Mp(e) {
  return typeof e == "string" && (e = NC(e)), bd(e), e;
}
class PC {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function RC(e) {
  const t = (r) => e().update(Mp(r)).digest(), n = e();
  return t.outputLen = n.outputLen, t.blockLen = n.blockLen, t.create = () => e(), t;
}
const Fp = [], Vp = [], Bp = [], OC = /* @__PURE__ */ BigInt(0), Qo = /* @__PURE__ */ BigInt(1), DC = /* @__PURE__ */ BigInt(2), MC = /* @__PURE__ */ BigInt(7), FC = /* @__PURE__ */ BigInt(256), VC = /* @__PURE__ */ BigInt(113);
for (let e = 0, t = Qo, n = 1, r = 0; e < 24; e++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], Fp.push(2 * (5 * r + n)), Vp.push((e + 1) * (e + 2) / 2 % 64);
  let o = OC;
  for (let i = 0; i < 7; i++)
    t = (t << Qo ^ (t >> MC) * VC) % FC, t & DC && (o ^= Qo << (Qo << /* @__PURE__ */ BigInt(i)) - Qo);
  Bp.push(o);
}
const [BC, kC] = /* @__PURE__ */ CC(Bp, !0), y1 = (e, t, n) => n > 32 ? IC(e, t, n) : xC(e, t, n), C1 = (e, t, n) => n > 32 ? EC(e, t, n) : wC(e, t, n);
function LC(e, t = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - t; r < 24; r++) {
    for (let s = 0; s < 10; s++)
      n[s] = e[s] ^ e[s + 10] ^ e[s + 20] ^ e[s + 30] ^ e[s + 40];
    for (let s = 0; s < 10; s += 2) {
      const a = (s + 8) % 10, c = (s + 2) % 10, u = n[c], l = n[c + 1], d = y1(u, l, 1) ^ n[a], f = C1(u, l, 1) ^ n[a + 1];
      for (let p = 0; p < 50; p += 10)
        e[s + p] ^= d, e[s + p + 1] ^= f;
    }
    let o = e[2], i = e[3];
    for (let s = 0; s < 24; s++) {
      const a = Vp[s], c = y1(o, i, a), u = C1(o, i, a), l = Fp[s];
      o = e[l], i = e[l + 1], e[l] = c, e[l + 1] = u;
    }
    for (let s = 0; s < 50; s += 10) {
      for (let a = 0; a < 10; a++)
        n[a] = e[s + a];
      for (let a = 0; a < 10; a++)
        e[s + a] ^= ~n[(a + 2) % 10] & n[(a + 4) % 10];
    }
    e[0] ^= BC[r], e[1] ^= kC[r];
  }
  n.fill(0);
}
class vd extends PC {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, n, r, o = !1, i = 24) {
    if (super(), this.blockLen = t, this.suffix = n, this.outputLen = r, this.enableXOF = o, this.rounds = i, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, p1(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = SC(this.state);
  }
  keccak() {
    b1 || v1(this.state32), LC(this.state32, this.rounds), b1 || v1(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    m1(this);
    const { blockLen: n, state: r } = this;
    t = Mp(t);
    const o = t.length;
    for (let i = 0; i < o; ) {
      const s = Math.min(n - this.pos, o - i);
      for (let a = 0; a < s; a++)
        r[this.pos++] ^= t[i++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: n, pos: r, blockLen: o } = this;
    t[r] ^= n, n & 128 && r === o - 1 && this.keccak(), t[o - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    m1(this, !1), bd(t), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let o = 0, i = t.length; o < i; ) {
      this.posOut >= r && this.keccak();
      const s = Math.min(r - this.posOut, i - o);
      t.set(n.subarray(this.posOut, this.posOut + s), o), this.posOut += s, o += s;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return p1(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (vC(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: n, suffix: r, outputLen: o, rounds: i, enableXOF: s } = this;
    return t || (t = new vd(n, r, o, s, i)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = i, t.suffix = r, t.outputLen = o, t.enableXOF = s, t.destroyed = this.destroyed, t;
  }
}
const HC = (e, t, n) => RC(() => new vd(t, e, n)), XC = /* @__PURE__ */ HC(1, 136, 256 / 8);
function wo(e, t) {
  const n = t || "hex", r = XC(Fo(e, { strict: !1 }) ? ld(e) : e);
  return n === "bytes" ? r : Ad(r);
}
const Sc = /* @__PURE__ */ new gd(8192);
function yd(e, t) {
  if (Sc.has(`${e}.${t}`))
    return Sc.get(`${e}.${t}`);
  const n = e.substring(2).toLowerCase(), r = wo(Ar(n), "bytes"), o = n.split("");
  for (let s = 0; s < 40; s += 2)
    r[s >> 1] >> 4 >= 8 && o[s] && (o[s] = o[s].toUpperCase()), (r[s >> 1] & 15) >= 8 && o[s + 1] && (o[s + 1] = o[s + 1].toUpperCase());
  const i = `0x${o.join("")}`;
  return Sc.set(`${e}.${t}`, i), i;
}
function Is(e, t) {
  if (!qn(e, { strict: !1 }))
    throw new bi({ address: e });
  return yd(e, t);
}
const WC = /^0x[a-fA-F0-9]{40}$/, Tc = /* @__PURE__ */ new gd(8192);
function qn(e, t) {
  const { strict: n = !0 } = t ?? {}, r = `${e}.${n}`;
  if (Tc.has(r))
    return Tc.get(r);
  const o = WC.test(e) ? e.toLowerCase() === e ? !0 : n ? yd(e) === e : !0 : !1;
  return Tc.set(r, o), o;
}
function ua(e, t, n, { strict: r } = {}) {
  return Fo(e, { strict: !1 }) ? ZC(e, t, n, {
    strict: r
  }) : Hp(e, t, n, {
    strict: r
  });
}
function kp(e, t) {
  if (typeof t == "number" && t > 0 && t > ct(e) - 1)
    throw new Np({
      offset: t,
      position: "start",
      size: ct(e)
    });
}
function Lp(e, t, n) {
  if (typeof t == "number" && typeof n == "number" && ct(e) !== n - t)
    throw new Np({
      offset: n,
      position: "end",
      size: ct(e)
    });
}
function Hp(e, t, n, { strict: r } = {}) {
  kp(e, t);
  const o = e.slice(t, n);
  return r && Lp(o, t, n), o;
}
function ZC(e, t, n, { strict: r } = {}) {
  kp(e, t);
  const o = `0x${e.replace("0x", "").slice((t ?? 0) * 2, (n ?? e.length) * 2)}`;
  return r && Lp(o, t, n), o;
}
function Xp(e, t) {
  if (e.length !== t.length)
    throw new lC({
      expectedLength: e.length,
      givenLength: t.length
    });
  const n = zC({
    params: e,
    values: t
  }), r = xd(n);
  return r.length === 0 ? "0x" : r;
}
function zC({ params: e, values: t }) {
  const n = [];
  for (let r = 0; r < e.length; r++)
    n.push(Cd({ param: e[r], value: t[r] }));
  return n;
}
function Cd({ param: e, value: t }) {
  const n = wd(e.type);
  if (n) {
    const [r, o] = n;
    return jC(t, { length: r, param: { ...e, type: o } });
  }
  if (e.type === "tuple")
    return JC(t, {
      param: e
    });
  if (e.type === "address")
    return GC(t);
  if (e.type === "bool")
    return QC(t);
  if (e.type.startsWith("uint") || e.type.startsWith("int")) {
    const r = e.type.startsWith("int");
    return qC(t, { signed: r });
  }
  if (e.type.startsWith("bytes"))
    return UC(t, { param: e });
  if (e.type === "string")
    return YC(t);
  throw new fC(e.type, {
    docsPath: "/docs/contract/encodeAbiParameters"
  });
}
function xd(e) {
  let t = 0;
  for (let i = 0; i < e.length; i++) {
    const { dynamic: s, encoded: a } = e[i];
    s ? t += 32 : t += ct(a);
  }
  const n = [], r = [];
  let o = 0;
  for (let i = 0; i < e.length; i++) {
    const { dynamic: s, encoded: a } = e[i];
    s ? (n.push(ze(t + o, { size: 32 })), r.push(a), o += ct(a)) : n.push(a);
  }
  return Cr([...n, ...r]);
}
function GC(e) {
  if (!qn(e))
    throw new bi({ address: e });
  return { dynamic: !1, encoded: Wn(e.toLowerCase()) };
}
function jC(e, { length: t, param: n }) {
  const r = t === null;
  if (!Array.isArray(e))
    throw new pC(e);
  if (!r && e.length !== t)
    throw new cC({
      expectedLength: t,
      givenLength: e.length,
      type: `${n.type}[${t}]`
    });
  let o = !1;
  const i = [];
  for (let s = 0; s < e.length; s++) {
    const a = Cd({ param: n, value: e[s] });
    a.dynamic && (o = !0), i.push(a);
  }
  if (r || o) {
    const s = xd(i);
    if (r) {
      const a = ze(i.length, { size: 32 });
      return {
        dynamic: !0,
        encoded: i.length > 0 ? Cr([a, s]) : a
      };
    }
    if (o)
      return { dynamic: !0, encoded: s };
  }
  return {
    dynamic: !1,
    encoded: Cr(i.map(({ encoded: s }) => s))
  };
}
function UC(e, { param: t }) {
  const [, n] = t.type.split("bytes"), r = ct(e);
  if (!n) {
    let o = e;
    return r % 32 !== 0 && (o = Wn(o, {
      dir: "right",
      size: Math.ceil((e.length - 2) / 2 / 32) * 32
    })), {
      dynamic: !0,
      encoded: Cr([Wn(ze(r, { size: 32 })), o])
    };
  }
  if (r !== Number.parseInt(n))
    throw new uC({
      expectedSize: Number.parseInt(n),
      value: e
    });
  return { dynamic: !1, encoded: Wn(e, { dir: "right" }) };
}
function QC(e) {
  if (typeof e != "boolean")
    throw new ne(`Invalid boolean value: "${e}" (type: ${typeof e}). Expected: \`true\` or \`false\`.`);
  return { dynamic: !1, encoded: Wn(Op(e)) };
}
function qC(e, { signed: t }) {
  return {
    dynamic: !1,
    encoded: ze(e, {
      size: 32,
      signed: t
    })
  };
}
function YC(e) {
  const t = fd(e), n = Math.ceil(ct(t) / 32), r = [];
  for (let o = 0; o < n; o++)
    r.push(Wn(ua(t, o * 32, (o + 1) * 32), {
      dir: "right"
    }));
  return {
    dynamic: !0,
    encoded: Cr([
      Wn(ze(ct(t), { size: 32 })),
      ...r
    ])
  };
}
function JC(e, { param: t }) {
  let n = !1;
  const r = [];
  for (let o = 0; o < t.components.length; o++) {
    const i = t.components[o], s = Array.isArray(e) ? o : i.name, a = Cd({
      param: i,
      value: e[s]
    });
    r.push(a), a.dynamic && (n = !0);
  }
  return {
    dynamic: n,
    encoded: n ? xd(r) : Cr(r.map(({ encoded: o }) => o))
  };
}
function wd(e) {
  const t = e.match(/^(.*)\[(\d+)?\]$/);
  return t ? (
    // Return `null` if the array is dynamic.
    [t[2] ? Number(t[2]) : null, t[1]]
  ) : void 0;
}
const Nc = "/docs/contract/encodeDeployData";
function Wp(e) {
  const { abi: t, args: n, bytecode: r } = e;
  if (!n || n.length === 0)
    return r;
  const o = t.find((s) => "type" in s && s.type === "constructor");
  if (!o)
    throw new sC({ docsPath: Nc });
  if (!("inputs" in o))
    throw new h1({ docsPath: Nc });
  if (!o.inputs || o.inputs.length === 0)
    throw new h1({ docsPath: Nc });
  const i = Xp(o.inputs, n);
  return md([r, i]);
}
function za(e) {
  return typeof e == "string" ? { address: e, type: "json-rpc" } : e;
}
class x1 extends ne {
  constructor({ offset: t }) {
    super(`Offset \`${t}\` cannot be negative.`, {
      name: "NegativeOffsetError"
    });
  }
}
class KC extends ne {
  constructor({ length: t, position: n }) {
    super(`Position \`${n}\` is out of bounds (\`0 < position < ${t}\`).`, { name: "PositionOutOfBoundsError" });
  }
}
class _C extends ne {
  constructor({ count: t, limit: n }) {
    super(`Recursive read limit of \`${n}\` exceeded (recursive read count: \`${t}\`).`, { name: "RecursiveReadLimitExceededError" });
  }
}
const $C = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: Number.POSITIVE_INFINITY,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new _C({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(e) {
    if (e < 0 || e > this.bytes.length - 1)
      throw new KC({
        length: this.bytes.length,
        position: e
      });
  },
  decrementPosition(e) {
    if (e < 0)
      throw new x1({ offset: e });
    const t = this.position - e;
    this.assertPosition(t), this.position = t;
  },
  getReadCount(e) {
    return this.positionReadCount.get(e || this.position) || 0;
  },
  incrementPosition(e) {
    if (e < 0)
      throw new x1({ offset: e });
    const t = this.position + e;
    this.assertPosition(t), this.position = t;
  },
  inspectByte(e) {
    const t = e ?? this.position;
    return this.assertPosition(t), this.bytes[t];
  },
  inspectBytes(e, t) {
    const n = t ?? this.position;
    return this.assertPosition(n + e - 1), this.bytes.subarray(n, n + e);
  },
  inspectUint8(e) {
    const t = e ?? this.position;
    return this.assertPosition(t), this.bytes[t];
  },
  inspectUint16(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 1), this.dataView.getUint16(t);
  },
  inspectUint24(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 2), (this.dataView.getUint16(t) << 8) + this.dataView.getUint8(t + 2);
  },
  inspectUint32(e) {
    const t = e ?? this.position;
    return this.assertPosition(t + 3), this.dataView.getUint32(t);
  },
  pushByte(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushBytes(e) {
    this.assertPosition(this.position + e.length - 1), this.bytes.set(e, this.position), this.position += e.length;
  },
  pushUint8(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushUint16(e) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, e), this.position += 2;
  },
  pushUint24(e) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, e >> 8), this.dataView.setUint8(this.position + 2, e & 255), this.position += 3;
  },
  pushUint32(e) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, e), this.position += 4;
  },
  readByte() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectByte();
    return this.position++, e;
  },
  readBytes(e, t) {
    this.assertReadLimit(), this._touch();
    const n = this.inspectBytes(e);
    return this.position += t ?? e, n;
  },
  readUint8() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint8();
    return this.position += 1, e;
  },
  readUint16() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint16();
    return this.position += 2, e;
  },
  readUint24() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint24();
    return this.position += 3, e;
  },
  readUint32() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint32();
    return this.position += 4, e;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(e) {
    const t = this.position;
    return this.assertPosition(e), this.position = e, () => this.position = t;
  },
  _touch() {
    if (this.recursiveReadLimit === Number.POSITIVE_INFINITY)
      return;
    const e = this.getReadCount();
    this.positionReadCount.set(this.position, e + 1), e > 0 && this.recursiveReadCount++;
  }
};
function ex(e, { recursiveReadLimit: t = 8192 } = {}) {
  const n = Object.create($C);
  return n.bytes = e, n.dataView = new DataView(e.buffer, e.byteOffset, e.byteLength), n.positionReadCount = /* @__PURE__ */ new Map(), n.recursiveReadLimit = t, n;
}
class Ou extends ne {
  constructor({ blockNumber: t, chain: n, contract: r }) {
    super(`Chain "${n.name}" does not support contract "${r.name}".`, {
      metaMessages: [
        "This could be due to any of the following:",
        ...t && r.blockCreated && r.blockCreated > t ? [
          `- The contract "${r.name}" was not deployed until block ${r.blockCreated} (current block ${t}).`
        ] : [
          `- The chain does not have the contract "${r.name}" configured.`
        ]
      ],
      name: "ChainDoesNotSupportContract"
    });
  }
}
class Zp extends ne {
  constructor() {
    super("No chain was provided to the Client.", {
      name: "ClientChainNotConfiguredError"
    });
  }
}
const tx = {
  gwei: 9,
  wei: 18
}, nx = {
  ether: -9,
  wei: 9
};
function zp(e, t) {
  let n = e.toString();
  const r = n.startsWith("-");
  r && (n = n.slice(1)), n = n.padStart(t, "0");
  let [o, i] = [
    n.slice(0, n.length - t),
    n.slice(n.length - t)
  ];
  return i = i.replace(/(0+)$/, ""), `${r ? "-" : ""}${o || "0"}${i ? `.${i}` : ""}`;
}
function fr(e, t = "wei") {
  return zp(e, nx[t]);
}
class jr extends ne {
  constructor({ cause: t, message: n } = {}) {
    var o;
    const r = (o = n == null ? void 0 : n.replace("execution reverted: ", "")) == null ? void 0 : o.replace("execution reverted", "");
    super(`Execution reverted ${r ? `with reason: ${r}` : "for an unknown reason"}.`, {
      cause: t,
      name: "ExecutionRevertedError"
    });
  }
}
Object.defineProperty(jr, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 3
});
Object.defineProperty(jr, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /execution reverted/
});
class la extends ne {
  constructor({ cause: t, maxFeePerGas: n } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${n ? ` = ${fr(n)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: t,
      name: "FeeCapTooHighError"
    });
  }
}
Object.defineProperty(la, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class Du extends ne {
  constructor({ cause: t, maxFeePerGas: n } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${n ? ` = ${fr(n)}` : ""} gwei) cannot be lower than the block base fee.`, {
      cause: t,
      name: "FeeCapTooLowError"
    });
  }
}
Object.defineProperty(Du, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class Mu extends ne {
  constructor({ cause: t, nonce: n } = {}) {
    super(`Nonce provided for the transaction ${n ? `(${n}) ` : ""}is higher than the next one expected.`, { cause: t, name: "NonceTooHighError" });
  }
}
Object.defineProperty(Mu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too high/
});
class Fu extends ne {
  constructor({ cause: t, nonce: n } = {}) {
    super([
      `Nonce provided for the transaction ${n ? `(${n}) ` : ""}is lower than the current nonce of the account.`,
      "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
    ].join(`
`), { cause: t, name: "NonceTooLowError" });
  }
}
Object.defineProperty(Fu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce too low|transaction already imported|already known/
});
class Vu extends ne {
  constructor({ cause: t, nonce: n } = {}) {
    super(`Nonce provided for the transaction ${n ? `(${n}) ` : ""}exceeds the maximum allowed nonce.`, { cause: t, name: "NonceMaxValueError" });
  }
}
Object.defineProperty(Vu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /nonce has max value/
});
class Bu extends ne {
  constructor({ cause: t } = {}) {
    super([
      "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
    ].join(`
`), {
      cause: t,
      metaMessages: [
        "This error could arise when the account does not have enough funds to:",
        " - pay for the total gas fee,",
        " - pay for the value to send.",
        " ",
        "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
        " - `gas` is the amount of gas needed for transaction to execute,",
        " - `gas fee` is the gas fee,",
        " - `value` is the amount of ether to send to the recipient."
      ],
      name: "InsufficientFundsError"
    });
  }
}
Object.defineProperty(Bu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /insufficient funds/
});
class ku extends ne {
  constructor({ cause: t, gas: n } = {}) {
    super(`The amount of gas ${n ? `(${n}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
      cause: t,
      name: "IntrinsicGasTooHighError"
    });
  }
}
Object.defineProperty(ku, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too high|gas limit reached/
});
class Lu extends ne {
  constructor({ cause: t, gas: n } = {}) {
    super(`The amount of gas ${n ? `(${n}) ` : ""}provided for the transaction is too low.`, {
      cause: t,
      name: "IntrinsicGasTooLowError"
    });
  }
}
Object.defineProperty(Lu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /intrinsic gas too low/
});
class Hu extends ne {
  constructor({ cause: t }) {
    super("The transaction type is not supported for this chain.", {
      cause: t,
      name: "TransactionTypeNotSupportedError"
    });
  }
}
Object.defineProperty(Hu, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /transaction type not valid/
});
class da extends ne {
  constructor({ cause: t, maxPriorityFeePerGas: n, maxFeePerGas: r } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${n ? ` = ${fr(n)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${r ? ` = ${fr(r)} gwei` : ""}).`
    ].join(`
`), {
      cause: t,
      name: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(da, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class Gp extends ne {
  constructor({ cause: t }) {
    super(`An error occurred while executing: ${t == null ? void 0 : t.shortMessage}`, {
      cause: t,
      name: "UnknownNodeError"
    });
  }
}
function rx(e, t = "wei") {
  return zp(e, tx[t]);
}
function jp(e) {
  const t = Object.entries(e).map(([r, o]) => o === void 0 || o === !1 ? null : [r, o]).filter(Boolean), n = t.reduce((r, [o]) => Math.max(r, o.length), 0);
  return t.map(([r, o]) => `  ${`${r}:`.padEnd(n + 1)}  ${o}`).join(`
`);
}
class ox extends ne {
  constructor() {
    super([
      "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
      "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
    ].join(`
`), { name: "FeeConflictError" });
  }
}
const Zn = (e, t, n) => JSON.stringify(e, (r, o) => typeof o == "bigint" ? o.toString() : o, n), ix = (e) => e, Id = (e) => e;
class ai extends ne {
  constructor({ body: t, cause: n, details: r, headers: o, status: i, url: s }) {
    super("HTTP request failed.", {
      cause: n,
      details: r,
      metaMessages: [
        i && `Status: ${i}`,
        `URL: ${Id(s)}`,
        t && `Request body: ${Zn(t)}`
      ].filter(Boolean),
      name: "HttpRequestError"
    }), Object.defineProperty(this, "body", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "headers", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "status", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "url", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.body = t, this.headers = o, this.status = i, this.url = s;
  }
}
class Up extends ne {
  constructor({ body: t, error: n, url: r }) {
    super("RPC Request failed.", {
      cause: n,
      details: n.message,
      metaMessages: [`URL: ${Id(r)}`, `Request body: ${Zn(t)}`],
      name: "RpcRequestError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.code = n.code;
  }
}
class w1 extends ne {
  constructor({ body: t, url: n }) {
    super("The request took too long to respond.", {
      details: "The request timed out.",
      metaMessages: [`URL: ${Id(n)}`, `Request body: ${Zn(t)}`],
      name: "TimeoutError"
    });
  }
}
const sx = -1;
class Ct extends ne {
  constructor(t, { code: n, docsPath: r, metaMessages: o, name: i, shortMessage: s }) {
    super(s, {
      cause: t,
      docsPath: r,
      metaMessages: o || (t == null ? void 0 : t.metaMessages),
      name: i || "RpcError"
    }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = i || t.name, this.code = t instanceof Up ? t.code : n ?? sx;
  }
}
class Vo extends Ct {
  constructor(t, n) {
    super(t, n), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = n.data;
  }
}
class vi extends Ct {
  constructor(t) {
    super(t, {
      code: vi.code,
      name: "ParseRpcError",
      shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    });
  }
}
Object.defineProperty(vi, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32700
});
class yi extends Ct {
  constructor(t) {
    super(t, {
      code: yi.code,
      name: "InvalidRequestRpcError",
      shortMessage: "JSON is not a valid request object."
    });
  }
}
Object.defineProperty(yi, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32600
});
class Ci extends Ct {
  constructor(t, { method: n } = {}) {
    super(t, {
      code: Ci.code,
      name: "MethodNotFoundRpcError",
      shortMessage: `The method${n ? ` "${n}"` : ""} does not exist / is not available.`
    });
  }
}
Object.defineProperty(Ci, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32601
});
class xi extends Ct {
  constructor(t) {
    super(t, {
      code: xi.code,
      name: "InvalidParamsRpcError",
      shortMessage: [
        "Invalid parameters were provided to the RPC method.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    });
  }
}
Object.defineProperty(xi, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32602
});
class xr extends Ct {
  constructor(t) {
    super(t, {
      code: xr.code,
      name: "InternalRpcError",
      shortMessage: "An internal error was received."
    });
  }
}
Object.defineProperty(xr, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32603
});
class wi extends Ct {
  constructor(t) {
    super(t, {
      code: wi.code,
      name: "InvalidInputRpcError",
      shortMessage: [
        "Missing or invalid parameters.",
        "Double check you have provided the correct parameters."
      ].join(`
`)
    });
  }
}
Object.defineProperty(wi, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32e3
});
class Ii extends Ct {
  constructor(t) {
    super(t, {
      code: Ii.code,
      name: "ResourceNotFoundRpcError",
      shortMessage: "Requested resource not found."
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ResourceNotFoundRpcError"
    });
  }
}
Object.defineProperty(Ii, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32001
});
class zn extends Ct {
  constructor(t) {
    super(t, {
      code: zn.code,
      name: "ResourceUnavailableRpcError",
      shortMessage: "Requested resource not available."
    });
  }
}
Object.defineProperty(zn, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32002
});
class Ei extends Ct {
  constructor(t) {
    super(t, {
      code: Ei.code,
      name: "TransactionRejectedRpcError",
      shortMessage: "Transaction creation failed."
    });
  }
}
Object.defineProperty(Ei, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32003
});
class Si extends Ct {
  constructor(t, { method: n } = {}) {
    super(t, {
      code: Si.code,
      name: "MethodNotSupportedRpcError",
      shortMessage: `Method${n ? ` "${n}"` : ""} is not implemented.`
    });
  }
}
Object.defineProperty(Si, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32004
});
class Io extends Ct {
  constructor(t) {
    super(t, {
      code: Io.code,
      name: "LimitExceededRpcError",
      shortMessage: "Request exceeds defined limit."
    });
  }
}
Object.defineProperty(Io, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32005
});
class Ti extends Ct {
  constructor(t) {
    super(t, {
      code: Ti.code,
      name: "JsonRpcVersionUnsupportedError",
      shortMessage: "Version of JSON-RPC protocol is not supported."
    });
  }
}
Object.defineProperty(Ti, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: -32006
});
class At extends Vo {
  constructor(t) {
    super(t, {
      code: At.code,
      name: "UserRejectedRequestError",
      shortMessage: "User rejected the request."
    });
  }
}
Object.defineProperty(At, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4001
});
class Ni extends Vo {
  constructor(t) {
    super(t, {
      code: Ni.code,
      name: "UnauthorizedProviderError",
      shortMessage: "The requested method and/or account has not been authorized by the user."
    });
  }
}
Object.defineProperty(Ni, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4100
});
class Pi extends Vo {
  constructor(t, { method: n } = {}) {
    super(t, {
      code: Pi.code,
      name: "UnsupportedProviderMethodError",
      shortMessage: `The Provider does not support the requested method${n ? ` " ${n}"` : ""}.`
    });
  }
}
Object.defineProperty(Pi, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4200
});
class Ri extends Vo {
  constructor(t) {
    super(t, {
      code: Ri.code,
      name: "ProviderDisconnectedError",
      shortMessage: "The Provider is disconnected from all chains."
    });
  }
}
Object.defineProperty(Ri, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4900
});
class Oi extends Vo {
  constructor(t) {
    super(t, {
      code: Oi.code,
      name: "ChainDisconnectedError",
      shortMessage: "The Provider is not connected to the requested chain."
    });
  }
}
Object.defineProperty(Oi, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4901
});
class wr extends Vo {
  constructor(t) {
    super(t, {
      code: wr.code,
      name: "SwitchChainError",
      shortMessage: "An error occurred when attempting to switch chain."
    });
  }
}
Object.defineProperty(wr, "code", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: 4902
});
class ax extends Ct {
  constructor(t) {
    super(t, {
      name: "UnknownRpcError",
      shortMessage: "An unknown RPC error occurred."
    });
  }
}
function cx(e, t) {
  const n = (e.details || "").toLowerCase(), r = e instanceof ne ? e.walk((o) => o.code === jr.code) : e;
  return r instanceof ne ? new jr({
    cause: e,
    message: r.details
  }) : jr.nodeMessage.test(n) ? new jr({
    cause: e,
    message: e.details
  }) : la.nodeMessage.test(n) ? new la({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas
  }) : Du.nodeMessage.test(n) ? new Du({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas
  }) : Mu.nodeMessage.test(n) ? new Mu({ cause: e, nonce: t == null ? void 0 : t.nonce }) : Fu.nodeMessage.test(n) ? new Fu({ cause: e, nonce: t == null ? void 0 : t.nonce }) : Vu.nodeMessage.test(n) ? new Vu({ cause: e, nonce: t == null ? void 0 : t.nonce }) : Bu.nodeMessage.test(n) ? new Bu({ cause: e }) : ku.nodeMessage.test(n) ? new ku({ cause: e, gas: t == null ? void 0 : t.gas }) : Lu.nodeMessage.test(n) ? new Lu({ cause: e, gas: t == null ? void 0 : t.gas }) : Hu.nodeMessage.test(n) ? new Hu({ cause: e }) : da.nodeMessage.test(n) ? new da({
    cause: e,
    maxFeePerGas: t == null ? void 0 : t.maxFeePerGas,
    maxPriorityFeePerGas: t == null ? void 0 : t.maxPriorityFeePerGas
  }) : new Gp({
    cause: e
  });
}
function ux(e, { format: t }) {
  if (!t)
    return {};
  const n = {};
  function r(i) {
    const s = Object.keys(i);
    for (const a of s)
      a in e && (n[a] = e[a]), i[a] && typeof i[a] == "object" && !Array.isArray(i[a]) && r(i[a]);
  }
  const o = t(e || {});
  return r(o), n;
}
const lx = {
  legacy: "0x0",
  eip2930: "0x1",
  eip1559: "0x2",
  eip4844: "0x3",
  eip7702: "0x4"
};
function dx(e) {
  const t = {};
  return typeof e.authorizationList < "u" && (t.authorizationList = Ax(e.authorizationList)), typeof e.accessList < "u" && (t.accessList = e.accessList), typeof e.blobVersionedHashes < "u" && (t.blobVersionedHashes = e.blobVersionedHashes), typeof e.blobs < "u" && (typeof e.blobs[0] != "string" ? t.blobs = e.blobs.map((n) => Vt(n)) : t.blobs = e.blobs), typeof e.data < "u" && (t.data = e.data), typeof e.from < "u" && (t.from = e.from), typeof e.gas < "u" && (t.gas = ze(e.gas)), typeof e.gasPrice < "u" && (t.gasPrice = ze(e.gasPrice)), typeof e.maxFeePerBlobGas < "u" && (t.maxFeePerBlobGas = ze(e.maxFeePerBlobGas)), typeof e.maxFeePerGas < "u" && (t.maxFeePerGas = ze(e.maxFeePerGas)), typeof e.maxPriorityFeePerGas < "u" && (t.maxPriorityFeePerGas = ze(e.maxPriorityFeePerGas)), typeof e.nonce < "u" && (t.nonce = ze(e.nonce)), typeof e.to < "u" && (t.to = e.to), typeof e.type < "u" && (t.type = lx[e.type]), typeof e.value < "u" && (t.value = ze(e.value)), t;
}
function Ax(e) {
  return e.map((t) => ({
    address: t.contractAddress,
    r: t.r,
    s: t.s,
    chainId: ze(t.chainId),
    nonce: ze(t.nonce),
    ...typeof t.yParity < "u" ? { yParity: ze(t.yParity) } : {},
    ...typeof t.v < "u" && typeof t.yParity > "u" ? { v: ze(t.v) } : {}
  }));
}
function Ga(e, t, n) {
  const r = e[t.name];
  if (typeof r == "function")
    return r;
  const o = e[n];
  return typeof o == "function" ? o : (i) => t(e, i);
}
function fx(e) {
  const { account: t, gasPrice: n, maxFeePerGas: r, maxPriorityFeePerGas: o, to: i } = e, s = t ? za(t) : void 0;
  if (s && !qn(s.address))
    throw new bi({ address: s.address });
  if (i && !qn(i))
    throw new bi({ address: i });
  if (typeof n < "u" && (typeof r < "u" || typeof o < "u"))
    throw new ox();
  if (r && r > 2n ** 256n - 1n)
    throw new la({ maxFeePerGas: r });
  if (o && r && o > r)
    throw new da({ maxFeePerGas: r, maxPriorityFeePerGas: o });
}
class hx extends ne {
  constructor({ address: t }) {
    super(`State for account "${t}" is set multiple times.`, {
      name: "AccountStateConflictError"
    });
  }
}
class px extends ne {
  constructor() {
    super("state and stateDiff are set on the same account.", {
      name: "StateAssignmentConflictError"
    });
  }
}
function I1(e) {
  return e.reduce((t, { slot: n, value: r }) => `${t}        ${n}: ${r}
`, "");
}
function mx(e) {
  return e.reduce((t, { address: n, ...r }) => {
    let o = `${t}    ${n}:
`;
    return r.nonce && (o += `      nonce: ${r.nonce}
`), r.balance && (o += `      balance: ${r.balance}
`), r.code && (o += `      code: ${r.code}
`), r.state && (o += `      state:
`, o += I1(r.state)), r.stateDiff && (o += `      stateDiff:
`, o += I1(r.stateDiff)), o;
  }, `  State Override:
`).slice(0, -1);
}
function E1(e) {
  if (!(!e || e.length === 0))
    return e.reduce((t, { slot: n, value: r }) => {
      if (n.length !== 66)
        throw new A1({
          size: n.length,
          targetSize: 66,
          type: "hex"
        });
      if (r.length !== 66)
        throw new A1({
          size: r.length,
          targetSize: 66,
          type: "hex"
        });
      return t[n] = r, t;
    }, {});
}
function gx(e) {
  const { balance: t, nonce: n, state: r, stateDiff: o, code: i } = e, s = {};
  if (i !== void 0 && (s.code = i), t !== void 0 && (s.balance = ze(t)), n !== void 0 && (s.nonce = ze(n)), r !== void 0 && (s.state = E1(r)), o !== void 0) {
    if (s.state)
      throw new px();
    s.stateDiff = E1(o);
  }
  return s;
}
function bx(e) {
  if (!e)
    return;
  const t = {};
  for (const { address: n, ...r } of e) {
    if (!qn(n, { strict: !1 }))
      throw new bi({ address: n });
    if (t[n])
      throw new hx({ address: n });
    t[n] = gx(r);
  }
  return t;
}
const S1 = [
  {
    inputs: [
      {
        components: [
          {
            name: "target",
            type: "address"
          },
          {
            name: "allowFailure",
            type: "bool"
          },
          {
            name: "callData",
            type: "bytes"
          }
        ],
        name: "calls",
        type: "tuple[]"
      }
    ],
    name: "aggregate3",
    outputs: [
      {
        components: [
          {
            name: "success",
            type: "bool"
          },
          {
            name: "returnData",
            type: "bytes"
          }
        ],
        name: "returnData",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], Qp = [
  {
    inputs: [],
    name: "ResolverNotFound",
    type: "error"
  },
  {
    inputs: [],
    name: "ResolverWildcardNotSupported",
    type: "error"
  },
  {
    inputs: [],
    name: "ResolverNotContract",
    type: "error"
  },
  {
    inputs: [
      {
        name: "returnData",
        type: "bytes"
      }
    ],
    name: "ResolverError",
    type: "error"
  },
  {
    inputs: [
      {
        components: [
          {
            name: "status",
            type: "uint16"
          },
          {
            name: "message",
            type: "string"
          }
        ],
        name: "errors",
        type: "tuple[]"
      }
    ],
    name: "HttpError",
    type: "error"
  }
], vx = [
  ...Qp,
  {
    name: "resolve",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes" },
      { name: "data", type: "bytes" }
    ],
    outputs: [
      { name: "", type: "bytes" },
      { name: "address", type: "address" }
    ]
  },
  {
    name: "resolve",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes" },
      { name: "data", type: "bytes" },
      { name: "gateways", type: "string[]" }
    ],
    outputs: [
      { name: "", type: "bytes" },
      { name: "address", type: "address" }
    ]
  }
], yx = [
  ...Qp,
  {
    name: "reverse",
    type: "function",
    stateMutability: "view",
    inputs: [{ type: "bytes", name: "reverseName" }],
    outputs: [
      { type: "string", name: "resolvedName" },
      { type: "address", name: "resolvedAddress" },
      { type: "address", name: "reverseResolver" },
      { type: "address", name: "resolver" }
    ]
  },
  {
    name: "reverse",
    type: "function",
    stateMutability: "view",
    inputs: [
      { type: "bytes", name: "reverseName" },
      { type: "string[]", name: "gateways" }
    ],
    outputs: [
      { type: "string", name: "resolvedName" },
      { type: "address", name: "resolvedAddress" },
      { type: "address", name: "reverseResolver" },
      { type: "address", name: "resolver" }
    ]
  }
], T1 = [
  {
    name: "text",
    type: "function",
    stateMutability: "view",
    inputs: [
      { name: "name", type: "bytes32" },
      { name: "key", type: "string" }
    ],
    outputs: [{ name: "", type: "string" }]
  }
];
function Cx(e, t = {}) {
  typeof t.size < "u" && An(e, { size: t.size });
  const n = Vt(e, t);
  return Rp(n, t);
}
function xx(e, t = {}) {
  let n = e;
  if (typeof t.size < "u" && (An(n, { size: t.size }), n = ud(n)), n.length > 1 || n[0] > 1)
    throw new J8(n);
  return !!n[0];
}
function vn(e, t = {}) {
  typeof t.size < "u" && An(e, { size: t.size });
  const n = Vt(e, t);
  return nC(n, t);
}
function wx(e, t = {}) {
  let n = e;
  return typeof t.size < "u" && (An(n, { size: t.size }), n = ud(n, { dir: "right" })), new TextDecoder().decode(n);
}
function qp(e, t) {
  const n = typeof t == "string" ? dd(t) : t, r = ex(n);
  if (ct(n) === 0 && e.length > 0)
    throw new pd();
  if (ct(t) && ct(t) < 32)
    throw new aC({
      data: typeof t == "string" ? t : Vt(t),
      params: e,
      size: ct(t)
    });
  let o = 0;
  const i = [];
  for (let s = 0; s < e.length; ++s) {
    const a = e[s];
    r.setPosition(o);
    const [c, u] = $r(r, a, {
      staticPosition: 0
    });
    o += u, i.push(c);
  }
  return i;
}
function $r(e, t, { staticPosition: n }) {
  const r = wd(t.type);
  if (r) {
    const [o, i] = r;
    return Ex(e, { ...t, type: i }, { length: o, staticPosition: n });
  }
  if (t.type === "tuple")
    return Px(e, t, { staticPosition: n });
  if (t.type === "address")
    return Ix(e);
  if (t.type === "bool")
    return Sx(e);
  if (t.type.startsWith("bytes"))
    return Tx(e, t, { staticPosition: n });
  if (t.type.startsWith("uint") || t.type.startsWith("int"))
    return Nx(e, t);
  if (t.type === "string")
    return Rx(e, { staticPosition: n });
  throw new hC(t.type, {
    docsPath: "/docs/contract/decodeAbiParameters"
  });
}
const N1 = 32, Xu = 32;
function Ix(e) {
  const t = e.readBytes(32);
  return [yd(Vt(Hp(t, -20))), 32];
}
function Ex(e, t, { length: n, staticPosition: r }) {
  if (!n) {
    const s = vn(e.readBytes(Xu)), a = r + s, c = a + N1;
    e.setPosition(a);
    const u = vn(e.readBytes(N1)), l = Di(t);
    let d = 0;
    const f = [];
    for (let p = 0; p < u; ++p) {
      e.setPosition(c + (l ? p * 32 : d));
      const [h, g] = $r(e, t, {
        staticPosition: c
      });
      d += g, f.push(h);
    }
    return e.setPosition(r + 32), [f, 32];
  }
  if (Di(t)) {
    const s = vn(e.readBytes(Xu)), a = r + s, c = [];
    for (let u = 0; u < n; ++u) {
      e.setPosition(a + u * 32);
      const [l] = $r(e, t, {
        staticPosition: a
      });
      c.push(l);
    }
    return e.setPosition(r + 32), [c, 32];
  }
  let o = 0;
  const i = [];
  for (let s = 0; s < n; ++s) {
    const [a, c] = $r(e, t, {
      staticPosition: r + o
    });
    o += c, i.push(a);
  }
  return [i, o];
}
function Sx(e) {
  return [xx(e.readBytes(32), { size: 32 }), 32];
}
function Tx(e, t, { staticPosition: n }) {
  const [r, o] = t.type.split("bytes");
  if (!o) {
    const s = vn(e.readBytes(32));
    e.setPosition(n + s);
    const a = vn(e.readBytes(32));
    if (a === 0)
      return e.setPosition(n + 32), ["0x", 32];
    const c = e.readBytes(a);
    return e.setPosition(n + 32), [Vt(c), 32];
  }
  return [Vt(e.readBytes(Number.parseInt(o), 32)), 32];
}
function Nx(e, t) {
  const n = t.type.startsWith("int"), r = Number.parseInt(t.type.split("int")[1] || "256"), o = e.readBytes(32);
  return [
    r > 48 ? Cx(o, { signed: n }) : vn(o, { signed: n }),
    32
  ];
}
function Px(e, t, { staticPosition: n }) {
  const r = t.components.length === 0 || t.components.some(({ name: s }) => !s), o = r ? [] : {};
  let i = 0;
  if (Di(t)) {
    const s = vn(e.readBytes(Xu)), a = n + s;
    for (let c = 0; c < t.components.length; ++c) {
      const u = t.components[c];
      e.setPosition(a + i);
      const [l, d] = $r(e, u, {
        staticPosition: a
      });
      i += d, o[r ? c : u == null ? void 0 : u.name] = l;
    }
    return e.setPosition(n + 32), [o, 32];
  }
  for (let s = 0; s < t.components.length; ++s) {
    const a = t.components[s], [c, u] = $r(e, a, {
      staticPosition: n
    });
    o[r ? s : a == null ? void 0 : a.name] = c, i += u;
  }
  return [o, i];
}
function Rx(e, { staticPosition: t }) {
  const n = vn(e.readBytes(32)), r = t + n;
  e.setPosition(r);
  const o = vn(e.readBytes(32));
  if (o === 0)
    return e.setPosition(t + 32), ["", 32];
  const i = e.readBytes(o, 32), s = wx(ud(i));
  return e.setPosition(t + 32), [s, 32];
}
function Di(e) {
  var r;
  const { type: t } = e;
  if (t === "string" || t === "bytes" || t.endsWith("[]"))
    return !0;
  if (t === "tuple")
    return (r = e.components) == null ? void 0 : r.some(Di);
  const n = wd(e.type);
  return !!(n && Di({ ...e, type: n[1] }));
}
const Ox = (e) => wo(ld(e));
function Dx(e) {
  return Ox(e);
}
const Mx = "1.0.5";
let Bt = class Wu extends Error {
  constructor(t, n = {}) {
    var s;
    const r = n.cause instanceof Wu ? n.cause.details : (s = n.cause) != null && s.message ? n.cause.message : n.details, o = n.cause instanceof Wu && n.cause.docsPath || n.docsPath, i = [
      t || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...o ? [`Docs: https://abitype.dev${o}`] : [],
      ...r ? [`Details: ${r}`] : [],
      `Version: abitype@${Mx}`
    ].join(`
`);
    super(i), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "AbiTypeError"
    }), n.cause && (this.cause = n.cause), this.details = r, this.docsPath = o, this.metaMessages = n.metaMessages, this.shortMessage = t;
  }
};
function Kn(e, t) {
  const n = e.exec(t);
  return n == null ? void 0 : n.groups;
}
const Yp = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/, Jp = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/, Kp = /^\(.+?\).*?$/, P1 = /^tuple(?<array>(\[(\d*)\])*)$/;
function Zu(e) {
  let t = e.type;
  if (P1.test(e.type) && "components" in e) {
    t = "(";
    const n = e.components.length;
    for (let o = 0; o < n; o++) {
      const i = e.components[o];
      t += Zu(i), o < n - 1 && (t += ", ");
    }
    const r = Kn(P1, e.type);
    return t += `)${(r == null ? void 0 : r.array) ?? ""}`, Zu({
      ...e,
      type: t
    });
  }
  return "indexed" in e && e.indexed && (t = `${t} indexed`), e.name ? `${t} ${e.name}` : t;
}
function qo(e) {
  let t = "";
  const n = e.length;
  for (let r = 0; r < n; r++) {
    const o = e[r];
    t += Zu(o), r !== n - 1 && (t += ", ");
  }
  return t;
}
function Fx(e) {
  return e.type === "function" ? `function ${e.name}(${qo(e.inputs)})${e.stateMutability && e.stateMutability !== "nonpayable" ? ` ${e.stateMutability}` : ""}${e.outputs.length ? ` returns (${qo(e.outputs)})` : ""}` : e.type === "event" ? `event ${e.name}(${qo(e.inputs)})` : e.type === "error" ? `error ${e.name}(${qo(e.inputs)})` : e.type === "constructor" ? `constructor(${qo(e.inputs)})${e.stateMutability === "payable" ? " payable" : ""}` : e.type === "fallback" ? "fallback()" : "receive() external payable";
}
const _p = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function Vx(e) {
  return _p.test(e);
}
function Bx(e) {
  return Kn(_p, e);
}
const $p = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function kx(e) {
  return $p.test(e);
}
function Lx(e) {
  return Kn($p, e);
}
const em = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function Hx(e) {
  return em.test(e);
}
function Xx(e) {
  return Kn(em, e);
}
const tm = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function nm(e) {
  return tm.test(e);
}
function Wx(e) {
  return Kn(tm, e);
}
const rm = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function Zx(e) {
  return rm.test(e);
}
function zx(e) {
  return Kn(rm, e);
}
const Gx = /^fallback\(\) external(?:\s(?<stateMutability>payable{1}))?$/;
function jx(e) {
  return Gx.test(e);
}
const Ux = /^receive\(\) external payable$/;
function Qx(e) {
  return Ux.test(e);
}
const qx = /* @__PURE__ */ new Set(["indexed"]), zu = /* @__PURE__ */ new Set([
  "calldata",
  "memory",
  "storage"
]);
class Yx extends Bt {
  constructor({ type: t }) {
    super("Unknown type.", {
      metaMessages: [
        `Type "${t}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownTypeError"
    });
  }
}
class Jx extends Bt {
  constructor({ type: t }) {
    super("Unknown type.", {
      metaMessages: [`Type "${t}" is not a valid ABI type.`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownSolidityTypeError"
    });
  }
}
class Kx extends Bt {
  constructor({ param: t }) {
    super("Invalid ABI parameter.", {
      details: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParameterError"
    });
  }
}
class _x extends Bt {
  constructor({ param: t, name: n }) {
    super("Invalid ABI parameter.", {
      details: t,
      metaMessages: [
        `"${n}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SolidityProtectedKeywordError"
    });
  }
}
class $x extends Bt {
  constructor({ param: t, type: n, modifier: r }) {
    super("Invalid ABI parameter.", {
      details: t,
      metaMessages: [
        `Modifier "${r}" not allowed${n ? ` in "${n}" type` : ""}.`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidModifierError"
    });
  }
}
class ew extends Bt {
  constructor({ param: t, type: n, modifier: r }) {
    super("Invalid ABI parameter.", {
      details: t,
      metaMessages: [
        `Modifier "${r}" not allowed${n ? ` in "${n}" type` : ""}.`,
        `Data location can only be specified for array, struct, or mapping types, but "${r}" was given.`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidFunctionModifierError"
    });
  }
}
class tw extends Bt {
  constructor({ abiParameter: t }) {
    super("Invalid ABI parameter.", {
      details: JSON.stringify(t, null, 2),
      metaMessages: ["ABI parameter type is invalid."]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAbiTypeParameterError"
    });
  }
}
class oi extends Bt {
  constructor({ signature: t, type: n }) {
    super(`Invalid ${n} signature.`, {
      details: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSignatureError"
    });
  }
}
class nw extends Bt {
  constructor({ signature: t }) {
    super("Unknown signature.", {
      details: t
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "UnknownSignatureError"
    });
  }
}
class rw extends Bt {
  constructor({ signature: t }) {
    super("Invalid struct signature.", {
      details: t,
      metaMessages: ["No properties exist."]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidStructSignatureError"
    });
  }
}
class ow extends Bt {
  constructor({ type: t }) {
    super("Circular reference detected.", {
      metaMessages: [`Struct "${t}" is a circular reference.`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "CircularReferenceError"
    });
  }
}
class iw extends Bt {
  constructor({ current: t, depth: n }) {
    super("Unbalanced parentheses.", {
      metaMessages: [
        `"${t.trim()}" has too many ${n > 0 ? "opening" : "closing"} parentheses.`
      ],
      details: `Depth "${n}"`
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidParenthesisError"
    });
  }
}
function sw(e, t) {
  return t ? `${t}:${e}` : e;
}
const Pc = /* @__PURE__ */ new Map([
  // Unnamed
  ["address", { type: "address" }],
  ["bool", { type: "bool" }],
  ["bytes", { type: "bytes" }],
  ["bytes32", { type: "bytes32" }],
  ["int", { type: "int256" }],
  ["int256", { type: "int256" }],
  ["string", { type: "string" }],
  ["uint", { type: "uint256" }],
  ["uint8", { type: "uint8" }],
  ["uint16", { type: "uint16" }],
  ["uint24", { type: "uint24" }],
  ["uint32", { type: "uint32" }],
  ["uint64", { type: "uint64" }],
  ["uint96", { type: "uint96" }],
  ["uint112", { type: "uint112" }],
  ["uint160", { type: "uint160" }],
  ["uint192", { type: "uint192" }],
  ["uint256", { type: "uint256" }],
  // Named
  ["address owner", { type: "address", name: "owner" }],
  ["address to", { type: "address", name: "to" }],
  ["bool approved", { type: "bool", name: "approved" }],
  ["bytes _data", { type: "bytes", name: "_data" }],
  ["bytes data", { type: "bytes", name: "data" }],
  ["bytes signature", { type: "bytes", name: "signature" }],
  ["bytes32 hash", { type: "bytes32", name: "hash" }],
  ["bytes32 r", { type: "bytes32", name: "r" }],
  ["bytes32 root", { type: "bytes32", name: "root" }],
  ["bytes32 s", { type: "bytes32", name: "s" }],
  ["string name", { type: "string", name: "name" }],
  ["string symbol", { type: "string", name: "symbol" }],
  ["string tokenURI", { type: "string", name: "tokenURI" }],
  ["uint tokenId", { type: "uint256", name: "tokenId" }],
  ["uint8 v", { type: "uint8", name: "v" }],
  ["uint256 balance", { type: "uint256", name: "balance" }],
  ["uint256 tokenId", { type: "uint256", name: "tokenId" }],
  ["uint256 value", { type: "uint256", name: "value" }],
  // Indexed
  [
    "event:address indexed from",
    { type: "address", name: "from", indexed: !0 }
  ],
  ["event:address indexed to", { type: "address", name: "to", indexed: !0 }],
  [
    "event:uint indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: !0 }
  ],
  [
    "event:uint256 indexed tokenId",
    { type: "uint256", name: "tokenId", indexed: !0 }
  ]
]);
function aw(e, t = {}) {
  if (Hx(e)) {
    const n = Xx(e);
    if (!n)
      throw new oi({ signature: e, type: "function" });
    const r = Zt(n.parameters), o = [], i = r.length;
    for (let a = 0; a < i; a++)
      o.push(tr(r[a], {
        modifiers: zu,
        structs: t,
        type: "function"
      }));
    const s = [];
    if (n.returns) {
      const a = Zt(n.returns), c = a.length;
      for (let u = 0; u < c; u++)
        s.push(tr(a[u], {
          modifiers: zu,
          structs: t,
          type: "function"
        }));
    }
    return {
      name: n.name,
      type: "function",
      stateMutability: n.stateMutability ?? "nonpayable",
      inputs: o,
      outputs: s
    };
  }
  if (kx(e)) {
    const n = Lx(e);
    if (!n)
      throw new oi({ signature: e, type: "event" });
    const r = Zt(n.parameters), o = [], i = r.length;
    for (let s = 0; s < i; s++)
      o.push(tr(r[s], {
        modifiers: qx,
        structs: t,
        type: "event"
      }));
    return { name: n.name, type: "event", inputs: o };
  }
  if (Vx(e)) {
    const n = Bx(e);
    if (!n)
      throw new oi({ signature: e, type: "error" });
    const r = Zt(n.parameters), o = [], i = r.length;
    for (let s = 0; s < i; s++)
      o.push(tr(r[s], { structs: t, type: "error" }));
    return { name: n.name, type: "error", inputs: o };
  }
  if (Zx(e)) {
    const n = zx(e);
    if (!n)
      throw new oi({ signature: e, type: "constructor" });
    const r = Zt(n.parameters), o = [], i = r.length;
    for (let s = 0; s < i; s++)
      o.push(tr(r[s], { structs: t, type: "constructor" }));
    return {
      type: "constructor",
      stateMutability: n.stateMutability ?? "nonpayable",
      inputs: o
    };
  }
  if (jx(e))
    return { type: "fallback" };
  if (Qx(e))
    return {
      type: "receive",
      stateMutability: "payable"
    };
  throw new nw({ signature: e });
}
const cw = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/, uw = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/, lw = /^u?int$/;
function tr(e, t) {
  var d, f;
  const n = sw(e, t == null ? void 0 : t.type);
  if (Pc.has(n))
    return Pc.get(n);
  const r = Kp.test(e), o = Kn(r ? uw : cw, e);
  if (!o)
    throw new Kx({ param: e });
  if (o.name && Aw(o.name))
    throw new _x({ param: e, name: o.name });
  const i = o.name ? { name: o.name } : {}, s = o.modifier === "indexed" ? { indexed: !0 } : {}, a = (t == null ? void 0 : t.structs) ?? {};
  let c, u = {};
  if (r) {
    c = "tuple";
    const p = Zt(o.type), h = [], g = p.length;
    for (let m = 0; m < g; m++)
      h.push(tr(p[m], { structs: a }));
    u = { components: h };
  } else if (o.type in a)
    c = "tuple", u = { components: a[o.type] };
  else if (lw.test(o.type))
    c = `${o.type}256`;
  else if (c = o.type, (t == null ? void 0 : t.type) !== "struct" && !om(c))
    throw new Jx({ type: c });
  if (o.modifier) {
    if (!((f = (d = t == null ? void 0 : t.modifiers) == null ? void 0 : d.has) != null && f.call(d, o.modifier)))
      throw new $x({
        param: e,
        type: t == null ? void 0 : t.type,
        modifier: o.modifier
      });
    if (zu.has(o.modifier) && !fw(c, !!o.array))
      throw new ew({
        param: e,
        type: t == null ? void 0 : t.type,
        modifier: o.modifier
      });
  }
  const l = {
    type: `${c}${o.array ?? ""}`,
    ...i,
    ...s,
    ...u
  };
  return Pc.set(n, l), l;
}
function Zt(e, t = [], n = "", r = 0) {
  const o = e.trim().length;
  for (let i = 0; i < o; i++) {
    const s = e[i], a = e.slice(i + 1);
    switch (s) {
      case ",":
        return r === 0 ? Zt(a, [...t, n.trim()]) : Zt(a, t, `${n}${s}`, r);
      case "(":
        return Zt(a, t, `${n}${s}`, r + 1);
      case ")":
        return Zt(a, t, `${n}${s}`, r - 1);
      default:
        return Zt(a, t, `${n}${s}`, r);
    }
  }
  if (n === "")
    return t;
  if (r !== 0)
    throw new iw({ current: n, depth: r });
  return t.push(n.trim()), t;
}
function om(e) {
  return e === "address" || e === "bool" || e === "function" || e === "string" || Yp.test(e) || Jp.test(e);
}
const dw = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function Aw(e) {
  return e === "address" || e === "bool" || e === "function" || e === "string" || e === "tuple" || Yp.test(e) || Jp.test(e) || dw.test(e);
}
function fw(e, t) {
  return t || e === "bytes" || e === "string" || e === "tuple";
}
function hw(e) {
  const t = {}, n = e.length;
  for (let s = 0; s < n; s++) {
    const a = e[s];
    if (!nm(a))
      continue;
    const c = Wx(a);
    if (!c)
      throw new oi({ signature: a, type: "struct" });
    const u = c.properties.split(";"), l = [], d = u.length;
    for (let f = 0; f < d; f++) {
      const h = u[f].trim();
      if (!h)
        continue;
      const g = tr(h, {
        type: "struct"
      });
      l.push(g);
    }
    if (!l.length)
      throw new rw({ signature: a });
    t[c.name] = l;
  }
  const r = {}, o = Object.entries(t), i = o.length;
  for (let s = 0; s < i; s++) {
    const [a, c] = o[s];
    r[a] = im(c, t);
  }
  return r;
}
const pw = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function im(e, t, n = /* @__PURE__ */ new Set()) {
  const r = [], o = e.length;
  for (let i = 0; i < o; i++) {
    const s = e[i];
    if (Kp.test(s.type))
      r.push(s);
    else {
      const c = Kn(pw, s.type);
      if (!(c != null && c.type))
        throw new tw({ abiParameter: s });
      const { array: u, type: l } = c;
      if (l in t) {
        if (n.has(l))
          throw new ow({ type: l });
        r.push({
          ...s,
          type: `tuple${u ?? ""}`,
          components: im(t[l] ?? [], t, /* @__PURE__ */ new Set([...n, l]))
        });
      } else if (om(l))
        r.push(s);
      else
        throw new Yx({ type: l });
    }
  }
  return r;
}
function sm(e) {
  const t = hw(e), n = [], r = e.length;
  for (let o = 0; o < r; o++) {
    const i = e[o];
    nm(i) || n.push(aw(i, t));
  }
  return n;
}
function mw(e) {
  let t = !0, n = "", r = 0, o = "", i = !1;
  for (let s = 0; s < e.length; s++) {
    const a = e[s];
    if (["(", ")", ","].includes(a) && (t = !0), a === "(" && r++, a === ")" && r--, !!t) {
      if (r === 0) {
        if (a === " " && ["event", "function", ""].includes(o))
          o = "";
        else if (o += a, a === ")") {
          i = !0;
          break;
        }
        continue;
      }
      if (a === " ") {
        e[s - 1] !== "," && n !== "," && n !== ",(" && (n = "", t = !1);
        continue;
      }
      o += a, n += a;
    }
  }
  if (!i)
    throw new ne("Unable to normalize signature.");
  return o;
}
const gw = (e) => {
  const t = typeof e == "string" ? e : Fx(e);
  return mw(t);
};
function am(e) {
  return Dx(gw(e));
}
const bw = am, Ed = (e) => ua(am(e), 0, 4);
function Sd(e) {
  const { abi: t, args: n = [], name: r } = e, o = Fo(r, { strict: !1 }), i = t.filter((a) => o ? a.type === "function" ? Ed(a) === r : a.type === "event" ? bw(a) === r : !1 : "name" in a && a.name === r);
  if (i.length === 0)
    return;
  if (i.length === 1)
    return i[0];
  let s;
  for (const a of i) {
    if (!("inputs" in a))
      continue;
    if (!n || n.length === 0) {
      if (!a.inputs || a.inputs.length === 0)
        return a;
      continue;
    }
    if (!a.inputs || a.inputs.length === 0 || a.inputs.length !== n.length)
      continue;
    if (n.every((u, l) => {
      const d = "inputs" in a && a.inputs[l];
      return d ? Gu(u, d) : !1;
    })) {
      if (s && "inputs" in s && s.inputs) {
        const u = cm(a.inputs, s.inputs, n);
        if (u)
          throw new AC({
            abiItem: a,
            type: u[0]
          }, {
            abiItem: s,
            type: u[1]
          });
      }
      s = a;
    }
  }
  return s || i[0];
}
function Gu(e, t) {
  const n = typeof e, r = t.type;
  switch (r) {
    case "address":
      return qn(e, { strict: !1 });
    case "bool":
      return n === "boolean";
    case "function":
      return n === "string";
    case "string":
      return n === "string";
    default:
      return r === "tuple" && "components" in t ? Object.values(t.components).every((o, i) => Gu(Object.values(e)[i], o)) : /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(r) ? n === "number" || n === "bigint" : /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(r) ? n === "string" || e instanceof Uint8Array : /[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(r) ? Array.isArray(e) && e.every((o) => Gu(o, {
        ...t,
        // Pop off `[]` or `[M]` from end of type
        type: r.replace(/(\[[0-9]{0,}\])$/, "")
      })) : !1;
  }
}
function cm(e, t, n) {
  for (const r in e) {
    const o = e[r], i = t[r];
    if (o.type === "tuple" && i.type === "tuple" && "components" in o && "components" in i)
      return cm(o.components, i.components, n[r]);
    const s = [o.type, i.type];
    if (s.includes("address") && s.includes("bytes20") ? !0 : s.includes("address") && s.includes("string") ? qn(n[r], { strict: !1 }) : s.includes("address") && s.includes("bytes") ? qn(n[r], { strict: !1 }) : !1)
      return s;
  }
}
const Rc = "/docs/contract/decodeFunctionResult";
function Td(e) {
  const { abi: t, args: n, functionName: r, data: o } = e;
  let i = t[0];
  if (r) {
    const a = Sd({ abi: t, args: n, name: r });
    if (!a)
      throw new ca(r, { docsPath: Rc });
    i = a;
  }
  if (i.type !== "function")
    throw new ca(void 0, { docsPath: Rc });
  if (!i.outputs)
    throw new dC(i.name, { docsPath: Rc });
  const s = qp(i.outputs, o);
  if (s && s.length > 1)
    return s;
  if (s && s.length === 1)
    return s[0];
}
const R1 = "/docs/contract/encodeFunctionData";
function vw(e) {
  const { abi: t, args: n, functionName: r } = e;
  let o = t[0];
  if (r) {
    const i = Sd({
      abi: t,
      args: n,
      name: r
    });
    if (!i)
      throw new ca(r, { docsPath: R1 });
    o = i;
  }
  if (o.type !== "function")
    throw new ca(void 0, { docsPath: R1 });
  return {
    abi: [o],
    functionName: Ed(xo(o))
  };
}
function Nd(e) {
  const { args: t } = e, { abi: n, functionName: r } = (() => {
    var a;
    return e.abi.length === 1 && ((a = e.functionName) != null && a.startsWith("0x")) ? e : vw(e);
  })(), o = n[0], i = r, s = "inputs" in o && o.inputs ? Xp(o.inputs, t ?? []) : void 0;
  return md([i, s ?? "0x"]);
}
function Pd({ blockNumber: e, chain: t, contract: n }) {
  var o;
  const r = (o = t == null ? void 0 : t.contracts) == null ? void 0 : o[n];
  if (!r)
    throw new Ou({
      chain: t,
      contract: { name: n }
    });
  if (e && r.blockCreated && r.blockCreated > e)
    throw new Ou({
      blockNumber: e,
      chain: t,
      contract: {
        name: n,
        blockCreated: r.blockCreated
      }
    });
  return r.address;
}
const um = {
  1: "An `assert` condition failed.",
  17: "Arithmetic operation resulted in underflow or overflow.",
  18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
  33: "Attempted to convert to an invalid type.",
  34: "Attempted to access a storage byte array that is incorrectly encoded.",
  49: "Performed `.pop()` on an empty array",
  50: "Array index is out of bounds.",
  65: "Allocated too much memory or created an array which is too large.",
  81: "Attempted to call a zero-initialized variable of internal function type."
}, yw = {
  inputs: [
    {
      name: "message",
      type: "string"
    }
  ],
  name: "Error",
  type: "error"
}, Cw = {
  inputs: [
    {
      name: "reason",
      type: "uint256"
    }
  ],
  name: "Panic",
  type: "error"
};
function xw(e) {
  const { abi: t, data: n } = e, r = ua(n, 0, 4);
  if (r === "0x")
    throw new pd();
  const i = [...t || [], yw, Cw].find((s) => s.type === "error" && r === Ed(xo(s)));
  if (!i)
    throw new Dp(r, {
      docsPath: "/docs/contract/decodeErrorResult"
    });
  return {
    abiItem: i,
    args: "inputs" in i && i.inputs && i.inputs.length > 0 ? qp(i.inputs, ua(n, 4)) : void 0,
    errorName: i.name
  };
}
function lm({ abiItem: e, args: t, includeFunctionName: n = !0, includeName: r = !1 }) {
  if ("name" in e && "inputs" in e && e.inputs)
    return `${n ? e.name : ""}(${e.inputs.map((o, i) => `${r && o.name ? `${o.name}: ` : ""}${typeof t[i] == "object" ? Zn(t[i]) : t[i]}`).join(", ")})`;
}
class ww extends ne {
  constructor(t, { account: n, docsPath: r, chain: o, data: i, gas: s, gasPrice: a, maxFeePerGas: c, maxPriorityFeePerGas: u, nonce: l, to: d, value: f, stateOverride: p }) {
    var m;
    const h = n ? za(n) : void 0;
    let g = jp({
      from: h == null ? void 0 : h.address,
      to: d,
      value: typeof f < "u" && `${rx(f)} ${((m = o == null ? void 0 : o.nativeCurrency) == null ? void 0 : m.symbol) || "ETH"}`,
      data: i,
      gas: s,
      gasPrice: typeof a < "u" && `${fr(a)} gwei`,
      maxFeePerGas: typeof c < "u" && `${fr(c)} gwei`,
      maxPriorityFeePerGas: typeof u < "u" && `${fr(u)} gwei`,
      nonce: l
    });
    p && (g += `
${mx(p)}`), super(t.shortMessage, {
      cause: t,
      docsPath: r,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        "Raw Call Arguments:",
        g
      ].filter(Boolean),
      name: "CallExecutionError"
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.cause = t;
  }
}
class Iw extends ne {
  constructor(t, { abi: n, args: r, contractAddress: o, docsPath: i, functionName: s, sender: a }) {
    const c = Sd({ abi: n, args: r, name: s }), u = c ? lm({
      abiItem: c,
      args: r,
      includeFunctionName: !1,
      includeName: !1
    }) : void 0, l = c ? xo(c, { includeName: !0 }) : void 0, d = jp({
      address: o && ix(o),
      function: l,
      args: u && u !== "()" && `${[...Array((s == null ? void 0 : s.length) ?? 0).keys()].map(() => " ").join("")}${u}`,
      sender: a
    });
    super(t.shortMessage || `An unknown error occurred while executing the contract function "${s}".`, {
      cause: t,
      docsPath: i,
      metaMessages: [
        ...t.metaMessages ? [...t.metaMessages, " "] : [],
        d && "Contract Call:",
        d
      ].filter(Boolean),
      name: "ContractFunctionExecutionError"
    }), Object.defineProperty(this, "abi", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "args", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "cause", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "contractAddress", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "formattedArgs", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "functionName", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sender", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.abi = n, this.args = r, this.cause = t, this.contractAddress = o, this.functionName = s, this.sender = a;
  }
}
class ju extends ne {
  constructor({ abi: t, data: n, functionName: r, message: o }) {
    let i, s, a, c;
    if (n && n !== "0x")
      try {
        s = xw({ abi: t, data: n });
        const { abiItem: l, errorName: d, args: f } = s;
        if (d === "Error")
          c = f[0];
        else if (d === "Panic") {
          const [p] = f;
          c = um[p];
        } else {
          const p = l ? xo(l, { includeName: !0 }) : void 0, h = l && f ? lm({
            abiItem: l,
            args: f,
            includeFunctionName: !1,
            includeName: !1
          }) : void 0;
          a = [
            p ? `Error: ${p}` : "",
            h && h !== "()" ? `       ${[...Array((d == null ? void 0 : d.length) ?? 0).keys()].map(() => " ").join("")}${h}` : ""
          ];
        }
      } catch (l) {
        i = l;
      }
    else o && (c = o);
    let u;
    i instanceof Dp && (u = i.signature, a = [
      `Unable to decode signature "${u}" as it was not found on the provided ABI.`,
      "Make sure you are using the correct ABI and that the error exists on it.",
      `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${u}.`
    ]), super(c && c !== "execution reverted" || u ? [
      `The contract function "${r}" reverted with the following ${u ? "signature" : "reason"}:`,
      c || u
    ].join(`
`) : `The contract function "${r}" reverted.`, {
      cause: i,
      metaMessages: a,
      name: "ContractFunctionRevertedError"
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "reason", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "signature", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = s, this.reason = c, this.signature = u;
  }
}
class Ew extends ne {
  constructor({ functionName: t }) {
    super(`The contract function "${t}" returned no data ("0x").`, {
      metaMessages: [
        "This could be due to any of the following:",
        `  - The contract does not have the function "${t}",`,
        "  - The parameters passed to the contract function may be invalid, or",
        "  - The address is not a contract."
      ],
      name: "ContractFunctionZeroDataError"
    });
  }
}
class Sw extends ne {
  constructor({ factory: t }) {
    super(`Deployment for counterfactual contract call failed${t ? ` for factory "${t}".` : ""}`, {
      metaMessages: [
        "Please ensure:",
        "- The `factory` is a valid contract deployment factory (ie. Create2 Factory, ERC-4337 Factory, etc).",
        "- The `factoryData` is a valid encoded function call for contract deployment function on the factory."
      ],
      name: "CounterfactualDeploymentFailedError"
    });
  }
}
class dm extends ne {
  constructor({ data: t, message: n }) {
    super(n || "", { name: "RawContractError" }), Object.defineProperty(this, "code", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 3
    }), Object.defineProperty(this, "data", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.data = t;
  }
}
function Am(e, t) {
  var r, o, i, s, a, c;
  if (!(e instanceof ne))
    return !1;
  const n = e.walk((u) => u instanceof ju);
  return n instanceof ju ? !!(((r = n.data) == null ? void 0 : r.errorName) === "ResolverNotFound" || ((o = n.data) == null ? void 0 : o.errorName) === "ResolverWildcardNotSupported" || ((i = n.data) == null ? void 0 : i.errorName) === "ResolverNotContract" || ((s = n.data) == null ? void 0 : s.errorName) === "ResolverError" || ((a = n.data) == null ? void 0 : a.errorName) === "HttpError" || (c = n.reason) != null && c.includes("Wildcard on non-extended resolvers is not supported") || t === "reverse" && n.reason === um[50]) : !1;
}
function fm(e) {
  if (e.length !== 66 || e.indexOf("[") !== 0 || e.indexOf("]") !== 65)
    return null;
  const t = `0x${e.slice(1, 65)}`;
  return Fo(t) ? t : null;
}
function Tw(e) {
  let t = new Uint8Array(32).fill(0);
  if (!e)
    return Vt(t);
  const n = e.split(".");
  for (let r = n.length - 1; r >= 0; r -= 1) {
    const o = fm(n[r]), i = o ? ld(o) : wo(Ar(n[r]), "bytes");
    t = wo(Cr([t, i]), "bytes");
  }
  return Vt(t);
}
function Nw(e) {
  return `[${e.slice(2)}]`;
}
function Pw(e) {
  const t = new Uint8Array(32).fill(0);
  return e ? fm(e) || wo(Ar(e)) : Vt(t);
}
function hm(e) {
  const t = e.replace(/^\.|\.$/gm, "");
  if (t.length === 0)
    return new Uint8Array(1);
  const n = new Uint8Array(Ar(t).byteLength + 2);
  let r = 0;
  const o = t.split(".");
  for (let i = 0; i < o.length; i++) {
    let s = Ar(o[i]);
    s.byteLength > 255 && (s = Ar(Nw(Pw(o[i])))), n[r] = s.length, n.set(s, r + 1), r += s.length + 1;
  }
  return n.byteLength !== r + 1 ? n.slice(0, r + 1) : n;
}
const Rw = 3;
function Ow(e, { abi: t, address: n, args: r, docsPath: o, functionName: i, sender: s }) {
  const { code: a, data: c, message: u, shortMessage: l } = e instanceof dm ? e : e instanceof ne ? e.walk((f) => "data" in f) || e.walk() : {}, d = e instanceof pd ? new Ew({ functionName: i }) : [Rw, xr.code].includes(a) && (c || u || l) ? new ju({
    abi: t,
    data: typeof c == "object" ? c.data : c,
    functionName: i,
    message: l ?? u
  }) : e;
  return new Iw(d, {
    abi: t,
    args: r,
    contractAddress: n,
    docsPath: o,
    functionName: i,
    sender: s
  });
}
const Dw = "0x82ad56cb", Mw = "0x608060405234801561001057600080fd5b5060405161018e38038061018e83398101604081905261002f91610124565b6000808351602085016000f59050803b61004857600080fd5b6000808351602085016000855af16040513d6000823e81610067573d81fd5b3d81f35b634e487b7160e01b600052604160045260246000fd5b600082601f83011261009257600080fd5b81516001600160401b038111156100ab576100ab61006b565b604051601f8201601f19908116603f011681016001600160401b03811182821017156100d9576100d961006b565b6040528181528382016020018510156100f157600080fd5b60005b82811015610110576020818601810151838301820152016100f4565b506000918101602001919091529392505050565b6000806040838503121561013757600080fd5b82516001600160401b0381111561014d57600080fd5b61015985828601610081565b602085015190935090506001600160401b0381111561017757600080fd5b61018385828601610081565b915050925092905056fe", Fw = "0x608060405234801561001057600080fd5b506040516102c03803806102c083398101604081905261002f916101e6565b836001600160a01b03163b6000036100e457600080836001600160a01b03168360405161005c9190610270565b6000604051808303816000865af19150503d8060008114610099576040519150601f19603f3d011682016040523d82523d6000602084013e61009e565b606091505b50915091508115806100b857506001600160a01b0386163b155b156100e1578060405163101bb98d60e01b81526004016100d8919061028c565b60405180910390fd5b50505b6000808451602086016000885af16040513d6000823e81610103573d81fd5b3d81f35b80516001600160a01b038116811461011e57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561015457818101518382015260200161013c565b50506000910152565b600082601f83011261016e57600080fd5b81516001600160401b0381111561018757610187610123565b604051601f8201601f19908116603f011681016001600160401b03811182821017156101b5576101b5610123565b6040528181528382016020018510156101cd57600080fd5b6101de826020830160208701610139565b949350505050565b600080600080608085870312156101fc57600080fd5b61020585610107565b60208601519094506001600160401b0381111561022157600080fd5b61022d8782880161015d565b93505061023c60408601610107565b60608601519092506001600160401b0381111561025857600080fd5b6102648782880161015d565b91505092959194509250565b60008251610282818460208701610139565b9190910192915050565b60208152600082518060208401526102ab816040850160208701610139565b601f01601f1916919091016040019291505056fe";
function Vw(e, { docsPath: t, ...n }) {
  const r = (() => {
    const o = cx(e, n);
    return o instanceof Gp ? e : o;
  })();
  return new ww(r, {
    docsPath: t,
    ...n
  });
}
const Oc = /* @__PURE__ */ new Map();
function pm({ fn: e, id: t, shouldSplitBatch: n, wait: r = 0, sort: o }) {
  const i = async () => {
    const l = c();
    s();
    const d = l.map(({ args: f }) => f);
    d.length !== 0 && e(d).then((f) => {
      var p;
      o && Array.isArray(f) && f.sort(o);
      for (let h = 0; h < l.length; h++) {
        const { pendingPromise: g } = l[h];
        (p = g.resolve) == null || p.call(g, [f[h], f]);
      }
    }).catch((f) => {
      var p;
      for (let h = 0; h < l.length; h++) {
        const { pendingPromise: g } = l[h];
        (p = g.reject) == null || p.call(g, f);
      }
    });
  }, s = () => Oc.delete(t), a = () => c().map(({ args: l }) => l), c = () => Oc.get(t) || [], u = (l) => Oc.set(t, [...c(), l]);
  return {
    flush: s,
    async schedule(l) {
      const d = {}, f = new Promise((g, m) => {
        d.resolve = g, d.reject = m;
      });
      return (n == null ? void 0 : n([...a(), l])) && i(), c().length > 0 ? (u({ args: l, pendingPromise: d }), f) : (u({ args: l, pendingPromise: d }), setTimeout(i, r), f);
    }
  };
}
async function Bw(e, t) {
  var W, V, X, N;
  const { account: n = e.account, batch: r = !!((W = e.batch) != null && W.multicall), blockNumber: o, blockTag: i = "latest", accessList: s, blobs: a, code: c, data: u, factory: l, factoryData: d, gas: f, gasPrice: p, maxFeePerBlobGas: h, maxFeePerGas: g, maxPriorityFeePerGas: m, nonce: b, to: v, value: C, stateOverride: w, ...y } = t, I = n ? za(n) : void 0;
  if (c && (l || d))
    throw new ne("Cannot provide both `code` & `factory`/`factoryData` as parameters.");
  if (c && v)
    throw new ne("Cannot provide both `code` & `to` as parameters.");
  const x = c && u, E = l && d && v && u, P = x || E, L = x ? Hw({
    code: c,
    data: u
  }) : E ? Xw({
    data: u,
    factory: l,
    factoryData: d,
    to: v
  }) : u;
  try {
    fx(t);
    const F = (o ? ze(o) : void 0) || i, B = bx(w), Z = (N = (X = (V = e.chain) == null ? void 0 : V.formatters) == null ? void 0 : X.transactionRequest) == null ? void 0 : N.format, K = (Z || dx)({
      // Pick out extra data that might exist on the chain's transaction request type.
      ...ux(y, { format: Z }),
      from: I == null ? void 0 : I.address,
      accessList: s,
      blobs: a,
      data: L,
      gas: f,
      gasPrice: p,
      maxFeePerBlobGas: h,
      maxFeePerGas: g,
      maxPriorityFeePerGas: m,
      nonce: b,
      to: P ? void 0 : v,
      value: C
    });
    if (r && kw({ request: K }) && !B)
      try {
        return await Lw(e, {
          ...K,
          blockNumber: o,
          blockTag: i
        });
      } catch (z) {
        if (!(z instanceof Zp) && !(z instanceof Ou))
          throw z;
      }
    const ee = await e.request({
      method: "eth_call",
      params: B ? [
        K,
        F,
        B
      ] : [K, F]
    });
    return ee === "0x" ? { data: void 0 } : { data: ee };
  } catch (M) {
    const F = Ww(M), { offchainLookup: B, offchainLookupSignature: Z } = await import("./ccip-ZwJOgmNt.js");
    if (e.ccipRead !== !1 && (F == null ? void 0 : F.slice(0, 10)) === Z && v)
      return { data: await B(e, { data: F, to: v }) };
    throw P && (F == null ? void 0 : F.slice(0, 10)) === "0x101bb98d" ? new Sw({ factory: l }) : Vw(M, {
      ...t,
      account: I,
      chain: e.chain
    });
  }
}
function kw({ request: e }) {
  const { data: t, to: n, ...r } = e;
  return !(!t || t.startsWith(Dw) || !n || Object.values(r).filter((o) => typeof o < "u").length > 0);
}
async function Lw(e, t) {
  var g;
  const { batchSize: n = 1024, wait: r = 0 } = typeof ((g = e.batch) == null ? void 0 : g.multicall) == "object" ? e.batch.multicall : {}, { blockNumber: o, blockTag: i = "latest", data: s, multicallAddress: a, to: c } = t;
  let u = a;
  if (!u) {
    if (!e.chain)
      throw new Zp();
    u = Pd({
      blockNumber: o,
      chain: e.chain,
      contract: "multicall3"
    });
  }
  const d = (o ? ze(o) : void 0) || i, { schedule: f } = pm({
    id: `${e.uid}.${d}`,
    wait: r,
    shouldSplitBatch(m) {
      return m.reduce((v, { data: C }) => v + (C.length - 2), 0) > n * 2;
    },
    fn: async (m) => {
      const b = m.map((w) => ({
        allowFailure: !0,
        callData: w.data,
        target: w.to
      })), v = Nd({
        abi: S1,
        args: [b],
        functionName: "aggregate3"
      }), C = await e.request({
        method: "eth_call",
        params: [
          {
            data: v,
            to: u
          },
          d
        ]
      });
      return Td({
        abi: S1,
        args: [b],
        functionName: "aggregate3",
        data: C || "0x"
      });
    }
  }), [{ returnData: p, success: h }] = await f({ data: s, to: c });
  if (!h)
    throw new dm({ data: p });
  return p === "0x" ? { data: void 0 } : { data: p };
}
function Hw(e) {
  const { code: t, data: n } = e;
  return Wp({
    abi: sm(["constructor(bytes, bytes)"]),
    bytecode: Mw,
    args: [t, n]
  });
}
function Xw(e) {
  const { data: t, factory: n, factoryData: r, to: o } = e;
  return Wp({
    abi: sm(["constructor(address, bytes, address, bytes)"]),
    bytecode: Fw,
    args: [o, t, n, r]
  });
}
function Ww(e) {
  var n;
  if (!(e instanceof ne))
    return;
  const t = e.walk();
  return typeof (t == null ? void 0 : t.data) == "object" ? (n = t.data) == null ? void 0 : n.data : t.data;
}
async function Aa(e, t) {
  const { abi: n, address: r, args: o, functionName: i, ...s } = t, a = Nd({
    abi: n,
    args: o,
    functionName: i
  });
  try {
    const { data: c } = await Ga(e, Bw, "call")({
      ...s,
      data: a,
      to: r
    });
    return Td({
      abi: n,
      args: o,
      functionName: i,
      data: c || "0x"
    });
  } catch (c) {
    throw Ow(c, {
      abi: n,
      address: r,
      args: o,
      docsPath: "/docs/contract/readContract",
      functionName: i
    });
  }
}
class Zw extends ne {
  constructor({ data: t }) {
    super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
      metaMessages: [
        "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
        "",
        `Provided data: ${JSON.stringify(t)}`
      ],
      name: "EnsAvatarInvalidMetadataError"
    });
  }
}
class Yo extends ne {
  constructor({ reason: t }) {
    super(`ENS NFT avatar URI is invalid. ${t}`, {
      name: "EnsAvatarInvalidNftUriError"
    });
  }
}
class Rd extends ne {
  constructor({ uri: t }) {
    super(`Unable to resolve ENS avatar URI "${t}". The URI may be malformed, invalid, or does not respond with a valid image.`, { name: "EnsAvatarUriResolutionError" });
  }
}
class zw extends ne {
  constructor({ namespace: t }) {
    super(`ENS NFT avatar namespace "${t}" is not supported. Must be "erc721" or "erc1155".`, { name: "EnsAvatarUnsupportedNamespaceError" });
  }
}
const Gw = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/, jw = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/, Uw = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/, Qw = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function qw(e) {
  try {
    const t = await fetch(e, { method: "HEAD" });
    if (t.status === 200) {
      const n = t.headers.get("content-type");
      return n == null ? void 0 : n.startsWith("image/");
    }
    return !1;
  } catch (t) {
    return typeof t == "object" && typeof t.response < "u" || !globalThis.hasOwnProperty("Image") ? !1 : new Promise((n) => {
      const r = new Image();
      r.onload = () => {
        n(!0);
      }, r.onerror = () => {
        n(!1);
      }, r.src = e;
    });
  }
}
function O1(e, t) {
  return e ? e.endsWith("/") ? e.slice(0, -1) : e : t;
}
function mm({ uri: e, gatewayUrls: t }) {
  const n = Uw.test(e);
  if (n)
    return { uri: e, isOnChain: !0, isEncoded: n };
  const r = O1(t == null ? void 0 : t.ipfs, "https://ipfs.io"), o = O1(t == null ? void 0 : t.arweave, "https://arweave.net"), i = e.match(Gw), { protocol: s, subpath: a, target: c, subtarget: u = "" } = (i == null ? void 0 : i.groups) || {}, l = s === "ipns:/" || a === "ipns/", d = s === "ipfs:/" || a === "ipfs/" || jw.test(e);
  if (e.startsWith("http") && !l && !d) {
    let p = e;
    return t != null && t.arweave && (p = e.replace(/https:\/\/arweave.net/g, t == null ? void 0 : t.arweave)), { uri: p, isOnChain: !1, isEncoded: !1 };
  }
  if ((l || d) && c)
    return {
      uri: `${r}/${l ? "ipns" : "ipfs"}/${c}${u}`,
      isOnChain: !1,
      isEncoded: !1
    };
  if (s === "ar:/" && c)
    return {
      uri: `${o}/${c}${u || ""}`,
      isOnChain: !1,
      isEncoded: !1
    };
  let f = e.replace(Qw, "");
  if (f.startsWith("<svg") && (f = `data:image/svg+xml;base64,${btoa(f)}`), f.startsWith("data:") || f.startsWith("{"))
    return {
      uri: f,
      isOnChain: !0,
      isEncoded: !1
    };
  throw new Rd({ uri: e });
}
function gm(e) {
  if (typeof e != "object" || !("image" in e) && !("image_url" in e) && !("image_data" in e))
    throw new Zw({ data: e });
  return e.image || e.image_url || e.image_data;
}
async function Yw({ gatewayUrls: e, uri: t }) {
  try {
    const n = await fetch(t).then((o) => o.json());
    return await Od({
      gatewayUrls: e,
      uri: gm(n)
    });
  } catch {
    throw new Rd({ uri: t });
  }
}
async function Od({ gatewayUrls: e, uri: t }) {
  const { uri: n, isOnChain: r } = mm({ uri: t, gatewayUrls: e });
  if (r || await qw(n))
    return n;
  throw new Rd({ uri: t });
}
function Jw(e) {
  let t = e;
  t.startsWith("did:nft:") && (t = t.replace("did:nft:", "").replace(/_/g, "/"));
  const [n, r, o] = t.split("/"), [i, s] = n.split(":"), [a, c] = r.split(":");
  if (!i || i.toLowerCase() !== "eip155")
    throw new Yo({ reason: "Only EIP-155 supported" });
  if (!s)
    throw new Yo({ reason: "Chain ID not found" });
  if (!c)
    throw new Yo({
      reason: "Contract address not found"
    });
  if (!o)
    throw new Yo({ reason: "Token ID not found" });
  if (!a)
    throw new Yo({ reason: "ERC namespace not found" });
  return {
    chainID: Number.parseInt(s),
    namespace: a.toLowerCase(),
    contractAddress: c,
    tokenID: o
  };
}
async function Kw(e, { nft: t }) {
  if (t.namespace === "erc721")
    return Aa(e, {
      address: t.contractAddress,
      abi: [
        {
          name: "tokenURI",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "tokenId", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "tokenURI",
      args: [BigInt(t.tokenID)]
    });
  if (t.namespace === "erc1155")
    return Aa(e, {
      address: t.contractAddress,
      abi: [
        {
          name: "uri",
          type: "function",
          stateMutability: "view",
          inputs: [{ name: "_id", type: "uint256" }],
          outputs: [{ name: "", type: "string" }]
        }
      ],
      functionName: "uri",
      args: [BigInt(t.tokenID)]
    });
  throw new zw({ namespace: t.namespace });
}
async function _w(e, { gatewayUrls: t, record: n }) {
  return /eip155:/i.test(n) ? $w(e, { gatewayUrls: t, record: n }) : Od({ uri: n, gatewayUrls: t });
}
async function $w(e, { gatewayUrls: t, record: n }) {
  const r = Jw(n), o = await Kw(e, { nft: r }), { uri: i, isOnChain: s, isEncoded: a } = mm({ uri: o, gatewayUrls: t });
  if (s && (i.includes("data:application/json;base64,") || i.startsWith("{"))) {
    const u = a ? (
      // if it is encoded, decode it
      atob(i.replace("data:application/json;base64,", ""))
    ) : (
      // if it isn't encoded assume it is a JSON string, but it could be anything (it will error if it is)
      i
    ), l = JSON.parse(u);
    return Od({ uri: gm(l), gatewayUrls: t });
  }
  let c = r.tokenID;
  return r.namespace === "erc1155" && (c = c.replace("0x", "").padStart(64, "0")), Yw({
    gatewayUrls: t,
    uri: i.replace(/(?:0x)?{id}/, c)
  });
}
async function eI(e, { blockNumber: t, blockTag: n, name: r, key: o, gatewayUrls: i, strict: s, universalResolverAddress: a }) {
  let c = a;
  if (!c) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    c = Pd({
      blockNumber: t,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  try {
    const u = {
      address: c,
      abi: vx,
      functionName: "resolve",
      args: [
        Ad(hm(r)),
        Nd({
          abi: T1,
          functionName: "text",
          args: [Tw(r), o]
        })
      ],
      blockNumber: t,
      blockTag: n
    }, l = Ga(e, Aa, "readContract"), d = i ? await l({
      ...u,
      args: [...u.args, i]
    }) : await l(u);
    if (d[0] === "0x")
      return null;
    const f = Td({
      abi: T1,
      functionName: "text",
      data: d[0]
    });
    return f === "" ? null : f;
  } catch (u) {
    if (s)
      throw u;
    if (Am(u, "resolve"))
      return null;
    throw u;
  }
}
async function tI(e, { blockNumber: t, blockTag: n, assetGatewayUrls: r, name: o, gatewayUrls: i, strict: s, universalResolverAddress: a }) {
  const c = await Ga(e, eI, "getEnsText")({
    blockNumber: t,
    blockTag: n,
    key: "avatar",
    name: o,
    universalResolverAddress: a,
    gatewayUrls: i,
    strict: s
  });
  if (!c)
    return null;
  try {
    return await _w(e, {
      record: c,
      gatewayUrls: r
    });
  } catch {
    return null;
  }
}
async function nI(e, { address: t, blockNumber: n, blockTag: r, gatewayUrls: o, strict: i, universalResolverAddress: s }) {
  let a = s;
  if (!a) {
    if (!e.chain)
      throw new Error("client chain not configured. universalResolverAddress is required.");
    a = Pd({
      blockNumber: n,
      chain: e.chain,
      contract: "ensUniversalResolver"
    });
  }
  const c = `${t.toLowerCase().substring(2)}.addr.reverse`;
  try {
    const u = {
      address: a,
      abi: yx,
      functionName: "reverse",
      args: [Ad(hm(c))],
      blockNumber: n,
      blockTag: r
    }, l = Ga(e, Aa, "readContract"), [d, f] = o ? await l({
      ...u,
      args: [...u.args, o]
    }) : await l(u);
    return t.toLowerCase() !== f.toLowerCase() ? null : d;
  } catch (u) {
    if (i)
      throw u;
    if (Am(u, "reverse"))
      return null;
    throw u;
  }
}
async function rI(e) {
  return new Promise((t) => setTimeout(t, e));
}
const Es = /* @__PURE__ */ new gd(8192);
function oI(e, { enabled: t = !0, id: n }) {
  if (!t || !n)
    return e();
  if (Es.get(n))
    return Es.get(n);
  const r = e().finally(() => Es.delete(n));
  return Es.set(n, r), r;
}
function bm(e, { delay: t = 100, retryCount: n = 2, shouldRetry: r = () => !0 } = {}) {
  return new Promise((o, i) => {
    const s = async ({ count: a = 0 } = {}) => {
      const c = async ({ error: u }) => {
        const l = typeof t == "function" ? t({ count: a, error: u }) : t;
        l && await rI(l), s({ count: a + 1 });
      };
      try {
        const u = await e();
        o(u);
      } catch (u) {
        if (a < n && await r({ count: a, error: u }))
          return c({ error: u });
        i(u);
      }
    };
    s();
  });
}
function iI(e, t = {}) {
  return async (n, r = {}) => {
    const { dedupe: o = !1, retryDelay: i = 150, retryCount: s = 3, uid: a } = {
      ...t,
      ...r
    }, c = o ? wo(fd(`${a}.${Zn(n)}`)) : void 0;
    return oI(() => bm(async () => {
      try {
        return await e(n);
      } catch (u) {
        const l = u;
        switch (l.code) {
          case vi.code:
            throw new vi(l);
          case yi.code:
            throw new yi(l);
          case Ci.code:
            throw new Ci(l, { method: n.method });
          case xi.code:
            throw new xi(l);
          case xr.code:
            throw new xr(l);
          case wi.code:
            throw new wi(l);
          case Ii.code:
            throw new Ii(l);
          case zn.code:
            throw new zn(l);
          case Ei.code:
            throw new Ei(l);
          case Si.code:
            throw new Si(l, {
              method: n.method
            });
          case Io.code:
            throw new Io(l);
          case Ti.code:
            throw new Ti(l);
          case At.code:
            throw new At(l);
          case Ni.code:
            throw new Ni(l);
          case Pi.code:
            throw new Pi(l);
          case Ri.code:
            throw new Ri(l);
          case Oi.code:
            throw new Oi(l);
          case wr.code:
            throw new wr(l);
          case 5e3:
            throw new At(l);
          default:
            throw u instanceof ne ? u : new ax(l);
        }
      }
    }, {
      delay: ({ count: u, error: l }) => {
        var d;
        if (l && l instanceof ai) {
          const f = (d = l == null ? void 0 : l.headers) == null ? void 0 : d.get("Retry-After");
          if (f != null && f.match(/\d/))
            return Number.parseInt(f) * 1e3;
        }
        return ~~(1 << u) * i;
      },
      retryCount: s,
      shouldRetry: ({ error: u }) => sI(u)
    }), { enabled: o, id: c });
  };
}
function sI(e) {
  return "code" in e && typeof e.code == "number" ? e.code === -1 || e.code === Io.code || e.code === xr.code : e instanceof ai && e.status ? e.status === 403 || e.status === 408 || e.status === 413 || e.status === 429 || e.status === 500 || e.status === 502 || e.status === 503 || e.status === 504 : !0;
}
function aI(e) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...e
  };
}
function vm(e, { errorInstance: t = new Error("timed out"), timeout: n, signal: r }) {
  return new Promise((o, i) => {
    (async () => {
      let s;
      try {
        const a = new AbortController();
        n > 0 && (s = setTimeout(() => {
          r ? a.abort() : i(t);
        }, n)), o(await e({ signal: (a == null ? void 0 : a.signal) || null }));
      } catch (a) {
        (a == null ? void 0 : a.name) === "AbortError" && i(t), i(a);
      } finally {
        clearTimeout(s);
      }
    })();
  });
}
function cI() {
  return {
    current: 0,
    take() {
      return this.current++;
    },
    reset() {
      this.current = 0;
    }
  };
}
const D1 = /* @__PURE__ */ cI();
function uI(e, t = {}) {
  return {
    async request(n) {
      var d;
      const { body: r, onRequest: o = t.onRequest, onResponse: i = t.onResponse, timeout: s = t.timeout ?? 1e4 } = n, a = {
        ...t.fetchOptions ?? {},
        ...n.fetchOptions ?? {}
      }, { headers: c, method: u, signal: l } = a;
      try {
        const f = await vm(async ({ signal: h }) => {
          const g = {
            ...a,
            body: Array.isArray(r) ? Zn(r.map((v) => ({
              jsonrpc: "2.0",
              id: v.id ?? D1.take(),
              ...v
            }))) : Zn({
              jsonrpc: "2.0",
              id: r.id ?? D1.take(),
              ...r
            }),
            headers: {
              "Content-Type": "application/json",
              ...c
            },
            method: u || "POST",
            signal: l || (s > 0 ? h : null)
          }, m = new Request(e, g);
          return o && await o(m), await fetch(e, g);
        }, {
          errorInstance: new w1({ body: r, url: e }),
          timeout: s,
          signal: !0
        });
        i && await i(f);
        let p;
        if ((d = f.headers.get("Content-Type")) != null && d.startsWith("application/json") ? p = await f.json() : (p = await f.text(), p = JSON.parse(p || "{}")), !f.ok)
          throw new ai({
            body: r,
            details: Zn(p.error) || f.statusText,
            headers: f.headers,
            status: f.status,
            url: e
          });
        return p;
      } catch (f) {
        throw f instanceof ai || f instanceof w1 ? f : new ai({
          body: r,
          cause: f,
          url: e
        });
      }
    }
  };
}
function ym(e, t, n) {
  const r = e[t.name];
  if (typeof r == "function")
    return r;
  const o = e[n];
  return typeof o == "function" ? o : (i) => t(e, i);
}
const zs = "2.13.3", lI = () => `@wagmi/core@${zs}`;
var Cm = function(e, t, n, r) {
  if (n === "a" && !r) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}, fa, xm;
let Dd = class Uu extends Error {
  get docsBaseUrl() {
    return "https://wagmi.sh/core";
  }
  get version() {
    return lI();
  }
  constructor(t, n = {}) {
    var i;
    super(), fa.add(this), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiCoreError"
    });
    const r = n.cause instanceof Uu ? n.cause.details : (i = n.cause) != null && i.message ? n.cause.message : n.details, o = n.cause instanceof Uu && n.cause.docsPath || n.docsPath;
    this.message = [
      t || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...o ? [
        `Docs: ${this.docsBaseUrl}${o}.html${n.docsSlug ? `#${n.docsSlug}` : ""}`
      ] : [],
      ...r ? [`Details: ${r}`] : [],
      `Version: ${this.version}`
    ].join(`
`), n.cause && (this.cause = n.cause), this.details = r, this.docsPath = o, this.metaMessages = n.metaMessages, this.shortMessage = t;
  }
  walk(t) {
    return Cm(this, fa, "m", xm).call(this, this, t);
  }
};
fa = /* @__PURE__ */ new WeakSet(), xm = function e(t, n) {
  return n != null && n(t) ? t : t.cause ? Cm(this, fa, "m", e).call(this, t.cause, n) : t;
};
class Qu extends Dd {
  constructor() {
    super("Chain not configured."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ChainNotConfiguredError"
    });
  }
}
const qu = 256;
let Ss = qu, Ts;
function wm(e = 11) {
  if (!Ts || Ss + e > qu * 2) {
    Ts = "", Ss = 0;
    for (let t = 0; t < qu; t++)
      Ts += (256 + Math.random() * 256 | 0).toString(16).substring(1);
  }
  return Ts.substring(Ss, Ss++ + e);
}
function dI(e) {
  const { batch: t, cacheTime: n = e.pollingInterval ?? 4e3, ccipRead: r, key: o = "base", name: i = "Base Client", pollingInterval: s = 4e3, type: a = "base" } = e, c = e.chain, u = e.account ? za(e.account) : void 0, { config: l, request: d, value: f } = e.transport({
    chain: c,
    pollingInterval: s
  }), p = { ...l, ...f }, h = {
    account: u,
    batch: t,
    cacheTime: n,
    ccipRead: r,
    chain: c,
    key: o,
    name: i,
    pollingInterval: s,
    request: d,
    transport: p,
    type: a,
    uid: wm()
  };
  function g(m) {
    return (b) => {
      const v = b(m);
      for (const w in h)
        delete v[w];
      const C = { ...m, ...v };
      return Object.assign(C, { extend: g(C) });
    };
  }
  return Object.assign(h, { extend: g(h) });
}
function AI({ key: e, name: t, request: n, retryCount: r = 3, retryDelay: o = 150, timeout: i, type: s }, a) {
  const c = wm();
  return {
    config: {
      key: e,
      name: t,
      request: n,
      retryCount: r,
      retryDelay: o,
      timeout: i,
      type: s
    },
    request: iI(n, { retryCount: r, retryDelay: o, uid: c }),
    value: a
  };
}
class fI extends ne {
  constructor() {
    super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
      docsPath: "/docs/clients/intro",
      name: "UrlRequiredError"
    });
  }
}
function hI(e, t = {}) {
  const { batch: n, fetchOptions: r, key: o = "http", name: i = "HTTP JSON-RPC", onFetchRequest: s, onFetchResponse: a, retryDelay: c } = t;
  return ({ chain: u, retryCount: l, timeout: d }) => {
    const { batchSize: f = 1e3, wait: p = 0 } = typeof n == "object" ? n : {}, h = t.retryCount ?? l, g = d ?? t.timeout ?? 1e4, m = u == null ? void 0 : u.rpcUrls.default.http[0];
    if (!m)
      throw new fI();
    const b = uI(m, {
      fetchOptions: r,
      onRequest: s,
      onResponse: a,
      timeout: g
    });
    return AI({
      key: o,
      name: i,
      async request({ method: v, params: C }) {
        const w = { method: v, params: C }, { schedule: y } = pm({
          id: m,
          wait: p,
          shouldSplitBatch(P) {
            return P.length > f;
          },
          fn: (P) => b.request({
            body: P
          }),
          sort: (P, L) => P.id - L.id
        }), I = async (P) => n ? y(P) : [
          await b.request({
            body: P
          })
        ], [{ error: x, result: E }] = await I(w);
        if (x)
          throw new Up({
            body: w,
            error: x,
            url: m
          });
        return E;
      },
      retryCount: h,
      retryDelay: c,
      timeout: g,
      type: "http"
    }, {
      fetchOptions: r,
      url: m
    });
  };
}
function M1(e) {
  return e.state.chainId;
}
function pI(e, t) {
  const { chainId: n, ...r } = t, o = e.getClient({ chainId: n });
  return ym(o, tI, "getEnsAvatar")(r);
}
function mI(e, t) {
  const { chainId: n, ...r } = t, o = e.getClient({ chainId: n });
  return ym(o, nI, "getEnsName")(r);
}
let Dc = !1;
async function gI(e, t = {}) {
  var u, l;
  if (Dc)
    return [];
  Dc = !0, e.setState((d) => ({
    ...d,
    status: d.current ? "reconnecting" : "connecting"
  }));
  const n = [];
  if ((u = t.connectors) != null && u.length)
    for (const d of t.connectors) {
      let f;
      typeof d == "function" ? f = e._internal.connectors.setup(d) : f = d, n.push(f);
    }
  else
    n.push(...e.connectors);
  let r;
  try {
    r = await ((l = e.storage) == null ? void 0 : l.getItem("recentConnectorId"));
  } catch {
  }
  const o = {};
  for (const [, d] of e.state.connections)
    o[d.connector.id] = 1;
  r && (o[r] = 0);
  const i = Object.keys(o).length > 0 ? (
    // .toSorted()
    [...n].sort((d, f) => (o[d.id] ?? 10) - (o[f.id] ?? 10))
  ) : n;
  let s = !1;
  const a = [], c = [];
  for (const d of i) {
    const f = await d.getProvider().catch(() => {
    });
    if (!f || c.some((g) => g === f) || !await d.isAuthorized())
      continue;
    const h = await d.connect({ isReconnecting: !0 }).catch(() => null);
    h && (d.emitter.off("connect", e._internal.events.connect), d.emitter.on("change", e._internal.events.change), d.emitter.on("disconnect", e._internal.events.disconnect), e.setState((g) => {
      const m = new Map(s ? g.connections : /* @__PURE__ */ new Map()).set(d.uid, { accounts: h.accounts, chainId: h.chainId, connector: d });
      return {
        ...g,
        current: s ? g.current : d.uid,
        connections: m
      };
    }), a.push({
      accounts: h.accounts,
      chainId: h.chainId,
      connector: d
    }), c.push(f), s = !0);
  }
  return (e.state.status === "reconnecting" || e.state.status === "connecting") && (s ? e.setState((d) => ({ ...d, status: "connected" })) : e.setState((d) => ({
    ...d,
    connections: /* @__PURE__ */ new Map(),
    current: null,
    status: "disconnected"
  }))), Dc = !1, a;
}
class Wr extends Dd {
  constructor() {
    super("Provider not found."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ProviderNotFoundError"
    });
  }
}
function bI(e, t) {
  const { onChange: n } = t;
  return e.subscribe((r) => r.chainId, n);
}
const vI = /(rabby|trustwallet)/, yI = {
  coinbaseWallet: {
    id: "coinbaseWallet",
    name: "Coinbase Wallet",
    provider(e) {
      return e != null && e.coinbaseWalletExtension ? e.coinbaseWalletExtension : Gs(e, "isCoinbaseWallet");
    }
  },
  metaMask: {
    id: "metaMask",
    name: "MetaMask",
    provider(e) {
      return Gs(e, (t) => {
        if (!t.isMetaMask || t.isBraveWallet && !t._events && !t._state)
          return !1;
        const n = [
          "isApexWallet",
          "isAvalanche",
          "isBitKeep",
          "isBlockWallet",
          "isKuCoinWallet",
          "isMathWallet",
          "isOkxWallet",
          "isOKExWallet",
          "isOneInchIOSWallet",
          "isOneInchAndroidWallet",
          "isOpera",
          "isPortal",
          "isRabby",
          "isTokenPocket",
          "isTokenary",
          "isZerion"
        ];
        for (const r of n)
          if (t[r])
            return !1;
        return !0;
      });
    }
  },
  phantom: {
    id: "phantom",
    name: "Phantom",
    provider(e) {
      var t, n;
      return (t = e == null ? void 0 : e.phantom) != null && t.ethereum ? (n = e.phantom) == null ? void 0 : n.ethereum : Gs(e, "isPhantom");
    }
  }
};
Md.type = "injected";
function Md(e = {}) {
  const { shimDisconnect: t = !0, unstable_shimAsyncInject: n } = e;
  function r() {
    const c = e.target;
    if (typeof c == "function") {
      const u = c();
      if (u)
        return u;
    }
    return typeof c == "object" ? c : typeof c == "string" ? {
      ...yI[c] ?? {
        id: c,
        name: `${c[0].toUpperCase()}${c.slice(1)}`,
        provider: `is${c[0].toUpperCase()}${c.slice(1)}`
      }
    } : {
      id: "injected",
      name: "Injected",
      provider(u) {
        return u == null ? void 0 : u.ethereum;
      }
    };
  }
  let o, i, s, a;
  return (c) => ({
    get icon() {
      return r().icon;
    },
    get id() {
      return r().id;
    },
    get name() {
      return r().name;
    },
    get supportsSimulation() {
      return vI.test(this.id.toLowerCase());
    },
    type: Md.type,
    async setup() {
      const u = await this.getProvider();
      u && e.target && (s || (s = this.onConnect.bind(this), u.on("connect", s)), o || (o = this.onAccountsChanged.bind(this), u.on("accountsChanged", o)));
    },
    async connect({ chainId: u, isReconnecting: l } = {}) {
      var p, h, g, m, b, v;
      const d = await this.getProvider();
      if (!d)
        throw new Wr();
      let f = [];
      if (l)
        f = await this.getAccounts().catch(() => []);
      else if (t)
        try {
          f = (m = (g = (h = (p = (await d.request({
            method: "wallet_requestPermissions",
            params: [{ eth_accounts: {} }]
          }))[0]) == null ? void 0 : p.caveats) == null ? void 0 : h[0]) == null ? void 0 : g.value) == null ? void 0 : m.map((w) => Is(w)), f.length > 0 && (f = await this.getAccounts());
        } catch (C) {
          const w = C;
          if (w.code === At.code)
            throw new At(w);
          if (w.code === zn.code)
            throw w;
        }
      try {
        !(f != null && f.length) && !l && (f = (await d.request({
          method: "eth_requestAccounts"
        })).map((y) => Is(y))), s && (d.removeListener("connect", s), s = void 0), o || (o = this.onAccountsChanged.bind(this), d.on("accountsChanged", o)), i || (i = this.onChainChanged.bind(this), d.on("chainChanged", i)), a || (a = this.onDisconnect.bind(this), d.on("disconnect", a));
        let C = await this.getChainId();
        if (u && C !== u) {
          const w = await this.switchChain({ chainId: u }).catch((y) => {
            if (y.code === At.code)
              throw y;
            return { id: C };
          });
          C = (w == null ? void 0 : w.id) ?? C;
        }
        return t && await ((b = c.storage) == null ? void 0 : b.removeItem(`${this.id}.disconnected`)), e.target || await ((v = c.storage) == null ? void 0 : v.setItem("injected.connected", !0)), { accounts: f, chainId: C };
      } catch (C) {
        const w = C;
        throw w.code === At.code ? new At(w) : w.code === zn.code ? new zn(w) : w;
      }
    },
    async disconnect() {
      var l, d;
      const u = await this.getProvider();
      if (!u)
        throw new Wr();
      i && (u.removeListener("chainChanged", i), i = void 0), a && (u.removeListener("disconnect", a), a = void 0), s || (s = this.onConnect.bind(this), u.on("connect", s));
      try {
        await vm(() => (
          // TODO: Remove explicit type for viem@3
          u.request({
            // `'wallet_revokePermissions'` added in `viem@2.10.3`
            method: "wallet_revokePermissions",
            params: [{ eth_accounts: {} }]
          })
        ), { timeout: 100 });
      } catch {
      }
      t && await ((l = c.storage) == null ? void 0 : l.setItem(`${this.id}.disconnected`, !0)), e.target || await ((d = c.storage) == null ? void 0 : d.removeItem("injected.connected"));
    },
    async getAccounts() {
      const u = await this.getProvider();
      if (!u)
        throw new Wr();
      return (await u.request({ method: "eth_accounts" })).map((d) => Is(d));
    },
    async getChainId() {
      const u = await this.getProvider();
      if (!u)
        throw new Wr();
      const l = await u.request({ method: "eth_chainId" });
      return Number(l);
    },
    async getProvider() {
      if (typeof window > "u")
        return;
      let u;
      const l = r();
      return typeof l.provider == "function" ? u = l.provider(window) : typeof l.provider == "string" ? u = Gs(window, l.provider) : u = l.provider, u && !u.removeListener && ("off" in u && typeof u.off == "function" ? u.removeListener = u.off : u.removeListener = () => {
      }), u;
    },
    async isAuthorized() {
      var u, l;
      try {
        if (t && // If shim exists in storage, connector is disconnected
        await ((u = c.storage) == null ? void 0 : u.getItem(`${this.id}.disconnected`)) || !e.target && !await ((l = c.storage) == null ? void 0 : l.getItem("injected.connected")))
          return !1;
        if (!await this.getProvider()) {
          if (n !== void 0 && n !== !1) {
            const h = async () => (typeof window < "u" && window.removeEventListener("ethereum#initialized", h), !!await this.getProvider()), g = typeof n == "number" ? n : 1e3;
            if (await Promise.race([
              ...typeof window < "u" ? [
                new Promise((b) => window.addEventListener("ethereum#initialized", () => b(h()), { once: !0 }))
              ] : [],
              new Promise((b) => setTimeout(() => b(h()), g))
            ]))
              return !0;
          }
          throw new Wr();
        }
        return !!(await bm(() => this.getAccounts())).length;
      } catch {
        return !1;
      }
    },
    async switchChain({ addEthereumChainParameter: u, chainId: l }) {
      var p, h, g, m;
      const d = await this.getProvider();
      if (!d)
        throw new Wr();
      const f = c.chains.find((b) => b.id === l);
      if (!f)
        throw new wr(new Qu());
      try {
        return await Promise.all([
          d.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: ze(l) }]
          }).then(async () => {
            await this.getChainId() === l && c.emitter.emit("change", { chainId: l });
          }),
          new Promise((b) => c.emitter.once("change", ({ chainId: v }) => {
            v === l && b();
          }))
        ]), f;
      } catch (b) {
        const v = b;
        if (v.code === 4902 || // Unwrapping for MetaMask Mobile
        // https://github.com/MetaMask/metamask-mobile/issues/2944#issuecomment-976988719
        ((h = (p = v == null ? void 0 : v.data) == null ? void 0 : p.originalError) == null ? void 0 : h.code) === 4902)
          try {
            const { default: C, ...w } = f.blockExplorers ?? {};
            let y;
            u != null && u.blockExplorerUrls ? y = u.blockExplorerUrls : C && (y = [
              C.url,
              ...Object.values(w).map((P) => P.url)
            ]);
            let I;
            (g = u == null ? void 0 : u.rpcUrls) != null && g.length ? I = u.rpcUrls : I = [((m = f.rpcUrls.default) == null ? void 0 : m.http[0]) ?? ""];
            const x = {
              blockExplorerUrls: y,
              chainId: ze(l),
              chainName: (u == null ? void 0 : u.chainName) ?? f.name,
              iconUrls: u == null ? void 0 : u.iconUrls,
              nativeCurrency: (u == null ? void 0 : u.nativeCurrency) ?? f.nativeCurrency,
              rpcUrls: I
            };
            if (await d.request({
              method: "wallet_addEthereumChain",
              params: [x]
            }), await this.getChainId() !== l)
              throw new At(new Error("User rejected switch after adding network."));
            return f;
          } catch (C) {
            throw new At(C);
          }
        throw v.code === At.code ? new At(v) : new wr(v);
      }
    },
    async onAccountsChanged(u) {
      var l;
      if (u.length === 0)
        this.onDisconnect();
      else if (c.emitter.listenerCount("connect")) {
        const d = (await this.getChainId()).toString();
        this.onConnect({ chainId: d }), t && await ((l = c.storage) == null ? void 0 : l.removeItem(`${this.id}.disconnected`));
      } else
        c.emitter.emit("change", {
          accounts: u.map((d) => Is(d))
        });
    },
    onChainChanged(u) {
      const l = Number(u);
      c.emitter.emit("change", { chainId: l });
    },
    async onConnect(u) {
      const l = await this.getAccounts();
      if (l.length === 0)
        return;
      const d = Number(u.chainId);
      c.emitter.emit("connect", { accounts: l, chainId: d });
      const f = await this.getProvider();
      f && (s && (f.removeListener("connect", s), s = void 0), o || (o = this.onAccountsChanged.bind(this), f.on("accountsChanged", o)), i || (i = this.onChainChanged.bind(this), f.on("chainChanged", i)), a || (a = this.onDisconnect.bind(this), f.on("disconnect", a)));
    },
    async onDisconnect(u) {
      const l = await this.getProvider();
      u && u.code === 1013 && l && (await this.getAccounts()).length || (c.emitter.emit("disconnect"), l && (i && (l.removeListener("chainChanged", i), i = void 0), a && (l.removeListener("disconnect", a), a = void 0), s || (s = this.onConnect.bind(this), l.on("connect", s))));
    }
  });
}
function Gs(e, t) {
  function n(o) {
    return typeof t == "function" ? t(o) : typeof t == "string" ? o[t] : !0;
  }
  const r = e.ethereum;
  if (r != null && r.providers)
    return r.providers.find((o) => n(o));
  if (r && n(r))
    return r;
}
function CI(e) {
  if (typeof window > "u")
    return;
  const t = (n) => e(n.detail);
  return window.addEventListener("eip6963:announceProvider", t), window.dispatchEvent(new CustomEvent("eip6963:requestProvider")), () => window.removeEventListener("eip6963:announceProvider", t);
}
function xI() {
  const e = /* @__PURE__ */ new Set();
  let t = [];
  const n = () => CI((o) => {
    t.some(({ info: i }) => i.uuid === o.info.uuid) || (t = [...t, o], e.forEach((i) => i(t, { added: [o] })));
  });
  let r = n();
  return {
    _listeners() {
      return e;
    },
    clear() {
      e.forEach((o) => o([], { removed: [...t] })), t = [];
    },
    destroy() {
      this.clear(), e.clear(), r == null || r();
    },
    findProvider({ rdns: o }) {
      return t.find((i) => i.info.rdns === o);
    },
    getProviders() {
      return t;
    },
    reset() {
      this.clear(), r == null || r(), r = n();
    },
    subscribe(o, { emitImmediately: i } = {}) {
      return e.add(o), i && o(t, { added: t }), () => e.delete(o);
    }
  };
}
const wI = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, II = (e) => (t, n, r) => {
  const o = r.subscribe;
  return r.subscribe = (s, a, c) => {
    let u = s;
    if (a) {
      const l = (c == null ? void 0 : c.equalityFn) || Object.is;
      let d = s(r.getState());
      u = (f) => {
        const p = s(f);
        if (!l(d, p)) {
          const h = d;
          a(d = p, h);
        }
      }, c != null && c.fireImmediately && a(d, d);
    }
    return o(u);
  }, e(t, n, r);
}, EI = II;
function SI(e, t) {
  let n;
  try {
    n = e();
  } catch {
    return;
  }
  return {
    getItem: (o) => {
      var i;
      const s = (c) => c === null ? null : JSON.parse(c, void 0), a = (i = n.getItem(o)) != null ? i : null;
      return a instanceof Promise ? a.then(s) : s(a);
    },
    setItem: (o, i) => n.setItem(
      o,
      JSON.stringify(i, void 0)
    ),
    removeItem: (o) => n.removeItem(o)
  };
}
const Mi = (e) => (t) => {
  try {
    const n = e(t);
    return n instanceof Promise ? n : {
      then(r) {
        return Mi(r)(n);
      },
      catch(r) {
        return this;
      }
    };
  } catch (n) {
    return {
      then(r) {
        return this;
      },
      catch(r) {
        return Mi(r)(n);
      }
    };
  }
}, TI = (e, t) => (n, r, o) => {
  let i = {
    getStorage: () => localStorage,
    serialize: JSON.stringify,
    deserialize: JSON.parse,
    partialize: (m) => m,
    version: 0,
    merge: (m, b) => ({
      ...b,
      ...m
    }),
    ...t
  }, s = !1;
  const a = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
  let u;
  try {
    u = i.getStorage();
  } catch {
  }
  if (!u)
    return e(
      (...m) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${i.name}', the given storage is currently unavailable.`
        ), n(...m);
      },
      r,
      o
    );
  const l = Mi(i.serialize), d = () => {
    const m = i.partialize({ ...r() });
    let b;
    const v = l({ state: m, version: i.version }).then(
      (C) => u.setItem(i.name, C)
    ).catch((C) => {
      b = C;
    });
    if (b)
      throw b;
    return v;
  }, f = o.setState;
  o.setState = (m, b) => {
    f(m, b), d();
  };
  const p = e(
    (...m) => {
      n(...m), d();
    },
    r,
    o
  );
  let h;
  const g = () => {
    var m;
    if (!u)
      return;
    s = !1, a.forEach((v) => v(r()));
    const b = ((m = i.onRehydrateStorage) == null ? void 0 : m.call(i, r())) || void 0;
    return Mi(u.getItem.bind(u))(i.name).then((v) => {
      if (v)
        return i.deserialize(v);
    }).then((v) => {
      if (v)
        if (typeof v.version == "number" && v.version !== i.version) {
          if (i.migrate)
            return i.migrate(
              v.state,
              v.version
            );
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return v.state;
    }).then((v) => {
      var C;
      return h = i.merge(
        v,
        (C = r()) != null ? C : p
      ), n(h, !0), d();
    }).then(() => {
      b == null || b(h, void 0), s = !0, c.forEach((v) => v(h));
    }).catch((v) => {
      b == null || b(void 0, v);
    });
  };
  return o.persist = {
    setOptions: (m) => {
      i = {
        ...i,
        ...m
      }, m.getStorage && (u = m.getStorage());
    },
    clearStorage: () => {
      u == null || u.removeItem(i.name);
    },
    getOptions: () => i,
    rehydrate: () => g(),
    hasHydrated: () => s,
    onHydrate: (m) => (a.add(m), () => {
      a.delete(m);
    }),
    onFinishHydration: (m) => (c.add(m), () => {
      c.delete(m);
    })
  }, g(), h || p;
}, NI = (e, t) => (n, r, o) => {
  let i = {
    storage: SI(() => localStorage),
    partialize: (g) => g,
    version: 0,
    merge: (g, m) => ({
      ...m,
      ...g
    }),
    ...t
  }, s = !1;
  const a = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
  let u = i.storage;
  if (!u)
    return e(
      (...g) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${i.name}', the given storage is currently unavailable.`
        ), n(...g);
      },
      r,
      o
    );
  const l = () => {
    const g = i.partialize({ ...r() });
    return u.setItem(i.name, {
      state: g,
      version: i.version
    });
  }, d = o.setState;
  o.setState = (g, m) => {
    d(g, m), l();
  };
  const f = e(
    (...g) => {
      n(...g), l();
    },
    r,
    o
  );
  let p;
  const h = () => {
    var g, m;
    if (!u)
      return;
    s = !1, a.forEach((v) => {
      var C;
      return v((C = r()) != null ? C : f);
    });
    const b = ((m = i.onRehydrateStorage) == null ? void 0 : m.call(i, (g = r()) != null ? g : f)) || void 0;
    return Mi(u.getItem.bind(u))(i.name).then((v) => {
      if (v)
        if (typeof v.version == "number" && v.version !== i.version) {
          if (i.migrate)
            return i.migrate(
              v.state,
              v.version
            );
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return v.state;
    }).then((v) => {
      var C;
      return p = i.merge(
        v,
        (C = r()) != null ? C : f
      ), n(p, !0), l();
    }).then(() => {
      b == null || b(p, void 0), p = r(), s = !0, c.forEach((v) => v(p));
    }).catch((v) => {
      b == null || b(void 0, v);
    });
  };
  return o.persist = {
    setOptions: (g) => {
      i = {
        ...i,
        ...g
      }, g.storage && (u = g.storage);
    },
    clearStorage: () => {
      u == null || u.removeItem(i.name);
    },
    getOptions: () => i,
    rehydrate: () => h(),
    hasHydrated: () => s,
    onHydrate: (g) => (a.add(g), () => {
      a.delete(g);
    }),
    onFinishHydration: (g) => (c.add(g), () => {
      c.delete(g);
    })
  }, i.skipHydration || h(), p || f;
}, PI = (e, t) => "getStorage" in t || "serialize" in t || "deserialize" in t ? ((wI ? "production" : void 0) !== "production" && console.warn(
  "[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead."
), TI(e, t)) : NI(e, t), RI = PI, OI = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, F1 = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (c, u) => {
    const l = typeof c == "function" ? c(t) : c;
    if (!Object.is(l, t)) {
      const d = t;
      t = u ?? typeof l != "object" ? l : Object.assign({}, t, l), n.forEach((f) => f(t, d));
    }
  }, o = () => t, a = { setState: r, getState: o, subscribe: (c) => (n.add(c), () => n.delete(c)), destroy: () => {
    (OI ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), n.clear();
  } };
  return t = e(r, o, a), a;
}, Mc = (e) => e ? F1(e) : F1;
var Im = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, n = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
  function o(c, u, l) {
    this.fn = c, this.context = u, this.once = l || !1;
  }
  function i(c, u, l, d, f) {
    if (typeof l != "function")
      throw new TypeError("The listener must be a function");
    var p = new o(l, d || c, f), h = n ? n + u : u;
    return c._events[h] ? c._events[h].fn ? c._events[h] = [c._events[h], p] : c._events[h].push(p) : (c._events[h] = p, c._eventsCount++), c;
  }
  function s(c, u) {
    --c._eventsCount === 0 ? c._events = new r() : delete c._events[u];
  }
  function a() {
    this._events = new r(), this._eventsCount = 0;
  }
  a.prototype.eventNames = function() {
    var u = [], l, d;
    if (this._eventsCount === 0) return u;
    for (d in l = this._events)
      t.call(l, d) && u.push(n ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? u.concat(Object.getOwnPropertySymbols(l)) : u;
  }, a.prototype.listeners = function(u) {
    var l = n ? n + u : u, d = this._events[l];
    if (!d) return [];
    if (d.fn) return [d.fn];
    for (var f = 0, p = d.length, h = new Array(p); f < p; f++)
      h[f] = d[f].fn;
    return h;
  }, a.prototype.listenerCount = function(u) {
    var l = n ? n + u : u, d = this._events[l];
    return d ? d.fn ? 1 : d.length : 0;
  }, a.prototype.emit = function(u, l, d, f, p, h) {
    var g = n ? n + u : u;
    if (!this._events[g]) return !1;
    var m = this._events[g], b = arguments.length, v, C;
    if (m.fn) {
      switch (m.once && this.removeListener(u, m.fn, void 0, !0), b) {
        case 1:
          return m.fn.call(m.context), !0;
        case 2:
          return m.fn.call(m.context, l), !0;
        case 3:
          return m.fn.call(m.context, l, d), !0;
        case 4:
          return m.fn.call(m.context, l, d, f), !0;
        case 5:
          return m.fn.call(m.context, l, d, f, p), !0;
        case 6:
          return m.fn.call(m.context, l, d, f, p, h), !0;
      }
      for (C = 1, v = new Array(b - 1); C < b; C++)
        v[C - 1] = arguments[C];
      m.fn.apply(m.context, v);
    } else {
      var w = m.length, y;
      for (C = 0; C < w; C++)
        switch (m[C].once && this.removeListener(u, m[C].fn, void 0, !0), b) {
          case 1:
            m[C].fn.call(m[C].context);
            break;
          case 2:
            m[C].fn.call(m[C].context, l);
            break;
          case 3:
            m[C].fn.call(m[C].context, l, d);
            break;
          case 4:
            m[C].fn.call(m[C].context, l, d, f);
            break;
          default:
            if (!v) for (y = 1, v = new Array(b - 1); y < b; y++)
              v[y - 1] = arguments[y];
            m[C].fn.apply(m[C].context, v);
        }
    }
    return !0;
  }, a.prototype.on = function(u, l, d) {
    return i(this, u, l, d, !1);
  }, a.prototype.once = function(u, l, d) {
    return i(this, u, l, d, !0);
  }, a.prototype.removeListener = function(u, l, d, f) {
    var p = n ? n + u : u;
    if (!this._events[p]) return this;
    if (!l)
      return s(this, p), this;
    var h = this._events[p];
    if (h.fn)
      h.fn === l && (!f || h.once) && (!d || h.context === d) && s(this, p);
    else {
      for (var g = 0, m = [], b = h.length; g < b; g++)
        (h[g].fn !== l || f && !h[g].once || d && h[g].context !== d) && m.push(h[g]);
      m.length ? this._events[p] = m.length === 1 ? m[0] : m : s(this, p);
    }
    return this;
  }, a.prototype.removeAllListeners = function(u) {
    var l;
    return u ? (l = n ? n + u : u, this._events[l] && s(this, l)) : (this._events = new r(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = n, a.EventEmitter = a, e.exports = a;
})(Im);
var DI = Im.exports;
const MI = /* @__PURE__ */ Do(DI);
class FI {
  constructor(t) {
    Object.defineProperty(this, "uid", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }), Object.defineProperty(this, "_emitter", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: new MI()
    });
  }
  on(t, n) {
    this._emitter.on(t, n);
  }
  once(t, n) {
    this._emitter.once(t, n);
  }
  off(t, n) {
    this._emitter.off(t, n);
  }
  emit(t, ...n) {
    const r = n[0];
    this._emitter.emit(t, { uid: this.uid, ...r });
  }
  listenerCount(t) {
    return this._emitter.listenerCount(t);
  }
}
function VI(e) {
  return new FI(e);
}
function BI(e, t) {
  return JSON.parse(e, (n, r) => {
    let o = r;
    return (o == null ? void 0 : o.__type) === "bigint" && (o = BigInt(o.value)), (o == null ? void 0 : o.__type) === "Map" && (o = new Map(o.value)), (t == null ? void 0 : t(n, o)) ?? o;
  });
}
function V1(e, t) {
  return e.slice(0, t).join(".") || ".";
}
function B1(e, t) {
  const { length: n } = e;
  for (let r = 0; r < n; ++r)
    if (e[r] === t)
      return r + 1;
  return 0;
}
function kI(e, t) {
  const n = typeof e == "function", r = typeof t == "function", o = [], i = [];
  return function(a, c) {
    if (typeof c == "object")
      if (o.length) {
        const u = B1(o, this);
        u === 0 ? o[o.length] = this : (o.splice(u), i.splice(u)), i[i.length] = a;
        const l = B1(o, c);
        if (l !== 0)
          return r ? t.call(this, a, c, V1(i, l)) : `[ref=${V1(i, l)}]`;
      } else
        o[0] = c, i[0] = a;
    return n ? e.call(this, a, c) : c;
  };
}
function LI(e, t, n, r) {
  return JSON.stringify(e, kI((o, i) => {
    let s = i;
    return typeof s == "bigint" && (s = { __type: "bigint", value: i.toString() }), s instanceof Map && (s = { __type: "Map", value: Array.from(i.entries()) }), (t == null ? void 0 : t(o, s)) ?? s;
  }, r), n ?? void 0);
}
function HI(e) {
  const { deserialize: t = BI, key: n = "wagmi", serialize: r = LI, storage: o = Em } = e;
  function i(s) {
    return s instanceof Promise ? s.then((a) => a).catch(() => null) : s;
  }
  return {
    ...o,
    key: n,
    async getItem(s, a) {
      const c = o.getItem(`${n}.${s}`), u = await i(c);
      return u ? t(u) ?? null : a ?? null;
    },
    async setItem(s, a) {
      const c = `${n}.${s}`;
      a === null ? await i(o.removeItem(c)) : await i(o.setItem(c, r(a)));
    },
    async removeItem(s) {
      await i(o.removeItem(`${n}.${s}`));
    }
  };
}
const Em = {
  getItem: () => null,
  setItem: () => {
  },
  removeItem: () => {
  }
}, Yu = 256;
let Ns = Yu, Ps;
function XI(e = 11) {
  if (!Ps || Ns + e > Yu * 2) {
    Ps = "", Ns = 0;
    for (let t = 0; t < Yu; t++)
      Ps += (256 + Math.random() * 256 | 0).toString(16).substring(1);
  }
  return Ps.substring(Ns, Ns++ + e);
}
function WI(e) {
  const { multiInjectedProviderDiscovery: t = !0, storage: n = HI({
    storage: typeof window < "u" && window.localStorage ? window.localStorage : Em
  }), syncConnectedChain: r = !0, ssr: o = !1, ...i } = e, s = typeof window < "u" && t ? xI() : void 0, a = Mc(() => i.chains), c = Mc(() => [
    ...i.connectors ?? [],
    ...o ? [] : (s == null ? void 0 : s.getProviders().map(l)) ?? []
  ].map(u));
  function u(y) {
    var E;
    const I = VI(XI()), x = {
      ...y({
        emitter: I,
        chains: a.getState(),
        storage: n,
        transports: i.transports
      }),
      emitter: I,
      uid: I.uid
    };
    return I.on("connect", C), (E = x.setup) == null || E.call(x), x;
  }
  function l(y) {
    const { info: I } = y, x = y.provider;
    return Md({ target: { ...I, id: I.rdns, provider: x } });
  }
  const d = /* @__PURE__ */ new Map();
  function f(y = {}) {
    const I = y.chainId ?? m.getState().chainId, x = a.getState().find((P) => P.id === I);
    if (y.chainId && !x)
      throw new Qu();
    {
      const P = d.get(m.getState().chainId);
      if (P && !x)
        return P;
      if (!x)
        throw new Qu();
    }
    {
      const P = d.get(I);
      if (P)
        return P;
    }
    let E;
    if (i.client)
      E = i.client({ chain: x });
    else {
      const P = x.id, L = a.getState().map((X) => X.id), W = {}, V = Object.entries(i);
      for (const [X, N] of V)
        if (!(X === "chains" || X === "client" || X === "connectors" || X === "transports"))
          if (typeof N == "object")
            if (P in N)
              W[X] = N[P];
            else {
              if (L.some((F) => F in N))
                continue;
              W[X] = N;
            }
          else
            W[X] = N;
      E = dI({
        ...W,
        chain: x,
        batch: W.batch ?? { multicall: !0 },
        transport: (X) => i.transports[P]({ ...X, connectors: c })
      });
    }
    return d.set(I, E), E;
  }
  function p() {
    return {
      chainId: a.getState()[0].id,
      connections: /* @__PURE__ */ new Map(),
      current: null,
      status: "disconnected"
    };
  }
  let h;
  const g = "0.0.0-canary-";
  zs.startsWith(g) ? h = Number.parseInt(zs.replace(g, "")) : h = Number.parseInt(zs.split(".")[0] ?? "0");
  const m = Mc(EI(
    // only use persist middleware if storage exists
    n ? RI(p, {
      migrate(y, I) {
        if (I === h)
          return y;
        const x = p(), E = b(y, x.chainId);
        return { ...x, chainId: E };
      },
      name: "store",
      partialize(y) {
        return {
          connections: {
            __type: "Map",
            value: Array.from(y.connections.entries()).map(([I, x]) => {
              const { id: E, name: P, type: L, uid: W } = x.connector;
              return [I, { ...x, connector: { id: E, name: P, type: L, uid: W } }];
            })
          },
          chainId: y.chainId,
          current: y.current
        };
      },
      merge(y, I) {
        typeof y == "object" && y && "status" in y && delete y.status;
        const x = b(y, I.chainId);
        return {
          ...I,
          ...y,
          chainId: x
        };
      },
      skipHydration: o,
      storage: n,
      version: h
    }) : p
  ));
  function b(y, I) {
    return y && typeof y == "object" && "chainId" in y && typeof y.chainId == "number" && a.getState().some((x) => x.id === y.chainId) ? y.chainId : I;
  }
  r && m.subscribe(({ connections: y, current: I }) => {
    var x;
    return I ? (x = y.get(I)) == null ? void 0 : x.chainId : void 0;
  }, (y) => {
    if (a.getState().some((x) => x.id === y))
      return m.setState((x) => ({
        ...x,
        chainId: y ?? x.chainId
      }));
  }), s == null || s.subscribe((y) => {
    const I = /* @__PURE__ */ new Map();
    for (const E of c.getState())
      I.set(E.id, !0);
    const x = [];
    for (const E of y) {
      const P = u(l(E));
      I.has(P.id) || x.push(P);
    }
    n && !m.persist.hasHydrated() || c.setState((E) => [...E, ...x], !0);
  });
  function v(y) {
    m.setState((I) => {
      const x = I.connections.get(y.uid);
      return x ? {
        ...I,
        connections: new Map(I.connections).set(y.uid, {
          accounts: y.accounts ?? x.accounts,
          chainId: y.chainId ?? x.chainId,
          connector: x.connector
        })
      } : I;
    });
  }
  function C(y) {
    m.getState().status === "connecting" || m.getState().status === "reconnecting" || m.setState((I) => {
      const x = c.getState().find((E) => E.uid === y.uid);
      return x ? (x.emitter.listenerCount("connect") && x.emitter.off("connect", v), x.emitter.listenerCount("change") || x.emitter.on("change", v), x.emitter.listenerCount("disconnect") || x.emitter.on("disconnect", w), {
        ...I,
        connections: new Map(I.connections).set(y.uid, {
          accounts: y.accounts,
          chainId: y.chainId,
          connector: x
        }),
        current: y.uid,
        status: "connected"
      }) : I;
    });
  }
  function w(y) {
    m.setState((I) => {
      const x = I.connections.get(y.uid);
      if (x) {
        const P = x.connector;
        P.emitter.listenerCount("change") && x.connector.emitter.off("change", v), P.emitter.listenerCount("disconnect") && x.connector.emitter.off("disconnect", w), P.emitter.listenerCount("connect") || x.connector.emitter.on("connect", C);
      }
      if (I.connections.delete(y.uid), I.connections.size === 0)
        return {
          ...I,
          connections: /* @__PURE__ */ new Map(),
          current: null,
          status: "disconnected"
        };
      const E = I.connections.values().next().value;
      return {
        ...I,
        connections: new Map(I.connections),
        current: E.connector.uid
      };
    });
  }
  return {
    get chains() {
      return a.getState();
    },
    get connectors() {
      return c.getState();
    },
    storage: n,
    getClient: f,
    get state() {
      return m.getState();
    },
    setState(y) {
      let I;
      typeof y == "function" ? I = y(m.getState()) : I = y;
      const x = p();
      typeof I != "object" && (I = x), Object.keys(x).some((P) => !(P in I)) && (I = x), m.setState(I, !0);
    },
    subscribe(y, I, x) {
      return m.subscribe(y, I, x ? {
        ...x,
        fireImmediately: x.emitImmediately
        // Workaround cast since Zustand does not support `'exactOptionalPropertyTypes'`
      } : void 0);
    },
    _internal: {
      mipd: s,
      store: m,
      ssr: !!o,
      syncConnectedChain: r,
      transports: i.transports,
      chains: {
        setState(y) {
          const I = typeof y == "function" ? y(a.getState()) : y;
          if (I.length !== 0)
            return a.setState(I, !0);
        },
        subscribe(y) {
          return a.subscribe(y);
        }
      },
      connectors: {
        providerDetailToConnector: l,
        setup: u,
        setState(y) {
          return c.setState(typeof y == "function" ? y(c.getState()) : y, !0);
        },
        subscribe(y) {
          return c.subscribe(y);
        }
      },
      events: { change: v, connect: C, disconnect: w }
    }
  };
}
function ZI(e, t) {
  const { initialState: n, reconnectOnMount: r } = t;
  return n && !e._internal.store.persist.hasHydrated() && e.setState({
    ...n,
    chainId: e.chains.some((o) => o.id === n.chainId) ? n.chainId : e.chains[0].id,
    connections: r ? n.connections : /* @__PURE__ */ new Map(),
    status: r ? "reconnecting" : "disconnected"
  }), {
    async onMount() {
      var o;
      if (e._internal.ssr) {
        await e._internal.store.persist.rehydrate();
        const i = (o = e._internal.mipd) == null ? void 0 : o.getProviders().map(e._internal.connectors.providerDetailToConnector).map(e._internal.connectors.setup);
        e._internal.connectors.setState((s) => [
          ...s,
          ...i ?? []
        ]);
      }
      r ? gI(e) : e.storage && e.setState((i) => ({
        ...i,
        connections: /* @__PURE__ */ new Map()
      }));
    }
  };
}
function zI(e) {
  const { children: t, config: n, initialState: r, reconnectOnMount: o = !0 } = e, { onMount: i } = ZI(n, {
    initialState: r,
    reconnectOnMount: o
  });
  n._internal.ssr || i();
  const s = Ce(!0);
  return Ie(() => {
    if (s.current && n._internal.ssr)
      return i(), () => {
        s.current = !1;
      };
  }, []), t;
}
const Sm = Tl(void 0);
function GI(e) {
  const { children: t, config: n } = e, r = { value: n };
  return go(zI, e, go(Sm.Provider, r, t));
}
const jI = "2.12.4", UI = () => `wagmi@${jI}`;
class QI extends Dd {
  constructor() {
    super(...arguments), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiError"
    });
  }
  get docsBaseUrl() {
    return "https://wagmi.sh/react";
  }
  get version() {
    return UI();
  }
}
class qI extends QI {
  constructor() {
    super("`useConfig` must be used within `WagmiProvider`.", {
      docsPath: "/api/WagmiProvider"
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiProviderNotFoundError"
    });
  }
}
function Fd(e = {}) {
  const t = e.config ?? Sa(Sm);
  if (!t)
    throw new qI();
  return t;
}
var ts = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, Eo = typeof window > "u" || "Deno" in globalThis;
function Dt() {
}
function YI(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ju(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function Tm(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function eo(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ht(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function k1(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: o,
    predicate: i,
    queryKey: s,
    stale: a
  } = e;
  if (s) {
    if (r) {
      if (t.queryHash !== Vd(s, t.options))
        return !1;
    } else if (!Vi(t.queryKey, s))
      return !1;
  }
  if (n !== "all") {
    const c = t.isActive();
    if (n === "active" && !c || n === "inactive" && c)
      return !1;
  }
  return !(typeof a == "boolean" && t.isStale() !== a || o && o !== t.state.fetchStatus || i && !i(t));
}
function L1(e, t) {
  const { exact: n, status: r, predicate: o, mutationKey: i } = e;
  if (i) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (Fi(t.options.mutationKey) !== Fi(i))
        return !1;
    } else if (!Vi(t.options.mutationKey, i))
      return !1;
  }
  return !(r && t.state.status !== r || o && !o(t));
}
function Vd(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Fi)(e);
}
function Fi(e) {
  return JSON.stringify(
    e,
    (t, n) => _u(n) ? Object.keys(n).sort().reduce((r, o) => (r[o] = n[o], r), {}) : n
  );
}
function Vi(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !Vi(e[n], t[n])) : !1;
}
function Nm(e, t) {
  if (e === t)
    return e;
  const n = H1(e) && H1(t);
  if (n || _u(e) && _u(t)) {
    const r = n ? e : Object.keys(e), o = r.length, i = n ? t : Object.keys(t), s = i.length, a = n ? [] : {};
    let c = 0;
    for (let u = 0; u < s; u++) {
      const l = n ? u : i[u];
      (!n && r.includes(l) || n) && e[l] === void 0 && t[l] === void 0 ? (a[l] = void 0, c++) : (a[l] = Nm(e[l], t[l]), a[l] === e[l] && e[l] !== void 0 && c++);
    }
    return o === s && c === o ? e : a;
  }
  return t;
}
function Ku(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function H1(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function _u(e) {
  if (!X1(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!X1(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function X1(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function JI(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function $u(e, t, n) {
  return typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing !== !1 ? Nm(e, t) : t;
}
function KI(e, t, n = 0) {
  const r = [...e, t];
  return n && r.length > n ? r.slice(1) : r;
}
function _I(e, t, n = 0) {
  const r = [t, ...e];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var el = Symbol();
function Pm(e, t) {
  return process.env.NODE_ENV !== "production" && e.queryFn === el && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
  ), !e.queryFn && (t != null && t.initialPromise) ? () => t.initialPromise : !e.queryFn || e.queryFn === el ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
var ir, Dn, ro, Df, $I = (Df = class extends ts {
  constructor() {
    super();
    ge(this, ir);
    ge(this, Dn);
    ge(this, ro);
    ae(this, ro, (t) => {
      if (!Eo && window.addEventListener) {
        const n = () => t();
        return window.addEventListener("visibilitychange", n, !1), () => {
          window.removeEventListener("visibilitychange", n);
        };
      }
    });
  }
  onSubscribe() {
    D(this, Dn) || this.setEventListener(D(this, ro));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = D(this, Dn)) == null || t.call(this), ae(this, Dn, void 0));
  }
  setEventListener(t) {
    var n;
    ae(this, ro, t), (n = D(this, Dn)) == null || n.call(this), ae(this, Dn, t((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    }));
  }
  setFocused(t) {
    D(this, ir) !== t && (ae(this, ir, t), this.onFocus());
  }
  onFocus() {
    const t = this.isFocused();
    this.listeners.forEach((n) => {
      n(t);
    });
  }
  isFocused() {
    var t;
    return typeof D(this, ir) == "boolean" ? D(this, ir) : ((t = globalThis.document) == null ? void 0 : t.visibilityState) !== "hidden";
  }
}, ir = new WeakMap(), Dn = new WeakMap(), ro = new WeakMap(), Df), Bd = new $I(), oo, Mn, io, Mf, eE = (Mf = class extends ts {
  constructor() {
    super();
    ge(this, oo, !0);
    ge(this, Mn);
    ge(this, io);
    ae(this, io, (t) => {
      if (!Eo && window.addEventListener) {
        const n = () => t(!0), r = () => t(!1);
        return window.addEventListener("online", n, !1), window.addEventListener("offline", r, !1), () => {
          window.removeEventListener("online", n), window.removeEventListener("offline", r);
        };
      }
    });
  }
  onSubscribe() {
    D(this, Mn) || this.setEventListener(D(this, io));
  }
  onUnsubscribe() {
    var t;
    this.hasListeners() || ((t = D(this, Mn)) == null || t.call(this), ae(this, Mn, void 0));
  }
  setEventListener(t) {
    var n;
    ae(this, io, t), (n = D(this, Mn)) == null || n.call(this), ae(this, Mn, t(this.setOnline.bind(this)));
  }
  setOnline(t) {
    D(this, oo) !== t && (ae(this, oo, t), this.listeners.forEach((r) => {
      r(t);
    }));
  }
  isOnline() {
    return D(this, oo);
  }
}, oo = new WeakMap(), Mn = new WeakMap(), io = new WeakMap(), Mf), ha = new eE();
function tE(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function Rm(e) {
  return (e ?? "online") === "online" ? ha.isOnline() : !0;
}
var Om = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function Fc(e) {
  return e instanceof Om;
}
function Dm(e) {
  let t = !1, n = 0, r = !1, o, i, s;
  const a = new Promise((b, v) => {
    i = b, s = v;
  }), c = (b) => {
    var v;
    r || (h(new Om(b)), (v = e.abort) == null || v.call(e));
  }, u = () => {
    t = !0;
  }, l = () => {
    t = !1;
  }, d = () => Bd.isFocused() && (e.networkMode === "always" || ha.isOnline()) && e.canRun(), f = () => Rm(e.networkMode) && e.canRun(), p = (b) => {
    var v;
    r || (r = !0, (v = e.onSuccess) == null || v.call(e, b), o == null || o(), i(b));
  }, h = (b) => {
    var v;
    r || (r = !0, (v = e.onError) == null || v.call(e, b), o == null || o(), s(b));
  }, g = () => new Promise((b) => {
    var v;
    o = (C) => {
      (r || d()) && b(C);
    }, (v = e.onPause) == null || v.call(e);
  }).then(() => {
    var b;
    o = void 0, r || (b = e.onContinue) == null || b.call(e);
  }), m = () => {
    if (r)
      return;
    let b;
    const v = n === 0 ? e.initialPromise : void 0;
    try {
      b = v ?? e.fn();
    } catch (C) {
      b = Promise.reject(C);
    }
    Promise.resolve(b).then(p).catch((C) => {
      var E;
      if (r)
        return;
      const w = e.retry ?? (Eo ? 0 : 3), y = e.retryDelay ?? tE, I = typeof y == "function" ? y(n, C) : y, x = w === !0 || typeof w == "number" && n < w || typeof w == "function" && w(n, C);
      if (t || !x) {
        h(C);
        return;
      }
      n++, (E = e.onFail) == null || E.call(e, n, C), JI(I).then(() => d() ? void 0 : g()).then(() => {
        t ? h(C) : m();
      });
    });
  };
  return {
    promise: a,
    cancel: c,
    continue: () => (o == null || o(), a),
    cancelRetry: u,
    continueRetry: l,
    canStart: f,
    start: () => (f() ? m() : g().then(m), a)
  };
}
function nE() {
  let e = [], t = 0, n = (f) => {
    f();
  }, r = (f) => {
    f();
  }, o = (f) => setTimeout(f, 0);
  const i = (f) => {
    o = f;
  }, s = (f) => {
    let p;
    t++;
    try {
      p = f();
    } finally {
      t--, t || u();
    }
    return p;
  }, a = (f) => {
    t ? e.push(f) : o(() => {
      n(f);
    });
  }, c = (f) => (...p) => {
    a(() => {
      f(...p);
    });
  }, u = () => {
    const f = e;
    e = [], f.length && o(() => {
      r(() => {
        f.forEach((p) => {
          n(p);
        });
      });
    });
  };
  return {
    batch: s,
    batchCalls: c,
    schedule: a,
    setNotifyFunction: (f) => {
      n = f;
    },
    setBatchNotifyFunction: (f) => {
      r = f;
    },
    setScheduler: i
  };
}
var ot = nE(), sr, Ff, Mm = (Ff = class {
  constructor() {
    ge(this, sr);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Ju(this.gcTime) && ae(this, sr, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (Eo ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    D(this, sr) && (clearTimeout(D(this, sr)), ae(this, sr, void 0));
  }
}, sr = new WeakMap(), Ff), so, ao, Ot, at, Ui, ar, Lt, mn, Vf, rE = (Vf = class extends Mm {
  constructor(t) {
    super();
    ge(this, Lt);
    ge(this, so);
    ge(this, ao);
    ge(this, Ot);
    ge(this, at);
    ge(this, Ui);
    ge(this, ar);
    ae(this, ar, !1), ae(this, Ui, t.defaultOptions), this.setOptions(t.options), this.observers = [], ae(this, Ot, t.cache), this.queryKey = t.queryKey, this.queryHash = t.queryHash, ae(this, so, oE(this.options)), this.state = t.state ?? D(this, so), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var t;
    return (t = D(this, at)) == null ? void 0 : t.promise;
  }
  setOptions(t) {
    this.options = { ...D(this, Ui), ...t }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && D(this, Ot).remove(this);
  }
  setData(t, n) {
    const r = $u(this.state.data, t, this.options);
    return Ne(this, Lt, mn).call(this, {
      data: r,
      type: "success",
      dataUpdatedAt: n == null ? void 0 : n.updatedAt,
      manual: n == null ? void 0 : n.manual
    }), r;
  }
  setState(t, n) {
    Ne(this, Lt, mn).call(this, { type: "setState", state: t, setStateOptions: n });
  }
  cancel(t) {
    var r, o;
    const n = (r = D(this, at)) == null ? void 0 : r.promise;
    return (o = D(this, at)) == null || o.cancel(t), n ? n.then(Dt).catch(Dt) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(D(this, so));
  }
  isActive() {
    return this.observers.some(
      (t) => Ht(t.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (t) => t.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !Tm(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = D(this, at)) == null || n.continue();
  }
  onOnline() {
    var n;
    const t = this.observers.find((r) => r.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (n = D(this, at)) == null || n.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), D(this, Ot).notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((n) => n !== t), this.observers.length || (D(this, at) && (D(this, ar) ? D(this, at).cancel({ revert: !0 }) : D(this, at).cancelRetry()), this.scheduleGc()), D(this, Ot).notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || Ne(this, Lt, mn).call(this, { type: "invalidate" });
  }
  fetch(t, n) {
    var c, u, l;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (n != null && n.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (D(this, at))
        return D(this, at).continueRetry(), D(this, at).promise;
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const d = this.observers.find((f) => f.options.queryFn);
      d && this.setOptions(d.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const r = new AbortController(), o = (d) => {
      Object.defineProperty(d, "signal", {
        enumerable: !0,
        get: () => (ae(this, ar, !0), r.signal)
      });
    }, i = () => {
      const d = Pm(this.options, n), f = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return o(f), ae(this, ar, !1), this.options.persister ? this.options.persister(
        d,
        f,
        this
      ) : d(f);
    }, s = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: i
    };
    o(s), (c = this.options.behavior) == null || c.onFetch(
      s,
      this
    ), ae(this, ao, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((u = s.fetchOptions) == null ? void 0 : u.meta)) && Ne(this, Lt, mn).call(this, { type: "fetch", meta: (l = s.fetchOptions) == null ? void 0 : l.meta });
    const a = (d) => {
      var f, p, h, g;
      Fc(d) && d.silent || Ne(this, Lt, mn).call(this, {
        type: "error",
        error: d
      }), Fc(d) || ((p = (f = D(this, Ot).config).onError) == null || p.call(
        f,
        d,
        this
      ), (g = (h = D(this, Ot).config).onSettled) == null || g.call(
        h,
        this.state.data,
        d,
        this
      )), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return ae(this, at, Dm({
      initialPromise: n == null ? void 0 : n.initialPromise,
      fn: s.fetchFn,
      abort: r.abort.bind(r),
      onSuccess: (d) => {
        var f, p, h, g;
        if (d === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), a(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        this.setData(d), (p = (f = D(this, Ot).config).onSuccess) == null || p.call(f, d, this), (g = (h = D(this, Ot).config).onSettled) == null || g.call(
          h,
          d,
          this.state.error,
          this
        ), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: a,
      onFail: (d, f) => {
        Ne(this, Lt, mn).call(this, { type: "failed", failureCount: d, error: f });
      },
      onPause: () => {
        Ne(this, Lt, mn).call(this, { type: "pause" });
      },
      onContinue: () => {
        Ne(this, Lt, mn).call(this, { type: "continue" });
      },
      retry: s.options.retry,
      retryDelay: s.options.retryDelay,
      networkMode: s.options.networkMode,
      canRun: () => !0
    })), D(this, at).start();
  }
}, so = new WeakMap(), ao = new WeakMap(), Ot = new WeakMap(), at = new WeakMap(), Ui = new WeakMap(), ar = new WeakMap(), Lt = new WeakSet(), mn = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          fetchFailureCount: t.failureCount,
          fetchFailureReason: t.error
        };
      case "pause":
        return {
          ...r,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...r,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...r,
          ...Fm(r.data, this.options),
          fetchMeta: t.meta ?? null
        };
      case "success":
        return {
          ...r,
          data: t.data,
          dataUpdateCount: r.dataUpdateCount + 1,
          dataUpdatedAt: t.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!t.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const o = t.error;
        return Fc(o) && o.revert && D(this, ao) ? { ...D(this, ao), fetchStatus: "idle" } : {
          ...r,
          error: o,
          errorUpdateCount: r.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: r.fetchFailureCount + 1,
          fetchFailureReason: o,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...r,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...r,
          ...t.state
        };
    }
  };
  this.state = n(this.state), ot.batch(() => {
    this.observers.forEach((r) => {
      r.onQueryUpdate();
    }), D(this, Ot).notify({ query: this, type: "updated", action: t });
  });
}, Vf);
function Fm(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: Rm(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function oE(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var $t, Bf, iE = (Bf = class extends ts {
  constructor(t = {}) {
    super();
    ge(this, $t);
    this.config = t, ae(this, $t, /* @__PURE__ */ new Map());
  }
  build(t, n, r) {
    const o = n.queryKey, i = n.queryHash ?? Vd(o, n);
    let s = this.get(i);
    return s || (s = new rE({
      cache: this,
      queryKey: o,
      queryHash: i,
      options: t.defaultQueryOptions(n),
      state: r,
      defaultOptions: t.getQueryDefaults(o)
    }), this.add(s)), s;
  }
  add(t) {
    D(this, $t).has(t.queryHash) || (D(this, $t).set(t.queryHash, t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const n = D(this, $t).get(t.queryHash);
    n && (t.destroy(), n === t && D(this, $t).delete(t.queryHash), this.notify({ type: "removed", query: t }));
  }
  clear() {
    ot.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return D(this, $t).get(t);
  }
  getAll() {
    return [...D(this, $t).values()];
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => k1(n, r)
    );
  }
  findAll(t = {}) {
    const n = this.getAll();
    return Object.keys(t).length > 0 ? n.filter((r) => k1(t, r)) : n;
  }
  notify(t) {
    ot.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  onFocus() {
    ot.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    ot.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
}, $t = new WeakMap(), Bf), en, ut, cr, tn, Rn, kf, sE = (kf = class extends Mm {
  constructor(t) {
    super();
    ge(this, tn);
    ge(this, en);
    ge(this, ut);
    ge(this, cr);
    this.mutationId = t.mutationId, ae(this, ut, t.mutationCache), ae(this, en, []), this.state = t.state || aE(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = t, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    D(this, en).includes(t) || (D(this, en).push(t), this.clearGcTimeout(), D(this, ut).notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    ae(this, en, D(this, en).filter((n) => n !== t)), this.scheduleGc(), D(this, ut).notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    D(this, en).length || (this.state.status === "pending" ? this.scheduleGc() : D(this, ut).remove(this));
  }
  continue() {
    var t;
    return ((t = D(this, cr)) == null ? void 0 : t.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(t) {
    var o, i, s, a, c, u, l, d, f, p, h, g, m, b, v, C, w, y, I, x;
    ae(this, cr, Dm({
      fn: () => this.options.mutationFn ? this.options.mutationFn(t) : Promise.reject(new Error("No mutationFn found")),
      onFail: (E, P) => {
        Ne(this, tn, Rn).call(this, { type: "failed", failureCount: E, error: P });
      },
      onPause: () => {
        Ne(this, tn, Rn).call(this, { type: "pause" });
      },
      onContinue: () => {
        Ne(this, tn, Rn).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => D(this, ut).canRun(this)
    }));
    const n = this.state.status === "pending", r = !D(this, cr).canStart();
    try {
      if (!n) {
        Ne(this, tn, Rn).call(this, { type: "pending", variables: t, isPaused: r }), await ((i = (o = D(this, ut).config).onMutate) == null ? void 0 : i.call(
          o,
          t,
          this
        ));
        const P = await ((a = (s = this.options).onMutate) == null ? void 0 : a.call(s, t));
        P !== this.state.context && Ne(this, tn, Rn).call(this, {
          type: "pending",
          context: P,
          variables: t,
          isPaused: r
        });
      }
      const E = await D(this, cr).start();
      return await ((u = (c = D(this, ut).config).onSuccess) == null ? void 0 : u.call(
        c,
        E,
        t,
        this.state.context,
        this
      )), await ((d = (l = this.options).onSuccess) == null ? void 0 : d.call(l, E, t, this.state.context)), await ((p = (f = D(this, ut).config).onSettled) == null ? void 0 : p.call(
        f,
        E,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((g = (h = this.options).onSettled) == null ? void 0 : g.call(h, E, null, t, this.state.context)), Ne(this, tn, Rn).call(this, { type: "success", data: E }), E;
    } catch (E) {
      try {
        throw await ((b = (m = D(this, ut).config).onError) == null ? void 0 : b.call(
          m,
          E,
          t,
          this.state.context,
          this
        )), await ((C = (v = this.options).onError) == null ? void 0 : C.call(
          v,
          E,
          t,
          this.state.context
        )), await ((y = (w = D(this, ut).config).onSettled) == null ? void 0 : y.call(
          w,
          void 0,
          E,
          this.state.variables,
          this.state.context,
          this
        )), await ((x = (I = this.options).onSettled) == null ? void 0 : x.call(
          I,
          void 0,
          E,
          t,
          this.state.context
        )), E;
      } finally {
        Ne(this, tn, Rn).call(this, { type: "error", error: E });
      }
    } finally {
      D(this, ut).runNext(this);
    }
  }
}, en = new WeakMap(), ut = new WeakMap(), cr = new WeakMap(), tn = new WeakSet(), Rn = function(t) {
  const n = (r) => {
    switch (t.type) {
      case "failed":
        return {
          ...r,
          failureCount: t.failureCount,
          failureReason: t.error
        };
      case "pause":
        return {
          ...r,
          isPaused: !0
        };
      case "continue":
        return {
          ...r,
          isPaused: !1
        };
      case "pending":
        return {
          ...r,
          context: t.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: t.isPaused,
          status: "pending",
          variables: t.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...r,
          data: t.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...r,
          data: void 0,
          error: t.error,
          failureCount: r.failureCount + 1,
          failureReason: t.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = n(this.state), ot.batch(() => {
    D(this, en).forEach((r) => {
      r.onMutationUpdate(t);
    }), D(this, ut).notify({
      mutation: this,
      type: "updated",
      action: t
    });
  });
}, kf);
function aE() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var wt, Qi, Lf, cE = (Lf = class extends ts {
  constructor(t = {}) {
    super();
    ge(this, wt);
    ge(this, Qi);
    this.config = t, ae(this, wt, /* @__PURE__ */ new Map()), ae(this, Qi, Date.now());
  }
  build(t, n, r) {
    const o = new sE({
      mutationCache: this,
      mutationId: ++ls(this, Qi)._,
      options: t.defaultMutationOptions(n),
      state: r
    });
    return this.add(o), o;
  }
  add(t) {
    const n = Rs(t), r = D(this, wt).get(n) ?? [];
    r.push(t), D(this, wt).set(n, r), this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    var r;
    const n = Rs(t);
    if (D(this, wt).has(n)) {
      const o = (r = D(this, wt).get(n)) == null ? void 0 : r.filter((i) => i !== t);
      o && (o.length === 0 ? D(this, wt).delete(n) : D(this, wt).set(n, o));
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    var r;
    const n = (r = D(this, wt).get(Rs(t))) == null ? void 0 : r.find((o) => o.state.status === "pending");
    return !n || n === t;
  }
  runNext(t) {
    var r;
    const n = (r = D(this, wt).get(Rs(t))) == null ? void 0 : r.find((o) => o !== t && o.state.isPaused);
    return (n == null ? void 0 : n.continue()) ?? Promise.resolve();
  }
  clear() {
    ot.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return [...D(this, wt).values()].flat();
  }
  find(t) {
    const n = { exact: !0, ...t };
    return this.getAll().find(
      (r) => L1(n, r)
    );
  }
  findAll(t = {}) {
    return this.getAll().filter((n) => L1(t, n));
  }
  notify(t) {
    ot.batch(() => {
      this.listeners.forEach((n) => {
        n(t);
      });
    });
  }
  resumePausedMutations() {
    const t = this.getAll().filter((n) => n.state.isPaused);
    return ot.batch(
      () => Promise.all(
        t.map((n) => n.continue().catch(Dt))
      )
    );
  }
}, wt = new WeakMap(), Qi = new WeakMap(), Lf);
function Rs(e) {
  var t;
  return ((t = e.options.scope) == null ? void 0 : t.id) ?? String(e.mutationId);
}
function uE(e) {
  return {
    onFetch: (t, n) => {
      const r = async () => {
        var h, g, m, b, v;
        const o = t.options, i = (m = (g = (h = t.fetchOptions) == null ? void 0 : h.meta) == null ? void 0 : g.fetchMore) == null ? void 0 : m.direction, s = ((b = t.state.data) == null ? void 0 : b.pages) || [], a = ((v = t.state.data) == null ? void 0 : v.pageParams) || [], c = { pages: [], pageParams: [] };
        let u = !1;
        const l = (C) => {
          Object.defineProperty(C, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? u = !0 : t.signal.addEventListener("abort", () => {
              u = !0;
            }), t.signal)
          });
        }, d = Pm(t.options, t.fetchOptions), f = async (C, w, y) => {
          if (u)
            return Promise.reject();
          if (w == null && C.pages.length)
            return Promise.resolve(C);
          const I = {
            queryKey: t.queryKey,
            pageParam: w,
            direction: y ? "backward" : "forward",
            meta: t.options.meta
          };
          l(I);
          const x = await d(
            I
          ), { maxPages: E } = t.options, P = y ? _I : KI;
          return {
            pages: P(C.pages, x, E),
            pageParams: P(C.pageParams, w, E)
          };
        };
        let p;
        if (i && s.length) {
          const C = i === "backward", w = C ? lE : W1, y = {
            pages: s,
            pageParams: a
          }, I = w(o, y);
          p = await f(y, I, C);
        } else {
          p = await f(
            c,
            a[0] ?? o.initialPageParam
          );
          const C = e ?? s.length;
          for (let w = 1; w < C; w++) {
            const y = W1(o, p);
            if (y == null)
              break;
            p = await f(p, y);
          }
        }
        return p;
      };
      t.options.persister ? t.fetchFn = () => {
        var o, i;
        return (i = (o = t.options).persister) == null ? void 0 : i.call(
          o,
          r,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = r;
    }
  };
}
function W1(e, { pages: t, pageParams: n }) {
  const r = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[r],
    t,
    n[r],
    n
  ) : void 0;
}
function lE(e, { pages: t, pageParams: n }) {
  var r;
  return t.length > 0 ? (r = e.getPreviousPageParam) == null ? void 0 : r.call(e, t[0], t, n[0], n) : void 0;
}
var je, Fn, Vn, co, uo, Bn, lo, Ao, Hf, dE = (Hf = class {
  constructor(e = {}) {
    ge(this, je);
    ge(this, Fn);
    ge(this, Vn);
    ge(this, co);
    ge(this, uo);
    ge(this, Bn);
    ge(this, lo);
    ge(this, Ao);
    ae(this, je, e.queryCache || new iE()), ae(this, Fn, e.mutationCache || new cE()), ae(this, Vn, e.defaultOptions || {}), ae(this, co, /* @__PURE__ */ new Map()), ae(this, uo, /* @__PURE__ */ new Map()), ae(this, Bn, 0);
  }
  mount() {
    ls(this, Bn)._++, D(this, Bn) === 1 && (ae(this, lo, Bd.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), D(this, je).onFocus());
    })), ae(this, Ao, ha.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), D(this, je).onOnline());
    })));
  }
  unmount() {
    var e, t;
    ls(this, Bn)._--, D(this, Bn) === 0 && ((e = D(this, lo)) == null || e.call(this), ae(this, lo, void 0), (t = D(this, Ao)) == null || t.call(this), ae(this, Ao, void 0));
  }
  isFetching(e) {
    return D(this, je).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return D(this, Fn).findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = D(this, je).get(t.queryHash)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(e) {
    const t = this.getQueryData(e.queryKey);
    if (t === void 0)
      return this.fetchQuery(e);
    {
      const n = this.defaultQueryOptions(e), r = D(this, je).build(this, n);
      return e.revalidateIfStale && r.isStaleByTime(eo(n.staleTime, r)) && this.prefetchQuery(n), Promise.resolve(t);
    }
  }
  getQueriesData(e) {
    return D(this, je).findAll(e).map(({ queryKey: t, state: n }) => {
      const r = n.data;
      return [t, r];
    });
  }
  setQueryData(e, t, n) {
    const r = this.defaultQueryOptions({ queryKey: e }), o = D(this, je).get(
      r.queryHash
    ), i = o == null ? void 0 : o.state.data, s = YI(t, i);
    if (s !== void 0)
      return D(this, je).build(this, r).setData(s, { ...n, manual: !0 });
  }
  setQueriesData(e, t, n) {
    return ot.batch(
      () => D(this, je).findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, n)
      ])
    );
  }
  getQueryState(e) {
    var n;
    const t = this.defaultQueryOptions({ queryKey: e });
    return (n = D(this, je).get(t.queryHash)) == null ? void 0 : n.state;
  }
  removeQueries(e) {
    const t = D(this, je);
    ot.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = D(this, je), r = {
      type: "active",
      ...e
    };
    return ot.batch(() => (n.findAll(e).forEach((o) => {
      o.reset();
    }), this.refetchQueries(r, t)));
  }
  cancelQueries(e = {}, t = {}) {
    const n = { revert: !0, ...t }, r = ot.batch(
      () => D(this, je).findAll(e).map((o) => o.cancel(n))
    );
    return Promise.all(r).then(Dt).catch(Dt);
  }
  invalidateQueries(e = {}, t = {}) {
    return ot.batch(() => {
      if (D(this, je).findAll(e).forEach((r) => {
        r.invalidate();
      }), e.refetchType === "none")
        return Promise.resolve();
      const n = {
        ...e,
        type: e.refetchType ?? e.type ?? "active"
      };
      return this.refetchQueries(n, t);
    });
  }
  refetchQueries(e = {}, t) {
    const n = {
      ...t,
      cancelRefetch: (t == null ? void 0 : t.cancelRefetch) ?? !0
    }, r = ot.batch(
      () => D(this, je).findAll(e).filter((o) => !o.isDisabled()).map((o) => {
        let i = o.fetch(void 0, n);
        return n.throwOnError || (i = i.catch(Dt)), o.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(r).then(Dt);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const n = D(this, je).build(this, t);
    return n.isStaleByTime(
      eo(t.staleTime, n)
    ) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(Dt).catch(Dt);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = uE(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(Dt).catch(Dt);
  }
  resumePausedMutations() {
    return ha.isOnline() ? D(this, Fn).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return D(this, je);
  }
  getMutationCache() {
    return D(this, Fn);
  }
  getDefaultOptions() {
    return D(this, Vn);
  }
  setDefaultOptions(e) {
    ae(this, Vn, e);
  }
  setQueryDefaults(e, t) {
    D(this, co).set(Fi(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...D(this, co).values()];
    let n = {};
    return t.forEach((r) => {
      Vi(e, r.queryKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  setMutationDefaults(e, t) {
    D(this, uo).set(Fi(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...D(this, uo).values()];
    let n = {};
    return t.forEach((r) => {
      Vi(e, r.mutationKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...D(this, Vn).queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = Vd(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.enabled !== !0 && t.queryFn === el && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...D(this, Vn).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    D(this, je).clear(), D(this, Fn).clear();
  }
}, je = new WeakMap(), Fn = new WeakMap(), Vn = new WeakMap(), co = new WeakMap(), uo = new WeakMap(), Bn = new WeakMap(), lo = new WeakMap(), Ao = new WeakMap(), Hf), mt, Pe, qi, lt, ur, fo, nn, Yi, ho, po, lr, dr, kn, mo, Fe, ii, tl, nl, rl, ol, il, sl, al, Vm, Xf, AE = (Xf = class extends ts {
  constructor(t, n) {
    super();
    ge(this, Fe);
    ge(this, mt);
    ge(this, Pe);
    ge(this, qi);
    ge(this, lt);
    ge(this, ur);
    ge(this, fo);
    ge(this, nn);
    ge(this, Yi);
    ge(this, ho);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    ge(this, po);
    ge(this, lr);
    ge(this, dr);
    ge(this, kn);
    ge(this, mo, /* @__PURE__ */ new Set());
    this.options = n, ae(this, mt, t), ae(this, nn, null), this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (D(this, Pe).addObserver(this), Z1(D(this, Pe), this.options) ? Ne(this, Fe, ii).call(this) : this.updateResult(), Ne(this, Fe, ol).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return cl(
      D(this, Pe),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return cl(
      D(this, Pe),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), Ne(this, Fe, il).call(this), Ne(this, Fe, sl).call(this), D(this, Pe).removeObserver(this);
  }
  setOptions(t, n) {
    const r = this.options, o = D(this, Pe);
    if (this.options = D(this, mt).defaultQueryOptions(t), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Ht(this.options.enabled, D(this, Pe)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    Ne(this, Fe, al).call(this), D(this, Pe).setOptions(this.options), r._defaulted && !Ku(this.options, r) && D(this, mt).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: D(this, Pe),
      observer: this
    });
    const i = this.hasListeners();
    i && z1(
      D(this, Pe),
      o,
      this.options,
      r
    ) && Ne(this, Fe, ii).call(this), this.updateResult(n), i && (D(this, Pe) !== o || Ht(this.options.enabled, D(this, Pe)) !== Ht(r.enabled, D(this, Pe)) || eo(this.options.staleTime, D(this, Pe)) !== eo(r.staleTime, D(this, Pe))) && Ne(this, Fe, tl).call(this);
    const s = Ne(this, Fe, nl).call(this);
    i && (D(this, Pe) !== o || Ht(this.options.enabled, D(this, Pe)) !== Ht(r.enabled, D(this, Pe)) || s !== D(this, kn)) && Ne(this, Fe, rl).call(this, s);
  }
  getOptimisticResult(t) {
    const n = D(this, mt).getQueryCache().build(D(this, mt), t), r = this.createResult(n, t);
    return hE(this, r) && (ae(this, lt, r), ae(this, fo, this.options), ae(this, ur, D(this, Pe).state)), r;
  }
  getCurrentResult() {
    return D(this, lt);
  }
  trackResult(t, n) {
    const r = {};
    return Object.keys(t).forEach((o) => {
      Object.defineProperty(r, o, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(o), n == null || n(o), t[o])
      });
    }), r;
  }
  trackProp(t) {
    D(this, mo).add(t);
  }
  getCurrentQuery() {
    return D(this, Pe);
  }
  refetch({ ...t } = {}) {
    return this.fetch({
      ...t
    });
  }
  fetchOptimistic(t) {
    const n = D(this, mt).defaultQueryOptions(t), r = D(this, mt).getQueryCache().build(D(this, mt), n);
    return r.isFetchingOptimistic = !0, r.fetch().then(() => this.createResult(r, n));
  }
  fetch(t) {
    return Ne(this, Fe, ii).call(this, {
      ...t,
      cancelRefetch: t.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), D(this, lt)));
  }
  createResult(t, n) {
    var x;
    const r = D(this, Pe), o = this.options, i = D(this, lt), s = D(this, ur), a = D(this, fo), u = t !== r ? t.state : D(this, qi), { state: l } = t;
    let d = { ...l }, f = !1, p;
    if (n._optimisticResults) {
      const E = this.hasListeners(), P = !E && Z1(t, n), L = E && z1(t, r, n, o);
      (P || L) && (d = {
        ...d,
        ...Fm(l.data, t.options)
      }), n._optimisticResults === "isRestoring" && (d.fetchStatus = "idle");
    }
    let { error: h, errorUpdatedAt: g, status: m } = d;
    if (n.select && d.data !== void 0)
      if (i && d.data === (s == null ? void 0 : s.data) && n.select === D(this, Yi))
        p = D(this, ho);
      else
        try {
          ae(this, Yi, n.select), p = n.select(d.data), p = $u(i == null ? void 0 : i.data, p, n), ae(this, ho, p), ae(this, nn, null);
        } catch (E) {
          ae(this, nn, E);
        }
    else
      p = d.data;
    if (n.placeholderData !== void 0 && p === void 0 && m === "pending") {
      let E;
      if (i != null && i.isPlaceholderData && n.placeholderData === (a == null ? void 0 : a.placeholderData))
        E = i.data;
      else if (E = typeof n.placeholderData == "function" ? n.placeholderData(
        (x = D(this, po)) == null ? void 0 : x.state.data,
        D(this, po)
      ) : n.placeholderData, n.select && E !== void 0)
        try {
          E = n.select(E), ae(this, nn, null);
        } catch (P) {
          ae(this, nn, P);
        }
      E !== void 0 && (m = "success", p = $u(
        i == null ? void 0 : i.data,
        E,
        n
      ), f = !0);
    }
    D(this, nn) && (h = D(this, nn), p = D(this, ho), g = Date.now(), m = "error");
    const b = d.fetchStatus === "fetching", v = m === "pending", C = m === "error", w = v && b, y = p !== void 0;
    return {
      status: m,
      fetchStatus: d.fetchStatus,
      isPending: v,
      isSuccess: m === "success",
      isError: C,
      isInitialLoading: w,
      isLoading: w,
      data: p,
      dataUpdatedAt: d.dataUpdatedAt,
      error: h,
      errorUpdatedAt: g,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > u.dataUpdateCount || d.errorUpdateCount > u.errorUpdateCount,
      isFetching: b,
      isRefetching: b && !v,
      isLoadingError: C && !y,
      isPaused: d.fetchStatus === "paused",
      isPlaceholderData: f,
      isRefetchError: C && y,
      isStale: kd(t, n),
      refetch: this.refetch
    };
  }
  updateResult(t) {
    const n = D(this, lt), r = this.createResult(D(this, Pe), this.options);
    if (ae(this, ur, D(this, Pe).state), ae(this, fo, this.options), D(this, ur).data !== void 0 && ae(this, po, D(this, Pe)), Ku(r, n))
      return;
    ae(this, lt, r);
    const o = {}, i = () => {
      if (!n)
        return !0;
      const { notifyOnChangeProps: s } = this.options, a = typeof s == "function" ? s() : s;
      if (a === "all" || !a && !D(this, mo).size)
        return !0;
      const c = new Set(
        a ?? D(this, mo)
      );
      return this.options.throwOnError && c.add("error"), Object.keys(D(this, lt)).some((u) => {
        const l = u;
        return D(this, lt)[l] !== n[l] && c.has(l);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && i() && (o.listeners = !0), Ne(this, Fe, Vm).call(this, { ...o, ...t });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && Ne(this, Fe, ol).call(this);
  }
}, mt = new WeakMap(), Pe = new WeakMap(), qi = new WeakMap(), lt = new WeakMap(), ur = new WeakMap(), fo = new WeakMap(), nn = new WeakMap(), Yi = new WeakMap(), ho = new WeakMap(), po = new WeakMap(), lr = new WeakMap(), dr = new WeakMap(), kn = new WeakMap(), mo = new WeakMap(), Fe = new WeakSet(), ii = function(t) {
  Ne(this, Fe, al).call(this);
  let n = D(this, Pe).fetch(
    this.options,
    t
  );
  return t != null && t.throwOnError || (n = n.catch(Dt)), n;
}, tl = function() {
  Ne(this, Fe, il).call(this);
  const t = eo(
    this.options.staleTime,
    D(this, Pe)
  );
  if (Eo || D(this, lt).isStale || !Ju(t))
    return;
  const r = Tm(D(this, lt).dataUpdatedAt, t) + 1;
  ae(this, lr, setTimeout(() => {
    D(this, lt).isStale || this.updateResult();
  }, r));
}, nl = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(D(this, Pe)) : this.options.refetchInterval) ?? !1;
}, rl = function(t) {
  Ne(this, Fe, sl).call(this), ae(this, kn, t), !(Eo || Ht(this.options.enabled, D(this, Pe)) === !1 || !Ju(D(this, kn)) || D(this, kn) === 0) && ae(this, dr, setInterval(() => {
    (this.options.refetchIntervalInBackground || Bd.isFocused()) && Ne(this, Fe, ii).call(this);
  }, D(this, kn)));
}, ol = function() {
  Ne(this, Fe, tl).call(this), Ne(this, Fe, rl).call(this, Ne(this, Fe, nl).call(this));
}, il = function() {
  D(this, lr) && (clearTimeout(D(this, lr)), ae(this, lr, void 0));
}, sl = function() {
  D(this, dr) && (clearInterval(D(this, dr)), ae(this, dr, void 0));
}, al = function() {
  const t = D(this, mt).getQueryCache().build(D(this, mt), this.options);
  if (t === D(this, Pe))
    return;
  const n = D(this, Pe);
  ae(this, Pe, t), ae(this, qi, t.state), this.hasListeners() && (n == null || n.removeObserver(this), t.addObserver(this));
}, Vm = function(t) {
  ot.batch(() => {
    t.listeners && this.listeners.forEach((n) => {
      n(D(this, lt));
    }), D(this, mt).getQueryCache().notify({
      query: D(this, Pe),
      type: "observerResultsUpdated"
    });
  });
}, Xf);
function fE(e, t) {
  return Ht(t.enabled, e) !== !1 && e.state.data === void 0 && !(e.state.status === "error" && t.retryOnMount === !1);
}
function Z1(e, t) {
  return fE(e, t) || e.state.data !== void 0 && cl(e, t, t.refetchOnMount);
}
function cl(e, t, n) {
  if (Ht(t.enabled, e) !== !1) {
    const r = typeof n == "function" ? n(e) : n;
    return r === "always" || r !== !1 && kd(e, t);
  }
  return !1;
}
function z1(e, t, n, r) {
  return (e !== t || Ht(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && kd(e, n);
}
function kd(e, t) {
  return Ht(t.enabled, e) !== !1 && e.isStaleByTime(eo(t.staleTime, e));
}
function hE(e, t) {
  return !Ku(e.getCurrentResult(), t);
}
function pE(e) {
  return JSON.stringify(e, (t, n) => mE(n) ? Object.keys(n).sort().reduce((r, o) => (r[o] = n[o], r), {}) : typeof n == "bigint" ? n.toString() : n);
}
function mE(e) {
  if (!G1(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const n = t.prototype;
  return !(!G1(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function G1(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Bm(e) {
  const {
    // import('@tanstack/query-core').QueryOptions
    _defaulted: t,
    behavior: n,
    gcTime: r,
    initialData: o,
    initialDataUpdatedAt: i,
    maxPages: s,
    meta: a,
    networkMode: c,
    queryFn: u,
    queryHash: l,
    queryKey: d,
    queryKeyHashFn: f,
    retry: p,
    retryDelay: h,
    structuralSharing: g,
    // import('@tanstack/query-core').InfiniteQueryObserverOptions
    getPreviousPageParam: m,
    getNextPageParam: b,
    initialPageParam: v,
    // import('@tanstack/react-query').UseQueryOptions
    _optimisticResults: C,
    enabled: w,
    notifyOnChangeProps: y,
    placeholderData: I,
    refetchInterval: x,
    refetchIntervalInBackground: E,
    refetchOnMount: P,
    refetchOnReconnect: L,
    refetchOnWindowFocus: W,
    retryOnMount: V,
    select: X,
    staleTime: N,
    suspense: M,
    throwOnError: F,
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // wagmi
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    config: B,
    connector: Z,
    query: H,
    ...K
  } = e;
  return K;
}
function gE(e, t = {}) {
  return {
    async queryFn({ queryKey: n }) {
      const { name: r, scopeKey: o, ...i } = n[1];
      if (!r)
        throw new Error("name is required");
      return pI(e, { ...i, name: r });
    },
    queryKey: bE(t)
  };
}
function bE(e = {}) {
  return ["ensAvatar", Bm(e)];
}
function vE(e, t = {}) {
  return {
    async queryFn({ queryKey: n }) {
      const { address: r, scopeKey: o, ...i } = n[1];
      if (!r)
        throw new Error("address is required");
      return mI(e, { ...i, address: r });
    },
    queryKey: yE(t)
  };
}
function yE(e = {}) {
  return ["ensName", Bm(e)];
}
var km = S.createContext(
  void 0
), CE = (e) => {
  const t = S.useContext(km);
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, xE = ({
  client: e,
  children: t
}) => (S.useEffect(() => (e.mount(), () => {
  e.unmount();
}), [e]), /* @__PURE__ */ A(km.Provider, { value: e, children: t })), Lm = S.createContext(!1), wE = () => S.useContext(Lm);
Lm.Provider;
function IE() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
var EE = S.createContext(IE()), SE = () => S.useContext(EE);
function TE(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
var NE = (e, t) => {
  (e.suspense || e.throwOnError) && (t.isReset() || (e.retryOnMount = !1));
}, PE = (e) => {
  S.useEffect(() => {
    e.clearReset();
  }, [e]);
}, RE = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: n,
  query: r
}) => e.isError && !t.isReset() && !e.isFetching && r && TE(n, [e.error, r]), OE = (e) => {
  e.suspense && (typeof e.staleTime != "number" && (e.staleTime = 1e3), typeof e.gcTime == "number" && (e.gcTime = Math.max(e.gcTime, 1e3)));
}, DE = (e, t) => (e == null ? void 0 : e.suspense) && t.isPending, ME = (e, t, n) => t.fetchOptimistic(e).catch(() => {
  n.clearReset();
});
function FE(e, t, n) {
  var u, l, d, f;
  if (process.env.NODE_ENV !== "production" && (typeof e != "object" || Array.isArray(e)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const r = CE(), o = wE(), i = SE(), s = r.defaultQueryOptions(e);
  (l = (u = r.getDefaultOptions().queries) == null ? void 0 : u._experimental_beforeQuery) == null || l.call(
    u,
    s
  ), s._optimisticResults = o ? "isRestoring" : "optimistic", OE(s), NE(s, i), PE(i);
  const [a] = S.useState(
    () => new t(
      r,
      s
    )
  ), c = a.getOptimisticResult(s);
  if (S.useSyncExternalStore(
    S.useCallback(
      (p) => {
        const h = o ? () => {
        } : a.subscribe(ot.batchCalls(p));
        return a.updateResult(), h;
      },
      [a, o]
    ),
    () => a.getCurrentResult(),
    () => a.getCurrentResult()
  ), S.useEffect(() => {
    a.setOptions(s, { listeners: !1 });
  }, [s, a]), DE(s, c))
    throw ME(s, a, i);
  if (RE({
    result: c,
    errorResetBoundary: i,
    throwOnError: s.throwOnError,
    query: r.getQueryCache().get(s.queryHash)
  }))
    throw c.error;
  return (f = (d = r.getDefaultOptions().queries) == null ? void 0 : d._experimental_afterQuery) == null || f.call(
    d,
    s,
    c
  ), s.notifyOnChangeProps ? c : a.trackResult(c);
}
function VE(e, t) {
  return FE(e, AE);
}
function Hm(e) {
  const t = VE({
    ...e,
    queryKeyHashFn: pE
    // for bigint support
  });
  return t.queryKey = e.queryKey, t;
}
function Xm(e = {}) {
  const t = Fd(e);
  return Wf((n) => bI(t, { onChange: n }), () => M1(t), () => M1(t));
}
function BE(e = {}) {
  const { name: t, query: n = {} } = e, r = Fd(e), o = Xm({ config: r }), i = gE(r, {
    ...e,
    chainId: e.chainId ?? o
  }), s = !!(t && (n.enabled ?? !0));
  return Hm({ ...n, ...i, enabled: s });
}
function Wm(e = {}) {
  const { address: t, query: n = {} } = e, r = Fd(e), o = Xm({ config: r }), i = vE(r, {
    ...e,
    chainId: e.chainId ?? o
  }), s = !!(t && (n.enabled ?? !0));
  return Hm({ ...n, ...i, enabled: s });
}
function Zm(e) {
  const { address: t, chainId: n = 1, size: r = "14px" } = e, o = {
    width: r,
    height: r
  }, i = Wm({ address: t, chainId: n }), s = i.data ?? void 0, a = BE({ name: s }), c = a.data ?? q8;
  return i.isLoading || a.isLoading ? /* @__PURE__ */ A(
    "div",
    {
      style: o,
      className: "flex-none animate-pulse rounded-full bg-gray-400 fade-out"
    }
  ) : /* @__PURE__ */ A(
    "img",
    {
      src: c,
      style: o,
      className: "flex-none rounded-full object-contain",
      alt: "ENS Avatar"
    }
  );
}
const kE = {
  SYNCING: "Syncing",
  SUCCESS: "Synced",
  CONFLICT: "Error",
  MISSING: "Circle",
  ERROR: "Error"
};
function zm(e) {
  const {
    syncStatus: t,
    className: n,
    overrideSyncIcons: r = {},
    ...o
  } = e, i = { ...kE, ...r };
  return {
    [yl]: /* @__PURE__ */ A(
      J,
      {
        size: 16,
        ...o,
        className: $("text-blue-900", n),
        name: i[yl]
      }
    ),
    [Sr]: /* @__PURE__ */ A(
      J,
      {
        size: 16,
        ...o,
        className: $("text-green-900", n),
        name: i[Sr]
      }
    ),
    [Cl]: /* @__PURE__ */ A(
      J,
      {
        size: 16,
        ...o,
        className: $("text-orange-900", n),
        name: i[Cl]
      }
    ),
    [xl]: /* @__PURE__ */ A(
      J,
      {
        size: 16,
        ...o,
        className: $("text-red-900", n),
        name: i[xl]
      }
    ),
    [Ea]: /* @__PURE__ */ A(
      J,
      {
        size: 16,
        ...o,
        className: $("text-red-900", n),
        name: i[Ea]
      }
    )
  }[t];
}
function DM(e) {
  const {
    uiNode: t,
    selectedNodePath: n,
    nodeOptions: r,
    isAllowedToCreateDocuments: o,
    isRemoteDrive: i,
    customDocumentIconSrc: s,
    className: a,
    setSelectedNode: c,
    onRenameNode: u,
    onDuplicateNode: l,
    onDeleteNode: d,
    onAddTrigger: f,
    onRemoveTrigger: p,
    onAddInvalidTrigger: h
  } = e, [g, m] = Q(zt), [b, v] = Q(!1), { dragProps: C } = _d(e), w = g === zt, y = $(
    "group flex h-12 cursor-pointer select-none items-center rounded-lg bg-gray-200 px-2 text-gray-600 hover:text-gray-800",
    a
  ), I = {
    [Mr]: () => l(t),
    [_n]: () => m(qr),
    [Fr]: () => d(t),
    [cs]: () => f(t.driveId),
    [as]: () => p(t.driveId),
    [us]: () => h(t.driveId)
  }, x = r[t.sharingType][Je], E = Object.entries(Kd).map(([F, B]) => ({
    ...B,
    id: F
  })).filter((F) => x.includes(F.id));
  function P(F) {
    u(F, t), m(zt);
  }
  function L() {
    m(zt);
  }
  function W() {
    c(t);
  }
  function V(F) {
    const B = I[F];
    if (!B) {
      console.error(`No handler found for dropdown menu item: ${F}`);
      return;
    }
    B(t), v(!1);
  }
  const X = Jg(
    t.documentType,
    s
  ), N = /* @__PURE__ */ R("div", { className: "relative", children: [
    /* @__PURE__ */ A(
      "img",
      {
        src: X,
        alt: "file icon",
        className: "max-w-none",
        width: 32,
        height: 34
      }
    ),
    w && i && t.syncStatus && /* @__PURE__ */ A("div", { className: "absolute bottom-[-2px] right-0 size-3 rounded-full bg-white", children: /* @__PURE__ */ A("div", { className: "absolute left-[-2px] top-[-2px]", children: /* @__PURE__ */ A(
      zm,
      {
        syncStatus: t.syncStatus,
        overrideSyncIcons: { SUCCESS: "CheckCircleFill" }
      }
    ) }) })
  ] }), M = w ? /* @__PURE__ */ R("div", { className: "flex w-52 items-center justify-between", children: [
    /* @__PURE__ */ R("div", { className: "mr-2 truncate group-hover:mr-0", children: [
      /* @__PURE__ */ A("div", { className: "max-h-6 truncate text-sm font-medium group-hover:text-gray-800", children: t.name }),
      /* @__PURE__ */ A("div", { className: "max-h-6 truncate text-xs font-medium text-gray-600 group-hover:text-gray-800", children: n.map((F) => F.name).join(" / ") })
    ] }),
    o && /* @__PURE__ */ A(
      cd,
      {
        open: b,
        onOpenChange: v,
        onItemClick: V,
        items: E,
        children: /* @__PURE__ */ A(
          "button",
          {
            onClick: (F) => {
              F.stopPropagation(), v(!0);
            },
            className: $(
              "hidden group-hover:block",
              b && "block"
            ),
            children: /* @__PURE__ */ A(J, { name: "VerticalDots", className: "text-gray-600" })
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ A(
    ki,
    {
      className: "ml-3 flex-1 font-medium",
      defaultValue: t.name,
      onCancel: L,
      onSubmit: P
    }
  );
  return /* @__PURE__ */ A("div", { onClick: W, className: "relative w-64", children: /* @__PURE__ */ A("div", { ...C, className: y, children: /* @__PURE__ */ R("div", { className: "flex items-center", children: [
    /* @__PURE__ */ A("div", { className: "mr-1.5", children: N }),
    M
  ] }) }) });
}
function MM(e) {
  const {
    uiNode: t,
    isAllowedToCreateDocuments: n,
    nodeOptions: r,
    isRemoteDrive: o,
    className: i,
    setSelectedNode: s,
    onRenameNode: a,
    onDuplicateNode: c,
    onDeleteNode: u,
    onAddTrigger: l,
    onRemoveTrigger: d,
    onAddInvalidTrigger: f
  } = e, [p, h] = Q(zt), [g, m] = Q(!1), { dragProps: b } = _d(e), { isDropTarget: v, dropProps: C } = $d(e), w = p === zt;
  function y() {
    h(zt);
  }
  function I(N) {
    a(N, t);
  }
  function x() {
    s(t);
  }
  const E = {
    [Mr]: () => c(t),
    [_n]: () => h(qr),
    [Fr]: () => u(t),
    [cs]: () => l(t.driveId),
    [as]: () => d(t.driveId),
    [us]: () => f(t.driveId)
  }, P = r[t.sharingType][Xt], L = Object.entries(Kd).map(([N, M]) => ({
    ...M,
    id: N
  })).filter((N) => P.includes(N.id));
  function W(N) {
    const M = E[N];
    if (!M) {
      console.error(`No handler found for dropdown menu item: ${N}`);
      return;
    }
    M(), m(!1);
  }
  const V = w || !n ? /* @__PURE__ */ A("div", { className: "ml-3 max-h-6 truncate font-medium text-gray-600 group-hover:text-gray-800", children: t.name }) : /* @__PURE__ */ A(
    ki,
    {
      className: "ml-3 font-medium",
      defaultValue: t.name,
      onCancel: y,
      onSubmit: I
    }
  ), X = $(
    "group flex h-12 cursor-pointer select-none items-center rounded-lg bg-gray-200 px-2",
    i,
    v && "bg-blue-100"
  );
  return /* @__PURE__ */ A("div", { onClick: x, className: "relative w-64", children: /* @__PURE__ */ R("div", { ...b, ...C, className: X, children: [
    /* @__PURE__ */ R("div", { className: "flex items-center overflow-hidden", children: [
      /* @__PURE__ */ A("div", { className: "p-1", children: /* @__PURE__ */ R("div", { className: "relative", children: [
        /* @__PURE__ */ A(J, { name: "FolderClose", size: 24 }),
        w && o && t.syncStatus && /* @__PURE__ */ A("div", { className: "absolute bottom-[-3px] right-[-2px] size-3 rounded-full bg-white", children: /* @__PURE__ */ A("div", { className: "absolute left-[-2px] top-[-2px]", children: /* @__PURE__ */ A(
          zm,
          {
            syncStatus: t.syncStatus,
            overrideSyncIcons: {
              SUCCESS: "CheckCircleFill"
            }
          }
        ) }) })
      ] }) }),
      V
    ] }),
    w && n && /* @__PURE__ */ A(
      cd,
      {
        open: g,
        onOpenChange: m,
        onItemClick: W,
        items: L,
        children: /* @__PURE__ */ A(
          "button",
          {
            onClick: (N) => {
              N.stopPropagation(), m(!0);
            },
            className: $(
              "ml-auto hidden group-hover:block",
              g && "block"
            ),
            children: /* @__PURE__ */ A(
              J,
              {
                name: "VerticalDots",
                className: "text-gray-600"
              }
            )
          }
        )
      }
    )
  ] }) });
}
var ns = (e) => e.type === "checkbox", Ur = (e) => e instanceof Date, ft = (e) => e == null;
const Gm = (e) => typeof e == "object";
var $e = (e) => !ft(e) && !Array.isArray(e) && Gm(e) && !Ur(e), jm = (e) => $e(e) && e.target ? ns(e.target) ? e.target.checked : e.target.value : e, LE = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Um = (e, t) => e.has(LE(t)), HE = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return $e(t) && t.hasOwnProperty("isPrototypeOf");
}, Ld = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ke(e) {
  let t;
  const n = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(Ld && (e instanceof Blob || e instanceof FileList)) && (n || $e(e)))
    if (t = n ? [] : {}, !n && !HE(e))
      t = e;
    else
      for (const r in e)
        e.hasOwnProperty(r) && (t[r] = Ke(e[r]));
  else
    return e;
  return t;
}
var rs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], He = (e) => e === void 0, _ = (e, t, n) => {
  if (!t || !$e(e))
    return n;
  const r = rs(t.split(/[,[\].]+?/)).reduce((o, i) => ft(o) ? o : o[i], e);
  return He(r) || r === e ? He(e[t]) ? n : e[t] : r;
}, an = (e) => typeof e == "boolean", Hd = (e) => /^\w*$/.test(e), Qm = (e) => rs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), ke = (e, t, n) => {
  let r = -1;
  const o = Hd(t) ? [t] : Qm(t), i = o.length, s = i - 1;
  for (; ++r < i; ) {
    const a = o[r];
    let c = n;
    if (r !== s) {
      const u = e[a];
      c = $e(u) || Array.isArray(u) ? u : isNaN(+o[r + 1]) ? {} : [];
    }
    if (a === "__proto__")
      return;
    e[a] = c, e = e[a];
  }
  return e;
};
const pa = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Mt = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, pn = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, XE = Y.createContext(null), ja = () => Y.useContext(XE);
var qm = (e, t, n, r = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const i in e)
    Object.defineProperty(o, i, {
      get: () => {
        const s = i;
        return t._proxyFormState[s] !== Mt.all && (t._proxyFormState[s] = !r || Mt.all), n && (n[s] = !0), e[s];
      }
    });
  return o;
}, dt = (e) => $e(e) && !Object.keys(e).length, Ym = (e, t, n, r) => {
  n(e);
  const { name: o, ...i } = e;
  return dt(i) || Object.keys(i).length >= Object.keys(t).length || Object.keys(i).find((s) => t[s] === (!r || Mt.all));
}, vt = (e) => Array.isArray(e) ? e : [e], Jm = (e, t, n) => !e || !t || e === t || vt(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r)));
function Ua(e) {
  const t = Y.useRef(e);
  t.current = e, Y.useEffect(() => {
    const n = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [e.disabled]);
}
function WE(e) {
  const t = ja(), { control: n = t.control, disabled: r, name: o, exact: i } = e || {}, [s, a] = Y.useState(n._formState), c = Y.useRef(!0), u = Y.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), l = Y.useRef(o);
  return l.current = o, Ua({
    disabled: r,
    next: (d) => c.current && Jm(l.current, d.name, i) && Ym(d, u.current, n._updateFormState) && a({
      ...n._formState,
      ...d
    }),
    subject: n._subjects.state
  }), Y.useEffect(() => (c.current = !0, u.current.isValid && n._updateValid(!0), () => {
    c.current = !1;
  }), [n]), qm(s, n, u.current, !1);
}
var un = (e) => typeof e == "string", Km = (e, t, n, r, o) => un(e) ? (r && t.watch.add(e), _(n, e, o)) : Array.isArray(e) ? e.map((i) => (r && t.watch.add(i), _(n, i))) : (r && (t.watchAll = !0), n);
function Gn(e) {
  const t = ja(), { control: n = t.control, name: r, defaultValue: o, disabled: i, exact: s } = e || {}, a = Y.useRef(r);
  a.current = r, Ua({
    disabled: i,
    subject: n._subjects.values,
    next: (l) => {
      Jm(a.current, l.name, s) && u(Ke(Km(a.current, n._names, l.values || n._formValues, !1, o)));
    }
  });
  const [c, u] = Y.useState(n._getWatch(r, o));
  return Y.useEffect(() => n._removeUnmounted()), c;
}
function ZE(e) {
  const t = ja(), { name: n, disabled: r, control: o = t.control, shouldUnregister: i } = e, s = Um(o._names.array, n), a = Gn({
    control: o,
    name: n,
    defaultValue: _(o._formValues, n, _(o._defaultValues, n, e.defaultValue)),
    exact: !0
  }), c = WE({
    control: o,
    name: n,
    exact: !0
  }), u = Y.useRef(o.register(n, {
    ...e.rules,
    value: a,
    ...an(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return Y.useEffect(() => {
    const l = o._options.shouldUnregister || i, d = (f, p) => {
      const h = _(o._fields, f);
      h && h._f && (h._f.mount = p);
    };
    if (d(n, !0), l) {
      const f = Ke(_(o._options.defaultValues, n));
      ke(o._defaultValues, n, f), He(_(o._formValues, n)) && ke(o._formValues, n, f);
    }
    return () => {
      (s ? l && !o._state.action : l) ? o.unregister(n) : d(n, !1);
    };
  }, [n, o, s, i]), Y.useEffect(() => {
    _(o._fields, n) && o._updateDisabledField({
      disabled: r,
      fields: o._fields,
      name: n,
      value: _(o._fields, n)._f.value
    });
  }, [r, n, o]), {
    field: {
      name: n,
      value: a,
      ...an(r) || c.disabled ? { disabled: c.disabled || r } : {},
      onChange: Y.useCallback((l) => u.current.onChange({
        target: {
          value: jm(l),
          name: n
        },
        type: pa.CHANGE
      }), [n]),
      onBlur: Y.useCallback(() => u.current.onBlur({
        target: {
          value: _(o._formValues, n),
          name: n
        },
        type: pa.BLUR
      }), [n, o]),
      ref: Y.useCallback((l) => {
        const d = _(o._fields, n);
        d && l && (d._f.ref = {
          focus: () => l.focus(),
          select: () => l.select(),
          setCustomValidity: (f) => l.setCustomValidity(f),
          reportValidity: () => l.reportValidity()
        });
      }, [o._fields, n])
    },
    formState: c,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!_(c.errors, n)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!_(c.dirtyFields, n)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!_(c.touchedFields, n)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!_(c.validatingFields, n)
      },
      error: {
        enumerable: !0,
        get: () => _(c.errors, n)
      }
    })
  };
}
const Xd = (e) => e.render(ZE(e));
var zE = (e, t, n, r, o) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: o || !0
  }
} : {}, Tn = () => {
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
    const n = (Math.random() * 16 + e) % 16 | 0;
    return (t == "x" ? n : n & 3 | 8).toString(16);
  });
}, Vc = (e, t, n = {}) => n.shouldFocus || He(n.shouldFocus) ? n.focusName || `${e}.${He(n.focusIndex) ? t : n.focusIndex}.` : "", ci = (e) => ({
  isOnSubmit: !e || e === Mt.onSubmit,
  isOnBlur: e === Mt.onBlur,
  isOnChange: e === Mt.onChange,
  isOnAll: e === Mt.all,
  isOnTouch: e === Mt.onTouched
}), ul = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const to = (e, t, n, r) => {
  for (const o of n || Object.keys(e)) {
    const i = _(e, o);
    if (i) {
      const { _f: s, ...a } = i;
      if (s) {
        if (s.refs && s.refs[0] && t(s.refs[0], o) && !r)
          break;
        if (s.ref && t(s.ref, s.name) && !r)
          break;
        to(a, t);
      } else $e(a) && to(a, t);
    }
  }
};
var _m = (e, t, n) => {
  const r = vt(_(e, n));
  return ke(r, "root", t[n]), ke(e, n, r), e;
}, Wd = (e) => e.type === "file", Ln = (e) => typeof e == "function", ma = (e) => {
  if (!Ld)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, js = (e) => un(e), Zd = (e) => e.type === "radio", ga = (e) => e instanceof RegExp;
const j1 = {
  value: !1,
  isValid: !1
}, U1 = { value: !0, isValid: !0 };
var $m = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !He(e[0].attributes.value) ? He(e[0].value) || e[0].value === "" ? U1 : { value: e[0].value, isValid: !0 } : U1
    ) : j1;
  }
  return j1;
};
const Q1 = {
  isValid: !1,
  value: null
};
var eg = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, Q1) : Q1;
function q1(e, t, n = "validate") {
  if (js(e) || Array.isArray(e) && e.every(js) || an(e) && !e)
    return {
      type: n,
      message: js(e) ? e : "",
      ref: t
    };
}
var Zr = (e) => $e(e) && !ga(e) ? e : {
  value: e,
  message: ""
}, ll = async (e, t, n, r, o) => {
  const { ref: i, refs: s, required: a, maxLength: c, minLength: u, min: l, max: d, pattern: f, validate: p, name: h, valueAsNumber: g, mount: m, disabled: b } = e._f, v = _(t, h);
  if (!m || b)
    return {};
  const C = s ? s[0] : i, w = (V) => {
    r && C.reportValidity && (C.setCustomValidity(an(V) ? "" : V || ""), C.reportValidity());
  }, y = {}, I = Zd(i), x = ns(i), E = I || x, P = (g || Wd(i)) && He(i.value) && He(v) || ma(i) && i.value === "" || v === "" || Array.isArray(v) && !v.length, L = zE.bind(null, h, n, y), W = (V, X, N, M = pn.maxLength, F = pn.minLength) => {
    const B = V ? X : N;
    y[h] = {
      type: V ? M : F,
      message: B,
      ref: i,
      ...L(V ? M : F, B)
    };
  };
  if (o ? !Array.isArray(v) || !v.length : a && (!E && (P || ft(v)) || an(v) && !v || x && !$m(s).isValid || I && !eg(s).isValid)) {
    const { value: V, message: X } = js(a) ? { value: !!a, message: a } : Zr(a);
    if (V && (y[h] = {
      type: pn.required,
      message: X,
      ref: C,
      ...L(pn.required, X)
    }, !n))
      return w(X), y;
  }
  if (!P && (!ft(l) || !ft(d))) {
    let V, X;
    const N = Zr(d), M = Zr(l);
    if (!ft(v) && !isNaN(v)) {
      const F = i.valueAsNumber || v && +v;
      ft(N.value) || (V = F > N.value), ft(M.value) || (X = F < M.value);
    } else {
      const F = i.valueAsDate || new Date(v), B = (K) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + K), Z = i.type == "time", H = i.type == "week";
      un(N.value) && v && (V = Z ? B(v) > B(N.value) : H ? v > N.value : F > new Date(N.value)), un(M.value) && v && (X = Z ? B(v) < B(M.value) : H ? v < M.value : F < new Date(M.value));
    }
    if ((V || X) && (W(!!V, N.message, M.message, pn.max, pn.min), !n))
      return w(y[h].message), y;
  }
  if ((c || u) && !P && (un(v) || o && Array.isArray(v))) {
    const V = Zr(c), X = Zr(u), N = !ft(V.value) && v.length > +V.value, M = !ft(X.value) && v.length < +X.value;
    if ((N || M) && (W(N, V.message, X.message), !n))
      return w(y[h].message), y;
  }
  if (f && !P && un(v)) {
    const { value: V, message: X } = Zr(f);
    if (ga(V) && !v.match(V) && (y[h] = {
      type: pn.pattern,
      message: X,
      ref: i,
      ...L(pn.pattern, X)
    }, !n))
      return w(X), y;
  }
  if (p) {
    if (Ln(p)) {
      const V = await p(v, t), X = q1(V, C);
      if (X && (y[h] = {
        ...X,
        ...L(pn.validate, X.message)
      }, !n))
        return w(X.message), y;
    } else if ($e(p)) {
      let V = {};
      for (const X in p) {
        if (!dt(V) && !n)
          break;
        const N = q1(await p[X](v, t), C, X);
        N && (V = {
          ...N,
          ...L(X, N.message)
        }, w(N.message), n && (y[h] = V));
      }
      if (!dt(V) && (y[h] = {
        ref: C,
        ...V
      }, !n))
        return y;
    }
  }
  return w(!0), y;
}, Bc = (e, t) => [
  ...e,
  ...vt(t)
], kc = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function Lc(e, t, n) {
  return [
    ...e.slice(0, t),
    ...vt(n),
    ...e.slice(t)
  ];
}
var Hc = (e, t, n) => Array.isArray(e) ? (He(e[n]) && (e[n] = void 0), e.splice(n, 0, e.splice(t, 1)[0]), e) : [], Xc = (e, t) => [
  ...vt(t),
  ...vt(e)
];
function GE(e, t) {
  let n = 0;
  const r = [...e];
  for (const o of t)
    r.splice(o - n, 1), n++;
  return rs(r).length ? r : [];
}
var Wc = (e, t) => He(t) ? [] : GE(e, vt(t).sort((n, r) => n - r)), Zc = (e, t, n) => {
  [e[t], e[n]] = [e[n], e[t]];
};
function jE(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    e = He(e) ? r++ : e[t[r++]];
  return e;
}
function UE(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !He(e[t]))
      return !1;
  return !0;
}
function Qe(e, t) {
  const n = Array.isArray(t) ? t : Hd(t) ? [t] : Qm(t), r = n.length === 1 ? e : jE(e, n), o = n.length - 1, i = n[o];
  return r && delete r[i], o !== 0 && ($e(r) && dt(r) || Array.isArray(r) && UE(r)) && Qe(e, n.slice(0, -1)), e;
}
var Y1 = (e, t, n) => (e[t] = n, e);
function QE(e) {
  const t = ja(), { control: n = t.control, name: r, keyName: o = "id", shouldUnregister: i } = e, [s, a] = Y.useState(n._getFieldArray(r)), c = Y.useRef(n._getFieldArray(r).map(Tn)), u = Y.useRef(s), l = Y.useRef(r), d = Y.useRef(!1);
  l.current = r, u.current = s, n._names.array.add(r), e.rules && n.register(r, e.rules), Ua({
    next: ({ values: y, name: I }) => {
      if (I === l.current || !I) {
        const x = _(y, l.current);
        Array.isArray(x) && (a(x), c.current = x.map(Tn));
      }
    },
    subject: n._subjects.array
  });
  const f = Y.useCallback((y) => {
    d.current = !0, n._updateFieldArray(r, y);
  }, [n, r]), p = (y, I) => {
    const x = vt(Ke(y)), E = Bc(n._getFieldArray(r), x);
    n._names.focus = Vc(r, E.length - 1, I), c.current = Bc(c.current, x.map(Tn)), f(E), a(E), n._updateFieldArray(r, E, Bc, {
      argA: kc(y)
    });
  }, h = (y, I) => {
    const x = vt(Ke(y)), E = Xc(n._getFieldArray(r), x);
    n._names.focus = Vc(r, 0, I), c.current = Xc(c.current, x.map(Tn)), f(E), a(E), n._updateFieldArray(r, E, Xc, {
      argA: kc(y)
    });
  }, g = (y) => {
    const I = Wc(n._getFieldArray(r), y);
    c.current = Wc(c.current, y), f(I), a(I), n._updateFieldArray(r, I, Wc, {
      argA: y
    });
  }, m = (y, I, x) => {
    const E = vt(Ke(I)), P = Lc(n._getFieldArray(r), y, E);
    n._names.focus = Vc(r, y, x), c.current = Lc(c.current, y, E.map(Tn)), f(P), a(P), n._updateFieldArray(r, P, Lc, {
      argA: y,
      argB: kc(I)
    });
  }, b = (y, I) => {
    const x = n._getFieldArray(r);
    Zc(x, y, I), Zc(c.current, y, I), f(x), a(x), n._updateFieldArray(r, x, Zc, {
      argA: y,
      argB: I
    }, !1);
  }, v = (y, I) => {
    const x = n._getFieldArray(r);
    Hc(x, y, I), Hc(c.current, y, I), f(x), a(x), n._updateFieldArray(r, x, Hc, {
      argA: y,
      argB: I
    }, !1);
  }, C = (y, I) => {
    const x = Ke(I), E = Y1(n._getFieldArray(r), y, x);
    c.current = [...E].map((P, L) => !P || L === y ? Tn() : c.current[L]), f(E), a([...E]), n._updateFieldArray(r, E, Y1, {
      argA: y,
      argB: x
    }, !0, !1);
  }, w = (y) => {
    const I = vt(Ke(y));
    c.current = I.map(Tn), f([...I]), a([...I]), n._updateFieldArray(r, [...I], (x) => x, {}, !0, !1);
  };
  return Y.useEffect(() => {
    if (n._state.action = !1, ul(r, n._names) && n._subjects.state.next({
      ...n._formState
    }), d.current && (!ci(n._options.mode).isOnSubmit || n._formState.isSubmitted))
      if (n._options.resolver)
        n._executeSchema([r]).then((y) => {
          const I = _(y.errors, r), x = _(n._formState.errors, r);
          (x ? !I && x.type || I && (x.type !== I.type || x.message !== I.message) : I && I.type) && (I ? ke(n._formState.errors, r, I) : Qe(n._formState.errors, r), n._subjects.state.next({
            errors: n._formState.errors
          }));
        });
      else {
        const y = _(n._fields, r);
        y && y._f && !(ci(n._options.reValidateMode).isOnSubmit && ci(n._options.mode).isOnSubmit) && ll(y, n._formValues, n._options.criteriaMode === Mt.all, n._options.shouldUseNativeValidation, !0).then((I) => !dt(I) && n._subjects.state.next({
          errors: _m(n._formState.errors, I, r)
        }));
      }
    n._subjects.values.next({
      name: r,
      values: { ...n._formValues }
    }), n._names.focus && to(n._fields, (y, I) => {
      if (n._names.focus && I.startsWith(n._names.focus) && y.focus)
        return y.focus(), 1;
    }), n._names.focus = "", n._updateValid(), d.current = !1;
  }, [s, r, n]), Y.useEffect(() => (!_(n._formValues, r) && n._updateFieldArray(r), () => {
    (n._options.shouldUnregister || i) && n.unregister(r);
  }), [r, n, o, i]), {
    swap: Y.useCallback(b, [f, r, n]),
    move: Y.useCallback(v, [f, r, n]),
    prepend: Y.useCallback(h, [f, r, n]),
    append: Y.useCallback(p, [f, r, n]),
    remove: Y.useCallback(g, [f, r, n]),
    insert: Y.useCallback(m, [f, r, n]),
    update: Y.useCallback(C, [f, r, n]),
    replace: Y.useCallback(w, [f, r, n]),
    fields: Y.useMemo(() => s.map((y, I) => ({
      ...y,
      [o]: c.current[I] || Tn()
    })), [s, o])
  };
}
var zc = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (o) => {
      for (const i of e)
        i.next && i.next(o);
    },
    subscribe: (o) => (e.push(o), {
      unsubscribe: () => {
        e = e.filter((i) => i !== o);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, ba = (e) => ft(e) || !Gm(e);
function or(e, t) {
  if (ba(e) || ba(t))
    return e === t;
  if (Ur(e) && Ur(t))
    return e.getTime() === t.getTime();
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (const o of n) {
    const i = e[o];
    if (!r.includes(o))
      return !1;
    if (o !== "ref") {
      const s = t[o];
      if (Ur(i) && Ur(s) || $e(i) && $e(s) || Array.isArray(i) && Array.isArray(s) ? !or(i, s) : i !== s)
        return !1;
    }
  }
  return !0;
}
var tg = (e) => e.type === "select-multiple", qE = (e) => Zd(e) || ns(e), Gc = (e) => ma(e) && e.isConnected, ng = (e) => {
  for (const t in e)
    if (Ln(e[t]))
      return !0;
  return !1;
};
function va(e, t = {}) {
  const n = Array.isArray(e);
  if ($e(e) || n)
    for (const r in e)
      Array.isArray(e[r]) || $e(e[r]) && !ng(e[r]) ? (t[r] = Array.isArray(e[r]) ? [] : {}, va(e[r], t[r])) : ft(e[r]) || (t[r] = !0);
  return t;
}
function rg(e, t, n) {
  const r = Array.isArray(e);
  if ($e(e) || r)
    for (const o in e)
      Array.isArray(e[o]) || $e(e[o]) && !ng(e[o]) ? He(t) || ba(n[o]) ? n[o] = Array.isArray(e[o]) ? va(e[o], []) : { ...va(e[o]) } : rg(e[o], ft(t) ? {} : t[o], n[o]) : n[o] = !or(e[o], t[o]);
  return n;
}
var Os = (e, t) => rg(e, t, va(t)), og = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => He(e) ? e : t ? e === "" ? NaN : e && +e : n && un(e) ? new Date(e) : r ? r(e) : e;
function jc(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((n) => n.disabled) : t.disabled))
    return Wd(t) ? t.files : Zd(t) ? eg(e.refs).value : tg(t) ? [...t.selectedOptions].map(({ value: n }) => n) : ns(t) ? $m(e.refs).value : og(He(t.value) ? e.ref.value : t.value, e);
}
var YE = (e, t, n, r) => {
  const o = {};
  for (const i of e) {
    const s = _(t, i);
    s && ke(o, i, s._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: o,
    shouldUseNativeValidation: r
  };
}, Jo = (e) => He(e) ? e : ga(e) ? e.source : $e(e) ? ga(e.value) ? e.value.source : e.value : e, JE = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function J1(e, t, n) {
  const r = _(e, n);
  if (r || Hd(n))
    return {
      error: r,
      name: n
    };
  const o = n.split(".");
  for (; o.length; ) {
    const i = o.join("."), s = _(t, i), a = _(e, i);
    if (s && !Array.isArray(s) && n !== i)
      return { name: n };
    if (a && a.type)
      return {
        name: i,
        error: a
      };
    o.pop();
  }
  return {
    name: n
  };
}
var KE = (e, t, n, r, o) => o.isOnAll ? !1 : !n && o.isOnTouch ? !(t || e) : (n ? r.isOnBlur : o.isOnBlur) ? !e : (n ? r.isOnChange : o.isOnChange) ? e : !0, _E = (e, t) => !rs(_(e, t)).length && Qe(e, t);
const $E = {
  mode: Mt.onSubmit,
  reValidateMode: Mt.onChange,
  shouldFocusError: !0
};
function eS(e = {}) {
  let t = {
    ...$E,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Ln(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, o = $e(t.defaultValues) || $e(t.values) ? Ke(t.defaultValues || t.values) || {} : {}, i = t.shouldUnregister ? {} : Ke(o), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, a = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, u = 0;
  const l = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, d = {
    values: zc(),
    array: zc(),
    state: zc()
  }, f = ci(t.mode), p = ci(t.reValidateMode), h = t.criteriaMode === Mt.all, g = (T) => (O) => {
    clearTimeout(u), u = setTimeout(T, O);
  }, m = async (T) => {
    if (l.isValid || T) {
      const O = t.resolver ? dt((await E()).errors) : await L(r, !0);
      O !== n.isValid && d.state.next({
        isValid: O
      });
    }
  }, b = (T, O) => {
    (l.isValidating || l.validatingFields) && ((T || Array.from(a.mount)).forEach((k) => {
      k && (O ? ke(n.validatingFields, k, O) : Qe(n.validatingFields, k));
    }), d.state.next({
      validatingFields: n.validatingFields,
      isValidating: !dt(n.validatingFields)
    }));
  }, v = (T, O = [], k, q, U = !0, G = !0) => {
    if (q && k) {
      if (s.action = !0, G && Array.isArray(_(r, T))) {
        const oe = k(_(r, T), q.argA, q.argB);
        U && ke(r, T, oe);
      }
      if (G && Array.isArray(_(n.errors, T))) {
        const oe = k(_(n.errors, T), q.argA, q.argB);
        U && ke(n.errors, T, oe), _E(n.errors, T);
      }
      if (l.touchedFields && G && Array.isArray(_(n.touchedFields, T))) {
        const oe = k(_(n.touchedFields, T), q.argA, q.argB);
        U && ke(n.touchedFields, T, oe);
      }
      l.dirtyFields && (n.dirtyFields = Os(o, i)), d.state.next({
        name: T,
        isDirty: V(T, O),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      ke(i, T, O);
  }, C = (T, O) => {
    ke(n.errors, T, O), d.state.next({
      errors: n.errors
    });
  }, w = (T) => {
    n.errors = T, d.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, y = (T, O, k, q) => {
    const U = _(r, T);
    if (U) {
      const G = _(i, T, He(k) ? _(o, T) : k);
      He(G) || q && q.defaultChecked || O ? ke(i, T, O ? G : jc(U._f)) : M(T, G), s.mount && m();
    }
  }, I = (T, O, k, q, U) => {
    let G = !1, oe = !1;
    const xe = {
      name: T
    }, pe = !!(_(r, T) && _(r, T)._f && _(r, T)._f.disabled);
    if (!k || q) {
      l.isDirty && (oe = n.isDirty, n.isDirty = xe.isDirty = V(), G = oe !== xe.isDirty);
      const Ze = pe || or(_(o, T), O);
      oe = !!(!pe && _(n.dirtyFields, T)), Ze || pe ? Qe(n.dirtyFields, T) : ke(n.dirtyFields, T, !0), xe.dirtyFields = n.dirtyFields, G = G || l.dirtyFields && oe !== !Ze;
    }
    if (k) {
      const Ze = _(n.touchedFields, T);
      Ze || (ke(n.touchedFields, T, k), xe.touchedFields = n.touchedFields, G = G || l.touchedFields && Ze !== k);
    }
    return G && U && d.state.next(xe), G ? xe : {};
  }, x = (T, O, k, q) => {
    const U = _(n.errors, T), G = l.isValid && an(O) && n.isValid !== O;
    if (e.delayError && k ? (c = g(() => C(T, k)), c(e.delayError)) : (clearTimeout(u), c = null, k ? ke(n.errors, T, k) : Qe(n.errors, T)), (k ? !or(U, k) : U) || !dt(q) || G) {
      const oe = {
        ...q,
        ...G && an(O) ? { isValid: O } : {},
        errors: n.errors,
        name: T
      };
      n = {
        ...n,
        ...oe
      }, d.state.next(oe);
    }
  }, E = async (T) => {
    b(T, !0);
    const O = await t.resolver(i, t.context, YE(T || a.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
    return b(T), O;
  }, P = async (T) => {
    const { errors: O } = await E(T);
    if (T)
      for (const k of T) {
        const q = _(O, k);
        q ? ke(n.errors, k, q) : Qe(n.errors, k);
      }
    else
      n.errors = O;
    return O;
  }, L = async (T, O, k = {
    valid: !0
  }) => {
    for (const q in T) {
      const U = T[q];
      if (U) {
        const { _f: G, ...oe } = U;
        if (G) {
          const xe = a.array.has(G.name);
          b([q], !0);
          const pe = await ll(U, i, h, t.shouldUseNativeValidation && !O, xe);
          if (b([q]), pe[G.name] && (k.valid = !1, O))
            break;
          !O && (_(pe, G.name) ? xe ? _m(n.errors, pe, G.name) : ke(n.errors, G.name, pe[G.name]) : Qe(n.errors, G.name));
        }
        !dt(oe) && await L(oe, O, k);
      }
    }
    return k.valid;
  }, W = () => {
    for (const T of a.unMount) {
      const O = _(r, T);
      O && (O._f.refs ? O._f.refs.every((k) => !Gc(k)) : !Gc(O._f.ref)) && ue(T);
    }
    a.unMount = /* @__PURE__ */ new Set();
  }, V = (T, O) => (T && O && ke(i, T, O), !or(ee(), o)), X = (T, O, k) => Km(T, a, {
    ...s.mount ? i : He(O) ? o : un(T) ? { [T]: O } : O
  }, k, O), N = (T) => rs(_(s.mount ? i : o, T, e.shouldUnregister ? _(o, T, []) : [])), M = (T, O, k = {}) => {
    const q = _(r, T);
    let U = O;
    if (q) {
      const G = q._f;
      G && (!G.disabled && ke(i, T, og(O, G)), U = ma(G.ref) && ft(O) ? "" : O, tg(G.ref) ? [...G.ref.options].forEach((oe) => oe.selected = U.includes(oe.value)) : G.refs ? ns(G.ref) ? G.refs.length > 1 ? G.refs.forEach((oe) => (!oe.defaultChecked || !oe.disabled) && (oe.checked = Array.isArray(U) ? !!U.find((xe) => xe === oe.value) : U === oe.value)) : G.refs[0] && (G.refs[0].checked = !!U) : G.refs.forEach((oe) => oe.checked = oe.value === U) : Wd(G.ref) ? G.ref.value = "" : (G.ref.value = U, G.ref.type || d.values.next({
        name: T,
        values: { ...i }
      })));
    }
    (k.shouldDirty || k.shouldTouch) && I(T, U, k.shouldTouch, k.shouldDirty, !0), k.shouldValidate && K(T);
  }, F = (T, O, k) => {
    for (const q in O) {
      const U = O[q], G = `${T}.${q}`, oe = _(r, G);
      (a.array.has(T) || !ba(U) || oe && !oe._f) && !Ur(U) ? F(G, U, k) : M(G, U, k);
    }
  }, B = (T, O, k = {}) => {
    const q = _(r, T), U = a.array.has(T), G = Ke(O);
    ke(i, T, G), U ? (d.array.next({
      name: T,
      values: { ...i }
    }), (l.isDirty || l.dirtyFields) && k.shouldDirty && d.state.next({
      name: T,
      dirtyFields: Os(o, i),
      isDirty: V(T, G)
    })) : q && !q._f && !ft(G) ? F(T, G, k) : M(T, G, k), ul(T, a) && d.state.next({ ...n }), d.values.next({
      name: s.mount ? T : void 0,
      values: { ...i }
    });
  }, Z = async (T) => {
    s.mount = !0;
    const O = T.target;
    let k = O.name, q = !0;
    const U = _(r, k), G = () => O.type ? jc(U._f) : jm(T), oe = (xe) => {
      q = Number.isNaN(xe) || xe === _(i, k, xe);
    };
    if (U) {
      let xe, pe;
      const Ze = G(), Br = T.type === pa.BLUR || T.type === pa.FOCUS_OUT, X3 = !JE(U._f) && !t.resolver && !_(n.errors, k) && !U._f.deps || KE(Br, _(n.touchedFields, k), n.isSubmitted, p, f), ac = ul(k, a, Br);
      ke(i, k, Ze), Br ? (U._f.onBlur && U._f.onBlur(T), c && c(0)) : U._f.onChange && U._f.onChange(T);
      const cc = I(k, Ze, Br, !1), W3 = !dt(cc) || ac;
      if (!Br && d.values.next({
        name: k,
        type: T.type,
        values: { ...i }
      }), X3)
        return l.isValid && m(), W3 && d.state.next({ name: k, ...ac ? {} : cc });
      if (!Br && ac && d.state.next({ ...n }), t.resolver) {
        const { errors: AA } = await E([k]);
        if (oe(Ze), q) {
          const Z3 = J1(n.errors, r, k), fA = J1(AA, r, Z3.name || k);
          xe = fA.error, k = fA.name, pe = dt(AA);
        }
      } else
        b([k], !0), xe = (await ll(U, i, h, t.shouldUseNativeValidation))[k], b([k]), oe(Ze), q && (xe ? pe = !1 : l.isValid && (pe = await L(r, !0)));
      q && (U._f.deps && K(U._f.deps), x(k, pe, xe, cc));
    }
  }, H = (T, O) => {
    if (_(n.errors, O) && T.focus)
      return T.focus(), 1;
  }, K = async (T, O = {}) => {
    let k, q;
    const U = vt(T);
    if (t.resolver) {
      const G = await P(He(T) ? T : U);
      k = dt(G), q = T ? !U.some((oe) => _(G, oe)) : k;
    } else T ? (q = (await Promise.all(U.map(async (G) => {
      const oe = _(r, G);
      return await L(oe && oe._f ? { [G]: oe } : oe);
    }))).every(Boolean), !(!q && !n.isValid) && m()) : q = k = await L(r);
    return d.state.next({
      ...!un(T) || l.isValid && k !== n.isValid ? {} : { name: T },
      ...t.resolver || !T ? { isValid: k } : {},
      errors: n.errors
    }), O.shouldFocus && !q && to(r, H, T ? U : a.mount), q;
  }, ee = (T) => {
    const O = {
      ...s.mount ? i : o
    };
    return He(T) ? O : un(T) ? _(O, T) : T.map((k) => _(O, k));
  }, z = (T, O) => ({
    invalid: !!_((O || n).errors, T),
    isDirty: !!_((O || n).dirtyFields, T),
    error: _((O || n).errors, T),
    isValidating: !!_(n.validatingFields, T),
    isTouched: !!_((O || n).touchedFields, T)
  }), ce = (T) => {
    T && vt(T).forEach((O) => Qe(n.errors, O)), d.state.next({
      errors: T ? n.errors : {}
    });
  }, be = (T, O, k) => {
    const q = (_(r, T, { _f: {} })._f || {}).ref, U = _(n.errors, T) || {}, { ref: G, message: oe, type: xe, ...pe } = U;
    ke(n.errors, T, {
      ...pe,
      ...O,
      ref: q
    }), d.state.next({
      name: T,
      errors: n.errors,
      isValid: !1
    }), k && k.shouldFocus && q && q.focus && q.focus();
  }, te = (T, O) => Ln(T) ? d.values.subscribe({
    next: (k) => T(X(void 0, O), k)
  }) : X(T, O, !0), ue = (T, O = {}) => {
    for (const k of T ? vt(T) : a.mount)
      a.mount.delete(k), a.array.delete(k), O.keepValue || (Qe(r, k), Qe(i, k)), !O.keepError && Qe(n.errors, k), !O.keepDirty && Qe(n.dirtyFields, k), !O.keepTouched && Qe(n.touchedFields, k), !O.keepIsValidating && Qe(n.validatingFields, k), !t.shouldUnregister && !O.keepDefaultValue && Qe(o, k);
    d.values.next({
      values: { ...i }
    }), d.state.next({
      ...n,
      ...O.keepDirty ? { isDirty: V() } : {}
    }), !O.keepIsValid && m();
  }, me = ({ disabled: T, name: O, field: k, fields: q, value: U }) => {
    if (an(T) && s.mount || T) {
      const G = T ? void 0 : He(U) ? jc(k ? k._f : _(q, O)._f) : U;
      ke(i, O, G), I(O, G, !1, !1, !0);
    }
  }, Te = (T, O = {}) => {
    let k = _(r, T);
    const q = an(O.disabled);
    return ke(r, T, {
      ...k || {},
      _f: {
        ...k && k._f ? k._f : { ref: { name: T } },
        name: T,
        mount: !0,
        ...O
      }
    }), a.mount.add(T), k ? me({
      field: k,
      disabled: O.disabled,
      name: T,
      value: O.value
    }) : y(T, !0, O.value), {
      ...q ? { disabled: O.disabled } : {},
      ...t.progressive ? {
        required: !!O.required,
        min: Jo(O.min),
        max: Jo(O.max),
        minLength: Jo(O.minLength),
        maxLength: Jo(O.maxLength),
        pattern: Jo(O.pattern)
      } : {},
      name: T,
      onChange: Z,
      onBlur: Z,
      ref: (U) => {
        if (U) {
          Te(T, O), k = _(r, T);
          const G = He(U.value) && U.querySelectorAll && U.querySelectorAll("input,select,textarea")[0] || U, oe = qE(G), xe = k._f.refs || [];
          if (oe ? xe.find((pe) => pe === G) : G === k._f.ref)
            return;
          ke(r, T, {
            _f: {
              ...k._f,
              ...oe ? {
                refs: [
                  ...xe.filter(Gc),
                  G,
                  ...Array.isArray(_(o, T)) ? [{}] : []
                ],
                ref: { type: G.type, name: T }
              } : { ref: G }
            }
          }), y(T, !1, void 0, G);
        } else
          k = _(r, T, {}), k._f && (k._f.mount = !1), (t.shouldUnregister || O.shouldUnregister) && !(Um(a.array, T) && s.action) && a.unMount.add(T);
      }
    };
  }, Be = () => t.shouldFocusError && to(r, H, a.mount), et = (T) => {
    an(T) && (d.state.next({ disabled: T }), to(r, (O, k) => {
      const q = _(r, k);
      q && (O.disabled = q._f.disabled || T, Array.isArray(q._f.refs) && q._f.refs.forEach((U) => {
        U.disabled = q._f.disabled || T;
      }));
    }, 0, !1));
  }, it = (T, O) => async (k) => {
    let q;
    k && (k.preventDefault && k.preventDefault(), k.persist && k.persist());
    let U = Ke(i);
    if (d.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: G, values: oe } = await E();
      n.errors = G, U = oe;
    } else
      await L(r);
    if (Qe(n.errors, "root"), dt(n.errors)) {
      d.state.next({
        errors: {}
      });
      try {
        await T(U, k);
      } catch (G) {
        q = G;
      }
    } else
      O && await O({ ...n.errors }, k), Be(), setTimeout(Be);
    if (d.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: dt(n.errors) && !q,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), q)
      throw q;
  }, re = (T, O = {}) => {
    _(r, T) && (He(O.defaultValue) ? B(T, Ke(_(o, T))) : (B(T, O.defaultValue), ke(o, T, Ke(O.defaultValue))), O.keepTouched || Qe(n.touchedFields, T), O.keepDirty || (Qe(n.dirtyFields, T), n.isDirty = O.defaultValue ? V(T, Ke(_(o, T))) : V()), O.keepError || (Qe(n.errors, T), l.isValid && m()), d.state.next({ ...n }));
  }, Ge = (T, O = {}) => {
    const k = T ? Ke(T) : o, q = Ke(k), U = dt(T), G = U ? o : q;
    if (O.keepDefaultValues || (o = k), !O.keepValues) {
      if (O.keepDirtyValues)
        for (const oe of a.mount)
          _(n.dirtyFields, oe) ? ke(G, oe, _(i, oe)) : B(oe, _(G, oe));
      else {
        if (Ld && He(T))
          for (const oe of a.mount) {
            const xe = _(r, oe);
            if (xe && xe._f) {
              const pe = Array.isArray(xe._f.refs) ? xe._f.refs[0] : xe._f.ref;
              if (ma(pe)) {
                const Ze = pe.closest("form");
                if (Ze) {
                  Ze.reset();
                  break;
                }
              }
            }
          }
        r = {};
      }
      i = e.shouldUnregister ? O.keepDefaultValues ? Ke(o) : {} : Ke(G), d.array.next({
        values: { ...G }
      }), d.values.next({
        values: { ...G }
      });
    }
    a = {
      mount: O.keepDirtyValues ? a.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !l.isValid || !!O.keepIsValid || !!O.keepDirtyValues, s.watch = !!e.shouldUnregister, d.state.next({
      submitCount: O.keepSubmitCount ? n.submitCount : 0,
      isDirty: U ? !1 : O.keepDirty ? n.isDirty : !!(O.keepDefaultValues && !or(T, o)),
      isSubmitted: O.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: U ? {} : O.keepDirtyValues ? O.keepDefaultValues && i ? Os(o, i) : n.dirtyFields : O.keepDefaultValues && T ? Os(o, T) : O.keepDirty ? n.dirtyFields : {},
      touchedFields: O.keepTouched ? n.touchedFields : {},
      errors: O.keepErrors ? n.errors : {},
      isSubmitSuccessful: O.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, nt = (T, O) => Ge(Ln(T) ? T(i) : T, O);
  return {
    control: {
      register: Te,
      unregister: ue,
      getFieldState: z,
      handleSubmit: it,
      setError: be,
      _executeSchema: E,
      _getWatch: X,
      _getDirty: V,
      _updateValid: m,
      _removeUnmounted: W,
      _updateFieldArray: v,
      _updateDisabledField: me,
      _getFieldArray: N,
      _reset: Ge,
      _resetDefaultValues: () => Ln(t.defaultValues) && t.defaultValues().then((T) => {
        nt(T, t.resetOptions), d.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (T) => {
        n = {
          ...n,
          ...T
        };
      },
      _disableForm: et,
      _subjects: d,
      _proxyFormState: l,
      _setErrors: w,
      get _fields() {
        return r;
      },
      get _formValues() {
        return i;
      },
      get _state() {
        return s;
      },
      set _state(T) {
        s = T;
      },
      get _defaultValues() {
        return o;
      },
      get _names() {
        return a;
      },
      set _names(T) {
        a = T;
      },
      get _formState() {
        return n;
      },
      set _formState(T) {
        n = T;
      },
      get _options() {
        return t;
      },
      set _options(T) {
        t = {
          ...t,
          ...T
        };
      }
    },
    trigger: K,
    register: Te,
    handleSubmit: it,
    watch: te,
    setValue: B,
    getValues: ee,
    reset: nt,
    resetField: re,
    clearErrors: ce,
    unregister: ue,
    setError: be,
    setFocus: (T, O = {}) => {
      const k = _(r, T), q = k && k._f;
      if (q) {
        const U = q.refs ? q.refs[0] : q.ref;
        U.focus && (U.focus(), O.shouldSelect && U.select());
      }
    },
    getFieldState: z
  };
}
function Qa(e = {}) {
  const t = Y.useRef(), n = Y.useRef(), [r, o] = Y.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ln(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Ln(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ...eS(e),
    formState: r
  });
  const i = t.current.control;
  return i._options = e, Ua({
    subject: i._subjects.state,
    next: (s) => {
      Ym(s, i._proxyFormState, i._updateFormState, !0) && o({ ...i._formState });
    }
  }), Y.useEffect(() => i._disableForm(e.disabled), [i, e.disabled]), Y.useEffect(() => {
    if (i._proxyFormState.isDirty) {
      const s = i._getDirty();
      s !== r.isDirty && i._subjects.state.next({
        isDirty: s
      });
    }
  }, [i, r.isDirty]), Y.useEffect(() => {
    e.values && !or(e.values, n.current) ? (i._reset(e.values, i._options.resetOptions), n.current = e.values, o((s) => ({ ...s }))) : i._resetDefaultValues();
  }, [e.values, i]), Y.useEffect(() => {
    e.errors && i._setErrors(e.errors);
  }, [e.errors, i]), Y.useEffect(() => {
    i._state.mount || (i._updateValid(), i._state.mount = !0), i._state.watch && (i._state.watch = !1, i._subjects.state.next({ ...i._formState })), i._removeUnmounted();
  }), Y.useEffect(() => {
    e.shouldUnregister && i._subjects.values.next({
      values: i._getWatch()
    });
  }, [e.shouldUnregister, i]), t.current.formState = qm(r, i), t.current;
}
function tS(e) {
  var u;
  const [t, n] = Q(!1), [r, o] = Q(!1), {
    register: i,
    handleSubmit: s,
    control: a,
    formState: { errors: c }
  } = Qa({
    defaultValues: {
      name: "",
      sharingType: _t,
      availableOffline: !1
    }
  });
  return /* @__PURE__ */ R("form", { onSubmit: s(e.onSubmit), children: [
    /* @__PURE__ */ A(Ca, { htmlFor: "driveName", children: "Drive Name" }),
    /* @__PURE__ */ A(
      os,
      {
        ...i("name", {
          required: "Drive name is required"
        }),
        errorMessage: (u = c.name) == null ? void 0 : u.message,
        icon: /* @__PURE__ */ A(J, { name: "Drive" }),
        placeholder: "Drive name"
      }
    ),
    /* @__PURE__ */ A(bt, { className: "my-4" }),
    /* @__PURE__ */ A(Ca, { htmlFor: "sharingType", children: "Sharing settings" }),
    /* @__PURE__ */ A(gg, { control: a }),
    /* @__PURE__ */ A(bt, { className: "my-3" }),
    /* @__PURE__ */ A(
      Co,
      {
        title: "Upload from device",
        isOpen: r,
        onOpenChange: () => o(!r),
        children: /* @__PURE__ */ A("div", { className: "mt-3 grid h-[117px] w-full place-items-center rounded-xl bg-gray-200", children: /* @__PURE__ */ R("div", { className: "rounded-xl bg-white p-3 text-xs", children: [
          /* @__PURE__ */ A(
            J,
            {
              name: "ArrowUp",
              size: 20,
              className: "mr-2 inline-block"
            }
          ),
          "Click or drop folder"
        ] }) })
      }
    ),
    /* @__PURE__ */ A(bt, { className: "my-3" }),
    /* @__PURE__ */ R(
      Co,
      {
        title: "Location",
        isOpen: t,
        onOpenChange: () => n(!t),
        children: [
          /* @__PURE__ */ A(qd, { location: Zi }),
          /* @__PURE__ */ A(Qd, { ...i("availableOffline") })
        ]
      }
    ),
    /* @__PURE__ */ A(bt, { className: "my-3" }),
    /* @__PURE__ */ A(jt, { type: "submit", className: "mb-4 w-full", children: "Create new drive" })
  ] });
}
const zd = JSON, nS = (e) => e.toUpperCase(), rS = (e) => {
  const t = {};
  return e.forEach((n, r) => {
    t[r] = n;
  }), t;
}, oS = (e, t, n) => e.document ? e : {
  document: e,
  variables: t,
  requestHeaders: n,
  signal: void 0
}, iS = (e, t, n) => e.query ? e : {
  query: e,
  variables: t,
  requestHeaders: n,
  signal: void 0
}, sS = (e, t) => e.documents ? e : {
  documents: e,
  requestHeaders: t,
  signal: void 0
};
function Us(e, t) {
  if (!!!e)
    throw new Error(t);
}
function aS(e) {
  return typeof e == "object" && e !== null;
}
function cS(e, t) {
  if (!!!e)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const uS = /\r\n|[\n\r]/g;
function dl(e, t) {
  let n = 0, r = 1;
  for (const o of e.body.matchAll(uS)) {
    if (typeof o.index == "number" || cS(!1), o.index >= t)
      break;
    n = o.index + o[0].length, r += 1;
  }
  return {
    line: r,
    column: t + 1 - n
  };
}
function lS(e) {
  return ig(
    e.source,
    dl(e.source, e.start)
  );
}
function ig(e, t) {
  const n = e.locationOffset.column - 1, r = "".padStart(n) + e.body, o = t.line - 1, i = e.locationOffset.line - 1, s = t.line + i, a = t.line === 1 ? n : 0, c = t.column + a, u = `${e.name}:${s}:${c}
`, l = r.split(/\r\n|[\n\r]/g), d = l[o];
  if (d.length > 120) {
    const f = Math.floor(c / 80), p = c % 80, h = [];
    for (let g = 0; g < d.length; g += 80)
      h.push(d.slice(g, g + 80));
    return u + K1([
      [`${s} |`, h[0]],
      ...h.slice(1, f + 1).map((g) => ["|", g]),
      ["|", "^".padStart(p)],
      ["|", h[f + 1]]
    ]);
  }
  return u + K1([
    // Lines specified like this: ["prefix", "string"],
    [`${s - 1} |`, l[o - 1]],
    [`${s} |`, d],
    ["|", "^".padStart(c)],
    [`${s + 1} |`, l[o + 1]]
  ]);
}
function K1(e) {
  const t = e.filter(([r, o]) => o !== void 0), n = Math.max(...t.map(([r]) => r.length));
  return t.map(([r, o]) => r.padStart(n) + (o ? " " + o : "")).join(`
`);
}
function dS(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
class Gd extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...n) {
    var r, o, i;
    const { nodes: s, source: a, positions: c, path: u, originalError: l, extensions: d } = dS(n);
    super(t), this.name = "GraphQLError", this.path = u ?? void 0, this.originalError = l ?? void 0, this.nodes = _1(
      Array.isArray(s) ? s : s ? [s] : void 0
    );
    const f = _1(
      (r = this.nodes) === null || r === void 0 ? void 0 : r.map((h) => h.loc).filter((h) => h != null)
    );
    this.source = a ?? (f == null || (o = f[0]) === null || o === void 0 ? void 0 : o.source), this.positions = c ?? (f == null ? void 0 : f.map((h) => h.start)), this.locations = c && a ? c.map((h) => dl(a, h)) : f == null ? void 0 : f.map((h) => dl(h.source, h.start));
    const p = aS(
      l == null ? void 0 : l.extensions
    ) ? l == null ? void 0 : l.extensions : void 0;
    this.extensions = (i = d ?? p) !== null && i !== void 0 ? i : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), l != null && l.stack ? Object.defineProperty(this, "stack", {
      value: l.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Gd) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const n of this.nodes)
        n.loc && (t += `

` + lS(n.loc));
    else if (this.source && this.locations)
      for (const n of this.locations)
        t += `

` + ig(this.source, n);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
}
function _1(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function tt(e, t, n) {
  return new Gd(`Syntax Error: ${n}`, {
    source: e,
    positions: [t]
  });
}
class AS {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, n, r) {
    this.start = t.start, this.end = n.end, this.startToken = t, this.endToken = n, this.source = r;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class sg {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, n, r, o, i, s) {
    this.kind = t, this.start = n, this.end = r, this.line = o, this.column = i, this.value = s, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const ag = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, fS = new Set(Object.keys(ag));
function $1(e) {
  const t = e == null ? void 0 : e.kind;
  return typeof t == "string" && fS.has(t);
}
var Qr;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(Qr || (Qr = {}));
var Al;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(Al || (Al = {}));
var fe;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(fe || (fe = {}));
function fl(e) {
  return e === 9 || e === 32;
}
function Bi(e) {
  return e >= 48 && e <= 57;
}
function cg(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function ug(e) {
  return cg(e) || e === 95;
}
function hS(e) {
  return cg(e) || Bi(e) || e === 95;
}
function pS(e) {
  var t;
  let n = Number.MAX_SAFE_INTEGER, r = null, o = -1;
  for (let s = 0; s < e.length; ++s) {
    var i;
    const a = e[s], c = mS(a);
    c !== a.length && (r = (i = r) !== null && i !== void 0 ? i : s, o = s, s !== 0 && c < n && (n = c));
  }
  return e.map((s, a) => a === 0 ? s : s.slice(n)).slice(
    (t = r) !== null && t !== void 0 ? t : 0,
    o + 1
  );
}
function mS(e) {
  let t = 0;
  for (; t < e.length && fl(e.charCodeAt(t)); )
    ++t;
  return t;
}
function gS(e, t) {
  const n = e.replace(/"""/g, '\\"""'), r = n.split(/\r\n|[\n\r]/g), o = r.length === 1, i = r.length > 1 && r.slice(1).every((p) => p.length === 0 || fl(p.charCodeAt(0))), s = n.endsWith('\\"""'), a = e.endsWith('"') && !s, c = e.endsWith("\\"), u = a || c, l = (
    // add leading and trailing new lines only if it improves readability
    !o || e.length > 70 || u || i || s
  );
  let d = "";
  const f = o && fl(e.charCodeAt(0));
  return (l && !f || i) && (d += `
`), d += n, (l || u) && (d += `
`), '"""' + d + '"""';
}
var j;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(j || (j = {}));
class bS {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const n = new sg(j.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = n, this.token = n, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== j.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const n = yS(this, t.end);
          t.next = n, n.prev = t, t = n;
        }
      while (t.kind === j.COMMENT);
    return t;
  }
}
function vS(e) {
  return e === j.BANG || e === j.DOLLAR || e === j.AMP || e === j.PAREN_L || e === j.PAREN_R || e === j.SPREAD || e === j.COLON || e === j.EQUALS || e === j.AT || e === j.BRACKET_L || e === j.BRACKET_R || e === j.BRACE_L || e === j.PIPE || e === j.BRACE_R;
}
function Bo(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function qa(e, t) {
  return lg(e.charCodeAt(t)) && dg(e.charCodeAt(t + 1));
}
function lg(e) {
  return e >= 55296 && e <= 56319;
}
function dg(e) {
  return e >= 56320 && e <= 57343;
}
function Ir(e, t) {
  const n = e.source.body.codePointAt(t);
  if (n === void 0)
    return j.EOF;
  if (n >= 32 && n <= 126) {
    const r = String.fromCodePoint(n);
    return r === '"' ? `'"'` : `"${r}"`;
  }
  return "U+" + n.toString(16).toUpperCase().padStart(4, "0");
}
function qe(e, t, n, r, o) {
  const i = e.line, s = 1 + n - e.lineStart;
  return new sg(t, n, r, i, s, o);
}
function yS(e, t) {
  const n = e.source.body, r = n.length;
  let o = t;
  for (; o < r; ) {
    const i = n.charCodeAt(o);
    switch (i) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++o;
        continue;
      case 10:
        ++o, ++e.line, e.lineStart = o;
        continue;
      case 13:
        n.charCodeAt(o + 1) === 10 ? o += 2 : ++o, ++e.line, e.lineStart = o;
        continue;
      case 35:
        return CS(e, o);
      case 33:
        return qe(e, j.BANG, o, o + 1);
      case 36:
        return qe(e, j.DOLLAR, o, o + 1);
      case 38:
        return qe(e, j.AMP, o, o + 1);
      case 40:
        return qe(e, j.PAREN_L, o, o + 1);
      case 41:
        return qe(e, j.PAREN_R, o, o + 1);
      case 46:
        if (n.charCodeAt(o + 1) === 46 && n.charCodeAt(o + 2) === 46)
          return qe(e, j.SPREAD, o, o + 3);
        break;
      case 58:
        return qe(e, j.COLON, o, o + 1);
      case 61:
        return qe(e, j.EQUALS, o, o + 1);
      case 64:
        return qe(e, j.AT, o, o + 1);
      case 91:
        return qe(e, j.BRACKET_L, o, o + 1);
      case 93:
        return qe(e, j.BRACKET_R, o, o + 1);
      case 123:
        return qe(e, j.BRACE_L, o, o + 1);
      case 124:
        return qe(e, j.PIPE, o, o + 1);
      case 125:
        return qe(e, j.BRACE_R, o, o + 1);
      case 34:
        return n.charCodeAt(o + 1) === 34 && n.charCodeAt(o + 2) === 34 ? TS(e, o) : wS(e, o);
    }
    if (Bi(i) || i === 45)
      return xS(e, o, i);
    if (ug(i))
      return NS(e, o);
    throw tt(
      e.source,
      o,
      i === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Bo(i) || qa(n, o) ? `Unexpected character: ${Ir(e, o)}.` : `Invalid character: ${Ir(e, o)}.`
    );
  }
  return qe(e, j.EOF, r, r);
}
function CS(e, t) {
  const n = e.source.body, r = n.length;
  let o = t + 1;
  for (; o < r; ) {
    const i = n.charCodeAt(o);
    if (i === 10 || i === 13)
      break;
    if (Bo(i))
      ++o;
    else if (qa(n, o))
      o += 2;
    else
      break;
  }
  return qe(
    e,
    j.COMMENT,
    t,
    o,
    n.slice(t + 1, o)
  );
}
function xS(e, t, n) {
  const r = e.source.body;
  let o = t, i = n, s = !1;
  if (i === 45 && (i = r.charCodeAt(++o)), i === 48) {
    if (i = r.charCodeAt(++o), Bi(i))
      throw tt(
        e.source,
        o,
        `Invalid number, unexpected digit after 0: ${Ir(
          e,
          o
        )}.`
      );
  } else
    o = Uc(e, o, i), i = r.charCodeAt(o);
  if (i === 46 && (s = !0, i = r.charCodeAt(++o), o = Uc(e, o, i), i = r.charCodeAt(o)), (i === 69 || i === 101) && (s = !0, i = r.charCodeAt(++o), (i === 43 || i === 45) && (i = r.charCodeAt(++o)), o = Uc(e, o, i), i = r.charCodeAt(o)), i === 46 || ug(i))
    throw tt(
      e.source,
      o,
      `Invalid number, expected digit but got: ${Ir(
        e,
        o
      )}.`
    );
  return qe(
    e,
    s ? j.FLOAT : j.INT,
    t,
    o,
    r.slice(t, o)
  );
}
function Uc(e, t, n) {
  if (!Bi(n))
    throw tt(
      e.source,
      t,
      `Invalid number, expected digit but got: ${Ir(
        e,
        t
      )}.`
    );
  const r = e.source.body;
  let o = t + 1;
  for (; Bi(r.charCodeAt(o)); )
    ++o;
  return o;
}
function wS(e, t) {
  const n = e.source.body, r = n.length;
  let o = t + 1, i = o, s = "";
  for (; o < r; ) {
    const a = n.charCodeAt(o);
    if (a === 34)
      return s += n.slice(i, o), qe(e, j.STRING, t, o + 1, s);
    if (a === 92) {
      s += n.slice(i, o);
      const c = n.charCodeAt(o + 1) === 117 ? n.charCodeAt(o + 2) === 123 ? IS(e, o) : ES(e, o) : SS(e, o);
      s += c.value, o += c.size, i = o;
      continue;
    }
    if (a === 10 || a === 13)
      break;
    if (Bo(a))
      ++o;
    else if (qa(n, o))
      o += 2;
    else
      throw tt(
        e.source,
        o,
        `Invalid character within String: ${Ir(
          e,
          o
        )}.`
      );
  }
  throw tt(e.source, o, "Unterminated string.");
}
function IS(e, t) {
  const n = e.source.body;
  let r = 0, o = 3;
  for (; o < 12; ) {
    const i = n.charCodeAt(t + o++);
    if (i === 125) {
      if (o < 5 || !Bo(r))
        break;
      return {
        value: String.fromCodePoint(r),
        size: o
      };
    }
    if (r = r << 4 | si(i), r < 0)
      break;
  }
  throw tt(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${n.slice(
      t,
      t + o
    )}".`
  );
}
function ES(e, t) {
  const n = e.source.body, r = ef(n, t + 2);
  if (Bo(r))
    return {
      value: String.fromCodePoint(r),
      size: 6
    };
  if (lg(r) && n.charCodeAt(t + 6) === 92 && n.charCodeAt(t + 7) === 117) {
    const o = ef(n, t + 8);
    if (dg(o))
      return {
        value: String.fromCodePoint(r, o),
        size: 12
      };
  }
  throw tt(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${n.slice(t, t + 6)}".`
  );
}
function ef(e, t) {
  return si(e.charCodeAt(t)) << 12 | si(e.charCodeAt(t + 1)) << 8 | si(e.charCodeAt(t + 2)) << 4 | si(e.charCodeAt(t + 3));
}
function si(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function SS(e, t) {
  const n = e.source.body;
  switch (n.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw tt(
    e.source,
    t,
    `Invalid character escape sequence: "${n.slice(
      t,
      t + 2
    )}".`
  );
}
function TS(e, t) {
  const n = e.source.body, r = n.length;
  let o = e.lineStart, i = t + 3, s = i, a = "";
  const c = [];
  for (; i < r; ) {
    const u = n.charCodeAt(i);
    if (u === 34 && n.charCodeAt(i + 1) === 34 && n.charCodeAt(i + 2) === 34) {
      a += n.slice(s, i), c.push(a);
      const l = qe(
        e,
        j.BLOCK_STRING,
        t,
        i + 3,
        // Return a string of the lines joined with U+000A.
        pS(c).join(`
`)
      );
      return e.line += c.length - 1, e.lineStart = o, l;
    }
    if (u === 92 && n.charCodeAt(i + 1) === 34 && n.charCodeAt(i + 2) === 34 && n.charCodeAt(i + 3) === 34) {
      a += n.slice(s, i), s = i + 1, i += 4;
      continue;
    }
    if (u === 10 || u === 13) {
      a += n.slice(s, i), c.push(a), u === 13 && n.charCodeAt(i + 1) === 10 ? i += 2 : ++i, a = "", s = i, o = i;
      continue;
    }
    if (Bo(u))
      ++i;
    else if (qa(n, i))
      i += 2;
    else
      throw tt(
        e.source,
        i,
        `Invalid character within String: ${Ir(
          e,
          i
        )}.`
      );
  }
  throw tt(e.source, i, "Unterminated string.");
}
function NS(e, t) {
  const n = e.source.body, r = n.length;
  let o = t + 1;
  for (; o < r; ) {
    const i = n.charCodeAt(o);
    if (hS(i))
      ++o;
    else
      break;
  }
  return qe(
    e,
    j.NAME,
    t,
    o,
    n.slice(t, o)
  );
}
const PS = 10, Ag = 2;
function jd(e) {
  return Ya(e, []);
}
function Ya(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return RS(e, t);
    default:
      return String(e);
  }
}
function RS(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const n = [...t, e];
  if (OS(e)) {
    const r = e.toJSON();
    if (r !== e)
      return typeof r == "string" ? r : Ya(r, n);
  } else if (Array.isArray(e))
    return MS(e, n);
  return DS(e, n);
}
function OS(e) {
  return typeof e.toJSON == "function";
}
function DS(e, t) {
  const n = Object.entries(e);
  return n.length === 0 ? "{}" : t.length > Ag ? "[" + FS(e) + "]" : "{ " + n.map(
    ([o, i]) => o + ": " + Ya(i, t)
  ).join(", ") + " }";
}
function MS(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > Ag)
    return "[Array]";
  const n = Math.min(PS, e.length), r = e.length - n, o = [];
  for (let i = 0; i < n; ++i)
    o.push(Ya(e[i], t));
  return r === 1 ? o.push("... 1 more item") : r > 1 && o.push(`... ${r} more items`), "[" + o.join(", ") + "]";
}
function FS(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const n = e.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return t;
}
const VS = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", BS = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  VS ? function(t, n) {
    return t instanceof n;
  } : function(t, n) {
    if (t instanceof n)
      return !0;
    if (typeof t == "object" && t !== null) {
      var r;
      const o = n.prototype[Symbol.toStringTag], i = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in t ? t[Symbol.toStringTag] : (r = t.constructor) === null || r === void 0 ? void 0 : r.name
      );
      if (o === i) {
        const s = jd(t);
        throw new Error(`Cannot use ${o} "${s}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class fg {
  constructor(t, n = "GraphQL request", r = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || Us(!1, `Body must be a string. Received: ${jd(t)}.`), this.body = t, this.name = n, this.locationOffset = r, this.locationOffset.line > 0 || Us(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || Us(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function kS(e) {
  return BS(e, fg);
}
function LS(e, t) {
  return new HS(e, t).parseDocument();
}
class HS {
  constructor(t, n = {}) {
    const r = kS(t) ? t : new fg(t);
    this._lexer = new bS(r), this._options = n, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(j.NAME);
    return this.node(t, {
      kind: fe.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: fe.DOCUMENT,
      definitions: this.many(
        j.SOF,
        this.parseDefinition,
        j.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(j.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), n = t ? this._lexer.lookahead() : this._lexer.token;
    if (n.kind === j.NAME) {
      switch (n.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (t)
        throw tt(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (n.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(n);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(j.BRACE_L))
      return this.node(t, {
        kind: fe.OPERATION_DEFINITION,
        operation: Qr.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const n = this.parseOperationType();
    let r;
    return this.peek(j.NAME) && (r = this.parseName()), this.node(t, {
      kind: fe.OPERATION_DEFINITION,
      operation: n,
      name: r,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(j.NAME);
    switch (t.value) {
      case "query":
        return Qr.QUERY;
      case "mutation":
        return Qr.MUTATION;
      case "subscription":
        return Qr.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      j.PAREN_L,
      this.parseVariableDefinition,
      j.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: fe.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(j.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(j.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(j.DOLLAR), this.node(t, {
      kind: fe.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: fe.SELECTION_SET,
      selections: this.many(
        j.BRACE_L,
        this.parseSelection,
        j.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(j.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, n = this.parseName();
    let r, o;
    return this.expectOptionalToken(j.COLON) ? (r = n, o = this.parseName()) : o = n, this.node(t, {
      kind: fe.FIELD,
      alias: r,
      name: o,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(j.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const n = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(j.PAREN_L, n, j.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const n = this._lexer.token, r = this.parseName();
    return this.expectToken(j.COLON), this.node(n, {
      kind: fe.ARGUMENT,
      name: r,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(j.SPREAD);
    const n = this.expectOptionalKeyword("on");
    return !n && this.peek(j.NAME) ? this.node(t, {
      kind: fe.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: fe.INLINE_FRAGMENT,
      typeCondition: n ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: fe.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: fe.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const n = this._lexer.token;
    switch (n.kind) {
      case j.BRACKET_L:
        return this.parseList(t);
      case j.BRACE_L:
        return this.parseObject(t);
      case j.INT:
        return this.advanceLexer(), this.node(n, {
          kind: fe.INT,
          value: n.value
        });
      case j.FLOAT:
        return this.advanceLexer(), this.node(n, {
          kind: fe.FLOAT,
          value: n.value
        });
      case j.STRING:
      case j.BLOCK_STRING:
        return this.parseStringLiteral();
      case j.NAME:
        switch (this.advanceLexer(), n.value) {
          case "true":
            return this.node(n, {
              kind: fe.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(n, {
              kind: fe.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(n, {
              kind: fe.NULL
            });
          default:
            return this.node(n, {
              kind: fe.ENUM,
              value: n.value
            });
        }
      case j.DOLLAR:
        if (t)
          if (this.expectToken(j.DOLLAR), this._lexer.token.kind === j.NAME) {
            const r = this._lexer.token.value;
            throw tt(
              this._lexer.source,
              n.start,
              `Unexpected variable "$${r}" in constant value.`
            );
          } else
            throw this.unexpected(n);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: fe.STRING,
      value: t.value,
      block: t.kind === j.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const n = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: fe.LIST,
      values: this.any(j.BRACKET_L, n, j.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const n = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: fe.OBJECT,
      fields: this.any(j.BRACE_L, n, j.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const n = this._lexer.token, r = this.parseName();
    return this.expectToken(j.COLON), this.node(n, {
      kind: fe.OBJECT_FIELD,
      name: r,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const n = [];
    for (; this.peek(j.AT); )
      n.push(this.parseDirective(t));
    return n;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const n = this._lexer.token;
    return this.expectToken(j.AT), this.node(n, {
      kind: fe.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let n;
    if (this.expectOptionalToken(j.BRACKET_L)) {
      const r = this.parseTypeReference();
      this.expectToken(j.BRACKET_R), n = this.node(t, {
        kind: fe.LIST_TYPE,
        type: r
      });
    } else
      n = this.parseNamedType();
    return this.expectOptionalToken(j.BANG) ? this.node(t, {
      kind: fe.NON_NULL_TYPE,
      type: n
    }) : n;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: fe.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(j.STRING) || this.peek(j.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("schema");
    const r = this.parseConstDirectives(), o = this.many(
      j.BRACE_L,
      this.parseOperationTypeDefinition,
      j.BRACE_R
    );
    return this.node(t, {
      kind: fe.SCHEMA_DEFINITION,
      description: n,
      directives: r,
      operationTypes: o
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, n = this.parseOperationType();
    this.expectToken(j.COLON);
    const r = this.parseNamedType();
    return this.node(t, {
      kind: fe.OPERATION_TYPE_DEFINITION,
      operation: n,
      type: r
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("scalar");
    const r = this.parseName(), o = this.parseConstDirectives();
    return this.node(t, {
      kind: fe.SCALAR_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: o
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("type");
    const r = this.parseName(), o = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(t, {
      kind: fe.OBJECT_TYPE_DEFINITION,
      description: n,
      name: r,
      interfaces: o,
      directives: i,
      fields: s
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(j.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      j.BRACE_L,
      this.parseFieldDefinition,
      j.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, n = this.parseDescription(), r = this.parseName(), o = this.parseArgumentDefs();
    this.expectToken(j.COLON);
    const i = this.parseTypeReference(), s = this.parseConstDirectives();
    return this.node(t, {
      kind: fe.FIELD_DEFINITION,
      description: n,
      name: r,
      arguments: o,
      type: i,
      directives: s
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      j.PAREN_L,
      this.parseInputValueDef,
      j.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, n = this.parseDescription(), r = this.parseName();
    this.expectToken(j.COLON);
    const o = this.parseTypeReference();
    let i;
    this.expectOptionalToken(j.EQUALS) && (i = this.parseConstValueLiteral());
    const s = this.parseConstDirectives();
    return this.node(t, {
      kind: fe.INPUT_VALUE_DEFINITION,
      description: n,
      name: r,
      type: o,
      defaultValue: i,
      directives: s
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("interface");
    const r = this.parseName(), o = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    return this.node(t, {
      kind: fe.INTERFACE_TYPE_DEFINITION,
      description: n,
      name: r,
      interfaces: o,
      directives: i,
      fields: s
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("union");
    const r = this.parseName(), o = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: fe.UNION_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: o,
      types: i
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(j.EQUALS) ? this.delimitedMany(j.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("enum");
    const r = this.parseName(), o = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: fe.ENUM_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: o,
      values: i
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      j.BRACE_L,
      this.parseEnumValueDefinition,
      j.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, n = this.parseDescription(), r = this.parseEnumValueName(), o = this.parseConstDirectives();
    return this.node(t, {
      kind: fe.ENUM_VALUE_DEFINITION,
      description: n,
      name: r,
      directives: o
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw tt(
        this._lexer.source,
        this._lexer.token.start,
        `${Ds(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("input");
    const r = this.parseName(), o = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: fe.INPUT_OBJECT_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: o,
      fields: i
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      j.BRACE_L,
      this.parseInputValueDef,
      j.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === j.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const n = this.parseConstDirectives(), r = this.optionalMany(
      j.BRACE_L,
      this.parseOperationTypeDefinition,
      j.BRACE_R
    );
    if (n.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.SCHEMA_EXTENSION,
      directives: n,
      operationTypes: r
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const n = this.parseName(), r = this.parseConstDirectives();
    if (r.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.SCALAR_TYPE_EXTENSION,
      name: n,
      directives: r
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), i = this.parseFieldsDefinition();
    if (r.length === 0 && o.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.OBJECT_TYPE_EXTENSION,
      name: n,
      interfaces: r,
      directives: o,
      fields: i
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), i = this.parseFieldsDefinition();
    if (r.length === 0 && o.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.INTERFACE_TYPE_EXTENSION,
      name: n,
      interfaces: r,
      directives: o,
      fields: i
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const n = this.parseName(), r = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    if (r.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.UNION_TYPE_EXTENSION,
      name: n,
      directives: r,
      types: o
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const n = this.parseName(), r = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    if (r.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.ENUM_TYPE_EXTENSION,
      name: n,
      directives: r,
      values: o
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const n = this.parseName(), r = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    if (r.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: fe.INPUT_OBJECT_TYPE_EXTENSION,
      name: n,
      directives: r,
      fields: o
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(j.AT);
    const r = this.parseName(), o = this.parseArgumentDefs(), i = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const s = this.parseDirectiveLocations();
    return this.node(t, {
      kind: fe.DIRECTIVE_DEFINITION,
      description: n,
      name: r,
      arguments: o,
      repeatable: i,
      locations: s
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(j.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, n = this.parseName();
    if (Object.prototype.hasOwnProperty.call(Al, n.value))
      return n;
    throw this.unexpected(t);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, n) {
    return this._options.noLocation !== !0 && (n.loc = new AS(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), n;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const n = this._lexer.token;
    if (n.kind === t)
      return this.advanceLexer(), n;
    throw tt(
      this._lexer.source,
      n.start,
      `Expected ${hg(t)}, found ${Ds(n)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const n = this._lexer.token;
    if (n.kind === j.NAME && n.value === t)
      this.advanceLexer();
    else
      throw tt(
        this._lexer.source,
        n.start,
        `Expected "${t}", found ${Ds(n)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const n = this._lexer.token;
    return n.kind === j.NAME && n.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const n = t ?? this._lexer.token;
    return tt(
      this._lexer.source,
      n.start,
      `Unexpected ${Ds(n)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, n, r) {
    this.expectToken(t);
    const o = [];
    for (; !this.expectOptionalToken(r); )
      o.push(n.call(this));
    return o;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, n, r) {
    if (this.expectOptionalToken(t)) {
      const o = [];
      do
        o.push(n.call(this));
      while (!this.expectOptionalToken(r));
      return o;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, n, r) {
    this.expectToken(t);
    const o = [];
    do
      o.push(n.call(this));
    while (!this.expectOptionalToken(r));
    return o;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, n) {
    this.expectOptionalToken(t);
    const r = [];
    do
      r.push(n.call(this));
    while (this.expectOptionalToken(t));
    return r;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, n = this._lexer.advance();
    if (t !== void 0 && n.kind !== j.EOF && (++this._tokenCounter, this._tokenCounter > t))
      throw tt(
        this._lexer.source,
        n.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
}
function Ds(e) {
  const t = e.value;
  return hg(e.kind) + (t != null ? ` "${t}"` : "");
}
function hg(e) {
  return vS(e) ? `"${e}"` : e;
}
function XS(e) {
  return `"${e.replace(WS, ZS)}"`;
}
const WS = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function ZS(e) {
  return zS[e.charCodeAt(0)];
}
const zS = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], GS = Object.freeze({});
function jS(e, t, n = ag) {
  const r = /* @__PURE__ */ new Map();
  for (const b of Object.values(fe))
    r.set(b, US(t, b));
  let o, i = Array.isArray(e), s = [e], a = -1, c = [], u = e, l, d;
  const f = [], p = [];
  do {
    a++;
    const b = a === s.length, v = b && c.length !== 0;
    if (b) {
      if (l = p.length === 0 ? void 0 : f[f.length - 1], u = d, d = p.pop(), v)
        if (i) {
          u = u.slice();
          let w = 0;
          for (const [y, I] of c) {
            const x = y - w;
            I === null ? (u.splice(x, 1), w++) : u[x] = I;
          }
        } else {
          u = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(u)
          );
          for (const [w, y] of c)
            u[w] = y;
        }
      a = o.index, s = o.keys, c = o.edits, i = o.inArray, o = o.prev;
    } else if (d) {
      if (l = i ? a : s[a], u = d[l], u == null)
        continue;
      f.push(l);
    }
    let C;
    if (!Array.isArray(u)) {
      var h, g;
      $1(u) || Us(!1, `Invalid AST Node: ${jd(u)}.`);
      const w = b ? (h = r.get(u.kind)) === null || h === void 0 ? void 0 : h.leave : (g = r.get(u.kind)) === null || g === void 0 ? void 0 : g.enter;
      if (C = w == null ? void 0 : w.call(t, u, l, d, f, p), C === GS)
        break;
      if (C === !1) {
        if (!b) {
          f.pop();
          continue;
        }
      } else if (C !== void 0 && (c.push([l, C]), !b))
        if ($1(C))
          u = C;
        else {
          f.pop();
          continue;
        }
    }
    if (C === void 0 && v && c.push([l, u]), b)
      f.pop();
    else {
      var m;
      o = {
        inArray: i,
        index: a,
        keys: s,
        edits: c,
        prev: o
      }, i = Array.isArray(u), s = i ? u : (m = n[u.kind]) !== null && m !== void 0 ? m : [], a = -1, c = [], d && p.push(d), d = u;
    }
  } while (o !== void 0);
  return c.length !== 0 ? c[c.length - 1][1] : e;
}
function US(e, t) {
  const n = e[t];
  return typeof n == "object" ? n : typeof n == "function" ? {
    enter: n,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function QS(e) {
  return jS(e, YS);
}
const qS = 80, YS = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => se(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = Se("(", se(e.variableDefinitions, ", "), ")"), n = se(
        [
          e.operation,
          se([e.name, t]),
          se(e.directives, " ")
        ],
        " "
      );
      return (n === "query" ? "" : n + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: n, directives: r }) => e + ": " + t + Se(" = ", n) + Se(" ", se(r, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => kt(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: n, directives: r, selectionSet: o }) {
      const i = Se("", e, ": ") + t;
      let s = i + Se("(", se(n, ", "), ")");
      return s.length > qS && (s = i + Se(`(
`, Qs(se(n, `
`)), `
)`)), se([s, se(r, " "), o], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + Se(" ", se(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: n }) => se(
      [
        "...",
        Se("on ", e),
        se(t, " "),
        n
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: e, typeCondition: t, variableDefinitions: n, directives: r, selectionSet: o }) => (
      // or removed in the future.
      `fragment ${e}${Se("(", se(n, ", "), ")")} on ${t} ${Se("", se(r, " "), " ")}` + o
    )
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? gS(e) : XS(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + se(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + se(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + Se("(", se(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: n }) => Se("", e, `
`) + se(["schema", se(t, " "), kt(n)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: n }) => Se("", e, `
`) + se(["scalar", t, se(n, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: n, directives: r, fields: o }) => Se("", e, `
`) + se(
      [
        "type",
        t,
        Se("implements ", se(n, " & ")),
        se(r, " "),
        kt(o)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: n, type: r, directives: o }) => Se("", e, `
`) + t + (tf(n) ? Se(`(
`, Qs(se(n, `
`)), `
)`) : Se("(", se(n, ", "), ")")) + ": " + r + Se(" ", se(o, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: n, defaultValue: r, directives: o }) => Se("", e, `
`) + se(
      [t + ": " + n, Se("= ", r), se(o, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: n, directives: r, fields: o }) => Se("", e, `
`) + se(
      [
        "interface",
        t,
        Se("implements ", se(n, " & ")),
        se(r, " "),
        kt(o)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: n, types: r }) => Se("", e, `
`) + se(
      ["union", t, se(n, " "), Se("= ", se(r, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: n, values: r }) => Se("", e, `
`) + se(["enum", t, se(n, " "), kt(r)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: n }) => Se("", e, `
`) + se([t, se(n, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: n, fields: r }) => Se("", e, `
`) + se(["input", t, se(n, " "), kt(r)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: n, repeatable: r, locations: o }) => Se("", e, `
`) + "directive @" + t + (tf(n) ? Se(`(
`, Qs(se(n, `
`)), `
)`) : Se("(", se(n, ", "), ")")) + (r ? " repeatable" : "") + " on " + se(o, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => se(
      ["extend schema", se(e, " "), kt(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => se(["extend scalar", e, se(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: n, fields: r }) => se(
      [
        "extend type",
        e,
        Se("implements ", se(t, " & ")),
        se(n, " "),
        kt(r)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: n, fields: r }) => se(
      [
        "extend interface",
        e,
        Se("implements ", se(t, " & ")),
        se(n, " "),
        kt(r)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: n }) => se(
      [
        "extend union",
        e,
        se(t, " "),
        Se("= ", se(n, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: n }) => se(["extend enum", e, se(t, " "), kt(n)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: n }) => se(["extend input", e, se(t, " "), kt(n)], " ")
  }
};
function se(e, t = "") {
  var n;
  return (n = e == null ? void 0 : e.filter((r) => r).join(t)) !== null && n !== void 0 ? n : "";
}
function kt(e) {
  return Se(`{
`, Qs(se(e, `
`)), `
}`);
}
function Se(e, t, n = "") {
  return t != null && t !== "" ? e + t + n : "";
}
function Qs(e) {
  return Se("  ", e.replace(/\n/g, `
  `));
}
function tf(e) {
  var t;
  return (t = e == null ? void 0 : e.some((n) => n.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
const nf = (e) => {
  var r, o;
  let t;
  const n = e.definitions.filter((i) => i.kind === "OperationDefinition");
  return n.length === 1 && (t = (o = (r = n[0]) == null ? void 0 : r.name) == null ? void 0 : o.value), t;
}, Qc = (e) => {
  if (typeof e == "string") {
    let n;
    try {
      const r = LS(e);
      n = nf(r);
    } catch {
    }
    return { query: e, operationName: n };
  }
  const t = nf(e);
  return { query: QS(e), operationName: t };
};
class ui extends Error {
  constructor(t, n) {
    const r = `${ui.extractMessage(t)}: ${JSON.stringify({
      response: t,
      request: n
    })}`;
    super(r), Object.setPrototypeOf(this, ui.prototype), this.response = t, this.request = n, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, ui);
  }
  static extractMessage(t) {
    var n, r;
    return ((r = (n = t.errors) == null ? void 0 : n[0]) == null ? void 0 : r.message) ?? `GraphQL Error (Code: ${t.status})`;
  }
}
var hl = { exports: {} };
(function(e, t) {
  var n = typeof self < "u" ? self : ri, r = function() {
    function i() {
      this.fetch = !1, this.DOMException = n.DOMException;
    }
    return i.prototype = n, new i();
  }();
  (function(i) {
    (function(s) {
      var a = {
        searchParams: "URLSearchParams" in i,
        iterable: "Symbol" in i && "iterator" in Symbol,
        blob: "FileReader" in i && "Blob" in i && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in i,
        arrayBuffer: "ArrayBuffer" in i
      };
      function c(N) {
        return N && DataView.prototype.isPrototypeOf(N);
      }
      if (a.arrayBuffer)
        var u = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], l = ArrayBuffer.isView || function(N) {
          return N && u.indexOf(Object.prototype.toString.call(N)) > -1;
        };
      function d(N) {
        if (typeof N != "string" && (N = String(N)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(N))
          throw new TypeError("Invalid character in header field name");
        return N.toLowerCase();
      }
      function f(N) {
        return typeof N != "string" && (N = String(N)), N;
      }
      function p(N) {
        var M = {
          next: function() {
            var F = N.shift();
            return { done: F === void 0, value: F };
          }
        };
        return a.iterable && (M[Symbol.iterator] = function() {
          return M;
        }), M;
      }
      function h(N) {
        this.map = {}, N instanceof h ? N.forEach(function(M, F) {
          this.append(F, M);
        }, this) : Array.isArray(N) ? N.forEach(function(M) {
          this.append(M[0], M[1]);
        }, this) : N && Object.getOwnPropertyNames(N).forEach(function(M) {
          this.append(M, N[M]);
        }, this);
      }
      h.prototype.append = function(N, M) {
        N = d(N), M = f(M);
        var F = this.map[N];
        this.map[N] = F ? F + ", " + M : M;
      }, h.prototype.delete = function(N) {
        delete this.map[d(N)];
      }, h.prototype.get = function(N) {
        return N = d(N), this.has(N) ? this.map[N] : null;
      }, h.prototype.has = function(N) {
        return this.map.hasOwnProperty(d(N));
      }, h.prototype.set = function(N, M) {
        this.map[d(N)] = f(M);
      }, h.prototype.forEach = function(N, M) {
        for (var F in this.map)
          this.map.hasOwnProperty(F) && N.call(M, this.map[F], F, this);
      }, h.prototype.keys = function() {
        var N = [];
        return this.forEach(function(M, F) {
          N.push(F);
        }), p(N);
      }, h.prototype.values = function() {
        var N = [];
        return this.forEach(function(M) {
          N.push(M);
        }), p(N);
      }, h.prototype.entries = function() {
        var N = [];
        return this.forEach(function(M, F) {
          N.push([F, M]);
        }), p(N);
      }, a.iterable && (h.prototype[Symbol.iterator] = h.prototype.entries);
      function g(N) {
        if (N.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        N.bodyUsed = !0;
      }
      function m(N) {
        return new Promise(function(M, F) {
          N.onload = function() {
            M(N.result);
          }, N.onerror = function() {
            F(N.error);
          };
        });
      }
      function b(N) {
        var M = new FileReader(), F = m(M);
        return M.readAsArrayBuffer(N), F;
      }
      function v(N) {
        var M = new FileReader(), F = m(M);
        return M.readAsText(N), F;
      }
      function C(N) {
        for (var M = new Uint8Array(N), F = new Array(M.length), B = 0; B < M.length; B++)
          F[B] = String.fromCharCode(M[B]);
        return F.join("");
      }
      function w(N) {
        if (N.slice)
          return N.slice(0);
        var M = new Uint8Array(N.byteLength);
        return M.set(new Uint8Array(N)), M.buffer;
      }
      function y() {
        return this.bodyUsed = !1, this._initBody = function(N) {
          this._bodyInit = N, N ? typeof N == "string" ? this._bodyText = N : a.blob && Blob.prototype.isPrototypeOf(N) ? this._bodyBlob = N : a.formData && FormData.prototype.isPrototypeOf(N) ? this._bodyFormData = N : a.searchParams && URLSearchParams.prototype.isPrototypeOf(N) ? this._bodyText = N.toString() : a.arrayBuffer && a.blob && c(N) ? (this._bodyArrayBuffer = w(N.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : a.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(N) || l(N)) ? this._bodyArrayBuffer = w(N) : this._bodyText = N = Object.prototype.toString.call(N) : this._bodyText = "", this.headers.get("content-type") || (typeof N == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : a.searchParams && URLSearchParams.prototype.isPrototypeOf(N) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, a.blob && (this.blob = function() {
          var N = g(this);
          if (N)
            return N;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? g(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(b);
        }), this.text = function() {
          var N = g(this);
          if (N)
            return N;
          if (this._bodyBlob)
            return v(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(C(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, a.formData && (this.formData = function() {
          return this.text().then(P);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var I = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function x(N) {
        var M = N.toUpperCase();
        return I.indexOf(M) > -1 ? M : N;
      }
      function E(N, M) {
        M = M || {};
        var F = M.body;
        if (N instanceof E) {
          if (N.bodyUsed)
            throw new TypeError("Already read");
          this.url = N.url, this.credentials = N.credentials, M.headers || (this.headers = new h(N.headers)), this.method = N.method, this.mode = N.mode, this.signal = N.signal, !F && N._bodyInit != null && (F = N._bodyInit, N.bodyUsed = !0);
        } else
          this.url = String(N);
        if (this.credentials = M.credentials || this.credentials || "same-origin", (M.headers || !this.headers) && (this.headers = new h(M.headers)), this.method = x(M.method || this.method || "GET"), this.mode = M.mode || this.mode || null, this.signal = M.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && F)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(F);
      }
      E.prototype.clone = function() {
        return new E(this, { body: this._bodyInit });
      };
      function P(N) {
        var M = new FormData();
        return N.trim().split("&").forEach(function(F) {
          if (F) {
            var B = F.split("="), Z = B.shift().replace(/\+/g, " "), H = B.join("=").replace(/\+/g, " ");
            M.append(decodeURIComponent(Z), decodeURIComponent(H));
          }
        }), M;
      }
      function L(N) {
        var M = new h(), F = N.replace(/\r?\n[\t ]+/g, " ");
        return F.split(/\r?\n/).forEach(function(B) {
          var Z = B.split(":"), H = Z.shift().trim();
          if (H) {
            var K = Z.join(":").trim();
            M.append(H, K);
          }
        }), M;
      }
      y.call(E.prototype);
      function W(N, M) {
        M || (M = {}), this.type = "default", this.status = M.status === void 0 ? 200 : M.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in M ? M.statusText : "OK", this.headers = new h(M.headers), this.url = M.url || "", this._initBody(N);
      }
      y.call(W.prototype), W.prototype.clone = function() {
        return new W(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new h(this.headers),
          url: this.url
        });
      }, W.error = function() {
        var N = new W(null, { status: 0, statusText: "" });
        return N.type = "error", N;
      };
      var V = [301, 302, 303, 307, 308];
      W.redirect = function(N, M) {
        if (V.indexOf(M) === -1)
          throw new RangeError("Invalid status code");
        return new W(null, { status: M, headers: { location: N } });
      }, s.DOMException = i.DOMException;
      try {
        new s.DOMException();
      } catch {
        s.DOMException = function(M, F) {
          this.message = M, this.name = F;
          var B = Error(M);
          this.stack = B.stack;
        }, s.DOMException.prototype = Object.create(Error.prototype), s.DOMException.prototype.constructor = s.DOMException;
      }
      function X(N, M) {
        return new Promise(function(F, B) {
          var Z = new E(N, M);
          if (Z.signal && Z.signal.aborted)
            return B(new s.DOMException("Aborted", "AbortError"));
          var H = new XMLHttpRequest();
          function K() {
            H.abort();
          }
          H.onload = function() {
            var ee = {
              status: H.status,
              statusText: H.statusText,
              headers: L(H.getAllResponseHeaders() || "")
            };
            ee.url = "responseURL" in H ? H.responseURL : ee.headers.get("X-Request-URL");
            var z = "response" in H ? H.response : H.responseText;
            F(new W(z, ee));
          }, H.onerror = function() {
            B(new TypeError("Network request failed"));
          }, H.ontimeout = function() {
            B(new TypeError("Network request failed"));
          }, H.onabort = function() {
            B(new s.DOMException("Aborted", "AbortError"));
          }, H.open(Z.method, Z.url, !0), Z.credentials === "include" ? H.withCredentials = !0 : Z.credentials === "omit" && (H.withCredentials = !1), "responseType" in H && a.blob && (H.responseType = "blob"), Z.headers.forEach(function(ee, z) {
            H.setRequestHeader(z, ee);
          }), Z.signal && (Z.signal.addEventListener("abort", K), H.onreadystatechange = function() {
            H.readyState === 4 && Z.signal.removeEventListener("abort", K);
          }), H.send(typeof Z._bodyInit > "u" ? null : Z._bodyInit);
        });
      }
      return X.polyfill = !0, i.fetch || (i.fetch = X, i.Headers = h, i.Request = E, i.Response = W), s.Headers = h, s.Request = E, s.Response = W, s.fetch = X, Object.defineProperty(s, "__esModule", { value: !0 }), s;
    })({});
  })(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
  var o = r;
  t = o.fetch, t.default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e.exports = t;
})(hl, hl.exports);
var ya = hl.exports;
const qs = /* @__PURE__ */ Do(ya), JS = /* @__PURE__ */ Q3({
  __proto__: null,
  default: qs
}, [ya]), zr = (e) => {
  let t = {};
  return e && (typeof Headers < "u" && e instanceof Headers || JS && ya.Headers && e instanceof ya.Headers ? t = rS(e) : Array.isArray(e) ? e.forEach(([n, r]) => {
    n && r !== void 0 && (t[n] = r);
  }) : t = e), t;
}, rf = (e) => e.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), KS = (e) => {
  if (!Array.isArray(e.query)) {
    const r = e, o = [`query=${encodeURIComponent(rf(r.query))}`];
    return e.variables && o.push(`variables=${encodeURIComponent(r.jsonSerializer.stringify(r.variables))}`), r.operationName && o.push(`operationName=${encodeURIComponent(r.operationName)}`), o.join("&");
  }
  if (typeof e.variables < "u" && !Array.isArray(e.variables))
    throw new Error("Cannot create query with given variable type, array expected");
  const t = e, n = e.query.reduce((r, o, i) => (r.push({
    query: rf(o),
    variables: t.variables ? t.jsonSerializer.stringify(t.variables[i]) : void 0
  }), r), []);
  return `query=${encodeURIComponent(t.jsonSerializer.stringify(n))}`;
}, _S = (e) => async (t) => {
  const { url: n, query: r, variables: o, operationName: i, fetch: s, fetchOptions: a, middleware: c } = t, u = { ...t.headers };
  let l = "", d;
  e === "POST" ? (d = eT(r, o, i, a.jsonSerializer), typeof d == "string" && (u["Content-Type"] = "application/json")) : l = KS({
    query: r,
    variables: o,
    operationName: i,
    jsonSerializer: a.jsonSerializer ?? zd
  });
  const f = {
    method: e,
    headers: u,
    body: d,
    ...a
  };
  let p = n, h = f;
  if (c) {
    const g = await Promise.resolve(c({ ...f, url: n, operationName: i, variables: o })), { url: m, ...b } = g;
    p = m, h = b;
  }
  return l && (p = `${p}?${l}`), await s(p, h);
};
class $S {
  constructor(t, n = {}) {
    this.url = t, this.requestConfig = n, this.rawRequest = async (...r) => {
      const [o, i, s] = r, a = iS(o, i, s), { headers: c, fetch: u = qs, method: l = "POST", requestMiddleware: d, responseMiddleware: f, ...p } = this.requestConfig, { url: h } = this;
      a.signal !== void 0 && (p.signal = a.signal);
      const { operationName: g } = Qc(a.query);
      return qc({
        url: h,
        query: a.query,
        variables: a.variables,
        headers: {
          ...zr(Yc(c)),
          ...zr(a.requestHeaders)
        },
        operationName: g,
        fetch: u,
        method: l,
        fetchOptions: p,
        middleware: d
      }).then((m) => (f && f(m), m)).catch((m) => {
        throw f && f(m), m;
      });
    };
  }
  async request(t, ...n) {
    const [r, o] = n, i = oS(t, r, o), { headers: s, fetch: a = qs, method: c = "POST", requestMiddleware: u, responseMiddleware: l, ...d } = this.requestConfig, { url: f } = this;
    i.signal !== void 0 && (d.signal = i.signal);
    const { query: p, operationName: h } = Qc(i.document);
    return qc({
      url: f,
      query: p,
      variables: i.variables,
      headers: {
        ...zr(Yc(s)),
        ...zr(i.requestHeaders)
      },
      operationName: h,
      fetch: a,
      method: c,
      fetchOptions: d,
      middleware: u
    }).then((g) => (l && l(g), g.data)).catch((g) => {
      throw l && l(g), g;
    });
  }
  // prettier-ignore
  batchRequests(t, n) {
    const r = sS(t, n), { headers: o, ...i } = this.requestConfig;
    r.signal !== void 0 && (i.signal = r.signal);
    const s = r.documents.map(({ document: c }) => Qc(c).query), a = r.documents.map(({ variables: c }) => c);
    return qc({
      url: this.url,
      query: s,
      // @ts-expect-error TODO reconcile batch variables into system.
      variables: a,
      headers: {
        ...zr(Yc(o)),
        ...zr(r.requestHeaders)
      },
      operationName: void 0,
      fetch: this.requestConfig.fetch ?? qs,
      method: this.requestConfig.method || "POST",
      fetchOptions: i,
      middleware: this.requestConfig.requestMiddleware
    }).then((c) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(c), c.data)).catch((c) => {
      throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(c), c;
    });
  }
  setHeaders(t) {
    return this.requestConfig.headers = t, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(t, n) {
    const { headers: r } = this.requestConfig;
    return r ? r[t] = n : this.requestConfig.headers = { [t]: n }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(t) {
    return this.url = t, this;
  }
}
const qc = async (e) => {
  const { query: t, variables: n, fetchOptions: r } = e, o = _S(nS(e.method ?? "post")), i = Array.isArray(e.query), s = await o(e), a = await tT(s, r.jsonSerializer ?? zd), c = Array.isArray(a) ? !a.some(({ data: l }) => !l) : !!a.data, u = Array.isArray(a) || !a.errors || Array.isArray(a.errors) && !a.errors.length || r.errorPolicy === "all" || r.errorPolicy === "ignore";
  if (s.ok && u && c) {
    const { errors: l, ...d } = (Array.isArray(a), a), f = r.errorPolicy === "ignore" ? d : a;
    return {
      ...i ? { data: f } : f,
      headers: s.headers,
      status: s.status
    };
  } else {
    const l = typeof a == "string" ? {
      error: a
    } : a;
    throw new ui(
      // @ts-expect-error TODO
      { ...l, status: s.status, headers: s.headers },
      { query: t, variables: n }
    );
  }
}, eT = (e, t, n, r) => {
  const o = r ?? zd;
  if (!Array.isArray(e))
    return o.stringify({ query: e, variables: t, operationName: n });
  if (typeof t < "u" && !Array.isArray(t))
    throw new Error("Cannot create request body with given variable type, array expected");
  const i = e.reduce((s, a, c) => (s.push({ query: a, variables: t ? t[c] : void 0 }), s), []);
  return o.stringify(i);
}, tT = async (e, t) => {
  let n;
  return e.headers.forEach((r, o) => {
    o.toLowerCase() === "content-type" && (n = r);
  }), n && (n.toLowerCase().startsWith("application/json") || n.toLowerCase().startsWith("application/graphql+json") || n.toLowerCase().startsWith("application/graphql-response+json")) ? t.parse(await e.text()) : e.text();
}, Yc = (e) => typeof e == "function" ? e() : e, nT = (e, ...t) => e.reduce((n, r, o) => `${n}${r}${o in t ? String(t[o]) : ""}`, "");
async function rT(...e) {
  const [t, ...n] = e;
  return new $S(t, { fetch }).request(...n);
}
async function oT(e) {
  let t;
  try {
    t = (await rT(
      e,
      nT`
                query getDrive {
                    drive {
                        id
                        name
                        icon
                        slug
                    }
                }
            `
    )).drive;
  } catch (n) {
    throw console.error(n), new Error("Couldn't find drive info");
  }
  if (!t)
    throw new Error("Drive not found");
  return t;
}
var iT = "Expected a function", of = NaN, sT = "[object Symbol]", aT = /^\s+|\s+$/g, cT = /^[-+]0x[0-9a-f]+$/i, uT = /^0b[01]+$/i, lT = /^0o[0-7]+$/i, dT = parseInt, AT = typeof ri == "object" && ri && ri.Object === Object && ri, fT = typeof self == "object" && self && self.Object === Object && self, hT = AT || fT || Function("return this")(), pT = Object.prototype, mT = pT.toString, gT = Math.max, bT = Math.min, Jc = function() {
  return hT.Date.now();
};
function vT(e, t, n) {
  var r, o, i, s, a, c, u = 0, l = !1, d = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(iT);
  t = sf(t) || 0, pl(n) && (l = !!n.leading, d = "maxWait" in n, i = d ? gT(sf(n.maxWait) || 0, t) : i, f = "trailing" in n ? !!n.trailing : f);
  function p(I) {
    var x = r, E = o;
    return r = o = void 0, u = I, s = e.apply(E, x), s;
  }
  function h(I) {
    return u = I, a = setTimeout(b, t), l ? p(I) : s;
  }
  function g(I) {
    var x = I - c, E = I - u, P = t - x;
    return d ? bT(P, i - E) : P;
  }
  function m(I) {
    var x = I - c, E = I - u;
    return c === void 0 || x >= t || x < 0 || d && E >= i;
  }
  function b() {
    var I = Jc();
    if (m(I))
      return v(I);
    a = setTimeout(b, g(I));
  }
  function v(I) {
    return a = void 0, f && r ? p(I) : (r = o = void 0, s);
  }
  function C() {
    a !== void 0 && clearTimeout(a), u = 0, r = c = o = a = void 0;
  }
  function w() {
    return a === void 0 ? s : v(Jc());
  }
  function y() {
    var I = Jc(), x = m(I);
    if (r = arguments, o = this, c = I, x) {
      if (a === void 0)
        return h(c);
      if (d)
        return a = setTimeout(b, t), p(c);
    }
    return a === void 0 && (a = setTimeout(b, t)), s;
  }
  return y.cancel = C, y.flush = w, y;
}
function pl(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function yT(e) {
  return !!e && typeof e == "object";
}
function CT(e) {
  return typeof e == "symbol" || yT(e) && mT.call(e) == sT;
}
function sf(e) {
  if (typeof e == "number")
    return e;
  if (CT(e))
    return of;
  if (pl(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = pl(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(aT, "");
  var n = uT.test(e);
  return n || lT.test(e) ? dT(e.slice(2), n ? 2 : 8) : cT.test(e) ? of : +e;
}
var xT = vT;
const af = /* @__PURE__ */ Do(xT);
var wT = typeof window < "u" ? Yn : Ie;
function pg(e, t, n, r) {
  const o = Ce(t);
  wT(() => {
    o.current = t;
  }, [t]), Ie(() => {
    const i = window;
    if (!(i && i.addEventListener))
      return;
    const s = (a) => {
      o.current(a);
    };
    return i.addEventListener(e, s, r), () => {
      i.removeEventListener(e, s, r);
    };
  }, [e, n, r]);
}
function Ud() {
  const [e, t] = Q(null), n = ye(async (r) => {
    if (!(navigator != null && navigator.clipboard))
      return console.warn("Clipboard not supported"), !1;
    try {
      return await navigator.clipboard.writeText(r), t(r), !0;
    } catch (o) {
      return console.warn("Copy failed", o), t(null), !1;
    }
  }, []);
  return [e, n];
}
function IT(e) {
  const t = Ce(e);
  t.current = e, Ie(
    () => () => {
      t.current();
    },
    []
  );
}
function ET(e, t = 500, n) {
  const r = Ce();
  IT(() => {
    r.current && r.current.cancel();
  });
  const o = ve(() => {
    const i = af(e, t, n), s = (...a) => i(...a);
    return s.cancel = () => {
      i.cancel();
    }, s.isPending = () => !!r.current, s.flush = () => i.flush(), s;
  }, [e, t, n]);
  return Ie(() => {
    r.current = af(e, t, n);
  }, [e, t, n]), o;
}
function ST(e, t, n) {
  const r = (u, l) => u === l, o = e instanceof Function ? e() : e, [i, s] = Q(o), a = Ce(o), c = ET(
    s,
    t,
    n
  );
  return r(a.current, o) || (c(o), a.current = o), [i, c];
}
function TT(e, t, n = "mousedown", r = {}) {
  pg(
    n,
    (o) => {
      const i = o.target;
      if (!i || !i.isConnected)
        return;
      (Array.isArray(e) ? e.filter((a) => !!a.current).every((a) => a.current && !a.current.contains(i)) : e.current && !e.current.contains(i)) && t(o);
    },
    void 0,
    r
  );
}
function NT(e) {
  const { sharingType: t = Dr } = e, [n, r] = Q(), [o, i] = Q(!1), [s, a] = Q(!0), [c, u] = Q(!1), [l, d] = Q(""), [f, p] = Q(""), [h, g] = ST(f, 500), { register: m, handleSubmit: b, setValue: v } = Qa({
    mode: "onBlur",
    defaultValues: {
      availableOffline: (n == null ? void 0 : n.availableOffline) ?? !1
    }
  });
  Ie(() => {
    g(f);
  }, [f]), Ie(() => {
    if (u(!1), h === "") return;
    w().catch(console.error);
    async function w() {
      try {
        const { id: y, name: I } = await oT(h);
        r({
          id: y,
          name: I,
          sharingType: t,
          location: Zi,
          availableOffline: !0
        }), v("availableOffline", !0), a(!0), d("");
      } catch (y) {
        r(void 0), a(!1), d(y.message);
      }
    }
  }, [h, v, t]);
  function C({ availableOffline: w }) {
    n && e.onSubmit({
      ...n,
      availableOffline: w,
      url: h
    });
  }
  return /* @__PURE__ */ R("form", { onSubmit: b(C), children: [
    /* @__PURE__ */ A(Ca, { htmlFor: "url", children: "Add existing drive" }),
    c ? /* @__PURE__ */ R(Ee, { children: [
      /* @__PURE__ */ A(
        OT,
        {
          driveName: (n == null ? void 0 : n.name) ?? "New drive"
        }
      ),
      /* @__PURE__ */ A(bt, { className: "my-3" }),
      /* @__PURE__ */ R(
        Co,
        {
          title: "Location",
          isOpen: o,
          onOpenChange: () => i(!o),
          children: [
            /* @__PURE__ */ A(qd, { location: Zi }),
            /* @__PURE__ */ A(
              Qd,
              {
                ...m("availableOffline")
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ A(bt, { className: "my-3" }),
      /* @__PURE__ */ A(jt, { type: "submit", color: "dark", className: "mt-4 w-full", children: "Add drive" })
    ] }) : /* @__PURE__ */ R(Ee, { children: [
      /* @__PURE__ */ A(
        os,
        {
          type: "url",
          icon: /* @__PURE__ */ A(J, { name: "BrickGlobe" }),
          value: f,
          placeholder: "Drive URL",
          required: !0,
          onChange: (w) => p(w.target.value),
          errorMessage: l
        }
      ),
      /* @__PURE__ */ A(bt, { className: "mb-3" }),
      /* @__PURE__ */ A(
        jt,
        {
          type: "button",
          color: "light",
          className: "mt-4 w-full",
          onClick: (w) => {
            w.preventDefault(), u(!0);
          },
          disabled: !s || f === "",
          children: "Confirm URL"
        }
      )
    ] })
  ] });
}
function PT(e) {
  const { uiDriveNode: t, onSubmit: n } = e, { name: r, sharingType: o, availableOffline: i } = t, [s, a] = Q(!1), [c, u] = Q(!1), [l, d] = Q(!1), { register: f, handleSubmit: p, control: h } = Qa({
    mode: "onBlur",
    defaultValues: {
      name: r,
      sharingType: o,
      availableOffline: i
    }
  }), g = o === Dr ? Zi : o;
  return /* @__PURE__ */ R("form", { onSubmit: p(n), children: [
    /* @__PURE__ */ A(mg, { ...f("name") }),
    /* @__PURE__ */ A(bt, { className: "my-4" }),
    /* @__PURE__ */ A(Ca, { htmlFor: "sharingType", children: "Sharing settings" }),
    /* @__PURE__ */ A(gg, { control: h }),
    /* @__PURE__ */ A(bt, { className: "my-3" }),
    /* @__PURE__ */ R(
      Co,
      {
        title: "Location",
        isOpen: s,
        onOpenChange: () => a(!s),
        children: [
          /* @__PURE__ */ A(qd, { location: g }),
          /* @__PURE__ */ A(Qd, { ...f("availableOffline") })
        ]
      }
    ),
    /* @__PURE__ */ A(bt, { className: "my-3" }),
    /* @__PURE__ */ A(
      Co,
      {
        title: "Danger zone",
        isOpen: c,
        onOpenChange: () => u(!c),
        children: /* @__PURE__ */ R(
          "button",
          {
            type: "button",
            className: "flex gap-2 py-3 font-semibold text-red-900 transition hover:brightness-125",
            onClick: () => d(!0),
            children: [
              /* @__PURE__ */ A(J, { name: "Trash" }),
              "Delete drive"
            ]
          }
        )
      }
    ),
    l && c ? /* @__PURE__ */ A(
      RT,
      {
        ...e,
        onCancel: () => d(!1)
      }
    ) : /* @__PURE__ */ R(Ee, { children: [
      /* @__PURE__ */ A(bt, { className: "my-3" }),
      /* @__PURE__ */ A(jt, { type: "submit", className: "mb-4 w-full", children: "Confirm" })
    ] })
  ] });
}
const Qd = Pt(
  function(t, n) {
    return /* @__PURE__ */ R("div", { className: "flex items-center rounded-xl bg-gray-100 p-3 text-slate-200", children: [
      /* @__PURE__ */ R("div", { className: "flex-1", children: [
        /* @__PURE__ */ A("label", { htmlFor: "availableOffline", className: "font-semibold", children: "Make available offline" }),
        /* @__PURE__ */ R("p", { className: "text-xs text-gray-500", children: [
          "Check this options if you keep a local backup",
          /* @__PURE__ */ A("br", {}),
          "available at all times."
        ] })
      ] }),
      /* @__PURE__ */ A(aR, { id: "availableOffline", ref: n, ...t })
    ] });
  }
);
function RT(e) {
  const { uiDriveNode: t, handleDeleteDrive: n, onCancel: r } = e, [o, i] = Q(""), s = o === t.name;
  function a() {
    s && n();
  }
  return /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ A("p", { className: "mb-2 rounded-md bg-slate-50 p-4 text-center text-slate-200", children: "Are you sure you want to delete this drive? All files and subfolders within it will be removed. Do you want to proceed?" }),
    /* @__PURE__ */ A(
      mg,
      {
        value: o,
        placeholder: "Enter drive name...",
        onChange: (c) => i(c.target.value),
        icon: /* @__PURE__ */ A(J, { name: "Lock" })
      }
    ),
    /* @__PURE__ */ R("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ A(jt, { onClick: r, color: "light", className: "w-full", children: "Cancel" }),
      /* @__PURE__ */ A(
        jt,
        {
          onClick: a,
          disabled: !s,
          color: "red",
          className: "w-full",
          children: "Delete"
        }
      )
    ] })
  ] });
}
function OT(e) {
  return /* @__PURE__ */ R("div", { className: "flex gap-2 rounded-xl bg-gray-100 p-3 font-semibold text-gray-500", children: [
    /* @__PURE__ */ A(J, { name: "Drive", className: "text-gray-600" }),
    e.driveName
  ] });
}
const mg = Pt(function(t, n) {
  return /* @__PURE__ */ A(
    os,
    {
      ...t,
      ref: n,
      icon: t.icon ?? /* @__PURE__ */ A(J, { name: "Drive" }),
      id: "driveName",
      placeholder: "Drive name"
    }
  );
});
function Ca(e) {
  const { children: t, className: n, ...r } = e;
  return /* @__PURE__ */ A(
    "label",
    {
      ...r,
      className: $(
        "mb-3 block font-semibold text-gray-500",
        n
      ),
      children: t
    }
  );
}
function qd(e) {
  const { location: t, className: n, ...r } = e, o = LR[t];
  return /* @__PURE__ */ R(
    "div",
    {
      ...r,
      className: $(
        "my-3 flex items-center gap-2 rounded-xl border border-gray-100 p-3 text-gray-800 shadow",
        n
      ),
      children: [
        o.icon,
        /* @__PURE__ */ R("div", { children: [
          /* @__PURE__ */ A("p", { children: o.title }),
          /* @__PURE__ */ A("p", { className: "text-xs text-slate-200", children: o.description })
        ] })
      ]
    }
  );
}
function gg(e) {
  const { control: t, ...n } = e;
  return /* @__PURE__ */ A(
    Xd,
    {
      name: "sharingType",
      control: t,
      render: ({ field: r }) => /* @__PURE__ */ A(
        wg,
        {
          ...n,
          ...r,
          id: "sharingType",
          items: kR
        }
      )
    }
  );
}
const os = Pt(function(t, n) {
  const {
    icon: r,
    errorMessage: o,
    isDirty: i,
    containerClassName: s,
    inputClassName: a,
    errorMessageClassName: c,
    hideErrors: u = !1,
    ...l
  } = t, d = t.type ?? "text", f = !!o;
  return /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ R(
      "div",
      {
        className: $(
          "mb-1 flex gap-2 rounded-xl border border-transparent bg-gray-100 p-3 text-gray-800 placeholder:text-gray-500",
          f && "border-red-900",
          s
        ),
        children: [
          /* @__PURE__ */ A(
            "span",
            {
              className: Nr(
                (!i || f) && "text-slate-200"
              ),
              children: r
            }
          ),
          /* @__PURE__ */ A(
            "input",
            {
              ...l,
              type: d,
              ref: n,
              className: $(
                "w-full bg-transparent font-semibold outline-none",
                a
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ A(
      "p",
      {
        className: $(
          "hidden min-h-4 text-xs text-red-900",
          f && "block",
          u && "hidden",
          c
        ),
        children: o
      }
    )
  ] });
});
function FM(e) {
  const { open: t, onOpenChange: n, onSubmit: r, modalProps: o, containerProps: i } = e;
  function s() {
    n(!1);
  }
  return /* @__PURE__ */ A(
    wn,
    {
      ...o,
      open: t,
      onOpenChange: n,
      contentProps: {
        className: "rounded-2xl"
      },
      children: /* @__PURE__ */ R(
        "div",
        {
          ...i,
          className: $(
            "max-w-[408px] rounded-2xl p-6",
            i == null ? void 0 : i.className
          ),
          children: [
            /* @__PURE__ */ R("div", { className: "flex justify-between", children: [
              /* @__PURE__ */ A("h1", { className: "text-xl font-bold", children: "Create new drive " }),
              /* @__PURE__ */ A(
                "button",
                {
                  className: "flex size-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 outline-none hover:text-gray-900",
                  onClick: s,
                  tabIndex: -1,
                  children: /* @__PURE__ */ A(J, { name: "XmarkLight", size: 24 })
                }
              )
            ] }),
            /* @__PURE__ */ A(bt, { className: "my-4" }),
            /* @__PURE__ */ A(
              tS,
              {
                onSubmit: r,
                onCancel: s
              }
            )
          ]
        }
      )
    }
  );
}
function VM(e) {
  const {
    open: t,
    onOpenChange: n,
    onSubmit: r,
    sharingType: o,
    modalProps: i,
    containerProps: s
  } = e;
  function a() {
    n(!1);
  }
  return /* @__PURE__ */ A(
    wn,
    {
      ...i,
      open: t,
      onOpenChange: n,
      contentProps: {
        className: "rounded-2xl"
      },
      children: /* @__PURE__ */ R(
        "div",
        {
          ...s,
          className: $(
            "min-w-[408px] max-w-[408px] rounded-2xl p-6",
            s == null ? void 0 : s.className
          ),
          children: [
            /* @__PURE__ */ R("div", { className: "flex justify-between", children: [
              /* @__PURE__ */ A("h1", { className: "text-xl font-bold", children: "Add drive" }),
              /* @__PURE__ */ A(
                "button",
                {
                  className: "flex size-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 outline-none hover:text-gray-900",
                  onClick: a,
                  tabIndex: -1,
                  children: /* @__PURE__ */ A(J, { name: "XmarkLight", size: 24 })
                }
              )
            ] }),
            /* @__PURE__ */ A(bt, { className: "my-4" }),
            /* @__PURE__ */ A(
              NT,
              {
                sharingType: o,
                onSubmit: r,
                onCancel: a
              }
            )
          ]
        }
      )
    }
  );
}
const cf = "min-h-[48px] min-w-[142px] text-base font-semibold py-3 px-6 rounded-xl outline-none active:opacity-75 hover:scale-105 transform transition-all", bg = (e) => {
  const {
    body: t,
    header: n,
    children: r,
    onCancel: o,
    onOpenChange: i,
    onContinue: s,
    cancelLabel: a,
    continueLabel: c,
    overlayProps: u,
    contentProps: l,
    bodyProps: d = {},
    headerProps: f = {},
    containerProps: p = {},
    cancelButtonProps: h = {},
    continueButtonProps: g = {},
    buttonContainerProps: m = {},
    ...b
  } = e;
  return /* @__PURE__ */ A(
    wn,
    {
      overlayProps: {
        ...u,
        className: $("top-10", u == null ? void 0 : u.className)
      },
      contentProps: {
        ...l,
        className: $("rounded-3xl", l == null ? void 0 : l.className)
      },
      onOpenChange: i,
      ...b,
      children: /* @__PURE__ */ R(
        "div",
        {
          ...gn(
            p,
            "w-[400px] p-6 text-slate-300"
          ),
          children: [
            /* @__PURE__ */ A(
              "div",
              {
                ...gn(
                  f,
                  "border-b border-slate-50 pb-2 text-2xl font-bold text-gray-800"
                ),
                children: n
              }
            ),
            /* @__PURE__ */ R(
              "div",
              {
                ...gn(
                  d,
                  "my-6 rounded-md bg-slate-50 p-4 text-center text-slate-200"
                ),
                children: [
                  t,
                  r
                ]
              }
            ),
            /* @__PURE__ */ R(
              "div",
              {
                ...gn(
                  m,
                  "mt-8 flex justify-between gap-3"
                ),
                children: [
                  /* @__PURE__ */ A(
                    "button",
                    {
                      onClick: o,
                      ...gn(
                        h,
                        $(
                          cf,
                          "flex-1 bg-slate-50 text-slate-800"
                        )
                      ),
                      children: a
                    }
                  ),
                  /* @__PURE__ */ A(
                    "button",
                    {
                      onClick: s,
                      ...gn(
                        g,
                        $(
                          cf,
                          "flex-1 bg-gray-800 text-gray-50"
                        )
                      ),
                      children: c
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    }
  );
}, uf = "min-h-[48px] min-w-[142px] text-base font-semibold py-3 px-6 rounded-xl outline-none active:opacity-75 hover:scale-105 transform transition-all", BM = (e) => {
  const {
    onOpenChange: t,
    onContinue: n,
    overlayProps: r,
    contentProps: o,
    ...i
  } = e, [s, a] = Q("");
  return /* @__PURE__ */ A(
    wn,
    {
      overlayProps: {
        ...r,
        className: $("top-10", r == null ? void 0 : r.className)
      },
      contentProps: {
        ...o,
        className: $("rounded-3xl", o == null ? void 0 : o.className)
      },
      onOpenChange: t,
      ...i,
      children: /* @__PURE__ */ R("div", { className: "w-[400px] p-6 text-slate-300", children: [
        /* @__PURE__ */ A("div", { className: "border-b border-slate-50 pb-2 text-2xl font-bold text-gray-800", children: "Create a new document" }),
        /* @__PURE__ */ A("div", { className: "my-6", children: /* @__PURE__ */ A(
          os,
          {
            icon: /* @__PURE__ */ A(J, { name: "BrickGlobe" }),
            value: s,
            placeholder: "Document name",
            required: !0,
            onChange: (c) => a(c.target.value)
          }
        ) }),
        /* @__PURE__ */ R("div", { className: "mt-8 flex justify-between gap-3", children: [
          /* @__PURE__ */ A(
            "button",
            {
              onClick: () => t == null ? void 0 : t(!1),
              className: $(
                uf,
                "flex-1 bg-slate-50 text-slate-800"
              ),
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ A(
            jt,
            {
              onClick: () => n(s),
              className: $(
                uf,
                "flex-1 bg-gray-800 text-gray-50"
              ),
              children: "Create"
            }
          )
        ] })
      ] })
    }
  );
}, kM = (e) => {
  const { inputPlaceholder: t, body: n, driveName: r, ...o } = e, [i, s] = Q("");
  return /* @__PURE__ */ A(
    bg,
    {
      bodyProps: { className: "p-0 bg-white my-0" },
      containerProps: { className: "w-[450px]" },
      continueButtonProps: {
        disabled: i !== r,
        className: i !== r ? "bg-red-600 hover:scale-100 cursor-not-allowed active:opacity-100" : "bg-red-900"
      },
      ...o,
      children: /* @__PURE__ */ R("div", { children: [
        /* @__PURE__ */ A("div", { className: "my-6 rounded-md bg-slate-50 p-4 text-center text-slate-200", children: n }),
        /* @__PURE__ */ A("div", { children: /* @__PURE__ */ A(
          os,
          {
            value: i,
            icon: /* @__PURE__ */ A(J, { name: "Lock" }),
            placeholder: t,
            onChange: (a) => s(a.target.value),
            hideErrors: !0
          }
        ) })
      ] })
    }
  );
}, LM = (e) => {
  const { onDelete: t, deleteLabel: n, ...r } = e;
  return /* @__PURE__ */ A(
    bg,
    {
      ...r,
      containerProps: { className: "w-[450px]" },
      continueButtonProps: {
        className: "bg-red-900"
      },
      onContinue: t,
      continueLabel: n
    }
  );
};
function HM(e) {
  const {
    uiDriveNode: t,
    open: n,
    onOpenChange: r,
    onDeleteDrive: o,
    onRenameDrive: i,
    onChangeSharingType: s,
    onChangeAvailableOffline: a,
    modalProps: c,
    containerProps: u
  } = e, l = (p) => {
    p.name !== t.name && i(t, p.name), p.sharingType !== t.sharingType && s(t, p.sharingType), p.availableOffline !== t.availableOffline && a(t, p.availableOffline), r(!1);
  };
  function d() {
    o(t), r(!1);
  }
  function f() {
    r(!1);
  }
  return /* @__PURE__ */ A(
    wn,
    {
      ...c,
      open: n,
      onOpenChange: r,
      contentProps: {
        className: "rounded-2xl"
      },
      children: /* @__PURE__ */ R(
        "div",
        {
          ...u,
          className: $(
            "max-w-[408px] rounded-2xl p-6",
            u == null ? void 0 : u.className
          ),
          children: [
            /* @__PURE__ */ R("div", { className: "flex justify-between", children: [
              /* @__PURE__ */ A("h1", { className: "text-xl font-bold", children: "Drive settings" }),
              /* @__PURE__ */ A(
                "button",
                {
                  className: "flex size-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 outline-none hover:text-gray-900",
                  onClick: f,
                  tabIndex: -1,
                  children: /* @__PURE__ */ A(J, { name: "XmarkLight", size: 24 })
                }
              )
            ] }),
            /* @__PURE__ */ A(bt, { className: "my-4" }),
            /* @__PURE__ */ A(
              PT,
              {
                uiDriveNode: t,
                onSubmit: l,
                handleDeleteDrive: d,
                handleCancel: f
              }
            )
          ]
        }
      )
    }
  );
}
const vg = (e) => {
  const { title: t, children: n, description: r, ...o } = e;
  return /* @__PURE__ */ R("div", { ...o, children: [
    t && /* @__PURE__ */ A("h2", { className: "font-semibold", children: t }),
    /* @__PURE__ */ R("div", { className: "flex items-center justify-between gap-x-12 text-sm font-medium", children: [
      /* @__PURE__ */ A("p", { children: r }),
      /* @__PURE__ */ A("div", { children: n })
    ] })
  ] });
}, XM = (e) => {
  const { onClearStorage: t, buttonLabel: n, ...r } = e;
  return /* @__PURE__ */ A(vg, { ...r, children: /* @__PURE__ */ A(
    jt,
    {
      onClick: t,
      iconPosition: "right",
      icon: /* @__PURE__ */ A(J, { name: "Trash", size: 18 }),
      className: "h-auto min-h-9 rounded border border-solid border-gray-300 bg-white px-3 py-0 text-sm text-red-800 hover:border-gray-500 hover:bg-white hover:text-red-900",
      children: n
    }
  ) });
};
function DT(e) {
  if (!e || typeof e != "object")
    throw new Error("Invalid package.json");
  if (!("version" in e))
    throw new Error("Missing version field in package.json");
  if (!("dependencies" in e))
    throw new Error("Missing dependencies field in package.json");
  if (!("devDependencies" in e))
    throw new Error("Missing devDependencies field in package.json");
  if (typeof e.version != "string")
    throw new Error("Invalid version field in package.json");
  if (!e.dependencies || typeof e.dependencies != "object")
    throw new Error("Invalid dependencies field in package.json");
  if (!e.devDependencies || typeof e.devDependencies != "object")
    throw new Error("Invalid devDependencies field in package.json");
  if (!("@powerhousedao/design-system" in e.dependencies) || typeof e.dependencies["@powerhousedao/design-system"] != "string")
    throw new Error("Invalid @powerhousedao/design-system dependency");
  if (!("document-drive" in e.dependencies) || typeof e.dependencies["document-drive"] != "string")
    throw new Error("Invalid document-drive dependency");
  if (!("document-model" in e.dependencies) || typeof e.dependencies["document-model"] != "string")
    throw new Error("Invalid document-model dependency");
  if (!("document-model-libs" in e.dependencies) || typeof e.dependencies["document-model-libs"] != "string")
    throw new Error("Invalid document-model-libs dependency");
}
function WM(e) {
  const [t, n] = Q(!1), { packageJson: r } = e;
  try {
    DT(r);
  } catch (o) {
    return console.error(o), null;
  }
  return /* @__PURE__ */ A(
    Co,
    {
      title: `App version: ${r.version}`,
      isOpen: t,
      onOpenChange: () => n(!t),
      children: /* @__PURE__ */ R("ul", { className: "text-gray-800", children: [
        /* @__PURE__ */ R("li", { className: "my-1 flex justify-between pr-1", children: [
          /* @__PURE__ */ A("span", { children: "design-system:" }),
          /* @__PURE__ */ A("span", { className: "font-medium", children: r.dependencies["@powerhousedao/design-system"] })
        ] }),
        /* @__PURE__ */ R("li", { className: "my-1 flex justify-between pr-1", children: [
          /* @__PURE__ */ A("span", { children: "document-drive:" }),
          " ",
          /* @__PURE__ */ A("span", { className: "font-medium", children: r.dependencies["document-drive"] })
        ] }),
        /* @__PURE__ */ R("li", { className: "my-1 flex justify-between pr-1", children: [
          /* @__PURE__ */ A("span", { children: "document-model:" }),
          " ",
          /* @__PURE__ */ A("span", { className: "font-medium", children: r.dependencies["document-model"] })
        ] }),
        /* @__PURE__ */ R("li", { className: "my-1 flex justify-between pr-1", children: [
          /* @__PURE__ */ A("span", { children: "document-model-libs:" }),
          " ",
          /* @__PURE__ */ A("span", { className: "font-medium", children: r.dependencies["document-model-libs"] })
        ] })
      ] })
    }
  );
}
function MT(e, { insertAt: t } = {}) {
  if (typeof document > "u") return;
  let n = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
  r.type = "text/css", t === "top" && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
}
MT(`.rmsc{--rmsc-main: #4285f4;--rmsc-hover: #f1f3f5;--rmsc-selected: #e2e6ea;--rmsc-border: #ccc;--rmsc-gray: #aaa;--rmsc-bg: #fff;--rmsc-p: 10px;--rmsc-radius: 4px;--rmsc-h: 38px}.rmsc *{box-sizing:border-box;transition:all .2s ease}.rmsc .gray{color:var(--rmsc-gray)}.rmsc .dropdown-content{position:absolute;z-index:1;top:100%;width:100%;padding-top:8px}.rmsc .dropdown-content .panel-content{overflow:hidden;border-radius:var(--rmsc-radius);background:var(--rmsc-bg);box-shadow:0 0 0 1px #0000001a,0 4px 11px #0000001a}.rmsc .dropdown-container{position:relative;outline:0;background-color:var(--rmsc-bg);border:1px solid var(--rmsc-border);border-radius:var(--rmsc-radius)}.rmsc .dropdown-container[aria-disabled=true]:focus-within{box-shadow:var(--rmsc-gray) 0 0 0 1px;border-color:var(--rmsc-gray)}.rmsc .dropdown-container:focus-within{box-shadow:var(--rmsc-main) 0 0 0 1px;border-color:var(--rmsc-main)}.rmsc .dropdown-heading{position:relative;padding:0 var(--rmsc-p);display:flex;align-items:center;width:100%;height:var(--rmsc-h);cursor:default;outline:0}.rmsc .dropdown-heading .dropdown-heading-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}.rmsc .clear-selected-button{cursor:pointer;background:none;border:0;padding:0;display:flex}.rmsc .options{max-height:260px;overflow-y:auto;margin:0;padding-left:0}.rmsc .options li{list-style:none;margin:0}.rmsc .select-item{box-sizing:border-box;cursor:pointer;display:block;padding:var(--rmsc-p);outline-offset:-1px;outline-color:var(--rmsc-primary)}.rmsc .select-item:hover{background:var(--rmsc-hover)}.rmsc .select-item.selected{background:var(--rmsc-selected)}.rmsc .no-options{padding:var(--rmsc-p);text-align:center;color:var(--rmsc-gray)}.rmsc .search{width:100%;position:relative;border-bottom:1px solid var(--rmsc-border)}.rmsc .search input{background:none;height:var(--rmsc-h);padding:0 var(--rmsc-p);width:100%;outline:0;border:0;font-size:1em}.rmsc .search input:focus{background:var(--rmsc-hover)}.rmsc .search-clear-button{cursor:pointer;position:absolute;top:0;right:0;bottom:0;background:none;border:0;padding:0 calc(var(--rmsc-p) / 2)}.rmsc .search-clear-button [hidden]{display:none}.rmsc .item-renderer{display:flex;align-items:baseline}.rmsc .item-renderer input{margin:0 5px 0 0}.rmsc .item-renderer.disabled{opacity:.5}.rmsc .spinner{animation:rotate 2s linear infinite}.rmsc .spinner .path{stroke:var(--rmsc-border);stroke-width:4px;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}
`);
var FT = { allItemsAreSelected: "All items are selected.", clearSearch: "Clear Search", clearSelected: "Clear Selected", noOptions: "No options", search: "Search", selectAll: "Select All", selectAllFiltered: "Select All (Filtered)", selectSomeItems: "Select...", create: "Create" }, VT = { value: [], hasSelectAll: !0, className: "multi-select", debounceDuration: 200, options: [] }, yg = Y.createContext({}), BT = ({ props: e, children: t }) => {
  let [n, r] = Q(e.options), o = (i) => {
    var s;
    return ((s = e.overrideStrings) == null ? void 0 : s[i]) || FT[i];
  };
  return Ie(() => {
    r(e.options);
  }, [e.options]), A(yg.Provider, { value: { t: o, ...VT, ...e, options: n, setOptions: r }, children: t });
}, Ja = () => Y.useContext(yg);
function kT(e, t) {
  let n = Ce(!1);
  Ie(() => {
    n.current ? e() : n.current = !0;
  }, t);
}
var LT = { when: !0, eventTypes: ["keydown"] };
function xa(e, t, n) {
  let r = ve(() => Array.isArray(e) ? e : [e], [e]), o = Object.assign({}, LT, n), { when: i, eventTypes: s } = o, a = Ce(t), { target: c } = o;
  Ie(() => {
    a.current = t;
  });
  let u = ye((l) => {
    r.some((d) => l.key === d || l.code === d) && a.current(l);
  }, [r]);
  Ie(() => {
    if (i && typeof window < "u") {
      let l = c ? c.current : window;
      return s.forEach((d) => {
        l && l.addEventListener(d, u);
      }), () => {
        s.forEach((d) => {
          l && l.removeEventListener(d, u);
        });
      };
    }
  }, [i, s, r, c, t]);
}
var gt = { ARROW_DOWN: "ArrowDown", ARROW_UP: "ArrowUp", ENTER: "Enter", ESCAPE: "Escape", SPACE: "Space" }, HT = (e, t) => {
  let n;
  return function(...r) {
    clearTimeout(n), n = setTimeout(() => {
      e.apply(null, r);
    }, t);
  };
};
function XT(e, t) {
  return t ? e.filter(({ label: n, value: r }) => n != null && r != null && n.toLowerCase().includes(t.toLowerCase())) : e;
}
var Cg = () => R("svg", { width: "24", height: "24", fill: "none", stroke: "currentColor", strokeWidth: "2", className: "dropdown-search-clear-icon gray", children: [A("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), A("line", { x1: "6", y1: "6", x2: "18", y2: "18" })] }), WT = ({ checked: e, option: t, onClick: n, disabled: r }) => R("div", { className: `item-renderer ${r ? "disabled" : ""}`, children: [A("input", { type: "checkbox", onChange: n, checked: e, tabIndex: -1, disabled: r }), A("span", { children: t.label })] }), ZT = WT, zT = ({ itemRenderer: e = ZT, option: t, checked: n, tabIndex: r, disabled: o, onSelectionChanged: i, onClick: s }) => {
  let a = Ce(), c = (d) => {
    u(), d.preventDefault();
  }, u = () => {
    o || i(!n);
  }, l = (d) => {
    u(), s(d);
  };
  return xa([gt.ENTER, gt.SPACE], c, { target: a }), A("label", { className: `select-item ${n ? "selected" : ""}`, role: "option", "aria-selected": n, tabIndex: r, ref: a, children: A(e, { option: t, checked: n, onClick: l, disabled: o }) });
}, xg = zT, GT = ({ options: e, onClick: t, skipIndex: n }) => {
  let { disabled: r, value: o, onChange: i, ItemRenderer: s } = Ja(), a = (c, u) => {
    r || i(u ? [...o, c] : o.filter((l) => l.value !== c.value));
  };
  return A(Ee, { children: e.map((c, u) => {
    let l = u + n;
    return A("li", { children: A(xg, { tabIndex: l, option: c, onSelectionChanged: (d) => a(c, d), checked: !!o.find((d) => d.value === c.value), onClick: (d) => t(d, l), itemRenderer: s, disabled: c.disabled || r }) }, (c == null ? void 0 : c.key) || u);
  }) });
}, jT = GT, UT = () => {
  let { t: e, onChange: t, options: n, setOptions: r, value: o, filterOptions: i, ItemRenderer: s, disabled: a, disableSearch: c, hasSelectAll: u, ClearIcon: l, debounceDuration: d, isCreatable: f, onCreateOption: p } = Ja(), h = Ce(), g = Ce(), [m, b] = Q(""), [v, C] = Q(n), [w, y] = Q(""), [I, x] = Q(0), E = ye(HT((te) => y(te), d), []), P = ve(() => {
    let te = 0;
    return c || (te += 1), u && (te += 1), te;
  }, [c, u]), L = { label: e(m ? "selectAllFiltered" : "selectAll"), value: "" }, W = (te) => {
    let ue = v.filter((me) => !me.disabled).map((me) => me.value);
    if (te) {
      let me = [...o.map((Te) => Te.value), ...ue];
      return (i ? v : n).filter((Te) => me.includes(Te.value));
    }
    return o.filter((me) => !ue.includes(me.value));
  }, V = (te) => {
    let ue = W(te);
    t(ue);
  }, X = (te) => {
    E(te.target.value), b(te.target.value), x(0);
  }, N = () => {
    var te;
    y(""), b(""), (te = g == null ? void 0 : g.current) == null || te.focus();
  }, M = (te) => x(te), F = (te) => {
    switch (te.code) {
      case gt.ARROW_UP:
        K(-1);
        break;
      case gt.ARROW_DOWN:
        K(1);
        break;
      default:
        return;
    }
    te.stopPropagation(), te.preventDefault();
  };
  xa([gt.ARROW_DOWN, gt.ARROW_UP], F, { target: h });
  let B = () => {
    x(0);
  }, Z = async () => {
    let te = { label: m, value: m, __isNew__: !0 };
    p && (te = await p(m)), r([te, ...n]), N(), t([...o, te]);
  }, H = async () => i ? await i(n, w) : XT(n, w), K = (te) => {
    let ue = I + te;
    ue = Math.max(0, ue), ue = Math.min(ue, n.length + Math.max(P - 1, 0)), x(ue);
  };
  Ie(() => {
    var te, ue;
    (ue = (te = h == null ? void 0 : h.current) == null ? void 0 : te.querySelector(`[tabIndex='${I}']`)) == null || ue.focus();
  }, [I]);
  let [ee, z] = ve(() => {
    let te = v.filter((ue) => !ue.disabled);
    return [te.every((ue) => o.findIndex((me) => me.value === ue.value) !== -1), te.length !== 0];
  }, [v, o]);
  Ie(() => {
    H().then(C);
  }, [w, n]);
  let ce = Ce();
  xa([gt.ENTER], Z, { target: ce });
  let be = f && m && !v.some((te) => (te == null ? void 0 : te.value) === m);
  return R("div", { className: "select-panel", role: "listbox", ref: h, children: [!c && R("div", { className: "search", children: [A("input", { placeholder: e("search"), type: "text", "aria-describedby": e("search"), onChange: X, onFocus: B, value: m, ref: g, tabIndex: 0 }), A("button", { type: "button", className: "search-clear-button", hidden: !m, onClick: N, "aria-label": e("clearSearch"), children: l || A(Cg, {}) })] }), R("ul", { className: "options", children: [u && z && A(xg, { tabIndex: P === 1 ? 0 : 1, checked: ee, option: L, onSelectionChanged: V, onClick: () => M(1), itemRenderer: s, disabled: a }), v.length ? A(jT, { skipIndex: P, options: v, onClick: (te, ue) => M(ue) }) : be ? A("li", { onClick: Z, className: "select-item creatable", tabIndex: 1, ref: ce, children: `${e("create")} "${m}"` }) : A("li", { className: "no-options", children: e("noOptions") })] })] });
}, QT = UT, qT = ({ expanded: e }) => A("svg", { width: "24", height: "24", fill: "none", stroke: "currentColor", strokeWidth: "2", className: "dropdown-heading-dropdown-arrow gray", children: A("path", { d: e ? "M18 15 12 9 6 15" : "M6 9L12 15 18 9" }) }), YT = () => {
  let { t: e, value: t, options: n, valueRenderer: r } = Ja(), o = t.length === 0, i = t.length === n.length, s = r && r(t, n);
  return o ? A("span", { className: "gray", children: s || e("selectSomeItems") }) : A("span", { children: s || (i ? e("allItemsAreSelected") : t.map((a) => a.label).join(", ")) });
}, JT = ({ size: e = 24 }) => A("span", { style: { width: e, marginRight: "0.2rem" }, children: A("svg", { width: e, height: e, className: "spinner", viewBox: "0 0 50 50", style: { display: "inline", verticalAlign: "middle" }, children: A("circle", { cx: "25", cy: "25", r: "20", fill: "none", className: "path" }) }) }), KT = () => {
  let { t: e, onMenuToggle: t, ArrowRenderer: n, shouldToggleOnHover: r, isLoading: o, disabled: i, onChange: s, labelledBy: a, value: c, isOpen: u, defaultIsOpen: l, ClearSelectedIcon: d, closeOnChangedValue: f } = Ja();
  Ie(() => {
    f && m(!1);
  }, [c]);
  let [p, h] = Q(!0), [g, m] = Q(l), [b, v] = Q(!1), C = n || qT, w = Ce();
  kT(() => {
    t && t(g);
  }, [g]), Ie(() => {
    l === void 0 && typeof u == "boolean" && (h(!1), m(u));
  }, [u]);
  let y = (X) => {
    var N;
    ["text", "button"].includes(X.target.type) && [gt.SPACE, gt.ENTER].includes(X.code) || (p && (X.code === gt.ESCAPE ? (m(!1), (N = w == null ? void 0 : w.current) == null || N.focus()) : m(!0)), X.preventDefault());
  };
  xa([gt.ENTER, gt.ARROW_DOWN, gt.SPACE, gt.ESCAPE], y, { target: w });
  let I = (X) => {
    p && r && m(X);
  }, x = () => !b && v(!0), E = (X) => {
    !X.currentTarget.contains(X.relatedTarget) && p && (v(!1), m(!1));
  }, P = () => I(!0), L = () => I(!1), W = () => {
    p && m(o || i ? !1 : !g);
  }, V = (X) => {
    X.stopPropagation(), s([]), p && m(!1);
  };
  return R("div", { tabIndex: 0, className: "dropdown-container", "aria-labelledby": a, "aria-expanded": g, "aria-readonly": !0, "aria-disabled": i, ref: w, onFocus: x, onBlur: E, onMouseEnter: P, onMouseLeave: L, children: [R("div", { className: "dropdown-heading", onClick: W, children: [A("div", { className: "dropdown-heading-value", children: A(YT, {}) }), o && A(JT, {}), c.length > 0 && d !== null && A("button", { type: "button", className: "clear-selected-button", onClick: V, disabled: i, "aria-label": e("clearSelected"), children: d || A(Cg, {}) }), A(C, { expanded: g })] }), g && A("div", { className: "dropdown-content", children: A("div", { className: "panel-content", children: A(QT, {}) }) })] });
}, _T = KT, $T = (e) => A(BT, { props: e, children: A("div", { className: `rmsc ${e.className || "multi-select"}`, children: A(_T, {}) }) }), eN = $T;
const ZM = (e) => {
  const {
    options: t,
    onChange: n,
    className: r,
    selected: o = [],
    selectProps: i = {},
    ...s
  } = e;
  return /* @__PURE__ */ A(vg, { ...s, children: /* @__PURE__ */ A(
    eN,
    {
      labelledBy: "Select",
      value: o,
      onChange: n,
      options: t,
      className: $("checkbox-container w-[200px]", r),
      ...i
    }
  ) });
}, zM = (e) => {
  const {
    body: t,
    title: n,
    onSave: r,
    children: o,
    saveLabel: i,
    cancelLabel: s,
    overlayProps: a,
    contentProps: c,
    onOpenChange: u,
    ...l
  } = e;
  return /* @__PURE__ */ A(
    wn,
    {
      overlayProps: {
        ...a,
        className: $("top-10", a == null ? void 0 : a.className)
      },
      contentProps: {
        ...c,
        className: $("rounded-2xl", c == null ? void 0 : c.className)
      },
      onOpenChange: u,
      ...l,
      children: /* @__PURE__ */ R("div", { className: "w-[432px] p-4 text-gray-900", children: [
        /* @__PURE__ */ R("div", { className: "flex justify-between", children: [
          /* @__PURE__ */ A("h1", { className: "text-center text-xl font-bold", children: n }),
          /* @__PURE__ */ A(
            "button",
            {
              className: "flex size-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 outline-none hover:text-gray-900",
              onClick: () => u == null ? void 0 : u(!1),
              children: /* @__PURE__ */ A(J, { name: "XmarkLight", size: 24 })
            }
          )
        ] }),
        /* @__PURE__ */ A("div", { className: "mt-8 flex min-h-[50px] items-center justify-center rounded-md bg-slate-50 p-3 text-xs font-medium text-gray-600", children: t }),
        /* @__PURE__ */ A("div", { className: "mt-4 flex flex-col gap-y-4", children: o }),
        /* @__PURE__ */ R("div", { className: "mt-4 flex justify-end gap-x-4", children: [
          /* @__PURE__ */ A(
            jt,
            {
              color: "light",
              className: "text-gray-900",
              onClick: () => u == null ? void 0 : u(!1),
              children: s
            }
          ),
          /* @__PURE__ */ A(jt, { onClick: r, children: i })
        ] })
      ] })
    }
  );
}, lf = "min-h-[48px] min-w-[142px] text-base font-semibold py-3 px-6 rounded-xl outline-none active:opacity-75 hover:scale-105 transform transition-all", GM = (e) => {
  const {
    body: t,
    header: n,
    onOpenChange: r,
    onContinue: o,
    cancelLabel: i,
    continueLabel: s,
    overlayProps: a,
    contentProps: c,
    ...u
  } = e;
  return /* @__PURE__ */ A(
    wn,
    {
      overlayProps: {
        ...a,
        className: $("top-10", a == null ? void 0 : a.className)
      },
      contentProps: {
        ...c,
        className: $("rounded-3xl", c == null ? void 0 : c.className)
      },
      onOpenChange: r,
      ...u,
      children: /* @__PURE__ */ R("div", { className: "w-[400px] p-6 text-slate-300", children: [
        /* @__PURE__ */ A("div", { className: "border-b border-slate-50 pb-2 text-2xl font-bold text-gray-800", children: n }),
        /* @__PURE__ */ A("div", { className: "my-6 rounded-md bg-slate-50 p-4 text-center text-slate-200", children: t }),
        /* @__PURE__ */ R("div", { className: "mt-8 flex justify-between gap-3", children: [
          /* @__PURE__ */ A(
            "button",
            {
              onClick: () => r == null ? void 0 : r(!1),
              className: $(
                lf,
                "flex-1 bg-slate-50 text-slate-800"
              ),
              children: i
            }
          ),
          /* @__PURE__ */ A(
            "button",
            {
              onClick: o,
              className: $(
                lf,
                "flex-1 bg-gray-800 text-gray-50"
              ),
              children: s
            }
          )
        ] })
      ] })
    }
  );
};
function ki(e) {
  const {
    onSubmit: t,
    onCancel: n,
    defaultValue: r,
    className: o,
    minLength: i = 1,
    ...s
  } = e, [a, c] = Q(r ?? ""), u = Ce(null);
  TT(u, l), pg("keyup", (d) => {
    d.key === "Enter" && l(), d.key === "Escape" && n();
  }), Yn(() => {
    setTimeout(() => {
      var d, f, p;
      (d = u.current) == null || d.focus(), (f = u.current) == null || f.select(), (p = u.current) == null || p.scroll({ left: 9999 });
    }, 100);
  }, []);
  function l() {
    a.length >= i && t(a);
  }
  return /* @__PURE__ */ A(
    "input",
    {
      ...s,
      required: !0,
      autoFocus: !0,
      type: "text",
      ref: u,
      value: a,
      minLength: i,
      className: $(
        "bg-inherit text-inherit outline-none",
        o
      ),
      onChange: (d) => c(d.target.value)
    }
  );
}
function tN(e) {
  const { branch: t = "main" } = e;
  return /* @__PURE__ */ R("button", { className: "flex h-8 items-center gap-1 rounded-lg bg-slate-50 pl-1 pr-2 text-xs text-slate-100", children: [
    /* @__PURE__ */ A(J, { name: "Branch" }),
    /* @__PURE__ */ A("span", { children: "BRANCH" }),
    /* @__PURE__ */ A("span", { className: "text-gray-900", children: t })
  ] });
}
function nN(e) {
  const { docId: t } = e, [, n] = Ud();
  function r(o) {
    return () => {
      n(o).catch((i) => {
        console.error("Failed to copy!", i);
      });
    };
  }
  return /* @__PURE__ */ R(
    "button",
    {
      className: "flex h-8 items-center gap-1 rounded-lg bg-slate-50 pl-1 pr-2 text-xs text-slate-100",
      onClick: r(t),
      children: [
        /* @__PURE__ */ A(J, { name: "Link" }),
        "DOC ID",
        /* @__PURE__ */ A("span", { className: "text-gray-900", children: t })
      ]
    }
  );
}
const wg = Hh(function(t, n) {
  const {
    items: r,
    value: o,
    id: i,
    onChange: s,
    containerClassName: a,
    menuClassName: c,
    itemClassName: u,
    absolutePositionMenu: l = !1,
    borderRadius: d = "12px"
  } = t, [f, p] = Q(!1), h = m(o) ?? r[0];
  function g(v) {
    v.disabled || (s(v.value), p(!1));
  }
  function m(v) {
    return r.find((C) => C.value === v);
  }
  const b = r.filter((v) => v.value !== o);
  return /* @__PURE__ */ R(
    "div",
    {
      className: $(
        "bg-gray-100 transition-[border-radius]",
        l && "relative",
        a
      ),
      ref: n,
      style: {
        borderRadius: f ? `${d} ${d} 0 0` : d
      },
      "data-open": f,
      children: [
        /* @__PURE__ */ R(
          "div",
          {
            onClick: () => p(!f),
            id: i,
            className: $(
              "flex min-w-[360px] cursor-pointer items-center justify-between pr-3 text-gray-800 outline-none",
              c
            ),
            children: [
              /* @__PURE__ */ A(df, { ...h, className: u }),
              /* @__PURE__ */ A(
                J,
                {
                  name: "ChevronDown",
                  className: Nr(
                    "transition",
                    f ? "" : "-rotate-90"
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ A(
          "div",
          {
            style: {
              borderRadius: `0 0 ${d} ${d}`
            },
            className: $(
              "max-h-0 w-full overflow-hidden bg-inherit transition-[max-height] ease-in-out",
              f && "max-h-screen",
              l && "absolute"
            ),
            children: b.map((v) => /* @__PURE__ */ A(
              df,
              {
                ...v,
                onItemClick: () => g(v),
                className: u
              },
              v.value
            ))
          }
        )
      ]
    }
  );
});
function df(e) {
  const {
    className: t,
    disabled: n,
    onItemClick: r,
    icon: o,
    displayValue: i,
    value: s,
    description: a
  } = e;
  return /* @__PURE__ */ R(
    "div",
    {
      className: $(
        n ? "cursor-not-allowed text-gray-500" : "text-gray-800",
        "flex size-full cursor-pointer items-center gap-2 bg-inherit py-3 pl-3 text-start outline-none",
        t
      ),
      onClick: r,
      children: [
        o,
        /* @__PURE__ */ R("div", { children: [
          /* @__PURE__ */ A("p", { className: "capitalize text-inherit", children: i ?? s.toLowerCase() }),
          /* @__PURE__ */ A("p", { className: "text-xs text-inherit", children: a })
        ] })
      ]
    }
  );
}
function rN(e) {
  const { value: t, onChange: n } = e;
  return /* @__PURE__ */ A(
    wg,
    {
      id: "scope select",
      value: t,
      items: [
        { displayValue: "Global scope", value: "global" },
        { displayValue: "Local scope", value: "local" }
      ],
      onChange: n,
      containerClassName: "bg-slate-50 text-gray-500 rounded-lg w-fit text-xs",
      menuClassName: "min-w-0 text-gray-500",
      itemClassName: "py-2 text-gray-500 grid grid-cols-[auto,auto] gap-1",
      absolutePositionMenu: !0
    }
  );
}
function oN(e) {
  const { title: t, docId: n, scope: r, onChangeScope: o, onClose: i } = e;
  return /* @__PURE__ */ R("header", { className: "flex items-center justify-between bg-transparent", children: [
    /* @__PURE__ */ R("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ A(
        "button",
        {
          onClick: i,
          className: "rounded-lg bg-gray-50 p-1 text-slate-100 shadow-button",
          children: /* @__PURE__ */ A(J, { name: "VariantArrowLeft" })
        }
      ),
      /* @__PURE__ */ A("h1", { className: "text-xs", children: t })
    ] }),
    /* @__PURE__ */ R("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ A(nN, { docId: n }),
      /* @__PURE__ */ A(tN, {}),
      /* @__PURE__ */ A(rN, { value: r, onChange: o })
    ] })
  ] });
}
function Ko(e, t, n) {
  let r = n.initialDeps ?? [], o;
  return () => {
    var i, s, a, c;
    let u;
    n.key && ((i = n.debug) != null && i.call(n)) && (u = Date.now());
    const l = e();
    if (!(l.length !== r.length || l.some((p, h) => r[h] !== p)))
      return o;
    r = l;
    let f;
    if (n.key && ((s = n.debug) != null && s.call(n)) && (f = Date.now()), o = t(...l), n.key && ((a = n.debug) != null && a.call(n))) {
      const p = Math.round((Date.now() - u) * 100) / 100, h = Math.round((Date.now() - f) * 100) / 100, g = h / 16, m = (b, v) => {
        for (b = String(b); b.length < v; )
          b = " " + b;
        return b;
      };
      console.info(
        `%c⏱ ${m(h, 5)} /${m(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * g, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (c = n == null ? void 0 : n.onChange) == null || c.call(n, o), o;
  };
}
function Kc(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const iN = (e, t) => Math.abs(e - t) < 1, sN = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
}, aN = (e) => e, cN = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let o = t; o <= n; o++)
    r.push(o);
  return r;
}, uN = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (s) => {
    const { width: a, height: c } = s;
    t({ width: Math.round(a), height: Math.round(c) });
  };
  if (o(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((s) => {
    const a = s[0];
    if (a != null && a.borderBoxSize) {
      const c = a.borderBoxSize[0];
      if (c) {
        o({ width: c.inlineSize, height: c.blockSize });
        return;
      }
    }
    o(n.getBoundingClientRect());
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, Af = {
  passive: !0
}, lN = typeof window > "u" ? !0 : "onscrollend" in window, dN = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let o = 0;
  const i = lN ? () => {
  } : sN(
    r,
    () => {
      t(o, !1);
    },
    e.options.isScrollingResetDelay
  ), s = (u) => () => {
    o = n[e.options.horizontal ? "scrollLeft" : "scrollTop"], i(), t(o, u);
  }, a = s(!0), c = s(!1);
  return c(), n.addEventListener("scroll", a, Af), n.addEventListener("scrollend", c, Af), () => {
    n.removeEventListener("scroll", a), n.removeEventListener("scrollend", c);
  };
}, AN = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, fN = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, i;
  const s = e + t;
  (i = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || i.call(o, {
    [r.options.horizontal ? "left" : "top"]: s,
    behavior: n
  });
};
class hN {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var o;
          return (o = r()) == null ? void 0 : o.disconnect();
        },
        observe: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: aN,
        rangeExtractor: cN,
        onChange: () => {
        },
        measureElement: AN,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        ...n
      };
    }, this.notify = (n, r) => {
      var o, i;
      const { startIndex: s, endIndex: a } = this.range ?? {
        startIndex: void 0,
        endIndex: void 0
      }, c = this.calculateRange();
      (n || s !== (c == null ? void 0 : c.startIndex) || a !== (c == null ? void 0 : c.endIndex)) && ((i = (o = this.options).onChange) == null || i.call(o, this, r));
    }, this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.observer.disconnect(), this.elementsCache.clear();
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.notify(!1, !1);
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.notify(!1, !1);
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o;
            const s = this.isScrolling;
            this.isScrolling = i, this.notify(s !== i, i);
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let s = r - 1; s >= 0; s--) {
        const a = n[s];
        if (o.has(a.lane))
          continue;
        const c = i.get(
          a.lane
        );
        if (c == null || a.end > c.end ? i.set(a.lane, a) : a.end < c.end && o.set(a.lane, !0), o.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((s, a) => s.end === a.end ? s.index - a.index : s.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = Ko(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, i, s) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Ko(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: i, enabled: s }, a) => {
        var c;
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((d) => {
          this.itemSizeCache.set(d.key, d.size);
        }));
        const u = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const l = this.measurementsCache.slice(0, u);
        for (let d = u; d < n; d++) {
          let f = (c = this.measurementsCache[d]) == null ? void 0 : c.measureElement;
          f || (f = (w) => {
            const y = i(d), I = this.elementsCache.get(y);
            if (!w) {
              I && (this.observer.unobserve(I), this.elementsCache.delete(y));
              return;
            }
            I !== w && (I && this.observer.unobserve(I), this.observer.observe(w), this.elementsCache.set(y, w)), w.isConnected && this.resizeItem(
              d,
              this.options.measureElement(w, void 0, this)
            );
          });
          const p = i(d), h = this.options.lanes === 1 ? l[d - 1] : this.getFurthestMeasurement(l, d), g = h ? h.end + this.options.gap : r + o, m = a.get(p), b = typeof m == "number" ? m : this.options.estimateSize(d), v = g + b, C = h ? h.lane : d % this.options.lanes;
          l[d] = {
            index: d,
            start: g,
            size: b,
            end: v,
            key: p,
            lane: C,
            measureElement: f
          };
        }
        return this.measurementsCache = l, l;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Ko(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, o) => this.range = n.length > 0 && r > 0 ? pN({
        measurements: n,
        outerSize: r,
        scrollOffset: o
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = Ko(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, o, i) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: o,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), i = this.getMeasurements()[o];
      if (!i || !n.isConnected) {
        this.elementsCache.forEach((a, c) => {
          a === n && (this.observer.unobserve(n), this.elementsCache.delete(c));
        });
        return;
      }
      const s = this.elementsCache.get(i.key);
      s !== n && (s && this.observer.unobserve(s), this.observer.observe(n), this.elementsCache.set(i.key, n)), this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.getMeasurements()[n];
      if (!o)
        return;
      const i = this.itemSizeCache.get(o.key) ?? o.size, s = r - i;
      s !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, s, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", s), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!0, !1));
    }, this.measureElement = (n) => {
      n && this._measureElement(n, void 0);
    }, this.getVirtualItems = Ko(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let i = 0, s = n.length; i < s; i++) {
          const a = n[i], c = r[a];
          o.push(c);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return Kc(
          r[Ig(
            0,
            r.length - 1,
            (o) => Kc(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const o = this.getSize(), i = this.getScrollOffset();
      r === "auto" && (n <= i ? r = "start" : n >= i + o ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - o : r === "center" && (n = n - o / 2);
      const s = this.options.horizontal ? "scrollWidth" : "scrollHeight", c = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[s] : this.scrollElement[s] : 0) - o;
      return Math.max(Math.min(c, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.getMeasurements()[n];
      if (!o)
        return;
      const i = this.getSize(), s = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= s + i - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= s + this.options.scrollPaddingStart)
          r = "start";
        else
          return [s, r];
      const a = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(a, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(n, r);
      if (!i) return;
      const [s, a] = i;
      this._scrollToOffset(s, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [u] = Kc(
            this.getOffsetForIndex(n, a)
          );
          iN(u, this.getScrollOffset()) || this.scrollToIndex(n, { align: a, behavior: o });
        } else
          this.scrollToIndex(n, { align: a, behavior: o });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      return r.length === 0 ? o = this.options.paddingStart : o = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((i) => i.end)
      ), o - this.options.scrollMargin + this.options.paddingEnd;
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      var n, r;
      this.itemSizeCache = /* @__PURE__ */ new Map(), (r = (n = this.options).onChange) == null || r.call(n, this, !1);
    }, this.setOptions(t);
  }
}
const Ig = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, i = n(o);
    if (i < r)
      e = o + 1;
    else if (i > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function pN({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const r = e.length - 1, i = Ig(0, r, (a) => e[a].start, n);
  let s = i;
  for (; s < r && e[s].end < n + t; )
    s++;
  return { startIndex: i, endIndex: s };
}
const mN = typeof document < "u" ? S.useLayoutEffect : S.useEffect;
function gN(e) {
  const t = S.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (o, i) => {
      var s;
      i ? U3(t) : t(), (s = e.onChange) == null || s.call(e, o, i);
    }
  }, [r] = S.useState(
    () => new hN(n)
  );
  return r.setOptions(n), S.useEffect(() => r._didMount(), []), mN(() => r._willUpdate()), r;
}
function bN(e) {
  return gN({
    observeElementRect: uN,
    observeElementOffset: dN,
    scrollToFn: fN,
    ...e
  });
}
function vN(e) {
  const { address: t, chainId: n } = e, [, r] = Ud();
  if (!t) return null;
  const o = Yg(t);
  function i(a) {
    return () => {
      r(a).catch((c) => {
        console.error("Failed to copy!", c);
      });
    };
  }
  const s = /* @__PURE__ */ R(
    "button",
    {
      onClick: i(t),
      className: "flex items-center gap-1",
      children: [
        t,
        /* @__PURE__ */ A(
          J,
          {
            name: "FilesEarmark",
            className: "inline-block text-gray-600",
            size: 16
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ A(Or, { content: s, children: /* @__PURE__ */ R("span", { className: "flex w-fit cursor-pointer items-center gap-1 rounded-lg bg-gray-100 p-1 text-xs text-slate-100", children: [
    /* @__PURE__ */ A(Zm, { address: t, chainId: n }),
    o
  ] }) });
}
function yN(e) {
  const { errors: t } = e, n = !!(t != null && t.length), r = n ? "text-red-800" : "text-green-700", o = n ? /* @__PURE__ */ A(J, { name: "Exclamation", size: 16 }) : /* @__PURE__ */ A(J, { name: "Check", size: 16 }), i = n ? `Error: ${t[0]}` : "No errors", s = /* @__PURE__ */ R(
    "span",
    {
      className: $(
        "flex w-fit items-center rounded-lg border border-gray-200 px-2 py-1 text-xs",
        r,
        n && "cursor-pointer"
      ),
      children: [
        o,
        /* @__PURE__ */ A("span", { className: $("inline-block max-w-36 truncate"), children: i })
      ]
    }
  ), a = t == null ? void 0 : t.map((c, u) => /* @__PURE__ */ R("p", { className: "text-red-800", children: [
    "Error: ",
    c
  ] }, u));
  return n ? /* @__PURE__ */ A(Or, { content: a, children: s }) : s;
}
function CN(e) {
  const { operationType: t, operationInput: n } = e, r = /* @__PURE__ */ A("code", { children: /* @__PURE__ */ A("pre", { children: JSON.stringify(n, null, 2) }) });
  return /* @__PURE__ */ A(Or, { content: r, children: /* @__PURE__ */ R("span", { className: "flex cursor-pointer items-center gap-2 text-xs", children: [
    t,
    /* @__PURE__ */ A(J, { name: "Braces", className: "text-gray-300", size: 16 })
  ] }) });
}
function xN(e) {
  const { operationIndex: t, eventId: n, stateHash: r } = e, [, o] = Ud(), i = t + 1, s = /* @__PURE__ */ R(
    "button",
    {
      onClick: a(r),
      className: "flex items-center gap-1",
      children: [
        "Revision ",
        i,
        " - Event ID: ",
        n,
        " - State Hash:",
        " ",
        r,
        /* @__PURE__ */ A(
          J,
          {
            name: "FilesEarmark",
            className: "inline-block text-gray-600",
            size: 16
          }
        )
      ]
    }
  );
  function a(c) {
    return () => {
      o(c).catch((u) => {
        console.error("Failed to copy!", u);
      });
    };
  }
  return /* @__PURE__ */ A(Or, { content: s, children: /* @__PURE__ */ R("span", { className: "flex cursor-pointer items-center gap-2 text-xs text-gray-600", children: [
    "Revision ",
    i,
    ".",
    /* @__PURE__ */ A("a", { children: /* @__PURE__ */ A(
      J,
      {
        name: "Ellipsis",
        size: 14,
        className: "cursor-pointer text-slate-100"
      }
    ) })
  ] }) });
}
function wN(e) {
  const { signatures: t } = e;
  if (!(t != null && t.length)) return null;
  const n = t.length, r = t.filter(
    (a) => a.isVerified
  ).length, o = n === 1 ? "signature" : "signatures";
  function i() {
    const a = `${r}/${n} ${o} verified`;
    return /* @__PURE__ */ A("span", { className: `text-xs ${r === 0 ? "text-red-800" : r === n ? "text-green-700" : "text-orange-700"}`, children: a });
  }
  const s = /* @__PURE__ */ R("div", { className: "text-xs text-slate-300", children: [
    /* @__PURE__ */ A("h3", { className: "mb-2", children: "Signature details:" }),
    t.map((a, c) => /* @__PURE__ */ R("div", { className: "mb-2 last:mb-0", children: [
      /* @__PURE__ */ R("h4", { children: [
        "Signature #",
        c + 1,
        " -",
        " ",
        a.isVerified ? "verified" : "unverified"
      ] }),
      /* @__PURE__ */ A("code", { children: /* @__PURE__ */ A("pre", { children: JSON.stringify(a, null, 2) }) })
    ] }, a.hash))
  ] });
  return /* @__PURE__ */ A(Or, { content: s, children: /* @__PURE__ */ R("span", { className: "flex w-fit cursor-pointer items-center gap-1 rounded-lg border border-gray-200 px-2 py-1", children: [
    /* @__PURE__ */ A(i, {}),
    " ",
    /* @__PURE__ */ A(J, { name: "InfoSquare", className: "text-gray-300", size: 16 })
  ] }) });
}
function Kt(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Er(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
const Eg = 6048e5, IN = 864e5;
let EN = {};
function Ka() {
  return EN;
}
function Li(e, t) {
  var a, c, u, l;
  const n = Ka(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : c.weekStartsOn) ?? n.weekStartsOn ?? ((l = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : l.weekStartsOn) ?? 0, o = Kt(e), i = o.getDay(), s = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - s), o.setHours(0, 0, 0, 0), o;
}
function wa(e) {
  return Li(e, { weekStartsOn: 1 });
}
function Sg(e) {
  const t = Kt(e), n = t.getFullYear(), r = Er(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = wa(r), i = Er(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const s = wa(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function ff(e) {
  const t = Kt(e);
  return t.setHours(0, 0, 0, 0), t;
}
function hf(e) {
  const t = Kt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function SN(e, t) {
  const n = ff(e), r = ff(t), o = +n - hf(n), i = +r - hf(r);
  return Math.round((o - i) / IN);
}
function TN(e) {
  const t = Sg(e), n = Er(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), wa(n);
}
function NN(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function PN(e) {
  if (!NN(e) && typeof e != "number")
    return !1;
  const t = Kt(e);
  return !isNaN(Number(t));
}
function RN(e) {
  const t = Kt(e), n = Er(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const ON = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, DN = (e, t, n) => {
  let r;
  const o = ON[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function _c(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const MN = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, FN = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, VN = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, BN = {
  date: _c({
    formats: MN,
    defaultWidth: "full"
  }),
  time: _c({
    formats: FN,
    defaultWidth: "full"
  }),
  dateTime: _c({
    formats: VN,
    defaultWidth: "full"
  })
}, kN = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, LN = (e, t, n, r) => kN[e];
function _o(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : s;
      o = e.formattingValues[a] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, a = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[a] || e.values[s];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const HN = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, XN = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, WN = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, ZN = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, zN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, GN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, jN = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, UN = {
  ordinalNumber: jN,
  era: _o({
    values: HN,
    defaultWidth: "wide"
  }),
  quarter: _o({
    values: XN,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: _o({
    values: WN,
    defaultWidth: "wide"
  }),
  day: _o({
    values: ZN,
    defaultWidth: "wide"
  }),
  dayPeriod: _o({
    values: zN,
    defaultWidth: "wide",
    formattingValues: GN,
    defaultFormattingWidth: "wide"
  })
};
function $o(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const s = i[0], a = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(a) ? qN(a, (d) => d.test(s)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      QN(a, (d) => d.test(s))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(c) : c, u = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(u)
    ) : u;
    const l = t.slice(s.length);
    return { value: u, rest: l };
  };
}
function QN(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function qN(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function YN(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let s = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const a = t.slice(o.length);
    return { value: s, rest: a };
  };
}
const JN = /^(\d+)(th|st|nd|rd)?/i, KN = /\d+/i, _N = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, $N = {
  any: [/^b/i, /^(a|c)/i]
}, eP = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, tP = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, nP = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, rP = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, oP = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, iP = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, sP = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, aP = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, cP = {
  ordinalNumber: YN({
    matchPattern: JN,
    parsePattern: KN,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: $o({
    matchPatterns: _N,
    defaultMatchWidth: "wide",
    parsePatterns: $N,
    defaultParseWidth: "any"
  }),
  quarter: $o({
    matchPatterns: eP,
    defaultMatchWidth: "wide",
    parsePatterns: tP,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: $o({
    matchPatterns: nP,
    defaultMatchWidth: "wide",
    parsePatterns: rP,
    defaultParseWidth: "any"
  }),
  day: $o({
    matchPatterns: oP,
    defaultMatchWidth: "wide",
    parsePatterns: iP,
    defaultParseWidth: "any"
  }),
  dayPeriod: $o({
    matchPatterns: sP,
    defaultMatchWidth: "any",
    parsePatterns: aP,
    defaultParseWidth: "any"
  })
}, uP = {
  code: "en-US",
  formatDistance: DN,
  formatLong: BN,
  formatRelative: LN,
  localize: UN,
  match: cP,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function lP(e) {
  const t = Kt(e);
  return SN(t, RN(t)) + 1;
}
function dP(e) {
  const t = Kt(e), n = +wa(t) - +TN(t);
  return Math.round(n / Eg) + 1;
}
function Tg(e, t) {
  var l, d, f, p;
  const n = Kt(e), r = n.getFullYear(), o = Ka(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((p = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, s = Er(e, 0);
  s.setFullYear(r + 1, 0, i), s.setHours(0, 0, 0, 0);
  const a = Li(s, t), c = Er(e, 0);
  c.setFullYear(r, 0, i), c.setHours(0, 0, 0, 0);
  const u = Li(c, t);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= u.getTime() ? r : r - 1;
}
function AP(e, t) {
  var a, c, u, l;
  const n = Ka(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((l = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : l.firstWeekContainsDate) ?? 1, o = Tg(e, t), i = Er(e, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), Li(i, t);
}
function fP(e, t) {
  const n = Kt(e), r = +Li(n, t) - +AP(n, t);
  return Math.round(r / Eg) + 1;
}
function Ve(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Nn = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Ve(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Ve(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Ve(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Ve(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Ve(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Ve(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Ve(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Ve(o, t.length);
  }
}, Gr = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, pf = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Nn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = Tg(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const s = i % 100;
      return Ve(s, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Ve(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Sg(e);
    return Ve(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Ve(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Ve(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Ve(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Nn.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Ve(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = fP(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Ve(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = dP(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Ve(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Nn.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = lP(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Ve(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return Ve(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return Ve(i, t.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return Ve(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = Gr.noon : r === 0 ? o = Gr.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = Gr.evening : r >= 12 ? o = Gr.afternoon : r >= 4 ? o = Gr.morning : o = Gr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Nn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Nn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ve(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ve(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Nn.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Nn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Nn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return gf(r);
      case "XXXX":
      case "XX":
        return er(r);
      case "XXXXX":
      case "XXX":
      default:
        return er(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return gf(r);
      case "xxxx":
      case "xx":
        return er(r);
      case "xxxxx":
      case "xxx":
      default:
        return er(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + mf(r, ":");
      case "OOOO":
      default:
        return "GMT" + er(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + mf(r, ":");
      case "zzzz":
      default:
        return "GMT" + er(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Ve(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return Ve(r, t.length);
  }
};
function mf(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + Ve(i, 2);
}
function gf(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ve(Math.abs(e) / 60, 2) : er(e, t);
}
function er(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Ve(Math.trunc(r / 60), 2), i = Ve(r % 60, 2);
  return n + o + t + i;
}
const bf = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Ng = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, hP = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return bf(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", bf(r, t)).replace("{{time}}", Ng(o, t));
}, pP = {
  p: Ng,
  P: hP
}, mP = /^D+$/, gP = /^Y+$/, bP = ["D", "DD", "YY", "YYYY"];
function vP(e) {
  return mP.test(e);
}
function yP(e) {
  return gP.test(e);
}
function CP(e, t, n) {
  const r = xP(e, t, n);
  if (console.warn(r), bP.includes(e)) throw new RangeError(r);
}
function xP(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const wP = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, IP = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, EP = /^'([^]*?)'?$/, SP = /''/g, TP = /[a-zA-Z]/;
function Hi(e, t, n) {
  var l, d, f, p;
  const r = Ka(), o = r.locale ?? uP, i = r.firstWeekContainsDate ?? ((d = (l = r.locale) == null ? void 0 : l.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, s = r.weekStartsOn ?? ((p = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : p.weekStartsOn) ?? 0, a = Kt(e);
  if (!PN(a))
    throw new RangeError("Invalid time value");
  let c = t.match(IP).map((h) => {
    const g = h[0];
    if (g === "p" || g === "P") {
      const m = pP[g];
      return m(h, o.formatLong);
    }
    return h;
  }).join("").match(wP).map((h) => {
    if (h === "''")
      return { isToken: !1, value: "'" };
    const g = h[0];
    if (g === "'")
      return { isToken: !1, value: NP(h) };
    if (pf[g])
      return { isToken: !0, value: h };
    if (g.match(TP))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + g + "`"
      );
    return { isToken: !1, value: h };
  });
  o.localize.preprocessor && (c = o.localize.preprocessor(a, c));
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: o
  };
  return c.map((h) => {
    if (!h.isToken) return h.value;
    const g = h.value;
    (yP(g) || vP(g)) && CP(g, t, String(e));
    const m = pf[g[0]];
    return m(a, g, o.localize, u);
  }).join("");
}
function NP(e) {
  const t = e.match(EP);
  return t ? t[1].replace(SP, "'") : e;
}
function PP(e) {
  const { timestamp: t } = e, n = new Date(t), r = Hi(n, "HH:mm 'UTC'"), o = Hi(n, "eee, dd MMM yyyy HH:mm:ss 'UTC'");
  return /* @__PURE__ */ A(Or, { content: /* @__PURE__ */ A("div", { children: o }), children: /* @__PURE__ */ R("span", { className: "cursor-pointer text-xs", children: [
    "committed at ",
    r
  ] }) });
}
function RP(e) {
  return /* @__PURE__ */ R("article", { className: "flex items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-2", children: [
    /* @__PURE__ */ R("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ A(xN, { ...e }),
      /* @__PURE__ */ A(CN, { ...e }),
      /* @__PURE__ */ A(vN, { ...e }),
      /* @__PURE__ */ A(PP, { ...e })
    ] }),
    /* @__PURE__ */ R("div", { className: "flex items-center gap-1", children: [
      /* @__PURE__ */ A(wN, { ...e }),
      /* @__PURE__ */ A(yN, { ...e })
    ] })
  ] });
}
const OP = Tr(RP);
function DP(e) {
  const { operationIndex: t, skipCount: n } = e, r = t + 1, o = n === 1 ? `${r}` : `${r} - ${r + n - 1}`;
  return /* @__PURE__ */ R("article", { className: "grid grid-cols-[1fr,auto,1fr] items-center py-2", children: [
    /* @__PURE__ */ A("div", { className: "h-px rounded-full bg-slate-100" }),
    /* @__PURE__ */ R("div", { className: "mx-3 text-xs text-slate-100", children: [
      "[Skipped Revision ",
      o,
      "]"
    ] }),
    /* @__PURE__ */ A("div", { className: "h-px rounded-full bg-slate-100" })
  ] });
}
function MP(e) {
  var i, s, a, c, u, l, d, f;
  const t = [];
  let n = 0, r = "";
  const o = /* @__PURE__ */ new Set();
  for (; n < e.length; ) {
    const p = e[n], h = p.timestamp.split("T")[0];
    if (h !== r && !o.has(h)) {
      o.add(h), t.push({
        type: "day",
        height: 32,
        timestamp: h
      }), r = h;
      continue;
    }
    if (p.skip > 0) {
      t.push({
        type: "skip",
        height: 18,
        operationIndex: p.index,
        skipCount: p.skip,
        timestamp: p.timestamp
      }), n += p.skip;
      continue;
    } else
      t.push({
        type: "revision",
        height: 46,
        operationIndex: p.index,
        eventId: p.id ?? "EVENT_ID_NOT_FOUND",
        stateHash: p.hash,
        operationType: p.type,
        operationInput: p.input ?? {},
        address: (a = (s = (i = p.context) == null ? void 0 : i.signer) == null ? void 0 : s.user) == null ? void 0 : a.address,
        chainId: (l = (u = (c = p.context) == null ? void 0 : c.signer) == null ? void 0 : u.user) == null ? void 0 : l.chainId,
        timestamp: p.timestamp,
        signatures: VP(
          (f = (d = p.context) == null ? void 0 : d.signer) == null ? void 0 : f.signatures
        ),
        errors: p.error ? [p.error] : void 0
      });
    n += 1;
  }
  return t;
}
function FP(e) {
  const [t, n, r, o] = e;
  return {
    signerAddress: t,
    hash: n,
    prevStateHash: r,
    signatureBytes: o,
    isVerified: !0
  };
}
function VP(e) {
  return e == null ? void 0 : e.map(FP);
}
function BP(e) {
  const { timestamp: t } = e, n = Hi(t, "MMM dd, yyyy");
  return /* @__PURE__ */ R("h2", { className: "-ml-6 flex items-center gap-1 bg-slate-50 py-2 text-xs text-slate-100", children: [
    /* @__PURE__ */ A(J, { name: "Ring", size: 16 }),
    " Changes on ",
    n
  ] });
}
function kP(e) {
  const { localOperations: t, globalOperations: n, scope: r } = e, o = r === "local" ? t : n, i = 100, s = ve(
    () => MP(o.sort((b, v) => v.index - b.index)),
    [o]
  ), [a, c] = Q(0), [u, l] = Q(i), [d, f] = Q(() => s.slice(0, u)), p = Ce(null), h = d.length < s.length, g = bN({
    count: d.length,
    getScrollElement: () => p.current,
    estimateSize: (b) => s[b].height,
    gap: 8
  });
  Ie(() => {
    if (!h) return;
    const b = Math.floor(a / 46), v = i + b;
    l(
      (C) => v > C ? v : C
    );
  }, [a, h]), Ie(() => {
    f(s.slice(0, u));
  }, [s, u]);
  const m = (b) => {
    c((v) => {
      const C = v + b.deltaY;
      return C < 0 ? 0 : C;
    });
  };
  return Ie(() => (window.addEventListener("wheel", m), () => {
    window.removeEventListener("wheel", m);
  }), []), /* @__PURE__ */ A(
    "div",
    {
      ref: p,
      style: {
        height: `${g.getTotalSize()}px`,
        width: "100%",
        position: "relative"
      },
      className: `border-l border-slate-100
            `,
      children: g.getVirtualItems().map((b) => {
        const v = d[b.index];
        return /* @__PURE__ */ A(
          "div",
          {
            style: {
              position: "absolute",
              top: 0,
              left: 16,
              width: "100%",
              height: `${b.size}px`,
              transform: `translateY(${b.start}px)`
            },
            children: /* @__PURE__ */ R(Ee, { children: [
              v.type === "revision" && /* @__PURE__ */ go(OP, { ...v, key: b.key }),
              v.type === "skip" && /* @__PURE__ */ A(DP, { ...v }, b.key),
              v.type === "day" && /* @__PURE__ */ A(BP, { ...v }, b.key)
            ] })
          },
          b.index
        );
      })
    }
  );
}
function jM(e) {
  const {
    documentTitle: t,
    documentId: n,
    globalOperations: r,
    localOperations: o,
    onClose: i
  } = e, [s, a] = Q("global");
  function c(u) {
    a(u);
  }
  return /* @__PURE__ */ A(zg, { children: /* @__PURE__ */ R("div", { className: "h-[calc(100vh-86px)]", children: [
    /* @__PURE__ */ A(
      oN,
      {
        title: t,
        docId: n,
        scope: s,
        onChangeScope: c,
        onClose: i
      }
    ),
    /* @__PURE__ */ A("div", { className: "mt-9 flex h-full justify-center rounded-md bg-slate-50 p-4", children: /* @__PURE__ */ A("div", { className: "grid grid-cols-[minmax(min-content,1018px)]", children: /* @__PURE__ */ A(
      kP,
      {
        scope: s,
        globalOperations: r,
        localOperations: o
      }
    ) }) })
  ] }) });
}
const vf = (e) => {
  const { item: t, ...n } = e;
  return /* @__PURE__ */ R(
    "div",
    {
      ...gn(
        n,
        "flex h-full flex-row items-center justify-between gap-x-4 px-2"
      ),
      children: [
        t.icon,
        /* @__PURE__ */ A("div", { className: "text-sm font-semibold text-slate-200", children: t.label })
      ]
    }
  );
}, UM = (e) => {
  const {
    value: t,
    onChange: n,
    placeholder: r,
    filterLabel: o,
    filterItems: i,
    selectedFilter: s,
    onFilterSelect: a = () => {
    }
  } = e, c = ve(
    () => (i == null ? void 0 : i.map((f) => ({
      id: f.id,
      content: /* @__PURE__ */ A(vf, { item: f })
    }))) ?? [],
    [i]
  ), u = i == null ? void 0 : i.find(
    (f) => f.id === s
  ), l = u ? /* @__PURE__ */ A(vf, { item: u, className: "gap-x-1" }) : o && /* @__PURE__ */ A("div", { className: "mr-2 text-sm font-semibold text-slate-200", children: o });
  function d(f) {
    n(f.target.value);
  }
  return /* @__PURE__ */ R("div", { className: "flex items-center", children: [
    /* @__PURE__ */ A(J, { name: "Search", className: "mr-3" }),
    /* @__PURE__ */ A(
      "input",
      {
        value: t,
        onChange: d,
        placeholder: r,
        className: $(
          "flex h-[52px] min-w-0 flex-1 items-center rounded-xl border border-gray-200 bg-gray-50 px-4 text-sm text-slate-200 outline-none"
        )
      }
    ),
    /* @__PURE__ */ R(vh, { children: [
      /* @__PURE__ */ R(yh, { className: "ml-3 flex h-full flex-row items-center outline-none", children: [
        l,
        " ",
        /* @__PURE__ */ A(J, { name: "ChevronDown" })
      ] }),
      /* @__PURE__ */ A(Ch, { className: "rounded-xl border border-gray-100 bg-gray-50 p-2", children: c.map((f) => /* @__PURE__ */ A(
        xh,
        {
          id: f.id,
          className: "h-10 cursor-pointer overflow-hidden rounded-lg hover:bg-gray-100",
          onSelect: () => a(f.id),
          children: f.content
        },
        f.id
      )) })
    ] })
  ] });
}, LP = "data:image/png;base64,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", HP = "data:image/png;base64,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", XP = "data:image/png;base64,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", WP = "data:image/png;base64,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", ZP = ({ onLogin: e }) => /* @__PURE__ */ R(Ee, { children: [
  /* @__PURE__ */ R(
    "button",
    {
      className: "group/sidebar-footer hidden w-full cursor-pointer items-baseline justify-start text-sm font-semibold leading-10 text-gray-600 expanded:flex",
      onClick: e,
      children: [
        /* @__PURE__ */ A("span", { children: "Login with" }),
        /* @__PURE__ */ A(
          "img",
          {
            src: WP,
            className: "ml-2 h-5 group-hover/sidebar-footer:hidden"
          }
        ),
        /* @__PURE__ */ A(
          "img",
          {
            src: LP,
            className: "ml-2 hidden h-5 group-hover/sidebar-footer:block"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ R(
    "button",
    {
      className: "group/sidebar-footer hidden w-full cursor-pointer place-items-center p-1 collapsed:grid",
      onClick: e,
      "aria-label": "Login with Renown",
      children: [
        /* @__PURE__ */ A(
          "img",
          {
            src: XP,
            className: "group-hover/sidebar-footer:hidden"
          }
        ),
        /* @__PURE__ */ A(
          "img",
          {
            src: HP,
            className: "hidden group-hover/sidebar-footer:block"
          }
        )
      ]
    }
  )
] }), zP = ({ address: e }) => {
  const t = Wm({ address: e }), n = t.isLoading, r = t.data ?? void 0, o = Yg(e);
  return /* @__PURE__ */ R(
    "div",
    {
      className: `flex gap-2 rounded-sm py-2.5 collapsed:justify-center
            collapsed:px-1 expanding:justify-center expanding:px-1`,
      children: [
        /* @__PURE__ */ A(Zm, { address: e, size: "40px" }),
        /* @__PURE__ */ R("div", { className: "grid w-full items-center font-semibold collapsed:hidden expanding:hidden", children: [
          n && /* @__PURE__ */ R(Ee, { children: [
            /* @__PURE__ */ A("p", { className: "mb-2 h-4 w-4/5 animate-pulse rounded bg-gray-400" }),
            /* @__PURE__ */ A("p", { className: "h-3 w-4/5 animate-pulse rounded bg-gray-400" })
          ] }),
          !n && !!r && /* @__PURE__ */ R(Ee, { children: [
            /* @__PURE__ */ A("p", { className: "mb-2 h-4 text-sm text-gray-800 duration-1000 animate-in fade-in", children: r }),
            /* @__PURE__ */ A("p", { className: "h-3 text-xs text-gray-600 duration-1000 animate-in fade-in", children: o })
          ] }),
          !n && !r && /* @__PURE__ */ A("p", { className: "text-sm text-gray-800 duration-1000 animate-in fade-in", children: o })
        ] })
      ]
    }
  );
}, GP = ({
  address: e,
  className: t,
  onLogin: n,
  onClickSettings: r,
  ...o
}) => /* @__PURE__ */ R(
  K5,
  {
    ...o,
    className: $(
      "bg-gray-50 p-4 collapsed:px-1 expanding:px-1",
      t
    ),
    children: [
      /* @__PURE__ */ A("div", { className: "collapsed:bg-transparent collapsing:bg-transparent expanding:bg-transparent", children: e ? /* @__PURE__ */ A(zP, { address: e }) : /* @__PURE__ */ A(ZP, { onLogin: n }) }),
      /* @__PURE__ */ R(
        "button",
        {
          className: "mt-3 flex w-full cursor-pointer gap-3 outline-none collapsed:px-3 expanding:px-3",
          onClick: r,
          children: [
            /* @__PURE__ */ A(J, { name: "Settings", className: "text-gray-600" }),
            /* @__PURE__ */ A("span", { className: "text-sm font-semibold leading-6 text-gray-800 collapsed:hidden expanding:hidden", children: "Settings" })
          ]
        }
      )
    ]
  }
), jP = ({
  onToggle: e,
  className: t,
  children: n,
  ...r
}) => /* @__PURE__ */ R(
  J5,
  {
    ...r,
    className: $(
      "mb-4 flex justify-between gap-4 px-4 pt-11 collapsed:justify-center",
      t
    ),
    children: [
      /* @__PURE__ */ A("div", { className: "collapsed:hidden expanding:hidden", children: n || /* @__PURE__ */ A(
        "input",
        {
          placeholder: "Create new document",
          className: "flex-1 rounded-md border border-gray-100 px-5 py-3 leading-none text-gray-600 placeholder-shown:bg-transparent"
        }
      ) }),
      /* @__PURE__ */ A(
        "button",
        {
          className: `rounded-md border border-gray-100 p-3 outline-none hover:bg-slate-50
                collapsed:rotate-180 collapsed:border-gray-100/10 collapsed:bg-gray-100
                collapsed:shadow-sidebar collapsed:hover:bg-slate-50
                expanding:hidden`,
          onClick: () => e(),
          children: /* @__PURE__ */ A(J, { name: "ArrowLeft", size: 16, className: "text-gray-600" })
        }
      )
    ]
  }
), QM = ({
  onToggle: e,
  address: t,
  headerContent: n,
  onClickSettings: r,
  collapsed: o = !1,
  maxWidth: i = "304px",
  minWidth: s = "58px",
  onLogin: a,
  ...c
}) => /* @__PURE__ */ R(
  _5,
  {
    ...c,
    collapsed: o,
    maxWidth: i,
    minWidth: s,
    children: [
      /* @__PURE__ */ R($5, { children: [
        /* @__PURE__ */ A(jP, { onToggle: e, children: n }),
        /* @__PURE__ */ A("div", { className: "hidden expanded:block", children: c.children })
      ] }),
      /* @__PURE__ */ A(
        GP,
        {
          address: t,
          onLogin: a,
          onClickSettings: r
        }
      )
    ]
  }
);
function Pg(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = Pg(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Hn() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = Pg(e)) && (r && (r += " "), r += t);
  return r;
}
const Xi = (e) => typeof e == "number" && !isNaN(e), hr = (e) => typeof e == "string", Et = (e) => typeof e == "function", Ys = (e) => hr(e) || Et(e) ? e : null, ml = (e) => Yr(e) || hr(e) || Et(e) || Xi(e);
function UP(e, t, n) {
  n === void 0 && (n = 300);
  const { scrollHeight: r, style: o } = e;
  requestAnimationFrame(() => {
    o.minHeight = "initial", o.height = r + "px", o.transition = `all ${n}ms`, requestAnimationFrame(() => {
      o.height = "0", o.padding = "0", o.margin = "0", setTimeout(t, n);
    });
  });
}
function _a(e) {
  let { enter: t, exit: n, appendPosition: r = !1, collapse: o = !0, collapseDuration: i = 300 } = e;
  return function(s) {
    let { children: a, position: c, preventExitTransition: u, done: l, nodeRef: d, isIn: f, playToast: p } = s;
    const h = r ? `${t}--${c}` : t, g = r ? `${n}--${c}` : n, m = Ce(0);
    return Yn(() => {
      const b = d.current, v = h.split(" "), C = (w) => {
        w.target === d.current && (p(), b.removeEventListener("animationend", C), b.removeEventListener("animationcancel", C), m.current === 0 && w.type !== "animationcancel" && b.classList.remove(...v));
      };
      b.classList.add(...v), b.addEventListener("animationend", C), b.addEventListener("animationcancel", C);
    }, []), Ie(() => {
      const b = d.current, v = () => {
        b.removeEventListener("animationend", v), o ? UP(b, l, i) : l();
      };
      f || (u ? v() : (m.current = 1, b.className += ` ${g}`, b.addEventListener("animationend", v)));
    }, [f]), Y.createElement(Y.Fragment, null, a);
  };
}
function yf(e, t) {
  return e != null ? { content: e.content, containerId: e.props.containerId, id: e.props.toastId, theme: e.props.theme, type: e.props.type, data: e.props.data || {}, isLoading: e.props.isLoading, icon: e.props.icon, status: t } : {};
}
const ht = /* @__PURE__ */ new Map();
let Wi = [];
const gl = /* @__PURE__ */ new Set(), QP = (e) => gl.forEach((t) => t(e)), Rg = () => ht.size > 0;
function Og(e, t) {
  var n;
  if (t) return !((n = ht.get(t)) == null || !n.isToastActive(e));
  let r = !1;
  return ht.forEach((o) => {
    o.isToastActive(e) && (r = !0);
  }), r;
}
function Dg(e, t) {
  ml(e) && (Rg() || Wi.push({ content: e, options: t }), ht.forEach((n) => {
    n.buildToast(e, t);
  }));
}
function Cf(e, t) {
  ht.forEach((n) => {
    t != null && t != null && t.containerId ? (t == null ? void 0 : t.containerId) === n.id && n.toggle(e, t == null ? void 0 : t.id) : n.toggle(e, t == null ? void 0 : t.id);
  });
}
function qP(e) {
  const { subscribe: t, getSnapshot: n, setProps: r } = Ce(function(i) {
    const s = i.containerId || 1;
    return { subscribe(a) {
      const c = /* @__PURE__ */ function(l, d, f) {
        let p = 1, h = 0, g = [], m = [], b = [], v = d;
        const C = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Set(), y = () => {
          b = Array.from(C.values()), w.forEach((E) => E());
        }, I = (E) => {
          m = E == null ? [] : m.filter((P) => P !== E), y();
        }, x = (E) => {
          const { toastId: P, onOpen: L, updateId: W, children: V } = E.props, X = W == null;
          E.staleId && C.delete(E.staleId), C.set(P, E), m = [...m, E.props.toastId].filter((N) => N !== E.staleId), y(), f(yf(E, X ? "added" : "updated")), X && Et(L) && L(Yr(V) && V.props);
        };
        return { id: l, props: v, observe: (E) => (w.add(E), () => w.delete(E)), toggle: (E, P) => {
          C.forEach((L) => {
            P != null && P !== L.props.toastId || Et(L.toggle) && L.toggle(E);
          });
        }, removeToast: I, toasts: C, clearQueue: () => {
          h -= g.length, g = [];
        }, buildToast: (E, P) => {
          if (((z) => {
            let { containerId: ce, toastId: be, updateId: te } = z;
            const ue = ce ? ce !== l : l !== 1, me = C.has(be) && te == null;
            return ue || me;
          })(P)) return;
          const { toastId: L, updateId: W, data: V, staleId: X, delay: N } = P, M = () => {
            I(L);
          }, F = W == null;
          F && h++;
          const B = { ...v, style: v.toastStyle, key: p++, ...Object.fromEntries(Object.entries(P).filter((z) => {
            let [ce, be] = z;
            return be != null;
          })), toastId: L, updateId: W, data: V, closeToast: M, isIn: !1, className: Ys(P.className || v.toastClassName), bodyClassName: Ys(P.bodyClassName || v.bodyClassName), progressClassName: Ys(P.progressClassName || v.progressClassName), autoClose: !P.isLoading && (Z = P.autoClose, H = v.autoClose, Z === !1 || Xi(Z) && Z > 0 ? Z : H), deleteToast() {
            const z = C.get(L), { onClose: ce, children: be } = z.props;
            Et(ce) && ce(Yr(be) && be.props), f(yf(z, "removed")), C.delete(L), h--, h < 0 && (h = 0), g.length > 0 ? x(g.shift()) : y();
          } };
          var Z, H;
          B.closeButton = v.closeButton, P.closeButton === !1 || ml(P.closeButton) ? B.closeButton = P.closeButton : P.closeButton === !0 && (B.closeButton = !ml(v.closeButton) || v.closeButton);
          let K = E;
          Yr(E) && !hr(E.type) ? K = uu(E, { closeToast: M, toastProps: B, data: V }) : Et(E) && (K = E({ closeToast: M, toastProps: B, data: V }));
          const ee = { content: K, props: B, staleId: X };
          v.limit && v.limit > 0 && h > v.limit && F ? g.push(ee) : Xi(N) ? setTimeout(() => {
            x(ee);
          }, N) : x(ee);
        }, setProps(E) {
          v = E;
        }, setToggle: (E, P) => {
          C.get(E).toggle = P;
        }, isToastActive: (E) => m.some((P) => P === E), getSnapshot: () => v.newestOnTop ? b.reverse() : b };
      }(s, i, QP);
      ht.set(s, c);
      const u = c.observe(a);
      return Wi.forEach((l) => Dg(l.content, l.options)), Wi = [], () => {
        u(), ht.delete(s);
      };
    }, setProps(a) {
      var c;
      (c = ht.get(s)) == null || c.setProps(a);
    }, getSnapshot() {
      var a;
      return (a = ht.get(s)) == null ? void 0 : a.getSnapshot();
    } };
  }(e)).current;
  r(e);
  const o = Wf(t, n, n);
  return { getToastToRender: function(i) {
    if (!o) return [];
    const s = /* @__PURE__ */ new Map();
    return o.forEach((a) => {
      const { position: c } = a.props;
      s.has(c) || s.set(c, []), s.get(c).push(a);
    }), Array.from(s, (a) => i(a[0], a[1]));
  }, isToastActive: Og, count: o == null ? void 0 : o.length };
}
function YP(e) {
  const [t, n] = Q(!1), [r, o] = Q(!1), i = Ce(null), s = Ce({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, didMove: !1 }).current, { autoClose: a, pauseOnHover: c, closeToast: u, onClick: l, closeOnClick: d } = e;
  var f, p;
  function h() {
    n(!0);
  }
  function g() {
    n(!1);
  }
  function m(C) {
    const w = i.current;
    s.canDrag && w && (s.didMove = !0, t && g(), s.delta = e.draggableDirection === "x" ? C.clientX - s.start : C.clientY - s.start, s.start !== C.clientX && (s.canCloseOnClick = !1), w.style.transform = `translate3d(${e.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`},0)`, w.style.opacity = "" + (1 - Math.abs(s.delta / s.removalDistance)));
  }
  function b() {
    document.removeEventListener("pointermove", m), document.removeEventListener("pointerup", b);
    const C = i.current;
    if (s.canDrag && s.didMove && C) {
      if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) return o(!0), e.closeToast(), void e.collapseAll();
      C.style.transition = "transform 0.2s, opacity 0.2s", C.style.removeProperty("transform"), C.style.removeProperty("opacity");
    }
  }
  (p = ht.get((f = { id: e.toastId, containerId: e.containerId, fn: n }).containerId || 1)) == null || p.setToggle(f.id, f.fn), Ie(() => {
    if (e.pauseOnFocusLoss) return document.hasFocus() || g(), window.addEventListener("focus", h), window.addEventListener("blur", g), () => {
      window.removeEventListener("focus", h), window.removeEventListener("blur", g);
    };
  }, [e.pauseOnFocusLoss]);
  const v = { onPointerDown: function(C) {
    if (e.draggable === !0 || e.draggable === C.pointerType) {
      s.didMove = !1, document.addEventListener("pointermove", m), document.addEventListener("pointerup", b);
      const w = i.current;
      s.canCloseOnClick = !0, s.canDrag = !0, w.style.transition = "none", e.draggableDirection === "x" ? (s.start = C.clientX, s.removalDistance = w.offsetWidth * (e.draggablePercent / 100)) : (s.start = C.clientY, s.removalDistance = w.offsetHeight * (e.draggablePercent === 80 ? 1.5 * e.draggablePercent : e.draggablePercent) / 100);
    }
  }, onPointerUp: function(C) {
    const { top: w, bottom: y, left: I, right: x } = i.current.getBoundingClientRect();
    C.nativeEvent.type !== "touchend" && e.pauseOnHover && C.clientX >= I && C.clientX <= x && C.clientY >= w && C.clientY <= y ? g() : h();
  } };
  return a && c && (v.onMouseEnter = g, e.stacked || (v.onMouseLeave = h)), d && (v.onClick = (C) => {
    l && l(C), s.canCloseOnClick && u();
  }), { playToast: h, pauseToast: g, isRunning: t, preventExitTransition: r, toastRef: i, eventHandlers: v };
}
function JP(e) {
  let { delay: t, isRunning: n, closeToast: r, type: o = "default", hide: i, className: s, style: a, controlledProgress: c, progress: u, rtl: l, isIn: d, theme: f } = e;
  const p = i || c && u === 0, h = { ...a, animationDuration: `${t}ms`, animationPlayState: n ? "running" : "paused" };
  c && (h.transform = `scaleX(${u})`);
  const g = Hn("Toastify__progress-bar", c ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${f}`, `Toastify__progress-bar--${o}`, { "Toastify__progress-bar--rtl": l }), m = Et(s) ? s({ rtl: l, type: o, defaultClassName: g }) : Hn(g, s), b = { [c && u >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: c && u < 1 ? null : () => {
    d && r();
  } };
  return Y.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": p }, Y.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${f} Toastify__progress-bar--${o}` }), Y.createElement("div", { role: "progressbar", "aria-hidden": p ? "true" : "false", "aria-label": "notification timer", className: m, style: h, ...b }));
}
let KP = 1;
const Mg = () => "" + KP++;
function _P(e) {
  return e && (hr(e.toastId) || Xi(e.toastId)) ? e.toastId : Mg();
}
function li(e, t) {
  return Dg(e, t), t.toastId;
}
function Ia(e, t) {
  return { ...t, type: t && t.type || e, toastId: _P(t) };
}
function Ms(e) {
  return (t, n) => li(t, Ia(e, n));
}
function Le(e, t) {
  return li(e, Ia("default", t));
}
Le.loading = (e, t) => li(e, Ia("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...t })), Le.promise = function(e, t, n) {
  let r, { pending: o, error: i, success: s } = t;
  o && (r = hr(o) ? Le.loading(o, n) : Le.loading(o.render, { ...n, ...o }));
  const a = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, c = (l, d, f) => {
    if (d == null) return void Le.dismiss(r);
    const p = { type: l, ...a, ...n, data: f }, h = hr(d) ? { render: d } : d;
    return r ? Le.update(r, { ...p, ...h }) : Le(h.render, { ...p, ...h }), f;
  }, u = Et(e) ? e() : e;
  return u.then((l) => c("success", s, l)).catch((l) => c("error", i, l)), u;
}, Le.success = Ms("success"), Le.info = Ms("info"), Le.error = Ms("error"), Le.warning = Ms("warning"), Le.warn = Le.warning, Le.dark = (e, t) => li(e, Ia("default", { theme: "dark", ...t })), Le.dismiss = function(e) {
  (function(t) {
    var n;
    if (Rg()) {
      if (t == null || hr(n = t) || Xi(n)) ht.forEach((r) => {
        r.removeToast(t);
      });
      else if (t && ("containerId" in t || "id" in t)) {
        const r = ht.get(t.containerId);
        r ? r.removeToast(t.id) : ht.forEach((o) => {
          o.removeToast(t.id);
        });
      }
    } else Wi = Wi.filter((r) => t != null && r.options.toastId !== t);
  })(e);
}, Le.clearWaitingQueue = function(e) {
  e === void 0 && (e = {}), ht.forEach((t) => {
    !t.props.limit || e.containerId && t.id !== e.containerId || t.clearQueue();
  });
}, Le.isActive = Og, Le.update = function(e, t) {
  t === void 0 && (t = {});
  const n = ((r, o) => {
    var i;
    let { containerId: s } = o;
    return (i = ht.get(s || 1)) == null ? void 0 : i.toasts.get(r);
  })(e, t);
  if (n) {
    const { props: r, content: o } = n, i = { delay: 100, ...r, ...t, toastId: t.toastId || e, updateId: Mg() };
    i.toastId !== e && (i.staleId = e);
    const s = i.render || o;
    delete i.render, li(s, i);
  }
}, Le.done = (e) => {
  Le.update(e, { progress: 1 });
}, Le.onChange = function(e) {
  return gl.add(e), () => {
    gl.delete(e);
  };
}, Le.play = (e) => Cf(!0, e), Le.pause = (e) => Cf(!1, e);
const $P = typeof window < "u" ? Yn : Ie, Fs = (e) => {
  let { theme: t, type: n, isLoading: r, ...o } = e;
  return Y.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${n})`, ...o });
}, $c = { info: function(e) {
  return Y.createElement(Fs, { ...e }, Y.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(e) {
  return Y.createElement(Fs, { ...e }, Y.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(e) {
  return Y.createElement(Fs, { ...e }, Y.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(e) {
  return Y.createElement(Fs, { ...e }, Y.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return Y.createElement("div", { className: "Toastify__spinner" });
} }, eR = (e) => {
  const { isRunning: t, preventExitTransition: n, toastRef: r, eventHandlers: o, playToast: i } = YP(e), { closeButton: s, children: a, autoClose: c, onClick: u, type: l, hideProgressBar: d, closeToast: f, transition: p, position: h, className: g, style: m, bodyClassName: b, bodyStyle: v, progressClassName: C, progressStyle: w, updateId: y, role: I, progress: x, rtl: E, toastId: P, deleteToast: L, isIn: W, isLoading: V, closeOnClick: X, theme: N } = e, M = Hn("Toastify__toast", `Toastify__toast-theme--${N}`, `Toastify__toast--${l}`, { "Toastify__toast--rtl": E }, { "Toastify__toast--close-on-click": X }), F = Et(g) ? g({ rtl: E, position: h, type: l, defaultClassName: M }) : Hn(M, g), B = function(ee) {
    let { theme: z, type: ce, isLoading: be, icon: te } = ee, ue = null;
    const me = { theme: z, type: ce };
    return te === !1 || (Et(te) ? ue = te({ ...me, isLoading: be }) : Yr(te) ? ue = uu(te, me) : be ? ue = $c.spinner() : ((Te) => Te in $c)(ce) && (ue = $c[ce](me))), ue;
  }(e), Z = !!x || !c, H = { closeToast: f, type: l, theme: N };
  let K = null;
  return s === !1 || (K = Et(s) ? s(H) : Yr(s) ? uu(s, H) : function(ee) {
    let { closeToast: z, theme: ce, ariaLabel: be = "close" } = ee;
    return Y.createElement("button", { className: `Toastify__close-button Toastify__close-button--${ce}`, type: "button", onClick: (te) => {
      te.stopPropagation(), z(te);
    }, "aria-label": be }, Y.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, Y.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
  }(H)), Y.createElement(p, { isIn: W, done: L, position: h, preventExitTransition: n, nodeRef: r, playToast: i }, Y.createElement("div", { id: P, onClick: u, "data-in": W, className: F, ...o, style: m, ref: r }, Y.createElement("div", { ...W && { role: I }, className: Et(b) ? b({ type: l }) : Hn("Toastify__toast-body", b), style: v }, B != null && Y.createElement("div", { className: Hn("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !V }) }, B), Y.createElement("div", null, a)), K, Y.createElement(JP, { ...y && !Z ? { key: `pb-${y}` } : {}, rtl: E, theme: N, delay: c, isRunning: t, isIn: W, closeToast: f, hide: d, type: l, style: w, className: C, controlledProgress: Z, progress: x || 0 })));
}, $a = function(e, t) {
  return t === void 0 && (t = !1), { enter: `Toastify--animate Toastify__${e}-enter`, exit: `Toastify--animate Toastify__${e}-exit`, appendPosition: t };
}, tR = _a($a("bounce", !0));
_a($a("slide", !0));
_a($a("zoom"));
_a($a("flip"));
const nR = { position: "top-right", transition: tR, autoClose: 5e3, closeButton: !0, pauseOnHover: !0, pauseOnFocusLoss: !0, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
function rR(e) {
  let t = { ...nR, ...e };
  const n = e.stacked, [r, o] = Q(!0), i = Ce(null), { getToastToRender: s, isToastActive: a, count: c } = qP(t), { className: u, style: l, rtl: d, containerId: f } = t;
  function p(g) {
    const m = Hn("Toastify__toast-container", `Toastify__toast-container--${g}`, { "Toastify__toast-container--rtl": d });
    return Et(u) ? u({ position: g, rtl: d, defaultClassName: m }) : Hn(m, Ys(u));
  }
  function h() {
    n && (o(!0), Le.play());
  }
  return $P(() => {
    if (n) {
      var g;
      const m = i.current.querySelectorAll('[data-in="true"]'), b = 12, v = (g = t.position) == null ? void 0 : g.includes("top");
      let C = 0, w = 0;
      Array.from(m).reverse().forEach((y, I) => {
        const x = y;
        x.classList.add("Toastify__toast--stacked"), I > 0 && (x.dataset.collapsed = `${r}`), x.dataset.pos || (x.dataset.pos = v ? "top" : "bot");
        const E = C * (r ? 0.2 : 1) + (r ? 0 : b * I);
        x.style.setProperty("--y", `${v ? E : -1 * E}px`), x.style.setProperty("--g", `${b}`), x.style.setProperty("--s", "" + (1 - (r ? w : 0))), C += x.offsetHeight, w += 0.025;
      });
    }
  }, [r, c, n]), Y.createElement("div", { ref: i, className: "Toastify", id: f, onMouseEnter: () => {
    n && (o(!1), Le.pause());
  }, onMouseLeave: h }, s((g, m) => {
    const b = m.length ? { ...l } : { ...l, pointerEvents: "none" };
    return Y.createElement("div", { className: p(g), style: b, key: `container-${g}` }, m.map((v) => {
      let { content: C, props: w } = v;
      return Y.createElement(eR, { ...w, stacked: n, collapseAll: h, isIn: a(w.toastId, w.containerId), style: w.style, key: `toast-${w.key}` }, C);
    }));
  }));
}
function oR(e) {
  return e === "connect-success" || e === "connect-warning" || e === "connect-loading" || e === "connect-deleted";
}
function iR(e) {
  if (oR(e)) {
    const t = {};
    switch (e) {
      case "connect-success":
        t.type = "success", t.icon = /* @__PURE__ */ A(
          J,
          {
            size: 24,
            name: "CheckCircleFill",
            className: "text-green-800"
          }
        );
        break;
      case "connect-warning":
        t.type = "warning", t.icon = /* @__PURE__ */ A(
          J,
          {
            size: 24,
            name: "WarningFill",
            className: "text-gray-600"
          }
        );
        break;
      case "connect-loading":
        t.type = "default", t.icon = /* @__PURE__ */ A(
          J,
          {
            size: 24,
            name: "ClockFill",
            className: "text-gray-600"
          }
        );
        break;
      case "connect-deleted":
        t.type = "error", t.icon = /* @__PURE__ */ A(J, { size: 24, name: "TrashFill", className: "text-red-800" });
        break;
    }
    return t;
  }
  return { type: e };
}
function qM(e, t) {
  const { type: n = "default", ...r } = t || {}, o = iR(n);
  return Le(e, { ...o, ...r });
}
const sR = ({ closeToast: e }) => /* @__PURE__ */ A(
  "button",
  {
    onClick: e,
    className: "flex items-center text-gray-500 hover:text-gray-600",
    children: /* @__PURE__ */ A(J, { name: "XmarkLight", size: 16 })
  }
), YM = (e) => /* @__PURE__ */ A(rR, { closeButton: sR, ...e }), aR = Pt(function(t, n) {
  return /* @__PURE__ */ R(
    "label",
    {
      htmlFor: t.id,
      className: "relative cursor-pointer items-center",
      children: [
        /* @__PURE__ */ A(
          "input",
          {
            ref: n,
            type: "checkbox",
            value: "",
            className: "peer sr-only",
            ...t
          }
        ),
        /* @__PURE__ */ A("div", { className: "peer h-6 w-11 rounded-full bg-gray-500 after:absolute after:start-0.5 after:top-0.5 after:size-5 after:rounded-full after:border after:border-none after:bg-gray-50 after:transition-all peer-checked:bg-blue-900 peer-checked:after:translate-x-full peer-focus:outline-none" })
      ]
    }
  );
});
var cR = "VisuallyHidden", Fg = S.forwardRef(
  (e, t) => /* @__PURE__ */ A(
    Xe.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Fg.displayName = cR;
var uR = Fg, [ec, JM] = Jn("Tooltip", [
  Oa
]), tc = Oa(), Vg = "TooltipProvider", lR = 700, bl = "tooltip.open", [dR, Yd] = ec(Vg), Bg = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = lR,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, [s, a] = S.useState(!0), c = S.useRef(!1), u = S.useRef(0);
  return S.useEffect(() => {
    const l = u.current;
    return () => window.clearTimeout(l);
  }, []), /* @__PURE__ */ A(
    dR,
    {
      scope: t,
      isOpenDelayed: s,
      delayDuration: n,
      onOpen: S.useCallback(() => {
        window.clearTimeout(u.current), a(!1);
      }, []),
      onClose: S.useCallback(() => {
        window.clearTimeout(u.current), u.current = window.setTimeout(
          () => a(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: S.useCallback((l) => {
        c.current = l;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
Bg.displayName = Vg;
var nc = "Tooltip", [AR, is] = ec(nc), kg = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: i,
    disableHoverableContent: s,
    delayDuration: a
  } = e, c = Yd(nc, e.__scopeTooltip), u = tc(t), [l, d] = S.useState(null), f = Xn(), p = S.useRef(0), h = s ?? c.disableHoverableContent, g = a ?? c.delayDuration, m = S.useRef(!1), [b = !1, v] = Ji({
    prop: r,
    defaultProp: o,
    onChange: (x) => {
      x ? (c.onOpen(), document.dispatchEvent(new CustomEvent(bl))) : c.onClose(), i == null || i(x);
    }
  }), C = S.useMemo(() => b ? m.current ? "delayed-open" : "instant-open" : "closed", [b]), w = S.useCallback(() => {
    window.clearTimeout(p.current), m.current = !1, v(!0);
  }, [v]), y = S.useCallback(() => {
    window.clearTimeout(p.current), v(!1);
  }, [v]), I = S.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      m.current = !0, v(!0);
    }, g);
  }, [g, v]);
  return S.useEffect(() => () => window.clearTimeout(p.current), []), /* @__PURE__ */ A(C0, { ...u, children: /* @__PURE__ */ A(
    AR,
    {
      scope: t,
      contentId: f,
      open: b,
      stateAttribute: C,
      trigger: l,
      onTriggerChange: d,
      onTriggerEnter: S.useCallback(() => {
        c.isOpenDelayed ? I() : w();
      }, [c.isOpenDelayed, I, w]),
      onTriggerLeave: S.useCallback(() => {
        h ? y() : window.clearTimeout(p.current);
      }, [y, h]),
      onOpen: w,
      onClose: y,
      disableHoverableContent: h,
      children: n
    }
  ) });
};
kg.displayName = nc;
var vl = "TooltipTrigger", Lg = S.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = is(vl, n), i = Yd(vl, n), s = tc(n), a = S.useRef(null), c = _e(t, a, o.onTriggerChange), u = S.useRef(!1), l = S.useRef(!1), d = S.useCallback(() => u.current = !1, []);
    return S.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ A(x0, { asChild: !0, ...s, children: /* @__PURE__ */ A(
      Xe.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: c,
        onPointerMove: he(e.onPointerMove, (f) => {
          f.pointerType !== "touch" && !l.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), l.current = !0);
        }),
        onPointerLeave: he(e.onPointerLeave, () => {
          o.onTriggerLeave(), l.current = !1;
        }),
        onPointerDown: he(e.onPointerDown, () => {
          u.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: he(e.onFocus, () => {
          u.current || o.onOpen();
        }),
        onBlur: he(e.onBlur, o.onClose),
        onClick: he(e.onClick, o.onClose)
      }
    ) });
  }
);
Lg.displayName = vl;
var Jd = "TooltipPortal", [fR, hR] = ec(Jd, {
  forceMount: void 0
}), Hg = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = is(Jd, t);
  return /* @__PURE__ */ A(fR, { scope: t, forceMount: n, children: /* @__PURE__ */ A(Yt, { present: n || i.open, children: /* @__PURE__ */ A(Da, { asChild: !0, container: o, children: r }) }) });
};
Hg.displayName = Jd;
var So = "TooltipContent", Xg = S.forwardRef(
  (e, t) => {
    const n = hR(So, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, s = is(So, e.__scopeTooltip);
    return /* @__PURE__ */ A(Yt, { present: r || s.open, children: s.disableHoverableContent ? /* @__PURE__ */ A(Wg, { side: o, ...i, ref: t }) : /* @__PURE__ */ A(pR, { side: o, ...i, ref: t }) });
  }
), pR = S.forwardRef((e, t) => {
  const n = is(So, e.__scopeTooltip), r = Yd(So, e.__scopeTooltip), o = S.useRef(null), i = _e(t, o), [s, a] = S.useState(null), { trigger: c, onClose: u } = n, l = o.current, { onPointerInTransitChange: d } = r, f = S.useCallback(() => {
    a(null), d(!1);
  }, [d]), p = S.useCallback(
    (h, g) => {
      const m = h.currentTarget, b = { x: h.clientX, y: h.clientY }, v = vR(b, m.getBoundingClientRect()), C = yR(b, v), w = CR(g.getBoundingClientRect()), y = wR([...C, ...w]);
      a(y), d(!0);
    },
    [d]
  );
  return S.useEffect(() => () => f(), [f]), S.useEffect(() => {
    if (c && l) {
      const h = (m) => p(m, l), g = (m) => p(m, c);
      return c.addEventListener("pointerleave", h), l.addEventListener("pointerleave", g), () => {
        c.removeEventListener("pointerleave", h), l.removeEventListener("pointerleave", g);
      };
    }
  }, [c, l, p, f]), S.useEffect(() => {
    if (s) {
      const h = (g) => {
        const m = g.target, b = { x: g.clientX, y: g.clientY }, v = (c == null ? void 0 : c.contains(m)) || (l == null ? void 0 : l.contains(m)), C = !xR(b, s);
        v ? f() : C && (f(), u());
      };
      return document.addEventListener("pointermove", h), () => document.removeEventListener("pointermove", h);
    }
  }, [c, l, s, u, f]), /* @__PURE__ */ A(Wg, { ...e, ref: i });
}), [mR, gR] = ec(nc, { isInside: !1 }), Wg = S.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      ...a
    } = e, c = is(So, n), u = tc(n), { onClose: l } = c;
    return S.useEffect(() => (document.addEventListener(bl, l), () => document.removeEventListener(bl, l)), [l]), S.useEffect(() => {
      if (c.trigger) {
        const d = (f) => {
          const p = f.target;
          p != null && p.contains(c.trigger) && l();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [c.trigger, l]), /* @__PURE__ */ A(
      Na,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: s,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: l,
        children: /* @__PURE__ */ R(
          w0,
          {
            "data-state": c.stateAttribute,
            ...u,
            ...a,
            ref: t,
            style: {
              ...a.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ A(qf, { children: r }),
              /* @__PURE__ */ A(mR, { scope: n, isInside: !0, children: /* @__PURE__ */ A(uR, { id: c.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
Xg.displayName = So;
var Zg = "TooltipArrow", bR = S.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = tc(n);
    return gR(
      Zg,
      n
    ).isInside ? null : /* @__PURE__ */ A(I0, { ...o, ...r, ref: t });
  }
);
bR.displayName = Zg;
function vR(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function yR(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function CR(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function xR(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const a = t[i].x, c = t[i].y, u = t[s].x, l = t[s].y;
    c > r != l > r && n < (u - a) * (r - c) / (l - c) + a && (o = !o);
  }
  return o;
}
function wR(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), IR(t);
}
function IR(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], s = t[t.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], s = n[n.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var ER = Bg, SR = kg, TR = Lg, NR = Hg, PR = Xg;
function Or(e) {
  const {
    children: t,
    content: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    className: s,
    ...a
  } = e;
  return /* @__PURE__ */ R(
    SR,
    {
      open: r,
      defaultOpen: o,
      onOpenChange: i,
      delayDuration: 0,
      children: [
        /* @__PURE__ */ A(TR, { asChild: !0, children: t }),
        /* @__PURE__ */ A(NR, { children: /* @__PURE__ */ A(
          PR,
          {
            ...a,
            className: $(
              "rounded-lg border border-gray-200 bg-white p-2 text-xs shadow-tooltip",
              s
            ),
            children: n
          }
        ) })
      ]
    }
  );
}
const zg = ER;
function RR(e) {
  const { uiNode: t, position: n, className: r, getParentNode: o } = e, i = o(t), { isDropTarget: s, dropProps: a } = $d({
    ...e,
    uiNode: i
  });
  return /* @__PURE__ */ A(
    "div",
    {
      ...a,
      className: $(
        "absolute left-0 z-10 flex h-0.5 w-full",
        n === "before" ? "top-0" : "bottom-0",
        s && "bg-blue-800",
        r
      )
    }
  );
}
function Gg(e) {
  const {
    uiNode: t,
    nodeOptions: n,
    level: r = 0,
    isAllowedToCreateDocuments: o,
    customDocumentIconSrc: i,
    setSelectedNode: s,
    getIsInSelectedNodePath: a,
    getIsSelected: c,
    onClick: u,
    onAddFolder: l,
    onRenameNode: d,
    onDuplicateNode: f,
    onDeleteNode: p,
    onDeleteDrive: h,
    showDriveSettingsModal: g,
    onAddTrigger: m,
    onRemoveTrigger: b,
    onAddInvalidTrigger: v
  } = e, [C, w] = Q(zt), [y, I] = Q(!1), [x, E] = Q(!0), [P, L] = Q(!1), { dragProps: W } = _d(e), { isDropTarget: V, dropProps: X } = $d(e), N = 10, M = t.kind !== Je ? t.children : null, F = !!M && M.length > 0, B = c(t), Z = a(t), H = y ? x : Z, K = t.kind === St, ee = K && t.sharingType === _t, z = K && t.sharingType === ko, ce = K && t.sharingType === Dr, be = nt(), te = $(
    "text-gray-600 transition-colors group-hover/node:text-gray-900",
    B && "text-gray-900"
  ), ue = {
    [Mr]: () => f(t),
    [ss]: () => {
      s(t), E(!0), w(Vs);
    },
    [_n]: () => w(qr),
    [Fr]: () => {
      t.kind === St ? h(t) : p(t);
    },
    [oc]: () => {
      t.kind === St && g(t);
    },
    [cs]: () => m(t.driveId),
    [as]: () => b(t.driveId),
    [us]: () => v(t.driveId)
  }, me = n[t.sharingType][t.kind], Te = Object.entries(Kd).map(([pe, Ze]) => ({
    ...Ze,
    id: pe
  })).filter((pe) => me.includes(pe.id));
  function Be(pe) {
    const Ze = ue[pe];
    if (!Ze) {
      console.error(`No handler found for dropdown menu item: ${pe}`);
      return;
    }
    Ze(), L(!1);
  }
  function et(pe) {
    C === Vs ? (l(pe, t), s(t)) : d(pe, t), w(zt);
  }
  const it = (pe) => {
    if (pe.stopPropagation(), u == null || u(pe), C !== qr) {
      if (s(t), !y) {
        I(!0);
        return;
      }
      E((Ze) => !Ze);
    }
  };
  function re() {
    w(zt);
  }
  function Ge() {
    return ce ? k : z ? O : ee ? T : t.kind === Je ? ie : H ? $n : Rt;
  }
  function nt() {
    return !!(V || C === qr || C === Vs || P || B);
  }
  const Rt = /* @__PURE__ */ A(J, { name: "FolderClose", className: te, size: 20 }), $n = /* @__PURE__ */ A(J, { name: "FolderOpen", className: te, size: 22 }), ie = /* @__PURE__ */ A(
    "img",
    {
      src: Jg(
        t.kind === Je ? t.documentType : rc,
        i
      ),
      alt: "file icon",
      className: "size-7 object-contain"
    }
  ), T = /* @__PURE__ */ A(J, { name: "Hdd" }), O = /* @__PURE__ */ A(J, { name: "Server" }), k = "icon" in t && t.icon ? /* @__PURE__ */ A(
    "img",
    {
      src: t.icon,
      className: "size-6 object-contain",
      alt: "drive icon"
    }
  ) : /* @__PURE__ */ A(J, { name: "M" }), q = /* @__PURE__ */ A(
    J,
    {
      name: "Caret",
      className: $(
        H && "rotate-90",
        "ease pointer-events-none transition delay-75"
      )
    }
  ), U = /* @__PURE__ */ A("div", { className: "mr-2 w-5 flex-none", children: Ge() }), G = /* @__PURE__ */ R("div", { className: "group/node grid w-full grid-cols-[1fr,auto] items-center justify-between", children: [
    /* @__PURE__ */ A("p", { className: "mr-1 truncate", children: t.name }),
    o && /* @__PURE__ */ A(
      cd,
      {
        open: P,
        onOpenChange: L,
        onItemClick: Be,
        items: Te,
        children: /* @__PURE__ */ A(
          "button",
          {
            onClick: (pe) => {
              pe.stopPropagation(), L(!0);
            },
            className: $(
              "hidden group-hover/node:block",
              P && "block"
            ),
            children: /* @__PURE__ */ A(J, { name: "VerticalDots", className: "text-gray-600" })
          }
        )
      }
    )
  ] }), oe = /* @__PURE__ */ A(
    ki,
    {
      defaultValue: t.name,
      onSubmit: et,
      onCancel: re
    }
  ), xe = /* @__PURE__ */ R(
    "div",
    {
      style: {
        paddingLeft: `${(r + 1) * N + 20}px`
      },
      className: "flex cursor-pointer items-center gap-2 px-1 py-2",
      children: [
        $n,
        /* @__PURE__ */ A(
          ki,
          {
            defaultValue: "New Folder",
            onSubmit: et,
            onCancel: re
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ R(
      "div",
      {
        ...W,
        ...X,
        onClick: it,
        className: $(
          "flex cursor-pointer select-none items-center rounded-lg px-1 py-2 text-gray-800 transition-colors hover:bg-gray-300",
          be && "bg-gray-300 text-gray-900"
        ),
        style: {
          transform: "translate(0, 0)",
          position: "relative",
          paddingLeft: `${r * N + (F ? 0 : 20)}px`
        },
        children: [
          /* @__PURE__ */ A(RR, { ...e, position: "before" }),
          F && q,
          U,
          C === zt && G,
          C === qr && oe
        ]
      }
    ),
    /* @__PURE__ */ R(
      "div",
      {
        className: $(
          "max-h-0 overflow-hidden transition-[max-height] duration-300 ease-in-out",
          H && "max-h-screen"
        ),
        children: [
          C === Vs && xe,
          M == null ? void 0 : M.map((pe) => /* @__PURE__ */ go(
            Gg,
            {
              ...e,
              key: pe.id,
              uiNode: pe,
              level: r + 1
            }
          ))
        ]
      }
    )
  ] });
}
const jg = "powerhouse/budget-statement", rc = "powerhouse/default", Ug = "makerdao/rwa-portfolio", OR = [jg, rc, Ug], Zi = "SWITCHBOARD", _t = "LOCAL", ko = "CLOUD", Dr = "PUBLIC", KM = [_t, ko, Dr], _M = [_t, ko, Zi], DR = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAB4CAYAAAAXIRdAAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAzWSURBVHgB7V1dbBXHFZ5d/wI1WMhuVBUJq1GlAg9QlZSngNU2D9BIreoYGikKUdVKjaoSklSRWol4TdWmUgs0SFVTVaqUELUKhDTlIUFqiDA8lKQ8QCvMS5PaVRAN14kMjrGN7TuZb5izPne89/r+7HrXvvNJ17s7O3v3er89Z845M3PGE+XDw58j372+Pi8bv+3n5WZV0i2l1y6EbBfLFNKT/U8fvycQGYFXznkppTi8O7fXF95eKWS3qDN4irQnM0LaPMIUOWGZ53ni0O7r3Z5o+JOQokvUMYyk9dOhSAkFhHGyfvXg/9pbVq7oU7tP8DotqzzRsb5R3Lu1Sazb2CTaOnxdtpxw9OGPI8st0nSRWGT4dgGk6je7P+xSZL0tGFkgZVvPCvHY8+2i50Cb2LKzVRHXsOzIKgVPen1HdufwEosgCPCPL/o/79n7v+79f1eD57/NVeCWnS2KrJV1Q04xCSOol7p//ysd/Xi5LSQucY1Qg3Tj57453G6Ttf3RlVqaHOagnlnf4T03sNtvnfJgoKnnmRhxPn9LdJvFyHrgh6scWUUA9Xho94d988rN8+T2QJwI27BDvTf2CtZmQbI27GgRDsURRRokTGjeIGzxkxYSpl6M8MYbtrc4ySoTNmlcwrAfN2masMMPXX+MVOHqTl9se2iFcCgfUZJG7VjcpN2VMK9xHxVAukCaQ2WwSANZBQEIEZML4MOMV9+/hQpcu1U9GGnaWjS+mt6atq32exzak9vv5eURHHxha7N48OnPiHrHQn7YQkBEZGzj7w8qokKWjLkvajX7fV+KHXSwbmOjcKgdkLS2wcefLSgzxkiEs10RfMn8rk4VanKIB8VMfjL7qzVElEjJLjpAUNdBiDZldI3l8qJWmNijuLnxdwf18V3fTJh9Mv0rUo8wB8POx3oK5JbC6s74NA3CWGuUeuzr6+PEhCZ/pXD2ewTWbYhX0yhBQuyxD9YiSFJbPzxVoWp0hEVgy674ozxkiIA0Zj16lUqZIywCLSs98XnVORs3QNqawR8diDxVpqQ5wooAPRVJtOmKmKBYlL8c0hxhRaBjqj3JxFTJ5C8S/ShJmiOsBNBjkSRpv90z8iwnrZz2zBG2ANBzgb7BpNQj98OMQVLyRt7h3hvhBfv+slY4ROOWcqTfeXVCXD03JeLEUyc+61OcEWD7kfrShTbKBNq0Bx5fpSXu/Yt3xHsXp8XI8IyYGq89Ct/f3w+GyvoiR1iFAHFo22rpka+lN8C1YRkAOdIUCRFWByiHIyxD4BGQYnUcYSmDzHqyDi3fTI8u5g61IyxlQAeCLBPNl9wA4V0xwkidIyxlKLK0KjRE0RgQzUtEX5nnrMQMAJKkCNP7fByImD+7yElY2oCE8ZAUb8t41IMsSCdhGYEiBGMSwmFxRh3ysJXedxKWMiBhCjA8fDaOURaLKToJywAMabTVkma1ZSGchGUExlpcsBPTEZYyGFHyypUrHh/kYdSiLOgzq7fulWuD0+LCycmSkXaM59i4vTmxeQY8+Ku6VxpIJYKwTZs2UVxR8m4XQl1J2DsnJ8TJn49p0kp1i+D8318Y1/UXAR4RxsnSJyyy6soPuzowpTsgK4HusByIt8PSRm9vb2S57YNhCwLrhrDBc3dENaj2unIBqYKE0chgZubP88GAuiEMbVY1gHpMEmi3sEUskQwQBfLDwn4yql83flgcXflJgVuKZjY7BX5DR5rqOrM+ZZw4cUISYZAy1aZFDt8mKXORjpRBFiIA9QgCTTk3OiRJmSMsZXCSYICoT9hHFlXfqcSUociCaa9VIYspenxCO6+/ZCQMRsOl05NiUPlFxWZHYggaohTbelpjnZSXJLgkQbpYmTY6eLcLsCQk7FZuVvz5pze1I1tqKitG58LRfU1FM3DNUgBUIkmR2Q/nQZsqBRK2JAhDOKmSOccgDqQtFRijIrQYjU8WEmUI1L5Z5gmD41rNBHGQ9kHCTm8cQBtG4BYjV5U0agplmScsN1y9ars2WF10YzERZQ1aE9gLkHmjI8sRijhAISge7aBym0w3aioDoGg9GRyeN9eHac/QrKtofVZB0XoW4cBGS5dJEbH0rMTlDJIsFqkHiqpFR1hGwC1Ec8zJCklbFKMjC+Mosg5LykKyDHEhgYkThnER5XTNg1R8bo3kE5u5n0XAD7NVot3bzHMsJqoSszqOIsugHmiAgsDc+EhUwmoZR1EvqpHMekgXDXOj6IclaXn18ROVsKyOo8giSB0iylEsQw5IS5Sw5R6liANMmrQvxh3nCGQ/+LvcwaxBO/gbzhNjEpf94G+9ICicwRIGgCFtZjqtPnRjOlIGWYXUF0bHMOPZMAE3zC0rQBsGy5DGdFBsEaDRUtwIcRKWMmDWG4K4CR8mCQvmps9qOAlLGTRqyrLlJVmKLvibMYAQMudtSzEKjrCUQQRBwniPszk3b8qRa8NSBhFGs1d46qIgYspRohIWR9rVuFK3ZnXVC2a60/G8pCq8XqIShrVcqokL8kV7OmpYwKej4Htq/y1JgKxE5oNJK4UsVKW/KBKGIdPVgGf7xGrs1ST9x7Dte+9rjvW3JAE+LpHNceap+LxFc5zX6XHulXVGor7dtYKk/20VLPMIsr5zYHUivyVuMD+Md2RGTkoHErcSkdQYD7yUlKB9wXnUi1owFQT0KAKwPmcp4tpMPl6QFbWOZxy/JW7waH3A5joTyGikIPCiWIl4S2t9UymrdRZ+S5ygDkwTmuK5fgtTkxppc35YBkAxRDqWd6H3KTzl/LCMwYxPLGi7WDwxNEYcYSmDulUUJE9dBLBVacPVaZ1KzAjsGKKVoDkkzRGWMqgfLGDj66OSgrk2LCOwMgeQpIVp95jRIZXJ71Y3SgNW+r1Gu88LvlixkVNOJaYMPpCUtjToJioA7FRixsBDU5bkaZXoJCwDCIr0MvOwlDBLCDvCUgb3u2ziuElP6tERljKMBciP57VdHK4NSxm8A5NgIvZewBI1owx1HGEpg/wwgIjzIhYtJbXoVGJGQWoRJj71hQVLIRNOPSCYn0WAz3GWPHrvCEsZlPaBEBQZTArSnFmfIfAgMElX1ExMZ3SkDPLDeBCYLENrQW493M1JWEbA1SC1WcaUDyfzOaMjo+CqMHCzV7KFoHDCg97avcwAbRVh3ihd4Gb9J4+p2wXPeDQq0gHYo6aIvEbhyVHVrLXjJNIGda5aGtmolypGhgpylwwbo4MbFxrWyrPhaCpfitlzdKIeE5osNgpT4sohSA9fzqMYQpWoDMhLVPjexWSXXnIQBYmj854cCExG7Yhoh0bA1g4D/Lw3dopOjgzNisnxyjNYO5SHmzdmxfsX5wibuJM7xZOBwXnGNmCrQhhCw5G//jOvfHFIcT2AAzSIl96cFA7xAyrtakGyNHn5zOiPh/l0I5ZGVlpkhekffFgpMj/7El10+c0pJ2UxAw9ar1pxjqUVlPnnOzs7pb2kYmDlTAzYItza6ADDF/z9L6r9IRRCypCzsEhGMYcKQc/x3ZNzy5DgWZ8aefgY1WEkFVwbRGTCwao62o7/qjiyo0E0n6ET9z+yQmzZ1WpukM35wVkHkYVm5vwxluhTzn7vqVc/p7WaHckwy1Pl7e+ZN93oXfHkgMznj9Lx+ZfvZga1sok5lAl6bliNiZMlZf7oP7x9YRNkRzqOHz8+rz1iycG0w6YlDLr0yzMH21sb1yop8zZThfsfaRWbd7YWhEscosFfbOxfPl1Iliodzn387688d+YbOrqEZw7HmWat0OJvZi3M0Erk9wglDG3Zz/66YXTGv9VD7Rlw/uVJ8dYL48okndE/Ip/Ph2+P+0R/Jj6ZFeeO3S4gS73mQ6Jp8mv/WfuHkCz27MMuFl2XpS0KrBFUYNA3JzWbYPm+6V92NTWveUvdu4sqtnX44kvbm9SnWaxW+7ak8eOo2Rc2eJ2o+nYZHZdTt1JUe70tUTDYIFX/On3HihnKyzPTt3qeeR0uVHHJ4hfY9yJ+NFnkvKEwl8t5+OKJ6Y+2Qt/SBWMqzvjP16bEsf1j4o0j47oh/eDKtH6bSPLoYx9HfXidqPrFvrOcupV+qr0e/3vuvzP6Wbz+i0/0s8Ez4mRJOXN0cmbo62+M/mDYJoBS7VH6PVMe+VKQtKGSz8Mi3POGmjzUc22v39B0gEubw8KACrwjJ75/0fvJWSojJ5nUIUkVyCLyqP0i2O2YNuvZtE0yK8MLuru7vbNnz8rDe64/KvL+E9wgcYjEgPSmX7og97/ICYLmUs8yH6H+eAwxckIfJ01LGF1EWxJP3ATeOPZxc5C3654/rm/Ir/qWumyH8rvXe8Jbr5radlGHUP/7qFKmN1XTMaC6qS7fnh7/2wHVnNBLbkcxAHssPUlXqTlhAJH4Kc1sL4jISlnaAAAAAElFTkSuQmCC", MR = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACgCAYAAADjPOUVAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABhoSURBVHgB7V19jBzleX9ndu/D50gYgl05luzDUCWWkYJi8lft1Iji/NEKA5XPTahKVUJksFs+oqrBCr45OyKR2gbiIpcStWqIEhW7aoBKSDFRMcX8FUjrqDYEpQgcBRSfg48o9p1vd2fy/t59n7ln3p3Z752P2/cnrXZmdnZ27+a3z/fzvI7oEUEQOB/e90errnAmdgpX3CB8Z4M8fIN8ZZV8XiUsWsDxnCNHZ0RB4YgOAcJIBMGXP3+l+E31fnng90UgtguLHuDMSBJ5+N+qPfn/FQVBRwRSf+CDt1/hL44+4IrgfmElTB+hSESSaHkRiH4ZYu/uaWGJM0DUSST/30tHci6NEgmkVZXanv/CrsnxMfEf8ndxQ9L5tY2bhL9uffgcrJgQwfiEsIjiI3/9Zy3OiEgi3Idck6jMd0JJIxTz1ZcXe6fukruPSfI0SJ1gxUpR2bpDVD7zWUuWviGYDvZNCeeJOonoRyz0jz1vhCqbB/DlPM9zBfTwX0JliWnzHBBn8ZbbRGXbZ4XFAOAH07X7pkRpSZ2RNsBOx47PIOGEXpV+FvoLyj9gWhrKDeSpbNshFnfcYSVOl2itwpbgS3VGJCJJxO0jQpYSqUzk0fvqubr3jtvcoJE8l2+900qdFOFqdSYR2kRMpcWSKW24ZCzPzMzUZeS+XZOloPQv/CSorPk9+y15soBUZ770fqVZEVFdJJU0ocg+Sl29ucRo+QXrdPad/xKGmz6/52FRu/YTwiIbQBJNnztzgB8LnRwNIk/aJHL1h9a/xL4pxHkm+QlQW/7H1guLrKEM64hZwQxrkkbEKEekZGy79OHz995xDcQlf7F64zartnIEV5MI6oxJn9C9F4w0adlHikD4QuOiHBGR/lWrpbd1u7DIF0CiR6Q6w4+e20VkipAtS87RoFWa+oCFe6Ymx0fF2/yFhd33KAlk0V904sY3A7n4ca+lmQpRRvTISLCdH4T0seTJN5SLL9VZjKoKyDtjsaOB2URKhZVc56/4QUSZLYqAuouvtphNZJLK9Nj6CReJUjNJ6l+7SVgUA2RYk+0DGITBcbUzCHvINdVXTZLHv/JqYVEckGFNRrUZdBT1XFqgidVXEpVLjvNJfqC20QYMiwgdbAR7DuqgMJc8YTZW7/et8tGVHxMhkA0aFhmNEWtII54/YwZ2X4yisrTZJ3kFJTwwi8EBeUVn/qIYHJR3JsT0NFx8J0xRGSfFVGF0BddMXQTW/hkoglUfFYOHzCho70ztGR4Y6r146U4vcBs+eoWt8xkk/HUbRDqQ6ux8VJ0RpqenuW3UkypzhUWqqKbppPj1YCOruCDjWT/17pVZAqWM2vVblB2UHlRRWoM6465+LyQqC4tUAROhumWrGDn5A5EadI31ISEOUpBRG9CiV1gJlAHQxZI2eFEay9iHj24L0iyBMgAi/ZWtWdRZ1W0iMqLVESmFqDy2G5feEigjoNYqm5jbUgIWoBSH3uaZ+7YkkSVQRoAttLDn4UxIxCsbdQ+g6aG1nb23BMoQUGULd92fGYmkTfQItjWRAtruJD7kBPftipz4m799WlikC/fCeTH+5NeE+8GsSBvOkWNxQoQX5zclkpVAOQAk0fwDhzIyrKPqSquy0AZq5ZVZAuUEsIku77xTXNr/jdTLiXm2Hh4aCzK2VGOWQDmDsot23yMuHnoybGzw124YaPSaCNOqBz8O1gYaMphdIbCBWBwotn66mUFtJZCF4HEgeka0mgrPmtlBlkBDjpj6aToeemLNJJBNpg45EioWTfD26YhKsxLIokECgSjcsA5PjJFElkBDDrOmI64In04VMUVolkBDDk4WgKU0IsSKMaTVviWQhWMa0qb64vEhgi4DcSyBhhxQYbw+CCDpQ1WLJnnIFsKzJdCQg8/HBAzp45iRaW1g02hEx7rxQw5eyqH3fSEindAKNNBKS5+wLchKIAszmOg0OS8kjjpRksoSyALEEMbcRZJMsVn5yHDPoiVTnflLwlmQjw/OizSRNOYY38d972x9cRmZSc97Z6+ZTJ1Zs7lknqMlTcDKXcNqRXO7EDYQbhL6qEr//6Z8vCGyQNIPq/R/r4vxo98K9zHdpHLjNlHbvEX4VxVjzgAk0K5du5RYOXr0qK8lkmvYRqatpLZzrcJAnNEXvy8mHn1IjB7/fmbk6QSQRmPPf1dMfO0h9d3xNxQBmzdvDo4dO0ZrfDlJrr2J3BLIlSpqxWNfUcSByioi8N3xN7gpq9tOAGlD6QwtedRxuPaGHRQB2Uu5JBCRB8XmRUe9YP7R3JIIhAFZTp8+DbIIPNNx/RxRY0Qcih3ljkD4R+MfXlSpE4c8k4gIA/UF0kCVEXkA6lwFQCaKByFehOfcEWhMGqTLQfKYwN80xoztvACEIRIRSBrhQb3zPEJNMxhhJ+WKQOXXXimEodwt8LfBk8wTQAyQSG8r8kAaYZ+XeoA0VOrBVVmu4kDwtvIqfZL+L+UfvRJx41sBY5SxfFZWiIsDgTREIr4NkJFtLnRHRMqNBMIvczmqLhN5k0Lc3iEbSPeG0eGAJ1sB6tyAVMoNgcoyIDcsKJ9+TeQFRBRuB0FPUWDRjD6zc9RzbgiEANywwH3v5yIvMG0gAOQhb4wHFEEks146PwR6f3gI5GQwRKEVyBsjNUbbxoBOcuPDVRJzQ6DBDt/OF3Jm60WIgwN8m6ClT0NUupAFZVWZqMRSnEGXyUpk8kdkyABhg2EH1BW57fyYJJUwj8fVRReOQBg2gKEDPeHKq1V5xtj4RLrTUnMIIglLXVDMB1IoVF14zayPhndWuIKyfq7jmsW01LwB0oYnUQG+zWFKIKBwBOrnWmZ2XTQRUVM8hYFtM8XhGeuR5SoO1C76GYQbptBBEogwZDhDIsFaxraZWPVimg4LRyAUafXtWsf7d60ig0scKiojacTiQNygDrcLZ0QjFYCc2eKtd3Y9tQtxmJHXTy7rxG278Fg5q3bdI+UdOo0RHtcIA4mFdONVfc23vykseodWUaFEIbXFvLJIdyq3f3DMNhZamC48SaRAZ+K5FIrYP4AlkEWEQAA6M/iCLGKJPA1LaNrGwiEHN5QpJkR9zdBdPAPv1due+XvtdI5hBwgzNTXl8kpEj3VmGCv7RMa+FDIOZNF/8JiPGYWOiz7zArNC2kBw36s3bhW1td2tcV96/6wonf5xJmtT5A3eUslqpJ2HQQUWkwzpwhEIK9uoZZJ6SENU5cOV2fysFjjJE8jmYSRRgOoi0jBDmpPIKaQKuzx1T19yWLgGrmURbS7EPp4pGm2c11CdWDgCJU3JyPpaRQfvxiBj2ujOaDCGChlIxLCCfo1Q6aVTVHWRvPeuKkwrMnhnqnyoYzzBSvBihisUMpWBArDFW/pTE9RpRSKNmRn57x8sq9Zr7YWp7Zi6IMdMZxAKOaEMGfReM/I0NqaT62Bky8oDe/o2LSQvffKQOrz2x4xKUxzI7EglFNKNVySSj26N6W6K2kdeaSx9RTihtvETaqiU+V3wGag3Kr39ZmzDAIYtoLoy7cXlTMjoc5h5JzuInkkCCea+m25+oXNhWXU34KarKWRtGuGwl8wiflVR8My3REWS7PKtd4qswMlDx3hQMc724Tkxm0ztACCOWu+9Q8kHouHhyvdCcnIiQbKhLml+z/5M5isyYzng6osy8iJm4V1OqtwMVzCb/vMEqCosz92OxIFkaUUwEGj0xWcjQcy0hi7ErFhYZqWqka5UhiDpejYX1gKIfM8/eKgt8qjZiI8+pB7NoFqTEE1n68VDCuH9GSAw66INFz62lDXXI+7ygk7TJmRoKwO6hX2mFtc1SIT3Z9GnRmUc5I3BZ6eaaD6hjHemkktfWBsINyC4crXoBs7c+ZY5sF5zbmqOdYv3EolWPPZI6KnBRqpu2ZaaPUQqC9v0bI5zAagy0TSsC0cg2COXd39BtTf3AtghY89/L7Enf/GW21qSp9n86hXSTQ/GJ4S/boP02LYKf+Om2LnRikTSvsL5dE3Ep9L2zKgeiBMKMSAjeNhgCxWOQLixvZIHgB2CYF5cMBGvtYrPuL84K8a//XhTVYWAY32gVJ1c8LTibCkcw+eRdwZVhmh7GlJI570cFo0O82FIqCa58hSZLpwN1M/AGwY0xKFV+7QaQ4ypqx3GoZoNgzA/My1byPS6yPYBiDws+rzkvudtwFQWiPuFg6CtVNeo9JY6TWfATW92XbzGfxxxke9BwvTCAjNnUUeDbVQ4AvWzHTkumVpppbqk9CmfbhzHB7UKFXVp/zfEpQe/qrYVGbWXBTuoFfhnwxZKc5aiF+0Fi7zG7SCeDytkPdDYM0/1JRGp7B+jtRkSqVW8x4lRW3jfwp/XA42QJMiNYRtjaC49/PfSSH6gLdWL9/BuW5SLDBqwdcw2ZqpSNNfL0K8FbPG54hnRsDuwkEn1emlIj3dnZIIE7i/ebVBDUDMt35vgtYGQSavzVK//lGgXSM6ShEMiNslO6xe412WC10l7bLE5PuausHGgQUx19dso0ueBPwLUjSI1vLfNn5ISaEPXSz1BeglNIJB80EA5B9UCsTiP2vfYsCnAbHH28rReGER/1rMD27npqnRDkiguEFlmGXelyqRE6yRrT+8jpFG0hnIOgMeBkkij10t1cpmNxz/bLUh5KIrxKfCXBJXO0ISqR5z3dyyV0lxrjMeB8AxCocXZCCSGgxXoQG6M6NrHuuvxygKQKPC04tRZHECmFY9/JRWjuFNAhZn1QOTOt1ozDMgNgWA/dDvvJwtAlXEPqxWZIE2QOukEaUSiSYUR+Lph5JlplRZLotyoMOVCSwM0y9G73YQH4GGRl4UYlerU+NFJ6UE1Dq9CSqNVvRC3A7tNFncKGvUL1UUlrdhnwcRAq618BxIRzs9SCvU6LR9SCdJo/t6HVUAx7m9ptdo0D5SmsWgvCANbh/Z5NJq58eCJw5c5AHLX1oNfJpKlGRVWtT3yjpKwzTysbstAEPsJr7E2HbsQ0znIMGalrHwt1bAzQxj5sNzFgRA4ww3KorCK0get3G6Qh1x2WuYbsR9Kljo63REXdPSbOAv4bP6edgKbvYLqoYXOyFODIcgDYsltP+F9atnLXAYSL++s18JkQSJ0TzQjEEjmMklFy3y3g7qjMNH0swkwytNqvTYz8p7ulWdufIP9QzZRbnNhINHlHiaxdgtIlWbGtDKUuwh4ghDNykRUkpYTaGN6fftJ66bqeiC1jnzM2/I/XAHqDAXtaTffNetYVYZyhwVt7ZTHmp/ZzyUdmoFG/PKJ9ZBA1C8WAzpP2di5WjO1GVR138/eVO4xqgEHcX0e6EuqHiRACqFmB98lzmUHahs31d38T29T5a1JgORBkyGhLwvKJCCmrafkGf3wXJWx9VKVyuKpjUINV8AN4DGXfqOeEP1SaMSiXHX+ga8mutJqvhCrW1ZVAqydB258O56YWVbSStUNAjEJVLXNJ5PREDNOHjsnmgHGLQ8hgFDoX283h9WN2w7yjBulse0U8/cTZEDzIZt0TC+uSzGh8D1cCtm+MAbYXJWtS/U3qn8dN7jNCDXZapAirUgQR57Kth2p23u8pYckD1u5kE/8Dd/DSzqsBDIA768+VaNu1xCJ2pmkAbvFbaN3HvGe8X99PFKugfafy7f+qcgCun0ndryL0OUbupSj4X1WAsUA5akIDBJokgYeraRR0zzXB/XroBSEkwfGdhp98XEAOaiQzDhOmw1LfpM0AqkK44VlgbHnvhsbzOzHeBcC1Faaksf0wmbWbC7RNp8LxIKLQZPL5aciMY+AOqutW98wSYPSGPAMa9dtUjmr2AFTmEf9szdiKwsRIIXBPOia53bhJTQQCj3ehaoQSfpo78yxEqgNgAzmXJ9eAKmzuOOOprGhQSFOAnkxQzUBcuObSSFrA7UBVZKKFh0Z22mneCwOdYlzu7h46EmlsrIgTxy0ZOH7IZForQyjxzAy+tdKoC5BAxVUbkwax5j4QUFIkCUYX6EMcdUrpp/zgCQJBHisvRnPVFQWt14GwdpAXYLG1i0X8DogFhtSUshMZ/D3WRU25PAaB4oLPvKXotBxWXkcK3mf3uzxg2nnYSzShZn1d/5w6qBXXzNM7W/fvl3Mzs46R44cUeTB/okTJ9SDoFMZ+WostMgGWtpEcmFCz000B0xRDkxLJHXMEmjIEddQSETiy0B5eqgCwasvf2mXvLSIjnMh8lBfWJIHpjs1rAQadoAourkwcbwvDySai65YCTTkoE4MbMdFpD1jgRVdIxTOErISaMjhsUkbRB49L1q9rtt6GmwhO2jcQoGTh55JKrHCMr5aj9Jf4ZQym8oYLjRLpibBa5JMtSpsyEEqjK+ZSvVA2jZqVg9kVdiwQ6ulSF8YwBec84owH8giO5i5ML6tuzKUJOLemDWiLRTMlmbqVOXQZHF4/Me29VgomEt90zZAZRzN6oEsgYYcZEATgWALUZDQXPYpzhYCgeb4gTQng1qki7h7S3EffixpvbC4yfUull+LfMiCJdByRcwyDe/EpC4iRWWsB4yfE+6UAyc45QRikg5gOnqavdkW6cEcji6pocaRmDkwb2lqmWDDFcI8GKo8KH7kygOR4cVJo0osig9zpSPJjP/Fc5wBTfCi8xF5X7w67tb84FSzD7FYPjCHiFZ8/ydetGU5YuPoGdH0eqSdh7bL50r+c+sC95+XPuRNIdCeUqCh3xat4Uj1xSfAAhf82st4Dof/yNPI9tHjXRwa7yLYcCmeG3MfPFeek3sv8wtj8lYQBMJi+cCUPvL2ntp3YQRGtCrToACiLnENR73w6GGcIe3WR7pGCTR68riwWD6AMEB/P0fV9Q/TOhmmK98ktcHX01DnI5XvrD33059cPbrii3J/HAedakWqsAlRW39t0yikRf4B8mAyyMjrJyPHK4H/0FvXXP/hmTNnVPpizZo16jhUGI6BOCdOnAjQzgOOvPTSS+Kmm26KXNfR4qmEmth/u1occB1xIDxBEujil/9OtelaEhUT6iZL22fin74emYRWE87Tn5sN/oL2zQmtBBjR1B/PXPjIZ7j6AuKtix8cFiwqjajl6PFnwy9iUSzQPRvDaBojgPir6uJB83yqAeLHqHnQdOE5XEgfPJ7ZuO2CH4jD/MXRV4+Hy09bEhUHuFdKdcl7Z6oueY8PwnjGNgQHnwfN7SDW3uwkfQZQ5m8oHTt20N+7a6eMTH+Sjo//5/dEbe36yCABq9Lyichy3DKeh3sXeV1Gnv/kvFDSh2fhzWeWxggrFJkLTzXRQWRONF3w15XKH19RHnlNbq6i1ya+c1hc/OLfqDElSbrQIltw8iCWN/H0YfOUudlq5WYZpFH32lxozmOjXUgqMRc+XOrb01PK9Ot1Nx4gVbbqqWffqfjOl/jFYQ995JvTal6g7/uhiLRqLXvwe1FXW8fFyqe+3pAUXxTB3VBdRB6tvkKJwtWYkc5oGLLJx/wigFTiF92+fbsD9612766IVxZ+kS1bxcIf7BSCTelqZmRZ9B9c2oSQ2QMYzGOvvthwftUPDn3+V84MtjF5A/cX23TPxRJJwpG/RvwnMJc4CDURCISDRCL6gLpr70sSuQ0kUiPfbt4pyfR7Iq5izRJpMDAlPkkdkGb8h8/FluLAaIbdg/tKx1avXq0uxCfT8+5UAsvKh9kOjzUiAqWpqSkHF6fF51944YVQP/77JeflnSuDUyXhYJToOL0JX3TkzP+I0R+/qmb9+RjnJh8Wg0VE8kDivPyCWPmdJ9S9UMHfKOZksnSvlDzKGMJ9nZycdEAeCAsZLAx0sBBqSwUPAezLc1RgEbOBEECUxHGxLWNCkTlBAFjpMgucGu0FMRbS6Jd33Ta5ZuXoD+VXn0z646obPy6q13xcLd/tr8Ko/6sKtQpznqFmLy7Mi/L7Z0X57Z+Kkn5OQuCIU7PSGdr91ty7IAzuJRGH7i/ZOnFlHOxYaP/wWUFcnSkC0ZtMApEqI0M7yS6yyA3mEMsjVx0g8tA+eVg8686rECkWROWrNBtRvu6aA6cABBIddsGIkvWWFmJVj9I/Hjv4YdW9zg8C2/+cL8zBUH6ruvC7N78xe4h+8AAZzBycKABPqHJJxBZaaRgwFZ6DF/XiqhEjSscDFIlom6QRnp+YqEx+dGLsM67r388DjxbpAWU4qKRAGures7UPTTVFoOWczOJ5gBOG1QXRqs0Rl93TwxVIsIRLXuLCJImMeEC4liZ5aNjGl9x3aeSdz533n959Tmw5d7FynYwd3S0jRIfrtUXOO8Kin5jD/7QWiOdrQfAP0ji++/ULs6t3z4qbD/3O5pkD81fNJb2RVJYpXUjrcBuI3HdaH76VN43XfwvGZvVMUGpnZwAAAABJRU5ErkJggg==", FR = "data:image/png;base64,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", xf = {
  [jg]: DR,
  [rc]: FR,
  [Ug]: MR
}, St = "DRIVE", Xt = "FOLDER", Je = "FILE", Vs = "CREATE", qr = "WRITE", zt = "READ", Qg = "UI_NODE", $M = "NEW", Mr = "DUPLICATE", ss = "NEW_FOLDER", _n = "RENAME", Fr = "DELETE", oc = "SETTINGS", as = "REMOVE_TRIGGER", cs = "ADD_TRIGGER", us = "ADD_INVALID_TRIGGER", eu = [
  ss,
  _n,
  oc
], tu = [
  _n,
  Fr,
  Mr
], nu = [
  ss,
  _n,
  Fr,
  Mr
], VR = [
  Mr,
  ss,
  _n,
  Fr,
  oc
], BR = [
  cs,
  as,
  us
], eF = [...VR, ...BR], kR = [
  {
    value: _t,
    icon: /* @__PURE__ */ A(J, { name: "Lock" }),
    description: "Only available to you"
  },
  {
    value: ko,
    icon: /* @__PURE__ */ A(J, { name: "People" }),
    description: "Only available to people in this drive"
  },
  {
    value: Dr,
    icon: /* @__PURE__ */ A(J, { name: "Globe" }),
    description: "Available to everyone",
    disabled: !0
  }
], LR = {
  CLOUD: {
    title: "Secure cloud",
    description: "End to end encryption between members.",
    icon: /* @__PURE__ */ A(J, { name: "Lock" })
  },
  LOCAL: {
    title: "Local",
    description: "Private and only available to you.",
    icon: /* @__PURE__ */ A(J, { name: "Hdd" })
  },
  SWITCHBOARD: {
    title: "Switchboard",
    description: "Public and available to everyone.",
    icon: /* @__PURE__ */ A(J, { name: "Drive" })
  }
}, HR = {
  [cs]: {
    label: "Add Trigger",
    icon: /* @__PURE__ */ A(J, { name: "Plus", className: "text-orange-900" })
  },
  [as]: {
    label: "Remove Trigger",
    icon: /* @__PURE__ */ A(J, { name: "Xmark", className: "text-orange-900" })
  },
  [us]: {
    label: "Add Trigger",
    icon: /* @__PURE__ */ A(J, { name: "Exclamation", className: "text-orange-900" })
  }
}, XR = {
  [Mr]: {
    label: "Duplicate",
    icon: /* @__PURE__ */ A(J, { name: "FilesEarmark" })
  },
  [ss]: {
    label: "New Folder",
    icon: /* @__PURE__ */ A(J, { name: "FolderPlus" })
  },
  [_n]: {
    label: "Rename",
    icon: /* @__PURE__ */ A(J, { name: "Pencil" })
  },
  [Fr]: {
    label: "Delete",
    icon: /* @__PURE__ */ A(J, { name: "Trash" }),
    className: "text-red-900"
  },
  [oc]: {
    label: "Settings",
    icon: /* @__PURE__ */ A(J, { name: "Gear" })
  }
}, Kd = {
  ...HR,
  ...XR
}, yl = "SYNCING", Sr = "SUCCESS", Cl = "CONFLICT", xl = "MISSING", Ea = "ERROR", tF = [
  yl,
  Sr,
  Cl,
  xl,
  Ea
], WR = {
  driveNodes: [],
  selectedNode: null,
  selectedNodePath: [],
  selectedDriveNode: null,
  selectedParentNode: null,
  setDriveNodes: () => {
  },
  setSelectedNode: () => {
  },
  getNodeById: () => null,
  getParentNode: () => null,
  getIsSelected: () => !1,
  getIsInSelectedNodePath: () => !1,
  getSiblings: () => []
}, qg = Tl(
  WR
), nF = ({
  children: e
}) => {
  const [t, n] = Q([]), [r, o] = Q(null), [i, s] = Q([]), [a, c] = Q(null), [u, l] = Q(null), d = ye(
    (x, E) => {
      if (!(E != null && E.length)) return null;
      for (const P of E) {
        if (P.id === x) return P;
        const L = P.nodeMap[x];
        if (L) return L;
      }
      return null;
    },
    []
  ), f = ye(
    (x) => d(x, t),
    [d, t]
  ), p = ye(
    (x, E) => !x || !(E != null && E.length) ? null : x.kind === St ? x : E.find((P) => P.id === x.driveId) ?? null,
    []
  ), h = ye(
    (x, E) => {
      if (!(E != null && E.length) || x.kind === St) return null;
      const P = d(x.parentFolder, E);
      if (!P) return null;
      if (P.kind === Je)
        throw new Error(
          `Parent node ${x.parentFolder} is a file, not a folder`
        );
      return P;
    },
    [d]
  ), g = ye(
    (x) => h(x, t),
    [h, t]
  ), m = ye(
    (x, E) => !x || !(E != null && E.length) ? null : x.kind === Je ? h(x, E) : x,
    [h]
  ), b = ye(
    (x, E) => {
      const P = [], L = E.find((V) => V.id === x.driveId);
      let W = x;
      for (; W; )
        P.push(W), W = W.parentFolder === (L == null ? void 0 : L.id) ? L : W.parentFolder ? L == null ? void 0 : L.nodeMap[W.parentFolder] : void 0;
      return P.reverse();
    },
    []
  ), v = ye(
    (x) => {
      if (!x) return;
      if (o(x), c(p(x, t)), l(m(x, t)), x.kind === St) {
        s([x]);
        return;
      }
      const E = b(x, t);
      s(E);
    },
    [
      t,
      b,
      p,
      m
    ]
  ), C = ye(
    (x) => r === x,
    [r]
  ), w = ye(
    (x) => x.kind === Je ? !1 : i.includes(x),
    [i]
  ), y = ye(
    (x) => {
      if (x.kind === St)
        return console.warn(
          "Drive nodes do not have siblings, as they are top-level nodes"
        ), [];
      const E = h(x, t);
      return (E == null ? void 0 : E.children) ?? [];
    },
    [h, t]
  );
  Ie(() => {
    if (!r) return;
    const x = d(r.id, t);
    x && v(x);
  }, [t, d, r, v]);
  const I = ve(
    () => ({
      driveNodes: t,
      selectedNode: r,
      selectedNodePath: i,
      selectedDriveNode: a,
      selectedParentNode: u,
      getNodeById: f,
      getParentNode: g,
      setDriveNodes: n,
      setSelectedNode: v,
      getIsSelected: C,
      getIsInSelectedNodePath: w,
      getSiblings: y
    }),
    [
      t,
      r,
      i,
      a,
      u,
      f,
      g,
      v,
      C,
      w,
      y
    ]
  );
  return /* @__PURE__ */ A(qg.Provider, { value: I, children: e });
}, rF = () => Sa(qg), wf = /* @__PURE__ */ aI({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://cloudflare-eth.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), ZR = WI({
  chains: [wf],
  transports: {
    [wf.id]: hI()
  }
}), zR = new dE();
function oF(e) {
  const { children: t, wagmiProviderProps: n, queryClientProviderProps: r } = e, { config: o = ZR, ...i } = n ?? {}, { client: s = zR, ...a } = r ?? {};
  return /* @__PURE__ */ A(GI, { config: o, ...i, children: /* @__PURE__ */ A(xE, { client: s, ...a, children: t }) });
}
function _d(e) {
  const { uiNode: t } = e, [n, r] = Q(!1), o = ye(
    (a) => {
      a.dataTransfer.setData(Qg, JSON.stringify(t));
    },
    [t]
  ), i = ye(() => {
    r(!1);
  }, []), s = !!t && t.kind !== St;
  return ve(() => ({
    isDragging: n,
    dragProps: s ? {
      draggable: !0,
      onDragStart: o,
      onDragEnd: i
    } : {
      draggable: !1,
      onDragStart: void 0,
      onDragEnd: void 0
    }
  }), [s, n, i, o]);
}
function $d(e) {
  const { uiNode: t, onAddFile: n, onCopyNode: r, onMoveNode: o } = e, [i, s] = Q(!1), a = !!t && t.kind !== Je, c = ye((d) => {
    d.preventDefault(), s(!0);
  }, []), u = ye(() => {
    s(!1);
  }, []), l = ye(
    async (d) => {
      if (d.preventDefault(), d.stopPropagation(), !t) return;
      const f = GR(d.dataTransfer.items);
      if (f.length)
        for await (const p of f)
          await n(p, t);
      else {
        const p = d.getModifierState("Alt"), h = d.dataTransfer.getData(Qg), g = JSON.parse(h);
        p ? await r(g, t) : await o(g, t);
      }
      s(!1);
    },
    [n, r, o, t]
  );
  return ve(() => ({
    isDropTarget: i,
    dropProps: a ? { onDragOver: c, onDragLeave: u, onDrop: l } : {
      onDragOver: void 0,
      onDragLeave: void 0,
      onDrop: void 0
    }
  }), [a, i, u, c, l]);
}
function GR(e) {
  return Array.from(e).map((n) => n.kind === "file" ? n.getAsFile() : null).filter(Boolean);
}
function Yg(e) {
  return `${e.slice(0, 7)}...${e.slice(-5)}`;
}
function Jg(e, t) {
  return t || (OR.includes(e) ? xf[e] : xf[rc]);
}
const iF = (e, t) => {
  for (const n of t)
    if (n.path.startsWith(e))
      return n.status || "SUCCESS";
  return "SUCCESS";
}, sF = (e) => e.sort((t, n) => {
  const r = [
    "ERROR",
    "CONFLICT",
    "SYNCING",
    "MISSING",
    "SYNCING",
    "SUCCESS"
  ];
  return r.indexOf(t.status || "SUCCESS") - r.indexOf(n.status || "SUCCESS");
}), aF = (e) => e.filter((t) => t.status !== "SUCCESS"), To = "mock-drive-id", cF = {
  kind: Je,
  documentType: "makerdao/rwa-portfolio",
  id: "file-1",
  name: "Mock file in drive",
  slug: "mock-file-in-drive",
  parentFolder: To,
  driveId: To,
  syncStatus: Sr,
  synchronizationUnits: [{ syncId: "1", scope: "global", branch: "main" }],
  sharingType: _t
}, uF = {
  kind: Xt,
  id: "folder-1",
  name: "Mock folder in drive",
  slug: "mock-folder-in-drive",
  parentFolder: To,
  driveId: To,
  syncStatus: Sr,
  children: [],
  sharingType: _t
}, jR = (e) => [
  {
    kind: Je,
    documentType: "makerdao/rwa-portfolio",
    id: "file-1",
    name: "Mock file in drive that has a very significantly long name",
    parentFolder: e,
    synchronizationUnits: [{ syncId: "1" }]
  },
  {
    kind: Xt,
    id: "folder-1",
    name: "Mock folder in drive 1",
    parentFolder: e
  },
  {
    kind: Xt,
    id: "folder-2",
    name: "Mock folder in drive 2",
    parentFolder: e
  },
  {
    kind: Je,
    documentType: "template",
    id: "folder-1-file-1",
    name: "Mock file in folder 1",
    parentFolder: "folder-1",
    synchronizationUnits: [{ syncId: "1" }]
  },
  {
    kind: Je,
    documentType: "global",
    id: "folder-2-file-2",
    name: "Mock file in folder 2",
    parentFolder: "folder-2",
    synchronizationUnits: [{ syncId: "1" }]
  },
  {
    kind: Xt,
    id: "folder-1-folder-1",
    name: "Mock folder in folder 1",
    parentFolder: "folder-1"
  },
  {
    kind: Xt,
    id: "folder-2-folder-1",
    name: "Mock folder in folder 2",
    parentFolder: "folder-2"
  },
  {
    kind: Je,
    documentType: "legal",
    id: "folder-1-folder-1-file-1",
    name: "Mock file in folder 1 folder 1",
    parentFolder: "folder-1-folder-1",
    synchronizationUnits: [{ syncId: "1" }]
  },
  {
    kind: Je,
    documentType: "budget",
    id: "folder-2-folder-1-file-1",
    name: "Mock file in folder 2 folder 1",
    parentFolder: "folder-2",
    synchronizationUnits: [{ syncId: "1" }]
  },
  {
    kind: Xt,
    id: "folder-1-folder-1-folder-1",
    name: "Mock folder in folder 1 folder 1",
    parentFolder: "folder-1-folder-1"
  },
  {
    kind: Xt,
    id: "folder-2-folder-1-folder-1",
    name: "Mock folder in folder 2 folder 1",
    parentFolder: "folder-2-folder-1"
  }
];
function eA(e) {
  var n, r;
  return {
    state: {
      global: {
        id: ((n = e == null ? void 0 : e.global) == null ? void 0 : n.id) ?? To,
        slug: "mock-drive",
        name: "Mock Drive",
        icon: "",
        nodes: jR(((r = e == null ? void 0 : e.global) == null ? void 0 : r.id) ?? To),
        ...e == null ? void 0 : e.global
      },
      local: {
        sharingType: _t,
        availableOffline: !1,
        ...e == null ? void 0 : e.local
      }
    }
  };
}
const UR = tA(
  eA({
    global: {
      id: "local-drive",
      name: "Local drive"
    },
    local: { sharingType: _t, availableOffline: !1 }
  })
), QR = tA(
  eA({
    global: {
      id: "public-drive",
      name: "Public drive"
    },
    local: { sharingType: Dr, availableOffline: !0 }
  })
), qR = tA(
  eA({
    global: {
      id: "cloud-drive",
      name: "Cloud drive"
    },
    local: { sharingType: ko, availableOffline: !0 }
  })
), lF = [QR, qR, UR], dF = {
  [Dr]: {
    [St]: [...eu],
    [Xt]: [...nu],
    [Je]: [...tu]
  },
  [ko]: {
    [St]: [...eu],
    [Xt]: [...nu],
    [Je]: [...tu]
  },
  [_t]: {
    [St]: [...eu],
    [Xt]: [...nu],
    [Je]: [...tu]
  }
};
function If(e, t) {
  if (t !== _t)
    try {
      return Sr;
    } catch (n) {
      return console.error(n), Ea;
    }
}
function tA(e) {
  const { id: t, name: n, icon: r, slug: o } = e.state.global, { sharingType: i, availableOffline: s } = e.state.local, a = If(t, i), c = {
    id: t,
    name: n,
    slug: o || null,
    kind: St,
    children: [],
    nodeMap: {},
    sharingType: i,
    syncStatus: a,
    availableOffline: s,
    icon: r,
    parentFolder: null,
    driveId: t
  }, u = e.state.global.nodes.map((l) => {
    const d = {
      ...l,
      slug: l.name.toLowerCase().replace(/\s/g, "-"),
      driveId: t,
      parentFolder: l.parentFolder || t,
      syncStatus: a,
      sharingType: i
    };
    if (d.kind === St)
      throw new Error("Drive nodes should not be nested");
    return d.kind === Je ? d : {
      ...d,
      children: []
    };
  });
  for (const l of u)
    c.nodeMap[l.id] = l;
  for (const l of u) {
    if (l.kind === Je && (l.syncStatus = If(
      l.synchronizationUnits[0].syncId,
      i
    )), l.parentFolder === t) {
      c.children.push(l);
      continue;
    }
    const d = c.nodeMap[l.parentFolder];
    if (d.kind === Je)
      throw new Error(
        `Parent node ${l.parentFolder} is a file, not a folder`
      );
    d.children.push(l), l.syncStatus !== Sr && (d.syncStatus = l.syncStatus);
  }
  return c;
}
const ru = (e) => /* @__PURE__ */ A(
  jt,
  {
    color: "light",
    size: "small",
    ...gn(
      e,
      "border border-solid border-gray-300 bg-white px-3 py-1 text-sm text-gray-900"
    ),
    children: e.children
  }
);
function Lo(e) {
  const { inputs: t } = e;
  return /* @__PURE__ */ A("div", { className: "bg-white text-xs font-medium", children: t.map(({ label: n, Input: r }, o) => /* @__PURE__ */ R(
    "div",
    {
      className: Nr(
        "grid min-h-11 grid-cols-[208px,380px] items-center px-6 text-gray-600",
        o % 2 !== 0 && "bg-gray-50"
      ),
      children: [
        /* @__PURE__ */ A("div", { children: n }),
        /* @__PURE__ */ A("div", { className: "h-max py-2 text-gray-900", children: /* @__PURE__ */ A(r, {}) }, o)
      ]
    },
    n
  )) });
}
const AF = ({
  label: e,
  value: t,
  ...n
}) => /* @__PURE__ */ R("div", { ...gn(n, "flex items-center px-6 text-xs"), children: [
  /* @__PURE__ */ A("div", { className: "text-gray-600", children: e }),
  /* @__PURE__ */ A("div", { className: "text-gray-900", children: t || "--" })
] });
function Kg(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
var zi;
(function(e) {
  e.event = "event", e.props = "prop";
})(zi || (zi = {}));
function On() {
}
function YR(e) {
  var t, n = void 0;
  return function() {
    for (var r = [], o = arguments.length; o--; ) r[o] = arguments[o];
    return t && r.length === t.length && r.every(function(i, s) {
      return i === t[s];
    }) || (t = r, n = e.apply(void 0, r)), n;
  };
}
function Gi(e) {
  return !!(e || "").match(/\d/);
}
function no(e) {
  return e == null;
}
function JR(e) {
  return typeof e == "number" && isNaN(e);
}
function _g(e) {
  return no(e) || JR(e) || typeof e == "number" && !isFinite(e);
}
function $g(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function KR(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function _R(e, t, n) {
  var r = KR(n), o = e.search(/[1-9]/);
  return o = o === -1 ? e.length : o, e.substring(0, o) + e.substring(o, e.length).replace(r, "$1" + t);
}
function $R(e) {
  var t = Ce(e);
  t.current = e;
  var n = Ce(function() {
    for (var r = [], o = arguments.length; o--; ) r[o] = arguments[o];
    return t.current.apply(t, r);
  });
  return n.current;
}
function nA(e, t) {
  t === void 0 && (t = !0);
  var n = e[0] === "-", r = n && t;
  e = e.replace("-", "");
  var o = e.split("."), i = o[0], s = o[1] || "";
  return {
    beforeDecimal: i,
    afterDecimal: s,
    hasNegation: n,
    addNegation: r
  };
}
function eO(e) {
  if (!e)
    return e;
  var t = e[0] === "-";
  t && (e = e.substring(1, e.length));
  var n = e.split("."), r = n[0].replace(/^0+/, "") || "0", o = n[1] || "";
  return (t ? "-" : "") + r + (o ? "." + o : "");
}
function e3(e, t, n) {
  for (var r = "", o = n ? "0" : "", i = 0; i <= t - 1; i++)
    r += e[i] || o;
  return r;
}
function Ef(e, t) {
  return Array(t + 1).join(e);
}
function t3(e) {
  var t = e + "", n = t[0] === "-" ? "-" : "";
  n && (t = t.substring(1));
  var r = t.split(/[eE]/g), o = r[0], i = r[1];
  if (i = Number(i), !i)
    return n + o;
  o = o.replace(".", "");
  var s = 1 + i, a = o.length;
  return s < 0 ? o = "0." + Ef("0", Math.abs(s)) + o : s >= a ? o = o + Ef("0", s - a) : o = (o.substring(0, s) || "0") + "." + o.substring(s), n + o;
}
function Sf(e, t, n) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var r = (e.indexOf(".") !== -1 || n) && t, o = nA(e), i = o.beforeDecimal, s = o.afterDecimal, a = o.hasNegation, c = parseFloat("0." + (s || "0")), u = s.length <= t ? "0." + s : c.toFixed(t), l = u.split("."), d = i;
  i && Number(l[0]) && (d = i.split("").reverse().reduce(function(g, m, b) {
    return g.length > b ? (Number(g[0]) + Number(m)).toString() + g.substring(1, g.length) : m + g;
  }, l[0]));
  var f = e3(l[1] || "", t, n), p = a ? "-" : "", h = r ? "." : "";
  return "" + p + d + h + f;
}
function nr(e, t) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var n = e.createTextRange();
      return n.move("character", t), n.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(t, t), !0) : (e.focus(), !1);
  }
}
var n3 = YR(function(e, t) {
  for (var n = 0, r = 0, o = e.length, i = t.length; e[n] === t[n] && n < o; )
    n++;
  for (; e[o - 1 - r] === t[i - 1 - r] && i - r > n && o - r > n; )
    r++;
  return {
    from: { start: n, end: o - r },
    to: { start: n, end: i - r }
  };
}), tO = function(e, t) {
  var n = Math.min(e.selectionStart, t);
  return {
    from: { start: n, end: e.selectionEnd },
    to: { start: n, end: t }
  };
};
function nO(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function ou(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function rO() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function oO(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function iO(e) {
  var t = e.currentValue, n = e.formattedValue, r = e.currentValueIndex, o = e.formattedValueIndex;
  return t[r] === n[o];
}
function sO(e, t, n, r, o, i, s) {
  s === void 0 && (s = iO);
  var a = o.findIndex(function(w) {
    return w;
  }), c = e.slice(0, a);
  !t && !n.startsWith(c) && (t = c, n = c + n, r = r + c.length);
  for (var u = n.length, l = e.length, d = {}, f = new Array(u), p = 0; p < u; p++) {
    f[p] = -1;
    for (var h = 0, g = l; h < g; h++) {
      var m = s({
        currentValue: n,
        lastValue: t,
        formattedValue: e,
        currentValueIndex: p,
        formattedValueIndex: h
      });
      if (m && d[h] !== !0) {
        f[p] = h, d[h] = !0;
        break;
      }
    }
  }
  for (var b = r; b < u && (f[b] === -1 || !i(n[b])); )
    b++;
  var v = b === u || f[b] === -1 ? l : f[b];
  for (b = r - 1; b > 0 && f[b] === -1; )
    b--;
  var C = b === -1 || f[b] === -1 ? 0 : f[b] + 1;
  return C > v ? v : r - C < v - r ? C : v;
}
function Tf(e, t, n, r) {
  var o = e.length;
  if (t = nO(t, 0, o), r === "left") {
    for (; t >= 0 && !n[t]; )
      t--;
    t === -1 && (t = n.indexOf(!0));
  } else {
    for (; t <= o && !n[t]; )
      t++;
    t > o && (t = n.lastIndexOf(!0));
  }
  return t === -1 && (t = o), t;
}
function aO(e) {
  for (var t = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), n = 0, r = t.length; n < r; n++)
    t[n] = !!(Gi(e[n]) || Gi(e[n - 1]));
  return t;
}
function r3(e, t, n, r, o, i) {
  i === void 0 && (i = On);
  var s = $R(function(h, g) {
    var m, b;
    return _g(h) ? (b = "", m = "") : typeof h == "number" || g ? (b = typeof h == "number" ? t3(h) : h, m = r(b)) : (b = o(h, void 0), m = r(b)), { formattedValue: m, numAsString: b };
  }), a = Q(function() {
    return s(no(e) ? t : e, n);
  }), c = a[0], u = a[1], l = function(h, g) {
    h.formattedValue !== c.formattedValue && u({
      formattedValue: h.formattedValue,
      numAsString: h.value
    }), i(h, g);
  }, d = e, f = n;
  no(e) && (d = c.numAsString, f = !0);
  var p = s(d, f);
  return ve(function() {
    u(p);
  }, [p.formattedValue]), [c, l];
}
function cO(e) {
  return e.replace(/[^0-9]/g, "");
}
function uO(e) {
  return e;
}
function lO(e) {
  var t = e.type;
  t === void 0 && (t = "text");
  var n = e.displayType;
  n === void 0 && (n = "input");
  var r = e.customInput, o = e.renderText, i = e.getInputRef, s = e.format;
  s === void 0 && (s = uO);
  var a = e.removeFormatting;
  a === void 0 && (a = cO);
  var c = e.defaultValue, u = e.valueIsNumericString, l = e.onValueChange, d = e.isAllowed, f = e.onChange;
  f === void 0 && (f = On);
  var p = e.onKeyDown;
  p === void 0 && (p = On);
  var h = e.onMouseUp;
  h === void 0 && (h = On);
  var g = e.onFocus;
  g === void 0 && (g = On);
  var m = e.onBlur;
  m === void 0 && (m = On);
  var b = e.value, v = e.getCaretBoundary;
  v === void 0 && (v = aO);
  var C = e.isValidInputCharacter;
  C === void 0 && (C = Gi);
  var w = e.isCharacterSame, y = Kg(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), I = r3(b, c, !!u, s, a, l), x = I[0], E = x.formattedValue, P = x.numAsString, L = I[1], W = Ce(), V = Ce({ formattedValue: E, numAsString: P }), X = function(ie, T) {
    V.current = { formattedValue: ie.formattedValue, numAsString: ie.value }, L(ie, T);
  }, N = Q(!1), M = N[0], F = N[1], B = Ce(null), Z = Ce({
    setCaretTimeout: null,
    focusTimeout: null
  });
  Ie(function() {
    return F(!0), function() {
      clearTimeout(Z.current.setCaretTimeout), clearTimeout(Z.current.focusTimeout);
    };
  }, []);
  var H = s, K = function(ie, T) {
    var O = parseFloat(T);
    return {
      formattedValue: ie,
      value: T,
      floatValue: isNaN(O) ? void 0 : O
    };
  }, ee = function(ie, T, O) {
    ie.selectionStart === 0 && ie.selectionEnd === ie.value.length || (nr(ie, T), Z.current.setCaretTimeout = setTimeout(function() {
      ie.value === O && ie.selectionStart !== T && nr(ie, T);
    }, 0));
  }, z = function(ie, T, O) {
    return Tf(ie, T, v(ie), O);
  }, ce = function(ie, T, O) {
    var k = v(T), q = sO(T, E, ie, O, k, C, w);
    return q = Tf(T, q, k), q;
  }, be = function(ie) {
    var T = ie.formattedValue;
    T === void 0 && (T = "");
    var O = ie.input, k = ie.source, q = ie.event, U = ie.numAsString, G;
    if (O) {
      var oe = ie.inputValue || O.value, xe = ou(O);
      O.value = T, G = ce(oe, T, xe), G !== void 0 && ee(O, G, T);
    }
    T !== E && X(K(T, U), { event: q, source: k });
  };
  Ie(function() {
    var ie = V.current, T = ie.formattedValue, O = ie.numAsString;
    (E !== T || P !== O) && X(K(E, P), {
      event: void 0,
      source: zi.props
    });
  }, [E, P]);
  var te = B.current ? ou(B.current) : void 0, ue = typeof window < "u" ? Yn : Ie;
  ue(function() {
    var ie = B.current;
    if (E !== V.current.formattedValue && ie) {
      var T = ce(V.current.formattedValue, E, te);
      ie.value = E, ee(ie, T, E);
    }
  }, [E]);
  var me = function(ie, T, O) {
    var k = T.target, q = W.current ? tO(W.current, k.selectionEnd) : n3(E, ie), U = Object.assign(Object.assign({}, q), { lastValue: E }), G = a(ie, U), oe = H(G);
    if (G = a(oe, void 0), d && !d(K(oe, G))) {
      var xe = T.target, pe = ou(xe), Ze = ce(ie, E, pe);
      return xe.value = E, ee(xe, Ze, E), !1;
    }
    return be({
      formattedValue: oe,
      numAsString: G,
      inputValue: ie,
      event: T,
      source: O,
      input: T.target
    }), !0;
  }, Te = function(ie, T) {
    T === void 0 && (T = 0);
    var O = ie.selectionStart, k = ie.selectionEnd;
    W.current = { selectionStart: O, selectionEnd: k + T };
  }, Be = function(ie) {
    var T = ie.target, O = T.value, k = me(O, ie, zi.event);
    k && f(ie), W.current = void 0;
  }, et = function(ie) {
    var T = ie.target, O = ie.key, k = T.selectionStart, q = T.selectionEnd, U = T.value;
    U === void 0 && (U = "");
    var G;
    O === "ArrowLeft" || O === "Backspace" ? G = Math.max(k - 1, 0) : O === "ArrowRight" ? G = Math.min(k + 1, U.length) : O === "Delete" && (G = k);
    var oe = 0;
    O === "Delete" && k === q && (oe = 1);
    var xe = O === "ArrowLeft" || O === "ArrowRight";
    if (G === void 0 || k !== q && !xe) {
      p(ie), Te(T, oe);
      return;
    }
    var pe = G;
    if (xe) {
      var Ze = O === "ArrowLeft" ? "left" : "right";
      pe = z(U, G, Ze), pe !== G && ie.preventDefault();
    } else O === "Delete" && !C(U[G]) ? pe = z(U, G, "right") : O === "Backspace" && !C(U[G]) && (pe = z(U, G, "left"));
    pe !== G && ee(T, pe, U), p(ie), Te(T, oe);
  }, it = function(ie) {
    var T = ie.target, O = function() {
      var k = T.selectionStart, q = T.selectionEnd, U = T.value;
      if (U === void 0 && (U = ""), k === q) {
        var G = z(U, k);
        G !== k && ee(T, G, U);
      }
    };
    O(), requestAnimationFrame(function() {
      O();
    }), h(ie), Te(T);
  }, re = function(ie) {
    ie.persist && ie.persist();
    var T = ie.target, O = ie.currentTarget;
    B.current = T, Z.current.focusTimeout = setTimeout(function() {
      var k = T.selectionStart, q = T.selectionEnd, U = T.value;
      U === void 0 && (U = "");
      var G = z(U, k);
      G !== k && !(k === 0 && q === U.length) && ee(T, G, U), g(Object.assign(Object.assign({}, ie), { currentTarget: O }));
    }, 0);
  }, Ge = function(ie) {
    B.current = null, clearTimeout(Z.current.focusTimeout), clearTimeout(Z.current.setCaretTimeout), m(ie);
  }, nt = M && rO() ? "numeric" : void 0, Rt = Object.assign({ inputMode: nt }, y, {
    type: t,
    value: E,
    onChange: Be,
    onKeyDown: et,
    onMouseUp: it,
    onFocus: re,
    onBlur: Ge
  });
  if (n === "text")
    return o ? Y.createElement(Y.Fragment, null, o(E, y) || null) : Y.createElement("span", Object.assign({}, y, { ref: i }), E);
  if (r) {
    var $n = r;
    return Y.createElement($n, Object.assign({}, Rt, { ref: i }));
  }
  return Y.createElement("input", Object.assign({}, Rt, { ref: i }));
}
function Nf(e, t) {
  var n = t.decimalScale, r = t.fixedDecimalScale, o = t.prefix;
  o === void 0 && (o = "");
  var i = t.suffix;
  i === void 0 && (i = "");
  var s = t.allowNegative, a = t.thousandsGroupStyle;
  if (a === void 0 && (a = "thousand"), e === "" || e === "-")
    return e;
  var c = ic(t), u = c.thousandSeparator, l = c.decimalSeparator, d = n !== 0 && e.indexOf(".") !== -1 || n && r, f = nA(e, s), p = f.beforeDecimal, h = f.afterDecimal, g = f.addNegation;
  return n !== void 0 && (h = e3(h, n, !!r)), u && (p = _R(p, u, a)), o && (p = o + p), i && (h = h + i), g && (p = "-" + p), e = p + (d && l || "") + h, e;
}
function ic(e) {
  var t = e.decimalSeparator;
  t === void 0 && (t = ".");
  var n = e.thousandSeparator, r = e.allowedDecimalSeparators;
  return n === !0 && (n = ","), r || (r = [t, "."]), {
    decimalSeparator: t,
    thousandSeparator: n,
    allowedDecimalSeparators: r
  };
}
function dO(e, t) {
  e === void 0 && (e = "");
  var n = new RegExp("(-)"), r = new RegExp("(-)(.)*(-)"), o = n.test(e), i = r.test(e);
  return e = e.replace(/-/g, ""), o && !i && t && (e = "-" + e), e;
}
function AO(e, t) {
  return new RegExp("(^-)|[0-9]|" + $g(e), "g");
}
function fO(e, t, n) {
  return e === "" ? !0 : !(t != null && t.match(/\d/)) && !(n != null && n.match(/\d/)) && typeof e == "string" && !isNaN(Number(e));
}
function hO(e, t, n) {
  var r;
  t === void 0 && (t = oO(e));
  var o = n.allowNegative, i = n.prefix;
  i === void 0 && (i = "");
  var s = n.suffix;
  s === void 0 && (s = "");
  var a = n.decimalScale, c = t.from, u = t.to, l = u.start, d = u.end, f = ic(n), p = f.allowedDecimalSeparators, h = f.decimalSeparator, g = e[d] === h;
  if (Gi(e) && (e === i || e === s) && t.lastValue === "")
    return e;
  if (d - l === 1 && p.indexOf(e[l]) !== -1) {
    var m = a === 0 ? "" : h;
    e = e.substring(0, l) + m + e.substring(l + 1, e.length);
  }
  var b = function(B, Z, H) {
    var K = !1, ee = !1;
    i.startsWith("-") ? K = !1 : B.startsWith("--") ? (K = !1, ee = !0) : s.startsWith("-") && B.length === s.length ? K = !1 : B[0] === "-" && (K = !0);
    var z = K ? 1 : 0;
    return ee && (z = 2), z && (B = B.substring(z), Z -= z, H -= z), { value: B, start: Z, end: H, hasNegation: K };
  }, v = b(e, l, d), C = v.hasNegation;
  r = v, e = r.value, l = r.start, d = r.end;
  var w = b(t.lastValue, c.start, c.end), y = w.start, I = w.end, x = w.value, E = e.substring(l, d);
  e.length && x.length && (y > x.length - s.length || I < i.length) && !(E && s.startsWith(E)) && (e = x);
  var P = 0;
  e.startsWith(i) ? P += i.length : l < i.length && (P = l), e = e.substring(P), d -= P;
  var L = e.length, W = e.length - s.length;
  e.endsWith(s) ? L = W : (d > W || d > e.length - s.length) && (L = d), e = e.substring(0, L), e = dO(C ? "-" + e : e, o), e = (e.match(AO(h)) || []).join("");
  var V = e.indexOf(h);
  e = e.replace(new RegExp($g(h), "g"), function(B, Z) {
    return Z === V ? "." : "";
  });
  var X = nA(e, o), N = X.beforeDecimal, M = X.afterDecimal, F = X.addNegation;
  return u.end - u.start < c.end - c.start && N === "" && g && !parseFloat(M) && (e = F ? "-" : ""), e;
}
function pO(e, t) {
  var n = t.prefix;
  n === void 0 && (n = "");
  var r = t.suffix;
  r === void 0 && (r = "");
  var o = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), i = e[0] === "-";
  o.fill(!1, 0, n.length + (i ? 1 : 0));
  var s = e.length;
  return o.fill(!1, s - r.length + 1, s + 1), o;
}
function mO(e) {
  var t = ic(e), n = t.thousandSeparator, r = t.decimalSeparator, o = e.prefix;
  o === void 0 && (o = "");
  var i = e.allowNegative;
  if (i === void 0 && (i = !0), n === r)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + n + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + r + ` (default value for decimalSeparator is .)
     `);
  return o.startsWith("-") && i && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + o + `
      allowNegative: ` + i + `
    `), i = !1), Object.assign(Object.assign({}, e), { allowNegative: i });
}
function gO(e) {
  e = mO(e), e.decimalSeparator, e.allowedDecimalSeparators, e.thousandsGroupStyle;
  var t = e.suffix, n = e.allowNegative, r = e.allowLeadingZeros, o = e.onKeyDown;
  o === void 0 && (o = On);
  var i = e.onBlur;
  i === void 0 && (i = On);
  var s = e.thousandSeparator, a = e.decimalScale, c = e.fixedDecimalScale, u = e.prefix;
  u === void 0 && (u = "");
  var l = e.defaultValue, d = e.value, f = e.valueIsNumericString, p = e.onValueChange, h = Kg(e, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), g = ic(e), m = g.decimalSeparator, b = g.allowedDecimalSeparators, v = function(F) {
    return Nf(F, e);
  }, C = function(F, B) {
    return hO(F, B, e);
  }, w = no(d) ? l : d, y = f ?? fO(w, u, t);
  no(d) ? no(l) || (y = y || typeof l == "number") : y = y || typeof d == "number";
  var I = function(F) {
    return _g(F) ? F : (typeof F == "number" && (F = t3(F)), y && typeof a == "number" ? Sf(F, a, !!c) : F);
  }, x = r3(I(d), I(l), !!y, v, C, p), E = x[0], P = E.numAsString, L = E.formattedValue, W = x[1], V = function(F) {
    var B = F.target, Z = F.key, H = B.selectionStart, K = B.selectionEnd, ee = B.value;
    if (ee === void 0 && (ee = ""), (Z === "Backspace" || Z === "Delete") && K < u.length) {
      F.preventDefault();
      return;
    }
    if (H !== K) {
      o(F);
      return;
    }
    Z === "Backspace" && ee[0] === "-" && H === u.length + 1 && n && nr(B, 1), a && c && (Z === "Backspace" && ee[H - 1] === m ? (nr(B, H - 1), F.preventDefault()) : Z === "Delete" && ee[H] === m && F.preventDefault()), b != null && b.includes(Z) && ee[H] === m && nr(B, H + 1);
    var z = s === !0 ? "," : s;
    Z === "Backspace" && ee[H - 1] === z && nr(B, H - 1), Z === "Delete" && ee[H] === z && nr(B, H + 1), o(F);
  }, X = function(F) {
    var B = P;
    if (B.match(/\d/g) || (B = ""), r || (B = eO(B)), c && a && (B = Sf(B, a, c)), B !== P) {
      var Z = Nf(B, e);
      W({
        formattedValue: Z,
        value: B,
        floatValue: parseFloat(B)
      }, {
        event: F,
        source: zi.event
      });
    }
    i(F);
  }, N = function(F) {
    return F === m ? !0 : Gi(F);
  }, M = function(F) {
    var B = F.currentValue, Z = F.lastValue, H = F.formattedValue, K = F.currentValueIndex, ee = F.formattedValueIndex, z = B[K], ce = H[ee], be = n3(Z, B), te = be.to;
    return K >= te.start && K < te.end && b && b.includes(z) && ce === m ? !0 : z === ce;
  };
  return Object.assign(Object.assign({}, h), {
    value: L,
    valueIsNumericString: !1,
    isValidInputCharacter: N,
    isCharacterSame: M,
    onValueChange: W,
    format: v,
    removeFormatting: C,
    getCaretBoundary: function(F) {
      return pO(F, e);
    },
    onKeyDown: V,
    onBlur: X
  });
}
function o3(e) {
  var t = gO(e);
  return Y.createElement(lO, Object.assign({}, t));
}
function wl(e) {
  const {
    name: t,
    control: n,
    currency: r,
    rules: o,
    errorMessage: i,
    errorMessageClassName: s,
    numericFormatProps: a,
    value: c,
    onChange: u,
    ...l
  } = e, {
    allowNegative: d = !1,
    decimalScale: f = 2,
    thousandSeparator: p = ",",
    fixedDecimalScale: h = !0
  } = a ?? {}, g = r === "USD" ? "$" : void 0, m = e["aria-invalid"] === "true";
  return /* @__PURE__ */ A(
    Xd,
    {
      name: t,
      control: n,
      rules: o,
      render: ({ field: { onChange: b, value: v, ref: C } }) => /* @__PURE__ */ R(Ee, { children: [
        /* @__PURE__ */ A(
          o3,
          {
            ...l,
            getInputRef: C,
            prefix: g,
            allowNegative: d,
            decimalScale: f,
            onValueChange: ({ floatValue: w }) => b(w),
            value: v,
            customInput: Gt,
            thousandSeparator: p,
            fixedDecimalScale: h
          }
        ),
        m && !!i && /* @__PURE__ */ A(
          "p",
          {
            role: "alert",
            className: $(
              "text-sm text-red-900",
              s
            ),
            children: i
          }
        )
      ] })
    }
  );
}
function pr(e) {
  const {
    options: t,
    name: n,
    control: r,
    rules: o,
    errorMessage: i,
    errorMessageClassName: s,
    disabled: a = !1,
    ...c
  } = e, u = e["aria-invalid"] === "true";
  return /* @__PURE__ */ A(
    Xd,
    {
      name: n,
      control: r,
      rules: o,
      render: ({ field: { onChange: l, onBlur: d, value: f } }) => {
        var p;
        return a ? /* @__PURE__ */ A(Ee, { children: (p = t.find((h) => h.value === f)) == null ? void 0 : p.label }) : /* @__PURE__ */ R(Ee, { children: [
          /* @__PURE__ */ A(
            Pu,
            {
              options: t,
              onBlur: d,
              value: t.find(
                (h) => h.value === f
              ) ?? null,
              isDisabled: a,
              onChange: (h) => !!h && typeof h == "object" && "value" in h && l(h.value),
              ...c
            }
          ),
          u && !!i && /* @__PURE__ */ A(
            "p",
            {
              role: "alert",
              className: $(
                "text-sm text-red-900",
                s
              ),
              children: i
            }
          )
        ] });
      }
    }
  );
}
const bO = Pt(function(t, n) {
  const r = t["aria-invalid"] === "true", {
    errorMessage: o,
    labelClassName: i,
    inputClassName: s,
    errorMessageClassName: a,
    ...c
  } = t;
  return /* @__PURE__ */ R("label", { className: i, children: [
    /* @__PURE__ */ A(
      "input",
      {
        ...c,
        type: "text",
        ref: n,
        className: $(
          "h-8 w-full rounded-md border border-transparent bg-gray-100 p-3 text-right placeholder:text-gray-500 disabled:bg-transparent disabled:p-0 disabled:text-left",
          r && "border-red-900 outline-red-900 placeholder:text-red-800",
          s
        )
      }
    ),
    r && !!o && /* @__PURE__ */ A(
      "p",
      {
        role: "alert",
        className: $(
          "text-sm text-red-900",
          a
        ),
        children: o
      }
    )
  ] });
}), Gt = Tr(bO);
function vO(e) {
  const { inputs: t } = e;
  return /* @__PURE__ */ A("div", { className: "bg-white text-xs font-medium", children: t.map(({ label: n, Input: r }, o) => /* @__PURE__ */ R("div", { className: "mb-4 mt-2 grid gap-1", children: [
    /* @__PURE__ */ A("label", { className: "text-base", children: n }),
    /* @__PURE__ */ A("div", { children: /* @__PURE__ */ A(r, {}) }, o)
  ] }, n)) });
}
function ji(e) {
  const {
    itemName: t,
    open: n,
    state: r,
    inputs: o,
    onOpenChange: i,
    reset: s,
    submit: a,
    ...c
  } = e;
  function u() {
    s(), i(!1);
  }
  const l = "min-h-[48px] min-w-[142px] text-base font-semibold py-3 px-6 rounded-xl outline-none active:opacity-75 hover:scale-105 transform transition-all";
  return /* @__PURE__ */ A(
    wn,
    {
      open: n,
      overlayProps: {
        className: "top-10"
      },
      contentProps: {
        className: "rounded-3xl"
      },
      onOpenChange: i,
      ...c,
      children: /* @__PURE__ */ R("div", { className: "w-[400px] p-6 text-slate-300", children: [
        /* @__PURE__ */ R("div", { className: "mb-6 flex justify-between", children: [
          /* @__PURE__ */ R("h1", { className: "text-xl font-bold", children: [
            "Create ",
            t
          ] }),
          /* @__PURE__ */ A(
            "button",
            {
              className: "flex size-8 items-center justify-center rounded-md bg-gray-100 text-gray-500 outline-none hover:text-gray-900",
              onClick: u,
              tabIndex: -1,
              children: /* @__PURE__ */ A(J, { name: "XmarkLight", size: 24 })
            }
          )
        ] }),
        /* @__PURE__ */ A(vO, { inputs: o }),
        /* @__PURE__ */ R("div", { className: "mt-8 flex justify-between gap-3", children: [
          /* @__PURE__ */ A(
            "button",
            {
              onClick: u,
              className: $(
                l,
                "flex-1 bg-slate-50 text-slate-800"
              ),
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ A(
            "button",
            {
              onClick: a,
              className: $(
                l,
                "flex-1 bg-gray-800 text-gray-50"
              ),
              children: "Save"
            }
          )
        ] })
      ] })
    }
  );
}
const yO = (e) => {
  const {
    itemName: t,
    dependentItemName: n,
    dependentItemList: r,
    onOpenChange: o,
    onContinue: i,
    ...s
  } = e;
  return /* @__PURE__ */ A(
    wn,
    {
      overlayProps: {
        className: "top-10"
      },
      contentProps: {
        className: "rounded-3xl"
      },
      onOpenChange: o,
      ...s,
      children: /* @__PURE__ */ R("div", { className: "w-[400px] p-6 text-slate-300", children: [
        /* @__PURE__ */ R("div", { className: "border-b border-slate-50 pb-2 text-2xl font-bold text-gray-800", children: [
          "Cannot delete ",
          t
        ] }),
        /* @__PURE__ */ R("div", { className: "my-6 flex gap-2 rounded-md bg-orange-100 p-4 text-orange-800", children: [
          /* @__PURE__ */ A("div", { children: /* @__PURE__ */ A(J, { name: "Error", className: "mt-1 text-orange-800" }) }),
          /* @__PURE__ */ R("div", { children: [
            "Warning! Cannot delete this ",
            t,
            " because there are",
            " ",
            n,
            " that depend on it. Please change or delete those first."
          ] })
        ] }),
        /* @__PURE__ */ A("div", { className: "my-6 rounded-md bg-slate-50 p-4 text-slate-200", children: r.map((a, c) => /* @__PURE__ */ A(mr, { children: a }, c)) }),
        /* @__PURE__ */ A("div", { className: "mt-8 flex justify-between gap-3", children: /* @__PURE__ */ A(
          "button",
          {
            onClick: i,
            className: "min-h-12 min-w-36 flex-1 rounded-xl bg-gray-800 px-6 py-3 text-base font-semibold text-gray-50 outline-none transition-all hover:scale-105 active:opacity-75",
            children: "Back"
          }
        ) })
      ] })
    }
  );
};
function CO(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s
  } = e, { serviceProviderFeeTypes: a, transactions: c, principalLenderAccountId: u } = t, l = (n == null ? void 0 : n.id) === u, { submit: d, reset: f, inputs: p } = i3({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s
  }), h = () => /* @__PURE__ */ A(Lo, { inputs: p }), g = !l, m = a.filter(
    ({ accountId: E }) => E === (n == null ? void 0 : n.id)
  ), b = c.map((E, P) => ({
    ...E,
    txNumber: P + 1
  })).filter(
    (E) => {
      var P, L;
      return ((P = E.cashTransaction) == null ? void 0 : P.accountId) === (n == null ? void 0 : n.id) || ((L = E.fixedIncomeTransaction) == null ? void 0 : L.accountId) === (n == null ? void 0 : n.id);
    }
  ), v = m.length && b.length ? "service providers and transactions" : m.length ? "service providers" : "transactions", C = m.length ? [
    /* @__PURE__ */ A("div", { className: "mb-0.5 font-semibold", children: "Service providers:" }, 1),
    ...m.map((E, P) => /* @__PURE__ */ A("div", { children: E.name }, P))
  ] : [], w = b.length ? [
    /* @__PURE__ */ A("div", { className: "mb-0.5 mt-1 font-semibold", children: "Transactions:" }, 5),
    ...b.map((E) => /* @__PURE__ */ R("div", { children: [
      "Transaction #",
      E.txNumber
    ] }, E.id))
  ] : [], y = [
    ...C,
    ...w
  ];
  return /* @__PURE__ */ A(Xo, { ...e, ...{
    formInputs: h,
    dependentItemProps: {
      dependentItemName: v,
      dependentItemList: y
    },
    submit: d,
    reset: f,
    isAllowedToDeleteItem: g
  } });
}
const xO = Tr(CO), wO = [
  { key: "label", label: "Label", allowSorting: !0 },
  { key: "reference", label: "Reference", allowSorting: !0 }
];
function IO(e, t) {
  return Vr(e).map((o) => ({
    ...o,
    customTransform: (s, a) => {
      if (o.id === t && a === "label")
        return /* @__PURE__ */ R(Ee, { children: [
          s,
          " ",
          /* @__PURE__ */ R("span", { className: "ml-2 inline-flex items-center gap-1 rounded bg-green-100 px-1 font-extralight", children: [
            "Lender ",
            /* @__PURE__ */ A(J, { name: "CheckCircle", size: 14 })
          ] })
        ] });
    }
  }));
}
function fF(e) {
  const { state: t } = e, { accounts: n, principalLenderAccountId: r } = t, o = "Account", i = ve(
    () => IO(n, r),
    [n, r]
  ), [s, a] = Q(), { operation: c, setOperation: u, showForm: l, existingState: d } = Zo({ state: t });
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      Wo,
      {
        ...e,
        itemName: o,
        tableData: i,
        columns: wO,
        selectedTableItem: s,
        operation: c,
        setSelectedTableItem: a,
        setOperation: u
      }
    ),
    l && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      xO,
      {
        ...e,
        itemName: o,
        state: d,
        tableItem: s,
        operation: c,
        setSelectedTableItem: a,
        setOperation: u
      }
    ) })
  ] });
}
function Ho(e) {
  const {
    operation: t,
    createDefaultValues: n,
    editDefaultValues: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s,
    customSubmitHandler: a
  } = e, c = t === "create" ? n : r, { register: u, handleSubmit: l, reset: d, watch: f, control: p, formState: h } = Qa({
    defaultValues: c
  }), g = ye(
    (b) => {
      if (!t || t === "view") return;
      if (a) {
        a(b);
        return;
      }
      const C = {
        create: o,
        edit: i,
        delete: s
      }[t];
      C == null || C(b);
    },
    [
      a,
      o,
      s,
      i,
      t
    ]
  ), m = l(g);
  return ve(
    () => ({
      register: u,
      reset: d,
      watch: f,
      control: p,
      formState: h,
      submit: m
    }),
    [p, h, u, d, m, f]
  );
}
function i3(e) {
  var g, m, b, v;
  const { item: t, onSubmitCreate: n, onSubmitEdit: r, onSubmitDelete: o, operation: i } = e, s = {
    label: null,
    reference: null
  }, a = t ? {
    id: t.id,
    label: t.label,
    reference: t.reference
  } : s, { submit: c, reset: u, register: l, control: d, formState: f } = Ho({
    operation: i,
    createDefaultValues: s,
    editDefaultValues: a,
    onSubmitCreate: n,
    onSubmitEdit: r,
    onSubmitDelete: o
  }), { errors: p } = f, h = ve(
    () => [
      {
        label: "Account Label",
        Input: () => {
          var C, w;
          return /* @__PURE__ */ A(
            Gt,
            {
              ...l("label", {
                disabled: i === "view",
                required: "Account label is required"
              }),
              "aria-invalid": ((C = p.label) == null ? void 0 : C.type) === "required" ? "true" : "false",
              errorMessage: (w = p.label) == null ? void 0 : w.message,
              placeholder: "E.g. My Label"
            }
          );
        }
      },
      {
        label: "Account Reference",
        Input: () => {
          var C, w;
          return /* @__PURE__ */ A(
            Gt,
            {
              ...l("reference", {
                disabled: i === "view",
                required: "Account reference is required"
              }),
              "aria-invalid": ((C = p.reference) == null ? void 0 : C.type) === "required" ? "true" : "false",
              errorMessage: (w = p.reference) == null ? void 0 : w.message,
              placeholder: "E.g. bank account number or ETH address"
            }
          );
        }
      }
    ],
    [
      (g = p.label) == null ? void 0 : g.message,
      (m = p.label) == null ? void 0 : m.type,
      (b = p.reference) == null ? void 0 : b.message,
      (v = p.reference) == null ? void 0 : v.type,
      i,
      l
    ]
  );
  return ve(() => ({
    submit: c,
    reset: u,
    register: l,
    control: d,
    inputs: h,
    formState: { errors: p }
  }), [c, u, l, d, h, p]);
}
function EO(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s,
    onSubmitCreateFixedIncomeType: a,
    onSubmitCreateSpv: c
  } = e, { transactions: u } = t, {
    submit: l,
    reset: d,
    inputs: f,
    showCreateFixedIncomeTypeModal: p,
    setShowCreateFixedIncomeTypeModal: h,
    showCreateSpvModal: g,
    setShowCreateSpvModal: m
  } = s3({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s
  }), b = () => /* @__PURE__ */ A(Lo, { inputs: f }), v = m3({
    state: t,
    operation: "create",
    onSubmitCreate: (x) => {
      a(x), h(!1);
    }
  }), C = C3({
    state: t,
    operation: "create",
    onSubmitCreate: (x) => {
      c(x), m(!1);
    }
  }), I = {
    dependentItemName: "transactions",
    dependentItemList: u.map((x, E) => ({
      ...x,
      txNumber: E + 1
    })).filter((x) => {
      var E;
      return ((E = x.fixedIncomeTransaction) == null ? void 0 : E.assetId) === (n == null ? void 0 : n.id);
    }).map((x) => /* @__PURE__ */ R("div", { children: [
      "Transaction #",
      x.txNumber
    ] }, x.id))
  };
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      Xo,
      {
        ...e,
        formInputs: b,
        dependentItemProps: I,
        submit: l,
        reset: d
      }
    ),
    p && /* @__PURE__ */ A(
      ji,
      {
        ...v,
        state: t,
        onOpenChange: h,
        open: p,
        itemName: "Fixed Income Type"
      }
    ),
    g && /* @__PURE__ */ A(
      ji,
      {
        ...C,
        state: t,
        onOpenChange: m,
        open: g,
        itemName: "SPV"
      }
    )
  ] });
}
const SO = Tr(EO);
function ei(e, t) {
  return e.reduce((n, r) => n + Number(r[t]), 0);
}
const TO = [
  { key: "name", label: "Name", allowSorting: !0 },
  {
    key: "purchaseDate",
    label: "Purchase Date",
    allowSorting: !0
  },
  { key: "maturity", label: "Maturity", allowSorting: !0 },
  {
    key: "notional",
    label: "Notional",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "currentValue",
    label: "Current Value",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "purchasePrice",
    label: "Purchase Price",
    allowSorting: !0,
    isNumberColumn: !0,
    decimalScale: 6
  },
  {
    key: "purchaseProceeds",
    label: "Purchase Proceeds",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "salesProceeds",
    label: "Sales Proceeds",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "totalDiscount",
    label: "Total Discount",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "realizedSurplus",
    label: "Realized Surplus",
    allowSorting: !0,
    isNumberColumn: !0
  }
];
function NO(e, t) {
  const n = /* @__PURE__ */ new Date();
  return e.map((o) => {
    const i = t(o, n);
    return {
      ...o,
      currentValue: i
    };
  });
}
function PO(e) {
  const t = "Asset", { state: n, calculateCurrentValueCallback: r } = e, o = sc(n), i = ve(
    () => Vr(
      NO(o, r)
    ),
    [o, r]
  ), [s, a] = Q(), { operation: c, setOperation: u, showForm: l, existingState: d } = Zo({ state: n }), f = sM(n), p = {
    id: "special-first-row",
    name: "Cash $USD",
    fixedIncomeTypeId: "--",
    spvId: "--",
    maturity: "--",
    ISIN: "--",
    CUSIP: "--",
    coupon: null,
    notional: (f == null ? void 0 : f.balance) ?? 0,
    purchaseDate: "--",
    purchasePrice: "--",
    purchaseProceeds: "--",
    salesProceeds: "--",
    totalDiscount: "--",
    realizedSurplus: "--",
    currentValue: "--"
  }, h = ei(
    [...o, p],
    "notional"
  ), g = ei(
    o,
    "purchaseProceeds"
  ), m = ei(o, "salesProceeds"), b = ei(o, "totalDiscount"), v = ei(o, "realizedSurplus");
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      Wo,
      {
        ...e,
        itemName: t,
        tableData: i,
        columns: TO,
        selectedTableItem: s,
        operation: c,
        setSelectedTableItem: a,
        setOperation: u,
        specialFirstRow: (y) => /* @__PURE__ */ A(Il, { children: y.map((I) => /* @__PURE__ */ R(mr, { children: [
          I.key === "name" && /* @__PURE__ */ A(xt, { children: "Cash $USD" }),
          I.key === "notional" && /* @__PURE__ */ A(xt, { className: "text-right", children: Wt(
            p[I.key]
          ) }, I.key),
          I.key !== "name" && I.key !== "notional" && /* @__PURE__ */ A(xt, {})
        ] }, I.key)) }),
        specialLastRow: (y) => /* @__PURE__ */ A(
          Il,
          {
            className: $(
              "sticky bottom-0",
              s !== void 0 && "hidden"
            ),
            children: y.map((I) => /* @__PURE__ */ R(mr, { children: [
              I.key === "name" && /* @__PURE__ */ A(xt, { children: "Totals" }),
              I.key === "notional" && /* @__PURE__ */ A(xt, { className: "text-right", children: Wt(h) }, I.key),
              I.key === "purchaseProceeds" && /* @__PURE__ */ A(xt, { className: "text-right", children: Wt(g) }, I.key),
              I.key === "salesProceeds" && /* @__PURE__ */ A(xt, { className: "text-right", children: Wt(m) }, I.key),
              I.key === "totalDiscount" && /* @__PURE__ */ A(xt, { className: "text-right", children: Wt(b) }, I.key),
              I.key === "realizedSurplus" && /* @__PURE__ */ A(xt, { className: "text-right", children: Wt(v) }, I.key),
              I.key !== "name" && I.key !== "notional" && I.key !== "purchaseProceeds" && I.key !== "salesProceeds" && I.key !== "totalDiscount" && I.key !== "realizedSurplus" && I.key !== "currentValue" && /* @__PURE__ */ A(xt, {})
            ] }, I.key))
          }
        )
      }
    ),
    l && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      SO,
      {
        ...e,
        itemName: t,
        state: d,
        tableItem: s,
        operation: c,
        setSelectedTableItem: a,
        setOperation: u
      }
    ) })
  ] });
}
function s3(e) {
  var x, E;
  const [t, n] = Q(!1), [r, o] = Q(!1), {
    item: i,
    state: s,
    onSubmitCreate: a,
    onSubmitEdit: c,
    onSubmitDelete: u,
    operation: l
  } = e, { fixedIncomeTypes: d, spvs: f } = s, p = {
    fixedIncomeTypeId: ((x = d[0]) == null ? void 0 : x.id) ?? null,
    spvId: ((E = f[0]) == null ? void 0 : E.id) ?? null,
    name: null,
    maturity: null,
    ISIN: null,
    CUSIP: null,
    coupon: null
  }, h = i ? {
    id: i.id,
    fixedIncomeTypeId: i.fixedIncomeTypeId,
    spvId: i.spvId,
    name: i.name,
    maturity: i.maturity ? Sl(i.maturity) : null,
    ISIN: i.ISIN,
    CUSIP: i.CUSIP,
    coupon: i.coupon
  } : p, { submit: g, reset: m, register: b, control: v, formState: C } = Ho({
    operation: l,
    createDefaultValues: p,
    editDefaultValues: h,
    onSubmitCreate: a,
    onSubmitEdit: c,
    onSubmitDelete: u
  }), { errors: w } = C, y = ve(
    () => l !== "create" ? [
      {
        label: "Notional",
        Input: () => /* @__PURE__ */ A(Ee, { children: Wt(i == null ? void 0 : i.notional) })
      },
      {
        label: "Purchase Date",
        Input: () => /* @__PURE__ */ A(Ee, { children: Wt(i == null ? void 0 : i.purchaseDate) })
      },
      {
        label: "Purchase Price",
        Input: () => /* @__PURE__ */ A(Ee, { children: Wt(i == null ? void 0 : i.purchasePrice, 6) })
      },
      {
        label: "Purchase Proceeds",
        Input: () => /* @__PURE__ */ A(Ee, { children: Wt(i == null ? void 0 : i.purchaseProceeds) })
      }
    ] : [],
    [
      i == null ? void 0 : i.notional,
      i == null ? void 0 : i.purchaseDate,
      i == null ? void 0 : i.purchasePrice,
      i == null ? void 0 : i.purchaseProceeds,
      l
    ]
  ), I = ve(
    () => [
      {
        label: "Asset Name",
        Input: () => {
          var P;
          return /* @__PURE__ */ A(
            Gt,
            {
              ...b("name", {
                disabled: l === "view",
                required: "Asset name is required"
              }),
              "aria-invalid": w.name ? "true" : "false",
              errorMessage: (P = w.name) == null ? void 0 : P.message,
              placeholder: "E.g. My Asset",
              inputClassName: "text-left"
            }
          );
        }
      },
      {
        label: "CUSIP",
        Input: () => {
          var P;
          return l === "view" ? (i == null ? void 0 : i.CUSIP) ?? "Not available" : /* @__PURE__ */ A(
            Gt,
            {
              ...b("CUSIP", {
                maxLength: {
                  value: 9,
                  message: "CUSIP cannot be longer than 9 characters"
                },
                minLength: {
                  value: 9,
                  message: "CUSIP cannot be shorter than 9 characters"
                },
                pattern: {
                  value: /^[a-zA-Z0-9]*$/,
                  message: "CUSIP must be alphanumeric"
                }
              }),
              errorMessage: (P = w.CUSIP) == null ? void 0 : P.message,
              "aria-invalid": w.CUSIP ? "true" : "false",
              placeholder: "E.g. A2345B789"
            }
          );
        }
      },
      {
        label: "ISIN",
        Input: () => {
          var P;
          return l === "view" ? (i == null ? void 0 : i.ISIN) ?? "Not available" : /* @__PURE__ */ A(
            Gt,
            {
              ...b("ISIN", {
                maxLength: {
                  value: 12,
                  message: "ISIN cannot be longer than 12 characters"
                },
                minLength: {
                  value: 12,
                  message: "ISIN cannot be shorter than 12 characters"
                },
                pattern: {
                  value: /^[a-zA-Z0-9]*$/,
                  message: "ISIN must be alphanumeric"
                }
              }),
              errorMessage: (P = w.ISIN) == null ? void 0 : P.message,
              "aria-invalid": w.ISIN ? "true" : "false",
              placeholder: "E.g. 123456789ABC"
            }
          );
        }
      },
      {
        label: "Maturity",
        Input: () => /* @__PURE__ */ A(
          Ep,
          {
            ...b("maturity", {
              disabled: l === "view",
              setValueAs: (P) => P === "" ? null : P
            }),
            name: "maturity"
          }
        )
      },
      {
        label: "Asset Type",
        Input: () => {
          var P;
          return /* @__PURE__ */ A(
            pr,
            {
              control: v,
              name: "fixedIncomeTypeId",
              disabled: l === "view",
              options: d.map((L) => ({
                ...L,
                value: L.id,
                label: L.name
              })),
              addItemButtonProps: {
                onClick: () => n(!0),
                label: "Create Fixed Income Type"
              },
              rules: { required: "Asset type is required" },
              "aria-invalid": w.fixedIncomeTypeId ? "true" : "false",
              errorMessage: (P = w.fixedIncomeTypeId) == null ? void 0 : P.message
            }
          );
        }
      },
      {
        label: "SPV",
        Input: () => {
          var P;
          return /* @__PURE__ */ A(
            pr,
            {
              control: v,
              name: "spvId",
              disabled: l === "view",
              options: f.map((L) => ({
                ...L,
                value: L.id,
                label: L.name
              })),
              addItemButtonProps: {
                onClick: () => o(!0),
                label: "Create SPV"
              },
              rules: { required: "SPV is required" },
              "aria-invalid": w.spvId ? "true" : "false",
              errorMessage: (P = w.spvId) == null ? void 0 : P.message
            }
          );
        }
      },
      ...y
    ],
    [
      y,
      b,
      l,
      w.name,
      w.CUSIP,
      w.ISIN,
      w.fixedIncomeTypeId,
      w.spvId,
      i == null ? void 0 : i.CUSIP,
      i == null ? void 0 : i.ISIN,
      v,
      d,
      f
    ]
  );
  return ve(() => ({
    submit: g,
    reset: m,
    register: b,
    control: v,
    inputs: I,
    formState: C,
    showCreateFixedIncomeTypeModal: t,
    setShowCreateFixedIncomeTypeModal: n,
    showCreateSpvModal: r,
    setShowCreateSpvModal: o
  }), [
    g,
    m,
    b,
    v,
    I,
    C,
    t,
    r
  ]);
}
function rA(e) {
  const {
    value: t,
    currency: n,
    decimalScale: r = 2,
    thousandSeparator: o = ",",
    fixedDecimalScale: i = !0
  } = e;
  return /* @__PURE__ */ A(
    o3,
    {
      displayType: "text",
      value: t,
      prefix: n === "USD" ? "$" : void 0,
      decimalScale: r,
      thousandSeparator: o,
      fixedDecimalScale: i
    }
  );
}
const hF = (e) => {
  const { label: t, ...n } = e;
  return /* @__PURE__ */ A("th", { scope: "col", ...n, children: t });
};
function Xo(e) {
  const {
    tableItem: t,
    itemName: n,
    className: r,
    operation: o = "view",
    isAllowedToCreateDocuments: i,
    isAllowedToEditDocuments: s,
    isAllowedToDeleteItem: a = !0,
    dependentItemProps: c,
    formInputs: u,
    setOperation: l,
    submit: d,
    onSubmitDelete: f,
    reset: p,
    setSelectedTableItem: h
  } = e, [g, m] = Q(!1), b = !!(c != null && c.dependentItemList.length), v = o === "edit", C = o === "create", w = o === "view", y = i || s, I = !w && y, x = !w && y, E = v && s && a, P = w && s;
  function L() {
    if (o === "edit") {
      l("view");
      return;
    }
    p(), h(void 0), l(null);
  }
  function W() {
    if (t) {
      if (b) {
        m(!0);
        return;
      }
      f(t.id), h(void 0);
    }
  }
  const V = /* @__PURE__ */ A(ru, { onClick: L, className: "text-gray-600", children: "Cancel" }), X = /* @__PURE__ */ A(
    ru,
    {
      onClick: d,
      iconPosition: "right",
      icon: /* @__PURE__ */ A(J, { name: "Save", size: 16 }),
      children: C ? "Save" : "Save Edits"
    }
  ), N = /* @__PURE__ */ A("button", { onClick: W, children: /* @__PURE__ */ A(J, { name: "Trash", className: "ml-3 text-red-800", size: 22 }) }), M = /* @__PURE__ */ R(
    ru,
    {
      onClick: () => {
        h(t), l("edit");
      },
      iconPosition: "right",
      icon: /* @__PURE__ */ A(J, { name: "Pencil", size: 16 }),
      children: [
        "Edit ",
        n
      ]
    }
  );
  return /* @__PURE__ */ R(
    "div",
    {
      className: $(
        "flex flex-col rounded-md border border-gray-300 bg-white",
        r
      ),
      children: [
        /* @__PURE__ */ R("div", { className: "flex justify-between rounded-t-md border-b border-gray-300 bg-gray-100 p-3 font-semibold text-gray-800", children: [
          /* @__PURE__ */ A("div", { className: "flex items-center", children: t != null && t.itemNumber ? `${n} #${t.itemNumber}` : `New ${n}` }),
          /* @__PURE__ */ R("div", { className: "flex gap-x-2", children: [
            I && V,
            x && X,
            E && N,
            P && M
          ] })
        ] }),
        /* @__PURE__ */ A(u, {}),
        c && /* @__PURE__ */ A(
          yO,
          {
            ...c,
            itemName: n.toLowerCase(),
            open: g,
            onContinue: () => m(!1)
          }
        )
      ]
    }
  );
}
const Il = Pt(function(t, n) {
  const { children: r, className: o, ...i } = t;
  return /* @__PURE__ */ A(
    "tr",
    {
      ...i,
      ref: n,
      className: $("odd:bg-white even:bg-gray-50", o),
      children: r
    }
  );
}), a3 = 34, c3 = 42, RO = a3 * 20 + c3;
function OO(e) {
  var l, d;
  const { selectedRowNumber: t, tableContainerRef: n, rowRefs: r, headerRef: o } = e, [i, s] = Q(
    `${RO}px`
  ), a = ((l = r.current[1]) == null ? void 0 : l.offsetHeight) ?? a3, c = ((d = o.current) == null ? void 0 : d.offsetHeight) ?? c3, u = ye(() => {
    var h, g;
    if (t === void 0) {
      const m = a * 20 + c;
      s(`${m}px`);
      return;
    }
    const f = (h = n.current) == null ? void 0 : h.getBoundingClientRect(), p = (g = r.current[t]) == null ? void 0 : g.getBoundingClientRect();
    if (p && f) {
      const m = p.bottom, b = f.top, v = m - b;
      s(`${v}px`);
    }
  }, [
    c,
    a,
    r,
    t,
    n
  ]);
  return Ie(() => {
    u();
  }, [u]), Ie(() => {
    const f = () => {
      u();
    }, p = n.current;
    return p && p.addEventListener("scroll", f), () => {
      p && p.removeEventListener(
        "scroll",
        f
      );
    };
  }, [n, u]), i;
}
function Wo(e) {
  const {
    itemName: t,
    columns: n,
    tableData: r,
    selectedTableItem: o,
    columnCountByTableWidth: i = zO,
    isAllowedToCreateDocuments: s,
    operation: a,
    setSelectedTableItem: c,
    setOperation: u,
    specialFirstRow: l,
    specialLastRow: d
  } = e, f = Ce(null), p = Ce([]), h = Ce(null), [g, m] = Q(), { sortedItems: b, sortHandler: v } = ND(r), { columnsToShow: C } = qO({
    columns: n,
    columnCountByTableWidth: i,
    tableContainerRef: f
  }), w = OO({
    tableContainerRef: f,
    rowRefs: p,
    headerRef: h,
    selectedRowNumber: g
  });
  function y() {
    c(void 0), u("create");
  }
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      DO,
      {
        onClickSort: v,
        ref: f,
        headerRef: h,
        tableData: b,
        columns: C,
        maxHeight: w,
        hasSelectedItem: !!o,
        renderRow: (x, E, P) => {
          const L = (o == null ? void 0 : o.id) === x.id;
          return /* @__PURE__ */ A(
            Il,
            {
              ref: (W) => p.current[P] = W,
              children: E.map((W) => {
                var V;
                return /* @__PURE__ */ R(mr, { children: [
                  W.key === "itemNumber" && /* @__PURE__ */ A(MO, { itemNumber: x.itemNumber }),
                  W.key !== "itemNumber" && W.key !== "moreDetails" && /* @__PURE__ */ A(
                    xt,
                    {
                      className: W.isNumberColumn ? "text-right" : "",
                      children: ((V = x.customTransform) == null ? void 0 : V.call(
                        x,
                        x[W.key],
                        W.key
                      )) ?? Wt(
                        x[W.key],
                        W.decimalScale
                      )
                    },
                    W.key
                  ),
                  W.key === "moreDetails" && /* @__PURE__ */ A(
                    FO,
                    {
                      isSelected: L,
                      onClick: () => {
                        if (L) {
                          u(null), c(void 0), m(void 0);
                          return;
                        }
                        u("view"), c(x), m(P);
                      }
                    }
                  )
                ] }, W.key);
              })
            },
            x.id
          );
        },
        specialFirstRow: l,
        specialLastRow: d
      }
    ),
    s && !a && /* @__PURE__ */ A(Ee, { children: /* @__PURE__ */ R(
      "button",
      {
        onClick: y,
        className: "mt-4 flex h-11 w-full items-center justify-center gap-x-2 rounded-lg border border-gray-300 bg-white text-sm font-semibold text-gray-900",
        children: [
          /* @__PURE__ */ R("span", { children: [
            "Create ",
            t
          ] }),
          /* @__PURE__ */ A(J, { name: "Plus", size: 14 })
        ]
      }
    ) })
  ] });
}
const DO = Hh(function(t, n) {
  const {
    children: r,
    tableData: o,
    columns: i,
    footer: s,
    renderRow: a,
    onClickSort: c,
    specialFirstRow: u,
    specialLastRow: l,
    maxHeight: d,
    headerRef: f,
    hasSelectedItem: p,
    ...h
  } = t, [g, m] = Q(
    null
  ), [b, v] = Q(null);
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      "div",
      {
        ...h,
        className: $(
          "relative rounded-lg border border-gray-300 bg-white",
          p ? "overflow-hidden" : "overflow-scroll",
          h.className
        ),
        ref: n,
        style: { maxHeight: d },
        children: /* @__PURE__ */ R("table", { className: "w-full", children: [
          /* @__PURE__ */ A(
            "thead",
            {
              ref: f,
              className: "sticky top-0 isolate select-none text-nowrap border-b border-gray-300 bg-gray-100",
              children: /* @__PURE__ */ A("tr", { children: i.map((C) => /* @__PURE__ */ A(
                "th",
                {
                  className: $(
                    "group border-l border-gray-300 py-3 pl-3 text-start text-xs font-medium text-gray-600 first:border-l-0",
                    C.allowSorting && "cursor-pointer hover:text-gray-900"
                  ),
                  onClick: () => {
                    if (!C.allowSorting) return;
                    let w = "asc";
                    b === C.key && g === "asc" && (w = "desc"), m(w), v(C.key), c(C.key, w);
                  },
                  children: /* @__PURE__ */ R(
                    "div",
                    {
                      className: $(
                        "group flex items-center",
                        C.isNumberColumn && "justify-end"
                      ),
                      children: [
                        C.label,
                        C.allowSorting && /* @__PURE__ */ A(
                          J,
                          {
                            name: "ArrowFilledRight",
                            size: 6,
                            className: $(
                              "invisible ml-1 rotate-90",
                              b === C.key && "group-hover:visible",
                              g === "asc" && "rotate-[270deg]"
                            )
                          }
                        )
                      ]
                    }
                  )
                },
                C.key
              )) })
            }
          ),
          /* @__PURE__ */ R("tbody", { children: [
            r,
            u == null ? void 0 : u(i),
            o == null ? void 0 : o.map(
              (C, w) => a(C, i, w)
            ),
            l == null ? void 0 : l(i)
          ] })
        ] })
      }
    ),
    s
  ] });
}), xt = (e) => /* @__PURE__ */ A(
  "td",
  {
    ...e,
    className: $(
      "truncate border-l border-gray-300 px-3 py-2 text-xs font-medium text-gray-900 first:border-l-0",
      e.className
    )
  }
);
function MO(e) {
  return /* @__PURE__ */ A(xt, { className: "w-4", children: e.itemNumber });
}
function FO(e) {
  const { isSelected: t, onClick: n } = e;
  return /* @__PURE__ */ A(xt, { className: "w-4", children: /* @__PURE__ */ A(
    "button",
    {
      className: "flex size-full items-center justify-center",
      onClick: n,
      children: /* @__PURE__ */ A(
        J,
        {
          name: "CaretDown",
          size: 16,
          className: $(
            "text-gray-600",
            t && "rotate-180"
          )
        }
      )
    }
  ) });
}
const VO = "ACCOUNTS", BO = "FIXED_INCOME_TYPES", kO = "SERVICE_PROVIDER_FEE_TYPES", LO = "SPVS", pF = [
  VO,
  BO,
  kO,
  LO
], u3 = "PORTFOLIO", HO = "TRANSACTIONS", XO = "OTHER", mF = [u3, HO, XO], oA = "AssetPurchase", iA = "AssetSale", l3 = "PrincipalDraw", d3 = "PrincipalReturn", A3 = "InterestIncome", f3 = "InterestPayment", sA = "FeesIncome", h3 = "FeesPayment", WO = [
  l3,
  d3
], aA = [oA, iA], cA = [sA, h3], ZO = [
  A3,
  f3
], El = [
  ...WO,
  ...aA,
  ...cA,
  ...ZO
], uA = {
  AssetPurchase: "Asset purchase",
  AssetSale: "Asset sale",
  PrincipalDraw: "Principal draw",
  PrincipalReturn: "Principal return",
  InterestIncome: "Interest income",
  InterestPayment: "Interest payment",
  FeesIncome: "Fees income",
  FeesPayment: "Fees payment"
}, zO = {
  1520: 10,
  1394: 9,
  1239: 8,
  1112: 7,
  984: 6
}, p3 = {
  [iA]: 1,
  [l3]: 1,
  [oA]: -1,
  [d3]: -1,
  [sA]: 1,
  [h3]: -1,
  [A3]: 1,
  [f3]: -1
}, GO = {
  [iA]: -1,
  [oA]: 1
};
function jO(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s
  } = e, a = sc(t), { submit: c, reset: u, inputs: l } = m3({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s
  }), d = () => /* @__PURE__ */ A(Lo, { inputs: l }), h = {
    dependentItemName: "assets",
    dependentItemList: a.filter(
      (m) => m.fixedIncomeTypeId === (n == null ? void 0 : n.id)
    ).map((m) => /* @__PURE__ */ A("div", { children: m.name }, m.id))
  };
  return /* @__PURE__ */ A(Xo, { ...e, ...{
    formInputs: d,
    dependentItemProps: h,
    submit: c,
    reset: u
  } });
}
const UO = Tr(jO), QO = [{ key: "name", label: "Name", allowSorting: !0 }];
function gF(e) {
  const { state: t } = e, { fixedIncomeTypes: n } = t, r = "Fixed Income Type", o = ve(
    () => Vr(n),
    [n]
  ), [i, s] = Q(), { operation: a, setOperation: c, showForm: u, existingState: l } = Zo({ state: t });
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      Wo,
      {
        ...e,
        itemName: r,
        tableData: o,
        columns: QO,
        selectedTableItem: i,
        operation: a,
        setSelectedTableItem: s,
        setOperation: c
      }
    ),
    u && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      UO,
      {
        ...e,
        itemName: r,
        state: l,
        tableItem: i,
        operation: a,
        setSelectedTableItem: s,
        setOperation: c
      }
    ) })
  ] });
}
function m3(e) {
  var g, m;
  const { item: t, onSubmitCreate: n, onSubmitEdit: r, onSubmitDelete: o, operation: i } = e, s = {
    name: null
  }, a = t ? {
    id: t.id,
    name: t.name
  } : s, { submit: c, reset: u, register: l, control: d, formState: f } = Ho({
    operation: i,
    createDefaultValues: s,
    editDefaultValues: a,
    onSubmitCreate: n,
    onSubmitEdit: r,
    onSubmitDelete: o
  }), { errors: p } = f, h = ve(
    () => [
      {
        label: "Fixed Income Type Name",
        Input: () => {
          var b, v;
          return /* @__PURE__ */ A(
            Gt,
            {
              ...l("name", {
                disabled: i === "view",
                required: "Fixed Income Type name is required"
              }),
              "aria-invalid": ((b = p.name) == null ? void 0 : b.type) === "required" ? "true" : "false",
              errorMessage: (v = p.name) == null ? void 0 : v.message,
              placeholder: "E.g. My Fixed Income Type name"
            }
          );
        }
      }
    ],
    [(g = p.name) == null ? void 0 : g.message, (m = p.name) == null ? void 0 : m.type, i, l]
  );
  return ve(() => ({
    submit: c,
    reset: u,
    register: l,
    control: d,
    inputs: h,
    formState: { errors: p }
  }), [c, u, l, d, h, p]);
}
function qO(e) {
  const {
    columnCountByTableWidth: t,
    tableContainerRef: n,
    columns: r,
    hasItemNumberColumn: o = !0,
    hasMoreDetailsColumn: i = !0
  } = e, [s, a] = Q(0), c = ve(
    () => o ? {
      key: "itemNumber",
      label: "#",
      allowSorting: !0,
      isSpecialColumn: !0
    } : void 0,
    [o]
  ), u = ve(
    () => i ? {
      key: "moreDetails",
      label: "",
      isSpecialColumn: !0
    } : void 0,
    [i]
  ), [l, d] = Q([]), f = ye(() => {
    var h;
    (h = n.current) != null && h.parentElement && a(n.current.parentElement.offsetWidth);
  }, [n]), p = ye(() => {
    const h = YO(
      s,
      t
    ), g = (r == null ? void 0 : r.slice(0, h)) ?? [];
    d(
      [c, ...g, u].filter(
        Boolean
      )
    );
  }, [
    s,
    r,
    t,
    c,
    u
  ]);
  return Ie(() => (f(), window.addEventListener("resize", f), () => window.removeEventListener("resize", f)), [f]), Ie(() => {
    p();
  }, [p, s]), ve(() => ({ columnsToShow: l }), [l]);
}
function YO(e, t) {
  let n = 1520, r = 1 / 0;
  return Object.keys(t).forEach((i) => {
    const s = parseInt(i), a = Math.abs(e - s);
    a < r && (r = a, n = parseInt(i));
  }), t[n];
}
function Zo({ state: e }) {
  const [t, n] = Q(null), [r, o] = Q(() => e), i = t !== null;
  return Ie(() => {
    o(e);
  }, [t]), ve(
    () => ({
      operation: t,
      setOperation: n,
      showForm: i,
      existingState: r
    }),
    [t, n, i, r]
  );
}
/**
 * natural-orderby v3.0.2
 *
 * Copyright (c) Olaf Ennen
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var g3 = function(t, n) {
  return t < n ? -1 : t > n ? 1 : 0;
}, JO = function(t, n) {
  var r = t.localeCompare(n);
  return r ? r / Math.abs(r) : 0;
}, KO = /(^0x[\da-fA-F]+$|^([+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?(?!\.\d+)(?=\D|\s|$))|\d+)/g, b3 = /^\s+|\s+$/g, _O = /\s+/g, $O = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/, eD = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[/-]\d{1,4}[/-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, tD = /^0+[1-9]{1}[0-9]*$/, nD = /[^\x00-\x80]/, Pf = function(t, n) {
  return t < n ? -1 : t > n ? 1 : 0;
}, rD = function(t, n) {
  for (var r = t.length, o = n.length, i = Math.min(r, o), s = 0; s < i; s++) {
    var a = t[s], c = n[s];
    if (a.normalizedString !== c.normalizedString) {
      if (a.normalizedString === "" != (c.normalizedString === ""))
        return a.normalizedString === "" ? -1 : 1;
      if (a.parsedNumber !== void 0 && c.parsedNumber !== void 0) {
        var u = g3(a.parsedNumber, c.parsedNumber);
        return u === 0 ? Pf(a.normalizedString, c.normalizedString) : u;
      } else return a.parsedNumber !== void 0 || c.parsedNumber !== void 0 ? a.parsedNumber !== void 0 ? -1 : 1 : nD.test(a.normalizedString + c.normalizedString) ? JO(a.normalizedString, c.normalizedString) : Pf(a.normalizedString, c.normalizedString);
    }
  }
  return r > i || o > i ? r <= i ? -1 : 1 : 0;
}, oD = function(t, n) {
  return (t.chunks ? !n.chunks : n.chunks) ? t.chunks ? -1 : 1 : (t.isNaN ? !n.isNaN : n.isNaN) ? t.isNaN ? -1 : 1 : (t.isSymbol ? !n.isSymbol : n.isSymbol) ? t.isSymbol ? -1 : 1 : (t.isObject ? !n.isObject : n.isObject) ? t.isObject ? -1 : 1 : (t.isArray ? !n.isArray : n.isArray) ? t.isArray ? -1 : 1 : (t.isFunction ? !n.isFunction : n.isFunction) ? t.isFunction ? -1 : 1 : (t.isNull ? !n.isNull : n.isNull) ? t.isNull ? -1 : 1 : 0;
}, iD = function(t, n) {
  return t.value === n.value ? 0 : t.parsedNumber !== void 0 && n.parsedNumber !== void 0 ? g3(t.parsedNumber, n.parsedNumber) : t.chunks && n.chunks ? rD(t.chunks, n.chunks) : oD(t, n);
}, sD = function(t) {
  return t.replace(_O, " ").replace(b3, "");
}, v3 = function(t) {
  if (t.length !== 0) {
    var n = Number(t);
    if (!Number.isNaN(n))
      return n;
  }
}, aD = function(t, n, r) {
  if ($O.test(t) && (!tD.test(t) || n === 0 || r[n - 1] !== "."))
    return v3(t) || 0;
}, cD = function(t, n, r) {
  return {
    parsedNumber: aD(t, n, r),
    normalizedString: sD(t)
  };
}, uD = function(t) {
  return t.replace(KO, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0");
}, lD = function(t) {
  var n = uD(t).map(cD);
  return n;
}, dD = function(t) {
  return typeof t == "function";
}, Rf = function(t) {
  return Number.isNaN(t) || t instanceof Number && Number.isNaN(t.valueOf());
}, AD = function(t) {
  return t === null;
}, fD = function(t) {
  return t !== null && typeof t == "object" && !Array.isArray(t) && !(t instanceof Number) && !(t instanceof String) && !(t instanceof Boolean) && !(t instanceof Date);
}, hD = function(t) {
  return typeof t == "symbol";
}, pD = function(t) {
  return t === void 0;
}, mD = function(t) {
  try {
    var n = Date.parse(t);
    return !Number.isNaN(n) && eD.test(t) ? n : void 0;
  } catch {
    return;
  }
}, gD = function(t) {
  var n = v3(t);
  return n !== void 0 ? n : mD(t);
}, bD = function(t) {
  return typeof t == "boolean" || t instanceof Boolean ? Number(t).toString() : typeof t == "number" || t instanceof Number ? t.toString() : t instanceof Date ? t.getTime().toString() : typeof t == "string" || t instanceof String ? t.toLowerCase().replace(b3, "") : "";
}, vD = function(t) {
  if (typeof t == "string" || t instanceof String || (typeof t == "number" || t instanceof Number) && !Rf(t) || typeof t == "boolean" || t instanceof Boolean || t instanceof Date) {
    var n = bD(t), r = gD(n), o = lD(r ? "" + r : n);
    return {
      parsedNumber: r,
      chunks: o,
      value: t
    };
  }
  return {
    isArray: Array.isArray(t),
    isFunction: dD(t),
    isNaN: Rf(t),
    isNull: AD(t),
    isObject: fD(t),
    isSymbol: hD(t),
    isUndefined: pD(t),
    value: t
  };
}, yD = function(t, n, r) {
  for (var o = t.index, i = t.values, s = n.index, a = n.values, c = i.length, u = r.length, l = 0; l < c; l++) {
    var d = l < u ? r[l] : null;
    if (d && typeof d == "function") {
      var f = d(i[l].value, a[l].value);
      if (f)
        return f;
    } else {
      var p = iD(i[l], a[l]);
      if (p)
        return p * (d === "desc" ? -1 : 1);
    }
  }
  return o - s;
}, CD = function(t) {
  return typeof t == "function" ? t : function(n) {
    if (Array.isArray(n)) {
      var r = Number(t);
      if (Number.isInteger(r))
        return n[r];
    } else if (n && typeof n == "object") {
      var o = Object.getOwnPropertyDescriptor(n, t);
      return o == null ? void 0 : o.value;
    }
    return n;
  };
}, xD = function(t, n) {
  return t[n];
}, wD = function(t, n) {
  return n(t);
}, ID = function(t, n, r) {
  var o = n.length ? n.map(CD) : [function(s) {
    return s;
  }], i = t.map(function(s, a) {
    var c = o.map(function(u) {
      return wD(s, u);
    }).map(vD);
    return {
      index: a,
      values: c
    };
  });
  return i.sort(function(s, a) {
    return yD(s, a, r);
  }), i.map(function(s) {
    return xD(t, s.index);
  });
}, ED = function(t) {
  if (!t)
    return [];
  var n = Array.isArray(t) ? [].concat(t) : [t];
  return n.some(function(r) {
    return typeof r != "string" && typeof r != "number" && typeof r != "function";
  }) ? [] : n;
}, SD = function(t) {
  if (!t)
    return [];
  var n = Array.isArray(t) ? [].concat(t) : [t];
  return n.some(function(r) {
    return r !== "asc" && r !== "desc" && typeof r != "function";
  }) ? [] : n;
};
function TD(e, t, n) {
  if (!e || !Array.isArray(e))
    return [];
  var r = ED(t), o = SD(n);
  return ID(e, r, o);
}
function ND(e) {
  const [t, n] = Q(e), [r, o] = Q(), [i, s] = Q("asc"), a = ye(
    (c, u) => {
      o(c), s(u);
    },
    []
  );
  return Ie(() => {
    if (e) {
      if (!r) {
        n(e);
        return;
      }
      n(TD(e, [r], [i]));
    }
  }, [r, i, e, a]), ve(
    () => ({ sortedItems: t, sortHandler: a }),
    [t, a]
  );
}
function PD(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s,
    onSubmitCreateAccount: a
  } = e, { transactions: c } = t, {
    inputs: u,
    submit: l,
    reset: d,
    showCreateAccountModal: f,
    setShowCreateAccountModal: p
  } = y3({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s
  }), h = () => /* @__PURE__ */ A(Lo, { inputs: u }), g = i3({
    state: t,
    operation: "create",
    onSubmitCreate: (v) => {
      a(v), p(!1);
    }
  }), b = {
    dependentItemName: "transactions",
    dependentItemList: c.filter(
      (v) => {
        var C;
        return (C = v.fees) == null ? void 0 : C.some((w) => w.serviceProviderFeeTypeId === (n == null ? void 0 : n.id));
      }
    ).map((v, C) => /* @__PURE__ */ R("div", { children: [
      "Transaction #",
      C + 1
    ] }, v.id))
  };
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      Xo,
      {
        ...e,
        formInputs: h,
        dependentItemProps: b,
        submit: l,
        reset: d,
        onSubmitCreate: o,
        onSubmitEdit: i,
        onSubmitDelete: s
      }
    ),
    f && /* @__PURE__ */ A(
      ji,
      {
        ...e,
        ...g,
        open: f,
        onOpenChange: p,
        itemName: "Account"
      }
    )
  ] });
}
const RD = Tr(
  PD
), OD = [
  { key: "name", label: "Name", allowSorting: !0 },
  { key: "feeType", label: "Fee Type", allowSorting: !0 },
  { key: "accountName", label: "Account Name", allowSorting: !0 },
  {
    key: "accountReference",
    label: "Account Reference",
    allowSorting: !0
  }
];
function DD(e, t) {
  if (!(e != null && e.length) || !(t != null && t.length)) return [];
  const n = e.map((r) => {
    const o = t.find(
      (i) => i.id === r.accountId
    );
    return {
      ...r,
      accountName: o == null ? void 0 : o.label,
      accountReference: o == null ? void 0 : o.reference
    };
  });
  return Vr(n);
}
function bF(e) {
  const { state: t } = e, { serviceProviderFeeTypes: n, accounts: r } = t, o = "Service Provider Fee Type", i = ve(
    () => DD(
      n,
      r
    ),
    [n, r]
  ), [s, a] = Q(), { operation: c, setOperation: u, showForm: l, existingState: d } = Zo({ state: t });
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      Wo,
      {
        ...e,
        itemName: o,
        tableData: i,
        columns: OD,
        selectedTableItem: s,
        operation: c,
        setSelectedTableItem: a,
        setOperation: u
      }
    ),
    l && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      RD,
      {
        ...e,
        itemName: o,
        state: d,
        tableItem: s,
        operation: c,
        setSelectedTableItem: a,
        setOperation: u
      }
    ) })
  ] });
}
function y3(e) {
  var y, I, x;
  const [t, n] = Q(!1), {
    item: r,
    state: o,
    onSubmitCreate: i,
    onSubmitEdit: s,
    onSubmitDelete: a,
    operation: c
  } = e, { accounts: u } = o, l = {
    name: null,
    feeType: null,
    accountId: ((y = u[0]) == null ? void 0 : y.id) ?? null
  }, d = r ? {
    id: r.id,
    name: r.name,
    feeType: r.feeType,
    accountId: r.accountId
  } : l, { submit: f, reset: p, register: h, control: g, formState: m } = Ho({
    operation: c,
    createDefaultValues: l,
    editDefaultValues: d,
    onSubmitCreate: i,
    onSubmitEdit: s,
    onSubmitDelete: a
  }), { errors: b } = m;
  function v(E) {
    return `${E.label} (${E.reference})`;
  }
  const C = ye((E) => E.map((P) => ({
    ...P,
    value: P.id,
    label: v(P)
  })), []), w = ve(
    () => [
      {
        label: "Service Provider Name",
        Input: () => {
          var E, P;
          return /* @__PURE__ */ A(
            Gt,
            {
              ...h("name", {
                disabled: c === "view",
                required: "Service provider name is required"
              }),
              "aria-invalid": ((E = b.name) == null ? void 0 : E.type) === "required" ? "true" : "false",
              errorMessage: (P = b.name) == null ? void 0 : P.message,
              placeholder: "E.g. My Service Provider"
            }
          );
        }
      },
      {
        label: "Fee Type",
        Input: () => {
          var E, P;
          return /* @__PURE__ */ A(
            Gt,
            {
              ...h("feeType", {
                disabled: c === "view",
                required: "Fee type is required"
              }),
              "aria-invalid": ((E = b.name) == null ? void 0 : E.type) === "required" ? "true" : "false",
              errorMessage: (P = b.name) == null ? void 0 : P.message,
              placeholder: "E.g. My Fee Type"
            }
          );
        }
      },
      {
        label: "Account",
        Input: () => {
          var E;
          return /* @__PURE__ */ A(
            pr,
            {
              control: g,
              name: "accountId",
              disabled: c === "view",
              options: C(u),
              addItemButtonProps: {
                onClick: () => n(!0),
                label: "Create Account"
              },
              rules: { required: "Account is required" },
              "aria-invalid": b.accountId ? "true" : "false",
              errorMessage: (E = b.accountId) == null ? void 0 : E.message
            }
          );
        }
      }
    ],
    [
      u,
      g,
      b.accountId,
      (I = b.name) == null ? void 0 : I.message,
      (x = b.name) == null ? void 0 : x.type,
      C,
      c,
      h
    ]
  );
  return ve(() => ({
    submit: f,
    reset: p,
    register: h,
    control: g,
    inputs: w,
    formState: { errors: b },
    showCreateAccountModal: t,
    setShowCreateAccountModal: n
  }), [
    f,
    p,
    h,
    g,
    w,
    b,
    t
  ]);
}
function MD(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s
  } = e, a = sc(t), { submit: c, reset: u, inputs: l } = C3({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s
  }), d = () => /* @__PURE__ */ A(Lo, { inputs: l }), p = {
    dependentItemName: "assets",
    dependentItemList: a.filter(
      (g) => g.spvId === (n == null ? void 0 : n.id)
    ).map((g) => /* @__PURE__ */ A("div", { children: g.name }, g.id))
  };
  return /* @__PURE__ */ A(Xo, { ...e, ...{
    formInputs: d,
    dependentItemProps: p,
    submit: c,
    reset: u
  } });
}
const FD = [{ key: "name", label: "Name", allowSorting: !0 }];
function vF(e) {
  const { state: t } = e, { spvs: n } = t, r = "SPV", o = ve(() => Vr(n), [n]), [i, s] = Q(), { operation: a, setOperation: c, showForm: u, existingState: l } = Zo({ state: t });
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      Wo,
      {
        ...e,
        itemName: r,
        tableData: o,
        columns: FD,
        selectedTableItem: i,
        operation: a,
        setSelectedTableItem: s,
        setOperation: c
      }
    ),
    u && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      MD,
      {
        ...e,
        itemName: r,
        state: l,
        tableItem: i,
        operation: a,
        setSelectedTableItem: s,
        setOperation: c
      }
    ) })
  ] });
}
function C3(e) {
  var g, m;
  const { item: t, onSubmitCreate: n, onSubmitEdit: r, onSubmitDelete: o, operation: i } = e, s = {
    name: null
  }, a = t ? {
    id: t.id,
    name: t.name
  } : s, { submit: c, reset: u, register: l, control: d, formState: f } = Ho({
    operation: i,
    createDefaultValues: s,
    editDefaultValues: a,
    onSubmitCreate: n,
    onSubmitEdit: r,
    onSubmitDelete: o
  }), { errors: p } = f, h = ve(
    () => [
      {
        label: "SPV name",
        Input: () => {
          var b, v;
          return /* @__PURE__ */ A(
            Gt,
            {
              ...l("name", {
                disabled: i === "view",
                required: "SPV name is required"
              }),
              "aria-invalid": ((b = p.name) == null ? void 0 : b.type) === "required" ? "true" : "false",
              errorMessage: (v = p.name) == null ? void 0 : v.message,
              placeholder: "E.g. My SPV name"
            }
          );
        }
      }
    ],
    [(g = p.name) == null ? void 0 : g.message, (m = p.name) == null ? void 0 : m.type, i, l]
  );
  return ve(() => ({
    submit: c,
    reset: u,
    register: l,
    control: d,
    inputs: h,
    formState: f
  }), [c, u, l, d, h, f]);
}
function VD(e) {
  const t = ["Fees", "Service Provider", "Amount", ""];
  return /* @__PURE__ */ R(Ee, { children: [
    e.feeInputs.length > 0 && /* @__PURE__ */ A("div", { className: "bg-gray-50 pl-5 pt-3", children: /* @__PURE__ */ R("table", { className: "w-full border-separate text-xs font-medium", children: [
      /* @__PURE__ */ A("thead", { className: "mb-2", children: /* @__PURE__ */ A("tr", { children: t.map((n) => /* @__PURE__ */ A(
        "th",
        {
          className: $(
            "py-2 text-left font-medium text-gray-600",
            n === "Amount" && !e.isViewOnly && "text-right"
          ),
          children: n
        },
        n
      )) }) }),
      /* @__PURE__ */ A("tbody", { children: e.feeInputs.map((n, r) => {
        var o, i, s, a;
        return /* @__PURE__ */ R("tr", { children: [
          /* @__PURE__ */ A("td", { className: "w-52" }),
          /* @__PURE__ */ A("td", { className: "w-96", children: /* @__PURE__ */ A(
            pr,
            {
              rules: {
                required: "Service provider is required"
              },
              control: e.control,
              name: `fees.${r}.serviceProviderFeeTypeId`,
              disabled: e.isViewOnly,
              options: e.serviceProviderFeeTypeOptions,
              addItemButtonProps: {
                onClick: () => e.setShowServiceProviderFeeTypeModal(
                  !0
                ),
                label: "Add Service Provider"
              },
              "aria-invalid": (i = (o = e.errors.fees) == null ? void 0 : o[r]) != null && i.serviceProviderFeeTypeId ? "true" : "false"
            }
          ) }),
          /* @__PURE__ */ A("td", { className: "w-52", children: /* @__PURE__ */ A(
            wl,
            {
              rules: {
                required: "Amount is required",
                validate: {
                  positive: (c) => !!c && Number(c) > 0 || "Fee amount must be greater than zero"
                }
              },
              name: `fees.${r}.amount`,
              control: e.control,
              disabled: e.isViewOnly,
              currency: "USD",
              "aria-invalid": (a = (s = e.errors.fees) == null ? void 0 : s[r]) != null && a.amount ? "true" : "false",
              placeholder: "E.g. $1,000.00"
            }
          ) }),
          /* @__PURE__ */ A("td", { className: "", children: !e.isViewOnly && /* @__PURE__ */ A(
            "button",
            {
              type: "button",
              onClick: () => e.remove(r),
              className: "flex items-center",
              children: /* @__PURE__ */ A(
                J,
                {
                  name: "Xmark",
                  className: "text-gray-900"
                }
              )
            }
          ) })
        ] }, n.id);
      }) })
    ] }) }),
    !e.isViewOnly && /* @__PURE__ */ R(
      "button",
      {
        onClick: () => {
          var n;
          return e.append({
            amount: null,
            serviceProviderFeeTypeId: (n = e.serviceProviderFeeTypes[0]) == null ? void 0 : n.id
          });
        },
        className: "ml-[234px] mt-1 flex w-fit items-center justify-center gap-x-2 rounded-lg bg-white pb-6 text-sm font-semibold text-gray-900",
        children: [
          /* @__PURE__ */ A("span", { children: "Add Fee" }),
          /* @__PURE__ */ A(J, { name: "Plus", size: 16 })
        ]
      }
    )
  ] });
}
function BD(e) {
  return kD(e) ? e.length === 66 : !1;
}
function kD(e) {
  return typeof e == "string" && e.startsWith("0x");
}
const LD = Pt(function(t, n) {
  const { control: r, disabled: o } = t, i = Gn({ control: r, name: "txRef" }), s = 46, c = typeof i == "string" && i.length >= s ? `${i.slice(0, s)}...` : i, u = BD(i), l = /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ A("p", { children: i }),
    u && /* @__PURE__ */ A("p", { className: "mt-2 text-center", children: /* @__PURE__ */ A(
      "a",
      {
        className: "text-blue-900 underline",
        href: `https://etherscan.io/tx/${i}`,
        children: "View on Etherscan"
      }
    ) })
  ] });
  return o ? /* @__PURE__ */ A(zg, { children: /* @__PURE__ */ A(Or, { content: l, children: /* @__PURE__ */ A("span", { children: c }) }) }) : /* @__PURE__ */ A(Gt, { ...t, ref: n });
});
function HD(e) {
  const { control: t } = e, n = Gn({ control: t, name: "cashAmount" }), r = Gn({ control: t, name: "fixedIncomeAmount" }), o = YD(n, r);
  return /* @__PURE__ */ R("div", { className: $("mt-1 w-fit", !e.isViewOnly && "ml-auto"), children: [
    /* @__PURE__ */ A("span", { className: "text-gray-600", children: "Unit Price" }),
    " ",
    /* @__PURE__ */ A("span", { className: "text-gray-900", children: /* @__PURE__ */ A(rA, { value: o, decimalScale: 6 }) })
  ] });
}
function XD(e) {
  var H, K, ee;
  const [t, n] = Q(!1), [
    r,
    o
  ] = Q(!1), {
    item: i,
    state: s,
    onSubmitCreate: a,
    onSubmitEdit: c,
    onSubmitDelete: u,
    operation: l
  } = e, { serviceProviderFeeTypes: d, accounts: f } = s, p = ve(() => sc(s), [s]), h = El.map((z) => ({
    label: uA[z],
    value: z
  })), g = p.map((z) => ({
    label: x3(z),
    value: z.id
  })), m = {
    type: El[0],
    entryTime: Sl(/* @__PURE__ */ new Date()),
    cashAmount: null,
    fixedIncomeId: ((H = p[0]) == null ? void 0 : H.id) ?? null,
    fixedIncomeAmount: null,
    serviceProviderFeeTypeId: null,
    fees: null,
    txRef: null
  }, b = i ? {
    id: i.id,
    type: i.type,
    entryTime: Sl(i.entryTime),
    cashAmount: i.cashTransaction.amount ?? null,
    fixedIncomeId: ((K = i.fixedIncomeTransaction) == null ? void 0 : K.assetId) ?? null,
    fixedIncomeAmount: ((ee = i.fixedIncomeTransaction) == null ? void 0 : ee.amount) ?? null,
    serviceProviderFeeTypeId: i.serviceProviderFeeTypeId ?? null,
    fees: i.fees ?? null,
    txRef: i.txRef ?? null
  } : m, { submit: v, reset: C, register: w, watch: y, control: I, formState: x } = Ho({
    operation: l,
    createDefaultValues: m,
    editDefaultValues: b,
    onSubmitCreate: a,
    onSubmitEdit: c,
    onSubmitDelete: u,
    customSubmitHandler: V
  }), E = Gn({ control: I, name: "type" }), P = !!E && aA.includes(E), L = !!E && cA.includes(E), W = !L;
  function V(z) {
    if (!l || l === "view") return;
    const ce = z.id, be = z.type, te = z.entryTime, ue = z.cashAmount, me = P ? z.fixedIncomeId : null, Te = z.serviceProviderFeeTypeId ?? null, Be = P ? z.fixedIncomeAmount : null, et = z.txRef ?? null, it = W ? z.fees : null, Ge = {
      create: a,
      edit: c,
      delete: u
    }[l];
    Ge == null || Ge({
      id: ce,
      type: be,
      entryTime: te,
      cashAmount: ue,
      fixedIncomeId: me,
      fixedIncomeAmount: Be,
      serviceProviderFeeTypeId: Te,
      fees: it,
      txRef: et
    });
  }
  const { errors: X } = x, { fields: N, append: M, remove: F } = QE({
    control: I,
    name: "fees"
  }), B = ve(
    () => d.map((z) => {
      var ce;
      return {
        label: `${z.name} — ${z.feeType} — ${(ce = f.find((be) => be.id === z.accountId)) == null ? void 0 : ce.reference}`,
        value: z.id
      };
    }),
    [d, f]
  ), Z = [
    {
      label: "Transaction Type",
      Input: () => {
        var z;
        return /* @__PURE__ */ A(
          pr,
          {
            control: I,
            name: "type",
            disabled: l === "view",
            options: h,
            rules: { required: "Transaction type is required" },
            "aria-invalid": X.type ? "true" : "false",
            errorMessage: (z = X.type) == null ? void 0 : z.message
          }
        );
      }
    },
    {
      label: "Entry Time",
      Input: () => /* @__PURE__ */ A(
        Ep,
        {
          ...w("entryTime", {
            required: !0,
            disabled: l === "view"
          }),
          name: "entryTime"
        }
      )
    },
    L ? {
      label: "Service Provider",
      Input: () => /* @__PURE__ */ A(
        pr,
        {
          control: I,
          name: "serviceProviderFeeTypeId",
          disabled: l === "view",
          options: B,
          addItemButtonProps: {
            onClick: () => o(
              !0
            ),
            label: "Add Service Provider"
          }
        }
      )
    } : null,
    P ? {
      label: "Asset name",
      Input: () => {
        var z;
        return /* @__PURE__ */ A(
          pr,
          {
            control: I,
            name: "fixedIncomeId",
            disabled: l === "view",
            options: g,
            addItemButtonProps: {
              onClick: () => n(!0),
              label: "Create Asset"
            },
            rules: { required: "Asset name is required" },
            "aria-invalid": X.type ? "true" : "false",
            errorMessage: (z = X.type) == null ? void 0 : z.message
          }
        );
      }
    } : void 0,
    P ? {
      label: "Quantity",
      Input: () => {
        var z;
        return /* @__PURE__ */ A(
          wl,
          {
            name: "fixedIncomeAmount",
            rules: {
              required: "Quantity is required",
              validate: {
                positive: (ce) => !!ce && Number(ce) > 0 || "Asset proceeds must be greater than zero"
              }
            },
            disabled: l === "view",
            control: I,
            "aria-invalid": X.fixedIncomeAmount ? "true" : "false",
            errorMessage: (z = X.fixedIncomeAmount) == null ? void 0 : z.message,
            placeholder: "E.g. 1,000.00"
          }
        );
      }
    } : void 0,
    {
      label: P ? "Asset Proceeds" : "Cash Amount",
      Input: () => {
        var z;
        return /* @__PURE__ */ R(Ee, { children: [
          /* @__PURE__ */ A(
            wl,
            {
              name: "cashAmount",
              rules: {
                required: "Asset proceeds is required",
                validate: {
                  positive: (ce) => !!ce && Number(ce) > 0 || "Asset proceeds must be greater than zero"
                }
              },
              currency: "USD",
              disabled: l === "view",
              control: I,
              "aria-invalid": X.cashAmount ? "true" : "false",
              errorMessage: (z = X.cashAmount) == null ? void 0 : z.message,
              placeholder: "E.g. $1,000.00"
            }
          ),
          P && /* @__PURE__ */ A(
            HD,
            {
              control: I,
              isViewOnly: l === "view"
            }
          )
        ] });
      }
    },
    {
      label: "Transaction reference",
      Input: () => {
        var z;
        return /* @__PURE__ */ A(
          LD,
          {
            ...w("txRef", {
              disabled: l === "view"
            }),
            control: I,
            "aria-invalid": X.txRef ? "true" : "false",
            errorMessage: (z = X.txRef) == null ? void 0 : z.message,
            placeholder: "E.g. 0x123..."
          }
        );
      }
    }
  ].filter(Boolean);
  return ve(() => ({
    submit: v,
    reset: C,
    register: w,
    append: M,
    watch: y,
    fields: N,
    remove: F,
    control: I,
    inputs: Z,
    formState: x,
    serviceProviderFeeTypeOptions: B,
    showCreateAssetModal: t,
    setShowCreateAssetModal: n,
    showCreateServiceProviderFeeTypeModal: r,
    setShowCreateServiceProviderFeeTypeModal: o,
    canHaveTransactionFees: W
  }), [
    v,
    C,
    w,
    M,
    y,
    N,
    F,
    I,
    Z,
    x,
    B,
    t,
    r,
    W
  ]);
}
function WD(e) {
  const { control: t } = e, n = Gn({ control: t, name: "cashAmount" }), r = Gn({ control: t, name: "type" }), o = Gn({ control: t, name: "fees" }), i = JD(
    r,
    n,
    o
  );
  return /* @__PURE__ */ A(Ee, { children: /* @__PURE__ */ R("div", { className: "flex items-center justify-between border-t border-gray-300 bg-gray-100 p-3 font-semibold text-gray-800", children: [
    /* @__PURE__ */ A("div", { className: "mr-6 text-sm text-gray-600", children: "Cash Balance Change $USD" }),
    /* @__PURE__ */ A("div", { className: "h-px flex-1 border-b border-dashed border-gray-400" }),
    /* @__PURE__ */ A("div", { className: "pl-8 text-sm text-gray-900", children: /* @__PURE__ */ A(rA, { value: i }) })
  ] }) });
}
function ZD(e) {
  const {
    state: t,
    tableItem: n,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s,
    onSubmitCreateAsset: a,
    onSubmitCreateServiceProviderFeeType: c
  } = e, { serviceProviderFeeTypes: u } = t, {
    submit: l,
    reset: d,
    formState: f,
    inputs: p,
    register: h,
    control: g,
    watch: m,
    append: b,
    remove: v,
    fields: C,
    serviceProviderFeeTypeOptions: w,
    showCreateAssetModal: y,
    setShowCreateAssetModal: I,
    setShowCreateServiceProviderFeeTypeModal: x,
    showCreateServiceProviderFeeTypeModal: E,
    canHaveTransactionFees: P
  } = XD({
    item: n,
    state: t,
    operation: r,
    onSubmitCreate: o,
    onSubmitEdit: i,
    onSubmitDelete: s
  }), { errors: L } = f, W = s3({
    state: t,
    operation: "create",
    onSubmitCreate: (N) => {
      a(N), I(!1);
    }
  }), V = y3({
    state: t,
    operation: "create",
    onSubmitCreate: (N) => {
      c(N), x(!1);
    }
  });
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ A(
      Xo,
      {
        ...e,
        formInputs: () => /* @__PURE__ */ R(Ee, { children: [
          /* @__PURE__ */ A(Lo, { inputs: p }),
          P && /* @__PURE__ */ A(
            VD,
            {
              register: h,
              feeInputs: C,
              serviceProviderFeeTypes: u,
              serviceProviderFeeTypeOptions: w,
              setShowServiceProviderFeeTypeModal: x,
              control: g,
              watch: m,
              remove: v,
              append: b,
              errors: L,
              isViewOnly: r === "view"
            }
          ),
          /* @__PURE__ */ A(WD, { control: g })
        ] }),
        submit: l,
        reset: d
      }
    ),
    y && /* @__PURE__ */ A(
      ji,
      {
        ...e,
        ...W,
        open: y,
        onOpenChange: I,
        itemName: "Asset"
      }
    ),
    E && /* @__PURE__ */ A(
      ji,
      {
        ...e,
        ...V,
        open: E,
        onOpenChange: x,
        itemName: "Service Provider Fee Type"
      }
    )
  ] });
}
const zD = Tr(ZD), GD = [
  {
    key: "typeLabel",
    label: "Type",
    allowSorting: !0
  },
  {
    key: "entryTime",
    label: "Entry Time",
    allowSorting: !0
  },
  {
    key: "asset",
    label: "Asset",
    allowSorting: !0
  },
  {
    key: "quantity",
    label: "Quantity",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "cashAmount",
    label: "Cash Amount ($)",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "totalFees",
    label: "Total Fees ($)",
    allowSorting: !0,
    isNumberColumn: !0
  },
  {
    key: "cashBalanceChange",
    label: "Cash Balance Change ($)",
    allowSorting: !0,
    isNumberColumn: !0
  }
];
function iu(e, t) {
  return e && e * t;
}
function jD(e, t) {
  if (!(e != null && e.length)) return [];
  const n = e.map((r) => {
    var g, m, b, v, C;
    const o = r.id, i = r.entryTime, s = (g = t == null ? void 0 : t.find(
      (w) => {
        var y;
        return w.id === ((y = r.fixedIncomeTransaction) == null ? void 0 : y.assetId);
      }
    )) == null ? void 0 : g.name, a = r.type, c = uA[a], u = p3[a], l = oM(a) ? GO[a] : 1, d = iu(
      (m = r.fixedIncomeTransaction) == null ? void 0 : m.amount,
      l
    ), f = iu(
      (b = r.cashTransaction) == null ? void 0 : b.amount,
      u
    ), p = cA.includes(r.type) ? iu(
      (v = r.cashTransaction) == null ? void 0 : v.amount,
      r.type === sA ? -1 : 1
    ) ?? 0 : ((C = r.fees) == null ? void 0 : C.reduce((w, y) => w + y.amount, 0)) ?? 0, h = r.cashBalanceChange;
    return {
      ...r,
      id: o,
      type: a,
      typeLabel: c,
      entryTime: i,
      asset: s,
      quantity: d,
      cashAmount: f,
      totalFees: p,
      cashBalanceChange: h
    };
  });
  return Vr(n);
}
function UD(e) {
  const t = "Group Transaction", { state: n } = e, [r, o] = Q(), { transactions: i, portfolio: s } = n, { operation: a, setOperation: c, showForm: u, existingState: l } = Zo({ state: n }), d = s.filter((x) => F3(x)), [f, p] = Q(i), [h, g] = Q(), [m, b] = Q([]);
  Ie(() => {
    if (!h && !m.length) {
      p(i);
      return;
    }
    p(
      i.filter((x) => {
        var E, P;
        if (h && m.length)
          return ((E = x.fixedIncomeTransaction) == null ? void 0 : E.assetId) === h && m.includes(x.type);
        if (h)
          return ((P = x.fixedIncomeTransaction) == null ? void 0 : P.assetId) === h;
        if (m.length)
          return m.includes(x.type);
      })
    );
  }, [h, m, i]);
  const v = ve(
    () => d.map((x) => ({
      label: x3(x),
      value: x.id
    })),
    [d]
  ), C = ve(
    () => El.map((x) => ({
      label: uA[x],
      value: x
    })),
    []
  ), w = ve(
    () => Vr(
      jD(
        f,
        d
      )
    ),
    [f, d]
  );
  function y(x) {
    if (!x || typeof x != "object" || !("value" in x)) {
      g(void 0);
      return;
    }
    const { value: E } = x;
    g(E);
  }
  function I(x) {
    if (!x || !Array.isArray(x)) {
      b([]);
      return;
    }
    b(x.map(({ value: P }) => P));
  }
  return /* @__PURE__ */ R(Ee, { children: [
    /* @__PURE__ */ R("div", { className: "mb-2 flex gap-2", children: [
      /* @__PURE__ */ A("div", { className: "min-w-72 max-w-96", children: /* @__PURE__ */ A(
        Pu,
        {
          options: v,
          onChange: y,
          isClearable: !0,
          placeholder: "Filter by Asset"
        }
      ) }),
      /* @__PURE__ */ A("div", { className: "min-w-72 max-w-96", children: /* @__PURE__ */ A(
        Pu,
        {
          options: C,
          onChange: I,
          isClearable: !0,
          isMulti: !0,
          placeholder: "Filter by Type"
        }
      ) })
    ] }),
    /* @__PURE__ */ A(
      Wo,
      {
        ...e,
        state: n,
        itemName: t,
        tableData: w,
        columns: GD,
        selectedTableItem: r,
        operation: a,
        setSelectedTableItem: o,
        setOperation: c
      }
    ),
    u && /* @__PURE__ */ A("div", { className: "mt-4 rounded-md bg-white", children: /* @__PURE__ */ A(
      zD,
      {
        ...e,
        itemName: t,
        state: l,
        tableItem: r,
        operation: a,
        setSelectedTableItem: o,
        setOperation: c
      }
    ) })
  ] });
}
function x3(e) {
  let t = e.name;
  return e.ISIN && (t += ` - ${e.ISIN}`), e.CUSIP && (t += ` - ${e.CUSIP}`), t;
}
function QD(e) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(e)) return !1;
  const t = new Date(e);
  return t instanceof Date && !isNaN(t.getTime()) && t.toISOString() === e;
}
function qD(e) {
  if (e instanceof Date || QD(e)) {
    const n = e instanceof Date ? e.toISOString() : e;
    return rM(n);
  }
  return e;
}
function Wt(e, t = 2) {
  return e == null ? "--" : typeof e == "number" ? /* @__PURE__ */ A(rA, { value: e, decimalScale: t }) : qD(e);
}
function yF(e, t) {
  return t == null ? void 0 : t.find((n) => n.id === e);
}
function Vr(e, t) {
  return e.map((n, r) => ({
    ...n,
    itemNumber: r + 1,
    customTransform: t
  }));
}
function YD(e, t) {
  return !e || !t ? 0 : e / t;
}
function JD(e, t, n) {
  if (!t || !e) return 0;
  const r = p3[e], i = ((n == null ? void 0 : n.map((s) => s.amount).filter(Boolean)) ?? []).reduce((s, a) => s + a, 0);
  return t * r - i;
}
function CF(e) {
  const { otherTableComponents: t } = e;
  return /* @__PURE__ */ A("div", { children: t.map(
    ({ Component: n, value: r, label: o, description: i }) => /* @__PURE__ */ R("div", { children: [
      /* @__PURE__ */ A("h2", { className: "mb-2 text-lg font-bold", children: o }),
      /* @__PURE__ */ A("p", { className: "mb-4 text-xs text-gray-600", children: i }),
      /* @__PURE__ */ A(n, {})
    ] }, r)
  ) });
}
function w3(e) {
  const { label: t, description: n, children: r } = e;
  return /* @__PURE__ */ R("div", { children: [
    /* @__PURE__ */ A("h1", { className: "mb-2 text-lg font-bold", children: t }),
    /* @__PURE__ */ A("p", { className: "mb-4 text-xs text-gray-600", children: n }),
    r
  ] });
}
function xF(e) {
  return /* @__PURE__ */ A(w3, { ...{
    label: "Portfolio",
    description: "Details on the distribution of assets among different financial institutions or investment vehicles."
  }, children: /* @__PURE__ */ A(PO, { ...e }) });
}
var lA = "Tabs", [KD, wF] = Jn(lA, [
  Fa
]), I3 = Fa(), [_D, dA] = KD(lA), E3 = S.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: i,
      orientation: s = "horizontal",
      dir: a,
      activationMode: c = "automatic",
      ...u
    } = e, l = Rl(a), [d, f] = Ji({
      prop: r,
      onChange: o,
      defaultProp: i
    });
    return /* @__PURE__ */ A(
      _D,
      {
        scope: n,
        baseId: Xn(),
        value: d,
        onValueChange: f,
        orientation: s,
        dir: l,
        activationMode: c,
        children: /* @__PURE__ */ A(
          Xe.div,
          {
            dir: l,
            "data-orientation": s,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
E3.displayName = lA;
var S3 = "TabsList", T3 = S.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = e, i = dA(S3, n), s = I3(n);
    return /* @__PURE__ */ A(
      R0,
      {
        asChild: !0,
        ...s,
        orientation: i.orientation,
        dir: i.dir,
        loop: r,
        children: /* @__PURE__ */ A(
          Xe.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
T3.displayName = S3;
var N3 = "TabsTrigger", P3 = S.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...i } = e, s = dA(N3, n), a = I3(n), c = D3(s.baseId, r), u = M3(s.baseId, r), l = r === s.value;
    return /* @__PURE__ */ A(
      O0,
      {
        asChild: !0,
        ...a,
        focusable: !o,
        active: l,
        children: /* @__PURE__ */ A(
          Xe.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": l,
            "aria-controls": u,
            "data-state": l ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: c,
            ...i,
            ref: t,
            onMouseDown: he(e.onMouseDown, (d) => {
              !o && d.button === 0 && d.ctrlKey === !1 ? s.onValueChange(r) : d.preventDefault();
            }),
            onKeyDown: he(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && s.onValueChange(r);
            }),
            onFocus: he(e.onFocus, () => {
              const d = s.activationMode !== "manual";
              !l && !o && d && s.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
P3.displayName = N3;
var R3 = "TabsContent", O3 = S.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: i, ...s } = e, a = dA(R3, n), c = D3(a.baseId, r), u = M3(a.baseId, r), l = r === a.value, d = S.useRef(l);
    return S.useEffect(() => {
      const f = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(f);
    }, []), /* @__PURE__ */ A(Yt, { present: o || l, children: ({ present: f }) => /* @__PURE__ */ A(
      Xe.div,
      {
        "data-state": l ? "active" : "inactive",
        "data-orientation": a.orientation,
        role: "tabpanel",
        "aria-labelledby": c,
        hidden: !f,
        id: u,
        tabIndex: 0,
        ...s,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: f && i
      }
    ) });
  }
);
O3.displayName = R3;
function D3(e, t) {
  return `${e}-trigger-${t}`;
}
function M3(e, t) {
  return `${e}-content-${t}`;
}
var $D = E3, eM = T3, tM = P3, nM = O3;
function IF(e) {
  const { tabComponents: t } = e;
  return /* @__PURE__ */ R($D, { defaultValue: u3, children: [
    /* @__PURE__ */ R("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ A(eM, { className: "flex gap-x-2 rounded-xl bg-slate-50 p-1 text-sm font-semibold text-gray-600 outline-none", children: t.map(({ value: n, label: r, disabled: o }) => /* @__PURE__ */ A(
        tM,
        {
          value: n,
          disabled: o,
          className: "data-[state='active']:tab-shadow data-disabled:cursor-not-allowed data-disabled:text-gray-400 h-7 w-32 rounded-lg  transition duration-300 data-[state='active']:bg-gray-50 data-[state='active']:text-gray-900",
          children: r
        },
        n
      )) }),
      /* @__PURE__ */ A(Q8, { ...e })
    ] }),
    /* @__PURE__ */ A("div", { className: "mt-3 rounded-md bg-slate-50 p-8", children: t.map(({ value: n, Component: r }) => /* @__PURE__ */ A(nM, { value: n, children: /* @__PURE__ */ A(r, {}) }, n)) })
  ] });
}
function EF(e) {
  return /* @__PURE__ */ A(w3, { ...{
    label: "Transactions",
    description: "Details on the distribution of assets among different financial institutions or investment vehicles."
  }, children: /* @__PURE__ */ A(UD, { ...e }) });
}
function Sl(e = /* @__PURE__ */ new Date()) {
  return Hi(e, "yyyy-MM-dd'T'HH:mm");
}
function rM(e) {
  return Hi(e, "yyyy/MM/dd, HH:mm:ss");
}
function oM(e) {
  return aA.includes(e);
}
function F3(e) {
  return e ? e.type === "FixedIncome" || "fixedIncomeId" in e : !1;
}
function iM(e) {
  return e ? e.type === "Cash" || "currency" in e : !1;
}
function sc(e) {
  return e.portfolio.filter((t) => F3(t));
}
function sM(e) {
  return e.portfolio.find((t) => iM(t));
}
var V3 = {}, B3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function t(r, o) {
    return {
      handler: r,
      config: o
    };
  }
  t.withOptions = function(r, o = () => ({})) {
    const i = function(s) {
      return {
        __options: s,
        handler: r(s),
        config: o(s)
      };
    };
    return i.__isOptionsFunction = !0, i.__pluginFunction = r, i.__configFunction = o, i;
  };
  const n = t;
})(B3);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  const t = /* @__PURE__ */ n(B3);
  function n(o) {
    return o && o.__esModule ? o : {
      default: o
    };
  }
  const r = t.default;
})(V3);
let su = V3;
var k3 = (su.__esModule ? su : { default: su }).default;
const aM = /* @__PURE__ */ Do(k3), cM = k3;
function Of(e) {
  return Object.fromEntries(
    Object.entries(e).filter(([t]) => t !== "DEFAULT")
  );
}
var uM = cM(
  ({ addUtilities: e, matchUtilities: t, theme: n }) => {
    e({
      "@keyframes enter": n("keyframes.enter"),
      "@keyframes exit": n("keyframes.exit"),
      ".animate-in": {
        animationName: "enter",
        animationDuration: n("animationDuration.DEFAULT"),
        "--tw-enter-opacity": "initial",
        "--tw-enter-scale": "initial",
        "--tw-enter-rotate": "initial",
        "--tw-enter-translate-x": "initial",
        "--tw-enter-translate-y": "initial"
      },
      ".animate-out": {
        animationName: "exit",
        animationDuration: n("animationDuration.DEFAULT"),
        "--tw-exit-opacity": "initial",
        "--tw-exit-scale": "initial",
        "--tw-exit-rotate": "initial",
        "--tw-exit-translate-x": "initial",
        "--tw-exit-translate-y": "initial"
      }
    }), t(
      {
        "fade-in": (r) => ({ "--tw-enter-opacity": r }),
        "fade-out": (r) => ({ "--tw-exit-opacity": r })
      },
      { values: n("animationOpacity") }
    ), t(
      {
        "zoom-in": (r) => ({ "--tw-enter-scale": r }),
        "zoom-out": (r) => ({ "--tw-exit-scale": r })
      },
      { values: n("animationScale") }
    ), t(
      {
        "spin-in": (r) => ({ "--tw-enter-rotate": r }),
        "spin-out": (r) => ({ "--tw-exit-rotate": r })
      },
      { values: n("animationRotate") }
    ), t(
      {
        "slide-in-from-top": (r) => ({
          "--tw-enter-translate-y": `-${r}`
        }),
        "slide-in-from-bottom": (r) => ({
          "--tw-enter-translate-y": r
        }),
        "slide-in-from-left": (r) => ({
          "--tw-enter-translate-x": `-${r}`
        }),
        "slide-in-from-right": (r) => ({
          "--tw-enter-translate-x": r
        }),
        "slide-out-to-top": (r) => ({
          "--tw-exit-translate-y": `-${r}`
        }),
        "slide-out-to-bottom": (r) => ({
          "--tw-exit-translate-y": r
        }),
        "slide-out-to-left": (r) => ({
          "--tw-exit-translate-x": `-${r}`
        }),
        "slide-out-to-right": (r) => ({
          "--tw-exit-translate-x": r
        })
      },
      { values: n("animationTranslate") }
    ), t(
      { duration: (r) => ({ animationDuration: r }) },
      { values: Of(n("animationDuration")) }
    ), t(
      { delay: (r) => ({ animationDelay: r }) },
      { values: n("animationDelay") }
    ), t(
      { ease: (r) => ({ animationTimingFunction: r }) },
      { values: Of(n("animationTimingFunction")) }
    ), e({
      ".running": { animationPlayState: "running" },
      ".paused": { animationPlayState: "paused" }
    }), t(
      { "fill-mode": (r) => ({ animationFillMode: r }) },
      { values: n("animationFillMode") }
    ), t(
      { direction: (r) => ({ animationDirection: r }) },
      { values: n("animationDirection") }
    ), t(
      { repeat: (r) => ({ animationIterationCount: r }) },
      { values: n("animationRepeat") }
    );
  },
  {
    theme: {
      extend: {
        animationDelay: ({ theme: e }) => ({
          ...e("transitionDelay")
        }),
        animationDuration: ({ theme: e }) => ({
          0: "0ms",
          ...e("transitionDuration")
        }),
        animationTimingFunction: ({ theme: e }) => ({
          ...e("transitionTimingFunction")
        }),
        animationFillMode: {
          none: "none",
          forwards: "forwards",
          backwards: "backwards",
          both: "both"
        },
        animationDirection: {
          normal: "normal",
          reverse: "reverse",
          alternate: "alternate",
          "alternate-reverse": "alternate-reverse"
        },
        animationOpacity: ({ theme: e }) => ({
          DEFAULT: 0,
          ...e("opacity")
        }),
        animationTranslate: ({ theme: e }) => ({
          DEFAULT: "100%",
          ...e("translate")
        }),
        animationScale: ({ theme: e }) => ({
          DEFAULT: 0,
          ...e("scale")
        }),
        animationRotate: ({ theme: e }) => ({
          DEFAULT: "30deg",
          ...e("rotate")
        }),
        animationRepeat: {
          0: "0",
          1: "1",
          infinite: "infinite"
        },
        keyframes: {
          enter: {
            from: {
              opacity: "var(--tw-enter-opacity, 1)",
              transform: "translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))"
            }
          },
          exit: {
            to: {
              opacity: "var(--tw-exit-opacity, 1)",
              transform: "translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))"
            }
          }
        }
      }
    }
  }
);
const lM = /* @__PURE__ */ Do(uM);
var L3 = {}, H3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n) {
    return Array.isArray(n) ? n.map((r) => t(r)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([r, o]) => [
      r,
      t(o)
    ])) : n;
  }
})(H3);
var dM = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: e }) => ({
      ...e("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: e }) => e("blur"),
    backdropBrightness: ({ theme: e }) => e("brightness"),
    backdropContrast: ({ theme: e }) => e("contrast"),
    backdropGrayscale: ({ theme: e }) => e("grayscale"),
    backdropHueRotate: ({ theme: e }) => e("hueRotate"),
    backdropInvert: ({ theme: e }) => e("invert"),
    backdropOpacity: ({ theme: e }) => e("opacity"),
    backdropSaturate: ({ theme: e }) => e("saturate"),
    backdropSepia: ({ theme: e }) => e("sepia"),
    backgroundColor: ({ theme: e }) => e("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: e }) => e("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: e }) => ({
      ...e("colors"),
      DEFAULT: e("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: e }) => e("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: e }) => ({
      ...e("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: e }) => e("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: e }) => e("colors"),
    colors: ({ colors: e }) => ({
      inherit: e.inherit,
      current: e.current,
      transparent: e.transparent,
      black: e.black,
      white: e.white,
      slate: e.slate,
      gray: e.gray,
      zinc: e.zinc,
      neutral: e.neutral,
      stone: e.stone,
      red: e.red,
      orange: e.orange,
      amber: e.amber,
      yellow: e.yellow,
      lime: e.lime,
      green: e.green,
      emerald: e.emerald,
      teal: e.teal,
      cyan: e.cyan,
      sky: e.sky,
      blue: e.blue,
      indigo: e.indigo,
      violet: e.violet,
      purple: e.purple,
      fuchsia: e.fuchsia,
      pink: e.pink,
      rose: e.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: e }) => e("borderColor"),
    divideOpacity: ({ theme: e }) => e("borderOpacity"),
    divideWidth: ({ theme: e }) => e("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: e }) => e("spacing"),
    gradientColorStops: ({ theme: e }) => e("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridTemplateColumns: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    height: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: e }) => ({
      ...e("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: e, breakpoints: t }) => ({
      ...e("spacing"),
      none: "none",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...t(e("screens"))
    }),
    minHeight: ({ theme: e }) => ({
      ...e("spacing"),
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    minWidth: ({ theme: e }) => ({
      ...e("spacing"),
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      15: "0.15",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      35: "0.35",
      40: "0.4",
      45: "0.45",
      50: "0.5",
      55: "0.55",
      60: "0.6",
      65: "0.65",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      85: "0.85",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: e }) => e("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: e }) => e("spacing"),
    placeholderColor: ({ theme: e }) => e("colors"),
    placeholderOpacity: ({ theme: e }) => e("opacity"),
    ringColor: ({ theme: e }) => ({
      DEFAULT: e("colors.blue.500", "#3b82f6"),
      ...e("colors")
    }),
    ringOffsetColor: ({ theme: e }) => e("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: e }) => ({
      DEFAULT: "0.5",
      ...e("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: e }) => ({
      ...e("spacing")
    }),
    scrollPadding: ({ theme: e }) => e("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: e }) => ({
      ...e("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: e }) => e("colors"),
    textDecorationColor: ({ theme: e }) => e("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: e }) => ({
      ...e("spacing")
    }),
    textOpacity: ({ theme: e }) => e("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: e }) => ({
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    size: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    width: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      svw: "100svw",
      lvw: "100lvw",
      dvw: "100dvw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = H3, n = /* @__PURE__ */ r(dM);
  function r(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  const o = (0, t.cloneDeep)(n.default.theme);
})(L3);
let au = L3;
var AM = (au.__esModule ? au : { default: au }).default;
const cu = /* @__PURE__ */ Do(AM), fM = {
  fontFamily: {
    sans: ["Inter", ...cu.fontFamily.sans]
  },
  fontSize: {
    ...cu.fontSize,
    xs: ["0.75rem", "1.125rem"],
    sm: ["0.875rem", "1.5rem"],
    base: ["1rem", "1.5rem"],
    lg: ["1.125rem", "1.75rem"],
    xl: ["1.25rem", "1.875rem"],
    "2xl": ["1.5rem", "2.25rem"],
    "3xl": ["2rem", "3rem"],
    "4xl": ["2.5rem", "4rem"],
    "5xl": ["4rem", "5rem"]
  },
  colors: {
    transparent: "transparent",
    inherit: "inherit",
    white: "hsl(var(--color-white) / <alpha-value>)",
    black: "hsl(var(--color-black) / <alpha-value>)",
    "gray-50": "hsl(var(--color-gray-50) / <alpha-value>)",
    "gray-100": "hsl(var(--color-gray-100) / <alpha-value>)",
    "gray-200": "hsl(var(--color-gray-200) / <alpha-value>)",
    "gray-300": "hsl(var(--color-gray-300) / <alpha-value>)",
    "gray-400": "hsl(var(--color-gray-400) / <alpha-value>)",
    "gray-500": "hsl(var(--color-gray-500) / <alpha-value>)",
    "gray-600": "hsl(var(--color-gray-600) / <alpha-value>)",
    "gray-700": "hsl(var(--color-gray-700) / <alpha-value>)",
    "gray-800": "hsl(var(--color-gray-800) / <alpha-value>)",
    "gray-900": "hsl(var(--color-gray-900) / <alpha-value>)",
    "slate-50": "hsl(var(--color-slate-50) / <alpha-value>)",
    "slate-100": "hsl(var(--color-slate-100) / <alpha-value>)",
    "slate-200": "hsl(var(--color-slate-200) / <alpha-value>)",
    "slate-300": "hsl(var(--color-slate-300) / <alpha-value>)",
    "slate-400": "hsl(var(--color-slate-400) / <alpha-value>)",
    "slate-500": "hsl(var(--color-slate-500) / <alpha-value>)",
    "slate-600": "hsl(var(--color-slate-600) / <alpha-value>)",
    "slate-700": "hsl(var(--color-slate-700) / <alpha-value>)",
    "slate-800": "hsl(var(--color-slate-800) / <alpha-value>)",
    "slate-900": "hsl(var(--color-slate-900) / <alpha-value>)",
    "slate-950": "hsl(var(--color-slate-950) / <alpha-value>)",
    "blue-100": "hsl(var(--color-blue-100) / <alpha-value>)",
    "blue-200": "hsl(var(--color-blue-200) / <alpha-value>)",
    "blue-300": "hsl(var(--color-blue-300) / <alpha-value>)",
    "blue-400": "hsl(var(--color-blue-400) / <alpha-value>)",
    "blue-500": "hsl(var(--color-blue-500) / <alpha-value>)",
    "blue-600": "hsl(var(--color-blue-600) / <alpha-value>)",
    "blue-700": "hsl(var(--color-blue-700) / <alpha-value>)",
    "blue-800": "hsl(var(--color-blue-800) / <alpha-value>)",
    "blue-900": "hsl(var(--color-blue-900) / <alpha-value>)",
    "green-100": "hsl(var(--color-green-100) / <alpha-value>)",
    "green-200": "hsl(var(--color-green-200) / <alpha-value>)",
    "green-300": "hsl(var(--color-green-300) / <alpha-value>)",
    "green-400": "hsl(var(--color-green-400) / <alpha-value>)",
    "green-500": "hsl(var(--color-green-500) / <alpha-value>)",
    "green-600": "hsl(var(--color-green-600) / <alpha-value>)",
    "green-700": "hsl(var(--color-green-700) / <alpha-value>)",
    "green-800": "hsl(var(--color-green-800) / <alpha-value>)",
    "green-900": "hsl(var(--color-green-900) / <alpha-value>)",
    "purple-100": "hsl(var(--color-purple-100) / <alpha-value>)",
    "purple-200": "hsl(var(--color-purple-200) / <alpha-value>)",
    "purple-300": "hsl(var(--color-purple-300) / <alpha-value>)",
    "purple-400": "hsl(var(--color-purple-400) / <alpha-value>)",
    "purple-500": "hsl(var(--color-purple-500) / <alpha-value>)",
    "purple-600": "hsl(var(--color-purple-600) / <alpha-value>)",
    "purple-700": "hsl(var(--color-purple-700) / <alpha-value>)",
    "purple-800": "hsl(var(--color-purple-800) / <alpha-value>)",
    "purple-900": "hsl(var(--color-purple-900) / <alpha-value>)",
    "red-100": "hsl(var(--color-red-100) / <alpha-value>)",
    "red-200": "hsl(var(--color-red-200) / <alpha-value>)",
    "red-300": "hsl(var(--color-red-300) / <alpha-value>)",
    "red-400": "hsl(var(--color-red-400) / <alpha-value>)",
    "red-500": "hsl(var(--color-red-500) / <alpha-value>)",
    "red-600": "hsl(var(--color-red-600) / <alpha-value>)",
    "red-700": "hsl(var(--color-red-700) / <alpha-value>)",
    "red-800": "hsl(var(--color-red-800) / <alpha-value>)",
    "red-900": "hsl(var(--color-red-900) / <alpha-value>)",
    "orange-100": "hsl(var(--color-orange-100) / <alpha-value>)",
    "orange-200": "hsl(var(--color-orange-200) / <alpha-value>)",
    "orange-300": "hsl(var(--color-orange-300) / <alpha-value>)",
    "orange-400": "hsl(var(--color-orange-400) / <alpha-value>)",
    "orange-500": "hsl(var(--color-orange-500) / <alpha-value>)",
    "orange-600": "hsl(var(--color-orange-600) / <alpha-value>)",
    "orange-700": "hsl(var(--color-orange-700) / <alpha-value>)",
    "orange-800": "hsl(var(--color-orange-800) / <alpha-value>)",
    "orange-900": "hsl(var(--color-orange-900) / <alpha-value>)"
  },
  boxShadow: {
    ...cu.boxShadow,
    sidebar: "var(--shadow-sidebar)",
    tooltip: "var(--shadow-tooltip)",
    button: "var(--shadow-button)",
    DEFAULT: "0px 4px 8px -4px rgba(0, 0, 0, 0.02), 0px -1px 1px 0px rgba(0, 0, 0, 0.04) inset"
  },
  extend: {
    gridTemplateColumns: {
      "form-columns": "max-content auto"
    },
    keyframes: {
      "fade-in": {
        "0%": { opacity: "0%" },
        "100%": { opacity: "100%" }
      },
      "fade-out": {
        "0%": { opacity: "100%" },
        "100%": { opacity: "0%" }
      },
      "zoom-in": {
        "0%": { transform: "scale(0.95)" },
        "100%": { transform: "scale(1)" }
      },
      "zoom-out": {
        "0%": { transform: "scale(1)" },
        "100%": { transform: "scale(0.95)" }
      }
    },
    animation: {
      "fade-in": "fade-in 300ms ease-in",
      "fade-out": "fade-out 200ms ease-out",
      "zoom-in": "zoom-in 300ms ease-in",
      "zoom-out": "zoom-out 200ms ease-out"
    }
  }
}, hM = [
  lM,
  aM(function({ addVariant: e }) {
    e("collapsed", ":merge(.group).collapsed &"), e("collapsing", ":merge(.group).collapsing &"), e("expanded", ":merge(.group).expanded &"), e("expanding", ":merge(.group).expanding &");
  })
], SF = {
  theme: fM,
  plugins: hM
};
export {
  B2 as $,
  q3 as A,
  ne as B,
  o2 as C,
  h2 as D,
  p2 as E,
  m2 as F,
  g2 as G,
  ai as H,
  bi as I,
  b2 as J,
  v2 as K,
  y2 as L,
  C2 as M,
  x2 as N,
  w2 as O,
  I2 as P,
  E2 as Q,
  S2 as R,
  T2 as S,
  N2 as T,
  P2 as U,
  R2 as V,
  O2 as W,
  D2 as X,
  M2 as Y,
  F2 as Z,
  V2 as _,
  Cr as a,
  QM as a$,
  k2 as a0,
  L2 as a1,
  H2 as a2,
  X2 as a3,
  W2 as a4,
  Z2 as a5,
  z2 as a6,
  G2 as a7,
  j2 as a8,
  U2 as a9,
  PT as aA,
  Qd as aB,
  RT as aC,
  OT as aD,
  mg as aE,
  Ca as aF,
  qd as aG,
  gg as aH,
  os as aI,
  FM as aJ,
  VM as aK,
  bg as aL,
  BM as aM,
  kM as aN,
  LM as aO,
  HM as aP,
  XM as aQ,
  DT as aR,
  WM as aS,
  ZM as aT,
  vg as aU,
  zM as aV,
  GM as aW,
  ki as aX,
  jM as aY,
  UM as aZ,
  wg as a_,
  Q2 as aa,
  q2 as ab,
  Y2 as ac,
  J2 as ad,
  K2 as ae,
  _2 as af,
  $2 as ag,
  e9 as ah,
  t9 as ai,
  n4 as aj,
  NM as ak,
  r4 as al,
  Pu as am,
  Ep as an,
  PM as ao,
  Co as ap,
  bt as aq,
  RM as ar,
  cd as as,
  Q8 as at,
  OM as au,
  Zm as av,
  DM as aw,
  MM as ax,
  tS as ay,
  NT as az,
  Fo as b,
  iF as b$,
  GP as b0,
  jP as b1,
  zP as b2,
  zm as b3,
  oR as b4,
  qM as b5,
  YM as b6,
  aR as b7,
  Or as b8,
  zg as b9,
  cs as bA,
  us as bB,
  eu as bC,
  tu as bD,
  nu as bE,
  VR as bF,
  BR as bG,
  eF as bH,
  kR as bI,
  LR as bJ,
  HR as bK,
  XR as bL,
  Kd as bM,
  yl as bN,
  Sr as bO,
  Cl as bP,
  xl as bQ,
  Ea as bR,
  tF as bS,
  qg as bT,
  nF as bU,
  rF as bV,
  oF as bW,
  _d as bX,
  $d as bY,
  Yg as bZ,
  Jg as b_,
  Gg as ba,
  jg as bb,
  rc as bc,
  Ug as bd,
  OR as be,
  Zi as bf,
  _t as bg,
  ko as bh,
  Dr as bi,
  KM as bj,
  _M as bk,
  xf as bl,
  St as bm,
  Xt as bn,
  Je as bo,
  Vs as bp,
  qr as bq,
  zt as br,
  Qg as bs,
  $M as bt,
  Mr as bu,
  ss as bv,
  _n as bw,
  Fr as bx,
  oc as by,
  as as bz,
  Bw as c,
  p3 as c$,
  sF as c0,
  aF as c1,
  cF as c2,
  uF as c3,
  jR as c4,
  eA as c5,
  UR as c6,
  QR as c7,
  qR as c8,
  lF as c9,
  AF as cA,
  wl as cB,
  pr as cC,
  bO as cD,
  Gt as cE,
  ji as cF,
  yO as cG,
  vO as cH,
  CO as cI,
  xO as cJ,
  fF as cK,
  i3 as cL,
  EO as cM,
  SO as cN,
  NO as cO,
  PO as cP,
  s3 as cQ,
  rA as cR,
  hF as cS,
  Xo as cT,
  Wo as cU,
  DO as cV,
  xt as cW,
  MO as cX,
  FO as cY,
  Il as cZ,
  zO as c_,
  dF as ca,
  tA as cb,
  xM as cc,
  jt as cd,
  vh as ce,
  yh as cf,
  Ch as cg,
  CM as ch,
  xh as ci,
  J as cj,
  wn as ck,
  J5 as cl,
  K5 as cm,
  _5 as cn,
  $5 as co,
  EM as cp,
  SM as cq,
  $l as cr,
  e4 as cs,
  TM as ct,
  t4 as cu,
  Hh as cv,
  Xh as cw,
  gn as cx,
  ru as cy,
  Lo as cz,
  xw as d,
  sc as d$,
  GO as d0,
  jO as d1,
  UO as d2,
  gF as d3,
  m3 as d4,
  qO as d5,
  YO as d6,
  Zo as d7,
  ND as d8,
  PD as d9,
  BO as dA,
  kO as dB,
  LO as dC,
  pF as dD,
  u3 as dE,
  HO as dF,
  XO as dG,
  mF as dH,
  oA as dI,
  iA as dJ,
  l3 as dK,
  d3 as dL,
  A3 as dM,
  f3 as dN,
  sA as dO,
  h3 as dP,
  WO as dQ,
  aA as dR,
  cA as dS,
  ZO as dT,
  El as dU,
  uA as dV,
  Sl as dW,
  rM as dX,
  oM as dY,
  F3 as dZ,
  iM as d_,
  RD as da,
  DD as db,
  bF as dc,
  y3 as dd,
  MD as de,
  vF as df,
  C3 as dg,
  VD as dh,
  ZD as di,
  zD as dj,
  jD as dk,
  UD as dl,
  x3 as dm,
  QD as dn,
  qD as dp,
  Wt as dq,
  yF as dr,
  Vr as ds,
  YD as dt,
  JD as du,
  CF as dv,
  xF as dw,
  IF as dx,
  EF as dy,
  VO as dz,
  Xp as e,
  sM as e0,
  SF as e1,
  Y3 as f,
  Id as g,
  J3 as h,
  qn as i,
  K3 as j,
  _3 as k,
  $3 as l,
  e2 as m,
  t2 as n,
  n2 as o,
  r2 as p,
  i2 as q,
  s2 as r,
  Zn as s,
  a2 as t,
  c2 as u,
  u2 as v,
  l2 as w,
  d2 as x,
  A2 as y,
  f2 as z
};
//# sourceMappingURL=index-dIjxhE1H.js.map
